function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3sora", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$24737abaf730fa97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $fElvF;
    var $2JsdQ;
    var $jD5no;
    var $lf2Au;
    var $lL5b5;
    var $8J6rn;
    var $6s1PB;
    var $4R6GH;
    var $pa9q9;
    var $2gCtH;
    var $iixvy;
    var $cfDZ3;
    var $5rqex;
    var $14XJw;
    var $htI2Q;
    var $6juLJ;
    var $cf7yQ;
    var $lXCei;
    var $4dRjY;
    var $6XsPQ;
    var $dZw8H;
    var $90yGq;
    var $koeKL;
    var $2tT7R;
    var $DVljb;
    var $l8ruj;
    var $bPvna;
    var $c9lD2;
    var $fnaRp;
    const $24737abaf730fa97$var$PeopleProfilesShell = ({ history: history })=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [{ data: gspData }, { fetchState: fetchState }] = (0, (0, parcelRequire("6juLJ")).useGettingStartedPanelState)();
        (0, $5uXOq.useEffect)(()=>{
            if (gspData === undefined) fetchState();
        }, [
            gspData,
            fetchState
        ]);
        const gspProjectId = gspData?.properties?.user?.projectId;
        const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, (0, parcelRequire("htI2Q")).useIsFirstProjectITSM)(gspProjectId);
        (0, (0, parcelRequire("lXCei")).useInitializeActiveTab)('alerts', gspProjectId);
        const addFlag = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("c9lD2")).createShowFlagHandler)(showFlag, dismissFlag), [
            showFlag,
            dismissFlag
        ]);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const previousSubProduct = (0, (0, parcelRequire("cfDZ3")).getPreviousSubProduct)();
        const invitePeopleExperimentalFeatures = {
            inviteThirdPartyTeams: 'variation'
        };
        const { openModal: openModal } = (0, (0, parcelRequire("2JsdQ")).useInvitePeopleModal)({
            continueUrl: window.location.href,
            enableThirdParty: true,
            experimentalFeatures: invitePeopleExperimentalFeatures,
            displayInfiSpotlight: true,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            showFlag: addFlag,
            source: 'peopleDirectory',
            subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
        });
        const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
                handleOpenDialog: openModal
            }), [
            openModal
        ]);
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isAiOptInEnabled = (0, (0, parcelRequire("2gCtH")).useIsAiOptInEnabled)();
        const isPremium = (0, (0, parcelRequire("iixvy")).useIsPremium)();
        const isAIEnabled = isAiOptInEnabled && isPremium;
        if (!atlassianAccountId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lL5b5")).default), null);
        const { push: push, replace: replace } = history;
        const productFeatureFlags = {
            'event-on-call-consolidation_s97c8': true,
            'event-on-call-consolidation-state': shouldUseJSM
        };
        const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "people-profiles"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "people-profiles"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bPvna")).default), {
            appName: "jira-directory",
            contextSpaPaths: [
                '/browse',
                '/jira',
                '/projects'
            ],
            contextEntryPoint: "/jira/people",
            env: environment === 'prod' ? 'prod' : 'stg',
            locale: locale,
            addFlag: addFlag,
            push: push,
            replace: replace,
            docTitle: {
                end: 'Jira'
            },
            history: history,
            cloudId: cloudId,
            orgId: orgId,
            subProduct: previousSubProduct,
            invitePeopleHandlers: invitePeopleHandlers,
            productFeatureFlags: productFeatureFlags,
            isAIEnabled: isAIEnabled
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: "people-profiles",
            isExpectedToHaveSsr: false,
            metric: (0, (0, parcelRequire("fnaRp")).peopleProfilesPageLoad)
        }), (0, (0, parcelRequire("4R6GH")).fg)('set-embedded-directory-spa-ready') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null))), isNpleForItsmEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelOpenButton), null)));
    };
    var $24737abaf730fa97$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XsPQ")).HistoryAdapter), null, (history)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fElvF")).InvitePeopleModalContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($24737abaf730fa97$var$PeopleProfilesShell, {
                history: history
            })));
});
parcelRegister("lf2Au", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9249f8c63b854f95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $cSD7y;
    const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ect41sbm _1wyb1oud _4t3i1kw7 _1dyz4jg8"
            ])
        }, children);
    const $9249f8c63b854f95$var$AppStyleOld = (0, $47bDC.default).div.withConfig({
        componentId: "h5xpn2-0"
    })({
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        fontSize: `${(0, (0, parcelRequire("gwIPs")).fontSize)}px`,
        height: 'inherit',
        letterSpacing: 'normal'
    });
    const $9249f8c63b854f95$var$appStyles = null;
    const $9249f8c63b854f95$var$AppStyleFinal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jfp-1020-use-compiled', $9249f8c63b854f95$var$AppStyle, $9249f8c63b854f95$var$AppStyleOld);
    var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyleFinal;
});
parcelRegister("lL5b5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07c2532655d93687$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j0xEB;
    var $j2Jlg;
    var $07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
        const { href: href = null } = (0, (0, parcelRequire("j0xEB")).default)() || {};
        if (href && !href.includes('login.jsp')) {
            const encodedRedirectUrl = encodeURIComponent(href);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j2Jlg")).default), {
                url: `/login.jsp?os_destination=${encodedRedirectUrl}`
            });
        }
        return null;
    };
});
parcelRegister("j0xEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b1198aeec732ce1$export$2e2bcd8739ae039);
    var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
        if (typeof window !== 'undefined') return window.location;
        return undefined;
    };
});
parcelRegister("j2Jlg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$773e6f988af77e5c$export$2e2bcd8739ae039);
    var $773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
        window.location.assign(url);
        return null;
    };
});
parcelRegister("iixvy", function(module, exports) {
    $parcel$export(module.exports, "useIsPremium", ()=>$545133d1825caa45$export$1bb5840a003dc643);
    $parcel$export(module.exports, "useOptInStatus", ()=>$545133d1825caa45$export$5e56b08674e48311);
    $parcel$export(module.exports, "useAIOptIn", ()=>$545133d1825caa45$export$49e57b9044cda91c);
    var $5uXOq = parcelRequire("5uXOq");
    var $kTK0a;
    var $aIZdc;
    var $2vSU6;
    var $6s1PB;
    var $2gCtH;
    var $5NH95;
    var $93Yeu;
    var $14XJw;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $ljlOe;
    var $44KLa;
    const $545133d1825caa45$var$DISABLED = 'disabled';
    const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
    const $545133d1825caa45$var$ENABLED = 'enabled';
    const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return appEditions.core === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
        const isSupportedENV = !(0, (0, parcelRequire("aIZdc")).isFedRamp)();
        return isOrgAdmin && isPremium && isSupportedENV;
    };
    const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
        const isSupportedENV = !(0, (0, parcelRequire("aIZdc")).isFedRamp)();
        return isOrgAdmin && isStandard && isSupportedENV;
    };
    const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
        const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
        const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return $545133d1825caa45$var$DISABLED;
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { experimentValue: aiUpsellInEditorEnabled } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorRequirements)(product) : {
            experimentValue: false
        };
        if (aiUpsellInEditorEnabled) return $545133d1825caa45$var$DISABLED_OPT_IN;
        const isValidForGlobalOptIn = [
            product !== 'JPD',
            canOptIn
        ].every((condition)=>condition === true);
        const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
        const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
        return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
    };
    const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
        const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
        const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
        const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorFree)(optInStatus, product) : {
            isExperimentEnabled: false,
            triggerUpsellFlow: ()=>{},
            UpsellModal: null
        };
        const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
            setShowOptInModal(true);
        }, [
            setShowOptInModal
        ]);
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            setShowPremiumTrialModal(true);
        }, [
            setShowPremiumTrialModal
        ]);
        const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowOptInModal(false);
            const adminLink = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInModal), {
                showOptInModal: showOptInModal,
                isOrgAdmin: isOrgAdmin,
                onCloseModal: onCloseModal,
                adminLink: adminLink
            });
        }, [
            orgId,
            isOrgAdmin,
            showOptInModal
        ]);
        const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowPremiumTrialModal(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInUpsellModal), {
                "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
                showPremiumTrialModal: showPremiumTrialModal,
                onCloseModal: onCloseModal
            }));
        }, [
            showPremiumTrialModal
        ]);
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return {
            optInStatus: $545133d1825caa45$var$DISABLED,
            triggerOptInFlow: ()=>{},
            AIOptInModal: null
        };
        if (isAIUpsellInEditorFreeEnabled) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
            AIOptInModal: AIUpsellInEditorFreeModal
        };
        if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: null
        };
        if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerUpsellFlow,
            AIOptInModal: aiUpsellModal
        };
        return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: aiOptInModal
        };
    };
});
parcelRegister("5NH95", function(module, exports) {
    $parcel$export(module.exports, "useAIUpsellInEditorRequirements", ()=>$26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
    $parcel$export(module.exports, "useAIUpsellInEditorFree", ()=>$26b3b3762ac33b52$export$beacfd188d344f95);
    $parcel$export(module.exports, "AIUpsellButtonWrapper", ()=>$26b3b3762ac33b52$export$c44b9b0347b51c37);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $aIZdc;
    var $2vSU6;
    var $6s1PB;
    var $fmQtB;
    var $8zOmE;
    var $2NMNM;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $7xCut;
    const { fireEventOnce: $26b3b3762ac33b52$var$fireEventOnce } = (()=>{
        let hasFired = false;
        return {
            fireEventOnce: (fireFunction)=>{
                if (!hasFired) {
                    fireFunction();
                    hasFired = true;
                }
            }
        };
    })();
    const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
        switch(product){
            case 'JSW':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'JSM':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'JWM':
            case 'JPD':
            default:
                return undefined;
        }
    };
    const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        if (!appEditions) return undefined;
        if (projectType) return (0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions);
        return undefined;
    };
    const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [config, fireExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const statsigExperimentValue = config.get('experimentEnabled', undefined);
        const siteMeetsRequirements = $26b3b3762ac33b52$var$useGetSupportedEdition(product) === (0, (0, parcelRequire("ldyPw")).FREE_EDITION) && isOrgAdmin && !(0, (0, parcelRequire("aIZdc")).isFedRamp)() && typeof statsigExperimentValue === 'boolean';
        const experimentValue = siteMeetsRequirements ? statsigExperimentValue : undefined;
        const fireExposure = (0, $5uXOq.useCallback)(()=>{
            fireExperimentExposure();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'experiment exposed', {
                experimentKey: 'aiUpsellInEditorFree',
                isEligible: siteMeetsRequirements,
                cohort: experimentValue
            });
        }, [
            createAnalyticsEvent,
            experimentValue,
            fireExperimentExposure,
            siteMeetsRequirements
        ]);
        return {
            siteMeetsRequirements: siteMeetsRequirements,
            experimentValue: experimentValue,
            statsigExperimentValue: statsigExperimentValue,
            fireExperimentExposure: fireExposure
        };
    };
    const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
        const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        const siteMeetsOptInRequirements = siteMeetsRequirements && optInStatus !== 'enabled';
        const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : undefined;
        const isEnrolledInExperiment = typeof experimentValue === 'boolean';
        const isExperimentEnabled = isEnrolledInExperiment && experimentValue;
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'triggerUpsellFlow',
                actionSubject: 'aiUpsellInEditorFree'
            }), 'aiUpsellInEditorFreeTrigger', {});
            setShowUpsellModal(true);
            (0, (0, parcelRequire("7xCut")).setUpsellButtonWrapperClicked)(true);
        }, [
            createAnalyticsEvent
        ]);
        const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fmQtB")).AsyncAiUpsellInEditorFreeModal), {
                projectType: projectType,
                testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
                onModalClose: ()=>setShowUpsellModal(false)
            }) : null, [
            showUpsellModal,
            projectType
        ]);
        return {
            isEnrolledInExperiment: isEnrolledInExperiment,
            isExperimentEnabled: isExperimentEnabled,
            fireExperimentExposure: fireExperimentExposure,
            triggerUpsellFlow: triggerUpsellFlow,
            UpsellModal: UpsellModal
        };
    };
    const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isClicked = (0, (0, parcelRequire("7xCut")).getUpsellButtonWrapperClicked)();
        (0, $5uXOq.useEffect)(()=>{
            $26b3b3762ac33b52$var$fireEventOnce(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {}));
        }, [
            createAnalyticsEvent
        ]);
        return !isClicked ? (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
            "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $26b3b3762ac33b52$var$AIUpsellButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $26b3b3762ac33b52$var$AIUpsellButtonInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fmQtB", function(module, exports) {
    $parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", ()=>$2c23576aa5eb8dba$export$827041a383456a6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $kxZPA;
    const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("6zDy2")), {
        ssr: false,
        moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
    });
    const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "asyncAiUpsellInEditorFreeModal",
            packageName: "jira-growth-ai-upsell-in-editor-free-modal",
            teamName: "growth-tako",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));
});
parcelRegister("6zDy2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bQd01")
    ]).then(()=>parcelRequire('b738i'));
});
parcelRegister("7xCut", function(module, exports) {
    $parcel$export(module.exports, "getUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$f7d51ee95145148b);
    $parcel$export(module.exports, "setUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$b595420beb43f9ce);
    var $bSSG7;
    const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('ai-upsell-in-editor-free');
    function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
        return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
    }
    function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
        $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
    }
});
parcelRegister("ljlOe", function(module, exports) {
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", ()=>$82777381236a0306$export$77aa5ca661b0742c);
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", ()=>$82777381236a0306$export$dd0a751f23b19473);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mO32;
    var $l37qh;
    var $b3Gth;
    const $82777381236a0306$export$77aa5ca661b0742c = (0, (0, parcelRequire("l37qh")).createUseEntryPointContext)();
    const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
        const entryPointParams = {};
        const entryPointResult = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("b3Gth")).entryPointPremiumUpgradeModal), entryPointParams);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
            value: entryPointResult
        }, children);
    };
});
parcelRegister("l37qh", function(module, exports) {
    $parcel$export(module.exports, "createUseEntryPointContext", ()=>$6e7e19c2d291c94c$export$41bce2223126846b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>(0, $5uXOq.createContext)({
            entryPointActions: {
                cancelPreload () {},
                load () {},
                preload () {},
                unload () {}
            },
            entryPointReferenceSubject: {
                getValue: ()=>null,
                subscribe: ()=>()=>{}
            },
            stopMetric () {}
        });
});
parcelRegister("b3Gth", function(module, exports) {
    $parcel$export(module.exports, "entryPointPremiumUpgradeModal", ()=>$a50fd4829307668f$export$7116d5b1a93db8d6);
    var $eufEc;
    var $fEDBv;
    const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("paDrG")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
            moduleId: "1102b440"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("paDrG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5azfZ")
    ]).then(()=>parcelRequire('5s8iH'));
});
parcelRegister("44KLa", function(module, exports) {
    $parcel$export(module.exports, "OptInModal", ()=>$bf7c19a18c627984$export$1697f043758ae8d2);
    $parcel$export(module.exports, "OptInUpsellModal", ()=>$bf7c19a18c627984$export$bbf8d259a508a485);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $i8Qvm;
    var $4UN9Z;
    var $7XluA;
    var $8zOmE;
    var $2NMNM;
    var $ljlOe;
    var $ejjdc;
    const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, showOptInModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4UN9Z")).default), {
            source: "jira-editor",
            product: "jira",
            isOrgAdmin: isOrgAdmin,
            onAdminClose: onCloseModal,
            adminLink: adminLink
        })));
    const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>{
                    entryPointActions.unload();
                    const analyticsEvent = createAnalyticsEvent({
                        actionSubject: 'button',
                        action: 'clicked'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
                }
            }), [
            entryPointActions,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, showPremiumTrialModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejjdc")).AIOptInPremiumUpsell), {
            onClose: onCloseModal
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
            packageName: "platform-react-hooks-use-ai-opt-in",
            runtimeProps: runtimeProps
        }));
    };
});
parcelRegister("4UN9Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$498daaeb8cd4c6ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $eCeGD;
    var $1GGwS;
    var $dC5iT;
    var $8CUq3;
    var $c0x54 = parcelRequire("c0x54");
    var $ek69Y;
    var $lJhAv;
    const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onLearnMoreClicked = (e)=>{
            e.stopPropagation();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                    attributes: {
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const formatMessageValues = {
            a: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                    target: "_blank",
                    onClick: onLearnMoreClicked
                }, s),
            br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
        };
        const defaultHeader = formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogHeaderText);
        const header = headerText ?? defaultHeader;
        const body = bodyText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogBodyText, formatMessageValues);
        const orgAdminBody = adminBodyText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminBodyText, formatMessageValues);
        const orgAdminHeader = adminHeaderText ?? defaultHeader;
        (0, $5uXOq.useEffect)(()=>{
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, ($parcel$interopDefault($c0x54)))
            ]);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'aiGlobalOptInDialog',
                    attributes: {
                        source: source,
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        }, [
            createAnalyticsEvent,
            source,
            product,
            isOrgAdmin
        ]);
        const onCloseClicked = (e)=>{
            e.stopPropagation();
            onAdminClose?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const onCTAClicked = (e)=>{
            e.stopPropagation();
            onAdminCTA?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).OptInBackgroundBorder), {
            width: width,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).OptInContainer), null, image ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ImageWrapper), null, image) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ImageWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($c0x54))),
            height: "96px",
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ContentContainer), null, isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles
        }, formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInAdminOnlyVisible)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).BodyWrapper), {
            "data-testid": "dialog-body-text"
        }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ButtonContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onCloseClicked,
            testId: "admin-close-button"
        }, adminCloseCTAText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminMaybeLaterButtonText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
            appearance: "primary",
            onClick: onCTAClicked,
            href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
            target: "_blank",
            testId: "admin-cta-button"
        }, adminCTAText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminGetStartedButtonText))))));
    };
    var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
parcelRegister("c0x54", function(module, exports) {
    module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();
});
const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
parcelRegister("ek69Y", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$5fe19a2c65ae0a6d$export$defe85febe8b728c);
    var $7VHMR;
    const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aiOptInDialogHeaderText: {
            id: 'ai-opt-in.dialog.header.text',
            defaultMessage: 'Work smarter, not harder',
            description: 'Header text for AI Opt In Dialog'
        },
        aiOptInDialogBodyText: {
            id: 'ai-opt-in.dialog.body.text',
            defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
            description: 'Body text for AI Opt In Dialog'
        },
        aiOptInDialogLearnMoreLinkText: {
            id: 'ai-opt-in.dialog.learn-more.link.text',
            defaultMessage: 'Learn more about Atlassian Intelligence',
            description: 'Learn more link text for AI Opt In Dialog'
        },
        aiOptInDialogAdminBodyText: {
            id: 'ai-opt-in.dialog.admin.body.text',
            defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of AI Opt In Dialog'
        },
        aiOptInDialogAdminMaybeLaterButtonText: {
            id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
            defaultMessage: 'Maybe later',
            description: 'Admin maybe later button text'
        },
        aiOptInDialogAdminGetStartedButtonText: {
            id: 'ai-opt-in.dialog.admin.get-started.button.text',
            defaultMessage: 'Get started',
            description: 'Admin get started button text'
        },
        aiOptInBannerBodyText: {
            id: 'ai-opt-in.banner.body.text',
            defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
            description: 'Body text for Banner version of AI Opt In Dialog'
        },
        aiOptInBannerLearnMoreText: {
            id: 'ai-opt-in.banner.learn.more.text',
            defaultMessage: 'Learn more',
            description: 'Learn more text for Banner cta of AI Opt In Dialog'
        },
        aiOptInAdminBannerBodyText: {
            id: 'ai-opt-in.banner.admin.body.text',
            defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of the Banner Ai Opt In'
        },
        aiOptInAdminOnlyVisible: {
            id: 'ai-opt-in.admin.only.visible.text',
            defaultMessage: 'This message is only visible to org admins.',
            description: 'Text message to let org admins know that the content is only visible to them.'
        }
    });
});
parcelRegister("lJhAv", function(module, exports) {
    $parcel$export(module.exports, "OptInBackgroundBorder", ()=>$1bcec8f5b168d85d$export$24c280970213bb11);
    $parcel$export(module.exports, "OptInContainer", ()=>$1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
    $parcel$export(module.exports, "ImageWrapper", ()=>$1bcec8f5b168d85d$export$75f07c36086c2c81);
    $parcel$export(module.exports, "ContentContainer", ()=>$1bcec8f5b168d85d$export$9d2b4227a95687cc);
    $parcel$export(module.exports, "HeaderWrapper", ()=>$1bcec8f5b168d85d$export$960a49cc3d27a090);
    $parcel$export(module.exports, "BodyWrapper", ()=>$1bcec8f5b168d85d$export$14966827497f4695);
    $parcel$export(module.exports, "ButtonContainer", ()=>$1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1bcec8f5b168d85d$export$24c280970213bb11 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1vcp0mh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16qs1o46 _2rko14y2 _1yt4v77o _kqswh2mm _11q71lxv",
                __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$75f07c36086c2c81 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$9d2b4227a95687cc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81bk4",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$14966827497f4695 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ejjdc", function(module, exports) {
    $parcel$export(module.exports, "AIOptInPremiumUpsell", ()=>$678322372bbc5cca$export$54e4ba490d2c6bb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $l1N8i;
    var $2C7j9;
    var $c8oLN;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $gEusR;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $2ogyS;
    var $iau6N;
    const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'screen',
                action: 'viewed'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $678322372bbc5cca$var$containerBorderStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignBlock: "stretch",
            xcss: $678322372bbc5cca$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "end",
            grow: "fill",
            xcss: $678322372bbc5cca$var$headerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            onClick: onClose,
            label: formatMessage((0, (0, parcelRequire("2ogyS")).messages).closeModal),
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2C7j9")))))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
            all: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEusR")).default), {
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignInline: "stretch",
            space: "space.200",
            xcss: $678322372bbc5cca$var$textContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iau6N")).StartPremiumTrialButton), {
            onCloseParent: onClose
        })))));
    };
    const $678322372bbc5cca$var$containerBorderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        boxShadow: 'elevation.shadow.overlay',
        borderRadius: 'border.radius',
        width: '438px',
        position: 'relative',
        padding: 'space.025',
        background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`} 100%
    )`
    });
    const $678322372bbc5cca$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        backgroundColor: 'elevation.surface.overlay',
        overflow: 'hidden'
    });
    const $678322372bbc5cca$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        padding: 'space.075',
        right: 'space.025'
    });
    const $678322372bbc5cca$var$textContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.300'
    });
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("c8oLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e401c8401021557f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8CUq3;
    function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e401c8401021557f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $e401c8401021557f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $e401c8401021557f$var$baseStyles,
                (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
                (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $e401c8401021557f$var$Bleed.displayName = 'Bleed';
    var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("gEusR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daf0e2023e742d66$export$2e2bcd8739ae039);
    var $dCLgq;
    var $8nOP6 = parcelRequire("8nOP6");
    var $4aPxh = parcelRequire("4aPxh");
    const $daf0e2023e742d66$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($4aPxh)),
        srcDark: ($parcel$interopDefault($8nOP6))
    });
    var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
    const $daf0e2023e742d66$export$a179c88182cb9d56 = [
        0,
        0,
        438,
        96
    ];
});
parcelRegister("8nOP6", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();
});
parcelRegister("4aPxh", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();
});
parcelRegister("2ogyS", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$703e8ca8733c69fc$export$defe85febe8b728c);
    var $7VHMR;
    const $703e8ca8733c69fc$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
            "defaultMessage": "Write better, work faster with Atlassian Intelligence"
        },
        body: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
            "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
        },
        closeModal: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
            "defaultMessage": "Close Modal"
        },
        tryItFreeButton: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
            "defaultMessage": "Try it free"
        }
    });
});
parcelRegister("iau6N", function(module, exports) {
    $parcel$export(module.exports, "StartPremiumTrialButton", ()=>$d916fa2fae12e75a$export$a2651a739f515dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $8EYBJ;
    var $47gW9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $ljlOe;
    var $2ogyS;
    const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const triggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
        }, [
            createAnalyticsEvent
        ]);
        const onClick = ()=>{
            onCloseParent && onCloseParent();
            onClickAnalytics();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            onClick: onClick,
            ref: triggerRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EYBJ"))))), {
                size: "small",
                label: "",
                primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }),
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        display: 'flex',
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        outline: 'none',
                        boxSizing: 'border-box',
                        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                        borderRadius: "var(--ds-space-050, 4px)",
                        height: "var(--ds-space-400, 32px)",
                        border: 'none',
                        fontSize: '14px',
                        gap: "var(--ds-space-025, 2px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).tryItFreeButton));
    };
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) metric.stop({
            customData: customData,
            stopTime: stopTime
        });
        else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("htI2Q", function(module, exports) {
    $parcel$export(module.exports, "useGettingStartedPageStateActions", ()=>$33645e86b9772f1d$export$8d2572f02ec0aa4c);
    $parcel$export(module.exports, "useIsFirstProjectITSM", ()=>$33645e86b9772f1d$export$852fe39748ba826d);
    $parcel$export(module.exports, "useGetNpleDisabledProjectProperty", ()=>$33645e86b9772f1d$export$24659fa3abfd0100);
    $parcel$export(module.exports, "useIsGettingStartedPageEnabled", ()=>$33645e86b9772f1d$export$a58e406dc976509e);
    var $5uXOq = parcelRequire("5uXOq");
    var $58GFP;
    var $jcw0u;
    var $6s1PB;
    var $co1wz;
    var $4R6GH;
    var $eusud;
    var $2NMNM;
    var $O4MMs;
    var $dAfqg;
    var $324W5;
    var $lbaDt;
    var $9OXo1;
    var $5DnNI;
    var $jULiL;
    var $kTQYw;
    const $33645e86b9772f1d$export$8d2572f02ec0aa4c = ()=>{
        const baseUrl = window.location.origin;
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)() || {};
        const { projectId: projectId } = data || {};
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectIdString = projectId ? projectId.toString() : '';
        return (0, $5uXOq.useMemo)(()=>{
            const actionProps = {
                baseUrl: baseUrl,
                cloudId: cloudId,
                projectId: projectIdString,
                createAnalyticsEvent: createAnalyticsEvent
            };
            return [
                {
                    updateLandingPageStateProperties: (0, (0, parcelRequire("kTQYw")).updateLandingPageStateProperties)(actionProps),
                    getLandingPageState: (0, (0, parcelRequire("kTQYw")).getLandingPageState)(actionProps),
                    initialiseLandingPageState: (0, (0, parcelRequire("kTQYw")).initialiseLandingPageState)(actionProps)
                }
            ];
        }, [
            baseUrl,
            cloudId,
            createAnalyticsEvent,
            projectIdString
        ]);
    };
    const $33645e86b9772f1d$export$852fe39748ba826d = (inputProjectId)=>{
        const { data: containerContext, loading: loading } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const currentProjectId = inputProjectId || containerContext?.projectId;
        const [isFirstProject, setIsFirstProject] = (0, $5uXOq.useState)(false);
        const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $5uXOq.useState)(false);
        const [isStateLoading, setStateLoading] = (0, $5uXOq.useState)(true);
        const { error: isFirstProjectError, firstProject: firstProject } = (0, (0, parcelRequire("jULiL")).useFirstProjectDetails)();
        (0, $5uXOq.useEffect)(()=>{
            if (currentProjectId && !isFirstProjectError && firstProject) {
                setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
                setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, (0, parcelRequire("58GFP")).IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
                setStateLoading(false);
            } else if (isFirstProjectError) setStateLoading(false);
        }, [
            currentProjectId,
            firstProject,
            isFirstProjectError,
            setStateLoading
        ]);
        const memoizedValue = (0, $5uXOq.useMemo)(()=>({
                isLoading: loading || isStateLoading,
                isFirstProject: isFirstProject,
                isFirstProjectItsm: isFirstProjectItsm,
                isFirstProjectError: isFirstProjectError
            }), [
            isFirstProject,
            isFirstProjectItsm,
            isFirstProjectError,
            loading,
            isStateLoading
        ]);
        return memoizedValue;
    };
    const $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF = (projectId, customContext)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar')) {
            const { data: data, loading: loading } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("lbaDt")).requiredFrontendProperties), customContext);
            if (!data) return [
                null,
                loading
            ];
            return [
                data[0, (0, parcelRequire("58GFP")).INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY],
                loading
            ];
        }
        const { [(0, (0, parcelRequire("58GFP")).INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplateOld } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            (0, (0, parcelRequire("58GFP")).INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
        ], projectId);
        const isLoadingOld = initialProjectTemplateOld === undefined;
        return [
            initialProjectTemplateOld,
            isLoadingOld
        ];
    };
    const $33645e86b9772f1d$export$da3441212b1c36fb = (projectId, customContext)=>{
        const [initialProjectTemplate, isLoading] = $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF(projectId, customContext);
        const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $33645e86b9772f1d$export$852fe39748ba826d(projectId);
        const excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, (0, parcelRequire("5DnNI")).GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, (0, parcelRequire("5DnNI")).GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
        return (0, $5uXOq.useMemo)(()=>[
                isLoading || isFirstProjectITSMLoading,
                excludedProjectTemplates.includes(initialProjectTemplate)
            ], [
            excludedProjectTemplates,
            initialProjectTemplate,
            isFirstProjectITSMLoading,
            isLoading
        ]);
    };
    const $33645e86b9772f1d$export$24659fa3abfd0100 = (projectKeyOrId)=>{
        const [npleDisabled, setNpleDisabled] = (0, $5uXOq.useState)(projectKeyOrId ? undefined : true);
        const [isLoadingNew, setIsLoadingNew] = (0, $5uXOq.useState)(true);
        const isLoading = npleDisabled === undefined;
        const getNpleDisabledProjectProperty = (0, $5uXOq.useCallback)(async ()=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, (0, parcelRequire("5DnNI")).DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
                setNpleDisabled(response.value);
                setIsLoadingNew(false);
            } catch (error) {
                setNpleDisabled(error.statusCode !== 404);
                setIsLoadingNew(false);
                error.statusCode !== 404 && (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getDisableNpleProjectProperty',
                        packageName: (0, (0, parcelRequire("5DnNI")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("5DnNI")).PACKAGE_TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            projectKeyOrId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (projectKeyOrId) getNpleDisabledProjectProperty();
        }, [
            getNpleDisabledProjectProperty,
            projectKeyOrId
        ]);
        const isLoadingValue = (0, (0, parcelRequire("4R6GH")).fg)('jsm-wait-for-project-context-in-nple') ? isLoadingNew : isLoading;
        return [
            isLoadingValue,
            npleDisabled
        ];
    };
    const $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF = (projectKey, customContext)=>{
        const [isGetNpleDisabledLoadingOld, npleDisabledOld] = $33645e86b9772f1d$export$24659fa3abfd0100((0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout') && !(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar') ? projectKey : undefined);
        const { data: requiredProjectPropertiesDataNew, loading: isGetNpleDisabledLoadingNew } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("lbaDt")).requiredProjectProperties), customContext);
        const npleDisabledNew = requiredProjectPropertiesDataNew ? requiredProjectPropertiesDataNew[0, (0, parcelRequire("5DnNI")).DISABLE_NPLE_PROJECT_PROJECT_KEY] : false;
        const npleDisabled = (0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar') ? npleDisabledNew : npleDisabledOld;
        const isGetNpleDisabledLoading = (0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar') ? isGetNpleDisabledLoadingNew : isGetNpleDisabledLoadingOld;
        return [
            npleDisabled,
            isGetNpleDisabledLoading
        ];
    };
    const $33645e86b9772f1d$export$a58e406dc976509e = (customContext)=>{
        const { data: data, loading: projectContextLoading } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(customContext) || {};
        const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
        const [isLoading, isExcludedProject] = $33645e86b9772f1d$export$da3441212b1c36fb(projectId?.toString(), customContext);
        const [npleDisabled, isGetNpleDisabledLoading] = $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF(projectKey, customContext);
        const isDataLoading = isLoading || projectContextLoading && (0, (0, parcelRequire("4R6GH")).fg)('jsm-wait-for-project-context-in-nple') || isGetNpleDisabledLoading && (0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout');
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)() || {};
        const hasJSMAccess = (0, (0, parcelRequire("4R6GH")).fg)('add-product-permission-check-for-nple') ? appPermissions?.hasServiceDeskAccess : true;
        return (0, $5uXOq.useMemo)(()=>[
                isDataLoading,
                !isDataLoading ? hasJSMAccess && isProjectAdmin && !isSimplified && !isExcludedProject && !npleDisabled && (0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout') : false
            ], [
            isDataLoading,
            isProjectAdmin,
            isSimplified,
            isExcludedProject,
            npleDisabled,
            hasJSMAccess
        ]);
    };
});
parcelRegister("5DnNI", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$52e659885063405d$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "PACKAGE_TEAM_NAME", ()=>$52e659885063405d$export$2b3151a089bc8780);
    $parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", ()=>$52e659885063405d$export$190fb6b68393ab0a);
    $parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", ()=>$52e659885063405d$export$b51e545ada86528a);
    $parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", ()=>$52e659885063405d$export$2527ae3f75e929d);
    $parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", ()=>$52e659885063405d$export$7741797ac345bc17);
    $parcel$export(module.exports, "CONTACT_SUPPORT_URL", ()=>$52e659885063405d$export$2c16bd1d8b68b11f);
    $parcel$export(module.exports, "JSM_DOCUMENTATION_URL", ()=>$52e659885063405d$export$3b0c21ad7d48c17f);
    $parcel$export(module.exports, "ASK_COMMUNITY_URL", ()=>$52e659885063405d$export$eb3a822ca5964b4c);
    $parcel$export(module.exports, "SAMPLE_SPACE_URL", ()=>$52e659885063405d$export$7d64ff3c41d97984);
    $parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", ()=>$52e659885063405d$export$eb8426badfb143b);
    $parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", ()=>$52e659885063405d$export$6e4b80733f1b287d);
    $parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", ()=>$52e659885063405d$export$849d996b61162ae5);
    $parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", ()=>$52e659885063405d$export$84bc97b21fdd244a);
    $parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", ()=>$52e659885063405d$export$a45136678da730c);
    $parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", ()=>$52e659885063405d$export$4585842137473138);
    $parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", ()=>$52e659885063405d$export$4ff5ead961dddcb6);
    $parcel$export(module.exports, "ManageQueuesArticleId", ()=>$52e659885063405d$export$337d9a01cb6ca6b9);
    $parcel$export(module.exports, "RequestChannelsArticleId", ()=>$52e659885063405d$export$14ea17a7011e8003);
    $parcel$export(module.exports, "RequestTypesArticleId", ()=>$52e659885063405d$export$bf7175403ae935b4);
    $parcel$export(module.exports, "RequestQueuesArticleId", ()=>$52e659885063405d$export$f5f272385d51d0c);
    $parcel$export(module.exports, "ViewIssueArticleId", ()=>$52e659885063405d$export$3a62b051817d4794);
    $parcel$export(module.exports, "REQUEST_CHANNELS", ()=>$52e659885063405d$export$66b0ce7a4d805ff);
    $parcel$export(module.exports, "REQUEST_TYPES", ()=>$52e659885063405d$export$b1183955728be615);
    $parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", ()=>$52e659885063405d$export$56dfbf0bd0f6a594);
    $parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", ()=>$52e659885063405d$export$7153e91b542b7f0a);
    $parcel$export(module.exports, "DEMO_ISSUE_LABEL", ()=>$52e659885063405d$export$fe4edbd608405ae2);
    $parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", ()=>$52e659885063405d$export$b2f56b9b16e7a5d8);
    $parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", ()=>$52e659885063405d$export$8b55ba9520951f74);
    $parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", ()=>$52e659885063405d$export$8ce85ec44321d12);
    $parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", ()=>$52e659885063405d$export$2b5c9784d8cd5f0);
    $parcel$export(module.exports, "INCIDENTS", ()=>$52e659885063405d$export$a50b49a533b5f7bc);
    $parcel$export(module.exports, "CHANGES", ()=>$52e659885063405d$export$8598196f74460271);
    $parcel$export(module.exports, "ALERTS", ()=>$52e659885063405d$export$bc57e9dea1fac017);
    var $58GFP;
    const $52e659885063405d$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
    const $52e659885063405d$export$2b3151a089bc8780 = 'itops-mithril';
    const $52e659885063405d$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
    const $52e659885063405d$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
    const $52e659885063405d$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
    const $52e659885063405d$export$f250cf2c117f5561 = 'jsm.it-service-management';
    const $52e659885063405d$export$91f428721ec50d87 = 'jsm.it-service-management-advanced';
    const $52e659885063405d$export$adee93c2017009c = 'referrer';
    const $52e659885063405d$export$7741797ac345bc17 = 404;
    const $52e659885063405d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
    const $52e659885063405d$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
    const $52e659885063405d$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
    const $52e659885063405d$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
    const $52e659885063405d$export$2ff5a711d89d56f0 = '';
    const $52e659885063405d$export$eb8426badfb143b = [
        (0, (0, parcelRequire("58GFP")).IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
        (0, (0, parcelRequire("58GFP")).IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
        (0, (0, parcelRequire("58GFP")).JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY),
        $52e659885063405d$export$2ff5a711d89d56f0
    ];
    const $52e659885063405d$export$6e4b80733f1b287d = [
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
        $52e659885063405d$export$2ff5a711d89d56f0
    ];
    const $52e659885063405d$export$849d996b61162ae5 = [
        $52e659885063405d$export$f250cf2c117f5561,
        $52e659885063405d$export$91f428721ec50d87,
        (0, (0, parcelRequire("58GFP")).IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
        (0, (0, parcelRequire("58GFP")).IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
        (0, (0, parcelRequire("58GFP")).BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
        $52e659885063405d$export$2ff5a711d89d56f0
    ];
    const $52e659885063405d$export$84bc97b21fdd244a = 'Portal';
    const $52e659885063405d$export$a45136678da730c = 'Chat';
    const $52e659885063405d$export$4585842137473138 = 'Email';
    const $52e659885063405d$export$4ff5ead961dddcb6 = 4;
    const $52e659885063405d$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
    const $52e659885063405d$export$4427f2578322b0c1 = '3cdZ1Fc5T12gySP1kroJJr';
    const $52e659885063405d$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
    const $52e659885063405d$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
    const $52e659885063405d$export$f5f272385d51d0c = 'bfeWmUW9tPB6MqlPnOXgF';
    const $52e659885063405d$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
    const $52e659885063405d$export$66b0ce7a4d805ff = 'RequestChannel';
    const $52e659885063405d$export$b1183955728be615 = 'RequestTypes';
    const $52e659885063405d$export$5b2e9a43da487c8d = 'InviteTeam';
    const $52e659885063405d$export$82cf56f84f36683f = 'ManageQueues';
    const $52e659885063405d$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
    const $52e659885063405d$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
    const $52e659885063405d$export$be01cbdafda7d87f = 'rejected';
    const $52e659885063405d$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
    const $52e659885063405d$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
    const $52e659885063405d$export$8b55ba9520951f74 = 'npleDisabled';
    const $52e659885063405d$export$8ce85ec44321d12 = 'disable-nple-error';
    const $52e659885063405d$export$2b5c9784d8cd5f0 = 'disable-nple-success';
    const $52e659885063405d$export$a50b49a533b5f7bc = 'incidents';
    const $52e659885063405d$export$8598196f74460271 = 'changes';
    const $52e659885063405d$export$bc57e9dea1fac017 = 'alerts';
});
parcelRegister("jULiL", function(module, exports) {
    $parcel$export(module.exports, "useFirstProjectDetails", ()=>$2151d2bb13849eac$export$a2dd21ca7232bc34);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $3sQ5x;
    var $iXqE5;
    var $fvOWo;
    const $2151d2bb13849eac$var$initialState = {
        error: false,
        firstProject: undefined
    };
    const $2151d2bb13849eac$var$setError = (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        };
    const $2151d2bb13849eac$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
            setState({
                firstProject: firstProject
            });
        };
    const $2151d2bb13849eac$export$e324594224ef24da = {
        setError: $2151d2bb13849eac$var$setError,
        setFirstProject: $2151d2bb13849eac$var$setFirstProject
    };
    const $2151d2bb13849eac$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'getting-started-page-is-first-project',
        initialState: $2151d2bb13849eac$var$initialState,
        actions: $2151d2bb13849eac$export$e324594224ef24da
    });
    const $2151d2bb13849eac$export$a47f6b1a99a5e57f = (0, (0, parcelRequire("3sQ5x")).createHook)($2151d2bb13849eac$var$store);
    const $2151d2bb13849eac$export$a2dd21ca7232bc34 = ()=>{
        const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $2151d2bb13849eac$export$a47f6b1a99a5e57f();
        const { licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)() || {};
        const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
        (0, $5uXOq.useEffect)(()=>{
            if (!hasJsmLicense || data.firstProject || data.error) return;
            (0, (0, parcelRequire("fvOWo")).getFirstProject)().then((response)=>{
                setFirstProjectDetails(response);
            }).catch(()=>{
                setErrorState(true);
            });
        }, [
            hasJsmLicense,
            setErrorState,
            setFirstProjectDetails,
            data.firstProject,
            data.error
        ]);
        return data;
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("fvOWo", function(module, exports) {
    $parcel$export(module.exports, "getFirstProject", ()=>$bd9d8c1bcfe29e58$export$197802963901b2fb);
    var $bFU4G;
    var $jcw0u;
    var $eusud;
    var $5DnNI;
    const $bd9d8c1bcfe29e58$export$197802963901b2fb = async ()=>{
        try {
            const fetchStartTime = performance.now();
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', 'rest/servicedesk/latest/xflow/getFirstProject?type=service_desk', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            return response;
        } catch (error) {
            if (error.statusCode !== 404) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getFirstProject',
                    packageName: (0, (0, parcelRequire("5DnNI")).PACKAGE_NAME),
                    teamName: (0, (0, parcelRequire("5DnNI")).PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("kTQYw", function(module, exports) {
    $parcel$export(module.exports, "initialiseLandingPageState", ()=>$123174e2fee8004a$export$afc4bcbfce806408);
    $parcel$export(module.exports, "getLandingPageState", ()=>$123174e2fee8004a$export$43654a89c1df0019);
    $parcel$export(module.exports, "updateLandingPageStateProperties", ()=>$123174e2fee8004a$export$2dede61295d6c46);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $5DnNI;
    const $123174e2fee8004a$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
            try {
                await (0, (0, parcelRequire("eusud")).performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                    actionSubject: 'State',
                    action: 'initialised'
                }), 'jiraServicedeskGettingStartedPage.State initialised');
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'State',
                        packageName: (0, (0, parcelRequire("5DnNI")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("5DnNI")).PACKAGE_TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    const $123174e2fee8004a$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'State',
                    action: 'fetched'
                }), 'jiraServicedeskGettingStartedPage.State fetched');
                return response;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'State',
                        packageName: (0, (0, parcelRequire("5DnNI")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("5DnNI")).PACKAGE_TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    const $123174e2fee8004a$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
            const sectionStateString = JSON.stringify(properties);
            try {
                await (0, (0, parcelRequire("eusud")).performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                    body: JSON.stringify({
                        sectionState: sectionStateString
                    })
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                    actionSubject: 'Properties',
                    action: 'updated'
                }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                    property: properties
                });
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'Properties',
                        packageName: (0, (0, parcelRequire("5DnNI")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("5DnNI")).PACKAGE_TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
});
parcelRegister("6juLJ", function(module, exports) {
    $parcel$export(module.exports, "useOpsTeamMode", ()=>$3726f54bfa1691c8$export$97247be508d7d058);
    $parcel$export(module.exports, "useGettingStartedPanelState", ()=>$3726f54bfa1691c8$export$50f195e39d82318);
    $parcel$export(module.exports, "useGettingStartedPanelActions", ()=>$3726f54bfa1691c8$export$bb089b373d239cdd);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $2NMNM;
    var $8J6rn;
    var $4DPZY;
    var $aNLeB;
    var $hO5fm;
    var $7HThi;
    var $g5X3G;
    var $9OXo1;
    var $aeeX4;
    var $bmKPg;
    var $doZTA;
    var $3sQ5x;
    var $iXqE5;
    var $9TJvQ;
    const $3726f54bfa1691c8$var$initialState = {
        data: undefined,
        isGspInitialized: true,
        isSaving: false,
        shouldRecordPerformanceExperiences: true
    };
    const $3726f54bfa1691c8$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'GettingStartedPanelState',
        initialState: $3726f54bfa1691c8$var$initialState,
        actions: (0, (0, parcelRequire("9TJvQ")).actions)
    });
    const $3726f54bfa1691c8$var$useGettingStartedPanelStoreState = (0, (0, parcelRequire("3sQ5x")).createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
        selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
            const canRender = isGspInitialized && data?.properties.user.activeState === (0, (0, parcelRequire("aeeX4")).ActiveState).On;
            const canRenderPanel = canRender && data?.properties.user.visualState === (0, (0, parcelRequire("aeeX4")).VisualState).FullPanel;
            const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, (0, parcelRequire("aeeX4")).VisualState).Lozenge;
            const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, (0, parcelRequire("aeeX4")).ActiveState).Off;
            const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, (0, parcelRequire("aeeX4")).HasSeenReopenSpotlight).No;
            const canPollPanelState = data?.properties.user.activeState === (0, (0, parcelRequire("aeeX4")).ActiveState).On;
            return {
                data: data,
                canRenderPanel: canRenderPanel,
                canRenderOpenButton: canRenderOpenButton,
                canRenderReopenButton: canRenderReopenButton,
                canRenderReopenSpotlight: canRenderReopenSpotlight,
                canPollPanelState: canPollPanelState,
                shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
            };
        }
    });
    const $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $3726f54bfa1691c8$var$useIsProjectTourSeen = ()=>{
        const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, (0, parcelRequire("hO5fm")).useTourState)();
        const isError = !(0, ($parcel$interopDefault($hGgHi)))(error);
        const hasData = !(0, ($parcel$interopDefault($hGgHi)))(data);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasData && !isLoading && !isError) getTourState();
        }, [
            hasData,
            isLoading,
            isError,
            getTourState
        ]);
        return data?.seenProjectTour === (0, $87b6a84c4fa7f907$export$e47bc222770d5cfd);
    };
    const $3726f54bfa1691c8$var$useIsSampleProject = ()=>{
        const { data: isItsmSampleProject } = (0, (0, parcelRequire("7HThi")).useIsItsmSampleProject)();
        const [{ data: containerContext }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        if (isItsmSampleProject != null) return isItsmSampleProject;
        return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
    };
    const $3726f54bfa1691c8$export$2486eddc1a0bc021 = ()=>{
        const { data: isItsmProject } = (0, (0, parcelRequire("aNLeB")).useIsItsmTemplateProject)();
        const [{ data: containerContext }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const projectId = containerContext?.contextType === 'project' && !(0, ($parcel$interopDefault($hGgHi)))(containerContext.project) ? (0, (0, parcelRequire("g5X3G")).toProjectId)(String(containerContext.project.id)) : undefined;
        return {
            isItsmProject: !(0, ($parcel$interopDefault($hGgHi)))(projectId) && isItsmProject === true,
            projectId: projectId
        };
    };
    const $3726f54bfa1691c8$export$97247be508d7d058 = ()=>{
        const [{ location: { pathname: pathname } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isOpsPage = pathname.startsWith('/jira/ops/teams/');
        const [teamId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('teamId');
        const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
        return {
            teamId: teamId,
            enableOpsTeamMode: enableOpsTeamMode
        };
    };
    const $3726f54bfa1691c8$export$678a38a9dc2d3a0 = ()=>{
        const { isItsmProject: isItsmProject } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
        return enableUserCentricMode;
    };
    const $3726f54bfa1691c8$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
        const gatewayBaseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)(`${baseUrl}/gateway/api`);
        const isItsmSampleProject = $3726f54bfa1691c8$var$useIsSampleProject();
        const { isItsmProject: isItsmProject, projectId: projectId } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
        const isProjectTourSeen = $3726f54bfa1691c8$var$useIsProjectTourSeen();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $3726f54bfa1691c8$export$97247be508d7d058();
        const enableUserCentricMode = $3726f54bfa1691c8$export$678a38a9dc2d3a0();
        return (0, $5uXOq.useMemo)(()=>{
            const actionProps = {
                createAnalyticsEvent: createAnalyticsEvent,
                baseUrl: gatewayBaseUrl,
                cloudId: cloudId,
                accountId: accountId,
                isItsmSampleProject: isItsmSampleProject,
                isProjectTourSeen: isProjectTourSeen,
                isItsmProject: isItsmProject,
                projectId: projectId,
                ...enableOpsTeamMode && {
                    teamId: teamId,
                    enableOpsTeamMode: enableOpsTeamMode
                },
                ...enableUserCentricMode && {
                    enableUserCentricMode: enableUserCentricMode
                }
            };
            return {
                initializeState: initializeState(actionProps),
                reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
                markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
                fetchState: fetchState(actionProps),
                savePanelState: savePanelState(actionProps),
                resolveTask: resolveTask(actionProps),
                saveProperty: saveProperty(actionProps),
                stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
                setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
            };
        }, [
            createAnalyticsEvent,
            gatewayBaseUrl,
            cloudId,
            accountId,
            isItsmSampleProject,
            isProjectTourSeen,
            isItsmProject,
            projectId,
            enableOpsTeamMode,
            teamId,
            enableUserCentricMode,
            initializeState,
            reopenGettingStartedPanel,
            markReopenSpotlightAsSeen,
            fetchState,
            savePanelState,
            resolveTask,
            saveProperty,
            stopRecordingPerformanceExperiences,
            setOpsAdminTaskVisibility
        ]);
    };
    const $3726f54bfa1691c8$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $5uXOq.useMemo)(()=>({
                data: data,
                canRenderPanel: canRenderPanel,
                canRenderOpenButton: canRenderOpenButton,
                canRenderReopenButton: canRenderReopenButton,
                canRenderReopenSpotlight: canRenderReopenSpotlight,
                canPollPanelState: canPollPanelState,
                shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
            }), [
            data,
            canRenderPanel,
            canRenderOpenButton,
            canRenderReopenButton,
            canRenderReopenSpotlight,
            canPollPanelState,
            shouldRecordPerformanceExperiences
        ]);
    const $3726f54bfa1691c8$export$50f195e39d82318 = ()=>{
        const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [state, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreState();
        const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
            ...actions,
            baseUrl: baseUrl,
            cloudId: cloudId,
            accountId: accountId
        });
        const memoizedState = $3726f54bfa1691c8$var$useStateMemo(state);
        return (0, $5uXOq.useMemo)(()=>[
                memoizedState,
                memoizedActions
            ], [
            memoizedActions,
            memoizedState
        ]);
    };
    const $3726f54bfa1691c8$export$bb089b373d239cdd = ()=>{
        const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions();
        const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
            ...actions,
            baseUrl: baseUrl,
            cloudId: cloudId,
            accountId: accountId
        });
        return (0, $5uXOq.useMemo)(()=>[
                undefined,
                memoizedActions
            ], [
            memoizedActions
        ]);
    };
});
const $87b6a84c4fa7f907$export$17227441e89ee693 = 'INITIAL';
const $87b6a84c4fa7f907$export$23324e66dcb20cea = 'NOTSEEN';
const $87b6a84c4fa7f907$export$e47bc222770d5cfd = 'SEEN';
const $87b6a84c4fa7f907$export$103bedf43ba882db = 'ERROR';
const $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $87b6a84c4fa7f907$export$d57b6b390e78d90f = 'itops-mithril';
parcelRegister("hO5fm", function(module, exports) {
    $parcel$export(module.exports, "useTourState", ()=>$6d8bca487172cfe1$export$4aecabf781c5d857);
    var $5uXOq = parcelRequire("5uXOq");
    var $g5X3G;
    var $3sQ5x;
    var $iXqE5;
    var $7tQNr;
    const $6d8bca487172cfe1$export$d4c72bab9d6cc13a = {
        data: undefined,
        isLoading: false,
        error: undefined
    };
    const $6d8bca487172cfe1$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'ItsmFirstSessionFlowTourState',
        initialState: $6d8bca487172cfe1$export$d4c72bab9d6cc13a,
        actions: (0, (0, parcelRequire("7tQNr")).actions)
    });
    const $6d8bca487172cfe1$var$useStore = (0, (0, parcelRequire("3sQ5x")).createHook)($6d8bca487172cfe1$export$6f57813fe9f31bf9);
    const $6d8bca487172cfe1$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $5uXOq.useMemo)(()=>({
                getTourState: getTourState({
                    baseUrl: baseUrl
                }),
                setTourState: setTourState({
                    baseUrl: baseUrl
                })
            }), [
            baseUrl,
            getTourState,
            setTourState
        ]);
    const $6d8bca487172cfe1$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $5uXOq.useMemo)(()=>({
                data: data,
                isLoading: isLoading,
                error: error
            }), [
            data,
            isLoading,
            error
        ]);
    const $6d8bca487172cfe1$export$4aecabf781c5d857 = ()=>{
        const baseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
        const [state, actions] = $6d8bca487172cfe1$var$useStore();
        const memoizedActions = $6d8bca487172cfe1$var$useActionsMemo({
            ...actions,
            baseUrl: baseUrl
        });
        const memoizedState = $6d8bca487172cfe1$var$useStateMemo(state);
        return (0, $5uXOq.useMemo)(()=>[
                memoizedState,
                memoizedActions
            ], [
            memoizedActions,
            memoizedState
        ]);
    };
});
parcelRegister("7tQNr", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$e522e9db5e833423$export$e324594224ef24da);
    var $bXTMr;
    var $2SNiB;
    const $e522e9db5e833423$export$e324594224ef24da = {
        getTourState: (0, parcelRequire("bXTMr")).getTourState,
        setTourState: (0, parcelRequire("2SNiB")).setTourState
    };
});
parcelRegister("bXTMr", function(module, exports) {
    $parcel$export(module.exports, "getTourState", ()=>$eed4e52cff30c013$export$a758fd93ae41dde5);
    var $aDvGo;
    var $jcw0u;
    var $jJZqs;
    var $fZneA;
    var $g5X3G;
    const $eed4e52cff30c013$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
    const $eed4e52cff30c013$var$fetchTourState = async (baseUrl)=>{
        const url = $eed4e52cff30c013$var$getUrl(baseUrl);
        const response = await fetch(url, (0, (0, parcelRequire("aDvGo")).default));
        if (!response.ok) {
            const text = await response.text();
            const error = new (0, (0, parcelRequire("jJZqs")).default)(response.status, text);
            if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getTourState_responseNotOK',
                    packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                    teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                },
                attributes: {
                    message: error.message
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        return response.json();
    };
    const $eed4e52cff30c013$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
                const { data: data, isLoading: isLoading } = getState();
                if (data || isLoading) return;
                setState({
                    error: undefined,
                    isLoading: true
                });
                try {
                    const result = await $eed4e52cff30c013$var$fetchTourState(baseUrl);
                    const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                    setState({
                        data: {
                            seenProjectTour: seenProjectTour,
                            projectId: projectId === null ? null : (0, (0, parcelRequire("g5X3G")).toProjectId)(projectId)
                        },
                        isLoading: false
                    });
                } catch (error) {
                    if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'getTourState',
                            packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                            teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        error: error,
                        isLoading: false
                    });
                    if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) throw error;
                }
            };
});
parcelRegister("2SNiB", function(module, exports) {
    $parcel$export(module.exports, "setTourState", ()=>$e6283e07e269c047$export$35f9649c739aaca3);
    var $aDvGo;
    var $jcw0u;
    var $jJZqs;
    const $e6283e07e269c047$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
    const $e6283e07e269c047$var$putTourState = async (baseUrl, tourState)=>{
        const url = $e6283e07e269c047$var$getUrl(baseUrl);
        const response = await fetch(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            method: 'PUT',
            body: JSON.stringify(tourState)
        });
        if (!response.ok) {
            const text = await response.text();
            const error = new (0, (0, parcelRequire("jJZqs")).default)(response.status, text);
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'setTourState_responseNotOK',
                    packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                    teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                },
                attributes: {
                    message: error.message
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $e6283e07e269c047$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>async (tourState)=>{
                setState({
                    error: undefined,
                    data: tourState,
                    isLoading: true
                });
                try {
                    await $e6283e07e269c047$var$putTourState(baseUrl, tourState);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'setTourState',
                            packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                            teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        error: error
                    });
                    throw error;
                } finally{
                    setState({
                        isLoading: false
                    });
                }
            };
});
parcelRegister("7HThi", function(module, exports) {
    $parcel$export(module.exports, "useIsItsmSampleProject", ()=>$1bd32a46a0882e8f$export$b8afdaba4bd6f483);
    var $hGgHi = parcelRequire("hGgHi");
    var $aNLeB;
    var $g4ge5;
    const $1bd32a46a0882e8f$export$b8afdaba4bd6f483 = ()=>{
        const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, (0, parcelRequire("g4ge5")).useIsDemoProject)();
        const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, (0, parcelRequire("aNLeB")).useIsItsmTemplateProject)();
        return {
            data: !(0, ($parcel$interopDefault($hGgHi)))(isDemoProject) && !(0, ($parcel$interopDefault($hGgHi)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
            loading: loadingIsDemoProject || loadingIsItsmProject,
            error: errorIsDemoProject || errorIsItsmProject
        };
    };
});
parcelRegister("g4ge5", function(module, exports) {
    $parcel$export(module.exports, "useIsDemoProject", ()=>$09e24bc2f005ce6a$export$9b4078600f2ad4d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $4DPZY;
    var $g5X3G;
    var $3sQ5x;
    var $iXqE5;
    var $dciEf;
    var $6LFnT;
    const $09e24bc2f005ce6a$export$d4c72bab9d6cc13a = {};
    const $09e24bc2f005ce6a$export$bf108b10a3a0ab90 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'IsDemoProject',
        initialState: $09e24bc2f005ce6a$export$d4c72bab9d6cc13a,
        actions: (0, (0, parcelRequire("dciEf")).actions)
    });
    const $09e24bc2f005ce6a$var$useIsDemoProjectStore = (0, (0, parcelRequire("3sQ5x")).createHook)($09e24bc2f005ce6a$export$bf108b10a3a0ab90);
    const $09e24bc2f005ce6a$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    const $09e24bc2f005ce6a$export$9b4078600f2ad4d2 = ()=>{
        const [{ data: contextData }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const numProjectId = contextData && contextData.project && contextData.project.id;
        const projectId = (0, (0, parcelRequire("g5X3G")).toProjectId)(String(numProjectId));
        const baseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
        const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $09e24bc2f005ce6a$var$useIsDemoProjectStore();
        const memoizedState = $09e24bc2f005ce6a$var$useStateMemo({
            ...state[projectId] ?? (0, (0, parcelRequire("6LFnT")).initialIsDemoProjectState)
        });
        const { data: data } = memoizedState;
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(numProjectId) && (0, ($parcel$interopDefault($hGgHi)))(data)) fetchIsDemoProject({
                baseUrl: baseUrl,
                projectId: projectId
            })();
        }, [
            fetchIsDemoProject,
            baseUrl,
            numProjectId,
            projectId,
            data
        ]);
        return memoizedState;
    };
});
parcelRegister("dciEf", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$ffc7e95937855e49$export$e324594224ef24da);
    var $4MUdY;
    const $ffc7e95937855e49$export$e324594224ef24da = {
        fetchIsDemoProject: (0, parcelRequire("4MUdY")).fetchIsDemoProject
    };
});
parcelRegister("4MUdY", function(module, exports) {
    $parcel$export(module.exports, "fetchIsDemoProject", ()=>$19341c0fa64f8930$export$feaee63a215b34da);
    var $hGgHi = parcelRequire("hGgHi");
    var $i8xPd;
    var $6LFnT;
    const $19341c0fa64f8930$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>({ getState: getState, setState: setState })=>async ()=>{
                const projectState = getState()[projectId] ?? (0, (0, parcelRequire("6LFnT")).initialIsDemoProjectState);
                if (!(0, ($parcel$interopDefault($hGgHi)))(projectState.data) || projectState.loading) return;
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        loading: true
                    }
                });
                try {
                    const isDemo = await (0, (0, parcelRequire("i8xPd")).isDemoProject)({
                        baseUrl: baseUrl,
                        projectId: projectId
                    });
                    setState({
                        ...getState(),
                        [String(projectId)]: {
                            ...projectState,
                            data: isDemo,
                            error: null,
                            loading: false
                        }
                    });
                } catch (error) {
                    setState({
                        ...getState(),
                        [String(projectId)]: {
                            ...projectState,
                            error: error,
                            loading: false
                        }
                    });
                    throw error;
                }
            };
});
parcelRegister("i8xPd", function(module, exports) {
    $parcel$export(module.exports, "isDemoProject", ()=>$aef4f72f73469a32$export$cf7813449d38d4ac);
    $parcel$export(module.exports, "getItsmSampleProject", ()=>$aef4f72f73469a32$export$c498e29d716efe7a);
    var $38QcJ;
    var $dJl1T;
    var $4R6GH;
    var $eusud;
    const $aef4f72f73469a32$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
        try {
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_caching_layer_milestone_1')) {
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('jira.servicedesk.itsm-sample-project.utils', `isDemoProject is using cache: FF jira_caching_layer_milestone_1 - ${(0, (0, parcelRequire("4R6GH")).fg)('jira_caching_layer_milestone_1')}`);
                const response = await (0, (0, parcelRequire("38QcJ")).performGetRequestWithCache)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`, (error)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('jira.servicedesk.itsm-sample-project.utils', `On fetch Cache Error - ${error.name} - FG - ${(0, (0, parcelRequire("4R6GH")).fg)('jira_caching_layer_milestone_1')}`);
                    if (error.statusCode === 404) return {
                        value: false
                    };
                    throw error;
                });
                return !!response && !!response.value;
            }
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
            return !!response && !!response.value;
        } catch (error) {
            if (error.statusCode === 404) return false;
            throw error;
        }
    };
    const $aef4f72f73469a32$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
            return response;
        } catch (error) {
            if (error.statusCode === 404) return undefined;
            throw error;
        }
    };
});
parcelRegister("38QcJ", function(module, exports) {
    $parcel$export(module.exports, "performGetRequestWithCache", ()=>$babbea8c3a621dad$export$2df9cfe22532d245);
    var $eusud;
    var $aDezs;
    const $babbea8c3a621dad$export$2df9cfe22532d245 = (0, (0, parcelRequire("aDezs")).withCache)((0, (0, parcelRequire("eusud")).performGetRequest));
});
parcelRegister("aDezs", function(module, exports) {
    $parcel$export(module.exports, "withCache", ()=>$807c4ec3ea856331$export$33b32b3abf8170f0);
    var $sn9QA;
    var $x9xyg;
    var $4R6GH;
    var $4sfTg;
    const $807c4ec3ea856331$var$jiraCache = (0, (0, parcelRequire("sn9QA")).createIndexedDBStorageProvider)('jira-cache', {
        shouldAutoReconnect: true
    });
    const $807c4ec3ea856331$var$SEVEN_DAYS_IN_MILLIS = 604800000;
    const $807c4ec3ea856331$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = $807c4ec3ea856331$var$SEVEN_DAYS_IN_MILLIS, options = {})=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_caching_layer_milestone_1')) return fn(url, options);
            const cachedKey = (0, (0, parcelRequire("4sfTg")).createCacheKey)(url);
            (0, (0, parcelRequire("x9xyg")).setMark)('indexed-db-cache-read:start');
            const cachedData = await $807c4ec3ea856331$var$jiraCache.get(cachedKey);
            (0, (0, parcelRequire("x9xyg")).setMark)('indexed-db-cache-read:end');
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) data = onFnErrorCacheHandler(error);
                else throw error;
            }
            (0, (0, parcelRequire("x9xyg")).setMark)('indexed-db-cache-write:start');
            await $807c4ec3ea856331$var$jiraCache.set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('indexed-db-cache-write:end');
            return data;
        };
});
parcelRegister("sn9QA", function(module, exports) {
    $parcel$export(module.exports, "createIndexedDBStorageProvider", ()=>$cf3437e9474a0e2b$export$6ba36c4f5fb8919d);
    var $gJBT6 = parcelRequire("gJBT6");
    var $8vEj7;
    const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, ($parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const provider = (0, (0, parcelRequire("8vEj7")).createStorageProvider)(appPrefix);
        if (options?.shouldAutoReconnect) return (0, (0, parcelRequire("8vEj7")).withAutoReconnect)(provider);
        return provider;
    });
});
parcelRegister("8vEj7", function(module, exports) {
    $parcel$export(module.exports, "createStorageProvider", ()=>$33b8db71261fb346$export$8441605555fbd60c);
    $parcel$export(module.exports, "withAutoReconnect", ()=>$33b8db71261fb346$export$8432fe49db7d8865);
    var $jIIX7;
    const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
    const $33b8db71261fb346$var$createCustomStore = ()=>(0, (0, parcelRequire("jIIX7")).createStore)('keyval-store', 'keyval');
    let $33b8db71261fb346$var$customStore;
    const $33b8db71261fb346$var$getStore = ()=>{
        let store = $33b8db71261fb346$var$customStore;
        if (!store) {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
            store = $33b8db71261fb346$var$customStore;
        }
        return store;
    };
    const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
        const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
        const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
        const assertKey = (key)=>{
            if (!key) throw Error('You must provide a key');
        };
        const updateStoreKeys = async (key, remove = false)=>(0, (0, parcelRequire("jIIX7")).update)(KEYS_STORE_PREFIX, (currentKeys)=>{
                const storeKeys = new Set(currentKeys);
                if (remove) {
                    storeKeys.delete(key);
                    return Array.from(storeKeys.values());
                }
                storeKeys.add(key);
                return Array.from(storeKeys.values());
            }, $33b8db71261fb346$var$getStore());
        return {
            async get (key) {
                assertKey(key);
                return (0, (0, parcelRequire("jIIX7")).get)(prefix(key), $33b8db71261fb346$var$getStore());
            },
            async remove (key) {
                assertKey(key);
                const prefixedKey = prefix(key);
                await (0, (0, parcelRequire("jIIX7")).del)(prefixedKey, $33b8db71261fb346$var$getStore());
                return updateStoreKeys(prefixedKey, true);
            },
            async clearAll () {
                const prefixedKeys = await (0, (0, parcelRequire("jIIX7")).get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
                if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
                return (0, (0, parcelRequire("jIIX7")).delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
            },
            async set (key, value) {
                assertKey(key);
                const prefixedKey = prefix(key);
                if (typeof value === 'function') (0, (0, parcelRequire("jIIX7")).update)(prefixedKey, value);
                else (0, (0, parcelRequire("jIIX7")).set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
                return updateStoreKeys(prefixedKey);
            },
            async reconnect () {
                $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
            }
        };
    };
    const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
            async get (...args) {
                try {
                    return await storageProvider.get(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.get(...args);
                    }
                    throw e;
                }
            },
            async set (...args) {
                try {
                    return await storageProvider.set(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.set(...args);
                    }
                    throw e;
                }
            },
            async remove (...args) {
                try {
                    return await storageProvider.remove(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.remove(...args);
                    }
                    throw e;
                }
            },
            async clearAll (...args) {
                try {
                    return await storageProvider.clearAll(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.clearAll(...args);
                    }
                    throw e;
                }
            },
            async reconnect () {
                await storageProvider.reconnect?.();
            }
        });
});
parcelRegister("jIIX7", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$e5b4ff07e835609c$export$f51a9068ac82ea43);
    $parcel$export(module.exports, "get", ()=>$e5b4ff07e835609c$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$e5b4ff07e835609c$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "update", ()=>$e5b4ff07e835609c$export$722fbec263ad908a);
    $parcel$export(module.exports, "del", ()=>$e5b4ff07e835609c$export$1d2f21e549771e67);
    $parcel$export(module.exports, "delMany", ()=>$e5b4ff07e835609c$export$c8aa84257229cac8);
    function $e5b4ff07e835609c$export$b327150396135fe7(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
        return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
    }
    let $e5b4ff07e835609c$var$defaultGetStoreFunc;
    function $e5b4ff07e835609c$var$defaultGetStore() {
        if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
        return $e5b4ff07e835609c$var$defaultGetStoreFunc;
    }
    function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
    }
    function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.put(value, key);
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            entries.forEach((entry)=>store.put(entry[1], entry[0]));
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
    }
    function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>new Promise((resolve, reject)=>{
                store.get(key).onsuccess = function() {
                    try {
                        store.put(updater(this.result), key);
                        resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                    } catch (err) {
                        reject(err);
                    }
                };
            }));
    }
    function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.delete(key);
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            keys.forEach((key)=>store.delete(key));
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.clear();
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$var$eachCursor(store, callback) {
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    }
    function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
            const items = [];
            return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
        });
    }
    function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
            const items = [];
            return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
        });
    }
    function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAll && store.getAllKeys) return Promise.all([
                $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
                $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
            ]).then(([keys, values])=>keys.map((key, i)=>[
                        key,
                        values[i]
                    ]));
            const items = [];
            return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                        cursor.key,
                        cursor.value
                    ])).then(()=>items));
        });
    }
});
parcelRegister("4sfTg", function(module, exports) {
    $parcel$export(module.exports, "createCacheKey", ()=>$ae7ce70bbd907415$export$aa68fd26e593cc7e);
    var $4Pf62;
    const $ae7ce70bbd907415$export$aa68fd26e593cc7e = (endpoint)=>{
        const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const url = new URL(endpoint, window.location.origin);
        const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
        const endpointWithSearch = prefix + url.pathname + url.search;
        return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
    };
});
parcelRegister("6LFnT", function(module, exports) {
    $parcel$export(module.exports, "initialIsDemoProjectState", ()=>$21d88e1743f1ae3e$export$f6365b0f25aeae62);
    const $21d88e1743f1ae3e$export$f6365b0f25aeae62 = {
        data: null,
        loading: false,
        error: null
    };
});
parcelRegister("aeeX4", function(module, exports) {
    $parcel$export(module.exports, "ActiveState", ()=>$599e4b79be7e97d2$export$2f27df41e8b7edbb);
    $parcel$export(module.exports, "VisualState", ()=>$599e4b79be7e97d2$export$285eeaa5f468cfb6);
    $parcel$export(module.exports, "Product", ()=>$599e4b79be7e97d2$export$264ad599d7cef668);
    $parcel$export(module.exports, "Environment", ()=>$599e4b79be7e97d2$export$7dc6752a22ab011a);
    $parcel$export(module.exports, "GspSectionKey", ()=>$599e4b79be7e97d2$export$f4906a03a7a2d0af);
    $parcel$export(module.exports, "ChecklistTabKey", ()=>$599e4b79be7e97d2$export$4f1a05ccc35315c6);
    $parcel$export(module.exports, "ProductTourKey", ()=>$599e4b79be7e97d2$export$aa90cbc80c330872);
    $parcel$export(module.exports, "HeaderState", ()=>$599e4b79be7e97d2$export$38aab4015a34ead);
    $parcel$export(module.exports, "TaskId", ()=>$599e4b79be7e97d2$export$10cc267f702fbadd);
    $parcel$export(module.exports, "BasicsTaskIdsProductionised", ()=>$599e4b79be7e97d2$export$fe6666d729b0d637);
    $parcel$export(module.exports, "TeamEfficiencyTaskIds", ()=>$599e4b79be7e97d2$export$ed4dcaac45c6a484);
    $parcel$export(module.exports, "ChangesTaskIds", ()=>$599e4b79be7e97d2$export$3de0dd66b0de4cdc);
    $parcel$export(module.exports, "IncidentsTaskIds", ()=>$599e4b79be7e97d2$export$2852680309cf5a68);
    $parcel$export(module.exports, "AlertsTaskIds", ()=>$599e4b79be7e97d2$export$4f537e3bd8843f30);
    $parcel$export(module.exports, "HasSeenReopenSpotlight", ()=>$599e4b79be7e97d2$export$72401d057976d548);
    $parcel$export(module.exports, "ContainerType", ()=>$599e4b79be7e97d2$export$7d7a98f44861e6f7);
    $parcel$export(module.exports, "ExplicitStringBoolean", ()=>$599e4b79be7e97d2$export$d7341fa10d264a87);
    $parcel$export(module.exports, "PropertyKey", ()=>$599e4b79be7e97d2$export$e6bec6a1026bf0b4);
    var $599e4b79be7e97d2$export$2f27df41e8b7edbb;
    (function(ActiveState) {
        ActiveState["On"] = "on";
        ActiveState["Off"] = "off";
    })($599e4b79be7e97d2$export$2f27df41e8b7edbb || ($599e4b79be7e97d2$export$2f27df41e8b7edbb = {}));
    var $599e4b79be7e97d2$export$285eeaa5f468cfb6;
    (function(VisualState) {
        VisualState["Lozenge"] = "lozenge";
        VisualState["FullPanel"] = "full-panel";
    })($599e4b79be7e97d2$export$285eeaa5f468cfb6 || ($599e4b79be7e97d2$export$285eeaa5f468cfb6 = {}));
    var $599e4b79be7e97d2$export$264ad599d7cef668;
    (function(Product) {
        Product["ServiceDesk"] = "serviceDesk";
        Product["Opsgenie"] = "opsgenie";
    })($599e4b79be7e97d2$export$264ad599d7cef668 || ($599e4b79be7e97d2$export$264ad599d7cef668 = {}));
    var $599e4b79be7e97d2$export$7dc6752a22ab011a;
    (function(Environment) {
        Environment["Local"] = "local";
        Environment["Dev"] = "dev";
        Environment["Staging"] = "staging";
        Environment["Prod"] = "prod";
    })($599e4b79be7e97d2$export$7dc6752a22ab011a || ($599e4b79be7e97d2$export$7dc6752a22ab011a = {}));
    var $599e4b79be7e97d2$export$f4906a03a7a2d0af;
    (function(GspSectionKey) {
        GspSectionKey["Checklist"] = "checklist";
        GspSectionKey["ProductTours"] = "productTours";
        GspSectionKey["Home"] = "home";
    })($599e4b79be7e97d2$export$f4906a03a7a2d0af || ($599e4b79be7e97d2$export$f4906a03a7a2d0af = {}));
    var $599e4b79be7e97d2$export$4f1a05ccc35315c6;
    (function(ChecklistTabKey) {
        ChecklistTabKey["Basics"] = "basics";
        ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
        ChecklistTabKey["Incidents"] = "incidents";
        ChecklistTabKey["Changes"] = "changes";
        ChecklistTabKey["Alerts"] = "alerts";
    })($599e4b79be7e97d2$export$4f1a05ccc35315c6 || ($599e4b79be7e97d2$export$4f1a05ccc35315c6 = {}));
    var $599e4b79be7e97d2$export$aa90cbc80c330872;
    (function(ProductTourKey) {
        ProductTourKey["Welcome"] = "welcome";
        ProductTourKey["IncidentManagement"] = "incident-management";
        ProductTourKey["ChangeManagement"] = "change-management";
    })($599e4b79be7e97d2$export$aa90cbc80c330872 || ($599e4b79be7e97d2$export$aa90cbc80c330872 = {}));
    var $599e4b79be7e97d2$export$38aab4015a34ead;
    (function(HeaderState) {
        HeaderState["Minimized"] = "minimized";
        HeaderState["Expanded"] = "expanded";
    })($599e4b79be7e97d2$export$38aab4015a34ead || ($599e4b79be7e97d2$export$38aab4015a34ead = {}));
    var $599e4b79be7e97d2$export$10cc267f702fbadd;
    (function(TaskId) {
        TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
        TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
        TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
        TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
        TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
        TaskId["SetupServices"] = "servicedesk-services-setup";
        TaskId["AddTeamMember"] = "servicedesk-team-member-added";
        TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
        TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
        TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
        TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
        TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
        TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
        TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
        TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
        TaskId["SetupTeam"] = "opsgenie-response-team-setup";
        TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
        TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
        TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
        TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
        TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
        TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
        TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
        TaskId["AddIntegration"] = "opsgenie-add-integration";
        TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
        TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
    })($599e4b79be7e97d2$export$10cc267f702fbadd || ($599e4b79be7e97d2$export$10cc267f702fbadd = {}));
    const $599e4b79be7e97d2$export$9846214c9c3411dc = [
        "servicedesk-itsm-project-created",
        "servicedesk-portal-name-customized",
        "servicedesk-logo-added-to-portal",
        "servicedesk-email-requests-setup",
        "servicedesk-services-setup",
        "servicedesk-team-member-added",
        "servicedesk-basics-documentation-accessed"
    ];
    const $599e4b79be7e97d2$export$fe6666d729b0d637 = [
        "servicedesk-itsm-project-created",
        "servicedesk-portal-name-customized",
        "servicedesk-email-requests-setup",
        "servicedesk-chat-requests-setup",
        "servicedesk-services-setup",
        "servicedesk-team-member-added"
    ];
    const $599e4b79be7e97d2$export$ed4dcaac45c6a484 = [
        "servicedesk-team-efficiency-automate-your-work",
        "servicedesk-team-efficiency-setup-knowledge-base"
    ];
    const $599e4b79be7e97d2$export$3de0dd66b0de4cdc = [
        "servicedesk-change-management-pipeline-connected",
        "servicedesk-change-management-change-approvers-added",
        "servicedesk-change-management-documentation-accessed"
    ];
    const $599e4b79be7e97d2$export$2852680309cf5a68 = [
        "opsgenie-user-profile-notifications-setup",
        "opsgenie-response-team-setup",
        "opsgenie-owner-team-assigned-to-service",
        "opsgenie-incident-management-documentation-accessed"
    ];
    const $599e4b79be7e97d2$export$4f537e3bd8843f30 = [
        "opsgenie-enable-ops-for-team",
        "opsgenie-review-oncall-setup",
        "opsgenie-add-integration",
        "opsgenie-setup-ops-notifications",
        "opsgenie-review-alerts"
    ];
    var $599e4b79be7e97d2$export$72401d057976d548;
    (function(HasSeenReopenSpotlight) {
        HasSeenReopenSpotlight["Yes"] = "yes";
        HasSeenReopenSpotlight["No"] = "no";
    })($599e4b79be7e97d2$export$72401d057976d548 || ($599e4b79be7e97d2$export$72401d057976d548 = {}));
    var $599e4b79be7e97d2$export$7d7a98f44861e6f7;
    (function(ContainerType) {
        ContainerType["Project"] = "project";
    })($599e4b79be7e97d2$export$7d7a98f44861e6f7 || ($599e4b79be7e97d2$export$7d7a98f44861e6f7 = {}));
    var $599e4b79be7e97d2$export$d7341fa10d264a87;
    (function(ExplicitStringBoolean) {
        ExplicitStringBoolean["Yes"] = "yes";
        ExplicitStringBoolean["No"] = "no";
    })($599e4b79be7e97d2$export$d7341fa10d264a87 || ($599e4b79be7e97d2$export$d7341fa10d264a87 = {}));
    var $599e4b79be7e97d2$export$e6bec6a1026bf0b4;
    (function(PropertyKey) {
        PropertyKey["VisualState"] = "visualState";
        PropertyKey["ActiveState"] = "activeState";
        PropertyKey["SectionState"] = "sectionState";
        PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
    })($599e4b79be7e97d2$export$e6bec6a1026bf0b4 || ($599e4b79be7e97d2$export$e6bec6a1026bf0b4 = {}));
});
parcelRegister("9TJvQ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$5b9ea72599cc2c41$export$e324594224ef24da);
    var $fnccg;
    var $5lmbj;
    var $WkJdq;
    var $aLRn2;
    var $6g0vj;
    var $jVCdW;
    var $kTf1j;
    var $01F1V;
    var $9FflN;
    const $5b9ea72599cc2c41$export$e324594224ef24da = {
        initializeState: (0, parcelRequire("5lmbj")).initializeState,
        fetchState: (0, parcelRequire("fnccg")).fetchState,
        savePanelState: (0, parcelRequire("jVCdW")).savePanelState,
        reopenGettingStartedPanel: (0, parcelRequire("aLRn2")).reopenGettingStartedPanel,
        markReopenSpotlightAsSeen: (0, parcelRequire("WkJdq")).markReopenSpotlightAsSeen,
        resolveTask: (0, parcelRequire("6g0vj")).resolveTask,
        saveProperty: (0, parcelRequire("kTf1j")).saveProperty,
        stopRecordingPerformanceExperiences: (0, parcelRequire("9FflN")).stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility: (0, parcelRequire("01F1V")).setOpsAdminTaskVisibility
    };
});
parcelRegister("fnccg", function(module, exports) {
    $parcel$export(module.exports, "fetchState", ()=>$5cbeba9ce380e24a$export$f3df9013f2b58bce);
    var $8LQ84 = parcelRequire("8LQ84");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $k0qYG = parcelRequire("k0qYG");
    var $agVdz = parcelRequire("agVdz");
    var $jcw0u;
    var $6s1PB;
    var $7f4tk;
    var $8zOmE;
    var $gcBmk;
    var $j25Gb;
    var $eRXyM;
    var $5lmbj;
    const $5cbeba9ce380e24a$export$e15c3a0c2c6f7c69 = {
        RESPONSE_NOT_OBJECT: 'response is not an object',
        RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
        RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
        RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
        RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
        FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
    };
    const $5cbeba9ce380e24a$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
        const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
        const hasProject = ((0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') || isProjectTourSeen) && isItsmProject && !(0, ($parcel$interopDefault($hGgHi)))(projectId) && !(0, ($parcel$interopDefault($hGgHi)))(isItsmSampleProject);
        if (hasProject || enableOpsTeamMode) await dispatch((0, (0, parcelRequire("5lmbj")).initializeState)(actionProps))({
            projectId: projectId
        });
    };
    const $5cbeba9ce380e24a$export$8f32748afb26c81d = (response)=>{
        try {
            if (!(0, ($parcel$interopDefault($k0qYG)))(response)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
            const completedTasks = response?.completedItems;
            const properties = response?.properties;
            if (!(0, ($parcel$interopDefault($8LQ84)))(completedTasks)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
            if (!(0, ($parcel$interopDefault($k0qYG)))(properties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
            const userProperties = properties.user;
            if (!(0, ($parcel$interopDefault($k0qYG)))(userProperties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
            const sectionStateString = userProperties.sectionState;
            if (sectionStateString === undefined) return undefined;
            if (!(0, ($parcel$interopDefault($agVdz)))(sectionStateString)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
            try {
                JSON.parse(sectionStateString);
                return response;
            } catch (parseError) {
                throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
            }
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'fetchState_constructDataFromResponse',
                    packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                    teamName: 'itops-mithril'
                },
                attributes: {
                    message: error.message
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $5cbeba9ce380e24a$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
                const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
                const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
                if (isSaving) return;
                if (isGspInitialized) try {
                    let response;
                    try {
                        response = await (0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("5lmbj")).getUrl)({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'GET',
                            mode: 'cors',
                            credentials: 'include'
                        });
                    } catch (error) {
                        if (error.statusCode !== 404) throw error;
                    }
                    if (isSaving) return;
                    let data = response ? $5cbeba9ce380e24a$export$8f32748afb26c81d(response) : undefined;
                    if (enableUserCentricMode && data) data = await (0, (0, parcelRequire("eRXyM")).handleUserCentricMode)(data, cloudId);
                    else if (enableOpsTeamMode && teamId && data) {
                        const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                        data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                        data = await (0, (0, parcelRequire("j25Gb")).handleOpsTeamMode)(data, teamId, cloudId);
                    }
                    if (!!data && (0, ($parcel$interopDefault($ajpes)))(data, currentData)) return;
                    setState({
                        data: data,
                        isGspInitialized: !!data
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
                } catch (error) {
                    if ((0, (0, parcelRequire("gcBmk")).isExpectedError)(error)) return;
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'fetchState',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                const { isGspInitialized: currentIsGspInitialized } = getState();
                if (!currentIsGspInitialized) $5cbeba9ce380e24a$var$tryInitializeState({
                    ...actionProps,
                    dispatch: dispatch
                });
            };
});
const $fb1b8c66ae3d9468$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$47712c7937145142 = 320;
const $fb1b8c66ae3d9468$export$1cad4f611a1c0229 = 220;
const $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$bc8b984358922f81 = 'team';
const $fb1b8c66ae3d9468$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $fb1b8c66ae3d9468$export$cbbd90bf5df877bd = 'cloudid';
const $fb1b8c66ae3d9468$export$a74074a8f4372ab0 = 'referrer';
parcelRegister("gcBmk", function(module, exports) {
    $parcel$export(module.exports, "isInClassicSettingsPage", ()=>$7864772e348f8c72$export$a6e1eca03e2de987);
    $parcel$export(module.exports, "getCurrentPageName", ()=>$7864772e348f8c72$export$e2c4f60e8cad01fb);
    $parcel$export(module.exports, "isExpectedError", ()=>$7864772e348f8c72$export$8715824c16ceeca0);
    $parcel$export(module.exports, "shouldIncludePathname", ()=>$7864772e348f8c72$export$83501d9ba065ef89);
    $parcel$export(module.exports, "shouldExcludePathname", ()=>$7864772e348f8c72$export$8752a3c4a740bd52);
    $parcel$export(module.exports, "shouldExcludeRouteName", ()=>$7864772e348f8c72$export$5d52a100c70d4375);
    var $9UgXz = parcelRequire("9UgXz");
    var $fZneA;
    const $7864772e348f8c72$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
    const $7864772e348f8c72$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
    const $7864772e348f8c72$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
    const $7864772e348f8c72$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
    const $7864772e348f8c72$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
    const $7864772e348f8c72$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
    const $7864772e348f8c72$export$f8f0d4e52d7e9716 = (pathname)=>$7864772e348f8c72$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
    const $7864772e348f8c72$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
    const $7864772e348f8c72$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
    const $7864772e348f8c72$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
    const $7864772e348f8c72$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
    const $7864772e348f8c72$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
    const $7864772e348f8c72$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
    const $7864772e348f8c72$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
    const $7864772e348f8c72$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
    const $7864772e348f8c72$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
    const $7864772e348f8c72$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
    const $7864772e348f8c72$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
    const $7864772e348f8c72$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
    const $7864772e348f8c72$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
    const $7864772e348f8c72$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
    const $7864772e348f8c72$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
    const $7864772e348f8c72$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
    const $7864772e348f8c72$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
    const $7864772e348f8c72$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
    const $7864772e348f8c72$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
    const $7864772e348f8c72$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
    const $7864772e348f8c72$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
    const $7864772e348f8c72$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
    const $7864772e348f8c72$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
    const $7864772e348f8c72$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
    const $7864772e348f8c72$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
    const $7864772e348f8c72$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
    const $7864772e348f8c72$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
    const $7864772e348f8c72$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
    const $7864772e348f8c72$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
    const $7864772e348f8c72$export$a6e1eca03e2de987 = (pathname)=>$7864772e348f8c72$export$dbf902576403f80e(pathname) || $7864772e348f8c72$export$458d0b4237ae1dad(pathname) || $7864772e348f8c72$export$3b5fbfd2bca32dde(pathname) || $7864772e348f8c72$export$aeffbab88b3257bb(pathname) || $7864772e348f8c72$export$7e3236de8c2c8fcb(pathname) || $7864772e348f8c72$export$908f99db4c2098a0(pathname) || $7864772e348f8c72$export$c5b9a5ba6b3e9b66(pathname) || $7864772e348f8c72$export$f4e3d864ce1a2f74(pathname) || $7864772e348f8c72$export$21361d1ad00e769e(pathname) || $7864772e348f8c72$export$6208845cb364d4de(pathname) || $7864772e348f8c72$export$16978d524c086b4(pathname) || $7864772e348f8c72$export$b6d6b41b75346458(pathname) || $7864772e348f8c72$export$5b2153f9a7427657(pathname) || $7864772e348f8c72$export$c5434c69e9b50e81(pathname) || $7864772e348f8c72$export$3a7002667b72e8d7(pathname) || $7864772e348f8c72$export$542a1f79f5837827(pathname) || $7864772e348f8c72$export$b748c9dbd5996d34(pathname) || $7864772e348f8c72$export$455a6199a321423(pathname) || $7864772e348f8c72$export$fa426b2da28e4ae2(pathname) || $7864772e348f8c72$export$fc0fba46b7584812(pathname) || $7864772e348f8c72$export$882325faa1a194c6(pathname) || $7864772e348f8c72$export$8bb0073f55baf38b(pathname) || $7864772e348f8c72$export$1b69f3aa169f179(pathname) || $7864772e348f8c72$export$1c47b1cb87da237(pathname) || $7864772e348f8c72$export$ee56a66aa8efb6da(pathname) || $7864772e348f8c72$export$6256b4d737fa56f2(pathname) || $7864772e348f8c72$export$3f77d24f8de610a0(pathname);
    const $7864772e348f8c72$var$screenNameMap = {
        queues: $7864772e348f8c72$export$d7638addf23014e7,
        issues: $7864772e348f8c72$export$1b685dac913c7026,
        customers: $7864772e348f8c72$export$6292763547421a38,
        reports: $7864772e348f8c72$export$a05100bbf8bc68c3,
        knowledge: $7864772e348f8c72$export$e75cc3ec1f686973,
        services: $7864772e348f8c72$export$66d002c194bc72aa,
        onCall: $7864772e348f8c72$export$430089990bd4af09,
        incidents: $7864772e348f8c72$export$a655a298d384c316,
        problems: $7864772e348f8c72$export$1c5f444b718144b7,
        changes: $7864772e348f8c72$export$42dd8a49c7fa462c,
        serviceRequests: $7864772e348f8c72$export$5c77a7ea15a04e63,
        classicSettingsDetails: $7864772e348f8c72$export$dbf902576403f80e,
        classicSettingsPeople: $7864772e348f8c72$export$458d0b4237ae1dad,
        classicSettingsSummary: $7864772e348f8c72$export$3b5fbfd2bca32dde,
        classicSettingsIssueTypes: $7864772e348f8c72$export$aeffbab88b3257bb,
        classicSettingsRequestTypes: $7864772e348f8c72$export$7e3236de8c2c8fcb,
        classicSettingsChangeManagement: $7864772e348f8c72$export$908f99db4c2098a0,
        classicSettingsCustomerPermissions: $7864772e348f8c72$export$c5b9a5ba6b3e9b66,
        classicSettingsLanguage: $7864772e348f8c72$export$f4e3d864ce1a2f74,
        classicSettingsPortal: $7864772e348f8c72$export$21361d1ad00e769e,
        classicSettingsEmail: $7864772e348f8c72$export$6208845cb364d4de,
        classicSettingsEmailAlias: $7864772e348f8c72$export$16978d524c086b4,
        classicSettingsCustomerNotifications: $7864772e348f8c72$export$b6d6b41b75346458,
        classicSettingsWidget: $7864772e348f8c72$export$5b2153f9a7427657,
        classicSettingsFeedback: $7864772e348f8c72$export$c5434c69e9b50e81,
        classicSettingsConfluence: $7864772e348f8c72$export$3a7002667b72e8d7,
        classicSettingsSla: $7864772e348f8c72$export$542a1f79f5837827,
        classicSettingsAutomation: $7864772e348f8c72$export$b748c9dbd5996d34,
        classicSettingsApps: $7864772e348f8c72$export$455a6199a321423,
        classicSettingsWorkflows: $7864772e348f8c72$export$fa426b2da28e4ae2,
        classicSettingsScreens: $7864772e348f8c72$export$fc0fba46b7584812,
        classicSettingsFields: $7864772e348f8c72$export$882325faa1a194c6,
        classicSettingsVersions: $7864772e348f8c72$export$8bb0073f55baf38b,
        classicSettingsComponents: $7864772e348f8c72$export$1b69f3aa169f179,
        classicSettingsPermissions: $7864772e348f8c72$export$1c47b1cb87da237,
        classicSettingsIssueSecurity: $7864772e348f8c72$export$ee56a66aa8efb6da,
        classicSettingsNotifications: $7864772e348f8c72$export$6256b4d737fa56f2,
        classicSettingsIssueCollectors: $7864772e348f8c72$export$3f77d24f8de610a0
    };
    const $7864772e348f8c72$export$e2c4f60e8cad01fb = (pathname)=>(0, ($parcel$interopDefault($9UgXz)))($7864772e348f8c72$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
    const $7864772e348f8c72$export$8715824c16ceeca0 = (error)=>(0, (0, parcelRequire("fZneA")).isClientFetchError)(error);
    const $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER = {
        pathnameRegexes: [
            '/servicedesk/admin/[\\w\\d]+/customer-notifications'
        ],
        pathnameRegexesForNple: [
            '/servicedesk/admin/[\\w\\d]+/customer-notifications',
            '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
            '/plugins/servlet/project-config/[\\w\\d]+/people',
            '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
        ],
        routeNames: [
            'servicedesk-reports',
            'servicedesk-reports-custom',
            'servicedesk-reports-custom-create',
            'servicedesk-reports-custom-edit',
            'servicedesk-reports-custom-time-scale-issue',
            'servicedesk-reports-custom-time-scale',
            'servicedesk-reports-satisfaction',
            'servicedesk-reports-satisfaction-time-scale-issue',
            'servicedesk-reports-satisfaction-time-scale',
            'servicedesk-reports-summary',
            'servicedesk-reports-type',
            'servicedesk-reports-workload',
            'servicedesk-queues-new',
            'servicedesk-queues-edit'
        ]
    };
    const $7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER = {
        pathnameRegexes: [
            '/jira/people/search'
        ]
    };
    const $7864772e348f8c72$export$83501d9ba065ef89 = (pathname)=>$7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
    const $7864772e348f8c72$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
    const $7864772e348f8c72$export$5d52a100c70d4375 = (currentRouteName)=>$7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);
});
parcelRegister("9UgXz", function(module, exports) {
    var $fR2dZ = parcelRequire("fR2dZ");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $73667fdf8c12f2c8$var$findKey(object, predicate) {
        return $fR2dZ(object, $bxDef(predicate, 3), $hDnyx);
    }
    module.exports = $73667fdf8c12f2c8$var$findKey;
});
parcelRegister("fR2dZ", function(module, exports) {
    function $b8ad880aaae778a0$var$baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    module.exports = $b8ad880aaae778a0$var$baseFindKey;
});
parcelRegister("j25Gb", function(module, exports) {
    $parcel$export(module.exports, "handleOpsTeamMode", ()=>$3e2c1b76a45e5e3a$export$b05151222ac96edd);
    var $jcw0u;
    var $7f4tk;
    var $aeeX4;
    var $bx4nw;
    async function $3e2c1b76a45e5e3a$export$b05151222ac96edd(data, teamId, cloudId) {
        const mutatedData = {
            ...data
        };
        mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
            if (item === (0, (0, parcelRequire("aeeX4")).TaskId).ReviewOnCallSetup || item === (0, (0, parcelRequire("aeeX4")).TaskId).AddIntegration) return false;
            return true;
        });
        if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, (0, parcelRequire("bx4nw")).VisibilityValues).Visible) try {
            const teamCentricResponse = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
                method: 'GET',
                mode: 'cors'
            });
            mutatedData.completedItems = [
                ...mutatedData?.completedItems,
                ...teamCentricResponse?.completedItems
            ];
        } catch (error) {
            if (error.statusCode !== 404) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'handleOpsTeamMode-TeamCentricResponse',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return mutatedData;
    }
});
parcelRegister("bx4nw", function(module, exports) {
    $parcel$export(module.exports, "OpsVisibilityKeys", ()=>$a2143fca26914ad3$export$3cae6a891a2fb0c1);
    $parcel$export(module.exports, "SdVisibilityKeys", ()=>$a2143fca26914ad3$export$9ffa2df2d13a51e4);
    $parcel$export(module.exports, "OgVisibilityKeys", ()=>$a2143fca26914ad3$export$37aa46ee833f23f2);
    $parcel$export(module.exports, "VisibilityValues", ()=>$a2143fca26914ad3$export$b715b908ae0969fa);
    $parcel$export(module.exports, "SdVisibilityRoles", ()=>$a2143fca26914ad3$export$47a23917fcedd235);
    var $a2143fca26914ad3$export$3cae6a891a2fb0c1;
    (function(OpsVisibilityKeys) {
        OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
        OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
    })($a2143fca26914ad3$export$3cae6a891a2fb0c1 || ($a2143fca26914ad3$export$3cae6a891a2fb0c1 = {}));
    var $a2143fca26914ad3$export$9ffa2df2d13a51e4;
    (function(SdVisibilityKeys) {
        SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
        SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
    })($a2143fca26914ad3$export$9ffa2df2d13a51e4 || ($a2143fca26914ad3$export$9ffa2df2d13a51e4 = {}));
    var $a2143fca26914ad3$export$37aa46ee833f23f2;
    (function(OgVisibilityKeys) {
        OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
        OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
        OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
        OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
    })($a2143fca26914ad3$export$37aa46ee833f23f2 || ($a2143fca26914ad3$export$37aa46ee833f23f2 = {}));
    var $a2143fca26914ad3$export$b715b908ae0969fa;
    (function(VisibilityValues) {
        VisibilityValues["Hidden"] = "hidden";
        VisibilityValues["Visible"] = "visible";
        VisibilityValues["Unset"] = "unset";
    })($a2143fca26914ad3$export$b715b908ae0969fa || ($a2143fca26914ad3$export$b715b908ae0969fa = {}));
    var $a2143fca26914ad3$export$47a23917fcedd235;
    (function(SdVisibilityRoles) {
        SdVisibilityRoles["Advanced"] = "advanced";
        SdVisibilityRoles["Standard"] = "standard";
    })($a2143fca26914ad3$export$47a23917fcedd235 || ($a2143fca26914ad3$export$47a23917fcedd235 = {}));
});
parcelRegister("eRXyM", function(module, exports) {
    $parcel$export(module.exports, "handleUserCentricMode", ()=>$d050cf1516f8f999$export$10caa25085bdca55);
    var $jcw0u;
    var $7f4tk;
    var $aeeX4;
    async function $d050cf1516f8f999$export$10caa25085bdca55(data, cloudId) {
        const mutatedData = {
            ...data
        };
        mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
            if (item === (0, (0, parcelRequire("aeeX4")).TaskId).ReviewOnCallSetup || item === (0, (0, parcelRequire("aeeX4")).TaskId).AddIntegration) return false;
            return true;
        });
        try {
            const userCentricResponse = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
                method: 'GET',
                mode: 'cors'
            });
            const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
                if (item === (0, (0, parcelRequire("aeeX4")).TaskId).ReviewOnCallSetup || item === (0, (0, parcelRequire("aeeX4")).TaskId).AddIntegration) return true;
                return false;
            });
            mutatedData.completedItems = [
                ...mutatedData.completedItems,
                ...userCentricCompletedItems
            ];
        } catch (error) {
            if (error.statusCode !== 404) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'handleUserCentricMode-UserCentricResponse',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return mutatedData;
    }
});
parcelRegister("5lmbj", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$9d35edf9adbf7852$export$94df0e59ebebf4a7);
    $parcel$export(module.exports, "initializeState", ()=>$9d35edf9adbf7852$export$3ee49b4c70c0ec29);
    var $hGgHi = parcelRequire("hGgHi");
    var $jcw0u;
    var $7f4tk;
    var $8zOmE;
    var $7aw4m;
    var $kwNTl;
    var $bx4nw;
    var $j25Gb;
    var $eRXyM;
    var $jVCdW;
    const $9d35edf9adbf7852$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
    const $9d35edf9adbf7852$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
                const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
                if (isItsmSampleProject !== false) {
                    if ((0, ($parcel$interopDefault($hGgHi)))(isItsmSampleProject)) (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'initializeState_isItsmSampleProject_unknown',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        }
                    });
                    return;
                }
                const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                    const isFinalAttempt = attemptIndex === totalAttempts - 1;
                    setState({
                        isSaving: true
                    });
                    let response;
                    try {
                        response = await (0, (0, parcelRequire("7f4tk")).default)($9d35edf9adbf7852$export$94df0e59ebebf4a7({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'GET',
                            mode: 'cors',
                            credentials: 'include'
                        });
                    } catch (error) {
                        if (error.statusCode === 404) {
                            setState({
                                isSaving: false,
                                isGspInitialized: false
                            });
                            return;
                        }
                        setState({
                            isSaving: false
                        });
                        if (isFinalAttempt) (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'initializeState_fetch',
                                packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                                teamName: 'itops-mithril'
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                        throw error;
                    }
                    const serverData = response;
                    let data = {
                        completedItems: (0, (0, parcelRequire("kwNTl")).defaultGspState).completedItems,
                        properties: {
                            ...serverData.properties,
                            user: {
                                ...serverData.properties.user,
                                ...(0, (0, parcelRequire("kwNTl")).defaultGspState).properties.user,
                                projectId: projectId
                            }
                        }
                    };
                    if (enableUserCentricMode && data) data = await (0, (0, parcelRequire("eRXyM")).handleUserCentricMode)(data, cloudId);
                    else if (enableOpsTeamMode && teamId && data) {
                        const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, (0, parcelRequire("bx4nw")).VisibilityValues).Hidden;
                        data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                        data = await (0, (0, parcelRequire("j25Gb")).handleOpsTeamMode)(data, teamId, cloudId);
                    }
                    try {
                        setState({
                            data: data,
                            isGspInitialized: true,
                            isSaving: false
                        });
                        await dispatch((0, (0, parcelRequire("jVCdW")).savePanelState)(actionProps))(data);
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                    } catch (error) {
                        setState({
                            isGspInitialized: true,
                            isSaving: false
                        });
                        if (isFinalAttempt) (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'initializeState',
                                packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                                teamName: 'itops-mithril'
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                };
                await (0, (0, parcelRequire("7aw4m")).withExponentialBackoffRetries)({
                    callback: initializeStateOnce,
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
            };
});
parcelRegister("7aw4m", function(module, exports) {
    $parcel$export(module.exports, "withExponentialBackoffRetries", ()=>$2286d0a3de3201e1$export$344601bd15a7b6d);
    const $2286d0a3de3201e1$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
    const $2286d0a3de3201e1$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
        for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)try {
            return await callback(attemptIndex, totalAttempts);
        } catch (error) {
            if (attemptIndex + 1 < totalAttempts) await $2286d0a3de3201e1$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
            else throw error;
        }
        throw Error('withExponentialBackoffRetries should not reach');
    };
});
parcelRegister("kwNTl", function(module, exports) {
    $parcel$export(module.exports, "defaultGspState", ()=>$4b9c4470b77dfabd$export$4db8363977bdf2d4);
    $parcel$export(module.exports, "GSP", ()=>$4b9c4470b77dfabd$export$1cb8c028028700ec);
    var $aeeX4;
    const $4b9c4470b77dfabd$var$defaultSectionStateV2 = {
        version: 2,
        activeSection: (0, (0, parcelRequire("aeeX4")).GspSectionKey).Home,
        sections: {
            checklist: {
                headerState: (0, (0, parcelRequire("aeeX4")).HeaderState).Expanded,
                activeTab: (0, (0, parcelRequire("aeeX4")).ChecklistTabKey).Basics,
                tabs: {
                    basics: {
                        activeTask: undefined
                    },
                    teamEfficiency: {
                        activeTask: undefined
                    },
                    incidents: {
                        activeTask: undefined
                    },
                    changes: {
                        activeTask: undefined
                    },
                    alerts: {
                        activeTask: undefined
                    }
                }
            },
            productTours: {
                headerState: (0, (0, parcelRequire("aeeX4")).HeaderState).Expanded,
                activeTour: (0, (0, parcelRequire("aeeX4")).ProductTourKey).Welcome
            }
        }
    };
    const $4b9c4470b77dfabd$export$4db8363977bdf2d4 = {
        completedItems: [
            (0, (0, parcelRequire("aeeX4")).TaskId).CreateItsmProject
        ],
        properties: {
            containers: [],
            user: {
                activeState: (0, (0, parcelRequire("aeeX4")).ActiveState).On,
                visualState: (0, (0, parcelRequire("aeeX4")).VisualState).FullPanel,
                sectionState: JSON.stringify($4b9c4470b77dfabd$var$defaultSectionStateV2),
                hasSeenReopenSpotlight: (0, (0, parcelRequire("aeeX4")).HasSeenReopenSpotlight).No
            }
        }
    };
    const $4b9c4470b77dfabd$export$1cb8c028028700ec = 'GettingStartedPanel';
});
parcelRegister("jVCdW", function(module, exports) {
    $parcel$export(module.exports, "savePanelState", ()=>$8308a60f9f5d610a$export$8756ef0989d9dd58);
    var $jcw0u;
    var $7zmUm;
    var $8zOmE;
    var $7aw4m;
    const $8308a60f9f5d610a$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
    const $8308a60f9f5d610a$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
                const { data: data } = getState();
                try {
                    if (!data) throw new Error('Trying to save panel state without current GSP state.');
                    setState({
                        data: state,
                        isSaving: true
                    });
                    const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                    await (0, (0, parcelRequire("7aw4m")).withExponentialBackoffRetries)({
                        callback: ()=>(0, (0, parcelRequire("7zmUm")).default)($8308a60f9f5d610a$var$getUrl({
                                baseUrl: baseUrl,
                                cloudId: cloudId
                            }), {
                                method: 'POST',
                                credentials: 'include',
                                body: JSON.stringify({
                                    sectionState: sectionState,
                                    activeState: activeState,
                                    visualState: visualState,
                                    projectId: projectId,
                                    hasSeenReopenSpotlight: hasSeenReopenSpotlight
                                })
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    setState({
                        isSaving: false
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
                } catch (error) {
                    setState({
                        isSaving: false
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'savePanelState',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
            };
});
parcelRegister("7zmUm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$198ed207dec01cca$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $198ed207dec01cca$var$noContentStatus = 204;
    var $198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), options), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
                else throw new (0, (0, parcelRequire("jJZqs")).default)(status);
            }
            if (response.status === $198ed207dec01cca$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return (0, $kVLXA.Observable).of(response.responseText || 'OK');
        });
});
parcelRegister("WkJdq", function(module, exports) {
    $parcel$export(module.exports, "markReopenSpotlightAsSeen", ()=>$8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5);
    var $jcw0u;
    var $8zOmE;
    var $aeeX4;
    var $jVCdW;
    const $8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
                const { data: data } = getState();
                try {
                    if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                    await dispatch((0, (0, parcelRequire("jVCdW")).savePanelState)(actionProps))({
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                hasSeenReopenSpotlight: (0, (0, parcelRequire("aeeX4")).HasSeenReopenSpotlight).Yes
                            }
                        }
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'markReopenSpotlightAsSeen',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
            };
});
parcelRegister("aLRn2", function(module, exports) {
    $parcel$export(module.exports, "reopenGettingStartedPanel", ()=>$8b8ba476581e4096$export$3f8a23b1578c0a37);
    var $jcw0u;
    var $8zOmE;
    var $7aw4m;
    var $aeeX4;
    var $5lmbj;
    var $kTf1j;
    const $8b8ba476581e4096$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
                const getStateIfLoaded = async ()=>{
                    const state = getState();
                    const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                    if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                    return state;
                };
                try {
                    const { data: data, isGspInitialized: isGspInitialized } = await (0, (0, parcelRequire("7aw4m")).withExponentialBackoffRetries)({
                        callback: getStateIfLoaded,
                        totalAttempts: 6,
                        baseIntervalMs: 500
                    });
                    if (!isGspInitialized) {
                        if (projectId !== undefined) {
                            await dispatch((0, (0, parcelRequire("5lmbj")).initializeState)(actionProps))({
                                projectId: projectId
                            });
                            return;
                        }
                        throw new Error('No projectId to initialize GSP with');
                    }
                    if (!data) throw new Error('Trying to reopen GSP without current state');
                    await dispatch((0, (0, parcelRequire("kTf1j")).saveProperty)(actionProps))({
                        key: (0, (0, parcelRequire("aeeX4")).PropertyKey).VisualState,
                        value: (0, (0, parcelRequire("aeeX4")).VisualState).FullPanel
                    });
                    await dispatch((0, (0, parcelRequire("kTf1j")).saveProperty)(actionProps))({
                        key: (0, (0, parcelRequire("aeeX4")).PropertyKey).ActiveState,
                        value: (0, (0, parcelRequire("aeeX4")).ActiveState).On
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'reopenGettingStartedPanel',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
            };
});
parcelRegister("kTf1j", function(module, exports) {
    $parcel$export(module.exports, "saveProperty", ()=>$424bc97a870986cf$export$3d751d226e9d1512);
    var $jcw0u;
    var $7zmUm;
    var $8zOmE;
    var $7aw4m;
    const $424bc97a870986cf$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
    const $424bc97a870986cf$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
                const { data: data } = getState();
                try {
                    if (!data) throw new Error('Trying to save property without current GSP state.');
                    setState({
                        data: {
                            ...data,
                            properties: {
                                ...data.properties,
                                user: {
                                    ...data.properties.user,
                                    [key.toString()]: value
                                }
                            }
                        },
                        isSaving: true
                    });
                    await (0, (0, parcelRequire("7aw4m")).withExponentialBackoffRetries)({
                        callback: ()=>(0, (0, parcelRequire("7zmUm")).default)($424bc97a870986cf$var$getUrl({
                                baseUrl: baseUrl,
                                cloudId: cloudId
                            }), {
                                method: 'POST',
                                credentials: 'include',
                                body: JSON.stringify({
                                    [key.toString()]: value
                                })
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    setState({
                        isSaving: false
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
                } catch (error) {
                    setState({
                        isSaving: false
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'saveProperty',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
});
parcelRegister("6g0vj", function(module, exports) {
    $parcel$export(module.exports, "resolveTask", ()=>$111c5eed0cfc16aa$export$7c43f246bcca61d3);
    var $jcw0u;
    var $7zmUm;
    var $8zOmE;
    var $7aw4m;
    var $g5X3G;
    const $111c5eed0cfc16aa$var$getScopeFromTaskId = (taskId)=>{
        switch(taskId){
            case 'servicedesk-itsm-project-created':
            case 'servicedesk-portal-name-customized':
            case 'servicedesk-logo-added-to-portal':
            case 'servicedesk-email-requests-setup':
            case 'servicedesk-team-member-added':
                return 'container';
            case 'servicedesk-change-management-documentation-accessed':
            case 'servicedesk-basics-documentation-accessed':
            case 'servicedesk-queue-configurations-reviewed':
            case 'servicedesk-request-types-customised':
            case 'servicedesk-request-channels-email-portal-requests-customised':
            case 'servicedesk-chat-requests-setup':
                return 'user';
            case 'servicedesk-services-setup':
            case 'servicedesk-change-management-pipeline-connected':
            case 'servicedesk-change-management-change-approvers-added':
            case 'servicedesk-change-management-automation-rules-on':
                return 'workspace';
            case 'opsgenie-user-profile-notifications-setup':
            case 'opsgenie-incident-management-documentation-accessed':
                return 'user';
            case 'opsgenie-response-team-setup':
            case 'opsgenie-owner-team-assigned-to-service':
                return 'workspace';
            default:
                taskId;
                throw new Error(`Unknown scope for task ${taskId}`);
        }
    };
    const $111c5eed0cfc16aa$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
        let scopePath = '';
        if (scope === 'container') scopePath = `project/${projectId}/`;
        if (scope === 'user') scopePath = 'user/';
        return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
    };
    const $111c5eed0cfc16aa$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
                const { data: data } = getState();
                try {
                    if (!data) return;
                    const { completedItems: completedItems, properties: properties } = data;
                    const isTaskAlreadyCompleted = completedItems.includes(taskId);
                    if (!isTaskAlreadyCompleted) {
                        const updatedTasks = [
                            ...completedItems,
                            taskId
                        ];
                        setState({
                            data: {
                                ...data,
                                completedItems: updatedTasks
                            },
                            isSaving: true
                        });
                        const scope = $111c5eed0cfc16aa$var$getScopeFromTaskId(taskId);
                        const projectId = (0, (0, parcelRequire("g5X3G")).toProjectId)(properties.user.projectId || '');
                        await (0, (0, parcelRequire("7aw4m")).withExponentialBackoffRetries)({
                            callback: ()=>(0, (0, parcelRequire("7zmUm")).default)($111c5eed0cfc16aa$export$94df0e59ebebf4a7({
                                    baseUrl: baseUrl,
                                    cloudId: cloudId,
                                    scope: scope,
                                    projectId: projectId,
                                    taskId: taskId
                                }), {
                                    method: 'POST',
                                    credentials: 'include'
                                }).toPromise(),
                            totalAttempts: 5,
                            baseIntervalMs: 500
                        });
                        setState({
                            isSaving: false
                        });
                    }
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
                } catch (error) {
                    setState({
                        isSaving: false
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'resolveTask',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
            };
});
parcelRegister("01F1V", function(module, exports) {
    $parcel$export(module.exports, "setOpsAdminTaskVisibility", ()=>$3b1848fd2fed3e69$export$b9e7846826f1ebfd);
    var $jcw0u;
    var $7f4tk;
    var $bx4nw;
    const $3b1848fd2fed3e69$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
                const { data: data } = getState();
                if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
                try {
                    const adminTaskVisibilityResponse = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                        method: 'GET'
                    });
                    const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, (0, parcelRequire("bx4nw")).VisibilityValues).Visible : (0, (0, parcelRequire("bx4nw")).VisibilityValues).Hidden;
                    setState({
                        data: {
                            ...data,
                            properties: {
                                ...data.properties,
                                user: {
                                    ...data.properties.user,
                                    'ops-admin-tasks-visibility': visibility
                                }
                            }
                        }
                    });
                } catch (error) {
                    setState({
                        data: {
                            ...data,
                            properties: {
                                ...data.properties,
                                user: {
                                    ...data.properties.user,
                                    'ops-admin-tasks-visibility': (0, (0, parcelRequire("bx4nw")).VisibilityValues).Hidden
                                }
                            }
                        }
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'setOpsAdminTaskVisibility',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'Alexstrasza'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
});
parcelRegister("9FflN", function(module, exports) {
    $parcel$export(module.exports, "stopRecordingPerformanceExperiences", ()=>$0ed29e6b515a7853$export$3566fd94709fa84a);
    const $0ed29e6b515a7853$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
                setState({
                    shouldRecordPerformanceExperiences: false
                });
            };
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3kACf")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("CFRIm")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hnw8Z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7opQ6")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("3kACf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("chQyv")
    ]).then(()=>parcelRequire('hZyYK'));
});
parcelRegister("CFRIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("hnw8Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("7opQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("lXCei", function(module, exports) {
    $parcel$export(module.exports, "useInitializeActiveTab", ()=>$5c30285de08a922f$export$b0f185249c3d08fd);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $htI2Q;
    var $6juLJ;
    var $kwNTl;
    var $aeeX4;
    const $5c30285de08a922f$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
        const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, (0, parcelRequire("htI2Q")).useIsFirstProjectITSM)(gspProjectId);
        const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
        const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, (0, parcelRequire("6juLJ")).useGettingStartedPanelState)();
        const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (activeTabName === '') return;
            if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
                const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, (0, parcelRequire("kwNTl")).defaultGspState).properties.user.sectionState;
                const sectionState = JSON.parse(sectionStateJSON);
                if (sectionState.sections.checklist.activeTab !== activeTabName) {
                    sectionState.sections.checklist.activeTab = activeTabName;
                    saveProperty({
                        key: (0, (0, parcelRequire("aeeX4")).PropertyKey).SectionState,
                        value: JSON.stringify(sectionState)
                    });
                }
                setIsInitializedActiveTab(true);
            }
        }, [
            isNpleForItsmEnabled,
            gspStateData,
            saveProperty,
            activeTabName,
            isInitializedActiveTab
        ]);
        const resetInitialization = ()=>setIsInitializedActiveTab(false);
        return {
            resetInitialization: resetInitialization
        };
    };
});
parcelRegister("6XsPQ", function(module, exports) {
    $parcel$export(module.exports, "HistoryAdapter", ()=>$c364a1ba7d823379$export$d852f51b8427aefc);
    var $5uXOq = parcelRequire("5uXOq");
    var $1bQGJ;
    var $8oKIZ;
    class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.compatibleHistory = (0, (0, parcelRequire("8oKIZ")).createReactRouterCompatibleHistory)(props.history);
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.children !== this.props.children;
        }
        componentWillUnmount() {
            this.compatibleHistory.destroy && this.compatibleHistory.destroy();
        }
        render() {
            const { children: children } = this.props;
            return children(this.compatibleHistory);
        }
    }
    const $c364a1ba7d823379$export$d852f51b8427aefc = (0, (0, parcelRequire("1bQGJ")).withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);
});
parcelRegister("8oKIZ", function(module, exports) {
    $parcel$export(module.exports, "createReactRouterCompatibleHistory", ()=>$e043da36553b4806$export$2df73cd79c2401bf);
    var $bxYf9 = parcelRequire("bxYf9");
    const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
        let cleaned = false;
        let listeners = [];
        const listen = (callback)=>{
            if (cleaned) return ()=>{};
            const unsubscribe = (0, ($parcel$interopDefault($bxYf9)))(history.listen(callback));
            const listener = {
                unsubscribe: unsubscribe
            };
            listeners.push(listener);
            return (0, ($parcel$interopDefault($bxYf9)))(()=>{
                listener.unsubscribe();
            });
        };
        const cleanup = ()=>{
            listeners.forEach(({ unsubscribe: unsubscribe })=>{
                unsubscribe();
            });
            cleaned = true;
            listeners = [];
        };
        return {
            get length () {
                return history.length;
            },
            get location () {
                return history.location;
            },
            get action () {
                return history.action;
            },
            get index () {
                return history.index;
            },
            get entries () {
                return history.entries;
            },
            push: (path, state)=>history.push(path, state),
            replace: (path, state)=>history.replace(path, state),
            go: (n)=>history.go(n),
            goBack: ()=>history.goBack(),
            goForward: ()=>history.goForward(),
            createHref: (...args)=>history.createHref(...args),
            canGo: (n)=>{
                if (history.canGo) return history.canGo(n);
                return true;
            },
            listen: listen,
            block: (blocker)=>history.block(blocker),
            destroy: cleanup
        };
    };
});
parcelRegister("bPvna", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee44373ada01d76d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hsGgw;
    var $ftrEg;
    var $7OSF3;
    var $8gRFs;
    const $ee44373ada01d76d$var$EmbeddableDirectory = (props)=>{
        const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled } = props;
        if (env) (0, (0, parcelRequire("7OSF3")).setEnv)(env);
        const analyticsClient = (0, (0, parcelRequire("hsGgw")).useSetupAnalyticsClient)(cloudId, appName, subProduct);
        const apolloClient = (0, (0, parcelRequire("ftrEg")).useSetupApolloClient)(cloudId);
        if (!analyticsClient) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8gRFs")).default), {
            apolloClient: apolloClient,
            analytics: analyticsClient,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            env: env,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            statusCodeHandlers: statusCodeHandlers,
            history: history,
            cloudId: cloudId,
            orgId: orgId,
            teamCentralHandlers: teamCentralHandlers,
            skipI18nProvider: false,
            productFeatureFlags: productFeatureFlags,
            invitePeopleHandlers: invitePeopleHandlers,
            isSentryEnabled: isSentryEnabled,
            isAIEnabled: isAIEnabled
        });
    };
    var $ee44373ada01d76d$export$2e2bcd8739ae039 = $ee44373ada01d76d$var$EmbeddableDirectory;
});
parcelRegister("hsGgw", function(module, exports) {
    $parcel$export(module.exports, "useSetupAnalyticsClient", ()=>$37fa556ffc78c6ed$export$bcd55e98e7c6e45e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1loTp;
    function $37fa556ffc78c6ed$var$getAnalyticsSubproduct(appName, subProduct) {
        if (!subProduct) return appName;
        return `jira-${subProduct}-directory`;
    }
    function $37fa556ffc78c6ed$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
        const analyticsSubProduct = (0, $5uXOq.useMemo)(()=>$37fa556ffc78c6ed$var$getAnalyticsSubproduct(appName, subProduct), [
            appName,
            subProduct
        ]);
        const [analyticsClient, setAnalyticsClient] = (0, $5uXOq.useState)((0, (0, parcelRequire("1loTp")).getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        }));
        (0, $5uXOq.useEffect)(()=>{
            if (!cloudId) return;
            const analytics = (0, (0, parcelRequire("1loTp")).getAnalyticsClient)({
                mode: appName,
                subproduct: analyticsSubProduct,
                cloudId: cloudId
            });
            setAnalyticsClient(analytics);
        }, [
            cloudId,
            analyticsSubProduct,
            appName
        ]);
        return cloudId ? analyticsClient : undefined;
    }
});
parcelRegister("1loTp", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsClient", ()=>$5074461f430a0df8$export$fde53e78fd93a54d);
    var $buAWB;
    var $iZhen;
    var $kc6Iv;
    var $jCvwN;
    var $7OSF3;
    var $49z18;
    var $fyzT1;
    var $5kouT;
    var $65ws1;
    function $5074461f430a0df8$var$getServerName() {
        return window.location.hostname;
    }
    const { LOCAL: $5074461f430a0df8$var$LOCAL, DEV: $5074461f430a0df8$var$DEV, STAGING: $5074461f430a0df8$var$STAGING, PROD: $5074461f430a0df8$var$PROD } = (0, (0, parcelRequire("iZhen")).envType);
    const $5074461f430a0df8$var$ENV_MAP = {
        local: $5074461f430a0df8$var$LOCAL,
        test: $5074461f430a0df8$var$LOCAL,
        adev: $5074461f430a0df8$var$DEV,
        'stg-east': $5074461f430a0df8$var$STAGING,
        stg: $5074461f430a0df8$var$STAGING
    };
    const $5074461f430a0df8$var$getEnvType = (env)=>{
        return $5074461f430a0df8$var$ENV_MAP[env] || $5074461f430a0df8$var$PROD;
    };
    const $5074461f430a0df8$var$analyticsConfig = (0, (0, parcelRequire("jCvwN")).getConfig)().analytics;
    const $5074461f430a0df8$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
    const $5074461f430a0df8$var$PRODUCT_DEFAULT = 'people';
    class $5074461f430a0df8$var$AnalyticsClient {
        constructor(options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $5074461f430a0df8$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
            const customOptions = {
                commonProperties: commonProperties,
                eventPrefix: eventPrefix
            };
            this.cloudId = cloudId;
            this.commonProperties = customOptions.commonProperties;
            this.eventPrefix = customOptions.eventPrefix;
            this.state = {
                analyticsscheme: $5074461f430a0df8$var$analyticsConfig.scheme,
                analyticsserver: $5074461f430a0df8$var$analyticsConfig.server,
                server: $5074461f430a0df8$var$getServerName(),
                product: $5074461f430a0df8$var$PRODUCT_DEFAULT,
                isReadyToSend: false,
                pendingEventsQueue: [],
                storage_key: 'atlassian.people.analytics',
                ...options
            };
            this.analyticsWebClient = new (0, (0, parcelRequire("buAWB")).default)({
                env: $5074461f430a0df8$var$getEnvType((0, (0, parcelRequire("7OSF3")).getEnv)()),
                product: 'people',
                subproduct: subproduct
            }, {});
            this.initUFO();
            this._expTracker = (0, (0, parcelRequire("5kouT")).configureNewTracker)(this);
        }
        setTeamId(teamId) {
            this.teamId = teamId;
        }
        initUFO() {
            if ((0, (0, parcelRequire("kc6Iv")).getAppName)() !== (0, (0, parcelRequire("kc6Iv")).AppNames).STANDALONE_DIRECTORY) return;
            (0, (0, parcelRequire("49z18")).payloadPublisher).setup({
                gasv3: this.analyticsWebClient,
                product: 'people',
                app: {
                    version: {
                        web: __VERSION__
                    }
                },
                region: (0, (0, parcelRequire("7OSF3")).getEnv)()
            });
        }
        getAnalyticsWebClient() {
            return this.analyticsWebClient;
        }
        expTracker() {
            return this._expTracker;
        }
        sendTrackEvent(eventData) {
            this.analyticsWebClient.sendTrackEvent(eventData);
        }
        canEventBeSent(eventType, eventData, cb) {
            if (this.state.isReadyToSend) return true;
            this.state.pendingEventsQueue.push({
                eventType: eventType,
                eventData: eventData,
                eventCallback: cb
            });
            return false;
        }
        pushTrackEvent(eventData, cb) {
            if (this.canEventBeSent('track', eventData, cb)) {
                const event = this.buildEventPayload(eventData);
                this.analyticsWebClient.sendTrackEvent(event, cb);
            }
        }
        pushUIEvent(eventData, cb) {
            if (this.canEventBeSent('ui', eventData, cb)) {
                const event = this.buildEventPayload(eventData);
                this.analyticsWebClient.sendUIEvent(event, cb);
            }
        }
        pushOperationalEvent(eventData, cb) {
            if (this.canEventBeSent('operation', eventData, cb)) {
                const event = this.buildEventPayload(eventData);
                this.analyticsWebClient.sendOperationalEvent(event, cb);
            }
        }
        pushScreenEvent(eventData, cb) {
            const additionalAttributes = (0, (0, parcelRequire("65ws1")).default).get();
            (0, (0, parcelRequire("65ws1")).default).markUsed();
            if (eventData && additionalAttributes) eventData = {
                ...eventData,
                attributes: {
                    ...additionalAttributes,
                    ...eventData.attributes
                }
            };
            if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
        }
        buildEventPayload(eventData) {
            const attributes = this.teamId || eventData.attributes ? {
                ...this.teamId && {
                    teamId: this.teamId
                },
                ...eventData.attributes
            } : null;
            return {
                containerType: null,
                containerId: null,
                objectType: null,
                objectId: null,
                source: null,
                actionSubject: null,
                action: null,
                actionSubjectId: null,
                tags: [],
                ...eventData,
                attributes: attributes
            };
        }
        mapAnalyticsKeyToEvent(analyticsKey) {
            return (0, (0, parcelRequire("fyzT1")).analyticsKeyToEventMap)[analyticsKey] || null;
        }
        async startUIViewedEvent(principalUserId) {
            if (!principalUserId) return;
            this.analyticsWebClient.setTenantInfo((0, (0, parcelRequire("iZhen")).tenantType).CLOUD_ID, this.cloudId || '');
            this.analyticsWebClient.setUserInfo((0, (0, parcelRequire("iZhen")).userType).ATLASSIAN_ACCOUNT, principalUserId);
            this.analyticsWebClient.startUIViewedEvent();
            this.state.isReadyToSend = true;
            this.flushPendingEventsQueue();
        }
        flushPendingEventsQueue() {
            this.state.pendingEventsQueue.forEach((element)=>{
                const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
                switch(eventType){
                    case 'track':
                        this.pushTrackEvent(eventData, eventCallback);
                        break;
                    case 'ui':
                        this.pushUIEvent(eventData, eventCallback);
                        break;
                    case 'screen':
                        this.pushScreenEvent(eventData, eventCallback);
                        break;
                    case 'operation':
                        this.pushOperationalEvent(eventData, eventCallback);
                        break;
                    default:
                        console.error('Invalide Event :', element);
                        break;
                }
            });
        }
    }
    var $5074461f430a0df8$export$2e2bcd8739ae039 = $5074461f430a0df8$var$AnalyticsClient;
    let $5074461f430a0df8$var$preservedAnaylticsClient;
    const $5074461f430a0df8$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
        if (!cloudId) return;
        if ($5074461f430a0df8$var$preservedAnaylticsClient) return $5074461f430a0df8$var$preservedAnaylticsClient;
        $5074461f430a0df8$var$preservedAnaylticsClient = new $5074461f430a0df8$var$AnalyticsClient({}, {
            commonProperties: {
                mode: mode
            },
            subproduct: subproduct,
            cloudId: cloudId
        });
        return $5074461f430a0df8$var$preservedAnaylticsClient;
    };
});
parcelRegister("kc6Iv", function(module, exports) {
    $parcel$export(module.exports, "AppNames", ()=>$9dcbdd613bb2ce35$export$b767e803e7ca9563);
    $parcel$export(module.exports, "getAppName", ()=>$9dcbdd613bb2ce35$export$dcecb2dbc7fe753c);
    var $9dcbdd613bb2ce35$export$b767e803e7ca9563;
    (function(AppNames) {
        AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
        AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    })($9dcbdd613bb2ce35$export$b767e803e7ca9563 || ($9dcbdd613bb2ce35$export$b767e803e7ca9563 = {}));
    function $9dcbdd613bb2ce35$export$dcecb2dbc7fe753c() {
        return window.__app_name__ || "embeddableDirectory";
    }
});
parcelRegister("jCvwN", function(module, exports) {
    $parcel$export(module.exports, "isFedramp", ()=>$ef83275710befcd7$export$634ecc602a6871aa);
    $parcel$export(module.exports, "getConfig", ()=>$ef83275710befcd7$export$44487a86467333c3);
    var $dyczo = parcelRequire("dyczo");
    var $aIZdc;
    var $kc6Iv;
    var $7OSF3;
    var $2sqTC;
    const $ef83275710befcd7$var$productionConfig = {
        stargateRoot: '/gateway/api',
        analytics: {
            scheme: 'https',
            server: 'analytics.atlassian.com'
        },
        feedbackIssueCollectorId: '908df207',
        atlassianAccountUrl: 'https://id.atlassian.com',
        permsServiceUrl: '/gateway/api/permissions',
        collaborationGraph: '/gateway/api/collaboration',
        emojiUrl: '/gateway/api/emoji/standard',
        teamCentralUrl: 'https://team.atlassian.com',
        teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
    };
    const $ef83275710befcd7$var$devAndStagingConfig = {
        stargateRoot: '/gateway/api',
        analytics: {
            scheme: 'https',
            server: 'analytics.atlassian.com'
        },
        feedbackIssueCollectorId: '908df207',
        atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
        permsServiceUrl: '/gateway/api/permissions',
        collaborationGraph: '/gateway/api/collaboration',
        emojiUrl: '/gateway/api/emoji/standard',
        teamCentralUrl: 'https://team.stg.atlassian.com',
        teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
    };
    const $ef83275710befcd7$var$localAndTestConfig = {
        stargateRoot: '/gateway/api',
        analytics: {
            scheme: 'http',
            server: 'localhost:3000'
        },
        feedbackIssueCollectorId: '908df207',
        atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
        permsServiceUrl: '/gateway/api/permissions',
        collaborationGraph: '/gateway/api/collaboration',
        emojiUrl: '/gateway/api/emoji/standard',
        teamCentralUrl: 'https://team.stg.atlassian.com',
        teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
    };
    const $ef83275710befcd7$var$fedrampConfig = {
        stargateRoot: '/gateway/api',
        analytics: {
            scheme: 'https',
            server: 'analytics.atlassian.com'
        },
        feedbackIssueCollectorId: '908df207',
        atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
        permsServiceUrl: '/gateway/api/permissions',
        collaborationGraph: '/gateway/api/collaboration',
        emojiUrl: '/gateway/api/emoji/standard',
        teamCentralDisabled: true,
        teamCentralReactionDisabled: true
    };
    const $ef83275710befcd7$var$EnvOverrideKeys = [
        'adev',
        'stg-east',
        'local',
        'test',
        'fedramp',
        'prod-east'
    ];
    const $ef83275710befcd7$var$environmentOverrides = {
        'prod-east': $ef83275710befcd7$var$productionConfig,
        local: {
            ...(0, (0, parcelRequire("2sqTC")).LOCAL_PRODUCTION_BACKEND) ? $ef83275710befcd7$var$productionConfig : $ef83275710befcd7$var$localAndTestConfig,
            analytics: {
                scheme: 'http',
                server: `${(0, ($parcel$interopDefault($dyczo))).location.hostname}:3000`
            }
        },
        test: {
            ...$ef83275710befcd7$var$localAndTestConfig
        },
        adev: $ef83275710befcd7$var$devAndStagingConfig,
        'stg-east': $ef83275710befcd7$var$devAndStagingConfig,
        fedramp: $ef83275710befcd7$var$fedrampConfig
    };
    const $ef83275710befcd7$var$cachedConfig = {};
    function $ef83275710befcd7$export$634ecc602a6871aa() {
        return (0, (0, parcelRequire("aIZdc")).isFedRamp)();
    }
    function $ef83275710befcd7$export$44487a86467333c3() {
        const env = $ef83275710befcd7$export$634ecc602a6871aa() ? 'fedramp' : (0, (0, parcelRequire("7OSF3")).getEnv)();
        const appName = (0, (0, parcelRequire("kc6Iv")).getAppName)();
        const key = `${env}_${appName}`;
        if (!$ef83275710befcd7$var$cachedConfig[key]) {
            if ($ef83275710befcd7$var$EnvOverrideKeys.includes(env)) $ef83275710befcd7$var$cachedConfig[key] = {
                ...$ef83275710befcd7$var$environmentOverrides[env]
            };
            else $ef83275710befcd7$var$cachedConfig[key] = {
                ...$ef83275710befcd7$var$environmentOverrides['prod-east']
            };
        }
        return $ef83275710befcd7$var$cachedConfig[key];
    }
});
parcelRegister("7OSF3", function(module, exports) {
    $parcel$export(module.exports, "setEnv", ()=>$d72845fc4b3a6bd4$export$84bc02d3c7a6b55f);
    $parcel$export(module.exports, "getEnv", ()=>$d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e);
    var $dyczo = parcelRequire("dyczo");
    var $2sqTC;
    var $d72845fc4b3a6bd4$export$e7dfafc24fab792e;
    (function(MicrosEnv) {
        MicrosEnv["ADEV"] = "adev";
        MicrosEnv["STG_EAST"] = "stg-east";
        MicrosEnv["PROD_EAST"] = "prod-east";
    })($d72845fc4b3a6bd4$export$e7dfafc24fab792e || ($d72845fc4b3a6bd4$export$e7dfafc24fab792e = {}));
    const $d72845fc4b3a6bd4$export$d76bdf9f4281ae1b = {
        local: 'local',
        test: 'test',
        prod: 'prod',
        stg: 'staging',
        ["adev"]: 'staging',
        ["stg-east"]: 'staging',
        ["prod-east"]: 'production'
    };
    const $d72845fc4b3a6bd4$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
        prod: 'prod-east',
        stg: 'stg-east'
    };
    let $d72845fc4b3a6bd4$var$presetEnv;
    const $d72845fc4b3a6bd4$export$84bc02d3c7a6b55f = (env)=>{
        const envOverride = $d72845fc4b3a6bd4$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
        if (envOverride) $d72845fc4b3a6bd4$var$presetEnv = envOverride;
    };
    function $d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e() {
        if ($d72845fc4b3a6bd4$var$presetEnv) return $d72845fc4b3a6bd4$var$presetEnv;
        if (0, (0, parcelRequire("2sqTC")).DEV) return 'local';
        return (0, ($parcel$interopDefault($dyczo))).__env__;
    }
    function $d72845fc4b3a6bd4$export$15b8d8b1ba394f55() {
        return $d72845fc4b3a6bd4$export$d76bdf9f4281ae1b[$d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e()];
    }
});
parcelRegister("2sqTC", function(module, exports) {
    $parcel$export(module.exports, "DEV", ()=>$934cf0f7b2df335c$export$404582bc18fe4d9e);
    $parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", ()=>$934cf0f7b2df335c$export$771a63345d182ddd);
    const $934cf0f7b2df335c$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
    const $934cf0f7b2df335c$export$771a63345d182ddd = typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && __LOCAL_PRODUCTION_BACKEND__;
});
parcelRegister("fyzT1", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsKeys", ()=>$49573e686daf38b9$export$e8d1ded05852e864);
    $parcel$export(module.exports, "analyticsKeyToEventMap", ()=>$49573e686daf38b9$export$6430c2bbc66a6fa);
    $parcel$export(module.exports, "AnalyticsEventSource", ()=>$49573e686daf38b9$export$2102531865f3e90e);
    $parcel$export(module.exports, "AnalyticsEventActions", ()=>$49573e686daf38b9$export$74eee170ad238aae);
    $parcel$export(module.exports, "AnalyticsEventSubjects", ()=>$49573e686daf38b9$export$670f80b77450980d);
    const $49573e686daf38b9$export$e8d1ded05852e864 = {
        ACTIVITY_ALL_VIEW: 'activity.all.view',
        ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
        HISTORY_VIEW: 'history.view',
        PEOPLE_VIEW: 'people-search.view',
        PROFILE_PAGE_VIEW: 'profile-page.view',
        AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
        PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
        PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
        PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
        PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
        PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
        PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
        PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
        PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
        PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
        PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
        PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
        PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
        TEAM_PROFILE_VIEW: 'team-profile.view',
        KUDOS_PAGE_VIEW: 'kudos-page.view',
        TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
        ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
        LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
    };
    const $49573e686daf38b9$export$6430c2bbc66a6fa = {
        [$49573e686daf38b9$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
        [$49573e686daf38b9$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
    };
    var $49573e686daf38b9$export$2102531865f3e90e;
    (function(AnalyticsEventSource) {
        AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
        AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
        AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
        AnalyticsEventSource["AGENT_PROFILE_SCREEN"] = "agentProfileScreen";
        AnalyticsEventSource["AGENT_DELETE_SUCCESS_FLAG"] = "agentDeletedSuccessflag";
        AnalyticsEventSource["AGENT_DELETE_ERROR_FLAG"] = "agentDeletedErrorflag";
        AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
        AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
        AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
        AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
        AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
        AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
        AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
        AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
        AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
        AnalyticsEventSource["USER_MENU"] = "userMenu";
        AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
        AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
        AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
        AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
        AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
        AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
        AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
    })($49573e686daf38b9$export$2102531865f3e90e || ($49573e686daf38b9$export$2102531865f3e90e = {}));
    var $49573e686daf38b9$export$74eee170ad238aae;
    (function(AnalyticsEventActions) {
        AnalyticsEventActions["ACCEPTED"] = "accepted";
        AnalyticsEventActions["CLICKED"] = "clicked";
        AnalyticsEventActions["CLOSED"] = "closed";
        AnalyticsEventActions["COLLAPSED"] = "collapsed";
        AnalyticsEventActions["CREATED"] = "created";
        AnalyticsEventActions["DECLINED"] = "declined";
        AnalyticsEventActions["DELETED"] = "deleted";
        AnalyticsEventActions["EDITED"] = "edited";
        AnalyticsEventActions["EXPANDED"] = "expanded";
        AnalyticsEventActions["EXPOSED"] = "exposed";
        AnalyticsEventActions["FAILED"] = "failed";
        AnalyticsEventActions["JOINED"] = "joined";
        AnalyticsEventActions["REDIRECTED"] = "redirected";
        AnalyticsEventActions["REMOVED"] = "removed";
        AnalyticsEventActions["SENT"] = "sent";
        AnalyticsEventActions["SORTED"] = "sorted";
        AnalyticsEventActions["STARTED"] = "started";
        AnalyticsEventActions["OPENED"] = "opened";
        AnalyticsEventActions["SHOWN"] = "shown";
        AnalyticsEventActions["SUBMITTED"] = "submitted";
        AnalyticsEventActions["SUCCEEDED"] = "succeeded";
        AnalyticsEventActions["TRIGGERED"] = "triggered";
        AnalyticsEventActions["TYPED"] = "typed";
        AnalyticsEventActions["VIEWED"] = "viewed";
        AnalyticsEventActions["MOUNTED"] = "mounted";
        AnalyticsEventActions["MOVED"] = "moved";
        AnalyticsEventActions["DRAGGED"] = "dragged";
        AnalyticsEventActions["SELECTED"] = "selected";
    })($49573e686daf38b9$export$74eee170ad238aae || ($49573e686daf38b9$export$74eee170ad238aae = {}));
    var $49573e686daf38b9$export$670f80b77450980d;
    (function(AnalyticsEventSubjects) {
        AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
        AnalyticsEventSubjects["BUTTON"] = "button";
        AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
        AnalyticsEventSubjects["FORM"] = "form";
        AnalyticsEventSubjects["ERROR"] = "error";
    })($49573e686daf38b9$export$670f80b77450980d || ($49573e686daf38b9$export$670f80b77450980d = {}));
});
parcelRegister("5kouT", function(module, exports) {
    $parcel$export(module.exports, "configureNewTracker", ()=>$39e29a6d1a764883$export$54c7ecd74762af6a);
    $parcel$export(module.exports, "isNetworkError", ()=>$39e29a6d1a764883$export$476aa014e2fd89d5);
    var $ha42n;
    var $kc6Iv;
    var $fyzT1;
    var $jJaNd;
    var $4BpOs;
    var $a2luh;
    function $39e29a6d1a764883$export$54c7ecd74762af6a(analytics) {
        const tracker = new $39e29a6d1a764883$var$DirectoryExperienceTracker({
            isNetworkOfflineError: $39e29a6d1a764883$export$476aa014e2fd89d5
        });
        tracker.subscribe((event)=>{
            if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
                const performanceAttributes = $39e29a6d1a764883$var$computePerformanceAttributes(event);
                const errorAttributes = $39e29a6d1a764883$var$computeErrorAttributes(event);
                const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                    isStandalone: (0, (0, parcelRequire("kc6Iv")).getAppName)() === (0, (0, parcelRequire("kc6Iv")).AppNames).STANDALONE_DIRECTORY,
                    hasBrowseUsersPermission: (0, (0, parcelRequire("jJaNd")).isFlagEnabled)((0, $733e11e3c62664e2$export$28456d095a642fd))
                });
                const actionSubject = $39e29a6d1a764883$var$sanitiseExperienceName(event.name);
                analytics.pushOperationalEvent({
                    source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CLIENT_METRICS,
                    actionSubject: actionSubject,
                    action: event.action,
                    attributes: finalErrorDetails
                });
                if (event.action === 'taskFail') (0, (0, parcelRequire("a2luh")).logErrorMessage)(`taskFail:${actionSubject}`, finalErrorDetails);
            }
        });
        window.addEventListener('unload', ()=>{
            tracker.abort({
                reason: 'Abort due to Window unloading',
                attributes: {
                    cause: 'WINDOW_UNLOAD'
                }
            });
        });
        window.addEventListener('pagehide', ()=>{
            tracker.abort({
                reason: 'Window unloading',
                attributes: {
                    cause: 'PAGE_HIDE'
                }
            });
        });
        return tracker;
    }
    function $39e29a6d1a764883$var$sanitiseExperienceName(name) {
        return name.replace(/[\/-]/g, '_');
    }
    function $39e29a6d1a764883$var$computeErrorAttributes(event) {
        const attributes = {};
        if (event.action === 'taskFail' && event.error) {
            attributes.failError = event.error.message;
            attributes.traceId = event.error.traceId ?? null;
        }
        if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
        return attributes;
    }
    function $39e29a6d1a764883$var$computePerformanceAttributes(event) {
        if (event.action === 'taskStart') return {};
        const duration = event.duration;
        const latencySlo = event.attributes && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    class $39e29a6d1a764883$var$DirectoryExperienceTracker extends (0, (0, parcelRequire("ha42n")).ExperienceTracker) {
        constructor(options){
            super(options);
        }
        stopOnError({ name: name, error: error, attributes: attributes }) {
            if ((0, (0, parcelRequire("4BpOs")).isAuthError)(error)) {
                this.abort({
                    name: name,
                    reason: 'Abort due to user unauthenticated',
                    attributes: {
                        cause: 'USER_UNAUTHENTICATED',
                        error: error,
                        ...attributes
                    },
                    checkForTimeout: false
                });
                return;
            }
            if ((0, (0, parcelRequire("4BpOs")).isErrorStatusCode)((0, (0, parcelRequire("4BpOs")).StatusCode).GONE, error)) {
                this.abort({
                    name: name,
                    reason: 'Abort due to unavailable resource',
                    attributes: {
                        cause: 'GONE',
                        error: error,
                        ...attributes
                    },
                    checkForTimeout: false
                });
                return;
            }
            const reason = (0, (0, parcelRequire("4BpOs")).ignoredErrorReason)(error);
            if (reason) {
                this.abort({
                    name: name,
                    reason: 'Abort due to an error in ignore list',
                    attributes: {
                        cause: reason,
                        ...attributes
                    },
                    checkForTimeout: false
                });
                return;
            }
            super.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
        }
    }
    function $39e29a6d1a764883$export$476aa014e2fd89d5(error) {
        return error && !!error.message && (error.message.includes('NetworkError') || error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || !!(error['graphQLErrors'] && error['networkError']));
    }
});
const $733e11e3c62664e2$export$28456d095a642fd = 'internal.browse-users-allowed';
parcelRegister("jJaNd", function(module, exports) {
    $parcel$export(module.exports, "FeatureFlag", ()=>$7b68a7a6fc78be2f$export$df35587a8f95f16f);
    $parcel$export(module.exports, "isFlagEnabled", ()=>$7b68a7a6fc78be2f$export$ba72073d757a1bc2);
    var $04Mso;
    var $7OSF3;
    var $6cAn5 = parcelRequire("6cAn5");
    var $7b68a7a6fc78be2f$export$df35587a8f95f16f;
    (function(FeatureFlag) {
        FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
        FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
        FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
        FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
        FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
    })($7b68a7a6fc78be2f$export$df35587a8f95f16f || ($7b68a7a6fc78be2f$export$df35587a8f95f16f = {}));
    const $7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS = {
        ["enable_skills_and_interest_tags_in_profile_page"]: false,
        ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
        ["disable_atlas_crossflow_ads"]: false,
        ["event-on-call-consolidation_s97c8"]: false,
        ["event-on-call-consolidation-state"]: false
    };
    const $7b68a7a6fc78be2f$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
        ["enable_skills_and_interest_tags_in_profile_page"]: true
    };
    const $7b68a7a6fc78be2f$export$7101ae34ef1f53be = ()=>$6cAn5?.env?.NODE_ENV === 'development' || (0, (0, parcelRequire("7OSF3")).getEnv)() === 'local' ? {
            ...$7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS,
            ...$7b68a7a6fc78be2f$var$LOCAL_OVERRIDE_FEATURE_FLAGS
        } : {
            ...$7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS
        };
    function $7b68a7a6fc78be2f$export$ba72073d757a1bc2(flag) {
        return (0, (0, parcelRequire("04Mso")).isFlagEnabled)(flag);
    }
});
parcelRegister("04Mso", function(module, exports) {
    $parcel$export(module.exports, "getSettingsFromStorage", ()=>$bb2890e44c75956c$export$b40bc67e97afc0ed);
    $parcel$export(module.exports, "isFlagEnabled", ()=>$bb2890e44c75956c$export$ba72073d757a1bc2);
    var $2bf04;
    var $62DdI;
    var $2jlP9;
    const $bb2890e44c75956c$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
    function $bb2890e44c75956c$export$d9d01ff109db30f0(settings) {
        (0, (0, parcelRequire("62DdI")).default).setItem($bb2890e44c75956c$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
        $bb2890e44c75956c$export$455c5cbefb010abd(settings);
    }
    function $bb2890e44c75956c$export$b40bc67e97afc0ed() {
        const settingsString = (0, (0, parcelRequire("62DdI")).default).getItem($bb2890e44c75956c$var$STORAGE_KEY_SETTINGS);
        try {
            const parsed = settingsString ? JSON.parse(settingsString) : null;
            if ($bb2890e44c75956c$var$isStringBooleanDictionary(parsed)) return parsed;
            return null;
        } catch (e) {
            (0, (0, parcelRequire("2bf04")).logException)(e, 'Could not get settings from storage', {
                locallyStoredSettings: settingsString
            });
            return null;
        }
    }
    const $bb2890e44c75956c$var$effectiveFlags = {
        ...(0, (0, parcelRequire("2jlP9")).DEFAULT_FEATURE_FLAGS),
        ...$bb2890e44c75956c$export$b40bc67e97afc0ed() || {}
    };
    function $bb2890e44c75956c$export$455c5cbefb010abd(newFlags) {
        Object.assign($bb2890e44c75956c$var$effectiveFlags, newFlags);
    }
    function $bb2890e44c75956c$var$isStringBooleanDictionary(result) {
        return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
    }
    function $bb2890e44c75956c$export$2f63519103163252(featureFlag) {
        return Object.keys((0, (0, parcelRequire("2jlP9")).PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
    }
    function $bb2890e44c75956c$export$ba72073d757a1bc2(flag) {
        return $bb2890e44c75956c$var$effectiveFlags[flag];
    }
});
parcelRegister("2bf04", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$fe9042edcf886c67$export$f86b2a1a2ce291b3);
    $parcel$export(module.exports, "logInfoMessage", ()=>$fe9042edcf886c67$export$386587bcf05ee8ea);
    var $6laLp;
    const $fe9042edcf886c67$var$packageContext = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $fe9042edcf886c67$export$f86b2a1a2ce291b3 = (0, (0, parcelRequire("6laLp")).logExceptionWithPackageContext)($fe9042edcf886c67$var$packageContext);
    const $fe9042edcf886c67$export$ece28f5cfa04608 = (0, (0, parcelRequire("6laLp")).logErrorMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
    const $fe9042edcf886c67$export$386587bcf05ee8ea = (0, (0, parcelRequire("6laLp")).logInfoMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
    const $fe9042edcf886c67$export$9edc7d6f1c33ddc = (0, (0, parcelRequire("6laLp")).createErrorHandlerWithPackageContext)($fe9042edcf886c67$var$packageContext);
});
parcelRegister("62DdI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d849357ee9aa4ad$export$2e2bcd8739ae039);
    var $2bf04;
    const $4d849357ee9aa4ad$var$PREFIX = 'ptc-dir-ui.';
    const $4d849357ee9aa4ad$var$memoryLocalStorage = {
        data: {},
        setItem: (key, value)=>{
            $4d849357ee9aa4ad$var$memoryLocalStorage.data[key] = value;
        },
        getItem: (key)=>{
            return $4d849357ee9aa4ad$var$memoryLocalStorage.data[key];
        },
        removeItem: (key)=>{
            delete $4d849357ee9aa4ad$var$memoryLocalStorage.data[key];
        }
    };
    const $4d849357ee9aa4ad$var$localStorage = window.localStorage || $4d849357ee9aa4ad$var$memoryLocalStorage;
    var $4d849357ee9aa4ad$export$2e2bcd8739ae039 = {
        isQuotaExceeded () {
            const key = `${$4d849357ee9aa4ad$var$PREFIX}:${Date.now()}`;
            try {
                $4d849357ee9aa4ad$var$localStorage.setItem(key, 'test');
            } catch (e) {
                return true;
            } finally{
                $4d849357ee9aa4ad$var$localStorage.removeItem(key);
            }
            return false;
        },
        setItem (key, value) {
            try {
                $4d849357ee9aa4ad$var$localStorage.setItem($4d849357ee9aa4ad$var$PREFIX + key, value);
                return true;
            } catch (error) {
                (0, (0, parcelRequire("2bf04")).logInfoMessage)('Cannot read into localstorage', {
                    error: error
                });
            }
            return false;
        },
        getItem (key) {
            try {
                return $4d849357ee9aa4ad$var$localStorage.getItem($4d849357ee9aa4ad$var$PREFIX + key);
            } catch (error) {
                (0, (0, parcelRequire("2bf04")).logInfoMessage)('Cannot read into localstorage', {
                    error: error
                });
            }
            return null;
        },
        getItemSafely (key, defaultValue, fallback) {
            try {
                const storedValue = $4d849357ee9aa4ad$var$localStorage.getItem($4d849357ee9aa4ad$var$PREFIX + key);
                if (storedValue) return storedValue;
                if (this.setItem(key, defaultValue)) return defaultValue;
            } catch (error) {
                (0, (0, parcelRequire("2bf04")).logInfoMessage)('Cannot read into localstorage', {
                    error: error
                });
            }
            return fallback;
        }
    };
});
parcelRegister("2jlP9", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", ()=>$54ec26d0e515404f$export$f55f538942f87030);
    $parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", ()=>$54ec26d0e515404f$export$f38af5fc86a6e665);
    const $54ec26d0e515404f$export$f55f538942f87030 = {};
    const $54ec26d0e515404f$export$f38af5fc86a6e665 = {
        'ptc-directory-ui.enable.cancel-join-requests-silently': false,
        'ptc-directory-ui.deny-open-sites-in-fe': false,
        'ptc-directory-ui.enable.atlas-team-health-monitor': false,
        ...$54ec26d0e515404f$export$f55f538942f87030
    };
});
parcelRegister("4BpOs", function(module, exports) {
    $parcel$export(module.exports, "StatusCode", ()=>$7b0026b0a0fc608a$export$f66f92b8741acd5b);
    $parcel$export(module.exports, "isAuthError", ()=>$7b0026b0a0fc608a$export$cde1786a482f9a1c);
    $parcel$export(module.exports, "isErrorStatusCode", ()=>$7b0026b0a0fc608a$export$9677d7c364ada66c);
    $parcel$export(module.exports, "ignoredErrorReason", ()=>$7b0026b0a0fc608a$export$ece443678e6cc3f5);
    $parcel$export(module.exports, "is4xxError", ()=>$7b0026b0a0fc608a$export$94c4b26e937da69);
    $parcel$export(module.exports, "doesErrorContainStatus", ()=>$7b0026b0a0fc608a$export$7c7624f23566b6ff);
    $parcel$export(module.exports, "DirectoryErrorCode", ()=>$7b0026b0a0fc608a$export$b19e812222b57630);
    $parcel$export(module.exports, "isApolloError", ()=>$7b0026b0a0fc608a$export$17f5e6bd290bb15d);
    var $7b0026b0a0fc608a$export$fe4bb20808298551;
    (function(ErrorCategory) {
        ErrorCategory["NotFound"] = "NotFound";
        ErrorCategory["NotPermitted"] = "NotPermitted";
        ErrorCategory["MalformedInput"] = "MalformedInput";
        ErrorCategory["Internal"] = "Internal";
    })($7b0026b0a0fc608a$export$fe4bb20808298551 || ($7b0026b0a0fc608a$export$fe4bb20808298551 = {}));
    var $7b0026b0a0fc608a$export$f66f92b8741acd5b;
    (function(StatusCode) {
        StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
        StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
        StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
        StatusCode[StatusCode["GONE"] = 410] = "GONE";
        StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    })($7b0026b0a0fc608a$export$f66f92b8741acd5b || ($7b0026b0a0fc608a$export$f66f92b8741acd5b = {}));
    function $7b0026b0a0fc608a$export$cde1786a482f9a1c(error) {
        return $7b0026b0a0fc608a$export$9677d7c364ada66c(401, error) || $7b0026b0a0fc608a$export$9677d7c364ada66c(403, error);
    }
    const $7b0026b0a0fc608a$export$c27af9588f06f6fc = [
        'SentryIgnoreError'
    ];
    const $7b0026b0a0fc608a$export$f4c3d57f2f41ffe2 = {
        'Could not verify accountId from header': 'AccountIdMismatch'
    };
    function $7b0026b0a0fc608a$export$ece443678e6cc3f5(error) {
        const constructor = error?.constructor.name;
        if (constructor && $7b0026b0a0fc608a$export$c27af9588f06f6fc.includes(constructor)) return constructor;
        const message = error?.message || '';
        const containedReason = message && Object.keys($7b0026b0a0fc608a$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
        if (containedReason) return $7b0026b0a0fc608a$export$f4c3d57f2f41ffe2[containedReason];
    }
    function $7b0026b0a0fc608a$export$9677d7c364ada66c(statusCode, error) {
        if (!error) return false;
        if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
        const reg = new RegExp(`status (code)?.*(${statusCode})`);
        return !!error?.message?.match(reg);
    }
    function $7b0026b0a0fc608a$export$94c4b26e937da69(error) {
        if (!error) return false;
        const statusCode = error['status'] || error['statusCode'];
        if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500) return true;
        const reg = new RegExp(/status (code)?.*(4\d\d)/g);
        return !!error.message?.match(reg);
    }
    function $7b0026b0a0fc608a$export$7c7624f23566b6ff(statusCode, message) {
        const reg = new RegExp(`status .*(${statusCode})`);
        return reg.test(message);
    }
    var $7b0026b0a0fc608a$export$b19e812222b57630;
    (function(DirectoryErrorCode) {
        DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
    })($7b0026b0a0fc608a$export$b19e812222b57630 || ($7b0026b0a0fc608a$export$b19e812222b57630 = {}));
    var $7b0026b0a0fc608a$export$c33cd4757598521c;
    (function(TeamErrorType) {
        TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    })($7b0026b0a0fc608a$export$c33cd4757598521c || ($7b0026b0a0fc608a$export$c33cd4757598521c = {}));
    function $7b0026b0a0fc608a$export$76843b239f07f80a(error, field) {
        return error instanceof Error && field in error;
    }
    function $7b0026b0a0fc608a$export$17f5e6bd290bb15d(err) {
        return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
    }
});
parcelRegister("a2luh", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$37ee1557f838d13e$export$f86b2a1a2ce291b3);
    $parcel$export(module.exports, "logErrorMessage", ()=>$37ee1557f838d13e$export$ece28f5cfa04608);
    $parcel$export(module.exports, "logInfoMessage", ()=>$37ee1557f838d13e$export$386587bcf05ee8ea);
    $parcel$export(module.exports, "createErrorHandler", ()=>$37ee1557f838d13e$export$9edc7d6f1c33ddc);
    var $6laLp;
    const $37ee1557f838d13e$var$packageContext = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $37ee1557f838d13e$export$f86b2a1a2ce291b3 = (0, (0, parcelRequire("6laLp")).logExceptionWithPackageContext)($37ee1557f838d13e$var$packageContext);
    const $37ee1557f838d13e$export$ece28f5cfa04608 = (0, (0, parcelRequire("6laLp")).logErrorMessageWithPackageContext)($37ee1557f838d13e$var$packageContext);
    const $37ee1557f838d13e$export$386587bcf05ee8ea = (0, (0, parcelRequire("6laLp")).logInfoMessageWithPackageContext)($37ee1557f838d13e$var$packageContext);
    const $37ee1557f838d13e$export$9edc7d6f1c33ddc = (0, (0, parcelRequire("6laLp")).createErrorHandlerWithPackageContext)($37ee1557f838d13e$var$packageContext);
});
parcelRegister("65ws1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca7d138070beba16$export$2e2bcd8739ae039);
    var $6l1dD;
    let $ca7d138070beba16$var$data = null;
    const $ca7d138070beba16$var$referrerInfo = {
        isUsed: false,
        markUsed () {
            $ca7d138070beba16$var$referrerInfo.isUsed = true;
        },
        get () {
            return $ca7d138070beba16$var$data;
        },
        set ({ src: src = '', ref: ref = '' }) {
            $ca7d138070beba16$var$data = {
                src: (0, (0, parcelRequire("6l1dD")).sanitiseValue)(src || '', {
                    shouldHaveSafeCharsOnly: true,
                    shouldEncode: true
                }),
                ref: (0, (0, parcelRequire("6l1dD")).sanitiseValue)(ref, {
                    shouldHaveSafeCharsOnly: true,
                    shouldEncode: true
                })
            };
        },
        cleanup (force) {
            if (!$ca7d138070beba16$var$referrerInfo.isUsed && !force) return;
            $ca7d138070beba16$var$data = null;
        }
    };
    var $ca7d138070beba16$export$2e2bcd8739ae039 = $ca7d138070beba16$var$referrerInfo;
});
parcelRegister("6l1dD", function(module, exports) {
    $parcel$export(module.exports, "sanitiseValue", ()=>$94d6cd98d33d7505$export$b66eb39ba856053f);
    const $94d6cd98d33d7505$var$FORBIDDEN_CODE_CHARS = [
        8207
    ];
    function $94d6cd98d33d7505$export$b66eb39ba856053f(value, options = {}) {
        let trimmedStr = value.trim();
        $94d6cd98d33d7505$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
            const char = String.fromCharCode(codeChar);
            const re = new RegExp(char, 'gm');
            trimmedStr = trimmedStr.replace(re, '');
        });
        if (options.shouldHaveSafeCharsOnly) {
            trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
            trimmedStr = trimmedStr.trim();
        }
        if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
        return trimmedStr;
    }
});
parcelRegister("ftrEg", function(module, exports) {
    $parcel$export(module.exports, "useSetupApolloClient", ()=>$1f471b2a30cddb8a$export$78cd44b109ba6e2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $e7caa;
    function $1f471b2a30cddb8a$export$78cd44b109ba6e2a(cloudId) {
        const [apolloClient, setApolloClient] = (0, $5uXOq.useState)((0, (0, parcelRequire("e7caa")).getApolloClient)({
            getCloudId: ()=>cloudId
        }));
        const gatewayClient = (0, (0, parcelRequire("e7caa")).getGatewayClient)();
        (0, $5uXOq.useEffect)(()=>{
            if (!cloudId) return;
            const apolloClient = (0, (0, parcelRequire("e7caa")).getApolloClient)({
                getCloudId: ()=>cloudId
            });
            apolloClient.writeData({
                data: {
                    cloudId: cloudId
                }
            });
            setApolloClient(apolloClient);
        }, [
            cloudId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            gatewayClient.writeData({
                data: {
                    cloudId: cloudId || 'None'
                }
            });
        }, [
            cloudId,
            gatewayClient
        ]);
        return apolloClient;
    }
});
parcelRegister("e7caa", function(module, exports) {
    $parcel$export(module.exports, "getApolloClient", ()=>$bb872e306b903335$export$1e6cfeaf8b88bd01);
    $parcel$export(module.exports, "getGatewayClient", ()=>$bb872e306b903335$export$719274339c63410a);
    $parcel$export(module.exports, "getTeamCentralClient", ()=>$bb872e306b903335$export$6ef19f8a51b6041);
    var $1Py8o;
    var $2sqTC;
    var $jCvwN;
    var $f5deG;
    const $bb872e306b903335$var$customFetch = (0, (0, parcelRequire("f5deG")).withDefaultExponentialBackoff)(fetch);
    let $bb872e306b903335$var$cachedApolloClient;
    const $bb872e306b903335$export$1e6cfeaf8b88bd01 = (customConfig)=>{
        if ($bb872e306b903335$var$cachedApolloClient) return $bb872e306b903335$var$cachedApolloClient;
        const apolloClient = $bb872e306b903335$export$67100df7b1079985(customConfig);
        if (customConfig?.getCloudId && customConfig?.getCloudId()) $bb872e306b903335$var$cachedApolloClient = apolloClient;
        return apolloClient;
    };
    const $bb872e306b903335$export$67100df7b1079985 = (customConfig)=>(0, (0, parcelRequire("1Py8o")).createApolloClient)({
            connectToDevTools: !!(0, (0, parcelRequire("2sqTC")).DEV),
            url: {
                stargateRoot: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot,
                collaborationGraph: (0, (0, parcelRequire("jCvwN")).getConfig)().collaborationGraph
            },
            customFetch: $bb872e306b903335$var$customFetch,
            ...customConfig
        });
    let $bb872e306b903335$var$cachedWorklensClient;
    const $bb872e306b903335$export$f0c45e63c1288a74 = ()=>{
        if ($bb872e306b903335$var$cachedWorklensClient) return $bb872e306b903335$var$cachedWorklensClient;
        $bb872e306b903335$var$cachedWorklensClient = (0, (0, parcelRequire("1Py8o")).createWorklensClient)({
            url: {
                stargateRoot: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot
            },
            customFetch: $bb872e306b903335$var$customFetch
        });
        return $bb872e306b903335$var$cachedWorklensClient;
    };
    let $bb872e306b903335$var$cachedGatewayClient;
    const $bb872e306b903335$export$719274339c63410a = ()=>{
        if ($bb872e306b903335$var$cachedGatewayClient) return $bb872e306b903335$var$cachedGatewayClient;
        $bb872e306b903335$var$cachedGatewayClient = (0, (0, parcelRequire("1Py8o")).createAtlassianGatewayClient)({
            url: {
                stargateRoot: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot
            },
            customFetch: $bb872e306b903335$var$customFetch
        });
        return $bb872e306b903335$var$cachedGatewayClient;
    };
    let $bb872e306b903335$var$cachedTeamCentralClients = new Map();
    const $bb872e306b903335$export$6ef19f8a51b6041 = (cloudId)=>{
        let maybeCachedTeamCentralClient = $bb872e306b903335$var$cachedTeamCentralClients.get(cloudId);
        if (maybeCachedTeamCentralClient) return maybeCachedTeamCentralClient;
        const teamCentralClient = (0, (0, parcelRequire("1Py8o")).createTeamCentralClient)({
            url: {
                stargateRoot: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot
            },
            customFetch: $bb872e306b903335$var$customFetch,
            getCloudId: ()=>cloudId
        });
        $bb872e306b903335$var$cachedTeamCentralClients.set(cloudId, teamCentralClient);
        return teamCentralClient;
    };
});
parcelRegister("1Py8o", function(module, exports) {
    $parcel$export(module.exports, "createApolloClient", ()=>$177cf05ac00b7a30$export$67100df7b1079985);
    $parcel$export(module.exports, "createWorklensClient", ()=>$177cf05ac00b7a30$export$72afd8225aad0e67);
    $parcel$export(module.exports, "createAtlassianGatewayClient", ()=>$177cf05ac00b7a30$export$a518457feff205cb);
    $parcel$export(module.exports, "createTeamCentralClient", ()=>$177cf05ac00b7a30$export$63d9e7c1fb26588f);
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $kH9C9;
    var $cKbwx = parcelRequire("cKbwx");
    var $VSDnB;
    var $6nlEk;
    var $5nPJy;
    var $lgZyO;
    var $gUX0t;
    var $9NFua;
    var $520qQ;
    var $2WwVh;
    const $177cf05ac00b7a30$export$67100df7b1079985 = (options)=>{
        const { retryLink: retryOptions = {}, getCloudId: getCloudId, url: url, statusCodeHandlers: statusCodeHandlers = {}, customFetch: customFetch } = options;
        const links = [];
        const errorLink = (0, (0, parcelRequire("gUX0t")).createErrorLink)({
            statusCodeHandlers: statusCodeHandlers
        });
        if (errorLink) links.push(errorLink);
        const retryLink = (0, (0, parcelRequire("9NFua")).createRetryLink)(retryOptions);
        if (retryLink) links.push(retryLink);
        const customResolversLink = new (0, (0, parcelRequire("kH9C9")).SchemaLink)({
            schema: (0, $cKbwx.addResolveFunctionsToSchema)({
                schema: (0, parcelRequire("2WwVh")).schema,
                resolvers: (0, parcelRequire("520qQ")).default
            }),
            context: {
                url: url,
                fetch: (0, (0, parcelRequire("6nlEk")).getCustomResolversFetch)({
                    fetch: customFetch || fetch,
                    statusCodeHandlers: statusCodeHandlers
                })
            }
        });
        const directoryHttpLink = (0, (0, parcelRequire("lgZyO")).createDirectoryHttpLink)({
            url: `${url ? url.stargateRoot : ''}/directory/graphql`,
            getCloudId: getCloudId
        });
        links.push((0, (0, parcelRequire("clSzL")).split)((operation)=>(0, (0, parcelRequire("5nPJy")).isCustomQuery)(operation), customResolversLink, directoryHttpLink));
        return new (0, (0, parcelRequire("e3a3O")).default)({
            connectToDevTools: !!options.connectToDevTools,
            link: (0, (0, parcelRequire("clSzL")).from)(links),
            cache: new (0, (0, parcelRequire("ivfDv")).InMemoryCache)(),
            resolvers: {}
        });
    };
    const $177cf05ac00b7a30$export$72afd8225aad0e67 = (options)=>{
        const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
        const errorLink = (0, (0, parcelRequire("gUX0t")).createErrorLink)({
            statusCodeHandlers: statusCodeHandlers
        });
        const retryLink = (0, (0, parcelRequire("9NFua")).createRetryLink)(retryOptions);
        const httpLink = (0, (0, parcelRequire("lgZyO")).createDirectoryHttpLink)({
            url: `${url.stargateRoot}/worklens/api/graphql`
        });
        const links = [
            errorLink,
            retryLink,
            httpLink
        ];
        return new (0, (0, parcelRequire("e3a3O")).default)({
            link: (0, (0, parcelRequire("clSzL")).from)(links),
            cache: new (0, (0, parcelRequire("ivfDv")).InMemoryCache)()
        });
    };
    const $177cf05ac00b7a30$export$a518457feff205cb = (options)=>{
        const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
        const errorLink = (0, (0, parcelRequire("gUX0t")).createErrorLink)({
            statusCodeHandlers: statusCodeHandlers
        });
        const retryLink = (0, (0, parcelRequire("9NFua")).createRetryLink)(retryOptions);
        const httpLink = (0, (0, parcelRequire("lgZyO")).createDirectoryHttpLink)({
            url: `${url.stargateRoot}/graphql`
        });
        const links = [
            errorLink,
            retryLink,
            httpLink
        ];
        return new (0, (0, parcelRequire("e3a3O")).default)({
            link: (0, (0, parcelRequire("clSzL")).from)(links),
            cache: new (0, (0, parcelRequire("ivfDv")).InMemoryCache)(),
            resolvers: {}
        });
    };
    const $177cf05ac00b7a30$export$63d9e7c1fb26588f = (options)=>{
        const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
        const errorLink = (0, (0, parcelRequire("gUX0t")).createErrorLink)({
            statusCodeHandlers: statusCodeHandlers
        });
        const retryLink = (0, (0, parcelRequire("9NFua")).createRetryLink)(retryOptions);
        const cloudId = options.getCloudId?.();
        const maybeShardedGraphqlPath = cloudId !== undefined && (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${cloudId}/graphql` : '/watermelon/graphql';
        const httpLink = (0, (0, parcelRequire("lgZyO")).createDirectoryHttpLink)({
            url: `${url ? url.stargateRoot : ''}${maybeShardedGraphqlPath}`
        });
        const links = [
            errorLink,
            retryLink,
            httpLink
        ];
        return new (0, (0, parcelRequire("e3a3O")).default)({
            link: (0, (0, parcelRequire("clSzL")).from)(links),
            cache: new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
                dataIdFromObject: (obj)=>{
                    switch(obj.__typename){
                        case 'Icon':
                            return `${obj.id}:${obj.shortName}|${obj.color}`;
                        case 'GoalPhaseDetails':
                        case 'ProjectPhaseDetails':
                        case 'GqlJiraIssue':
                        case 'GqlJiraIssueType':
                        case 'GqlJiraStatus':
                        case 'GqlJiraStatusCategory':
                            return `${obj.__typename}:${obj.id}`;
                        default:
                            return obj.id;
                    }
                }
            })
        });
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("kH9C9", function(module, exports) {
    $parcel$export(module.exports, "SchemaLink", ()=>$f10f47fba63df518$export$f2b7839aa4c35c8d);
    var $3VFsf;
    var $clSzL;
    var $mP8zZ;
    var $f10f47fba63df518$export$f2b7839aa4c35c8d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SchemaLink, _super);
        function SchemaLink(_a) {
            var schema = _a.schema, rootValue = _a.rootValue, context = _a.context;
            var _this = _super.call(this) || this;
            _this.schema = schema;
            _this.rootValue = rootValue;
            _this.context = context;
            return _this;
        }
        SchemaLink.prototype.request = function(operation) {
            var _this = this;
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                Promise.resolve((0, (0, parcelRequire("mP8zZ")).execute)(_this.schema, operation.query, _this.rootValue, typeof _this.context === 'function' ? _this.context(operation) : _this.context, operation.variables, operation.operationName)).then(function(data) {
                    if (!observer.closed) {
                        observer.next(data);
                        observer.complete();
                    }
                }).catch(function(error) {
                    if (!observer.closed) observer.error(error);
                });
            });
        };
        return SchemaLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
    var $f10f47fba63df518$export$2e2bcd8739ae039 = $f10f47fba63df518$export$f2b7839aa4c35c8d;
});
parcelRegister("mP8zZ", function(module, exports) {
    $parcel$export(module.exports, "execute", ()=>$0449b901b9e9408e$export$51396ec711da548b);
    $parcel$export(module.exports, "assertValidExecutionArguments", ()=>$0449b901b9e9408e$export$e02b605d81e17af1);
    $parcel$export(module.exports, "buildExecutionContext", ()=>$0449b901b9e9408e$export$312a3f029bac48f9);
    $parcel$export(module.exports, "defaultFieldResolver", ()=>$0449b901b9e9408e$export$21fc6d079630d659);
    $parcel$export(module.exports, "collectFields", ()=>$0449b901b9e9408e$export$c23741d442fe90e9);
    $parcel$export(module.exports, "getFieldDef", ()=>$0449b901b9e9408e$export$dab6dcab745bb1b6);
    $parcel$export(module.exports, "buildResolveInfo", ()=>$0449b901b9e9408e$export$27b5443b7768606f);
    var $yEDl8;
    var $xeUe3;
    var $fM9AB;
    var $a1qmV;
    var $jMqAK;
    var $cJPdE;
    var $iAT21;
    var $jyJ52;
    var $efgSh;
    var $hEo2F;
    var $g5yZB;
    var $csEv9;
    var $bzIlO;
    var $bKGOe;
    var $4Hpke;
    var $35Smo;
    var $8oLgk;
    var $6D4Eu;
    var $etM9Y;
    var $7dqoX;
    function $0449b901b9e9408e$export$51396ec711da548b(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
        return arguments.length === 1 ? $0449b901b9e9408e$var$executeImpl(argsOrSchema) : $0449b901b9e9408e$var$executeImpl({
            schema: argsOrSchema,
            document: document,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        });
    }
    function $0449b901b9e9408e$export$6d0f20a121527483(args) {
        var result = $0449b901b9e9408e$var$executeImpl(args);
        if ((0, (0, parcelRequire("jMqAK")).default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
        return result;
    }
    function $0449b901b9e9408e$var$executeImpl(args) {
        var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver;
        $0449b901b9e9408e$export$e02b605d81e17af1(schema, document, variableValues);
        var exeContext = $0449b901b9e9408e$export$312a3f029bac48f9(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver);
        if (Array.isArray(exeContext)) return {
            errors: exeContext
        };
        var data = $0449b901b9e9408e$var$executeOperation(exeContext, exeContext.operation, rootValue);
        return $0449b901b9e9408e$var$buildResponse(exeContext, data);
    }
    function $0449b901b9e9408e$var$buildResponse(exeContext, data) {
        if ((0, (0, parcelRequire("jMqAK")).default)(data)) return data.then(function(resolved) {
            return $0449b901b9e9408e$var$buildResponse(exeContext, resolved);
        });
        return exeContext.errors.length === 0 ? {
            data: data
        } : {
            errors: exeContext.errors,
            data: data
        };
    }
    function $0449b901b9e9408e$export$e02b605d81e17af1(schema, document, rawVariableValues) {
        document || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide document.');
        (0, (0, parcelRequire("bKGOe")).assertValidSchema)(schema);
        rawVariableValues == null || (0, (0, parcelRequire("cJPdE")).default)(rawVariableValues) || (0, (0, parcelRequire("a1qmV")).default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
    }
    function $0449b901b9e9408e$export$312a3f029bac48f9(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
        var _definition$name, _operation$variableDe;
        var operation;
        var fragments = Object.create(null);
        for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
            var definition = _document$definitions2[_i2];
            switch(definition.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION:
                    if (operationName == null) {
                        if (operation !== undefined) return [
                            new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Must provide operation name if query contains multiple operations.')
                        ];
                        operation = definition;
                    } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION:
                    fragments[definition.name.value] = definition;
                    break;
            }
        }
        if (!operation) {
            if (operationName != null) return [
                new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
            ];
            return [
                new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Must provide an operation.')
            ];
        }
        var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
        var coercedVariableValues = (0, (0, parcelRequire("7dqoX")).getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
            maxErrors: 50
        });
        if (coercedVariableValues.errors) return coercedVariableValues.errors;
        return {
            schema: schema,
            fragments: fragments,
            rootValue: rootValue,
            contextValue: contextValue,
            operation: operation,
            variableValues: coercedVariableValues.coerced,
            fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : $0449b901b9e9408e$export$21fc6d079630d659,
            typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : $0449b901b9e9408e$export$4a45c17a1ba2cb7,
            errors: []
        };
    }
    function $0449b901b9e9408e$var$executeOperation(exeContext, operation, rootValue) {
        var type = (0, (0, parcelRequire("etM9Y")).getOperationRootType)(exeContext.schema, operation);
        var fields = $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
        var path = undefined;
        try {
            var result = operation.operation === 'mutation' ? $0449b901b9e9408e$var$executeFieldsSerially(exeContext, type, rootValue, path, fields) : $0449b901b9e9408e$var$executeFields(exeContext, type, rootValue, path, fields);
            if ((0, (0, parcelRequire("jMqAK")).default)(result)) return result.then(undefined, function(error) {
                exeContext.errors.push(error);
                return Promise.resolve(null);
            });
            return result;
        } catch (error) {
            exeContext.errors.push(error);
            return null;
        }
    }
    function $0449b901b9e9408e$var$executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
        return (0, (0, parcelRequire("jyJ52")).default)(Object.keys(fields), function(results, responseName) {
            var fieldNodes = fields[responseName];
            var fieldPath = (0, (0, parcelRequire("hEo2F")).addPath)(path, responseName, parentType.name);
            var result = $0449b901b9e9408e$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
            if (result === undefined) return results;
            if ((0, (0, parcelRequire("jMqAK")).default)(result)) return result.then(function(resolvedResult) {
                results[responseName] = resolvedResult;
                return results;
            });
            results[responseName] = result;
            return results;
        }, Object.create(null));
    }
    function $0449b901b9e9408e$var$executeFields(exeContext, parentType, sourceValue, path, fields) {
        var results = Object.create(null);
        var containsPromise = false;
        for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
            var responseName = _Object$keys2[_i4];
            var fieldNodes = fields[responseName];
            var fieldPath = (0, (0, parcelRequire("hEo2F")).addPath)(path, responseName, parentType.name);
            var result = $0449b901b9e9408e$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
            if (result !== undefined) {
                results[responseName] = result;
                if ((0, (0, parcelRequire("jMqAK")).default)(result)) containsPromise = true;
            }
        }
        if (!containsPromise) return results;
        return (0, (0, parcelRequire("efgSh")).default)(results);
    }
    function $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
        for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
            var selection = _selectionSet$selecti2[_i6];
            switch(selection.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).FIELD:
                    if (!$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection)) continue;
                    var name = $0449b901b9e9408e$var$getFieldEntryKey(selection);
                    if (!fields[name]) fields[name] = [];
                    fields[name].push(selection);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT:
                    if (!$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection) || !$0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                    $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD:
                    var fragName = selection.name.value;
                    if (visitedFragmentNames[fragName] || !$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection)) continue;
                    visitedFragmentNames[fragName] = true;
                    var fragment = exeContext.fragments[fragName];
                    if (!fragment || !$0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                    $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                    break;
            }
        }
        return fields;
    }
    function $0449b901b9e9408e$var$shouldIncludeNode(exeContext, node) {
        var skip = (0, (0, parcelRequire("7dqoX")).getDirectiveValues)((0, (0, parcelRequire("35Smo")).GraphQLSkipDirective), node, exeContext.variableValues);
        if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
        var include = (0, (0, parcelRequire("7dqoX")).getDirectiveValues)((0, (0, parcelRequire("35Smo")).GraphQLIncludeDirective), node, exeContext.variableValues);
        if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
        return true;
    }
    function $0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, fragment, type) {
        var typeConditionNode = fragment.typeCondition;
        if (!typeConditionNode) return true;
        var conditionalType = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(exeContext.schema, typeConditionNode);
        if (conditionalType === type) return true;
        if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
        return false;
    }
    function $0449b901b9e9408e$var$getFieldEntryKey(node) {
        return node.alias ? node.alias.value : node.name.value;
    }
    function $0449b901b9e9408e$var$resolveField(exeContext, parentType, source, fieldNodes, path) {
        var _fieldDef$resolve;
        var fieldNode = fieldNodes[0];
        var fieldName = fieldNode.name.value;
        var fieldDef = $0449b901b9e9408e$export$dab6dcab745bb1b6(exeContext.schema, parentType, fieldName);
        if (!fieldDef) return;
        var returnType = fieldDef.type;
        var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
        var info = $0449b901b9e9408e$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path);
        try {
            var args = (0, (0, parcelRequire("7dqoX")).getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues);
            var _contextValue = exeContext.contextValue;
            var result = resolveFn(source, args, _contextValue, info);
            var completed;
            if ((0, (0, parcelRequire("jMqAK")).default)(result)) completed = result.then(function(resolved) {
                return $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
            });
            else completed = $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, result);
            if ((0, (0, parcelRequire("jMqAK")).default)(completed)) return completed.then(undefined, function(rawError) {
                var error = (0, (0, parcelRequire("csEv9")).locatedError)(rawError, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(path));
                return $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext);
            });
            return completed;
        } catch (rawError) {
            var error = (0, (0, parcelRequire("csEv9")).locatedError)(rawError, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(path));
            return $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext);
        }
    }
    function $0449b901b9e9408e$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path) {
        return {
            fieldName: fieldDef.name,
            fieldNodes: fieldNodes,
            returnType: fieldDef.type,
            parentType: parentType,
            path: path,
            schema: exeContext.schema,
            fragments: exeContext.fragments,
            rootValue: exeContext.rootValue,
            operation: exeContext.operation,
            variableValues: exeContext.variableValues
        };
    }
    function $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext) {
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(returnType)) throw error;
        exeContext.errors.push(error);
        return null;
    }
    function $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, result) {
        if (result instanceof Error) throw result;
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(returnType)) {
            var completed = $0449b901b9e9408e$var$completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
            if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
            return completed;
        }
        if (result == null) return null;
        if ((0, (0, parcelRequire("8oLgk")).isListType)(returnType)) return $0449b901b9e9408e$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, (0, parcelRequire("8oLgk")).isLeafType)(returnType)) return $0449b901b9e9408e$var$completeLeafValue(returnType, result);
        if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(returnType)) return $0449b901b9e9408e$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(returnType)) return $0449b901b9e9408e$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Cannot complete value of unexpected output type: ' + (0, (0, parcelRequire("yEDl8")).default)(returnType));
    }
    function $0449b901b9e9408e$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
        var itemType = returnType.ofType;
        var containsPromise = false;
        var completedResults = (0, (0, parcelRequire("iAT21")).default)(result, function(item, index) {
            var itemPath = (0, (0, parcelRequire("hEo2F")).addPath)(path, index, undefined);
            try {
                var completedItem;
                if ((0, (0, parcelRequire("jMqAK")).default)(item)) completedItem = item.then(function(resolved) {
                    return $0449b901b9e9408e$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
                });
                else completedItem = $0449b901b9e9408e$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
                if ((0, (0, parcelRequire("jMqAK")).default)(completedItem)) {
                    containsPromise = true;
                    return completedItem.then(undefined, function(rawError) {
                        var error = (0, (0, parcelRequire("csEv9")).locatedError)(rawError, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(itemPath));
                        return $0449b901b9e9408e$var$handleFieldError(error, itemType, exeContext);
                    });
                }
                return completedItem;
            } catch (rawError) {
                var error = (0, (0, parcelRequire("csEv9")).locatedError)(rawError, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(itemPath));
                return $0449b901b9e9408e$var$handleFieldError(error, itemType, exeContext);
            }
        });
        if (completedResults == null) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
        return containsPromise ? Promise.all(completedResults) : completedResults;
    }
    function $0449b901b9e9408e$var$completeLeafValue(returnType, result) {
        var serializedResult = returnType.serialize(result);
        if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, (0, parcelRequire("yEDl8")).default)(returnType), "\" but ") + "received: ".concat((0, (0, parcelRequire("yEDl8")).default)(result)));
        return serializedResult;
    }
    function $0449b901b9e9408e$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
        var _returnType$resolveTy;
        var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
        var contextValue = exeContext.contextValue;
        var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
        if ((0, (0, parcelRequire("jMqAK")).default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
            return $0449b901b9e9408e$var$completeObjectValue(exeContext, $0449b901b9e9408e$var$ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
        });
        return $0449b901b9e9408e$var$completeObjectValue(exeContext, $0449b901b9e9408e$var$ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    }
    function $0449b901b9e9408e$var$ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
        if (runtimeTypeOrName == null) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
        var runtimeTypeName = (0, (0, parcelRequire("8oLgk")).isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
        if (typeof runtimeTypeName !== 'string') throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, (0, parcelRequire("yEDl8")).default)(result), ", received \"").concat((0, (0, parcelRequire("yEDl8")).default)(runtimeTypeOrName), "\"."));
        var runtimeType = exeContext.schema.getType(runtimeTypeName);
        if (runtimeType == null) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
        if (!(0, (0, parcelRequire("8oLgk")).isObjectType)(runtimeType)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
        if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
        return runtimeType;
    }
    function $0449b901b9e9408e$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
        if (returnType.isTypeOf) {
            var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
            if ((0, (0, parcelRequire("jMqAK")).default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
                if (!resolvedIsTypeOf) throw $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes);
                return $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
            });
            if (!isTypeOf) throw $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes);
        }
        return $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
    }
    function $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes) {
        return new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, (0, parcelRequire("yEDl8")).default)(result), "."), fieldNodes);
    }
    function $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
        var subFieldNodes = $0449b901b9e9408e$var$collectSubfields(exeContext, returnType, fieldNodes);
        return $0449b901b9e9408e$var$executeFields(exeContext, returnType, result, path, subFieldNodes);
    }
    var $0449b901b9e9408e$var$collectSubfields = (0, (0, parcelRequire("xeUe3")).default)($0449b901b9e9408e$var$_collectSubfields);
    function $0449b901b9e9408e$var$_collectSubfields(exeContext, returnType, fieldNodes) {
        var subFieldNodes = Object.create(null);
        var visitedFragmentNames = Object.create(null);
        for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
            var node = fieldNodes[_i8];
            if (node.selectionSet) subFieldNodes = $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
        }
        return subFieldNodes;
    }
    var $0449b901b9e9408e$export$4a45c17a1ba2cb7 = function defaultTypeResolver(value, contextValue, info, abstractType) {
        if ((0, (0, parcelRequire("cJPdE")).default)(value) && typeof value.__typename === 'string') return value.__typename;
        var possibleTypes = info.schema.getPossibleTypes(abstractType);
        var promisedIsTypeOfResults = [];
        for(var i = 0; i < possibleTypes.length; i++){
            var type = possibleTypes[i];
            if (type.isTypeOf) {
                var isTypeOfResult = type.isTypeOf(value, contextValue, info);
                if ((0, (0, parcelRequire("jMqAK")).default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
                else if (isTypeOfResult) return type.name;
            }
        }
        if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
            for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
                if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
            }
        });
    };
    var $0449b901b9e9408e$export$21fc6d079630d659 = function defaultFieldResolver(source, args, contextValue, info) {
        if ((0, (0, parcelRequire("cJPdE")).default)(source) || typeof source === 'function') {
            var property = source[info.fieldName];
            if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
            return property;
        }
    };
    function $0449b901b9e9408e$export$dab6dcab745bb1b6(schema, parentType, fieldName) {
        if (fieldName === (0, (0, parcelRequire("4Hpke")).SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, (0, parcelRequire("4Hpke")).SchemaMetaFieldDef;
        else if (fieldName === (0, (0, parcelRequire("4Hpke")).TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, (0, parcelRequire("4Hpke")).TypeMetaFieldDef;
        else if (fieldName === (0, (0, parcelRequire("4Hpke")).TypeNameMetaFieldDef).name) return 0, (0, parcelRequire("4Hpke")).TypeNameMetaFieldDef;
        return parentType.getFields()[fieldName];
    }
});
parcelRegister("xeUe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$063ea52d4dbbee9d$export$2e2bcd8739ae039);
    function $063ea52d4dbbee9d$export$2e2bcd8739ae039(fn) {
        var cache0;
        return function memoized(a1, a2, a3) {
            if (!cache0) cache0 = new WeakMap();
            var cache1 = cache0.get(a1);
            var cache2;
            if (cache1) {
                cache2 = cache1.get(a2);
                if (cache2) {
                    var cachedValue = cache2.get(a3);
                    if (cachedValue !== undefined) return cachedValue;
                }
            } else {
                cache1 = new WeakMap();
                cache0.set(a1, cache1);
            }
            if (!cache2) {
                cache2 = new WeakMap();
                cache1.set(a2, cache2);
            }
            var newValue = fn(a1, a2, a3);
            cache2.set(a3, newValue);
            return newValue;
        };
    }
});
parcelRegister("jMqAK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6672090fd5f8d8c$export$2e2bcd8739ae039);
    function $e6672090fd5f8d8c$export$2e2bcd8739ae039(value) {
        return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
    }
});
parcelRegister("iAT21", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d89646edb2b9c31b$export$2e2bcd8739ae039);
    var $6DBwa;
    function $d89646edb2b9c31b$var$_typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d89646edb2b9c31b$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        else $d89646edb2b9c31b$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return $d89646edb2b9c31b$var$_typeof(obj);
    }
    function $d89646edb2b9c31b$export$2e2bcd8739ae039(collection) {
        var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(item) {
            return item;
        };
        if (collection == null || $d89646edb2b9c31b$var$_typeof(collection) !== 'object') return null;
        if (Array.isArray(collection)) return collection.map(mapFn);
        var iteratorMethod = collection[0, (0, parcelRequire("6DBwa")).SYMBOL_ITERATOR];
        if (typeof iteratorMethod === 'function') {
            var iterator = iteratorMethod.call(collection);
            var result = [];
            var step;
            for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
            return result;
        }
        var length = collection.length;
        if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
            var _result = [];
            for(var _i = 0; _i < length; ++_i){
                if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
                _result.push(mapFn(collection[String(_i)], _i));
            }
            return _result;
        }
        return null;
    }
});
parcelRegister("jyJ52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3d4295120323fd9$export$2e2bcd8739ae039);
    var $jMqAK;
    function $e3d4295120323fd9$export$2e2bcd8739ae039(values, callback, initialValue) {
        return values.reduce(function(previous, value) {
            return (0, (0, parcelRequire("jMqAK")).default)(previous) ? previous.then(function(resolved) {
                return callback(resolved, value);
            }) : callback(previous, value);
        }, initialValue);
    }
});
parcelRegister("efgSh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5ef8e565e79ecea$export$2e2bcd8739ae039);
    function $a5ef8e565e79ecea$export$2e2bcd8739ae039(object) {
        var keys = Object.keys(object);
        var valuesAndPromises = keys.map(function(name) {
            return object[name];
        });
        return Promise.all(valuesAndPromises).then(function(values) {
            return values.reduce(function(resolvedObject, value, i) {
                resolvedObject[keys[i]] = value;
                return resolvedObject;
            }, Object.create(null));
        });
    }
});
parcelRegister("hEo2F", function(module, exports) {
    $parcel$export(module.exports, "addPath", ()=>$cd98d25b9dafb31a$export$4c25481b843feb0b);
    $parcel$export(module.exports, "pathToArray", ()=>$cd98d25b9dafb31a$export$38d939edd7751830);
    function $cd98d25b9dafb31a$export$4c25481b843feb0b(prev, key, typename) {
        return {
            prev: prev,
            key: key,
            typename: typename
        };
    }
    function $cd98d25b9dafb31a$export$38d939edd7751830(path) {
        var flattened = [];
        var curr = path;
        while(curr){
            flattened.push(curr.key);
            curr = curr.prev;
        }
        return flattened.reverse();
    }
});
parcelRegister("csEv9", function(module, exports) {
    $parcel$export(module.exports, "locatedError", ()=>$912784482422d090$export$d6d5dddbbbfd3fca);
    var $yEDl8;
    var $g5yZB;
    function $912784482422d090$export$d6d5dddbbbfd3fca(rawOriginalError, nodes, path) {
        var _nodes;
        var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, (0, parcelRequire("yEDl8")).default)(rawOriginalError));
        if (Array.isArray(originalError.path)) return originalError;
        return new (0, (0, parcelRequire("g5yZB")).GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
    }
});
parcelRegister("bKGOe", function(module, exports) {
    $parcel$export(module.exports, "validateSchema", ()=>$88e532994a71ff2b$export$4741711f07dbb8e7);
    $parcel$export(module.exports, "assertValidSchema", ()=>$88e532994a71ff2b$export$d32aa1886d3569c6);
    var $85NSv;
    var $isVmt;
    var $yEDl8;
    var $g5yZB;
    var $csEv9;
    var $yHEIl;
    var $9GswX;
    var $lUVCX;
    var $4Hpke;
    var $35Smo;
    var $8oLgk;
    function $88e532994a71ff2b$export$4741711f07dbb8e7(schema) {
        (0, (0, parcelRequire("lUVCX")).assertSchema)(schema);
        if (schema.__validationErrors) return schema.__validationErrors;
        var context = new $88e532994a71ff2b$var$SchemaValidationContext(schema);
        $88e532994a71ff2b$var$validateRootTypes(context);
        $88e532994a71ff2b$var$validateDirectives(context);
        $88e532994a71ff2b$var$validateTypes(context);
        var errors = context.getErrors();
        schema.__validationErrors = errors;
        return errors;
    }
    function $88e532994a71ff2b$export$d32aa1886d3569c6(schema) {
        var errors = $88e532994a71ff2b$export$4741711f07dbb8e7(schema);
        if (errors.length !== 0) throw new Error(errors.map(function(error) {
            return error.message;
        }).join('\n\n'));
    }
    var $88e532994a71ff2b$var$SchemaValidationContext = function() {
        function SchemaValidationContext(schema) {
            this._errors = [];
            this.schema = schema;
        }
        var _proto = SchemaValidationContext.prototype;
        _proto.reportError = function reportError(message, nodes) {
            var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
            this.addError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)(message, _nodes));
        };
        _proto.addError = function addError(error) {
            this._errors.push(error);
        };
        _proto.getErrors = function getErrors() {
            return this._errors;
        };
        return SchemaValidationContext;
    }();
    function $88e532994a71ff2b$var$validateRootTypes(context) {
        var schema = context.schema;
        var queryType = schema.getQueryType();
        if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
        else if (!(0, (0, parcelRequire("8oLgk")).isObjectType)(queryType)) {
            var _getOperationTypeNode;
            context.reportError("Query root type must be Object type, it cannot be ".concat((0, (0, parcelRequire("yEDl8")).default)(queryType), "."), (_getOperationTypeNode = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
        }
        var mutationType = schema.getMutationType();
        if (mutationType && !(0, (0, parcelRequire("8oLgk")).isObjectType)(mutationType)) {
            var _getOperationTypeNode2;
            context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, (0, parcelRequire("yEDl8")).default)(mutationType), "."), (_getOperationTypeNode2 = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
        }
        var subscriptionType = schema.getSubscriptionType();
        if (subscriptionType && !(0, (0, parcelRequire("8oLgk")).isObjectType)(subscriptionType)) {
            var _getOperationTypeNode3;
            context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, (0, parcelRequire("yEDl8")).default)(subscriptionType), "."), (_getOperationTypeNode3 = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
        }
    }
    function $88e532994a71ff2b$var$getOperationTypeNode(schema, operation) {
        var operationNodes = $88e532994a71ff2b$var$getAllSubNodes(schema, function(node) {
            return node.operationTypes;
        });
        for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
            var node = operationNodes[_i2];
            if (node.operation === operation) return node.type;
        }
        return undefined;
    }
    function $88e532994a71ff2b$var$validateDirectives(context) {
        for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
            var directive = _context$schema$getDi2[_i4];
            if (!(0, (0, parcelRequire("35Smo")).isDirective)(directive)) {
                context.reportError("Expected directive but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
                continue;
            }
            $88e532994a71ff2b$var$validateName(context, directive);
            for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                $88e532994a71ff2b$var$validateName(context, arg);
                if (!(0, (0, parcelRequire("8oLgk")).isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(arg.type), "."), arg.astNode);
                if ((0, (0, parcelRequire("8oLgk")).isRequiredArgument)(arg) && arg.deprecationReason != null) {
                    var _arg$astNode;
                    context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                        $88e532994a71ff2b$var$getDeprecatedDirectiveNode(arg.astNode),
                        (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                    ]);
                }
            }
        }
    }
    function $88e532994a71ff2b$var$validateName(context, node) {
        var error = (0, (0, parcelRequire("yHEIl")).isValidNameError)(node.name);
        if (error) context.addError((0, (0, parcelRequire("csEv9")).locatedError)(error, node.astNode));
    }
    function $88e532994a71ff2b$var$validateTypes(context) {
        var validateInputObjectCircularRefs = $88e532994a71ff2b$var$createInputObjectCircularRefsValidator(context);
        var typeMap = context.schema.getTypeMap();
        for(var _i8 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(typeMap); _i8 < _objectValues2.length; _i8++){
            var type = _objectValues2[_i8];
            if (!(0, (0, parcelRequire("8oLgk")).isNamedType)(type)) {
                context.reportError("Expected GraphQL named type but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(type), "."), type.astNode);
                continue;
            }
            if (!(0, (0, parcelRequire("4Hpke")).isIntrospectionType)(type)) $88e532994a71ff2b$var$validateName(context, type);
            if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type)) {
                $88e532994a71ff2b$var$validateFields(context, type);
                $88e532994a71ff2b$var$validateInterfaces(context, type);
            } else if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) {
                $88e532994a71ff2b$var$validateFields(context, type);
                $88e532994a71ff2b$var$validateInterfaces(context, type);
            } else if ((0, (0, parcelRequire("8oLgk")).isUnionType)(type)) $88e532994a71ff2b$var$validateUnionMembers(context, type);
            else if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) $88e532994a71ff2b$var$validateEnumValues(context, type);
            else if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
                $88e532994a71ff2b$var$validateInputFields(context, type);
                validateInputObjectCircularRefs(type);
            }
        }
    }
    function $88e532994a71ff2b$var$validateFields(context, type) {
        var fields = (0, (0, parcelRequire("isVmt")).default)(type.getFields());
        if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), $88e532994a71ff2b$var$getAllNodes(type));
        for(var _i10 = 0; _i10 < fields.length; _i10++){
            var field = fields[_i10];
            $88e532994a71ff2b$var$validateName(context, field);
            if (!(0, (0, parcelRequire("8oLgk")).isOutputType)(field.type)) {
                var _field$astNode;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
            }
            for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
                var arg = _field$args2[_i12];
                var argName = arg.name;
                $88e532994a71ff2b$var$validateName(context, arg);
                if (!(0, (0, parcelRequire("8oLgk")).isInputType)(arg.type)) {
                    var _arg$astNode2;
                    context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
                }
                if ((0, (0, parcelRequire("8oLgk")).isRequiredArgument)(arg) && arg.deprecationReason != null) {
                    var _arg$astNode3;
                    context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                        $88e532994a71ff2b$var$getDeprecatedDirectiveNode(arg.astNode),
                        (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                    ]);
                }
            }
        }
    }
    function $88e532994a71ff2b$var$validateInterfaces(context, type) {
        var ifaceTypeNames = Object.create(null);
        for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
            var iface = _type$getInterfaces2[_i14];
            if (!(0, (0, parcelRequire("8oLgk")).isInterfaceType)(iface)) {
                context.reportError("Type ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, (0, parcelRequire("yEDl8")).default)(iface), "."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
                continue;
            }
            if (type === iface) {
                context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
                continue;
            }
            if (ifaceTypeNames[iface.name]) {
                context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
                continue;
            }
            ifaceTypeNames[iface.name] = true;
            $88e532994a71ff2b$var$validateTypeImplementsAncestors(context, type, iface);
            $88e532994a71ff2b$var$validateTypeImplementsInterface(context, type, iface);
        }
    }
    function $88e532994a71ff2b$var$validateTypeImplementsInterface(context, type, iface) {
        var typeFieldMap = type.getFields();
        for(var _i16 = 0, _objectValues4 = (0, (0, parcelRequire("isVmt")).default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
            var ifaceField = _objectValues4[_i16];
            var fieldName = ifaceField.name;
            var typeField = typeFieldMap[fieldName];
            if (!typeField) {
                context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                    ifaceField.astNode
                ].concat($88e532994a71ff2b$var$getAllNodes(type)));
                continue;
            }
            if (!(0, (0, parcelRequire("9GswX")).isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
                var _ifaceField$astNode, _typeField$astNode;
                context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, (0, parcelRequire("yEDl8")).default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, (0, parcelRequire("yEDl8")).default)(typeField.type), "."), [
                    (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                    (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
                ]);
            }
            var _loop = function _loop(_i18, _ifaceField$args2) {
                var ifaceArg = _ifaceField$args2[_i18];
                var argName = ifaceArg.name;
                var typeArg = (0, (0, parcelRequire("85NSv")).default)(typeField.args, function(arg) {
                    return arg.name === argName;
                });
                if (!typeArg) {
                    context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                        ifaceArg.astNode,
                        typeField.astNode
                    ]);
                    return "continue";
                }
                if (!(0, (0, parcelRequire("9GswX")).isEqualType)(ifaceArg.type, typeArg.type)) {
                    var _ifaceArg$astNode, _typeArg$astNode;
                    context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, (0, parcelRequire("yEDl8")).default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, (0, parcelRequire("yEDl8")).default)(typeArg.type), "."), [
                        (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                        (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                    ]);
                }
            };
            for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
                var _ret = _loop(_i18, _ifaceField$args2);
                if (_ret === "continue") continue;
            }
            var _loop2 = function _loop2(_i20, _typeField$args2) {
                var typeArg = _typeField$args2[_i20];
                var argName = typeArg.name;
                var ifaceArg = (0, (0, parcelRequire("85NSv")).default)(ifaceField.args, function(arg) {
                    return arg.name === argName;
                });
                if (!ifaceArg && (0, (0, parcelRequire("8oLgk")).isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                    typeArg.astNode,
                    ifaceField.astNode
                ]);
            };
            for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
        }
    }
    function $88e532994a71ff2b$var$validateTypeImplementsAncestors(context, type, iface) {
        var ifaceInterfaces = type.getInterfaces();
        for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
            var transitive = _iface$getInterfaces2[_i22];
            if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat($88e532994a71ff2b$var$getAllImplementsInterfaceNodes(iface, transitive), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface)));
        }
    }
    function $88e532994a71ff2b$var$validateUnionMembers(context, union) {
        var memberTypes = union.getTypes();
        if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), $88e532994a71ff2b$var$getAllNodes(union));
        var includedTypeNames = Object.create(null);
        for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
            var memberType = memberTypes[_i24];
            if (includedTypeNames[memberType.name]) {
                context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, memberType.name));
                continue;
            }
            includedTypeNames[memberType.name] = true;
            if (!(0, (0, parcelRequire("8oLgk")).isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, (0, parcelRequire("yEDl8")).default)(memberType), "."), $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, String(memberType)));
        }
    }
    function $88e532994a71ff2b$var$validateEnumValues(context, enumType) {
        var enumValues = enumType.getValues();
        if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), $88e532994a71ff2b$var$getAllNodes(enumType));
        for(var _i26 = 0; _i26 < enumValues.length; _i26++){
            var enumValue = enumValues[_i26];
            var valueName = enumValue.name;
            $88e532994a71ff2b$var$validateName(context, enumValue);
            if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
        }
    }
    function $88e532994a71ff2b$var$validateInputFields(context, inputObj) {
        var fields = (0, (0, parcelRequire("isVmt")).default)(inputObj.getFields());
        if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), $88e532994a71ff2b$var$getAllNodes(inputObj));
        for(var _i28 = 0; _i28 < fields.length; _i28++){
            var field = fields[_i28];
            $88e532994a71ff2b$var$validateName(context, field);
            if (!(0, (0, parcelRequire("8oLgk")).isInputType)(field.type)) {
                var _field$astNode2;
                context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
            }
            if ((0, (0, parcelRequire("8oLgk")).isRequiredInputField)(field) && field.deprecationReason != null) {
                var _field$astNode3;
                context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                    $88e532994a71ff2b$var$getDeprecatedDirectiveNode(field.astNode),
                    (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
                ]);
            }
        }
    }
    function $88e532994a71ff2b$var$createInputObjectCircularRefsValidator(context) {
        var visitedTypes = Object.create(null);
        var fieldPath = [];
        var fieldPathIndexByTypeName = Object.create(null);
        return detectCycleRecursive;
        function detectCycleRecursive(inputObj) {
            if (visitedTypes[inputObj.name]) return;
            visitedTypes[inputObj.name] = true;
            fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
            var fields = (0, (0, parcelRequire("isVmt")).default)(inputObj.getFields());
            for(var _i30 = 0; _i30 < fields.length; _i30++){
                var field = fields[_i30];
                if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(field.type) && (0, (0, parcelRequire("8oLgk")).isInputObjectType)(field.type.ofType)) {
                    var fieldType = field.type.ofType;
                    var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                    fieldPath.push(field);
                    if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                    else {
                        var cyclePath = fieldPath.slice(cycleIndex);
                        var pathStr = cyclePath.map(function(fieldObj) {
                            return fieldObj.name;
                        }).join('.');
                        context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                            return fieldObj.astNode;
                        }));
                    }
                    fieldPath.pop();
                }
            }
            fieldPathIndexByTypeName[inputObj.name] = undefined;
        }
    }
    function $88e532994a71ff2b$var$getAllNodes(object) {
        var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
        return astNode ? extensionASTNodes ? [
            astNode
        ].concat(extensionASTNodes) : [
            astNode
        ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
    }
    function $88e532994a71ff2b$var$getAllSubNodes(object, getter) {
        var subNodes = [];
        for(var _i32 = 0, _getAllNodes2 = $88e532994a71ff2b$var$getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
            var _getter;
            var node = _getAllNodes2[_i32];
            subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
        }
        return subNodes;
    }
    function $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface) {
        return $88e532994a71ff2b$var$getAllSubNodes(type, function(typeNode) {
            return typeNode.interfaces;
        }).filter(function(ifaceNode) {
            return ifaceNode.name.value === iface.name;
        });
    }
    function $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, typeName) {
        return $88e532994a71ff2b$var$getAllSubNodes(union, function(unionNode) {
            return unionNode.types;
        }).filter(function(typeNode) {
            return typeNode.name.value === typeName;
        });
    }
    function $88e532994a71ff2b$var$getDeprecatedDirectiveNode(definitionNode) {
        var _definitionNode$direc;
        return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
            return node.name.value === (0, (0, parcelRequire("35Smo")).GraphQLDeprecatedDirective).name;
        });
    }
});
parcelRegister("85NSv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e457b17533127a2$export$2e2bcd8739ae039);
    var $5e457b17533127a2$var$find = Array.prototype.find ? function(list, predicate) {
        return Array.prototype.find.call(list, predicate);
    } : function(list, predicate) {
        for(var _i2 = 0; _i2 < list.length; _i2++){
            var value = list[_i2];
            if (predicate(value)) return value;
        }
    };
    var $5e457b17533127a2$export$2e2bcd8739ae039 = $5e457b17533127a2$var$find;
});
parcelRegister("isVmt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d717564e7dffc7e6$export$2e2bcd8739ae039);
    var $d717564e7dffc7e6$var$objectValues = Object.values || function(obj) {
        return Object.keys(obj).map(function(key) {
            return obj[key];
        });
    };
    var $d717564e7dffc7e6$export$2e2bcd8739ae039 = $d717564e7dffc7e6$var$objectValues;
});
parcelRegister("yHEIl", function(module, exports) {
    $parcel$export(module.exports, "isValidNameError", ()=>$06850a33089e598e$export$4ecdb5b419400d23);
    var $a1qmV;
    var $g5yZB;
    var $06850a33089e598e$var$NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
    function $06850a33089e598e$export$38c12a9ffd7a1417(name) {
        var error = $06850a33089e598e$export$4ecdb5b419400d23(name);
        if (error) throw error;
        return name;
    }
    function $06850a33089e598e$export$4ecdb5b419400d23(name) {
        typeof name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Expected name to be a string.');
        if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
        if (!$06850a33089e598e$var$NAME_RX.test(name)) return new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
    }
});
parcelRegister("9GswX", function(module, exports) {
    $parcel$export(module.exports, "isEqualType", ()=>$70ce2ade98c385c8$export$c8e484a9929e6d9f);
    $parcel$export(module.exports, "isTypeSubTypeOf", ()=>$70ce2ade98c385c8$export$c3f31adb68f3e853);
    $parcel$export(module.exports, "doTypesOverlap", ()=>$70ce2ade98c385c8$export$5e7a8ea86de754bd);
    var $8oLgk;
    function $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA, typeB) {
        if (typeA === typeB) return true;
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(typeA) && (0, (0, parcelRequire("8oLgk")).isNonNullType)(typeB)) return $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
        if ((0, (0, parcelRequire("8oLgk")).isListType)(typeA) && (0, (0, parcelRequire("8oLgk")).isListType)(typeB)) return $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
        return false;
    }
    function $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
        if (maybeSubType === superType) return true;
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(superType)) {
            if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(maybeSubType)) return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
            return false;
        }
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(maybeSubType)) return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
        if ((0, (0, parcelRequire("8oLgk")).isListType)(superType)) {
            if ((0, (0, parcelRequire("8oLgk")).isListType)(maybeSubType)) return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
            return false;
        }
        if ((0, (0, parcelRequire("8oLgk")).isListType)(maybeSubType)) return false;
        return (0, (0, parcelRequire("8oLgk")).isAbstractType)(superType) && ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(maybeSubType) || (0, (0, parcelRequire("8oLgk")).isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
    }
    function $70ce2ade98c385c8$export$5e7a8ea86de754bd(schema, typeA, typeB) {
        if (typeA === typeB) return true;
        if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(typeA)) {
            if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(typeB)) return schema.getPossibleTypes(typeA).some(function(type) {
                return schema.isSubType(typeB, type);
            });
            return schema.isSubType(typeA, typeB);
        }
        if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(typeB)) return schema.isSubType(typeB, typeA);
        return false;
    }
});
parcelRegister("8oLgk", function(module, exports) {
    $parcel$export(module.exports, "isType", ()=>$61d539f5c2a76fac$export$26b9f946b448f23e);
    $parcel$export(module.exports, "isScalarType", ()=>$61d539f5c2a76fac$export$5ef3b9aefb31c08b);
    $parcel$export(module.exports, "isObjectType", ()=>$61d539f5c2a76fac$export$f3091ca7b0907a5f);
    $parcel$export(module.exports, "isInterfaceType", ()=>$61d539f5c2a76fac$export$32fba5696fa641e);
    $parcel$export(module.exports, "isUnionType", ()=>$61d539f5c2a76fac$export$cca4caab5ef5a545);
    $parcel$export(module.exports, "isEnumType", ()=>$61d539f5c2a76fac$export$360fc30cf304623);
    $parcel$export(module.exports, "isInputObjectType", ()=>$61d539f5c2a76fac$export$594edc80cf154b94);
    $parcel$export(module.exports, "isListType", ()=>$61d539f5c2a76fac$export$f1003c1e9d4b008c);
    $parcel$export(module.exports, "isNonNullType", ()=>$61d539f5c2a76fac$export$146b6508fa0d6c82);
    $parcel$export(module.exports, "GraphQLScalarType", ()=>$61d539f5c2a76fac$export$64842b98ea53a3c9);
    $parcel$export(module.exports, "GraphQLObjectType", ()=>$61d539f5c2a76fac$export$375d3757a19c2e6e);
    $parcel$export(module.exports, "assertObjectType", ()=>$61d539f5c2a76fac$export$37a13eb12fbf3bc7);
    $parcel$export(module.exports, "GraphQLInterfaceType", ()=>$61d539f5c2a76fac$export$148e92587b8bf1f9);
    $parcel$export(module.exports, "assertInterfaceType", ()=>$61d539f5c2a76fac$export$b0fa8729bfe4811b);
    $parcel$export(module.exports, "GraphQLUnionType", ()=>$61d539f5c2a76fac$export$33c479b4c3812d0b);
    $parcel$export(module.exports, "GraphQLEnumType", ()=>$61d539f5c2a76fac$export$2577fb93f8748953);
    $parcel$export(module.exports, "GraphQLInputObjectType", ()=>$61d539f5c2a76fac$export$ea29baa44b9fd772);
    $parcel$export(module.exports, "GraphQLList", ()=>$61d539f5c2a76fac$export$de552006a6243367);
    $parcel$export(module.exports, "GraphQLNonNull", ()=>$61d539f5c2a76fac$export$ea3122a3d819ac9d);
    $parcel$export(module.exports, "isInputType", ()=>$61d539f5c2a76fac$export$1e617af703572bb5);
    $parcel$export(module.exports, "isOutputType", ()=>$61d539f5c2a76fac$export$27aadee607de5794);
    $parcel$export(module.exports, "isLeafType", ()=>$61d539f5c2a76fac$export$b390adabc64bab3);
    $parcel$export(module.exports, "isCompositeType", ()=>$61d539f5c2a76fac$export$3d8f0e61f2e75bb0);
    $parcel$export(module.exports, "isAbstractType", ()=>$61d539f5c2a76fac$export$6ea44a810dec4ac5);
    $parcel$export(module.exports, "assertNullableType", ()=>$61d539f5c2a76fac$export$9c6e9b78e1767de4);
    $parcel$export(module.exports, "getNullableType", ()=>$61d539f5c2a76fac$export$88b885687e78334b);
    $parcel$export(module.exports, "isNamedType", ()=>$61d539f5c2a76fac$export$f99194494d5b1a26);
    $parcel$export(module.exports, "getNamedType", ()=>$61d539f5c2a76fac$export$e6cd8ba67f39ede0);
    $parcel$export(module.exports, "argsToArgsConfig", ()=>$61d539f5c2a76fac$export$ae5ade30c645f6fd);
    $parcel$export(module.exports, "isRequiredArgument", ()=>$61d539f5c2a76fac$export$caef08b21560291a);
    $parcel$export(module.exports, "isRequiredInputField", ()=>$61d539f5c2a76fac$export$2657dcc79c2b6229);
    var $ge05d;
    var $6DBwa;
    var $yEDl8;
    var $aRWmX;
    var $eqSe6;
    var $2mUbt;
    var $a1qmV;
    var $2gSpW;
    var $6B4dU;
    var $h4f6N;
    var $cJPdE;
    var $frao6;
    var $520Pd;
    var $gXVhx;
    var $g5yZB;
    var $bzIlO;
    var $1c8Um;
    var $ccOQ3;
    function $61d539f5c2a76fac$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $61d539f5c2a76fac$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $61d539f5c2a76fac$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $61d539f5c2a76fac$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function $61d539f5c2a76fac$export$26b9f946b448f23e(type) {
        return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type) || $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) || $61d539f5c2a76fac$export$146b6508fa0d6c82(type);
    }
    function $61d539f5c2a76fac$export$804de46662e4ac95(type) {
        if (!$61d539f5c2a76fac$export$26b9f946b448f23e(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL type."));
        return type;
    }
    function $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$64842b98ea53a3c9);
    }
    function $61d539f5c2a76fac$export$6bfb69547e804cfa(type) {
        if (!$61d539f5c2a76fac$export$5ef3b9aefb31c08b(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Scalar type."));
        return type;
    }
    function $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$375d3757a19c2e6e);
    }
    function $61d539f5c2a76fac$export$37a13eb12fbf3bc7(type) {
        if (!$61d539f5c2a76fac$export$f3091ca7b0907a5f(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Object type."));
        return type;
    }
    function $61d539f5c2a76fac$export$32fba5696fa641e(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$148e92587b8bf1f9);
    }
    function $61d539f5c2a76fac$export$b0fa8729bfe4811b(type) {
        if (!$61d539f5c2a76fac$export$32fba5696fa641e(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Interface type."));
        return type;
    }
    function $61d539f5c2a76fac$export$cca4caab5ef5a545(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$33c479b4c3812d0b);
    }
    function $61d539f5c2a76fac$export$fd1fc643145b79aa(type) {
        if (!$61d539f5c2a76fac$export$cca4caab5ef5a545(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Union type."));
        return type;
    }
    function $61d539f5c2a76fac$export$360fc30cf304623(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$2577fb93f8748953);
    }
    function $61d539f5c2a76fac$export$152b058be1610b0e(type) {
        if (!$61d539f5c2a76fac$export$360fc30cf304623(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Enum type."));
        return type;
    }
    function $61d539f5c2a76fac$export$594edc80cf154b94(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$ea29baa44b9fd772);
    }
    function $61d539f5c2a76fac$export$d3177a47c4ed448a(type) {
        if (!$61d539f5c2a76fac$export$594edc80cf154b94(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Input Object type."));
        return type;
    }
    function $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$de552006a6243367);
    }
    function $61d539f5c2a76fac$export$a4a2309317558e91(type) {
        if (!$61d539f5c2a76fac$export$f1003c1e9d4b008c(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL List type."));
        return type;
    }
    function $61d539f5c2a76fac$export$146b6508fa0d6c82(type) {
        return (0, (0, parcelRequire("6B4dU")).default)(type, $61d539f5c2a76fac$export$ea3122a3d819ac9d);
    }
    function $61d539f5c2a76fac$export$4c0a7702e4a2acc9(type) {
        if (!$61d539f5c2a76fac$export$146b6508fa0d6c82(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL Non-Null type."));
        return type;
    }
    function $61d539f5c2a76fac$export$1e617af703572bb5(type) {
        return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type) || $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) && $61d539f5c2a76fac$export$1e617af703572bb5(type.ofType);
    }
    function $61d539f5c2a76fac$export$6e3e8b9b85427518(type) {
        if (!$61d539f5c2a76fac$export$1e617af703572bb5(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL input type."));
        return type;
    }
    function $61d539f5c2a76fac$export$27aadee607de5794(type) {
        return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) && $61d539f5c2a76fac$export$27aadee607de5794(type.ofType);
    }
    function $61d539f5c2a76fac$export$3efb5e473c31d62b(type) {
        if (!$61d539f5c2a76fac$export$27aadee607de5794(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL output type."));
        return type;
    }
    function $61d539f5c2a76fac$export$b390adabc64bab3(type) {
        return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$360fc30cf304623(type);
    }
    function $61d539f5c2a76fac$export$2bb5b8127c27d0cc(type) {
        if (!$61d539f5c2a76fac$export$b390adabc64bab3(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL leaf type."));
        return type;
    }
    function $61d539f5c2a76fac$export$3d8f0e61f2e75bb0(type) {
        return $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type);
    }
    function $61d539f5c2a76fac$export$5b55b276a74cf725(type) {
        if (!$61d539f5c2a76fac$export$3d8f0e61f2e75bb0(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL composite type."));
        return type;
    }
    function $61d539f5c2a76fac$export$6ea44a810dec4ac5(type) {
        return $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type);
    }
    function $61d539f5c2a76fac$export$d7092fd91c1fbaf8(type) {
        if (!$61d539f5c2a76fac$export$6ea44a810dec4ac5(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL abstract type."));
        return type;
    }
    function $61d539f5c2a76fac$export$de552006a6243367(ofType) {
        if (this instanceof $61d539f5c2a76fac$export$de552006a6243367) this.ofType = $61d539f5c2a76fac$export$804de46662e4ac95(ofType);
        else return new $61d539f5c2a76fac$export$de552006a6243367(ofType);
    }
    $61d539f5c2a76fac$export$de552006a6243367.prototype.toString = function toString() {
        return '[' + String(this.ofType) + ']';
    };
    $61d539f5c2a76fac$export$de552006a6243367.prototype.toJSON = function toJSON() {
        return this.toString();
    };
    Object.defineProperty($61d539f5c2a76fac$export$de552006a6243367.prototype, (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG), {
        get: function get() {
            return 'GraphQLList';
        }
    });
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$de552006a6243367);
    function $61d539f5c2a76fac$export$ea3122a3d819ac9d(ofType) {
        if (this instanceof $61d539f5c2a76fac$export$ea3122a3d819ac9d) this.ofType = $61d539f5c2a76fac$export$9c6e9b78e1767de4(ofType);
        else return new $61d539f5c2a76fac$export$ea3122a3d819ac9d(ofType);
    }
    $61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype.toString = function toString() {
        return String(this.ofType) + '!';
    };
    $61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype.toJSON = function toJSON() {
        return this.toString();
    };
    Object.defineProperty($61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype, (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG), {
        get: function get() {
            return 'GraphQLNonNull';
        }
    });
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$ea3122a3d819ac9d);
    function $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) {
        return $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) || $61d539f5c2a76fac$export$146b6508fa0d6c82(type);
    }
    function $61d539f5c2a76fac$export$ee52e012d8d583c6(type) {
        if (!$61d539f5c2a76fac$export$2dbe78c78d9c62bb(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL wrapping type."));
        return type;
    }
    function $61d539f5c2a76fac$export$103e38848746832(type) {
        return $61d539f5c2a76fac$export$26b9f946b448f23e(type) && !$61d539f5c2a76fac$export$146b6508fa0d6c82(type);
    }
    function $61d539f5c2a76fac$export$9c6e9b78e1767de4(type) {
        if (!$61d539f5c2a76fac$export$103e38848746832(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL nullable type."));
        return type;
    }
    function $61d539f5c2a76fac$export$88b885687e78334b(type) {
        if (type) return $61d539f5c2a76fac$export$146b6508fa0d6c82(type) ? type.ofType : type;
    }
    function $61d539f5c2a76fac$export$f99194494d5b1a26(type) {
        return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type);
    }
    function $61d539f5c2a76fac$export$57234e7b640498aa(type) {
        if (!$61d539f5c2a76fac$export$f99194494d5b1a26(type)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(type), " to be a GraphQL named type."));
        return type;
    }
    function $61d539f5c2a76fac$export$e6cd8ba67f39ede0(type) {
        if (type) {
            var unwrappedType = type;
            while($61d539f5c2a76fac$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
            return unwrappedType;
        }
    }
    function $61d539f5c2a76fac$var$resolveThunk(thunk) {
        return typeof thunk === 'function' ? thunk() : thunk;
    }
    function $61d539f5c2a76fac$var$undefineIfEmpty(arr) {
        return arr && arr.length > 0 ? arr : undefined;
    }
    var $61d539f5c2a76fac$export$64842b98ea53a3c9 = function() {
        function GraphQLScalarType(config) {
            var _config$parseValue, _config$serialize, _config$parseLiteral;
            var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, (0, parcelRequire("frao6")).default);
            this.name = config.name;
            this.description = config.description;
            this.specifiedByUrl = config.specifiedByUrl;
            this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, (0, parcelRequire("frao6")).default);
            this.parseValue = parseValue;
            this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
                return parseValue((0, (0, parcelRequire("ccOQ3")).valueFromASTUntyped)(node, variables));
            };
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
            config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(config.specifiedByUrl), "."));
            config.serialize == null || typeof config.serialize === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
            if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
        }
        var _proto = GraphQLScalarType.prototype;
        _proto.toConfig = function toConfig() {
            var _this$extensionASTNod;
            return {
                name: this.name,
                description: this.description,
                specifiedByUrl: this.specifiedByUrl,
                serialize: this.serialize,
                parseValue: this.parseValue,
                parseLiteral: this.parseLiteral,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
            };
        };
        _proto.toString = function toString() {
            return this.name;
        };
        _proto.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLScalarType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLScalarType';
                }
            }
        ]);
        return GraphQLScalarType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$64842b98ea53a3c9);
    var $61d539f5c2a76fac$export$375d3757a19c2e6e = function() {
        function GraphQLObjectType(config) {
            this.name = config.name;
            this.description = config.description;
            this.isTypeOf = config.isTypeOf;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            this._fields = $61d539f5c2a76fac$var$defineFieldMap.bind(undefined, config);
            this._interfaces = $61d539f5c2a76fac$var$defineInterfaces.bind(undefined, config);
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
            config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(config.isTypeOf), "."));
        }
        var _proto2 = GraphQLObjectType.prototype;
        _proto2.getFields = function getFields() {
            if (typeof this._fields === 'function') this._fields = this._fields();
            return this._fields;
        };
        _proto2.getInterfaces = function getInterfaces() {
            if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
            return this._interfaces;
        };
        _proto2.toConfig = function toConfig() {
            return {
                name: this.name,
                description: this.description,
                interfaces: this.getInterfaces(),
                fields: $61d539f5c2a76fac$var$fieldsToFieldsConfig(this.getFields()),
                isTypeOf: this.isTypeOf,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: this.extensionASTNodes || []
            };
        };
        _proto2.toString = function toString() {
            return this.name;
        };
        _proto2.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLObjectType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLObjectType';
                }
            }
        ]);
        return GraphQLObjectType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$375d3757a19c2e6e);
    function $61d539f5c2a76fac$var$defineInterfaces(config) {
        var _resolveThunk;
        var interfaces = (_resolveThunk = $61d539f5c2a76fac$var$resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
        Array.isArray(interfaces) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
        return interfaces;
    }
    function $61d539f5c2a76fac$var$defineFieldMap(config) {
        var fieldMap = $61d539f5c2a76fac$var$resolveThunk(config.fields);
        $61d539f5c2a76fac$var$isPlainObj(fieldMap) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
        return (0, (0, parcelRequire("eqSe6")).default)(fieldMap, function(fieldConfig, fieldName) {
            var _fieldConfig$args;
            $61d539f5c2a76fac$var$isPlainObj(fieldConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
            !('isDeprecated' in fieldConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
            fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(fieldConfig.resolve), "."));
            var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
            $61d539f5c2a76fac$var$isPlainObj(argsConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
            var args = (0, (0, parcelRequire("ge05d")).default)(argsConfig).map(function(_ref) {
                var argName = _ref[0], argConfig = _ref[1];
                return {
                    name: argName,
                    description: argConfig.description,
                    type: argConfig.type,
                    defaultValue: argConfig.defaultValue,
                    deprecationReason: argConfig.deprecationReason,
                    extensions: argConfig.extensions && (0, (0, parcelRequire("2mUbt")).default)(argConfig.extensions),
                    astNode: argConfig.astNode
                };
            });
            return {
                name: fieldName,
                description: fieldConfig.description,
                type: fieldConfig.type,
                args: args,
                resolve: fieldConfig.resolve,
                subscribe: fieldConfig.subscribe,
                isDeprecated: fieldConfig.deprecationReason != null,
                deprecationReason: fieldConfig.deprecationReason,
                extensions: fieldConfig.extensions && (0, (0, parcelRequire("2mUbt")).default)(fieldConfig.extensions),
                astNode: fieldConfig.astNode
            };
        });
    }
    function $61d539f5c2a76fac$var$isPlainObj(obj) {
        return (0, (0, parcelRequire("cJPdE")).default)(obj) && !Array.isArray(obj);
    }
    function $61d539f5c2a76fac$var$fieldsToFieldsConfig(fields) {
        return (0, (0, parcelRequire("eqSe6")).default)(fields, function(field) {
            return {
                description: field.description,
                type: field.type,
                args: $61d539f5c2a76fac$export$ae5ade30c645f6fd(field.args),
                resolve: field.resolve,
                subscribe: field.subscribe,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
    }
    function $61d539f5c2a76fac$export$ae5ade30c645f6fd(args) {
        return (0, (0, parcelRequire("2gSpW")).default)(args, function(arg) {
            return arg.name;
        }, function(arg) {
            return {
                description: arg.description,
                type: arg.type,
                defaultValue: arg.defaultValue,
                deprecationReason: arg.deprecationReason,
                extensions: arg.extensions,
                astNode: arg.astNode
            };
        });
    }
    function $61d539f5c2a76fac$export$caef08b21560291a(arg) {
        return $61d539f5c2a76fac$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
    }
    var $61d539f5c2a76fac$export$148e92587b8bf1f9 = function() {
        function GraphQLInterfaceType(config) {
            this.name = config.name;
            this.description = config.description;
            this.resolveType = config.resolveType;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            this._fields = $61d539f5c2a76fac$var$defineFieldMap.bind(undefined, config);
            this._interfaces = $61d539f5c2a76fac$var$defineInterfaces.bind(undefined, config);
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
            config.resolveType == null || typeof config.resolveType === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(config.resolveType), "."));
        }
        var _proto3 = GraphQLInterfaceType.prototype;
        _proto3.getFields = function getFields() {
            if (typeof this._fields === 'function') this._fields = this._fields();
            return this._fields;
        };
        _proto3.getInterfaces = function getInterfaces() {
            if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
            return this._interfaces;
        };
        _proto3.toConfig = function toConfig() {
            var _this$extensionASTNod2;
            return {
                name: this.name,
                description: this.description,
                interfaces: this.getInterfaces(),
                fields: $61d539f5c2a76fac$var$fieldsToFieldsConfig(this.getFields()),
                resolveType: this.resolveType,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
            };
        };
        _proto3.toString = function toString() {
            return this.name;
        };
        _proto3.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLInterfaceType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLInterfaceType';
                }
            }
        ]);
        return GraphQLInterfaceType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$148e92587b8bf1f9);
    var $61d539f5c2a76fac$export$33c479b4c3812d0b = function() {
        function GraphQLUnionType(config) {
            this.name = config.name;
            this.description = config.description;
            this.resolveType = config.resolveType;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            this._types = $61d539f5c2a76fac$var$defineTypes.bind(undefined, config);
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
            config.resolveType == null || typeof config.resolveType === 'function' || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(config.resolveType), "."));
        }
        var _proto4 = GraphQLUnionType.prototype;
        _proto4.getTypes = function getTypes() {
            if (typeof this._types === 'function') this._types = this._types();
            return this._types;
        };
        _proto4.toConfig = function toConfig() {
            var _this$extensionASTNod3;
            return {
                name: this.name,
                description: this.description,
                types: this.getTypes(),
                resolveType: this.resolveType,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
            };
        };
        _proto4.toString = function toString() {
            return this.name;
        };
        _proto4.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLUnionType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLUnionType';
                }
            }
        ]);
        return GraphQLUnionType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$33c479b4c3812d0b);
    function $61d539f5c2a76fac$var$defineTypes(config) {
        var types = $61d539f5c2a76fac$var$resolveThunk(config.types);
        Array.isArray(types) || (0, (0, parcelRequire("a1qmV")).default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
        return types;
    }
    var $61d539f5c2a76fac$export$2577fb93f8748953 = function() {
        function GraphQLEnumType(config) {
            this.name = config.name;
            this.description = config.description;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            this._values = $61d539f5c2a76fac$var$defineEnumValues(this.name, config.values);
            this._valueLookup = new Map(this._values.map(function(enumValue) {
                return [
                    enumValue.value,
                    enumValue
                ];
            }));
            this._nameLookup = (0, (0, parcelRequire("aRWmX")).default)(this._values, function(value) {
                return value.name;
            });
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
        }
        var _proto5 = GraphQLEnumType.prototype;
        _proto5.getValues = function getValues() {
            return this._values;
        };
        _proto5.getValue = function getValue(name) {
            return this._nameLookup[name];
        };
        _proto5.serialize = function serialize(outputValue) {
            var enumValue = this._valueLookup.get(outputValue);
            if (enumValue === undefined) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, (0, parcelRequire("yEDl8")).default)(outputValue)));
            return enumValue.name;
        };
        _proto5.parseValue = function parseValue(inputValue) {
            if (typeof inputValue !== 'string') {
                var valueStr = (0, (0, parcelRequire("yEDl8")).default)(inputValue);
                throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, valueStr));
            }
            var enumValue = this.getValue(inputValue);
            if (enumValue == null) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, inputValue));
            return enumValue.value;
        };
        _proto5.parseLiteral = function parseLiteral(valueNode, _variables) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).ENUM) {
                var valueStr = (0, (0, parcelRequire("1c8Um")).print)(valueNode);
                throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, valueStr), valueNode);
            }
            var enumValue = this.getValue(valueNode.value);
            if (enumValue == null) {
                var _valueStr = (0, (0, parcelRequire("1c8Um")).print)(valueNode);
                throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, _valueStr), valueNode);
            }
            return enumValue.value;
        };
        _proto5.toConfig = function toConfig() {
            var _this$extensionASTNod4;
            var values = (0, (0, parcelRequire("2gSpW")).default)(this.getValues(), function(value) {
                return value.name;
            }, function(value) {
                return {
                    description: value.description,
                    value: value.value,
                    deprecationReason: value.deprecationReason,
                    extensions: value.extensions,
                    astNode: value.astNode
                };
            });
            return {
                name: this.name,
                description: this.description,
                values: values,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
            };
        };
        _proto5.toString = function toString() {
            return this.name;
        };
        _proto5.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLEnumType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLEnumType';
                }
            }
        ]);
        return GraphQLEnumType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$2577fb93f8748953);
    function $61d539f5c2a76fac$var$didYouMeanEnumValue(enumType, unknownValueStr) {
        var allNames = enumType.getValues().map(function(value) {
            return value.name;
        });
        var suggestedValues = (0, (0, parcelRequire("gXVhx")).default)(unknownValueStr, allNames);
        return (0, (0, parcelRequire("h4f6N")).default)('the enum value', suggestedValues);
    }
    function $61d539f5c2a76fac$var$defineEnumValues(typeName, valueMap) {
        $61d539f5c2a76fac$var$isPlainObj(valueMap) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(typeName, " values must be an object with value names as keys."));
        return (0, (0, parcelRequire("ge05d")).default)(valueMap).map(function(_ref2) {
            var valueName = _ref2[0], valueConfig = _ref2[1];
            $61d539f5c2a76fac$var$isPlainObj(valueConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(valueConfig), "."));
            !('isDeprecated' in valueConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
            return {
                name: valueName,
                description: valueConfig.description,
                value: valueConfig.value !== undefined ? valueConfig.value : valueName,
                isDeprecated: valueConfig.deprecationReason != null,
                deprecationReason: valueConfig.deprecationReason,
                extensions: valueConfig.extensions && (0, (0, parcelRequire("2mUbt")).default)(valueConfig.extensions),
                astNode: valueConfig.astNode
            };
        });
    }
    var $61d539f5c2a76fac$export$ea29baa44b9fd772 = function() {
        function GraphQLInputObjectType(config) {
            this.name = config.name;
            this.description = config.description;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
            this._fields = $61d539f5c2a76fac$var$defineInputFieldMap.bind(undefined, config);
            typeof config.name === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide name.');
        }
        var _proto6 = GraphQLInputObjectType.prototype;
        _proto6.getFields = function getFields() {
            if (typeof this._fields === 'function') this._fields = this._fields();
            return this._fields;
        };
        _proto6.toConfig = function toConfig() {
            var _this$extensionASTNod5;
            var fields = (0, (0, parcelRequire("eqSe6")).default)(this.getFields(), function(field) {
                return {
                    description: field.description,
                    type: field.type,
                    defaultValue: field.defaultValue,
                    deprecationReason: field.deprecationReason,
                    extensions: field.extensions,
                    astNode: field.astNode
                };
            });
            return {
                name: this.name,
                description: this.description,
                fields: fields,
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
            };
        };
        _proto6.toString = function toString() {
            return this.name;
        };
        _proto6.toJSON = function toJSON() {
            return this.toString();
        };
        $61d539f5c2a76fac$var$_createClass(GraphQLInputObjectType, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLInputObjectType';
                }
            }
        ]);
        return GraphQLInputObjectType;
    }();
    (0, (0, parcelRequire("520Pd")).default)($61d539f5c2a76fac$export$ea29baa44b9fd772);
    function $61d539f5c2a76fac$var$defineInputFieldMap(config) {
        var fieldMap = $61d539f5c2a76fac$var$resolveThunk(config.fields);
        $61d539f5c2a76fac$var$isPlainObj(fieldMap) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
        return (0, (0, parcelRequire("eqSe6")).default)(fieldMap, function(fieldConfig, fieldName) {
            !('resolve' in fieldConfig) || (0, (0, parcelRequire("a1qmV")).default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
            return {
                name: fieldName,
                description: fieldConfig.description,
                type: fieldConfig.type,
                defaultValue: fieldConfig.defaultValue,
                deprecationReason: fieldConfig.deprecationReason,
                extensions: fieldConfig.extensions && (0, (0, parcelRequire("2mUbt")).default)(fieldConfig.extensions),
                astNode: fieldConfig.astNode
            };
        });
    }
    function $61d539f5c2a76fac$export$2657dcc79c2b6229(field) {
        return $61d539f5c2a76fac$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
    }
});
parcelRegister("ge05d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcfe04aa44184a0f$export$2e2bcd8739ae039);
    var $bcfe04aa44184a0f$var$objectEntries = Object.entries || function(obj) {
        return Object.keys(obj).map(function(key) {
            return [
                key,
                obj[key]
            ];
        });
    };
    var $bcfe04aa44184a0f$export$2e2bcd8739ae039 = $bcfe04aa44184a0f$var$objectEntries;
});
parcelRegister("aRWmX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e9c21869d55a3eb$export$2e2bcd8739ae039);
    function $7e9c21869d55a3eb$export$2e2bcd8739ae039(list, keyFn) {
        return list.reduce(function(map, item) {
            map[keyFn(item)] = item;
            return map;
        }, Object.create(null));
    }
});
parcelRegister("eqSe6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a81d8e9dff162917$export$2e2bcd8739ae039);
    var $ge05d;
    function $a81d8e9dff162917$export$2e2bcd8739ae039(map, fn) {
        var result = Object.create(null);
        for(var _i2 = 0, _objectEntries2 = (0, (0, parcelRequire("ge05d")).default)(map); _i2 < _objectEntries2.length; _i2++){
            var _ref2 = _objectEntries2[_i2];
            var _key = _ref2[0];
            var _value = _ref2[1];
            result[_key] = fn(_value, _key);
        }
        return result;
    }
});
parcelRegister("2mUbt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b9937d6c2ec8989$export$2e2bcd8739ae039);
    var $ge05d;
    function $1b9937d6c2ec8989$export$2e2bcd8739ae039(obj) {
        if (Object.getPrototypeOf(obj) === null) return obj;
        var map = Object.create(null);
        for(var _i2 = 0, _objectEntries2 = (0, (0, parcelRequire("ge05d")).default)(obj); _i2 < _objectEntries2.length; _i2++){
            var _ref2 = _objectEntries2[_i2];
            var key = _ref2[0];
            var value = _ref2[1];
            map[key] = value;
        }
        return map;
    }
});
parcelRegister("2gSpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a774990d750550b$export$2e2bcd8739ae039);
    function $1a774990d750550b$export$2e2bcd8739ae039(list, keyFn, valFn) {
        return list.reduce(function(map, item) {
            map[keyFn(item)] = valFn(item);
            return map;
        }, Object.create(null));
    }
});
parcelRegister("h4f6N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ce87a84ef3a40e$export$2e2bcd8739ae039);
    var $c6ce87a84ef3a40e$var$MAX_SUGGESTIONS = 5;
    function $c6ce87a84ef3a40e$export$2e2bcd8739ae039(firstArg, secondArg) {
        var _ref = typeof firstArg === 'string' ? [
            firstArg,
            secondArg
        ] : [
            undefined,
            firstArg
        ], subMessage = _ref[0], suggestionsArg = _ref[1];
        var message = ' Did you mean ';
        if (subMessage) message += subMessage + ' ';
        var suggestions = suggestionsArg.map(function(x) {
            return "\"".concat(x, "\"");
        });
        switch(suggestions.length){
            case 0:
                return '';
            case 1:
                return message + suggestions[0] + '?';
            case 2:
                return message + suggestions[0] + ' or ' + suggestions[1] + '?';
        }
        var selected = suggestions.slice(0, $c6ce87a84ef3a40e$var$MAX_SUGGESTIONS);
        var lastItem = selected.pop();
        return message + selected.join(', ') + ', or ' + lastItem + '?';
    }
});
parcelRegister("frao6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3d16f6eadb525f2$export$2e2bcd8739ae039);
    function $b3d16f6eadb525f2$export$2e2bcd8739ae039(x) {
        return x;
    }
});
parcelRegister("gXVhx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c59e970258122f7e$export$2e2bcd8739ae039);
    var $Jh3Fc;
    function $c59e970258122f7e$export$2e2bcd8739ae039(input, options) {
        var optionsByDistance = Object.create(null);
        var lexicalDistance = new $c59e970258122f7e$var$LexicalDistance(input);
        var threshold = Math.floor(input.length * 0.4) + 1;
        for(var _i2 = 0; _i2 < options.length; _i2++){
            var option = options[_i2];
            var distance = lexicalDistance.measure(option, threshold);
            if (distance !== undefined) optionsByDistance[option] = distance;
        }
        return Object.keys(optionsByDistance).sort(function(a, b) {
            var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
            return distanceDiff !== 0 ? distanceDiff : (0, (0, parcelRequire("Jh3Fc")).default)(a, b);
        });
    }
    var $c59e970258122f7e$var$LexicalDistance = function() {
        function LexicalDistance(input) {
            this._input = input;
            this._inputLowerCase = input.toLowerCase();
            this._inputArray = $c59e970258122f7e$var$stringToArray(this._inputLowerCase);
            this._rows = [
                new Array(input.length + 1).fill(0),
                new Array(input.length + 1).fill(0),
                new Array(input.length + 1).fill(0)
            ];
        }
        var _proto = LexicalDistance.prototype;
        _proto.measure = function measure(option, threshold) {
            if (this._input === option) return 0;
            var optionLowerCase = option.toLowerCase();
            if (this._inputLowerCase === optionLowerCase) return 1;
            var a = $c59e970258122f7e$var$stringToArray(optionLowerCase);
            var b = this._inputArray;
            if (a.length < b.length) {
                var tmp = a;
                a = b;
                b = tmp;
            }
            var aLength = a.length;
            var bLength = b.length;
            if (aLength - bLength > threshold) return undefined;
            var rows = this._rows;
            for(var j = 0; j <= bLength; j++)rows[0][j] = j;
            for(var i = 1; i <= aLength; i++){
                var upRow = rows[(i - 1) % 3];
                var currentRow = rows[i % 3];
                var smallestCell = currentRow[0] = i;
                for(var _j = 1; _j <= bLength; _j++){
                    var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                    var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost);
                    if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                        var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                        currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                    }
                    if (currentCell < smallestCell) smallestCell = currentCell;
                    currentRow[_j] = currentCell;
                }
                if (smallestCell > threshold) return undefined;
            }
            var distance = rows[aLength % 3][bLength];
            return distance <= threshold ? distance : undefined;
        };
        return LexicalDistance;
    }();
    function $c59e970258122f7e$var$stringToArray(str) {
        var strLength = str.length;
        var array = new Array(strLength);
        for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
        return array;
    }
});
parcelRegister("Jh3Fc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08816f772b4485d9$export$2e2bcd8739ae039);
    function $08816f772b4485d9$export$2e2bcd8739ae039(aStr, bStr) {
        var aIdx = 0;
        var bIdx = 0;
        while(aIdx < aStr.length && bIdx < bStr.length){
            var aChar = aStr.charCodeAt(aIdx);
            var bChar = bStr.charCodeAt(bIdx);
            if ($08816f772b4485d9$var$isDigit(aChar) && $08816f772b4485d9$var$isDigit(bChar)) {
                var aNum = 0;
                do {
                    ++aIdx;
                    aNum = aNum * 10 + aChar - $08816f772b4485d9$var$DIGIT_0;
                    aChar = aStr.charCodeAt(aIdx);
                }while ($08816f772b4485d9$var$isDigit(aChar) && aNum > 0)
                var bNum = 0;
                do {
                    ++bIdx;
                    bNum = bNum * 10 + bChar - $08816f772b4485d9$var$DIGIT_0;
                    bChar = bStr.charCodeAt(bIdx);
                }while ($08816f772b4485d9$var$isDigit(bChar) && bNum > 0)
                if (aNum < bNum) return -1;
                if (aNum > bNum) return 1;
            } else {
                if (aChar < bChar) return -1;
                if (aChar > bChar) return 1;
                ++aIdx;
                ++bIdx;
            }
        }
        return aStr.length - bStr.length;
    }
    var $08816f772b4485d9$var$DIGIT_0 = 48;
    var $08816f772b4485d9$var$DIGIT_9 = 57;
    function $08816f772b4485d9$var$isDigit(code) {
        return !isNaN(code) && $08816f772b4485d9$var$DIGIT_0 <= code && code <= $08816f772b4485d9$var$DIGIT_9;
    }
});
parcelRegister("ccOQ3", function(module, exports) {
    $parcel$export(module.exports, "valueFromASTUntyped", ()=>$8e2e0a854baa24a1$export$448e0963aec9442f);
    var $yEDl8;
    var $fM9AB;
    var $2gSpW;
    var $bzIlO;
    function $8e2e0a854baa24a1$export$448e0963aec9442f(valueNode, variables) {
        switch(valueNode.kind){
            case (0, (0, parcelRequire("bzIlO")).Kind).NULL:
                return null;
            case (0, (0, parcelRequire("bzIlO")).Kind).INT:
                return parseInt(valueNode.value, 10);
            case (0, (0, parcelRequire("bzIlO")).Kind).FLOAT:
                return parseFloat(valueNode.value);
            case (0, (0, parcelRequire("bzIlO")).Kind).STRING:
            case (0, (0, parcelRequire("bzIlO")).Kind).ENUM:
            case (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN:
                return valueNode.value;
            case (0, (0, parcelRequire("bzIlO")).Kind).LIST:
                return valueNode.values.map(function(node) {
                    return $8e2e0a854baa24a1$export$448e0963aec9442f(node, variables);
                });
            case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT:
                return (0, (0, parcelRequire("2gSpW")).default)(valueNode.fields, function(field) {
                    return field.name.value;
                }, function(field) {
                    return $8e2e0a854baa24a1$export$448e0963aec9442f(field.value, variables);
                });
            case (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE:
                return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected value node: ' + (0, (0, parcelRequire("yEDl8")).default)(valueNode));
    }
});
parcelRegister("lUVCX", function(module, exports) {
    $parcel$export(module.exports, "GraphQLSchema", ()=>$ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b);
    $parcel$export(module.exports, "assertSchema", ()=>$ff4b878cb0d3aa2a$export$6554dabc0f90e0c3);
    var $85NSv;
    var $awIoQ;
    var $isVmt;
    var $6DBwa;
    var $yEDl8;
    var $2mUbt;
    var $a1qmV;
    var $6B4dU;
    var $cJPdE;
    var $4Hpke;
    var $35Smo;
    var $8oLgk;
    function $ff4b878cb0d3aa2a$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $ff4b878cb0d3aa2a$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $ff4b878cb0d3aa2a$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $ff4b878cb0d3aa2a$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function $ff4b878cb0d3aa2a$export$213e2a3e7c4f326e(schema) {
        return (0, (0, parcelRequire("6B4dU")).default)(schema, $ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b);
    }
    function $ff4b878cb0d3aa2a$export$6554dabc0f90e0c3(schema) {
        if (!$ff4b878cb0d3aa2a$export$213e2a3e7c4f326e(schema)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(schema), " to be a GraphQL schema."));
        return schema;
    }
    var $ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b = function() {
        function GraphQLSchema(config) {
            var _config$directives;
            this.__validationErrors = config.assumeValid === true ? [] : undefined;
            (0, (0, parcelRequire("cJPdE")).default)(config) || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide configuration object.');
            !config.types || Array.isArray(config.types) || (0, (0, parcelRequire("a1qmV")).default)(0, "\"types\" must be Array if provided but got: ".concat((0, (0, parcelRequire("yEDl8")).default)(config.types), "."));
            !config.directives || Array.isArray(config.directives) || (0, (0, parcelRequire("a1qmV")).default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, (0, parcelRequire("yEDl8")).default)(config.directives), "."));
            this.description = config.description;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            this.extensionASTNodes = config.extensionASTNodes;
            this._queryType = config.query;
            this._mutationType = config.mutation;
            this._subscriptionType = config.subscription;
            this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, (0, parcelRequire("35Smo")).specifiedDirectives);
            var allReferencedTypes = new Set(config.types);
            if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
                var type = _config$types2[_i2];
                allReferencedTypes.delete(type);
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(type, allReferencedTypes);
            }
            if (this._queryType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._queryType, allReferencedTypes);
            if (this._mutationType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
            if (this._subscriptionType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
            for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
                var directive = _this$_directives2[_i4];
                if ((0, (0, parcelRequire("35Smo")).isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                    var arg = _directive$args2[_i6];
                    $ff4b878cb0d3aa2a$var$collectReferencedTypes(arg.type, allReferencedTypes);
                }
            }
            $ff4b878cb0d3aa2a$var$collectReferencedTypes((0, (0, parcelRequire("4Hpke")).__Schema), allReferencedTypes);
            this._typeMap = Object.create(null);
            this._subTypeMap = Object.create(null);
            this._implementationsMap = Object.create(null);
            for(var _i8 = 0, _arrayFrom2 = (0, (0, parcelRequire("awIoQ")).default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
                var namedType = _arrayFrom2[_i8];
                if (namedType == null) continue;
                var typeName = namedType.name;
                typeName || (0, (0, parcelRequire("a1qmV")).default)(0, 'One of the provided types for building the Schema is missing a name.');
                if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
                this._typeMap[typeName] = namedType;
                if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(namedType)) for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                    var iface = _namedType$getInterfa2[_i10];
                    if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(iface)) {
                        var implementations = this._implementationsMap[iface.name];
                        if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                            objects: [],
                            interfaces: []
                        };
                        implementations.interfaces.push(namedType);
                    }
                }
                else if ((0, (0, parcelRequire("8oLgk")).isObjectType)(namedType)) for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                    var _iface = _namedType$getInterfa4[_i12];
                    if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(_iface)) {
                        var _implementations = this._implementationsMap[_iface.name];
                        if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                            objects: [],
                            interfaces: []
                        };
                        _implementations.objects.push(namedType);
                    }
                }
            }
        }
        var _proto = GraphQLSchema.prototype;
        _proto.getQueryType = function getQueryType() {
            return this._queryType;
        };
        _proto.getMutationType = function getMutationType() {
            return this._mutationType;
        };
        _proto.getSubscriptionType = function getSubscriptionType() {
            return this._subscriptionType;
        };
        _proto.getTypeMap = function getTypeMap() {
            return this._typeMap;
        };
        _proto.getType = function getType(name) {
            return this.getTypeMap()[name];
        };
        _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
            return (0, (0, parcelRequire("8oLgk")).isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
        };
        _proto.getImplementations = function getImplementations(interfaceType) {
            var implementations = this._implementationsMap[interfaceType.name];
            return implementations !== null && implementations !== void 0 ? implementations : {
                objects: [],
                interfaces: []
            };
        };
        _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
            return this.isSubType(abstractType, possibleType);
        };
        _proto.isSubType = function isSubType(abstractType, maybeSubType) {
            var map = this._subTypeMap[abstractType.name];
            if (map === undefined) {
                map = Object.create(null);
                if ((0, (0, parcelRequire("8oLgk")).isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                    var type = _abstractType$getType2[_i14];
                    map[type.name] = true;
                }
                else {
                    var implementations = this.getImplementations(abstractType);
                    for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                        var _type = _implementations$obje2[_i16];
                        map[_type.name] = true;
                    }
                    for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                        var _type2 = _implementations$inte2[_i18];
                        map[_type2.name] = true;
                    }
                }
                this._subTypeMap[abstractType.name] = map;
            }
            return map[maybeSubType.name] !== undefined;
        };
        _proto.getDirectives = function getDirectives() {
            return this._directives;
        };
        _proto.getDirective = function getDirective(name) {
            return (0, (0, parcelRequire("85NSv")).default)(this.getDirectives(), function(directive) {
                return directive.name === name;
            });
        };
        _proto.toConfig = function toConfig() {
            var _this$extensionASTNod;
            return {
                description: this.description,
                query: this.getQueryType(),
                mutation: this.getMutationType(),
                subscription: this.getSubscriptionType(),
                types: (0, (0, parcelRequire("isVmt")).default)(this.getTypeMap()),
                directives: this.getDirectives().slice(),
                extensions: this.extensions,
                astNode: this.astNode,
                extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
                assumeValid: this.__validationErrors !== undefined
            };
        };
        $ff4b878cb0d3aa2a$var$_createClass(GraphQLSchema, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLSchema';
                }
            }
        ]);
        return GraphQLSchema;
    }();
    function $ff4b878cb0d3aa2a$var$collectReferencedTypes(type, typeSet) {
        var namedType = (0, (0, parcelRequire("8oLgk")).getNamedType)(type);
        if (!typeSet.has(namedType)) {
            typeSet.add(namedType);
            if ((0, (0, parcelRequire("8oLgk")).isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
                var memberType = _namedType$getTypes2[_i20];
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(memberType, typeSet);
            }
            else if ((0, (0, parcelRequire("8oLgk")).isObjectType)(namedType) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(namedType)) {
                for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                    var interfaceType = _namedType$getInterfa6[_i22];
                    $ff4b878cb0d3aa2a$var$collectReferencedTypes(interfaceType, typeSet);
                }
                for(var _i24 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                    var field = _objectValues2[_i24];
                    $ff4b878cb0d3aa2a$var$collectReferencedTypes(field.type, typeSet);
                    for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                        var arg = _field$args2[_i26];
                        $ff4b878cb0d3aa2a$var$collectReferencedTypes(arg.type, typeSet);
                    }
                }
            } else if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, (0, parcelRequire("isVmt")).default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
                var _field = _objectValues4[_i28];
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(_field.type, typeSet);
            }
        }
        return typeSet;
    }
});
parcelRegister("awIoQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01fa4fd43d92a80a$export$2e2bcd8739ae039);
    var $6DBwa;
    var $01fa4fd43d92a80a$var$arrayFrom = Array.from || function(obj, mapFn, thisArg) {
        if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
        var iteratorMethod = obj[0, (0, parcelRequire("6DBwa")).SYMBOL_ITERATOR];
        if (typeof iteratorMethod === 'function') {
            var iterator = iteratorMethod.call(obj);
            var result = [];
            var step;
            for(var i = 0; !(step = iterator.next()).done; ++i){
                result.push(mapFn.call(thisArg, step.value, i));
                if (i > 9999999) throw new TypeError('Near-infinite iteration.');
            }
            return result;
        }
        var length = obj.length;
        if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
            var _result = [];
            for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
            return _result;
        }
        return [];
    };
    var $01fa4fd43d92a80a$export$2e2bcd8739ae039 = $01fa4fd43d92a80a$var$arrayFrom;
});
parcelRegister("4Hpke", function(module, exports) {
    $parcel$export(module.exports, "__Schema", ()=>$36bed2a2a1d2d06b$export$1f18df711f6fa0ac);
    $parcel$export(module.exports, "TypeKind", ()=>$36bed2a2a1d2d06b$export$c29cf3c48471da7c);
    $parcel$export(module.exports, "SchemaMetaFieldDef", ()=>$36bed2a2a1d2d06b$export$36ed059ad2080404);
    $parcel$export(module.exports, "TypeMetaFieldDef", ()=>$36bed2a2a1d2d06b$export$87a968d084148b61);
    $parcel$export(module.exports, "TypeNameMetaFieldDef", ()=>$36bed2a2a1d2d06b$export$b9c17490e825648e);
    $parcel$export(module.exports, "introspectionTypes", ()=>$36bed2a2a1d2d06b$export$560bc6e8f6d098f4);
    $parcel$export(module.exports, "isIntrospectionType", ()=>$36bed2a2a1d2d06b$export$e1862b156b15ce4f);
    var $isVmt;
    var $yEDl8;
    var $fM9AB;
    var $1c8Um;
    var $jADQJ;
    var $d1i3Z;
    var $djKly;
    var $8oLgk;
    var $36bed2a2a1d2d06b$export$1f18df711f6fa0ac = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__Schema',
        description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
        fields: function fields() {
            return {
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(schema) {
                        return schema.description;
                    }
                },
                types: {
                    description: 'A list of all types supported by this server.',
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7))),
                    resolve: function resolve(schema) {
                        return (0, (0, parcelRequire("isVmt")).default)(schema.getTypeMap());
                    }
                },
                queryType: {
                    description: 'The type that query operations will be rooted at.',
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                    resolve: function resolve(schema) {
                        return schema.getQueryType();
                    }
                },
                mutationType: {
                    description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                    type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                    resolve: function resolve(schema) {
                        return schema.getMutationType();
                    }
                },
                subscriptionType: {
                    description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                    type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                    resolve: function resolve(schema) {
                        return schema.getSubscriptionType();
                    }
                },
                directives: {
                    description: 'A list of all directives supported by this server.',
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$2492e8c5b8ba489f))),
                    resolve: function resolve(schema) {
                        return schema.getDirectives();
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$2492e8c5b8ba489f = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__Directive',
        description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
        fields: function fields() {
            return {
                name: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                    resolve: function resolve(directive) {
                        return directive.name;
                    }
                },
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(directive) {
                        return directive.description;
                    }
                },
                isRepeatable: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                    resolve: function resolve(directive) {
                        return directive.isRepeatable;
                    }
                },
                locations: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$70e870c5930737d1))),
                    resolve: function resolve(directive) {
                        return directive.locations;
                    }
                },
                args: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b))),
                    args: {
                        includeDeprecated: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                            defaultValue: false
                        }
                    },
                    resolve: function resolve(field, _ref) {
                        var includeDeprecated = _ref.includeDeprecated;
                        return includeDeprecated ? field.args : field.args.filter(function(arg) {
                            return arg.deprecationReason == null;
                        });
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$70e870c5930737d1 = new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
        name: '__DirectiveLocation',
        description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
        values: {
            QUERY: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).QUERY,
                description: 'Location adjacent to a query operation.'
            },
            MUTATION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).MUTATION,
                description: 'Location adjacent to a mutation operation.'
            },
            SUBSCRIPTION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SUBSCRIPTION,
                description: 'Location adjacent to a subscription operation.'
            },
            FIELD: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD,
                description: 'Location adjacent to a field.'
            },
            FRAGMENT_DEFINITION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_DEFINITION,
                description: 'Location adjacent to a fragment definition.'
            },
            FRAGMENT_SPREAD: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_SPREAD,
                description: 'Location adjacent to a fragment spread.'
            },
            INLINE_FRAGMENT: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INLINE_FRAGMENT,
                description: 'Location adjacent to an inline fragment.'
            },
            VARIABLE_DEFINITION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).VARIABLE_DEFINITION,
                description: 'Location adjacent to a variable definition.'
            },
            SCHEMA: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SCHEMA,
                description: 'Location adjacent to a schema definition.'
            },
            SCALAR: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SCALAR,
                description: 'Location adjacent to a scalar definition.'
            },
            OBJECT: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).OBJECT,
                description: 'Location adjacent to an object type definition.'
            },
            FIELD_DEFINITION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD_DEFINITION,
                description: 'Location adjacent to a field definition.'
            },
            ARGUMENT_DEFINITION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ARGUMENT_DEFINITION,
                description: 'Location adjacent to an argument definition.'
            },
            INTERFACE: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INTERFACE,
                description: 'Location adjacent to an interface definition.'
            },
            UNION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).UNION,
                description: 'Location adjacent to a union definition.'
            },
            ENUM: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ENUM,
                description: 'Location adjacent to an enum definition.'
            },
            ENUM_VALUE: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ENUM_VALUE,
                description: 'Location adjacent to an enum value definition.'
            },
            INPUT_OBJECT: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INPUT_OBJECT,
                description: 'Location adjacent to an input object type definition.'
            },
            INPUT_FIELD_DEFINITION: {
                value: (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INPUT_FIELD_DEFINITION,
                description: 'Location adjacent to an input object field definition.'
            }
        }
    });
    var $36bed2a2a1d2d06b$export$b46ca740abcddda7 = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__Type',
        description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
        fields: function fields() {
            return {
                kind: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$163610506c99e78f),
                    resolve: function resolve(type) {
                        if ((0, (0, parcelRequire("8oLgk")).isScalarType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.SCALAR;
                        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.OBJECT;
                        if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INTERFACE;
                        if ((0, (0, parcelRequire("8oLgk")).isUnionType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.UNION;
                        if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.ENUM;
                        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INPUT_OBJECT;
                        if ((0, (0, parcelRequire("8oLgk")).isListType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.LIST;
                        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.NON_NULL;
                        (0, (0, parcelRequire("fM9AB")).default)(0, "Unexpected type: \"".concat((0, (0, parcelRequire("yEDl8")).default)(type), "\"."));
                    }
                },
                name: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(type) {
                        return type.name !== undefined ? type.name : undefined;
                    }
                },
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(type) {
                        return type.description !== undefined ? type.description : undefined;
                    }
                },
                specifiedByUrl: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(obj) {
                        return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                    }
                },
                fields: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$c93780024e419b02)),
                    args: {
                        includeDeprecated: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                            defaultValue: false
                        }
                    },
                    resolve: function resolve(type, _ref2) {
                        var includeDeprecated = _ref2.includeDeprecated;
                        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) {
                            var fields = (0, (0, parcelRequire("isVmt")).default)(type.getFields());
                            return includeDeprecated ? fields : fields.filter(function(field) {
                                return field.deprecationReason == null;
                            });
                        }
                    }
                },
                interfaces: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7)),
                    resolve: function resolve(type) {
                        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) return type.getInterfaces();
                    }
                },
                possibleTypes: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7)),
                    resolve: function resolve(type, _args, _context, _ref3) {
                        var schema = _ref3.schema;
                        if ((0, (0, parcelRequire("8oLgk")).isAbstractType)(type)) return schema.getPossibleTypes(type);
                    }
                },
                enumValues: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b93e3441ec96b29a)),
                    args: {
                        includeDeprecated: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                            defaultValue: false
                        }
                    },
                    resolve: function resolve(type, _ref4) {
                        var includeDeprecated = _ref4.includeDeprecated;
                        if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) {
                            var values = type.getValues();
                            return includeDeprecated ? values : values.filter(function(field) {
                                return field.deprecationReason == null;
                            });
                        }
                    }
                },
                inputFields: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b)),
                    args: {
                        includeDeprecated: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                            defaultValue: false
                        }
                    },
                    resolve: function resolve(type, _ref5) {
                        var includeDeprecated = _ref5.includeDeprecated;
                        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
                            var values = (0, (0, parcelRequire("isVmt")).default)(type.getFields());
                            return includeDeprecated ? values : values.filter(function(field) {
                                return field.deprecationReason == null;
                            });
                        }
                    }
                },
                ofType: {
                    type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                    resolve: function resolve(type) {
                        return type.ofType !== undefined ? type.ofType : undefined;
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$c93780024e419b02 = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__Field',
        description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
        fields: function fields() {
            return {
                name: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                    resolve: function resolve(field) {
                        return field.name;
                    }
                },
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(field) {
                        return field.description;
                    }
                },
                args: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b))),
                    args: {
                        includeDeprecated: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                            defaultValue: false
                        }
                    },
                    resolve: function resolve(field, _ref6) {
                        var includeDeprecated = _ref6.includeDeprecated;
                        return includeDeprecated ? field.args : field.args.filter(function(arg) {
                            return arg.deprecationReason == null;
                        });
                    }
                },
                type: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                    resolve: function resolve(field) {
                        return field.type;
                    }
                },
                isDeprecated: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                    resolve: function resolve(field) {
                        return field.deprecationReason != null;
                    }
                },
                deprecationReason: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(field) {
                        return field.deprecationReason;
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$bc79df5a9719c05b = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__InputValue',
        description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
        fields: function fields() {
            return {
                name: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                    resolve: function resolve(inputValue) {
                        return inputValue.name;
                    }
                },
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(inputValue) {
                        return inputValue.description;
                    }
                },
                type: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                    resolve: function resolve(inputValue) {
                        return inputValue.type;
                    }
                },
                defaultValue: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    description: 'A GraphQL-formatted string representing the default value for this input value.',
                    resolve: function resolve(inputValue) {
                        var type = inputValue.type, defaultValue = inputValue.defaultValue;
                        var valueAST = (0, (0, parcelRequire("d1i3Z")).astFromValue)(defaultValue, type);
                        return valueAST ? (0, (0, parcelRequire("1c8Um")).print)(valueAST) : null;
                    }
                },
                isDeprecated: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                    resolve: function resolve(field) {
                        return field.deprecationReason != null;
                    }
                },
                deprecationReason: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(obj) {
                        return obj.deprecationReason;
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$b93e3441ec96b29a = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        name: '__EnumValue',
        description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
        fields: function fields() {
            return {
                name: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                    resolve: function resolve(enumValue) {
                        return enumValue.name;
                    }
                },
                description: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(enumValue) {
                        return enumValue.description;
                    }
                },
                isDeprecated: {
                    type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                    resolve: function resolve(enumValue) {
                        return enumValue.deprecationReason != null;
                    }
                },
                deprecationReason: {
                    type: (0, (0, parcelRequire("djKly")).GraphQLString),
                    resolve: function resolve(enumValue) {
                        return enumValue.deprecationReason;
                    }
                }
            };
        }
    });
    var $36bed2a2a1d2d06b$export$c29cf3c48471da7c = Object.freeze({
        SCALAR: 'SCALAR',
        OBJECT: 'OBJECT',
        INTERFACE: 'INTERFACE',
        UNION: 'UNION',
        ENUM: 'ENUM',
        INPUT_OBJECT: 'INPUT_OBJECT',
        LIST: 'LIST',
        NON_NULL: 'NON_NULL'
    });
    var $36bed2a2a1d2d06b$export$163610506c99e78f = new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
        name: '__TypeKind',
        description: 'An enum describing what kind of type a given `__Type` is.',
        values: {
            SCALAR: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.SCALAR,
                description: 'Indicates this type is a scalar.'
            },
            OBJECT: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.OBJECT,
                description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
            },
            INTERFACE: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INTERFACE,
                description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
            },
            UNION: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.UNION,
                description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
            },
            ENUM: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.ENUM,
                description: 'Indicates this type is an enum. `enumValues` is a valid field.'
            },
            INPUT_OBJECT: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INPUT_OBJECT,
                description: 'Indicates this type is an input object. `inputFields` is a valid field.'
            },
            LIST: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.LIST,
                description: 'Indicates this type is a list. `ofType` is a valid field.'
            },
            NON_NULL: {
                value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.NON_NULL,
                description: 'Indicates this type is a non-null. `ofType` is a valid field.'
            }
        }
    });
    var $36bed2a2a1d2d06b$export$36ed059ad2080404 = {
        name: '__schema',
        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($36bed2a2a1d2d06b$export$1f18df711f6fa0ac),
        description: 'Access the current type schema of this server.',
        args: [],
        resolve: function resolve(_source, _args, _context, _ref7) {
            var schema = _ref7.schema;
            return schema;
        },
        isDeprecated: false,
        deprecationReason: undefined,
        extensions: undefined,
        astNode: undefined
    };
    var $36bed2a2a1d2d06b$export$87a968d084148b61 = {
        name: '__type',
        type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
        description: 'Request the type information of a single type.',
        args: [
            {
                name: 'name',
                description: undefined,
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                defaultValue: undefined,
                deprecationReason: undefined,
                extensions: undefined,
                astNode: undefined
            }
        ],
        resolve: function resolve(_source, _ref8, _context, _ref9) {
            var name = _ref8.name;
            var schema = _ref9.schema;
            return schema.getType(name);
        },
        isDeprecated: false,
        deprecationReason: undefined,
        extensions: undefined,
        astNode: undefined
    };
    var $36bed2a2a1d2d06b$export$b9c17490e825648e = {
        name: '__typename',
        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
        description: 'The name of the current Object type at runtime.',
        args: [],
        resolve: function resolve(_source, _args, _context, _ref10) {
            var parentType = _ref10.parentType;
            return parentType.name;
        },
        isDeprecated: false,
        deprecationReason: undefined,
        extensions: undefined,
        astNode: undefined
    };
    var $36bed2a2a1d2d06b$export$560bc6e8f6d098f4 = Object.freeze([
        $36bed2a2a1d2d06b$export$1f18df711f6fa0ac,
        $36bed2a2a1d2d06b$export$2492e8c5b8ba489f,
        $36bed2a2a1d2d06b$export$70e870c5930737d1,
        $36bed2a2a1d2d06b$export$b46ca740abcddda7,
        $36bed2a2a1d2d06b$export$c93780024e419b02,
        $36bed2a2a1d2d06b$export$bc79df5a9719c05b,
        $36bed2a2a1d2d06b$export$b93e3441ec96b29a,
        $36bed2a2a1d2d06b$export$163610506c99e78f
    ]);
    function $36bed2a2a1d2d06b$export$e1862b156b15ce4f(type) {
        return $36bed2a2a1d2d06b$export$560bc6e8f6d098f4.some(function(_ref11) {
            var name = _ref11.name;
            return type.name === name;
        });
    }
});
parcelRegister("d1i3Z", function(module, exports) {
    $parcel$export(module.exports, "astFromValue", ()=>$97a9615c2db018a5$export$973c016b19737b40);
    var $eeEse;
    var $isVmt;
    var $yEDl8;
    var $fM9AB;
    var $cJPdE;
    var $iAT21;
    var $bzIlO;
    var $djKly;
    var $8oLgk;
    function $97a9615c2db018a5$export$973c016b19737b40(value, type) {
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) {
            var astValue = $97a9615c2db018a5$export$973c016b19737b40(value, type.ofType);
            if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, (0, parcelRequire("bzIlO")).Kind).NULL) return null;
            return astValue;
        }
        if (value === null) return {
            kind: (0, (0, parcelRequire("bzIlO")).Kind).NULL
        };
        if (value === undefined) return null;
        if ((0, (0, parcelRequire("8oLgk")).isListType)(type)) {
            var itemType = type.ofType;
            var items = (0, (0, parcelRequire("iAT21")).default)(value);
            if (items != null) {
                var valuesNodes = [];
                for(var _i2 = 0; _i2 < items.length; _i2++){
                    var item = items[_i2];
                    var itemNode = $97a9615c2db018a5$export$973c016b19737b40(item, itemType);
                    if (itemNode != null) valuesNodes.push(itemNode);
                }
                return {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).LIST,
                    values: valuesNodes
                };
            }
            return $97a9615c2db018a5$export$973c016b19737b40(value, itemType);
        }
        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
            if (!(0, (0, parcelRequire("cJPdE")).default)(value)) return null;
            var fieldNodes = [];
            for(var _i4 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
                var field = _objectValues2[_i4];
                var fieldValue = $97a9615c2db018a5$export$973c016b19737b40(value[field.name], field.type);
                if (fieldValue) fieldNodes.push({
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_FIELD,
                    name: {
                        kind: (0, (0, parcelRequire("bzIlO")).Kind).NAME,
                        value: field.name
                    },
                    value: fieldValue
                });
            }
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT,
                fields: fieldNodes
            };
        }
        if ((0, (0, parcelRequire("8oLgk")).isLeafType)(type)) {
            var serialized = type.serialize(value);
            if (serialized == null) return null;
            if (typeof serialized === 'boolean') return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN,
                value: serialized
            };
            if (typeof serialized === 'number' && (0, (0, parcelRequire("eeEse")).default)(serialized)) {
                var stringNum = String(serialized);
                return $97a9615c2db018a5$var$integerStringRegExp.test(stringNum) ? {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).INT,
                    value: stringNum
                } : {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).FLOAT,
                    value: stringNum
                };
            }
            if (typeof serialized === 'string') {
                if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) return {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).ENUM,
                    value: serialized
                };
                if (type === (0, (0, parcelRequire("djKly")).GraphQLID) && $97a9615c2db018a5$var$integerStringRegExp.test(serialized)) return {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).INT,
                    value: serialized
                };
                return {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).STRING,
                    value: serialized
                };
            }
            throw new TypeError("Cannot convert value to AST: ".concat((0, (0, parcelRequire("yEDl8")).default)(serialized), "."));
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected input type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
    }
    var $97a9615c2db018a5$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;
});
parcelRegister("eeEse", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5d1c0e1c384cc48$export$2e2bcd8739ae039);
    var $a5d1c0e1c384cc48$var$isFinitePolyfill = Number.isFinite || function(value) {
        return typeof value === 'number' && isFinite(value);
    };
    var $a5d1c0e1c384cc48$export$2e2bcd8739ae039 = $a5d1c0e1c384cc48$var$isFinitePolyfill;
});
parcelRegister("djKly", function(module, exports) {
    $parcel$export(module.exports, "GraphQLInt", ()=>$9b21002c0b481d2b$export$4d4383325330928b);
    $parcel$export(module.exports, "GraphQLFloat", ()=>$9b21002c0b481d2b$export$3b54cc45efb7ef0d);
    $parcel$export(module.exports, "GraphQLString", ()=>$9b21002c0b481d2b$export$bf00325280f7630c);
    $parcel$export(module.exports, "GraphQLBoolean", ()=>$9b21002c0b481d2b$export$bcd144a2158fe517);
    $parcel$export(module.exports, "GraphQLID", ()=>$9b21002c0b481d2b$export$530df982af95a879);
    $parcel$export(module.exports, "specifiedScalarTypes", ()=>$9b21002c0b481d2b$export$5df80378609411b9);
    $parcel$export(module.exports, "isSpecifiedScalarType", ()=>$9b21002c0b481d2b$export$5d6bb1cb0ae296ca);
    var $eeEse;
    var $bC0K0;
    var $yEDl8;
    var $cJPdE;
    var $bzIlO;
    var $1c8Um;
    var $g5yZB;
    var $8oLgk;
    var $9b21002c0b481d2b$var$MAX_INT = 2147483647;
    var $9b21002c0b481d2b$var$MIN_INT = -2147483648;
    function $9b21002c0b481d2b$var$serializeInt(outputValue) {
        var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
        if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
        var num = coercedValue;
        if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
        if (!(0, (0, parcelRequire("bC0K0")).default)(num)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Int cannot represent non-integer value: ".concat((0, (0, parcelRequire("yEDl8")).default)(coercedValue)));
        if (num > $9b21002c0b481d2b$var$MAX_INT || num < $9b21002c0b481d2b$var$MIN_INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, (0, parcelRequire("yEDl8")).default)(coercedValue));
        return num;
    }
    function $9b21002c0b481d2b$var$coerceInt(inputValue) {
        if (!(0, (0, parcelRequire("bC0K0")).default)(inputValue)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Int cannot represent non-integer value: ".concat((0, (0, parcelRequire("yEDl8")).default)(inputValue)));
        if (inputValue > $9b21002c0b481d2b$var$MAX_INT || inputValue < $9b21002c0b481d2b$var$MIN_INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
        return inputValue;
    }
    var $9b21002c0b481d2b$export$4d4383325330928b = new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
        name: 'Int',
        description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
        serialize: $9b21002c0b481d2b$var$serializeInt,
        parseValue: $9b21002c0b481d2b$var$coerceInt,
        parseLiteral: function parseLiteral(valueNode) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Int cannot represent non-integer value: ".concat((0, (0, parcelRequire("1c8Um")).print)(valueNode)), valueNode);
            var num = parseInt(valueNode.value, 10);
            if (num > $9b21002c0b481d2b$var$MAX_INT || num < $9b21002c0b481d2b$var$MIN_INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
            return num;
        }
    });
    function $9b21002c0b481d2b$var$serializeFloat(outputValue) {
        var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
        if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
        var num = coercedValue;
        if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
        if (!(0, (0, parcelRequire("eeEse")).default)(num)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Float cannot represent non numeric value: ".concat((0, (0, parcelRequire("yEDl8")).default)(coercedValue)));
        return num;
    }
    function $9b21002c0b481d2b$var$coerceFloat(inputValue) {
        if (!(0, (0, parcelRequire("eeEse")).default)(inputValue)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Float cannot represent non numeric value: ".concat((0, (0, parcelRequire("yEDl8")).default)(inputValue)));
        return inputValue;
    }
    var $9b21002c0b481d2b$export$3b54cc45efb7ef0d = new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
        name: 'Float',
        description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
        serialize: $9b21002c0b481d2b$var$serializeFloat,
        parseValue: $9b21002c0b481d2b$var$coerceFloat,
        parseLiteral: function parseLiteral(valueNode) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).FLOAT && valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Float cannot represent non numeric value: ".concat((0, (0, parcelRequire("1c8Um")).print)(valueNode)), valueNode);
            return parseFloat(valueNode.value);
        }
    });
    function $9b21002c0b481d2b$var$serializeObject(outputValue) {
        if ((0, (0, parcelRequire("cJPdE")).default)(outputValue)) {
            if (typeof outputValue.valueOf === 'function') {
                var valueOfResult = outputValue.valueOf();
                if (!(0, (0, parcelRequire("cJPdE")).default)(valueOfResult)) return valueOfResult;
            }
            if (typeof outputValue.toJSON === 'function') return outputValue.toJSON();
        }
        return outputValue;
    }
    function $9b21002c0b481d2b$var$serializeString(outputValue) {
        var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
        if (typeof coercedValue === 'string') return coercedValue;
        if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
        if ((0, (0, parcelRequire("eeEse")).default)(coercedValue)) return coercedValue.toString();
        throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("String cannot represent value: ".concat((0, (0, parcelRequire("yEDl8")).default)(outputValue)));
    }
    function $9b21002c0b481d2b$var$coerceString(inputValue) {
        if (typeof inputValue !== 'string') throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("String cannot represent a non string value: ".concat((0, (0, parcelRequire("yEDl8")).default)(inputValue)));
        return inputValue;
    }
    var $9b21002c0b481d2b$export$bf00325280f7630c = new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
        name: 'String',
        description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
        serialize: $9b21002c0b481d2b$var$serializeString,
        parseValue: $9b21002c0b481d2b$var$coerceString,
        parseLiteral: function parseLiteral(valueNode) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).STRING) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("String cannot represent a non string value: ".concat((0, (0, parcelRequire("1c8Um")).print)(valueNode)), valueNode);
            return valueNode.value;
        }
    });
    function $9b21002c0b481d2b$var$serializeBoolean(outputValue) {
        var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
        if (typeof coercedValue === 'boolean') return coercedValue;
        if ((0, (0, parcelRequire("eeEse")).default)(coercedValue)) return coercedValue !== 0;
        throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, (0, parcelRequire("yEDl8")).default)(coercedValue)));
    }
    function $9b21002c0b481d2b$var$coerceBoolean(inputValue) {
        if (typeof inputValue !== 'boolean') throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, (0, parcelRequire("yEDl8")).default)(inputValue)));
        return inputValue;
    }
    var $9b21002c0b481d2b$export$bcd144a2158fe517 = new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
        name: 'Boolean',
        description: 'The `Boolean` scalar type represents `true` or `false`.',
        serialize: $9b21002c0b481d2b$var$serializeBoolean,
        parseValue: $9b21002c0b481d2b$var$coerceBoolean,
        parseLiteral: function parseLiteral(valueNode) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, (0, parcelRequire("1c8Um")).print)(valueNode)), valueNode);
            return valueNode.value;
        }
    });
    function $9b21002c0b481d2b$var$serializeID(outputValue) {
        var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
        if (typeof coercedValue === 'string') return coercedValue;
        if ((0, (0, parcelRequire("bC0K0")).default)(coercedValue)) return String(coercedValue);
        throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("ID cannot represent value: ".concat((0, (0, parcelRequire("yEDl8")).default)(outputValue)));
    }
    function $9b21002c0b481d2b$var$coerceID(inputValue) {
        if (typeof inputValue === 'string') return inputValue;
        if ((0, (0, parcelRequire("bC0K0")).default)(inputValue)) return inputValue.toString();
        throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("ID cannot represent value: ".concat((0, (0, parcelRequire("yEDl8")).default)(inputValue)));
    }
    var $9b21002c0b481d2b$export$530df982af95a879 = new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
        name: 'ID',
        description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
        serialize: $9b21002c0b481d2b$var$serializeID,
        parseValue: $9b21002c0b481d2b$var$coerceID,
        parseLiteral: function parseLiteral(valueNode) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).STRING && valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).INT) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, (0, parcelRequire("1c8Um")).print)(valueNode), valueNode);
            return valueNode.value;
        }
    });
    var $9b21002c0b481d2b$export$5df80378609411b9 = Object.freeze([
        $9b21002c0b481d2b$export$bf00325280f7630c,
        $9b21002c0b481d2b$export$4d4383325330928b,
        $9b21002c0b481d2b$export$3b54cc45efb7ef0d,
        $9b21002c0b481d2b$export$bcd144a2158fe517,
        $9b21002c0b481d2b$export$530df982af95a879
    ]);
    function $9b21002c0b481d2b$export$5d6bb1cb0ae296ca(type) {
        return $9b21002c0b481d2b$export$5df80378609411b9.some(function(_ref) {
            var name = _ref.name;
            return type.name === name;
        });
    }
});
parcelRegister("bC0K0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8743d1790da9a0f5$export$2e2bcd8739ae039);
    var $8743d1790da9a0f5$var$isInteger = Number.isInteger || function(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
    var $8743d1790da9a0f5$export$2e2bcd8739ae039 = $8743d1790da9a0f5$var$isInteger;
});
parcelRegister("35Smo", function(module, exports) {
    $parcel$export(module.exports, "isDirective", ()=>$240c01893cbc0376$export$4b5d79f26e0e3ad5);
    $parcel$export(module.exports, "GraphQLDirective", ()=>$240c01893cbc0376$export$90407e48aac654e9);
    $parcel$export(module.exports, "GraphQLIncludeDirective", ()=>$240c01893cbc0376$export$f92fb5dbf075dbee);
    $parcel$export(module.exports, "GraphQLSkipDirective", ()=>$240c01893cbc0376$export$7adbe9be7084cfe3);
    $parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", ()=>$240c01893cbc0376$export$15edbda76f1f9a89);
    $parcel$export(module.exports, "GraphQLDeprecatedDirective", ()=>$240c01893cbc0376$export$ed64f8040ac801d1);
    $parcel$export(module.exports, "GraphQLSpecifiedByDirective", ()=>$240c01893cbc0376$export$26ce3cf10bb75d41);
    $parcel$export(module.exports, "specifiedDirectives", ()=>$240c01893cbc0376$export$c48d2e3f4e034403);
    $parcel$export(module.exports, "isSpecifiedDirective", ()=>$240c01893cbc0376$export$7d2e48434602f4fe);
    var $ge05d;
    var $6DBwa;
    var $yEDl8;
    var $2mUbt;
    var $a1qmV;
    var $6B4dU;
    var $cJPdE;
    var $520Pd;
    var $jADQJ;
    var $djKly;
    var $8oLgk;
    function $240c01893cbc0376$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $240c01893cbc0376$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $240c01893cbc0376$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $240c01893cbc0376$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function $240c01893cbc0376$export$4b5d79f26e0e3ad5(directive) {
        return (0, (0, parcelRequire("6B4dU")).default)(directive, $240c01893cbc0376$export$90407e48aac654e9);
    }
    function $240c01893cbc0376$export$976bef3b79eaee5d(directive) {
        if (!$240c01893cbc0376$export$4b5d79f26e0e3ad5(directive)) throw new Error("Expected ".concat((0, (0, parcelRequire("yEDl8")).default)(directive), " to be a GraphQL directive."));
        return directive;
    }
    var $240c01893cbc0376$export$90407e48aac654e9 = function() {
        function GraphQLDirective(config) {
            var _config$isRepeatable, _config$args;
            this.name = config.name;
            this.description = config.description;
            this.locations = config.locations;
            this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
            this.extensions = config.extensions && (0, (0, parcelRequire("2mUbt")).default)(config.extensions);
            this.astNode = config.astNode;
            config.name || (0, (0, parcelRequire("a1qmV")).default)(0, 'Directive must be named.');
            Array.isArray(config.locations) || (0, (0, parcelRequire("a1qmV")).default)(0, "@".concat(config.name, " locations must be an Array."));
            var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
            (0, (0, parcelRequire("cJPdE")).default)(args) && !Array.isArray(args) || (0, (0, parcelRequire("a1qmV")).default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
            this.args = (0, (0, parcelRequire("ge05d")).default)(args).map(function(_ref) {
                var argName = _ref[0], argConfig = _ref[1];
                return {
                    name: argName,
                    description: argConfig.description,
                    type: argConfig.type,
                    defaultValue: argConfig.defaultValue,
                    deprecationReason: argConfig.deprecationReason,
                    extensions: argConfig.extensions && (0, (0, parcelRequire("2mUbt")).default)(argConfig.extensions),
                    astNode: argConfig.astNode
                };
            });
        }
        var _proto = GraphQLDirective.prototype;
        _proto.toConfig = function toConfig() {
            return {
                name: this.name,
                description: this.description,
                locations: this.locations,
                args: (0, (0, parcelRequire("8oLgk")).argsToArgsConfig)(this.args),
                isRepeatable: this.isRepeatable,
                extensions: this.extensions,
                astNode: this.astNode
            };
        };
        _proto.toString = function toString() {
            return '@' + this.name;
        };
        _proto.toJSON = function toJSON() {
            return this.toString();
        };
        $240c01893cbc0376$var$_createClass(GraphQLDirective, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'GraphQLDirective';
                }
            }
        ]);
        return GraphQLDirective;
    }();
    (0, (0, parcelRequire("520Pd")).default)($240c01893cbc0376$export$90407e48aac654e9);
    var $240c01893cbc0376$export$f92fb5dbf075dbee = new $240c01893cbc0376$export$90407e48aac654e9({
        name: 'include',
        description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
        locations: [
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_SPREAD,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INLINE_FRAGMENT
        ],
        args: {
            if: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                description: 'Included when true.'
            }
        }
    });
    var $240c01893cbc0376$export$7adbe9be7084cfe3 = new $240c01893cbc0376$export$90407e48aac654e9({
        name: 'skip',
        description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
        locations: [
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_SPREAD,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INLINE_FRAGMENT
        ],
        args: {
            if: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean)),
                description: 'Skipped when true.'
            }
        }
    });
    var $240c01893cbc0376$export$15edbda76f1f9a89 = 'No longer supported';
    var $240c01893cbc0376$export$ed64f8040ac801d1 = new $240c01893cbc0376$export$90407e48aac654e9({
        name: 'deprecated',
        description: 'Marks an element of a GraphQL schema as no longer supported.',
        locations: [
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD_DEFINITION,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ARGUMENT_DEFINITION,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INPUT_FIELD_DEFINITION,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ENUM_VALUE
        ],
        args: {
            reason: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString),
                description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
                defaultValue: $240c01893cbc0376$export$15edbda76f1f9a89
            }
        }
    });
    var $240c01893cbc0376$export$26ce3cf10bb75d41 = new $240c01893cbc0376$export$90407e48aac654e9({
        name: 'specifiedBy',
        description: 'Exposes a URL that specifies the behaviour of this scalar.',
        locations: [
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SCALAR
        ],
        args: {
            url: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString)),
                description: 'The URL that specifies the behaviour of this scalar.'
            }
        }
    });
    var $240c01893cbc0376$export$c48d2e3f4e034403 = Object.freeze([
        $240c01893cbc0376$export$f92fb5dbf075dbee,
        $240c01893cbc0376$export$7adbe9be7084cfe3,
        $240c01893cbc0376$export$ed64f8040ac801d1,
        $240c01893cbc0376$export$26ce3cf10bb75d41
    ]);
    function $240c01893cbc0376$export$7d2e48434602f4fe(directive) {
        return $240c01893cbc0376$export$c48d2e3f4e034403.some(function(_ref2) {
            var name = _ref2.name;
            return name === directive.name;
        });
    }
});
parcelRegister("6D4Eu", function(module, exports) {
    $parcel$export(module.exports, "typeFromAST", ()=>$4d39fe60a5e10327$export$292685f75a322892);
    var $yEDl8;
    var $fM9AB;
    var $bzIlO;
    var $8oLgk;
    function $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode) {
        var innerType;
        if (typeNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).LIST_TYPE) {
            innerType = $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode.type);
            return innerType && new (0, (0, parcelRequire("8oLgk")).GraphQLList)(innerType);
        }
        if (typeNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).NON_NULL_TYPE) {
            innerType = $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode.type);
            return innerType && new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(innerType);
        }
        if (typeNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected type node: ' + (0, (0, parcelRequire("yEDl8")).default)(typeNode));
    }
});
parcelRegister("etM9Y", function(module, exports) {
    $parcel$export(module.exports, "getOperationRootType", ()=>$a8a921a61a378224$export$f5bcbf8a32f314e5);
    var $g5yZB;
    function $a8a921a61a378224$export$f5bcbf8a32f314e5(schema, operation) {
        if (operation.operation === 'query') {
            var queryType = schema.getQueryType();
            if (!queryType) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Schema does not define the required query root type.', operation);
            return queryType;
        }
        if (operation.operation === 'mutation') {
            var mutationType = schema.getMutationType();
            if (!mutationType) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Schema is not configured for mutations.', operation);
            return mutationType;
        }
        if (operation.operation === 'subscription') {
            var subscriptionType = schema.getSubscriptionType();
            if (!subscriptionType) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Schema is not configured for subscriptions.', operation);
            return subscriptionType;
        }
        throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Can only have query, mutation and subscription operations.', operation);
    }
});
parcelRegister("7dqoX", function(module, exports) {
    $parcel$export(module.exports, "getVariableValues", ()=>$540e3a190dcd969f$export$2038fbf5c9bccf57);
    $parcel$export(module.exports, "getArgumentValues", ()=>$540e3a190dcd969f$export$5af04a8495f7ef54);
    $parcel$export(module.exports, "getDirectiveValues", ()=>$540e3a190dcd969f$export$1f7174681493b2aa);
    var $85NSv;
    var $aRWmX;
    var $yEDl8;
    var $lnnuh;
    var $g5yZB;
    var $bzIlO;
    var $1c8Um;
    var $8oLgk;
    var $6D4Eu;
    var $9aGhX;
    var $7B3dt;
    function $540e3a190dcd969f$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
        var errors = [];
        var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
        try {
            var coerced = $540e3a190dcd969f$var$coerceVariableValues(schema, varDefNodes, inputs, function(error) {
                if (maxErrors != null && errors.length >= maxErrors) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
                errors.push(error);
            });
            if (errors.length === 0) return {
                coerced: coerced
            };
        } catch (error) {
            errors.push(error);
        }
        return {
            errors: errors
        };
    }
    function $540e3a190dcd969f$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
        var coercedValues = {};
        var _loop = function _loop(_i2) {
            var varDefNode = varDefNodes[_i2];
            var varName = varDefNode.variable.name.value;
            var varType = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(schema, varDefNode.type);
            if (!(0, (0, parcelRequire("8oLgk")).isInputType)(varType)) {
                var varTypeStr = (0, (0, parcelRequire("1c8Um")).print)(varDefNode.type);
                onError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
                return "continue";
            }
            if (!$540e3a190dcd969f$var$hasOwnProperty(inputs, varName)) {
                if (varDefNode.defaultValue) coercedValues[varName] = (0, (0, parcelRequire("9aGhX")).valueFromAST)(varDefNode.defaultValue, varType);
                else if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(varType)) {
                    var _varTypeStr = (0, (0, parcelRequire("yEDl8")).default)(varType);
                    onError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
                }
                return "continue";
            }
            var value = inputs[varName];
            if (value === null && (0, (0, parcelRequire("8oLgk")).isNonNullType)(varType)) {
                var _varTypeStr2 = (0, (0, parcelRequire("yEDl8")).default)(varType);
                onError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
                return "continue";
            }
            coercedValues[varName] = (0, (0, parcelRequire("7B3dt")).coerceInputValue)(value, varType, function(path, invalidValue, error) {
                var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, (0, parcelRequire("yEDl8")).default)(invalidValue);
                if (path.length > 0) prefix += " at \"".concat(varName).concat((0, (0, parcelRequire("lnnuh")).default)(path), "\"");
                onError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
            });
        };
        for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
            var _ret = _loop(_i2);
            if (_ret === "continue") continue;
        }
        return coercedValues;
    }
    function $540e3a190dcd969f$export$5af04a8495f7ef54(def, node, variableValues) {
        var _node$arguments;
        var coercedValues = {};
        var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
        var argNodeMap = (0, (0, parcelRequire("aRWmX")).default)(argumentNodes, function(arg) {
            return arg.name.value;
        });
        for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
            var argDef = _def$args2[_i4];
            var name = argDef.name;
            var argType = argDef.type;
            var argumentNode = argNodeMap[name];
            if (!argumentNode) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(argType)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, (0, parcelRequire("yEDl8")).default)(argType), "\" ") + 'was not provided.', node);
                continue;
            }
            var valueNode = argumentNode.value;
            var isNull = valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).NULL;
            if (valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE) {
                var variableName = valueNode.name.value;
                if (variableValues == null || !$540e3a190dcd969f$var$hasOwnProperty(variableValues, variableName)) {
                    if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                    else if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(argType)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, (0, parcelRequire("yEDl8")).default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                    continue;
                }
                isNull = variableValues[variableName] == null;
            }
            if (isNull && (0, (0, parcelRequire("8oLgk")).isNonNullType)(argType)) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, (0, parcelRequire("yEDl8")).default)(argType), "\" ") + 'must not be null.', valueNode);
            var coercedValue = (0, (0, parcelRequire("9aGhX")).valueFromAST)(valueNode, argType, variableValues);
            if (coercedValue === undefined) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, (0, parcelRequire("1c8Um")).print)(valueNode), "."), valueNode);
            coercedValues[name] = coercedValue;
        }
        return coercedValues;
    }
    function $540e3a190dcd969f$export$1f7174681493b2aa(directiveDef, node, variableValues) {
        var directiveNode = node.directives && (0, (0, parcelRequire("85NSv")).default)(node.directives, function(directive) {
            return directive.name.value === directiveDef.name;
        });
        if (directiveNode) return $540e3a190dcd969f$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
    }
    function $540e3a190dcd969f$var$hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
});
parcelRegister("lnnuh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8fdf7159fd2d5ff$export$2e2bcd8739ae039);
    function $f8fdf7159fd2d5ff$export$2e2bcd8739ae039(path) {
        return path.map(function(key) {
            return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
        }).join('');
    }
});
parcelRegister("9aGhX", function(module, exports) {
    $parcel$export(module.exports, "valueFromAST", ()=>$6ad5d9e2e202f145$export$d32bfdfcfbe60e55);
    var $isVmt;
    var $aRWmX;
    var $yEDl8;
    var $fM9AB;
    var $bzIlO;
    var $8oLgk;
    function $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, type, variables) {
        if (!valueNode) return;
        if (valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variables == null || variables[variableName] === undefined) return;
            var variableValue = variables[variableName];
            if (variableValue === null && (0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) return;
            return variableValue;
        }
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) {
            if (valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).NULL) return;
            return $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
        }
        if (valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).NULL) return null;
        if ((0, (0, parcelRequire("8oLgk")).isListType)(type)) {
            var itemType = type.ofType;
            if (valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).LIST) {
                var coercedValues = [];
                for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                    var itemNode = _valueNode$values2[_i2];
                    if ($6ad5d9e2e202f145$var$isMissingVariable(itemNode, variables)) {
                        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(itemType)) return;
                        coercedValues.push(null);
                    } else {
                        var itemValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                        if (itemValue === undefined) return;
                        coercedValues.push(itemValue);
                    }
                }
                return coercedValues;
            }
            var coercedValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
            if (coercedValue === undefined) return;
            return [
                coercedValue
            ];
        }
        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
            if (valueNode.kind !== (0, (0, parcelRequire("bzIlO")).Kind).OBJECT) return;
            var coercedObj = Object.create(null);
            var fieldNodes = (0, (0, parcelRequire("aRWmX")).default)(valueNode.fields, function(field) {
                return field.name.value;
            });
            for(var _i4 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
                var field = _objectValues2[_i4];
                var fieldNode = fieldNodes[field.name];
                if (!fieldNode || $6ad5d9e2e202f145$var$isMissingVariable(fieldNode.value, variables)) {
                    if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                    else if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(field.type)) return;
                    continue;
                }
                var fieldValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
                if (fieldValue === undefined) return;
                coercedObj[field.name] = fieldValue;
            }
            return coercedObj;
        }
        if ((0, (0, parcelRequire("8oLgk")).isLeafType)(type)) {
            var result;
            try {
                result = type.parseLiteral(valueNode, variables);
            } catch (_error) {
                return;
            }
            if (result === undefined) return;
            return result;
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected input type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
    }
    function $6ad5d9e2e202f145$var$isMissingVariable(valueNode, variables) {
        return valueNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
    }
});
parcelRegister("7B3dt", function(module, exports) {
    $parcel$export(module.exports, "coerceInputValue", ()=>$587e7bc9fafdbc8f$export$7964ec791f1fa3f1);
    var $isVmt;
    var $yEDl8;
    var $fM9AB;
    var $h4f6N;
    var $cJPdE;
    var $iAT21;
    var $gXVhx;
    var $lnnuh;
    var $hEo2F;
    var $g5yZB;
    var $8oLgk;
    function $587e7bc9fafdbc8f$export$7964ec791f1fa3f1(inputValue, type) {
        var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $587e7bc9fafdbc8f$var$defaultOnError;
        return $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type, onError);
    }
    function $587e7bc9fafdbc8f$var$defaultOnError(path, invalidValue, error) {
        var errorPrefix = 'Invalid value ' + (0, (0, parcelRequire("yEDl8")).default)(invalidValue);
        if (path.length > 0) errorPrefix += " at \"value".concat((0, (0, parcelRequire("lnnuh")).default)(path), "\"");
        error.message = errorPrefix + ': ' + error.message;
        throw error;
    }
    function $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type, onError, path) {
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) {
            if (inputValue != null) return $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
            onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected non-nullable type \"".concat((0, (0, parcelRequire("yEDl8")).default)(type), "\" not to be null.")));
            return;
        }
        if (inputValue == null) return null;
        if ((0, (0, parcelRequire("8oLgk")).isListType)(type)) {
            var itemType = type.ofType;
            var coercedList = (0, (0, parcelRequire("iAT21")).default)(inputValue, function(itemValue, index) {
                var itemPath = (0, (0, parcelRequire("hEo2F")).addPath)(path, index, undefined);
                return $587e7bc9fafdbc8f$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
            });
            if (coercedList != null) return coercedList;
            return [
                $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, itemType, onError, path)
            ];
        }
        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
            if (!(0, (0, parcelRequire("cJPdE")).default)(inputValue)) {
                onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
                return;
            }
            var coercedValue = {};
            var fieldDefs = type.getFields();
            for(var _i2 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
                var field = _objectValues2[_i2];
                var fieldValue = inputValue[field.name];
                if (fieldValue === undefined) {
                    if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                    else if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(field.type)) {
                        var typeStr = (0, (0, parcelRequire("yEDl8")).default)(field.type);
                        onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                    }
                    continue;
                }
                coercedValue[field.name] = $587e7bc9fafdbc8f$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, (0, parcelRequire("hEo2F")).addPath)(path, field.name, type.name));
            }
            for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
                var fieldName = _Object$keys2[_i4];
                if (!fieldDefs[fieldName]) {
                    var suggestions = (0, (0, parcelRequire("gXVhx")).default)(fieldName, Object.keys(type.getFields()));
                    onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, (0, parcelRequire("h4f6N")).default)(suggestions)));
                }
            }
            return coercedValue;
        }
        if ((0, (0, parcelRequire("8oLgk")).isLeafType)(type)) {
            var parseResult;
            try {
                parseResult = type.parseValue(inputValue);
            } catch (error) {
                if (error instanceof (0, (0, parcelRequire("g5yZB")).GraphQLError)) onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, error);
                else onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
                return;
            }
            if (parseResult === undefined) onError((0, (0, parcelRequire("hEo2F")).pathToArray)(path), inputValue, new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected type \"".concat(type.name, "\".")));
            return parseResult;
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected input type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
    }
});
parcelRegister("cKbwx", function(module, exports) {
    function $9472b847e3d286b8$var$__export(m) {
        for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
    }
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    $9472b847e3d286b8$var$__export((parcelRequire("gIDuj")));
    $9472b847e3d286b8$var$__export((parcelRequire("cCTSK")));
    $9472b847e3d286b8$var$__export((parcelRequire("h3H2i")));
    $9472b847e3d286b8$var$__export((parcelRequire("810gP")));
    var $48EbR = parcelRequire("48EbR");
    module.exports.SchemaDirectiveVisitor = $48EbR.SchemaDirectiveVisitor;
});
parcelRegister("gIDuj", function(module, exports) {
    function $c2bf62df9ea62751$var$__export(m) {
        for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
    }
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    var $48EbR = parcelRequire("48EbR");
    var $4Imtl = parcelRequire("4Imtl");
    function $c2bf62df9ea62751$var$makeExecutableSchema(_a) {
        var typeDefs = _a.typeDefs, _b = _a.resolvers, resolvers = _b === void 0 ? {} : _b, connectors = _a.connectors, logger = _a.logger, _c = _a.allowUndefinedInResolve, allowUndefinedInResolve = _c === void 0 ? true : _c, _d = _a.resolverValidationOptions, resolverValidationOptions = _d === void 0 ? {} : _d, _e = _a.directiveResolvers, directiveResolvers = _e === void 0 ? null : _e, _f = _a.schemaDirectives, schemaDirectives = _f === void 0 ? null : _f, _g = _a.parseOptions, parseOptions = _g === void 0 ? {} : _g, _h = _a.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _h === void 0 ? false : _h;
        if (typeof resolverValidationOptions !== 'object') throw new (parcelRequire("l9QLJ")).SchemaError('Expected `resolverValidationOptions` to be an object');
        if (!typeDefs) throw new (parcelRequire("l9QLJ")).SchemaError('Must provide typeDefs');
        if (!resolvers) throw new (parcelRequire("l9QLJ")).SchemaError('Must provide resolvers');
        var resolverMap = Array.isArray(resolvers) ? resolvers.filter(function(resolverObj) {
            return typeof resolverObj === 'object';
        }).reduce($4Imtl.default, {}) : resolvers;
        var schema = (parcelRequire("l9QLJ")).buildSchemaFromTypeDefinitions(typeDefs, parseOptions);
        schema = (parcelRequire("l9QLJ")).addResolveFunctionsToSchema({
            schema: schema,
            resolvers: resolverMap,
            resolverValidationOptions: resolverValidationOptions,
            inheritResolversFromInterfaces: inheritResolversFromInterfaces
        });
        (parcelRequire("l9QLJ")).assertResolveFunctionsPresent(schema, resolverValidationOptions);
        if (!allowUndefinedInResolve) $c2bf62df9ea62751$var$addCatchUndefinedToSchema(schema);
        if (logger) $c2bf62df9ea62751$var$addErrorLoggingToSchema(schema, logger);
        if (typeof resolvers['__schema'] === 'function') (parcelRequire("l9QLJ")).addSchemaLevelResolveFunction(schema, resolvers['__schema']);
        if (connectors) (parcelRequire("l9QLJ")).attachConnectorsToContext(schema, connectors);
        if (directiveResolvers) (parcelRequire("l9QLJ")).attachDirectiveResolvers(schema, directiveResolvers);
        if (schemaDirectives) $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
        return schema;
    }
    module.exports.makeExecutableSchema = $c2bf62df9ea62751$var$makeExecutableSchema;
    function $c2bf62df9ea62751$var$decorateToCatchUndefined(fn, hint) {
        if (typeof fn === 'undefined') fn = (0, parcelRequire("mP8zZ")).defaultFieldResolver;
        return function(root, args, ctx, info) {
            var result = fn(root, args, ctx, info);
            if (typeof result === 'undefined') throw new Error("Resolve function for \"" + hint + "\" returned undefined");
            return result;
        };
    }
    function $c2bf62df9ea62751$var$addCatchUndefinedToSchema(schema) {
        (parcelRequire("l9QLJ")).forEachField(schema, function(field, typeName, fieldName) {
            var errorHint = typeName + "." + fieldName;
            field.resolve = $c2bf62df9ea62751$var$decorateToCatchUndefined(field.resolve, errorHint);
        });
    }
    module.exports.addCatchUndefinedToSchema = $c2bf62df9ea62751$var$addCatchUndefinedToSchema;
    function $c2bf62df9ea62751$var$addErrorLoggingToSchema(schema, logger) {
        if (!logger) throw new Error('Must provide a logger');
        if (typeof logger.log !== 'function') throw new Error('Logger.log must be a function');
        (parcelRequire("l9QLJ")).forEachField(schema, function(field, typeName, fieldName) {
            var errorHint = typeName + "." + fieldName;
            field.resolve = (parcelRequire("l9QLJ")).decorateWithLogger(field.resolve, logger, errorHint);
        });
    }
    module.exports.addErrorLoggingToSchema = $c2bf62df9ea62751$var$addErrorLoggingToSchema;
    $c2bf62df9ea62751$var$__export((parcelRequire("l9QLJ")));
});
parcelRegister("48EbR", function(module, exports) {
    var $303715b63bc39cec$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $303715b63bc39cec$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $lUVCX;
    var $bzIlO;
    var $7dqoX;
    var $303715b63bc39cec$var$hasOwn = Object.prototype.hasOwnProperty;
    var $303715b63bc39cec$var$SchemaVisitor = function() {
        function SchemaVisitor() {}
        SchemaVisitor.implementsVisitorMethod = function(methodName) {
            if (!methodName.startsWith('visit')) return false;
            var method = this.prototype[methodName];
            if (typeof method !== 'function') return false;
            if (this === SchemaVisitor) return true;
            var stub = SchemaVisitor.prototype[methodName];
            if (method === stub) return false;
            return true;
        };
        SchemaVisitor.prototype.visitSchema = function(schema) {};
        SchemaVisitor.prototype.visitScalar = function(scalar) {};
        SchemaVisitor.prototype.visitObject = function(object) {};
        SchemaVisitor.prototype.visitFieldDefinition = function(field, details) {};
        SchemaVisitor.prototype.visitArgumentDefinition = function(argument, details) {};
        SchemaVisitor.prototype.visitInterface = function(iface) {};
        SchemaVisitor.prototype.visitUnion = function(union) {};
        SchemaVisitor.prototype.visitEnum = function(type) {};
        SchemaVisitor.prototype.visitEnumValue = function(value, details) {};
        SchemaVisitor.prototype.visitInputObject = function(object) {};
        SchemaVisitor.prototype.visitInputFieldDefinition = function(field, details) {};
        return SchemaVisitor;
    }();
    module.exports.SchemaVisitor = $303715b63bc39cec$var$SchemaVisitor;
    function $303715b63bc39cec$var$visitSchema(schema, visitorSelector) {
        function callMethod(methodName, type) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            visitorSelector(type, methodName).every(function(visitor) {
                var newType = visitor[methodName].apply(visitor, $303715b63bc39cec$var$__spreadArrays([
                    type
                ], args));
                if (typeof newType === 'undefined') return true;
                if (methodName === 'visitSchema' || type instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) throw new Error("Method " + methodName + " cannot replace schema with " + newType);
                if (newType === null) {
                    type = null;
                    return false;
                }
                type = newType;
                return true;
            });
            return type;
        }
        function visit(type) {
            if (type instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) {
                callMethod('visitSchema', type);
                $303715b63bc39cec$var$updateEachKey(type.getTypeMap(), function(namedType, typeName) {
                    if (!typeName.startsWith('__')) return visit(namedType);
                });
                return type;
            }
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
                var newObject = callMethod('visitObject', type);
                if (newObject) visitFields(newObject);
                return newObject;
            }
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) {
                var newInterface = callMethod('visitInterface', type);
                if (newInterface) visitFields(newInterface);
                return newInterface;
            }
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInputObjectType) {
                var newInputObject_1 = callMethod('visitInputObject', type);
                if (newInputObject_1) $303715b63bc39cec$var$updateEachKey(newInputObject_1.getFields(), function(field) {
                    return callMethod('visitInputFieldDefinition', field, {
                        objectType: newInputObject_1
                    });
                });
                return newInputObject_1;
            }
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) return callMethod('visitScalar', type);
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) return callMethod('visitUnion', type);
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) {
                var newEnum_1 = callMethod('visitEnum', type);
                if (newEnum_1) $303715b63bc39cec$var$updateEachKey(newEnum_1.getValues(), function(value) {
                    return callMethod('visitEnumValue', value, {
                        enumType: newEnum_1
                    });
                });
                return newEnum_1;
            }
            throw new Error("Unexpected schema type: " + type);
        }
        function visitFields(type) {
            $303715b63bc39cec$var$updateEachKey(type.getFields(), function(field) {
                var newField = callMethod('visitFieldDefinition', field, {
                    objectType: type
                });
                if (newField && newField.args) $303715b63bc39cec$var$updateEachKey(newField.args, function(arg) {
                    return callMethod('visitArgumentDefinition', arg, {
                        field: newField,
                        objectType: type
                    });
                });
                return newField;
            });
        }
        visit(schema);
        return schema;
    }
    module.exports.visitSchema = $303715b63bc39cec$var$visitSchema;
    function $303715b63bc39cec$var$healSchema(schema) {
        heal(schema);
        return schema;
        function heal(type) {
            if (type instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) {
                var originalTypeMap_1 = type.getTypeMap();
                var actualNamedTypeMap_1 = Object.create(null);
                $303715b63bc39cec$var$each(originalTypeMap_1, function(namedType, typeName) {
                    if (typeName.startsWith('__')) return;
                    var actualName = namedType.name;
                    if (actualName.startsWith('__')) return;
                    if ($303715b63bc39cec$var$hasOwn.call(actualNamedTypeMap_1, actualName)) throw new Error("Duplicate schema type name " + actualName);
                    actualNamedTypeMap_1[actualName] = namedType;
                });
                $303715b63bc39cec$var$each(actualNamedTypeMap_1, function(namedType, typeName) {
                    originalTypeMap_1[typeName] = namedType;
                });
                $303715b63bc39cec$var$each(type.getDirectives(), function(decl) {
                    if (decl.args) $303715b63bc39cec$var$each(decl.args, function(arg) {
                        arg.type = healType(arg.type);
                    });
                });
                $303715b63bc39cec$var$each(originalTypeMap_1, function(namedType, typeName) {
                    if (!typeName.startsWith('__')) heal(namedType);
                });
                $303715b63bc39cec$var$updateEachKey(originalTypeMap_1, function(namedType, typeName) {
                    if (!typeName.startsWith('__') && !$303715b63bc39cec$var$hasOwn.call(actualNamedTypeMap_1, typeName)) return null;
                });
            } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
                healFields(type);
                $303715b63bc39cec$var$each(type.getInterfaces(), function(iface) {
                    return heal(iface);
                });
            } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) healFields(type);
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInputObjectType) $303715b63bc39cec$var$each(type.getFields(), function(field) {
                field.type = healType(field.type);
            });
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) ;
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) $303715b63bc39cec$var$updateEachKey(type.getTypes(), function(t) {
                return healType(t);
            });
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) ;
            else throw new Error("Unexpected schema type: " + type);
        }
        function healFields(type) {
            $303715b63bc39cec$var$each(type.getFields(), function(field) {
                field.type = healType(field.type);
                if (field.args) $303715b63bc39cec$var$each(field.args, function(arg) {
                    arg.type = healType(arg.type);
                });
            });
        }
        function healType(type) {
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLList) type = new (0, parcelRequire("8oLgk")).GraphQLList(healType(type.ofType));
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLNonNull) type = new (0, parcelRequire("8oLgk")).GraphQLNonNull(healType(type.ofType));
            else if ((0, parcelRequire("8oLgk")).isNamedType(type)) {
                var namedType = type;
                var officialType = schema.getType(namedType.name);
                if (officialType && namedType !== officialType) return officialType;
            }
            return type;
        }
    }
    module.exports.healSchema = $303715b63bc39cec$var$healSchema;
    var $303715b63bc39cec$var$SchemaDirectiveVisitor = function(_super) {
        $303715b63bc39cec$var$__extends(SchemaDirectiveVisitor, _super);
        function SchemaDirectiveVisitor(config) {
            var _this = _super.call(this) || this;
            _this.name = config.name;
            _this.args = config.args;
            _this.visitedType = config.visitedType;
            _this.schema = config.schema;
            _this.context = config.context;
            return _this;
        }
        SchemaDirectiveVisitor.getDirectiveDeclaration = function(directiveName, schema) {
            return schema.getDirective(directiveName);
        };
        SchemaDirectiveVisitor.visitSchemaDirectives = function(schema, directiveVisitors, context) {
            if (context === void 0) context = Object.create(null);
            var declaredDirectives = this.getDeclaredDirectives(schema, directiveVisitors);
            var createdVisitors = Object.create(null);
            Object.keys(directiveVisitors).forEach(function(directiveName) {
                createdVisitors[directiveName] = [];
            });
            function visitorSelector(type, methodName) {
                var visitors = [];
                var directiveNodes = type.astNode && type.astNode.directives;
                if (!directiveNodes) return visitors;
                directiveNodes.forEach(function(directiveNode) {
                    var directiveName = directiveNode.name.value;
                    if (!$303715b63bc39cec$var$hasOwn.call(directiveVisitors, directiveName)) return;
                    var visitorClass = directiveVisitors[directiveName];
                    if (!visitorClass.implementsVisitorMethod(methodName)) return;
                    var decl = declaredDirectives[directiveName];
                    var args;
                    if (decl) args = (0, parcelRequire("7dqoX")).getArgumentValues(decl, directiveNode);
                    else {
                        args = Object.create(null);
                        directiveNode.arguments.forEach(function(arg) {
                            args[arg.name.value] = $303715b63bc39cec$var$valueFromASTUntyped(arg.value);
                        });
                    }
                    visitors.push(new visitorClass({
                        name: directiveName,
                        args: args,
                        visitedType: type,
                        schema: schema,
                        context: context
                    }));
                });
                if (visitors.length > 0) visitors.forEach(function(visitor) {
                    createdVisitors[visitor.name].push(visitor);
                });
                return visitors;
            }
            $303715b63bc39cec$var$visitSchema(schema, visitorSelector);
            $303715b63bc39cec$var$healSchema(schema);
            return createdVisitors;
        };
        SchemaDirectiveVisitor.getDeclaredDirectives = function(schema, directiveVisitors) {
            var declaredDirectives = Object.create(null);
            $303715b63bc39cec$var$each(schema.getDirectives(), function(decl) {
                declaredDirectives[decl.name] = decl;
            });
            $303715b63bc39cec$var$each(directiveVisitors, function(visitorClass, directiveName) {
                var decl = visitorClass.getDirectiveDeclaration(directiveName, schema);
                if (decl) declaredDirectives[directiveName] = decl;
            });
            $303715b63bc39cec$var$each(declaredDirectives, function(decl, name) {
                if (!$303715b63bc39cec$var$hasOwn.call(directiveVisitors, name)) return;
                var visitorClass = directiveVisitors[name];
                $303715b63bc39cec$var$each(decl.locations, function(loc) {
                    var visitorMethodName = $303715b63bc39cec$var$directiveLocationToVisitorMethodName(loc);
                    if ($303715b63bc39cec$var$SchemaVisitor.implementsVisitorMethod(visitorMethodName) && !visitorClass.implementsVisitorMethod(visitorMethodName)) throw new Error("SchemaDirectiveVisitor for @" + name + " must implement " + visitorMethodName + " method");
                });
            });
            return declaredDirectives;
        };
        return SchemaDirectiveVisitor;
    }($303715b63bc39cec$var$SchemaVisitor);
    module.exports.SchemaDirectiveVisitor = $303715b63bc39cec$var$SchemaDirectiveVisitor;
    function $303715b63bc39cec$var$directiveLocationToVisitorMethodName(loc) {
        return 'visit' + loc.replace(/([^_]*)_?/g, function(wholeMatch, part) {
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        });
    }
    function $303715b63bc39cec$var$each(arrayOrObject, callback) {
        Object.keys(arrayOrObject).forEach(function(key) {
            callback(arrayOrObject[key], key);
        });
    }
    function $303715b63bc39cec$var$updateEachKey(arrayOrObject, callback) {
        var deletedCount = 0;
        Object.keys(arrayOrObject).forEach(function(key) {
            var result = callback(arrayOrObject[key], key);
            if (typeof result === 'undefined') return;
            if (result === null) {
                delete arrayOrObject[key];
                deletedCount++;
                return;
            }
            arrayOrObject[key] = result;
        });
        if (deletedCount > 0 && Array.isArray(arrayOrObject)) arrayOrObject.splice(0).forEach(function(elem) {
            arrayOrObject.push(elem);
        });
    }
    function $303715b63bc39cec$var$valueFromASTUntyped(valueNode) {
        switch(valueNode.kind){
            case (0, parcelRequire("bzIlO")).Kind.NULL:
                return null;
            case (0, parcelRequire("bzIlO")).Kind.INT:
                return parseInt(valueNode.value, 10);
            case (0, parcelRequire("bzIlO")).Kind.FLOAT:
                return parseFloat(valueNode.value);
            case (0, parcelRequire("bzIlO")).Kind.STRING:
            case (0, parcelRequire("bzIlO")).Kind.ENUM:
            case (0, parcelRequire("bzIlO")).Kind.BOOLEAN:
                return valueNode.value;
            case (0, parcelRequire("bzIlO")).Kind.LIST:
                return valueNode.values.map($303715b63bc39cec$var$valueFromASTUntyped);
            case (0, parcelRequire("bzIlO")).Kind.OBJECT:
                var obj_1 = Object.create(null);
                valueNode.fields.forEach(function(field) {
                    obj_1[field.name.value] = $303715b63bc39cec$var$valueFromASTUntyped(field.value);
                });
                return obj_1;
            default:
                throw new Error('Unexpected value kind: ' + valueNode.kind);
        }
    }
});
parcelRegister("4Imtl", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    function $36ecb406f3832123$var$mergeDeep(target, source) {
        var output = Object.assign({}, target);
        if ($36ecb406f3832123$var$isObject(target) && $36ecb406f3832123$var$isObject(source)) Object.keys(source).forEach(function(key) {
            var _a, _b;
            if ($36ecb406f3832123$var$isObject(source[key])) {
                if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
                else output[key] = $36ecb406f3832123$var$mergeDeep(target[key], source[key]);
            } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
        });
        return output;
    }
    module.exports.default = $36ecb406f3832123$var$mergeDeep;
    function $36ecb406f3832123$var$isObject(item) {
        return item && typeof item === 'object' && !Array.isArray(item);
    }
});
parcelRegister("l9QLJ", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jfNiv = parcelRequire("jfNiv");
    module.exports.addResolveFunctionsToSchema = $jfNiv.default;
    var $eEIIZ = parcelRequire("eEIIZ");
    module.exports.addSchemaLevelResolveFunction = $eEIIZ.default;
    var $2cFOE = parcelRequire("2cFOE");
    module.exports.assertResolveFunctionsPresent = $2cFOE.default;
    var $6uSkr = parcelRequire("6uSkr");
    module.exports.attachDirectiveResolvers = $6uSkr.default;
    var $7QdUr = parcelRequire("7QdUr");
    module.exports.attachConnectorsToContext = $7QdUr.default;
    var $6VZNv = parcelRequire("6VZNv");
    module.exports.buildSchemaFromTypeDefinitions = $6VZNv.default;
    var $fZSSc = parcelRequire("fZSSc");
    module.exports.chainResolvers = $fZSSc.chainResolvers;
    var $3xw8r = parcelRequire("3xw8r");
    module.exports.checkForResolveTypeResolver = $3xw8r.default;
    var $7Bsga = parcelRequire("7Bsga");
    module.exports.concatenateTypeDefs = $7Bsga.default;
    var $3qMTx = parcelRequire("3qMTx");
    module.exports.decorateWithLogger = $3qMTx.default;
    var $gk7uh = parcelRequire("gk7uh");
    module.exports.extendResolversFromInterfaces = $gk7uh.default;
    var $cfI70 = parcelRequire("cfI70");
    module.exports.extractExtensionDefinitions = $cfI70.default;
    var $izDlb = parcelRequire("izDlb");
    module.exports.forEachField = $izDlb.default;
    var $5gUcG = parcelRequire("5gUcG");
    module.exports.SchemaError = $5gUcG.default;
});
parcelRegister("jfNiv", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $l9QLJ = parcelRequire("l9QLJ");
    var $8oLgk;
    var $lUVCX;
    var $9CEZe = parcelRequire("9CEZe");
    var $l9QLJ = parcelRequire("l9QLJ");
    var $JUrSs = parcelRequire("JUrSs");
    function $e045a8785573f7ad$var$addResolveFunctionsToSchema(options, legacyInputResolvers, legacyInputValidationOptions) {
        if (options instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) {
            console.warn('The addResolveFunctionsToSchema function takes named options now; see IAddResolveFunctionsToSchemaOptions');
            options = {
                schema: options,
                resolvers: legacyInputResolvers,
                resolverValidationOptions: legacyInputValidationOptions
            };
        }
        var schema = options.schema, inputResolvers = options.resolvers, _a = options.resolverValidationOptions, resolverValidationOptions = _a === void 0 ? {} : _a, _b = options.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _b === void 0 ? false : _b;
        var _c = resolverValidationOptions.allowResolversNotInSchema, allowResolversNotInSchema = _c === void 0 ? false : _c, requireResolversForResolveType = resolverValidationOptions.requireResolversForResolveType;
        var resolvers = inheritResolversFromInterfaces ? $l9QLJ.extendResolversFromInterfaces(schema, inputResolvers) : inputResolvers;
        var enumValueMap = Object.create(null);
        Object.keys(resolvers).forEach(function(typeName) {
            var resolverValue = resolvers[typeName];
            var resolverType = typeof resolverValue;
            if (resolverType !== 'object' && resolverType !== 'function') throw new $l9QLJ.SchemaError("\"" + typeName + "\" defined in resolvers, but has invalid value \"" + resolverValue + "\". A resolver's value " + "must be of type object or function.");
            var type = schema.getType(typeName);
            if (!type && typeName !== '__schema') {
                if (allowResolversNotInSchema) return;
                throw new $l9QLJ.SchemaError("\"" + typeName + "\" defined in resolvers, but not in schema");
            }
            Object.keys(resolverValue).forEach(function(fieldName) {
                if (fieldName.startsWith('__')) {
                    type[fieldName.substring(2)] = resolverValue[fieldName];
                    return;
                }
                if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) {
                    type[fieldName] = resolverValue[fieldName];
                    return;
                }
                if (type instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) {
                    if (!type.getValue(fieldName)) {
                        if (allowResolversNotInSchema) return;
                        throw new $l9QLJ.SchemaError(typeName + "." + fieldName + " was defined in resolvers, but enum is not in schema");
                    }
                    enumValueMap[type.name] = enumValueMap[type.name] || {};
                    enumValueMap[type.name][fieldName] = resolverValue[fieldName];
                    return;
                }
                var fields = $e045a8785573f7ad$var$getFieldsForType(type);
                if (!fields) {
                    if (allowResolversNotInSchema) return;
                    throw new $l9QLJ.SchemaError(typeName + " was defined in resolvers, but it's not an object");
                }
                if (!fields[fieldName]) {
                    if (allowResolversNotInSchema) return;
                    throw new $l9QLJ.SchemaError(typeName + "." + fieldName + " defined in resolvers, but not in schema");
                }
                var field = fields[fieldName];
                var fieldResolve = resolverValue[fieldName];
                if (typeof fieldResolve === 'function') $e045a8785573f7ad$var$setFieldProperties(field, {
                    resolve: fieldResolve
                });
                else {
                    if (typeof fieldResolve !== 'object') throw new $l9QLJ.SchemaError("Resolver " + typeName + "." + fieldName + " must be object or function");
                    $e045a8785573f7ad$var$setFieldProperties(field, fieldResolve);
                }
            });
        });
        $l9QLJ.checkForResolveTypeResolver(schema, requireResolversForResolveType);
        var updatedSchema = $9CEZe.applySchemaTransforms(schema, [
            new $JUrSs.default(enumValueMap)
        ]);
        return updatedSchema;
    }
    function $e045a8785573f7ad$var$getFieldsForType(type) {
        if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType || type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) return type.getFields();
        else return undefined;
    }
    function $e045a8785573f7ad$var$setFieldProperties(field, propertiesObj) {
        Object.keys(propertiesObj).forEach(function(propertyName) {
            field[propertyName] = propertiesObj[propertyName];
        });
    }
    module.exports.default = $e045a8785573f7ad$var$addResolveFunctionsToSchema;
});
parcelRegister("9CEZe", function(module, exports) {
    var $701774c08b2cc58f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    function $701774c08b2cc58f$var$applySchemaTransforms(originalSchema, transforms) {
        return transforms.reduce(function(schema, transform) {
            return transform.transformSchema ? transform.transformSchema(schema) : schema;
        }, originalSchema);
    }
    module.exports.applySchemaTransforms = $701774c08b2cc58f$var$applySchemaTransforms;
    function $701774c08b2cc58f$var$applyRequestTransforms(originalRequest, transforms) {
        return transforms.reduce(function(request, transform) {
            return transform.transformRequest ? transform.transformRequest(request) : request;
        }, originalRequest);
    }
    module.exports.applyRequestTransforms = $701774c08b2cc58f$var$applyRequestTransforms;
    function $701774c08b2cc58f$var$applyResultTransforms(originalResult, transforms) {
        return transforms.reduce(function(result, transform) {
            return transform.transformResult ? transform.transformResult(result) : result;
        }, originalResult);
    }
    module.exports.applyResultTransforms = $701774c08b2cc58f$var$applyResultTransforms;
    function $701774c08b2cc58f$var$composeTransforms() {
        var transforms = [];
        for(var _i = 0; _i < arguments.length; _i++)transforms[_i] = arguments[_i];
        var reverseTransforms = $701774c08b2cc58f$var$__spreadArrays(transforms).reverse();
        return {
            transformSchema: function(originalSchema) {
                return $701774c08b2cc58f$var$applySchemaTransforms(originalSchema, transforms);
            },
            transformRequest: function(originalRequest) {
                return $701774c08b2cc58f$var$applyRequestTransforms(originalRequest, reverseTransforms);
            },
            transformResult: function(result) {
                return $701774c08b2cc58f$var$applyResultTransforms(result, reverseTransforms);
            }
        };
    }
    module.exports.composeTransforms = $701774c08b2cc58f$var$composeTransforms;
});
parcelRegister("JUrSs", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $1e7FQ = parcelRequire("1e7FQ");
    var $089ffd9b7a105de6$var$ConvertEnumValues = function() {
        function ConvertEnumValues(enumValueMap) {
            this.enumValueMap = enumValueMap;
        }
        ConvertEnumValues.prototype.transformSchema = function(schema) {
            var _a;
            var enumValueMap = this.enumValueMap;
            if (!enumValueMap || Object.keys(enumValueMap).length === 0) return schema;
            var transformedSchema = $1e7FQ.visitSchema(schema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.ENUM_TYPE] = function(enumType) {
                var externalToInternalValueMap = enumValueMap[enumType.name];
                if (externalToInternalValueMap) {
                    var values = enumType.getValues();
                    var newValues_1 = {};
                    values.forEach(function(value) {
                        var newValue = Object.keys(externalToInternalValueMap).includes(value.name) ? externalToInternalValueMap[value.name] : value.name;
                        newValues_1[value.name] = {
                            value: newValue,
                            deprecationReason: value.deprecationReason,
                            description: value.description,
                            astNode: value.astNode
                        };
                    });
                    return new (0, parcelRequire("8oLgk")).GraphQLEnumType({
                        name: enumType.name,
                        description: enumType.description,
                        astNode: enumType.astNode,
                        values: newValues_1
                    });
                }
                return enumType;
            }, _a));
            return transformedSchema;
        };
        return ConvertEnumValues;
    }();
    module.exports.default = $089ffd9b7a105de6$var$ConvertEnumValues;
});
parcelRegister("1e7FQ", function(module, exports) {
    var $0e4d0d21041b9ff9$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $lUVCX;
    var $cPwLY = parcelRequire("cPwLY");
    var $0e4d0d21041b9ff9$var$VisitSchemaKind;
    (function(VisitSchemaKind) {
        VisitSchemaKind["TYPE"] = "VisitSchemaKind.TYPE";
        VisitSchemaKind["SCALAR_TYPE"] = "VisitSchemaKind.SCALAR_TYPE";
        VisitSchemaKind["ENUM_TYPE"] = "VisitSchemaKind.ENUM_TYPE";
        VisitSchemaKind["COMPOSITE_TYPE"] = "VisitSchemaKind.COMPOSITE_TYPE";
        VisitSchemaKind["OBJECT_TYPE"] = "VisitSchemaKind.OBJECT_TYPE";
        VisitSchemaKind["INPUT_OBJECT_TYPE"] = "VisitSchemaKind.INPUT_OBJECT_TYPE";
        VisitSchemaKind["ABSTRACT_TYPE"] = "VisitSchemaKind.ABSTRACT_TYPE";
        VisitSchemaKind["UNION_TYPE"] = "VisitSchemaKind.UNION_TYPE";
        VisitSchemaKind["INTERFACE_TYPE"] = "VisitSchemaKind.INTERFACE_TYPE";
        VisitSchemaKind["ROOT_OBJECT"] = "VisitSchemaKind.ROOT_OBJECT";
        VisitSchemaKind["QUERY"] = "VisitSchemaKind.QUERY";
        VisitSchemaKind["MUTATION"] = "VisitSchemaKind.MUTATION";
        VisitSchemaKind["SUBSCRIPTION"] = "VisitSchemaKind.SUBSCRIPTION";
    })($0e4d0d21041b9ff9$var$VisitSchemaKind = module.exports.VisitSchemaKind || (module.exports.VisitSchemaKind = {}));
    function $0e4d0d21041b9ff9$var$visitSchema(schema, visitor, stripResolvers) {
        var types = {};
        var resolveType = $cPwLY.createResolveType(function(name) {
            if (typeof types[name] === 'undefined') throw new Error("Can't find type " + name + ".");
            return types[name];
        });
        var queryType = schema.getQueryType();
        var mutationType = schema.getMutationType();
        var subscriptionType = schema.getSubscriptionType();
        var typeMap = schema.getTypeMap();
        Object.keys(typeMap).map(function(typeName) {
            var type = typeMap[typeName];
            if ((0, parcelRequire("8oLgk")).isNamedType(type) && (0, parcelRequire("8oLgk")).getNamedType(type).name.slice(0, 2) !== '__') {
                var specifiers = $0e4d0d21041b9ff9$var$getTypeSpecifiers(type, schema);
                var typeVisitor = $0e4d0d21041b9ff9$var$getVisitor(visitor, specifiers);
                if (typeVisitor) {
                    var result = typeVisitor(type, schema);
                    if (typeof result === 'undefined') types[typeName] = $cPwLY.recreateType(type, resolveType, !stripResolvers);
                    else if (result === null) types[typeName] = null;
                    else types[typeName] = $cPwLY.recreateType(result, resolveType, !stripResolvers);
                } else types[typeName] = $cPwLY.recreateType(type, resolveType, !stripResolvers);
            }
        });
        return new (0, parcelRequire("lUVCX")).GraphQLSchema({
            query: queryType ? types[queryType.name] : null,
            mutation: mutationType ? types[mutationType.name] : null,
            subscription: subscriptionType ? types[subscriptionType.name] : null,
            types: Object.keys(types).map(function(name) {
                return types[name];
            })
        });
    }
    module.exports.visitSchema = $0e4d0d21041b9ff9$var$visitSchema;
    function $0e4d0d21041b9ff9$var$getTypeSpecifiers(type, schema) {
        var specifiers = [
            $0e4d0d21041b9ff9$var$VisitSchemaKind.TYPE
        ];
        if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
            specifiers.unshift($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.OBJECT_TYPE);
            var query = schema.getQueryType();
            var mutation = schema.getMutationType();
            var subscription = schema.getSubscriptionType();
            if (type === query) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.QUERY);
            else if (type === mutation) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.MUTATION);
            else if (type === subscription) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.SUBSCRIPTION);
        } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInputObjectType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.INPUT_OBJECT_TYPE);
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.ABSTRACT_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.INTERFACE_TYPE);
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.ABSTRACT_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.UNION_TYPE);
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ENUM_TYPE);
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.SCALAR_TYPE);
        return specifiers;
    }
    function $0e4d0d21041b9ff9$var$getVisitor(visitor, specifiers) {
        var typeVisitor = null;
        var stack = $0e4d0d21041b9ff9$var$__spreadArrays(specifiers);
        while(!typeVisitor && stack.length > 0){
            var next = stack.pop();
            typeVisitor = visitor[next];
        }
        return typeVisitor;
    }
});
parcelRegister("cPwLY", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $djKly;
    var $35Smo;
    var $bzIlO;
    var $7qT3x = parcelRequire("7qT3x");
    var $akAWC = parcelRequire("akAWC");
    var $kptle = parcelRequire("kptle");
    function $9573ab71d24e9252$var$recreateType(type, resolveType, keepResolvers) {
        if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
            var fields_1 = type.getFields();
            var interfaces_1 = type.getInterfaces();
            return new (0, parcelRequire("8oLgk")).GraphQLObjectType({
                name: type.name,
                description: type.description,
                astNode: type.astNode,
                isTypeOf: keepResolvers ? type.isTypeOf : undefined,
                fields: function() {
                    return $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields_1, resolveType, keepResolvers);
                },
                interfaces: function() {
                    return interfaces_1.map(function(iface) {
                        return resolveType(iface);
                    });
                }
            });
        } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) {
            var fields_2 = type.getFields();
            return new (0, parcelRequire("8oLgk")).GraphQLInterfaceType({
                name: type.name,
                description: type.description,
                astNode: type.astNode,
                fields: function() {
                    return $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields_2, resolveType, keepResolvers);
                },
                resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                    return $akAWC.default(parent, info.schema);
                }
            });
        } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) return new (0, parcelRequire("8oLgk")).GraphQLUnionType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            types: function() {
                return type.getTypes().map(function(unionMember) {
                    return resolveType(unionMember);
                });
            },
            resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                return $akAWC.default(parent, info.schema);
            }
        });
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInputObjectType) return new (0, parcelRequire("8oLgk")).GraphQLInputObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: function() {
                return $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap(type.getFields(), resolveType);
            }
        });
        else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) {
            var values = type.getValues();
            var newValues_1 = {};
            values.forEach(function(value) {
                newValues_1[value.name] = {
                    value: value.value,
                    deprecationReason: value.deprecationReason,
                    description: value.description,
                    astNode: value.astNode
                };
            });
            return new (0, parcelRequire("8oLgk")).GraphQLEnumType({
                name: type.name,
                description: type.description,
                astNode: type.astNode,
                values: newValues_1
            });
        } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) {
            if (keepResolvers || $7qT3x.default(type)) return type;
            else return new (0, parcelRequire("8oLgk")).GraphQLScalarType({
                name: type.name,
                description: type.description,
                astNode: type.astNode,
                serialize: function(value) {
                    return value;
                },
                parseValue: function(value) {
                    return value;
                },
                parseLiteral: function(ast) {
                    return $9573ab71d24e9252$var$parseLiteral(ast);
                }
            });
        } else throw new Error("Invalid type " + type);
    }
    module.exports.recreateType = $9573ab71d24e9252$var$recreateType;
    function $9573ab71d24e9252$var$recreateDirective(directive, resolveType) {
        return new (0, parcelRequire("35Smo")).GraphQLDirective({
            name: directive.name,
            description: directive.description,
            locations: directive.locations,
            args: $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(directive.args, resolveType),
            astNode: directive.astNode
        });
    }
    module.exports.recreateDirective = $9573ab71d24e9252$var$recreateDirective;
    function $9573ab71d24e9252$var$parseLiteral(ast) {
        switch(ast.kind){
            case (0, parcelRequire("bzIlO")).Kind.STRING:
            case (0, parcelRequire("bzIlO")).Kind.BOOLEAN:
                return ast.value;
            case (0, parcelRequire("bzIlO")).Kind.INT:
            case (0, parcelRequire("bzIlO")).Kind.FLOAT:
                return parseFloat(ast.value);
            case (0, parcelRequire("bzIlO")).Kind.OBJECT:
                var value_1 = Object.create(null);
                ast.fields.forEach(function(field) {
                    value_1[field.name.value] = $9573ab71d24e9252$var$parseLiteral(field.value);
                });
                return value_1;
            case (0, parcelRequire("bzIlO")).Kind.LIST:
                return ast.values.map($9573ab71d24e9252$var$parseLiteral);
            default:
                return null;
        }
    }
    function $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields, resolveType, keepResolvers) {
        var result = {};
        Object.keys(fields).forEach(function(name) {
            var field = fields[name];
            var type = resolveType(field.type);
            if (type !== null) result[name] = $9573ab71d24e9252$var$fieldToFieldConfig(fields[name], resolveType, keepResolvers);
        });
        return result;
    }
    module.exports.fieldMapToFieldConfigMap = $9573ab71d24e9252$var$fieldMapToFieldConfigMap;
    function $9573ab71d24e9252$var$createResolveType(getType) {
        var resolveType = function(type) {
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLList) {
                var innerType = resolveType(type.ofType);
                if (innerType === null) return null;
                else return new (0, parcelRequire("8oLgk")).GraphQLList(innerType);
            } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLNonNull) {
                var innerType = resolveType(type.ofType);
                if (innerType === null) return null;
                else return new (0, parcelRequire("8oLgk")).GraphQLNonNull(innerType);
            } else if ((0, parcelRequire("8oLgk")).isNamedType(type)) {
                var typeName = (0, parcelRequire("8oLgk")).getNamedType(type).name;
                switch(typeName){
                    case (0, parcelRequire("djKly")).GraphQLInt.name:
                        return (0, parcelRequire("djKly")).GraphQLInt;
                    case (0, parcelRequire("djKly")).GraphQLFloat.name:
                        return (0, parcelRequire("djKly")).GraphQLFloat;
                    case (0, parcelRequire("djKly")).GraphQLString.name:
                        return (0, parcelRequire("djKly")).GraphQLString;
                    case (0, parcelRequire("djKly")).GraphQLBoolean.name:
                        return (0, parcelRequire("djKly")).GraphQLBoolean;
                    case (0, parcelRequire("djKly")).GraphQLID.name:
                        return (0, parcelRequire("djKly")).GraphQLID;
                    default:
                        return getType(typeName, type);
                }
            } else return type;
        };
        return resolveType;
    }
    module.exports.createResolveType = $9573ab71d24e9252$var$createResolveType;
    function $9573ab71d24e9252$var$fieldToFieldConfig(field, resolveType, keepResolvers) {
        return {
            type: resolveType(field.type),
            args: $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(field.args, resolveType),
            resolve: keepResolvers ? field.resolve : $kptle.default,
            subscribe: keepResolvers ? field.subscribe : null,
            description: field.description,
            deprecationReason: field.deprecationReason,
            astNode: field.astNode
        };
    }
    module.exports.fieldToFieldConfig = $9573ab71d24e9252$var$fieldToFieldConfig;
    function $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(args, resolveType) {
        var result = {};
        args.forEach(function(arg) {
            var newArg = $9573ab71d24e9252$var$argumentToArgumentConfig(arg, resolveType);
            if (newArg) result[newArg[0]] = newArg[1];
        });
        return result;
    }
    module.exports.argsToFieldConfigArgumentMap = $9573ab71d24e9252$var$argsToFieldConfigArgumentMap;
    function $9573ab71d24e9252$var$argumentToArgumentConfig(argument, resolveType) {
        var type = resolveType(argument.type);
        if (type === null) return null;
        else return [
            argument.name,
            {
                type: type,
                defaultValue: argument.defaultValue,
                description: argument.description
            }
        ];
    }
    module.exports.argumentToArgumentConfig = $9573ab71d24e9252$var$argumentToArgumentConfig;
    function $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap(fields, resolveType) {
        var result = {};
        Object.keys(fields).forEach(function(name) {
            var field = fields[name];
            var type = resolveType(field.type);
            if (type !== null) result[name] = $9573ab71d24e9252$var$inputFieldToFieldConfig(fields[name], resolveType);
        });
        return result;
    }
    module.exports.inputFieldMapToFieldConfigMap = $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap;
    function $9573ab71d24e9252$var$inputFieldToFieldConfig(field, resolveType) {
        return {
            type: resolveType(field.type),
            defaultValue: field.defaultValue,
            description: field.description,
            astNode: field.astNode
        };
    }
    module.exports.inputFieldToFieldConfig = $9573ab71d24e9252$var$inputFieldToFieldConfig;
});
parcelRegister("7qT3x", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $djKly;
    var $8oLgk;
    module.exports.specifiedScalarTypes = [
        (0, parcelRequire("djKly")).GraphQLString,
        (0, parcelRequire("djKly")).GraphQLInt,
        (0, parcelRequire("djKly")).GraphQLFloat,
        (0, parcelRequire("djKly")).GraphQLBoolean,
        (0, parcelRequire("djKly")).GraphQLID
    ];
    function $5695ab17b574f1df$var$isSpecifiedScalarType(type) {
        return (0, parcelRequire("8oLgk")).isNamedType(type) && (type.name === (0, parcelRequire("djKly")).GraphQLString.name || type.name === (0, parcelRequire("djKly")).GraphQLInt.name || type.name === (0, parcelRequire("djKly")).GraphQLFloat.name || type.name === (0, parcelRequire("djKly")).GraphQLBoolean.name || type.name === (0, parcelRequire("djKly")).GraphQLID.name);
    }
    module.exports.default = $5695ab17b574f1df$var$isSpecifiedScalarType;
});
parcelRegister("akAWC", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    function $78586e0882c00923$var$resolveFromParentTypename(parent, schema) {
        var parentTypename = parent['__typename'];
        if (!parentTypename) throw new Error('Did not fetch typename for object, unable to resolve interface.');
        var resolvedType = schema.getType(parentTypename);
        if (!(resolvedType instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType)) throw new Error('__typename did not match an object type: ' + parentTypename);
        return resolvedType;
    }
    module.exports.default = $78586e0882c00923$var$resolveFromParentTypename;
});
parcelRegister("kptle", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $hEo2F;
    var $csEv9;
    var $2JIWi = parcelRequire("2JIWi");
    var $fqJQz = parcelRequire("fqJQz");
    var $edbce70fe578bc16$var$defaultMergedResolver = function(parent, args, context, info) {
        if (!parent) return null;
        var responseKey = $fqJQz.getResponseKeyFromInfo(info);
        var errorResult = $2JIWi.getErrorsFromParent(parent, responseKey);
        if (errorResult.kind === 'OWN') throw (0, parcelRequire("csEv9")).locatedError(new Error(errorResult.error.message), info.fieldNodes, (0, parcelRequire("hEo2F")).pathToArray(info.path));
        var result = parent[responseKey];
        if (result == null) result = parent[info.fieldName];
        if (!result && parent.data && parent.data[responseKey]) result = parent.data[responseKey];
        if (errorResult.errors) result = $2JIWi.annotateWithChildrenErrors(result, errorResult.errors);
        return result;
    };
    module.exports.default = $edbce70fe578bc16$var$defaultMergedResolver;
});
parcelRegister("2JIWi", function(module, exports) {
    var $1fe2a4bd62c0a6a2$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $1fe2a4bd62c0a6a2$var$__assign = module.exports && module.exports.__assign || function() {
        $1fe2a4bd62c0a6a2$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $1fe2a4bd62c0a6a2$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $hEo2F;
    var $csEv9;
    var $fqJQz = parcelRequire("fqJQz");
    if (typeof $parcel$global !== 'undefined' && 'Symbol' in $parcel$global || typeof window !== 'undefined' && 'Symbol' in window) module.exports.ERROR_SYMBOL = Symbol('subSchemaErrors');
    else module.exports.ERROR_SYMBOL = '@@__subSchemaErrors';
    function $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(object, childrenErrors) {
        var _a;
        if (!childrenErrors || childrenErrors.length === 0) return object;
        if (Array.isArray(object)) {
            var byIndex_1 = {};
            childrenErrors.forEach(function(error) {
                if (!error.path) return;
                var index = error.path[1];
                var current = byIndex_1[index] || [];
                current.push($1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, error), {
                    path: error.path.slice(1)
                }));
                byIndex_1[index] = current;
            });
            return object.map(function(item, index) {
                return $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(item, byIndex_1[index]);
            });
        }
        return $1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, object), (_a = {}, _a[module.exports.ERROR_SYMBOL] = childrenErrors.map(function(error) {
            return $1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, error), error.path ? {
                path: error.path.slice(1)
            } : {});
        }), _a));
    }
    module.exports.annotateWithChildrenErrors = $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors;
    function $1fe2a4bd62c0a6a2$var$getErrorsFromParent(object, fieldName) {
        var errors = object && object[module.exports.ERROR_SYMBOL] || [];
        var childrenErrors = [];
        for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
            var error = errors_1[_i];
            if (!error.path || error.path.length === 1 && error.path[0] === fieldName) return {
                kind: 'OWN',
                error: error
            };
            else if (error.path[0] === fieldName) childrenErrors.push(error);
        }
        return {
            kind: 'CHILDREN',
            errors: childrenErrors
        };
    }
    module.exports.getErrorsFromParent = $1fe2a4bd62c0a6a2$var$getErrorsFromParent;
    var $1fe2a4bd62c0a6a2$var$CombinedError = function(_super) {
        $1fe2a4bd62c0a6a2$var$__extends(CombinedError, _super);
        function CombinedError(message, errors) {
            var _this = _super.call(this, message) || this;
            _this.errors = errors;
            return _this;
        }
        return CombinedError;
    }(Error);
    function $1fe2a4bd62c0a6a2$var$checkResultAndHandleErrors(result, info, responseKey) {
        if (!responseKey) responseKey = $fqJQz.getResponseKeyFromInfo(info);
        if (result.errors && (!result.data || result.data[responseKey] == null)) {
            var newError = result.errors.length === 1 && $1fe2a4bd62c0a6a2$var$hasResult(result.errors[0]) ? result.errors[0] : new $1fe2a4bd62c0a6a2$var$CombinedError($1fe2a4bd62c0a6a2$var$concatErrors(result.errors), result.errors);
            throw (0, parcelRequire("csEv9")).locatedError(newError, info.fieldNodes, (0, parcelRequire("hEo2F")).pathToArray(info.path));
        }
        var resultObject = result.data[responseKey];
        if (result.errors) resultObject = $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(resultObject, result.errors);
        return resultObject;
    }
    module.exports.checkResultAndHandleErrors = $1fe2a4bd62c0a6a2$var$checkResultAndHandleErrors;
    function $1fe2a4bd62c0a6a2$var$concatErrors(errors) {
        return errors.map(function(error) {
            return error.message;
        }).join('\n');
    }
    function $1fe2a4bd62c0a6a2$var$hasResult(error) {
        return error.result || error.extensions || error.originalError && error.originalError.result;
    }
});
parcelRegister("fqJQz", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    function $b3bcd8f78f765cb3$var$getResponseKeyFromInfo(info) {
        return info.fieldNodes[0].alias ? info.fieldNodes[0].alias.value : info.fieldName;
    }
    module.exports.getResponseKeyFromInfo = $b3bcd8f78f765cb3$var$getResponseKeyFromInfo;
});
parcelRegister("eEIIZ", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    function $aab77e808c96b318$var$addSchemaLevelResolveFunction(schema, fn) {
        var rootTypes = [
            schema.getQueryType(),
            schema.getMutationType(),
            schema.getSubscriptionType()
        ].filter(function(x) {
            return !!x;
        });
        rootTypes.forEach(function(type) {
            var rootResolveFn = $aab77e808c96b318$var$runAtMostOncePerRequest(fn);
            var fields = type.getFields();
            Object.keys(fields).forEach(function(fieldName) {
                if (type === schema.getSubscriptionType()) fields[fieldName].resolve = $aab77e808c96b318$var$wrapResolver(fields[fieldName].resolve, fn);
                else fields[fieldName].resolve = $aab77e808c96b318$var$wrapResolver(fields[fieldName].resolve, rootResolveFn);
            });
        });
    }
    function $aab77e808c96b318$var$wrapResolver(innerResolver, outerResolver) {
        return function(obj, args, ctx, info) {
            return Promise.resolve(outerResolver(obj, args, ctx, info)).then(function(root) {
                if (innerResolver) return innerResolver(root, args, ctx, info);
                return (0, parcelRequire("mP8zZ")).defaultFieldResolver(root, args, ctx, info);
            });
        };
    }
    function $aab77e808c96b318$var$runAtMostOncePerRequest(fn) {
        var value;
        var randomNumber = Math.random();
        return function(root, args, ctx, info) {
            if (!info.operation['__runAtMostOnce']) info.operation['__runAtMostOnce'] = {};
            if (!info.operation['__runAtMostOnce'][randomNumber]) {
                info.operation['__runAtMostOnce'][randomNumber] = true;
                value = fn(root, args, ctx, info);
            }
            return value;
        };
    }
    module.exports.default = $aab77e808c96b318$var$addSchemaLevelResolveFunction;
});
parcelRegister("2cFOE", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $l9QLJ = parcelRequire("l9QLJ");
    function $19ad2383c183403f$var$assertResolveFunctionsPresent(schema, resolverValidationOptions) {
        if (resolverValidationOptions === void 0) resolverValidationOptions = {};
        var _a = resolverValidationOptions.requireResolversForArgs, requireResolversForArgs = _a === void 0 ? false : _a, _b = resolverValidationOptions.requireResolversForNonScalar, requireResolversForNonScalar = _b === void 0 ? false : _b, _c = resolverValidationOptions.requireResolversForAllFields, requireResolversForAllFields = _c === void 0 ? false : _c;
        if (requireResolversForAllFields && (requireResolversForArgs || requireResolversForNonScalar)) throw new TypeError("requireResolversForAllFields takes precedence over the more specific assertions. Please configure either requireResolversForAllFields or requireResolversForArgs / requireResolversForNonScalar, but not a combination of them.");
        $l9QLJ.forEachField(schema, function(field, typeName, fieldName) {
            if (requireResolversForAllFields) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
            if (requireResolversForArgs && field.args.length > 0) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
            if (requireResolversForNonScalar && !((0, parcelRequire("8oLgk")).getNamedType(field.type) instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType)) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
        });
    }
    function $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName) {
        if (!field.resolve) {
            console.warn("Resolve function missing for \"" + typeName + "." + fieldName + "\". To disable this warning check https://github.com/apollostack/graphql-tools/issues/131");
            return;
        }
        if (typeof field.resolve !== 'function') throw new $l9QLJ.SchemaError("Resolver \"" + typeName + "." + fieldName + "\" must be a function");
    }
    module.exports.default = $19ad2383c183403f$var$assertResolveFunctionsPresent;
});
parcelRegister("6uSkr", function(module, exports) {
    var $4bafaff7912ca240$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $4bafaff7912ca240$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $4bafaff7912ca240$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    var $48EbR = parcelRequire("48EbR");
    function $4bafaff7912ca240$var$attachDirectiveResolvers(schema, directiveResolvers) {
        if (typeof directiveResolvers !== 'object') throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
        if (Array.isArray(directiveResolvers)) throw new Error('Expected directiveResolvers to be of type object, got Array');
        var schemaDirectives = Object.create(null);
        Object.keys(directiveResolvers).forEach(function(directiveName) {
            schemaDirectives[directiveName] = function(_super) {
                $4bafaff7912ca240$var$__extends(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.visitFieldDefinition = function(field) {
                    var _this = this;
                    var resolver = directiveResolvers[directiveName];
                    var originalResolver = field.resolve || (0, parcelRequire("mP8zZ")).defaultFieldResolver;
                    var directiveArgs = this.args;
                    field.resolve = function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        var source = args[0], context = args[2], info = args[3];
                        return resolver(function() {
                            return $4bafaff7912ca240$var$__awaiter(_this, void 0, void 0, function() {
                                return $4bafaff7912ca240$var$__generator(this, function(_a) {
                                    return [
                                        2,
                                        originalResolver.apply(field, args)
                                    ];
                                });
                            });
                        }, source, directiveArgs, context, info);
                    };
                };
                return class_1;
            }($48EbR.SchemaDirectiveVisitor);
        });
        $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
    }
    module.exports.default = $4bafaff7912ca240$var$attachDirectiveResolvers;
});
parcelRegister("7QdUr", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $lUVCX;
    var $dmeHw = parcelRequire("dmeHw");
    var $l9QLJ = parcelRequire("l9QLJ");
    var $5b582dd7d9bb943b$var$attachConnectorsToContext = $dmeHw.deprecated({
        version: '0.7.0',
        url: 'https://github.com/apollostack/graphql-tools/issues/140'
    }, function(schema, connectors) {
        if (!schema || !(schema instanceof (0, parcelRequire("lUVCX")).GraphQLSchema)) throw new Error("schema must be an instance of GraphQLSchema. This error could be caused by installing more than one version of GraphQL-JS");
        if (typeof connectors !== 'object') {
            var connectorType = typeof connectors;
            throw new Error("Expected connectors to be of type object, got " + connectorType);
        }
        if (Object.keys(connectors).length === 0) throw new Error('Expected connectors to not be an empty object');
        if (Array.isArray(connectors)) throw new Error('Expected connectors to be of type object, got Array');
        if (schema['_apolloConnectorsAttached']) throw new Error('Connectors already attached to context, cannot attach more than once');
        schema['_apolloConnectorsAttached'] = true;
        var attachconnectorFn = function(root, args, ctx) {
            if (typeof ctx !== 'object') {
                var contextType = typeof ctx;
                throw new Error("Cannot attach connector because context is not an object: " + contextType);
            }
            if (typeof ctx.connectors === 'undefined') ctx.connectors = {};
            Object.keys(connectors).forEach(function(connectorName) {
                var connector = connectors[connectorName];
                if (!!connector.prototype) ctx.connectors[connectorName] = new connector(ctx);
                else throw new Error("Connector must be a function or an class");
            });
            return root;
        };
        $l9QLJ.addSchemaLevelResolveFunction(schema, attachconnectorFn);
    });
    module.exports.default = $5b582dd7d9bb943b$var$attachConnectorsToContext;
});
parcelRegister("dmeHw", function(module, exports) {
    "use strict";
    module.exports.options = {
        getWarner: undefined
    };
    function $9b98bbbf098f27a5$var$createWarner(type, name, alternative, version, url) {
        var warnedPositions = {};
        return function() {
            var stack = new Error().stack || '';
            var at = (stack.match(/(?:\s+at\s.+){2}\s+at\s(.+)/) || [
                undefined,
                ''
            ])[1];
            if (/\)$/.test(at)) at = at.match(/[^(]+(?=\)$)/)[0];
            else at = at.trim();
            if (at in warnedPositions) return;
            warnedPositions[at] = true;
            var message;
            switch(type){
                case 'class':
                    message = 'Class';
                    break;
                case 'property':
                    message = 'Property';
                    break;
                case 'method':
                    message = 'Method';
                    break;
                case 'function':
                    message = 'Function';
                    break;
            }
            message += " `" + name + "` has been deprecated";
            if (version) message += " since version " + version;
            if (alternative) message += ", use `" + alternative + "` instead";
            message += '.';
            if (at) message += "\n    at " + at;
            if (url) message += "\nCheck out " + url + " for more information.";
            console.warn(message);
        };
    }
    function $9b98bbbf098f27a5$var$decorateProperty(type, name, descriptor, alternative, version, url) {
        var warner = (module.exports.options.getWarner || $9b98bbbf098f27a5$var$createWarner)(type, name, alternative, version, url);
        descriptor = descriptor || {
            writable: true,
            enumerable: false,
            configurable: true
        };
        var deprecatedDescriptor = {
            enumerable: descriptor.enumerable,
            configurable: descriptor.configurable
        };
        if (descriptor.get || descriptor.set) {
            if (descriptor.get) deprecatedDescriptor.get = function() {
                warner();
                return descriptor.get.call(this);
            };
            if (descriptor.set) deprecatedDescriptor.set = function(value) {
                warner();
                return descriptor.set.call(this, value);
            };
        } else {
            var propertyValue_1 = descriptor.value;
            deprecatedDescriptor.get = function() {
                warner();
                return propertyValue_1;
            };
            if (descriptor.writable) deprecatedDescriptor.set = function(value) {
                warner();
                propertyValue_1 = value;
            };
        }
        return deprecatedDescriptor;
    }
    function $9b98bbbf098f27a5$var$decorateFunction(type, target, alternative, version, url) {
        var name = target.name;
        var warner = (module.exports.options.getWarner || $9b98bbbf098f27a5$var$createWarner)(type, name, alternative, version, url);
        var fn = function() {
            warner();
            return target.apply(this, arguments);
        };
        for(var _i = 0, _a = Object.getOwnPropertyNames(target); _i < _a.length; _i++){
            var propertyName = _a[_i];
            var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);
            if (descriptor.writable) fn[propertyName] = target[propertyName];
            else if (descriptor.configurable) Object.defineProperty(fn, propertyName, descriptor);
        }
        return fn;
    }
    function $9b98bbbf098f27a5$var$deprecated() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
        var fn = args[args.length - 1];
        if (typeof fn === 'function') fn = args.pop();
        else fn = undefined;
        var options = args[0];
        var alternative;
        var version;
        var url;
        if (typeof options === 'string') {
            alternative = options;
            version = args[1];
            url = args[2];
        } else if (options) alternative = options.alternative, version = options.version, url = options.url, options;
        if (fn) return $9b98bbbf098f27a5$var$decorateFunction('function', fn, alternative, version, url);
        return function(target, name, descriptor) {
            if (typeof name === 'string') {
                var type = descriptor && typeof descriptor.value === 'function' ? 'method' : 'property';
                return $9b98bbbf098f27a5$var$decorateProperty(type, name, descriptor, alternative, version, url);
            } else if (typeof target === 'function') {
                var constructor = $9b98bbbf098f27a5$var$decorateFunction('class', target, alternative, version, url);
                var className = target.name;
                for(var _i = 0, _a = Object.getOwnPropertyNames(constructor); _i < _a.length; _i++){
                    var propertyName = _a[_i];
                    var descriptor_1 = Object.getOwnPropertyDescriptor(constructor, propertyName);
                    descriptor_1 = $9b98bbbf098f27a5$var$decorateProperty('class', className, descriptor_1, alternative, version, url);
                    if (descriptor_1.writable) constructor[propertyName] = target[propertyName];
                    else if (descriptor_1.configurable) Object.defineProperty(constructor, propertyName, descriptor_1);
                }
                return constructor;
            }
        };
    }
    module.exports.deprecated = $9b98bbbf098f27a5$var$deprecated;
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $9b98bbbf098f27a5$var$deprecated;
});
parcelRegister("6VZNv", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $dQXZA;
    var $8mJYM;
    var $8uUC9;
    var $l9QLJ = parcelRequire("l9QLJ");
    var $b06Gv = parcelRequire("b06Gv");
    function $50c800a4e928dc15$var$buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions) {
        var myDefinitions = typeDefinitions;
        var astDocument;
        if ($50c800a4e928dc15$var$isDocumentNode(typeDefinitions)) astDocument = typeDefinitions;
        else if (typeof myDefinitions !== 'string') {
            if (!Array.isArray(myDefinitions)) {
                var type = typeof myDefinitions;
                throw new $l9QLJ.SchemaError("typeDefs must be a string, array or schema AST, got " + type);
            }
            myDefinitions = $l9QLJ.concatenateTypeDefs(myDefinitions);
        }
        if (typeof myDefinitions === 'string') astDocument = (0, parcelRequire("8uUC9")).parse(myDefinitions, parseOptions);
        var backcompatOptions = {
            commentDescriptions: true
        };
        var typesAst = $b06Gv.default(astDocument);
        var schema = (0, parcelRequire("dQXZA")).buildASTSchema(typesAst, backcompatOptions);
        var extensionsAst = $l9QLJ.extractExtensionDefinitions(astDocument);
        if (extensionsAst.definitions.length > 0) schema = (0, parcelRequire("8mJYM")).extendSchema(schema, extensionsAst, backcompatOptions);
        return schema;
    }
    function $50c800a4e928dc15$var$isDocumentNode(typeDefinitions) {
        return typeDefinitions.kind !== undefined;
    }
    module.exports.default = $50c800a4e928dc15$var$buildSchemaFromTypeDefinitions;
});
parcelRegister("dQXZA", function(module, exports) {
    $parcel$export(module.exports, "buildASTSchema", ()=>$a15eaae627e0015f$export$25eeb85cb306d87);
    $parcel$export(module.exports, "buildSchema", ()=>$a15eaae627e0015f$export$f668ee82107a74bd);
    var $a1qmV;
    var $bzIlO;
    var $8uUC9;
    var $c6jur;
    var $lUVCX;
    var $35Smo;
    var $8mJYM;
    function $a15eaae627e0015f$export$25eeb85cb306d87(documentAST, options) {
        documentAST != null && documentAST.kind === (0, (0, parcelRequire("bzIlO")).Kind).DOCUMENT || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide valid Document AST.');
        if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, (0, parcelRequire("c6jur")).assertValidSDL)(documentAST);
        var emptySchemaConfig = {
            description: undefined,
            types: [],
            directives: [],
            extensions: undefined,
            extensionASTNodes: [],
            assumeValid: false
        };
        var config = (0, (0, parcelRequire("8mJYM")).extendSchemaImpl)(emptySchemaConfig, documentAST, options);
        if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            switch(type.name){
                case 'Query':
                    config.query = type;
                    break;
                case 'Mutation':
                    config.mutation = type;
                    break;
                case 'Subscription':
                    config.subscription = type;
                    break;
            }
        }
        var directives = config.directives;
        var _loop = function _loop(_i4) {
            var stdDirective = (0, (0, parcelRequire("35Smo")).specifiedDirectives)[_i4];
            if (directives.every(function(directive) {
                return directive.name !== stdDirective.name;
            })) directives.push(stdDirective);
        };
        for(var _i4 = 0; _i4 < (0, (0, parcelRequire("35Smo")).specifiedDirectives).length; _i4++)_loop(_i4);
        return new (0, (0, parcelRequire("lUVCX")).GraphQLSchema)(config);
    }
    function $a15eaae627e0015f$export$f668ee82107a74bd(source, options) {
        var document = (0, (0, parcelRequire("8uUC9")).parse)(source, {
            noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
            allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
            allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
            experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
        });
        return $a15eaae627e0015f$export$25eeb85cb306d87(document, {
            commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
            assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
            assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
        });
    }
});
parcelRegister("c6jur", function(module, exports) {
    $parcel$export(module.exports, "validate", ()=>$8cf529db72906245$export$a22775fa5e2eebd9);
    $parcel$export(module.exports, "assertValidSDL", ()=>$8cf529db72906245$export$e53e4d7168bd6d92);
    $parcel$export(module.exports, "assertValidSDLExtension", ()=>$8cf529db72906245$export$9917845776f624a4);
    var $a1qmV;
    var $g5yZB;
    var $12QNw;
    var $bKGOe;
    var $jjG8c;
    var $1W847;
    var $1zF5q;
    function $8cf529db72906245$export$a22775fa5e2eebd9(schema, documentAST) {
        var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, (0, parcelRequire("1W847")).specifiedRules);
        var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, (0, parcelRequire("jjG8c")).TypeInfo)(schema);
        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            maxErrors: undefined
        };
        documentAST || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide document.');
        (0, (0, parcelRequire("bKGOe")).assertValidSchema)(schema);
        var abortObj = Object.freeze({});
        var errors = [];
        var context = new (0, (0, parcelRequire("1zF5q")).ValidationContext)(schema, documentAST, typeInfo, function(error) {
            if (options.maxErrors != null && errors.length >= options.maxErrors) {
                errors.push(new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
                throw abortObj;
            }
            errors.push(error);
        });
        var visitor = (0, (0, parcelRequire("12QNw")).visitInParallel)(rules.map(function(rule) {
            return rule(context);
        }));
        try {
            (0, (0, parcelRequire("12QNw")).visit)(documentAST, (0, (0, parcelRequire("jjG8c")).visitWithTypeInfo)(typeInfo, visitor));
        } catch (e) {
            if (e !== abortObj) throw e;
        }
        return errors;
    }
    function $8cf529db72906245$export$664b3e1af4fc59b0(documentAST, schemaToExtend) {
        var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, (0, parcelRequire("1W847")).specifiedSDLRules);
        var errors = [];
        var context = new (0, (0, parcelRequire("1zF5q")).SDLValidationContext)(documentAST, schemaToExtend, function(error) {
            errors.push(error);
        });
        var visitors = rules.map(function(rule) {
            return rule(context);
        });
        (0, (0, parcelRequire("12QNw")).visit)(documentAST, (0, (0, parcelRequire("12QNw")).visitInParallel)(visitors));
        return errors;
    }
    function $8cf529db72906245$export$e53e4d7168bd6d92(documentAST) {
        var errors = $8cf529db72906245$export$664b3e1af4fc59b0(documentAST);
        if (errors.length !== 0) throw new Error(errors.map(function(error) {
            return error.message;
        }).join('\n\n'));
    }
    function $8cf529db72906245$export$9917845776f624a4(documentAST, schema) {
        var errors = $8cf529db72906245$export$664b3e1af4fc59b0(documentAST, schema);
        if (errors.length !== 0) throw new Error(errors.map(function(error) {
            return error.message;
        }).join('\n\n'));
    }
});
parcelRegister("jjG8c", function(module, exports) {
    $parcel$export(module.exports, "TypeInfo", ()=>$e10079122696b9a0$export$f0c1fe746ce4bb1e);
    $parcel$export(module.exports, "visitWithTypeInfo", ()=>$e10079122696b9a0$export$18ca434620348336);
    var $85NSv;
    var $bzIlO;
    var $98oUl;
    var $12QNw;
    var $8oLgk;
    var $4Hpke;
    var $6D4Eu;
    var $e10079122696b9a0$export$f0c1fe746ce4bb1e = function() {
        function TypeInfo(schema, getFieldDefFn, initialType) {
            this._schema = schema;
            this._typeStack = [];
            this._parentTypeStack = [];
            this._inputTypeStack = [];
            this._fieldDefStack = [];
            this._defaultValueStack = [];
            this._directive = null;
            this._argument = null;
            this._enumValue = null;
            this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $e10079122696b9a0$var$getFieldDef;
            if (initialType) {
                if ((0, (0, parcelRequire("8oLgk")).isInputType)(initialType)) this._inputTypeStack.push(initialType);
                if ((0, (0, parcelRequire("8oLgk")).isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
                if ((0, (0, parcelRequire("8oLgk")).isOutputType)(initialType)) this._typeStack.push(initialType);
            }
        }
        var _proto = TypeInfo.prototype;
        _proto.getType = function getType() {
            if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
        };
        _proto.getParentType = function getParentType() {
            if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
        };
        _proto.getInputType = function getInputType() {
            if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
        };
        _proto.getParentInputType = function getParentInputType() {
            if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
        };
        _proto.getFieldDef = function getFieldDef() {
            if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
        };
        _proto.getDefaultValue = function getDefaultValue() {
            if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
        };
        _proto.getDirective = function getDirective() {
            return this._directive;
        };
        _proto.getArgument = function getArgument() {
            return this._argument;
        };
        _proto.getEnumValue = function getEnumValue() {
            return this._enumValue;
        };
        _proto.enter = function enter(node) {
            var schema = this._schema;
            switch(node.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).SELECTION_SET:
                    var namedType = (0, (0, parcelRequire("8oLgk")).getNamedType)(this.getType());
                    this._parentTypeStack.push((0, (0, parcelRequire("8oLgk")).isCompositeType)(namedType) ? namedType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).FIELD:
                    var parentType = this.getParentType();
                    var fieldDef;
                    var fieldType;
                    if (parentType) {
                        fieldDef = this._getFieldDef(schema, parentType, node);
                        if (fieldDef) fieldType = fieldDef.type;
                    }
                    this._fieldDefStack.push(fieldDef);
                    this._typeStack.push((0, (0, parcelRequire("8oLgk")).isOutputType)(fieldType) ? fieldType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE:
                    this._directive = schema.getDirective(node.name.value);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION:
                    var type;
                    switch(node.operation){
                        case 'query':
                            type = schema.getQueryType();
                            break;
                        case 'mutation':
                            type = schema.getMutationType();
                            break;
                        case 'subscription':
                            type = schema.getSubscriptionType();
                            break;
                    }
                    this._typeStack.push((0, (0, parcelRequire("8oLgk")).isObjectType)(type) ? type : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT:
                case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION:
                    var typeConditionAST = node.typeCondition;
                    var outputType = typeConditionAST ? (0, (0, parcelRequire("6D4Eu")).typeFromAST)(schema, typeConditionAST) : (0, (0, parcelRequire("8oLgk")).getNamedType)(this.getType());
                    this._typeStack.push((0, (0, parcelRequire("8oLgk")).isOutputType)(outputType) ? outputType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE_DEFINITION:
                    var inputType = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(schema, node.type);
                    this._inputTypeStack.push((0, (0, parcelRequire("8oLgk")).isInputType)(inputType) ? inputType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).ARGUMENT:
                    var _this$getDirective;
                    var argDef;
                    var argType;
                    var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                    if (fieldOrDirective) {
                        argDef = (0, (0, parcelRequire("85NSv")).default)(fieldOrDirective.args, function(arg) {
                            return arg.name === node.name.value;
                        });
                        if (argDef) argType = argDef.type;
                    }
                    this._argument = argDef;
                    this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                    this._inputTypeStack.push((0, (0, parcelRequire("8oLgk")).isInputType)(argType) ? argType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).LIST:
                    var listType = (0, (0, parcelRequire("8oLgk")).getNullableType)(this.getInputType());
                    var itemType = (0, (0, parcelRequire("8oLgk")).isListType)(listType) ? listType.ofType : listType;
                    this._defaultValueStack.push(undefined);
                    this._inputTypeStack.push((0, (0, parcelRequire("8oLgk")).isInputType)(itemType) ? itemType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_FIELD:
                    var objectType = (0, (0, parcelRequire("8oLgk")).getNamedType)(this.getInputType());
                    var inputFieldType;
                    var inputField;
                    if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(objectType)) {
                        inputField = objectType.getFields()[node.name.value];
                        if (inputField) inputFieldType = inputField.type;
                    }
                    this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                    this._inputTypeStack.push((0, (0, parcelRequire("8oLgk")).isInputType)(inputFieldType) ? inputFieldType : undefined);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).ENUM:
                    var enumType = (0, (0, parcelRequire("8oLgk")).getNamedType)(this.getInputType());
                    var enumValue;
                    if ((0, (0, parcelRequire("8oLgk")).isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                    this._enumValue = enumValue;
                    break;
            }
        };
        _proto.leave = function leave(node) {
            switch(node.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).SELECTION_SET:
                    this._parentTypeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).FIELD:
                    this._fieldDefStack.pop();
                    this._typeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE:
                    this._directive = null;
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION:
                case (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT:
                case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION:
                    this._typeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE_DEFINITION:
                    this._inputTypeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).ARGUMENT:
                    this._argument = null;
                    this._defaultValueStack.pop();
                    this._inputTypeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).LIST:
                case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_FIELD:
                    this._defaultValueStack.pop();
                    this._inputTypeStack.pop();
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).ENUM:
                    this._enumValue = null;
                    break;
            }
        };
        return TypeInfo;
    }();
    function $e10079122696b9a0$var$getFieldDef(schema, parentType, fieldNode) {
        var name = fieldNode.name.value;
        if (name === (0, (0, parcelRequire("4Hpke")).SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, (0, parcelRequire("4Hpke")).SchemaMetaFieldDef;
        if (name === (0, (0, parcelRequire("4Hpke")).TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, (0, parcelRequire("4Hpke")).TypeMetaFieldDef;
        if (name === (0, (0, parcelRequire("4Hpke")).TypeNameMetaFieldDef).name && (0, (0, parcelRequire("8oLgk")).isCompositeType)(parentType)) return 0, (0, parcelRequire("4Hpke")).TypeNameMetaFieldDef;
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(parentType) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(parentType)) return parentType.getFields()[name];
    }
    function $e10079122696b9a0$export$18ca434620348336(typeInfo, visitor) {
        return {
            enter: function enter(node) {
                typeInfo.enter(node);
                var fn = (0, (0, parcelRequire("12QNw")).getVisitFn)(visitor, node.kind, false);
                if (fn) {
                    var result = fn.apply(visitor, arguments);
                    if (result !== undefined) {
                        typeInfo.leave(node);
                        if ((0, (0, parcelRequire("98oUl")).isNode)(result)) typeInfo.enter(result);
                    }
                    return result;
                }
            },
            leave: function leave(node) {
                var fn = (0, (0, parcelRequire("12QNw")).getVisitFn)(visitor, node.kind, true);
                var result;
                if (fn) result = fn.apply(visitor, arguments);
                typeInfo.leave(node);
                return result;
            }
        };
    }
});
parcelRegister("1W847", function(module, exports) {
    $parcel$export(module.exports, "specifiedRules", ()=>$169176d8a596a904$export$ac8e8f03d4e8a76c);
    $parcel$export(module.exports, "specifiedSDLRules", ()=>$169176d8a596a904$export$117d63808a280985);
    var $DFCPk;
    var $30WWH;
    var $eyFIg;
    var $09Bdf;
    var $7bFax;
    var $dbQGB;
    var $1co8V;
    var $aPMtH;
    var $jQZ5i;
    var $8PIus;
    var $coK44;
    var $8m6li;
    var $3wQxN;
    var $90jMN;
    var $5OxVI;
    var $4uTwu;
    var $9TmyO;
    var $3N4Hj;
    var $VWtb8;
    var $9WoAw;
    var $36Mx7;
    var $5wBGi;
    var $jpyH1;
    var $8gRGf;
    var $gA8jd;
    var $dAQg3;
    var $beSbb;
    var $gBAc1;
    var $3iH5k;
    var $j74Ua;
    var $9mu02;
    var $6i9pg;
    var $ixjnC;
    var $169176d8a596a904$export$ac8e8f03d4e8a76c = Object.freeze([
        (0, (0, parcelRequire("DFCPk")).ExecutableDefinitionsRule),
        (0, (0, parcelRequire("30WWH")).UniqueOperationNamesRule),
        (0, (0, parcelRequire("eyFIg")).LoneAnonymousOperationRule),
        (0, (0, parcelRequire("09Bdf")).SingleFieldSubscriptionsRule),
        (0, (0, parcelRequire("7bFax")).KnownTypeNamesRule),
        (0, (0, parcelRequire("dbQGB")).FragmentsOnCompositeTypesRule),
        (0, (0, parcelRequire("1co8V")).VariablesAreInputTypesRule),
        (0, (0, parcelRequire("aPMtH")).ScalarLeafsRule),
        (0, (0, parcelRequire("jQZ5i")).FieldsOnCorrectTypeRule),
        (0, (0, parcelRequire("8PIus")).UniqueFragmentNamesRule),
        (0, (0, parcelRequire("coK44")).KnownFragmentNamesRule),
        (0, (0, parcelRequire("8m6li")).NoUnusedFragmentsRule),
        (0, (0, parcelRequire("3wQxN")).PossibleFragmentSpreadsRule),
        (0, (0, parcelRequire("90jMN")).NoFragmentCyclesRule),
        (0, (0, parcelRequire("5OxVI")).UniqueVariableNamesRule),
        (0, (0, parcelRequire("4uTwu")).NoUndefinedVariablesRule),
        (0, (0, parcelRequire("9TmyO")).NoUnusedVariablesRule),
        (0, (0, parcelRequire("3N4Hj")).KnownDirectivesRule),
        (0, (0, parcelRequire("VWtb8")).UniqueDirectivesPerLocationRule),
        (0, (0, parcelRequire("9WoAw")).KnownArgumentNamesRule),
        (0, (0, parcelRequire("36Mx7")).UniqueArgumentNamesRule),
        (0, (0, parcelRequire("5wBGi")).ValuesOfCorrectTypeRule),
        (0, (0, parcelRequire("jpyH1")).ProvidedRequiredArgumentsRule),
        (0, (0, parcelRequire("8gRGf")).VariablesInAllowedPositionRule),
        (0, (0, parcelRequire("gA8jd")).OverlappingFieldsCanBeMergedRule),
        (0, (0, parcelRequire("dAQg3")).UniqueInputFieldNamesRule)
    ]);
    var $169176d8a596a904$export$117d63808a280985 = Object.freeze([
        (0, (0, parcelRequire("beSbb")).LoneSchemaDefinitionRule),
        (0, (0, parcelRequire("gBAc1")).UniqueOperationTypesRule),
        (0, (0, parcelRequire("3iH5k")).UniqueTypeNamesRule),
        (0, (0, parcelRequire("j74Ua")).UniqueEnumValueNamesRule),
        (0, (0, parcelRequire("9mu02")).UniqueFieldDefinitionNamesRule),
        (0, (0, parcelRequire("6i9pg")).UniqueDirectiveNamesRule),
        (0, (0, parcelRequire("7bFax")).KnownTypeNamesRule),
        (0, (0, parcelRequire("3N4Hj")).KnownDirectivesRule),
        (0, (0, parcelRequire("VWtb8")).UniqueDirectivesPerLocationRule),
        (0, (0, parcelRequire("ixjnC")).PossibleTypeExtensionsRule),
        (0, (0, parcelRequire("9WoAw")).KnownArgumentNamesOnDirectivesRule),
        (0, (0, parcelRequire("36Mx7")).UniqueArgumentNamesRule),
        (0, (0, parcelRequire("dAQg3")).UniqueInputFieldNamesRule),
        (0, (0, parcelRequire("jpyH1")).ProvidedRequiredArgumentsOnDirectivesRule)
    ]);
});
parcelRegister("DFCPk", function(module, exports) {
    $parcel$export(module.exports, "ExecutableDefinitionsRule", ()=>$0773ee89c9209122$export$c3d3637a3c3c605e);
    var $g5yZB;
    var $bzIlO;
    var $Zbk4Z;
    function $0773ee89c9209122$export$c3d3637a3c3c605e(context) {
        return {
            Document: function Document(node) {
                for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                    var definition = _node$definitions2[_i2];
                    if (!(0, (0, parcelRequire("Zbk4Z")).isExecutableDefinitionNode)(definition)) {
                        var defName = definition.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION || definition.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                    }
                }
                return false;
            }
        };
    }
});
parcelRegister("Zbk4Z", function(module, exports) {
    $parcel$export(module.exports, "isExecutableDefinitionNode", ()=>$0b7e7b1ac74e324c$export$4cedd8740794bd78);
    $parcel$export(module.exports, "isTypeSystemDefinitionNode", ()=>$0b7e7b1ac74e324c$export$b05c7141ec7770ba);
    $parcel$export(module.exports, "isTypeSystemExtensionNode", ()=>$0b7e7b1ac74e324c$export$fbc18e88163d676d);
    $parcel$export(module.exports, "isSelectionNode", ()=>$0b7e7b1ac74e324c$export$65772b71e1d017ba);
    $parcel$export(module.exports, "isTypeDefinitionNode", ()=>$0b7e7b1ac74e324c$export$a3584bba04f5bfe0);
    $parcel$export(module.exports, "isTypeExtensionNode", ()=>$0b7e7b1ac74e324c$export$d7907721b241e11f);
    var $bzIlO;
    function $0b7e7b1ac74e324c$export$e7ecd7c16613ccfd(node) {
        return $0b7e7b1ac74e324c$export$4cedd8740794bd78(node) || $0b7e7b1ac74e324c$export$b05c7141ec7770ba(node) || $0b7e7b1ac74e324c$export$fbc18e88163d676d(node);
    }
    function $0b7e7b1ac74e324c$export$4cedd8740794bd78(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION;
    }
    function $0b7e7b1ac74e324c$export$65772b71e1d017ba(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).FIELD || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT;
    }
    function $0b7e7b1ac74e324c$export$ab65b54ec7cbe9e4(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INT || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).FLOAT || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).STRING || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).NULL || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).ENUM || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).LIST || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).OBJECT;
    }
    function $0b7e7b1ac74e324c$export$26e8a4730f4310f4(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).NAMED_TYPE || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).LIST_TYPE || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).NON_NULL_TYPE;
    }
    function $0b7e7b1ac74e324c$export$b05c7141ec7770ba(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION || $0b7e7b1ac74e324c$export$a3584bba04f5bfe0(node) || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION;
    }
    function $0b7e7b1ac74e324c$export$a3584bba04f5bfe0(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION;
    }
    function $0b7e7b1ac74e324c$export$fbc18e88163d676d(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION || $0b7e7b1ac74e324c$export$d7907721b241e11f(node);
    }
    function $0b7e7b1ac74e324c$export$d7907721b241e11f(node) {
        return node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION;
    }
});
parcelRegister("30WWH", function(module, exports) {
    $parcel$export(module.exports, "UniqueOperationNamesRule", ()=>$231f189a5fb9214e$export$a40a702cd7ad2eae);
    var $g5yZB;
    function $231f189a5fb9214e$export$a40a702cd7ad2eae(context) {
        var knownOperationNames = Object.create(null);
        return {
            OperationDefinition: function OperationDefinition(node) {
                var operationName = node.name;
                if (operationName) {
                    if (knownOperationNames[operationName.value]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                        knownOperationNames[operationName.value],
                        operationName
                    ]));
                    else knownOperationNames[operationName.value] = operationName;
                }
                return false;
            },
            FragmentDefinition: function FragmentDefinition() {
                return false;
            }
        };
    }
});
parcelRegister("eyFIg", function(module, exports) {
    $parcel$export(module.exports, "LoneAnonymousOperationRule", ()=>$a99498fb0f12eeb9$export$3a79c63c3de7a55f);
    var $g5yZB;
    var $bzIlO;
    function $a99498fb0f12eeb9$export$3a79c63c3de7a55f(context) {
        var operationCount = 0;
        return {
            Document: function Document(node) {
                operationCount = node.definitions.filter(function(definition) {
                    return definition.kind === (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION;
                }).length;
            },
            OperationDefinition: function OperationDefinition(node) {
                if (!node.name && operationCount > 1) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)('This anonymous operation must be the only defined operation.', node));
            }
        };
    }
});
parcelRegister("09Bdf", function(module, exports) {
    $parcel$export(module.exports, "SingleFieldSubscriptionsRule", ()=>$000772678217c64a$export$477fa0c787c0222d);
    var $g5yZB;
    function $000772678217c64a$export$477fa0c787c0222d(context) {
        return {
            OperationDefinition: function OperationDefinition(node) {
                if (node.operation === 'subscription') {
                    if (node.selectionSet.selections.length !== 1) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
                }
            }
        };
    }
});
parcelRegister("7bFax", function(module, exports) {
    $parcel$export(module.exports, "KnownTypeNamesRule", ()=>$53b97ecd605f9be8$export$2317edbae2efecbd);
    var $h4f6N;
    var $gXVhx;
    var $g5yZB;
    var $Zbk4Z;
    var $djKly;
    var $4Hpke;
    function $53b97ecd605f9be8$export$2317edbae2efecbd(context) {
        var schema = context.getSchema();
        var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
        var definedTypes = Object.create(null);
        for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
            var def = _context$getDocument$2[_i2];
            if ((0, (0, parcelRequire("Zbk4Z")).isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
        }
        var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
        return {
            NamedType: function NamedType(node, _1, parent, _2, ancestors) {
                var typeName = node.name.value;
                if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                    var _ancestors$;
                    var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                    var isSDL = definitionNode != null && $53b97ecd605f9be8$var$isSDLNode(definitionNode);
                    if (isSDL && $53b97ecd605f9be8$var$isStandardTypeName(typeName)) return;
                    var suggestedTypes = (0, (0, parcelRequire("gXVhx")).default)(typeName, isSDL ? $53b97ecd605f9be8$var$standardTypeNames.concat(typeNames) : typeNames);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, (0, parcelRequire("h4f6N")).default)(suggestedTypes), node));
                }
            }
        };
    }
    var $53b97ecd605f9be8$var$standardTypeNames = [].concat((0, (0, parcelRequire("djKly")).specifiedScalarTypes), (0, (0, parcelRequire("4Hpke")).introspectionTypes)).map(function(type) {
        return type.name;
    });
    function $53b97ecd605f9be8$var$isStandardTypeName(typeName) {
        return $53b97ecd605f9be8$var$standardTypeNames.indexOf(typeName) !== -1;
    }
    function $53b97ecd605f9be8$var$isSDLNode(value) {
        return !Array.isArray(value) && ((0, (0, parcelRequire("Zbk4Z")).isTypeSystemDefinitionNode)(value) || (0, (0, parcelRequire("Zbk4Z")).isTypeSystemExtensionNode)(value));
    }
});
parcelRegister("dbQGB", function(module, exports) {
    $parcel$export(module.exports, "FragmentsOnCompositeTypesRule", ()=>$99a52bd0560cc038$export$cb5241ba71fd55e0);
    var $g5yZB;
    var $1c8Um;
    var $8oLgk;
    var $6D4Eu;
    function $99a52bd0560cc038$export$cb5241ba71fd55e0(context) {
        return {
            InlineFragment: function InlineFragment(node) {
                var typeCondition = node.typeCondition;
                if (typeCondition) {
                    var type = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), typeCondition);
                    if (type && !(0, (0, parcelRequire("8oLgk")).isCompositeType)(type)) {
                        var typeStr = (0, (0, parcelRequire("1c8Um")).print)(typeCondition);
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                    }
                }
            },
            FragmentDefinition: function FragmentDefinition(node) {
                var type = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), node.typeCondition);
                if (type && !(0, (0, parcelRequire("8oLgk")).isCompositeType)(type)) {
                    var typeStr = (0, (0, parcelRequire("1c8Um")).print)(node.typeCondition);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
                }
            }
        };
    }
});
parcelRegister("1co8V", function(module, exports) {
    $parcel$export(module.exports, "VariablesAreInputTypesRule", ()=>$0df9a3b429e106f2$export$f20a29632b437591);
    var $g5yZB;
    var $1c8Um;
    var $8oLgk;
    var $6D4Eu;
    function $0df9a3b429e106f2$export$f20a29632b437591(context) {
        return {
            VariableDefinition: function VariableDefinition(node) {
                var type = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), node.type);
                if (type && !(0, (0, parcelRequire("8oLgk")).isInputType)(type)) {
                    var variableName = node.variable.name.value;
                    var typeName = (0, (0, parcelRequire("1c8Um")).print)(node.type);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
                }
            }
        };
    }
});
parcelRegister("aPMtH", function(module, exports) {
    $parcel$export(module.exports, "ScalarLeafsRule", ()=>$7e3445851432b2be$export$d779f66f65c88b9a);
    var $yEDl8;
    var $g5yZB;
    var $8oLgk;
    function $7e3445851432b2be$export$d779f66f65c88b9a(context) {
        return {
            Field: function Field(node) {
                var type = context.getType();
                var selectionSet = node.selectionSet;
                if (type) {
                    if ((0, (0, parcelRequire("8oLgk")).isLeafType)((0, (0, parcelRequire("8oLgk")).getNamedType)(type))) {
                        if (selectionSet) {
                            var fieldName = node.name.value;
                            var typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
                            context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                        }
                    } else if (!selectionSet) {
                        var _fieldName = node.name.value;
                        var _typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                    }
                }
            }
        };
    }
});
parcelRegister("jQZ5i", function(module, exports) {
    $parcel$export(module.exports, "FieldsOnCorrectTypeRule", ()=>$e74241bbdeb8f50c$export$595e5c0bf2d10a85);
    var $awIoQ;
    var $h4f6N;
    var $gXVhx;
    var $Jh3Fc;
    var $g5yZB;
    var $8oLgk;
    function $e74241bbdeb8f50c$export$595e5c0bf2d10a85(context) {
        return {
            Field: function Field(node) {
                var type = context.getParentType();
                if (type) {
                    var fieldDef = context.getFieldDef();
                    if (!fieldDef) {
                        var schema = context.getSchema();
                        var fieldName = node.name.value;
                        var suggestion = (0, (0, parcelRequire("h4f6N")).default)('to use an inline fragment on', $e74241bbdeb8f50c$var$getSuggestedTypeNames(schema, type, fieldName));
                        if (suggestion === '') suggestion = (0, (0, parcelRequire("h4f6N")).default)($e74241bbdeb8f50c$var$getSuggestedFieldNames(type, fieldName));
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                    }
                }
            }
        };
    }
    function $e74241bbdeb8f50c$var$getSuggestedTypeNames(schema, type, fieldName) {
        if (!(0, (0, parcelRequire("8oLgk")).isAbstractType)(type)) return [];
        var suggestedTypes = new Set();
        var usageCount = Object.create(null);
        for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
            var possibleType = _schema$getPossibleTy2[_i2];
            if (!possibleType.getFields()[fieldName]) continue;
            suggestedTypes.add(possibleType);
            usageCount[possibleType.name] = 1;
            for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
                var _usageCount$possibleI;
                var possibleInterface = _possibleType$getInte2[_i4];
                if (!possibleInterface.getFields()[fieldName]) continue;
                suggestedTypes.add(possibleInterface);
                usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
            }
        }
        return (0, (0, parcelRequire("awIoQ")).default)(suggestedTypes).sort(function(typeA, typeB) {
            var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
            if (usageCountDiff !== 0) return usageCountDiff;
            if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
            if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
            return (0, (0, parcelRequire("Jh3Fc")).default)(typeA.name, typeB.name);
        }).map(function(x) {
            return x.name;
        });
    }
    function $e74241bbdeb8f50c$var$getSuggestedFieldNames(type, fieldName) {
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) {
            var possibleFieldNames = Object.keys(type.getFields());
            return (0, (0, parcelRequire("gXVhx")).default)(fieldName, possibleFieldNames);
        }
        return [];
    }
});
parcelRegister("8PIus", function(module, exports) {
    $parcel$export(module.exports, "UniqueFragmentNamesRule", ()=>$66e598feff36d541$export$a920e0f1967f4b0a);
    var $g5yZB;
    function $66e598feff36d541$export$a920e0f1967f4b0a(context) {
        var knownFragmentNames = Object.create(null);
        return {
            OperationDefinition: function OperationDefinition() {
                return false;
            },
            FragmentDefinition: function FragmentDefinition(node) {
                var fragmentName = node.name.value;
                if (knownFragmentNames[fragmentName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                    knownFragmentNames[fragmentName],
                    node.name
                ]));
                else knownFragmentNames[fragmentName] = node.name;
                return false;
            }
        };
    }
});
parcelRegister("coK44", function(module, exports) {
    $parcel$export(module.exports, "KnownFragmentNamesRule", ()=>$906b756e66eb2437$export$94c8dd81fb6d3111);
    var $g5yZB;
    function $906b756e66eb2437$export$94c8dd81fb6d3111(context) {
        return {
            FragmentSpread: function FragmentSpread(node) {
                var fragmentName = node.name.value;
                var fragment = context.getFragment(fragmentName);
                if (!fragment) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
            }
        };
    }
});
parcelRegister("8m6li", function(module, exports) {
    $parcel$export(module.exports, "NoUnusedFragmentsRule", ()=>$61554c485d05a096$export$d29d2e5ed74717af);
    var $g5yZB;
    function $61554c485d05a096$export$d29d2e5ed74717af(context) {
        var operationDefs = [];
        var fragmentDefs = [];
        return {
            OperationDefinition: function OperationDefinition(node) {
                operationDefs.push(node);
                return false;
            },
            FragmentDefinition: function FragmentDefinition(node) {
                fragmentDefs.push(node);
                return false;
            },
            Document: {
                leave: function leave() {
                    var fragmentNameUsed = Object.create(null);
                    for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                        var operation = operationDefs[_i2];
                        for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                            var fragment = _context$getRecursive2[_i4];
                            fragmentNameUsed[fragment.name.value] = true;
                        }
                    }
                    for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                        var fragmentDef = fragmentDefs[_i6];
                        var fragName = fragmentDef.name.value;
                        if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                    }
                }
            }
        };
    }
});
parcelRegister("3wQxN", function(module, exports) {
    $parcel$export(module.exports, "PossibleFragmentSpreadsRule", ()=>$291d1e654f5f2bf9$export$aa7b39ab48da3359);
    var $yEDl8;
    var $g5yZB;
    var $8oLgk;
    var $6D4Eu;
    var $9GswX;
    function $291d1e654f5f2bf9$export$aa7b39ab48da3359(context) {
        return {
            InlineFragment: function InlineFragment(node) {
                var fragType = context.getType();
                var parentType = context.getParentType();
                if ((0, (0, parcelRequire("8oLgk")).isCompositeType)(fragType) && (0, (0, parcelRequire("8oLgk")).isCompositeType)(parentType) && !(0, (0, parcelRequire("9GswX")).doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                    var parentTypeStr = (0, (0, parcelRequire("yEDl8")).default)(parentType);
                    var fragTypeStr = (0, (0, parcelRequire("yEDl8")).default)(fragType);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
                }
            },
            FragmentSpread: function FragmentSpread(node) {
                var fragName = node.name.value;
                var fragType = $291d1e654f5f2bf9$var$getFragmentType(context, fragName);
                var parentType = context.getParentType();
                if (fragType && parentType && !(0, (0, parcelRequire("9GswX")).doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                    var parentTypeStr = (0, (0, parcelRequire("yEDl8")).default)(parentType);
                    var fragTypeStr = (0, (0, parcelRequire("yEDl8")).default)(fragType);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
                }
            }
        };
    }
    function $291d1e654f5f2bf9$var$getFragmentType(context, name) {
        var frag = context.getFragment(name);
        if (frag) {
            var type = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), frag.typeCondition);
            if ((0, (0, parcelRequire("8oLgk")).isCompositeType)(type)) return type;
        }
    }
});
parcelRegister("90jMN", function(module, exports) {
    $parcel$export(module.exports, "NoFragmentCyclesRule", ()=>$68e3764329525fe9$export$25eccb87f5a000e6);
    var $g5yZB;
    function $68e3764329525fe9$export$25eccb87f5a000e6(context) {
        var visitedFrags = Object.create(null);
        var spreadPath = [];
        var spreadPathIndexByName = Object.create(null);
        return {
            OperationDefinition: function OperationDefinition() {
                return false;
            },
            FragmentDefinition: function FragmentDefinition(node) {
                detectCycleRecursive(node);
                return false;
            }
        };
        function detectCycleRecursive(fragment) {
            if (visitedFrags[fragment.name.value]) return;
            var fragmentName = fragment.name.value;
            visitedFrags[fragmentName] = true;
            var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
            if (spreadNodes.length === 0) return;
            spreadPathIndexByName[fragmentName] = spreadPath.length;
            for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
                var spreadNode = spreadNodes[_i2];
                var spreadName = spreadNode.name.value;
                var cycleIndex = spreadPathIndexByName[spreadName];
                spreadPath.push(spreadNode);
                if (cycleIndex === undefined) {
                    var spreadFragment = context.getFragment(spreadName);
                    if (spreadFragment) detectCycleRecursive(spreadFragment);
                } else {
                    var cyclePath = spreadPath.slice(cycleIndex);
                    var viaPath = cyclePath.slice(0, -1).map(function(s) {
                        return '"' + s.name.value + '"';
                    }).join(', ');
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
                }
                spreadPath.pop();
            }
            spreadPathIndexByName[fragmentName] = undefined;
        }
    }
});
parcelRegister("5OxVI", function(module, exports) {
    $parcel$export(module.exports, "UniqueVariableNamesRule", ()=>$43bbf10c49115329$export$b9352e3a23ba4aa2);
    var $g5yZB;
    function $43bbf10c49115329$export$b9352e3a23ba4aa2(context) {
        var knownVariableNames = Object.create(null);
        return {
            OperationDefinition: function OperationDefinition() {
                knownVariableNames = Object.create(null);
            },
            VariableDefinition: function VariableDefinition(node) {
                var variableName = node.variable.name.value;
                if (knownVariableNames[variableName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                    knownVariableNames[variableName],
                    node.variable.name
                ]));
                else knownVariableNames[variableName] = node.variable.name;
            }
        };
    }
});
parcelRegister("4uTwu", function(module, exports) {
    $parcel$export(module.exports, "NoUndefinedVariablesRule", ()=>$34650881b8ee1909$export$207476dbb3f797ab);
    var $g5yZB;
    function $34650881b8ee1909$export$207476dbb3f797ab(context) {
        var variableNameDefined = Object.create(null);
        return {
            OperationDefinition: {
                enter: function enter() {
                    variableNameDefined = Object.create(null);
                },
                leave: function leave(operation) {
                    var usages = context.getRecursiveVariableUsages(operation);
                    for(var _i2 = 0; _i2 < usages.length; _i2++){
                        var _ref2 = usages[_i2];
                        var node = _ref2.node;
                        var varName = node.name.value;
                        if (variableNameDefined[varName] !== true) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                            node,
                            operation
                        ]));
                    }
                }
            },
            VariableDefinition: function VariableDefinition(node) {
                variableNameDefined[node.variable.name.value] = true;
            }
        };
    }
});
parcelRegister("9TmyO", function(module, exports) {
    $parcel$export(module.exports, "NoUnusedVariablesRule", ()=>$733ac02bd245c808$export$300a3bc5a4f49273);
    var $g5yZB;
    function $733ac02bd245c808$export$300a3bc5a4f49273(context) {
        var variableDefs = [];
        return {
            OperationDefinition: {
                enter: function enter() {
                    variableDefs = [];
                },
                leave: function leave(operation) {
                    var variableNameUsed = Object.create(null);
                    var usages = context.getRecursiveVariableUsages(operation);
                    for(var _i2 = 0; _i2 < usages.length; _i2++){
                        var _ref2 = usages[_i2];
                        var node = _ref2.node;
                        variableNameUsed[node.name.value] = true;
                    }
                    for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                        var variableDef = _variableDefs2[_i4];
                        var variableName = variableDef.variable.name.value;
                        if (variableNameUsed[variableName] !== true) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                    }
                }
            },
            VariableDefinition: function VariableDefinition(def) {
                variableDefs.push(def);
            }
        };
    }
});
parcelRegister("3N4Hj", function(module, exports) {
    $parcel$export(module.exports, "KnownDirectivesRule", ()=>$2c299789e5aa218d$export$f4ca94d7d1cf5874);
    var $yEDl8;
    var $fM9AB;
    var $g5yZB;
    var $bzIlO;
    var $jADQJ;
    var $35Smo;
    function $2c299789e5aa218d$export$f4ca94d7d1cf5874(context) {
        var locationsMap = Object.create(null);
        var schema = context.getSchema();
        var definedDirectives = schema ? schema.getDirectives() : (0, (0, parcelRequire("35Smo")).specifiedDirectives);
        for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
            var directive = definedDirectives[_i2];
            locationsMap[directive.name] = directive.locations;
        }
        var astDefinitions = context.getDocument().definitions;
        for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
            var def = astDefinitions[_i4];
            if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
                return name.value;
            });
        }
        return {
            Directive: function Directive(node, _key, _parent, _path, ancestors) {
                var name = node.name.value;
                var locations = locationsMap[name];
                if (!locations) {
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                    return;
                }
                var candidateLocation = $2c299789e5aa218d$var$getDirectiveLocationForASTPath(ancestors);
                if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
            }
        };
    }
    function $2c299789e5aa218d$var$getDirectiveLocationForASTPath(ancestors) {
        var appliedTo = ancestors[ancestors.length - 1];
        !Array.isArray(appliedTo) || (0, (0, parcelRequire("fM9AB")).default)(0);
        switch(appliedTo.kind){
            case (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION:
                return $2c299789e5aa218d$var$getDirectiveLocationForOperation(appliedTo.operation);
            case (0, (0, parcelRequire("bzIlO")).Kind).FIELD:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD;
            case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_SPREAD;
            case (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INLINE_FRAGMENT;
            case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FRAGMENT_DEFINITION;
            case (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE_DEFINITION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).VARIABLE_DEFINITION;
            case (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SCHEMA;
            case (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SCALAR;
            case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).OBJECT;
            case (0, (0, parcelRequire("bzIlO")).Kind).FIELD_DEFINITION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).FIELD_DEFINITION;
            case (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INTERFACE;
            case (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).UNION;
            case (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ENUM;
            case (0, (0, parcelRequire("bzIlO")).Kind).ENUM_VALUE_DEFINITION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ENUM_VALUE;
            case (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION:
            case (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION:
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INPUT_OBJECT;
            case (0, (0, parcelRequire("bzIlO")).Kind).INPUT_VALUE_DEFINITION:
                var parentNode = ancestors[ancestors.length - 3];
                return parentNode.kind === (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, (0, parcelRequire("jADQJ")).DirectiveLocation).INPUT_FIELD_DEFINITION : (0, (0, parcelRequire("jADQJ")).DirectiveLocation).ARGUMENT_DEFINITION;
        }
    }
    function $2c299789e5aa218d$var$getDirectiveLocationForOperation(operation) {
        switch(operation){
            case 'query':
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).QUERY;
            case 'mutation':
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).MUTATION;
            case 'subscription':
                return (0, (0, parcelRequire("jADQJ")).DirectiveLocation).SUBSCRIPTION;
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected operation: ' + (0, (0, parcelRequire("yEDl8")).default)(operation));
    }
});
parcelRegister("VWtb8", function(module, exports) {
    $parcel$export(module.exports, "UniqueDirectivesPerLocationRule", ()=>$0ae2add5c5a85d4e$export$4a38f68ea408504c);
    var $g5yZB;
    var $bzIlO;
    var $Zbk4Z;
    var $35Smo;
    function $0ae2add5c5a85d4e$export$4a38f68ea408504c(context) {
        var uniqueDirectiveMap = Object.create(null);
        var schema = context.getSchema();
        var definedDirectives = schema ? schema.getDirectives() : (0, (0, parcelRequire("35Smo")).specifiedDirectives);
        for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
            var directive = definedDirectives[_i2];
            uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
        }
        var astDefinitions = context.getDocument().definitions;
        for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
            var def = astDefinitions[_i4];
            if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
        }
        var schemaDirectives = Object.create(null);
        var typeDirectivesMap = Object.create(null);
        return {
            enter: function enter(node) {
                if (node.directives == null) return;
                var seenDirectives;
                if (node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION || node.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
                else if ((0, (0, parcelRequire("Zbk4Z")).isTypeDefinitionNode)(node) || (0, (0, parcelRequire("Zbk4Z")).isTypeExtensionNode)(node)) {
                    var typeName = node.name.value;
                    seenDirectives = typeDirectivesMap[typeName];
                    if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
                } else seenDirectives = Object.create(null);
                for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                    var _directive = _node$directives2[_i6];
                    var directiveName = _directive.name.value;
                    if (uniqueDirectiveMap[directiveName]) {
                        if (seenDirectives[directiveName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                            seenDirectives[directiveName],
                            _directive
                        ]));
                        else seenDirectives[directiveName] = _directive;
                    }
                }
            }
        };
    }
});
parcelRegister("9WoAw", function(module, exports) {
    $parcel$export(module.exports, "KnownArgumentNamesRule", ()=>$73cc9a88ccecd808$export$5d7b3b4b6779c802);
    $parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", ()=>$73cc9a88ccecd808$export$6eb6eb4c5417f2c4);
    var $h4f6N;
    var $gXVhx;
    var $g5yZB;
    var $bzIlO;
    var $35Smo;
    function $73cc9a88ccecd808$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $73cc9a88ccecd808$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) $73cc9a88ccecd808$var$ownKeys(Object(source), true).forEach(function(key) {
                $73cc9a88ccecd808$var$_defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else $73cc9a88ccecd808$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $73cc9a88ccecd808$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $73cc9a88ccecd808$export$5d7b3b4b6779c802(context) {
        return $73cc9a88ccecd808$var$_objectSpread($73cc9a88ccecd808$var$_objectSpread({}, $73cc9a88ccecd808$export$6eb6eb4c5417f2c4(context)), {}, {
            Argument: function Argument(argNode) {
                var argDef = context.getArgument();
                var fieldDef = context.getFieldDef();
                var parentType = context.getParentType();
                if (!argDef && fieldDef && parentType) {
                    var argName = argNode.name.value;
                    var knownArgsNames = fieldDef.args.map(function(arg) {
                        return arg.name;
                    });
                    var suggestions = (0, (0, parcelRequire("gXVhx")).default)(argName, knownArgsNames);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, (0, parcelRequire("h4f6N")).default)(suggestions), argNode));
                }
            }
        });
    }
    function $73cc9a88ccecd808$export$6eb6eb4c5417f2c4(context) {
        var directiveArgs = Object.create(null);
        var schema = context.getSchema();
        var definedDirectives = schema ? schema.getDirectives() : (0, (0, parcelRequire("35Smo")).specifiedDirectives);
        for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
            var directive = definedDirectives[_i2];
            directiveArgs[directive.name] = directive.args.map(function(arg) {
                return arg.name;
            });
        }
        var astDefinitions = context.getDocument().definitions;
        for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
            var def = astDefinitions[_i4];
            if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION) {
                var _def$arguments;
                var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
                directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                    return arg.name.value;
                });
            }
        }
        return {
            Directive: function Directive(directiveNode) {
                var directiveName = directiveNode.name.value;
                var knownArgs = directiveArgs[directiveName];
                if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                    var argNode = _directiveNode$argume2[_i6];
                    var argName = argNode.name.value;
                    if (knownArgs.indexOf(argName) === -1) {
                        var suggestions = (0, (0, parcelRequire("gXVhx")).default)(argName, knownArgs);
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, (0, parcelRequire("h4f6N")).default)(suggestions), argNode));
                    }
                }
                return false;
            }
        };
    }
});
parcelRegister("36Mx7", function(module, exports) {
    $parcel$export(module.exports, "UniqueArgumentNamesRule", ()=>$243794514e5ad328$export$8598b5acb1d855ca);
    var $g5yZB;
    function $243794514e5ad328$export$8598b5acb1d855ca(context) {
        var knownArgNames = Object.create(null);
        return {
            Field: function Field() {
                knownArgNames = Object.create(null);
            },
            Directive: function Directive() {
                knownArgNames = Object.create(null);
            },
            Argument: function Argument(node) {
                var argName = node.name.value;
                if (knownArgNames[argName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                    knownArgNames[argName],
                    node.name
                ]));
                else knownArgNames[argName] = node.name;
                return false;
            }
        };
    }
});
parcelRegister("5wBGi", function(module, exports) {
    $parcel$export(module.exports, "ValuesOfCorrectTypeRule", ()=>$405d2ba245013b29$export$669bf87f50cfda9b);
    var $isVmt;
    var $aRWmX;
    var $yEDl8;
    var $h4f6N;
    var $gXVhx;
    var $g5yZB;
    var $1c8Um;
    var $8oLgk;
    function $405d2ba245013b29$export$669bf87f50cfda9b(context) {
        return {
            ListValue: function ListValue(node) {
                var type = (0, (0, parcelRequire("8oLgk")).getNullableType)(context.getParentInputType());
                if (!(0, (0, parcelRequire("8oLgk")).isListType)(type)) {
                    $405d2ba245013b29$var$isValidValueNode(context, node);
                    return false;
                }
            },
            ObjectValue: function ObjectValue(node) {
                var type = (0, (0, parcelRequire("8oLgk")).getNamedType)(context.getInputType());
                if (!(0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) {
                    $405d2ba245013b29$var$isValidValueNode(context, node);
                    return false;
                }
                var fieldNodeMap = (0, (0, parcelRequire("aRWmX")).default)(node.fields, function(field) {
                    return field.name.value;
                });
                for(var _i2 = 0, _objectValues2 = (0, (0, parcelRequire("isVmt")).default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                    var fieldDef = _objectValues2[_i2];
                    var fieldNode = fieldNodeMap[fieldDef.name];
                    if (!fieldNode && (0, (0, parcelRequire("8oLgk")).isRequiredInputField)(fieldDef)) {
                        var typeStr = (0, (0, parcelRequire("yEDl8")).default)(fieldDef.type);
                        context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                    }
                }
            },
            ObjectField: function ObjectField(node) {
                var parentType = (0, (0, parcelRequire("8oLgk")).getNamedType)(context.getParentInputType());
                var fieldType = context.getInputType();
                if (!fieldType && (0, (0, parcelRequire("8oLgk")).isInputObjectType)(parentType)) {
                    var suggestions = (0, (0, parcelRequire("gXVhx")).default)(node.name.value, Object.keys(parentType.getFields()));
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, (0, parcelRequire("h4f6N")).default)(suggestions), node));
                }
            },
            NullValue: function NullValue(node) {
                var type = context.getInputType();
                if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected value of type \"".concat((0, (0, parcelRequire("yEDl8")).default)(type), "\", found ").concat((0, (0, parcelRequire("1c8Um")).print)(node), "."), node));
            },
            EnumValue: function EnumValue(node) {
                return $405d2ba245013b29$var$isValidValueNode(context, node);
            },
            IntValue: function IntValue(node) {
                return $405d2ba245013b29$var$isValidValueNode(context, node);
            },
            FloatValue: function FloatValue(node) {
                return $405d2ba245013b29$var$isValidValueNode(context, node);
            },
            StringValue: function StringValue(node) {
                return $405d2ba245013b29$var$isValidValueNode(context, node);
            },
            BooleanValue: function BooleanValue(node) {
                return $405d2ba245013b29$var$isValidValueNode(context, node);
            }
        };
    }
    function $405d2ba245013b29$var$isValidValueNode(context, node) {
        var locationType = context.getInputType();
        if (!locationType) return;
        var type = (0, (0, parcelRequire("8oLgk")).getNamedType)(locationType);
        if (!(0, (0, parcelRequire("8oLgk")).isLeafType)(type)) {
            var typeStr = (0, (0, parcelRequire("yEDl8")).default)(locationType);
            context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, (0, parcelRequire("1c8Um")).print)(node), "."), node));
            return;
        }
        try {
            var parseResult = type.parseLiteral(node, undefined);
            if (parseResult === undefined) {
                var _typeStr = (0, (0, parcelRequire("yEDl8")).default)(locationType);
                context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, (0, parcelRequire("1c8Um")).print)(node), "."), node));
            }
        } catch (error) {
            var _typeStr2 = (0, (0, parcelRequire("yEDl8")).default)(locationType);
            if (error instanceof (0, (0, parcelRequire("g5yZB")).GraphQLError)) context.reportError(error);
            else context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, (0, parcelRequire("1c8Um")).print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
        }
    }
});
parcelRegister("jpyH1", function(module, exports) {
    $parcel$export(module.exports, "ProvidedRequiredArgumentsRule", ()=>$e21b436f05c5ec12$export$4df169576372c8b2);
    $parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", ()=>$e21b436f05c5ec12$export$5ff6a71c337c020f);
    var $yEDl8;
    var $aRWmX;
    var $g5yZB;
    var $bzIlO;
    var $1c8Um;
    var $35Smo;
    var $8oLgk;
    function $e21b436f05c5ec12$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $e21b436f05c5ec12$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) $e21b436f05c5ec12$var$ownKeys(Object(source), true).forEach(function(key) {
                $e21b436f05c5ec12$var$_defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else $e21b436f05c5ec12$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $e21b436f05c5ec12$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $e21b436f05c5ec12$export$4df169576372c8b2(context) {
        return $e21b436f05c5ec12$var$_objectSpread($e21b436f05c5ec12$var$_objectSpread({}, $e21b436f05c5ec12$export$5ff6a71c337c020f(context)), {}, {
            Field: {
                leave: function leave(fieldNode) {
                    var _fieldNode$arguments;
                    var fieldDef = context.getFieldDef();
                    if (!fieldDef) return false;
                    var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                    var argNodeMap = (0, (0, parcelRequire("aRWmX")).default)(argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                        var argDef = _fieldDef$args2[_i2];
                        var argNode = argNodeMap[argDef.name];
                        if (!argNode && (0, (0, parcelRequire("8oLgk")).isRequiredArgument)(argDef)) {
                            var argTypeStr = (0, (0, parcelRequire("yEDl8")).default)(argDef.type);
                            context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                        }
                    }
                }
            }
        });
    }
    function $e21b436f05c5ec12$export$5ff6a71c337c020f(context) {
        var requiredArgsMap = Object.create(null);
        var schema = context.getSchema();
        var definedDirectives = schema ? schema.getDirectives() : (0, (0, parcelRequire("35Smo")).specifiedDirectives);
        for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
            var directive = definedDirectives[_i4];
            requiredArgsMap[directive.name] = (0, (0, parcelRequire("aRWmX")).default)(directive.args.filter((0, (0, parcelRequire("8oLgk")).isRequiredArgument)), function(arg) {
                return arg.name;
            });
        }
        var astDefinitions = context.getDocument().definitions;
        for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
            var def = astDefinitions[_i6];
            if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION) {
                var _def$arguments;
                var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
                requiredArgsMap[def.name.value] = (0, (0, parcelRequire("aRWmX")).default)(argNodes.filter($e21b436f05c5ec12$var$isRequiredArgumentNode), function(arg) {
                    return arg.name.value;
                });
            }
        }
        return {
            Directive: {
                leave: function leave(directiveNode) {
                    var directiveName = directiveNode.name.value;
                    var requiredArgs = requiredArgsMap[directiveName];
                    if (requiredArgs) {
                        var _directiveNode$argume;
                        var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                        var argNodeMap = (0, (0, parcelRequire("aRWmX")).default)(_argNodes, function(arg) {
                            return arg.name.value;
                        });
                        for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                            var argName = _Object$keys2[_i8];
                            if (!argNodeMap[argName]) {
                                var argType = requiredArgs[argName].type;
                                var argTypeStr = (0, (0, parcelRequire("8oLgk")).isType)(argType) ? (0, (0, parcelRequire("yEDl8")).default)(argType) : (0, (0, parcelRequire("1c8Um")).print)(argType);
                                context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                            }
                        }
                    }
                }
            }
        };
    }
    function $e21b436f05c5ec12$var$isRequiredArgumentNode(arg) {
        return arg.type.kind === (0, (0, parcelRequire("bzIlO")).Kind).NON_NULL_TYPE && arg.defaultValue == null;
    }
});
parcelRegister("8gRGf", function(module, exports) {
    $parcel$export(module.exports, "VariablesInAllowedPositionRule", ()=>$605975302951678f$export$7251631d636f2f74);
    var $yEDl8;
    var $g5yZB;
    var $bzIlO;
    var $8oLgk;
    var $6D4Eu;
    var $9GswX;
    function $605975302951678f$export$7251631d636f2f74(context) {
        var varDefMap = Object.create(null);
        return {
            OperationDefinition: {
                enter: function enter() {
                    varDefMap = Object.create(null);
                },
                leave: function leave(operation) {
                    var usages = context.getRecursiveVariableUsages(operation);
                    for(var _i2 = 0; _i2 < usages.length; _i2++){
                        var _ref2 = usages[_i2];
                        var node = _ref2.node;
                        var type = _ref2.type;
                        var defaultValue = _ref2.defaultValue;
                        var varName = node.name.value;
                        var varDef = varDefMap[varName];
                        if (varDef && type) {
                            var schema = context.getSchema();
                            var varType = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(schema, varDef.type);
                            if (varType && !$605975302951678f$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                                var varTypeStr = (0, (0, parcelRequire("yEDl8")).default)(varType);
                                var typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
                                context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                    varDef,
                                    node
                                ]));
                            }
                        }
                    }
                }
            },
            VariableDefinition: function VariableDefinition(node) {
                varDefMap[node.variable.name.value] = node;
            }
        };
    }
    function $605975302951678f$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(locationType) && !(0, (0, parcelRequire("8oLgk")).isNonNullType)(varType)) {
            var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, (0, parcelRequire("bzIlO")).Kind).NULL;
            var hasLocationDefaultValue = locationDefaultValue !== undefined;
            if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
            var nullableLocationType = locationType.ofType;
            return (0, (0, parcelRequire("9GswX")).isTypeSubTypeOf)(schema, varType, nullableLocationType);
        }
        return (0, (0, parcelRequire("9GswX")).isTypeSubTypeOf)(schema, varType, locationType);
    }
});
parcelRegister("gA8jd", function(module, exports) {
    $parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", ()=>$c126741f4d796028$export$ca8652d62af5670);
    var $85NSv;
    var $ge05d;
    var $yEDl8;
    var $g5yZB;
    var $bzIlO;
    var $1c8Um;
    var $8oLgk;
    var $6D4Eu;
    function $c126741f4d796028$var$reasonMessage(reason) {
        if (Array.isArray(reason)) return reason.map(function(_ref) {
            var responseName = _ref[0], subReason = _ref[1];
            return "subfields \"".concat(responseName, "\" conflict because ") + $c126741f4d796028$var$reasonMessage(subReason);
        }).join(' and ');
        return reason;
    }
    function $c126741f4d796028$export$ca8652d62af5670(context) {
        var comparedFragmentPairs = new $c126741f4d796028$var$PairSet();
        var cachedFieldsAndFragmentNames = new Map();
        return {
            SelectionSet: function SelectionSet(selectionSet) {
                var conflicts = $c126741f4d796028$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
                for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                    var _ref3 = conflicts[_i2];
                    var _ref2$ = _ref3[0];
                    var responseName = _ref2$[0];
                    var reason = _ref2$[1];
                    var fields1 = _ref3[1];
                    var fields2 = _ref3[2];
                    var reasonMsg = $c126741f4d796028$var$reasonMessage(reason);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
                }
            }
        };
    }
    function $c126741f4d796028$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
        var conflicts = [];
        var _getFieldsAndFragment = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1];
        $c126741f4d796028$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
        if (fragmentNames.length !== 0) for(var i = 0; i < fragmentNames.length; i++){
            $c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]);
            for(var j = i + 1; j < fragmentNames.length; j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
        }
        return conflicts;
    }
    function $c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
        var fragment = context.getFragment(fragmentName);
        if (!fragment) return;
        var _getReferencedFieldsA = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1];
        if (fieldMap === fieldMap2) return;
        $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2);
        for(var i = 0; i < fragmentNames2.length; i++)$c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
    }
    function $c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
        if (fragmentName1 === fragmentName2) return;
        if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
        comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
        var fragment1 = context.getFragment(fragmentName1);
        var fragment2 = context.getFragment(fragmentName2);
        if (!fragment1 || !fragment2) return;
        var _getReferencedFieldsA2 = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
        var _getReferencedFieldsA3 = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1];
        $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);
        for(var j = 0; j < fragmentNames2.length; j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
        for(var i = 0; i < fragmentNames1.length; i++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
    }
    function $c126741f4d796028$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
        var conflicts = [];
        var _getFieldsAndFragment2 = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
        var _getFieldsAndFragment3 = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1];
        $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);
        if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)$c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
        if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)$c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
        for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
        return conflicts;
    }
    function $c126741f4d796028$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
        for(var _i5 = 0, _objectEntries2 = (0, (0, parcelRequire("ge05d")).default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
            var _ref5 = _objectEntries2[_i5];
            var responseName = _ref5[0];
            var fields = _ref5[1];
            if (fields.length > 1) {
                for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                    var conflict = $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                    if (conflict) conflicts.push(conflict);
                }
            }
        }
    }
    function $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
        for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
            var responseName = _Object$keys2[_i7];
            var fields2 = fieldMap2[responseName];
            if (fields2) {
                var fields1 = fieldMap1[responseName];
                for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                    var conflict = $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                    if (conflict) conflicts.push(conflict);
                }
            }
        }
    }
    function $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
        var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
        var parentType2 = field2[0], node2 = field2[1], def2 = field2[2];
        var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, (0, parcelRequire("8oLgk")).isObjectType)(parentType1) && (0, (0, parcelRequire("8oLgk")).isObjectType)(parentType2);
        if (!areMutuallyExclusive) {
            var _node1$arguments, _node2$arguments;
            var name1 = node1.name.value;
            var name2 = node2.name.value;
            if (name1 !== name2) return [
                [
                    responseName,
                    "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
                ],
                [
                    node1
                ],
                [
                    node2
                ]
            ];
            var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : [];
            var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : [];
            if (!$c126741f4d796028$var$sameArguments(args1, args2)) return [
                [
                    responseName,
                    'they have differing arguments'
                ],
                [
                    node1
                ],
                [
                    node2
                ]
            ];
        }
        var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
        var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
        if (type1 && type2 && $c126741f4d796028$var$doTypesConflict(type1, type2)) return [
            [
                responseName,
                "they return conflicting types \"".concat((0, (0, parcelRequire("yEDl8")).default)(type1), "\" and \"").concat((0, (0, parcelRequire("yEDl8")).default)(type2), "\"")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
        var selectionSet1 = node1.selectionSet;
        var selectionSet2 = node2.selectionSet;
        if (selectionSet1 && selectionSet2) {
            var conflicts = $c126741f4d796028$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, (0, parcelRequire("8oLgk")).getNamedType)(type1), selectionSet1, (0, (0, parcelRequire("8oLgk")).getNamedType)(type2), selectionSet2);
            return $c126741f4d796028$var$subfieldConflicts(conflicts, responseName, node1, node2);
        }
    }
    function $c126741f4d796028$var$sameArguments(arguments1, arguments2) {
        if (arguments1.length !== arguments2.length) return false;
        return arguments1.every(function(argument1) {
            var argument2 = (0, (0, parcelRequire("85NSv")).default)(arguments2, function(argument) {
                return argument.name.value === argument1.name.value;
            });
            if (!argument2) return false;
            return $c126741f4d796028$var$sameValue(argument1.value, argument2.value);
        });
    }
    function $c126741f4d796028$var$sameValue(value1, value2) {
        return (0, (0, parcelRequire("1c8Um")).print)(value1) === (0, (0, parcelRequire("1c8Um")).print)(value2);
    }
    function $c126741f4d796028$var$doTypesConflict(type1, type2) {
        if ((0, (0, parcelRequire("8oLgk")).isListType)(type1)) return (0, (0, parcelRequire("8oLgk")).isListType)(type2) ? $c126741f4d796028$var$doTypesConflict(type1.ofType, type2.ofType) : true;
        if ((0, (0, parcelRequire("8oLgk")).isListType)(type2)) return true;
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type1)) return (0, (0, parcelRequire("8oLgk")).isNonNullType)(type2) ? $c126741f4d796028$var$doTypesConflict(type1.ofType, type2.ofType) : true;
        if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type2)) return true;
        if ((0, (0, parcelRequire("8oLgk")).isLeafType)(type1) || (0, (0, parcelRequire("8oLgk")).isLeafType)(type2)) return type1 !== type2;
        return false;
    }
    function $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
        var cached = cachedFieldsAndFragmentNames.get(selectionSet);
        if (!cached) {
            var nodeAndDefs = Object.create(null);
            var fragmentNames = Object.create(null);
            $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
            cached = [
                nodeAndDefs,
                Object.keys(fragmentNames)
            ];
            cachedFieldsAndFragmentNames.set(selectionSet, cached);
        }
        return cached;
    }
    function $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
        var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
        if (cached) return cached;
        var fragmentType = (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), fragment.typeCondition);
        return $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
    }
    function $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
        for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
            var selection = _selectionSet$selecti2[_i9];
            switch(selection.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).FIELD:
                    var fieldName = selection.name.value;
                    var fieldDef = void 0;
                    if ((0, (0, parcelRequire("8oLgk")).isObjectType)(parentType) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                    var responseName = selection.alias ? selection.alias.value : fieldName;
                    if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                    nodeAndDefs[responseName].push([
                        parentType,
                        selection,
                        fieldDef
                    ]);
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD:
                    fragmentNames[selection.name.value] = true;
                    break;
                case (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT:
                    var typeCondition = selection.typeCondition;
                    var inlineFragmentType = typeCondition ? (0, (0, parcelRequire("6D4Eu")).typeFromAST)(context.getSchema(), typeCondition) : parentType;
                    $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                    break;
            }
        }
    }
    function $c126741f4d796028$var$subfieldConflicts(conflicts, responseName, node1, node2) {
        if (conflicts.length > 0) return [
            [
                responseName,
                conflicts.map(function(_ref6) {
                    var reason = _ref6[0];
                    return reason;
                })
            ],
            conflicts.reduce(function(allFields, _ref7) {
                var fields1 = _ref7[1];
                return allFields.concat(fields1);
            }, [
                node1
            ]),
            conflicts.reduce(function(allFields, _ref8) {
                var fields2 = _ref8[2];
                return allFields.concat(fields2);
            }, [
                node2
            ])
        ];
    }
    var $c126741f4d796028$var$PairSet = function() {
        function PairSet() {
            this._data = Object.create(null);
        }
        var _proto = PairSet.prototype;
        _proto.has = function has(a, b, areMutuallyExclusive) {
            var first = this._data[a];
            var result = first && first[b];
            if (result === undefined) return false;
            if (areMutuallyExclusive === false) return result === false;
            return true;
        };
        _proto.add = function add(a, b, areMutuallyExclusive) {
            this._pairSetAdd(a, b, areMutuallyExclusive);
            this._pairSetAdd(b, a, areMutuallyExclusive);
        };
        _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
            var map = this._data[a];
            if (!map) {
                map = Object.create(null);
                this._data[a] = map;
            }
            map[b] = areMutuallyExclusive;
        };
        return PairSet;
    }();
});
parcelRegister("dAQg3", function(module, exports) {
    $parcel$export(module.exports, "UniqueInputFieldNamesRule", ()=>$9e572c7b7d0b165f$export$de7865c052ebdd8c);
    var $g5yZB;
    function $9e572c7b7d0b165f$export$de7865c052ebdd8c(context) {
        var knownNameStack = [];
        var knownNames = Object.create(null);
        return {
            ObjectValue: {
                enter: function enter() {
                    knownNameStack.push(knownNames);
                    knownNames = Object.create(null);
                },
                leave: function leave() {
                    knownNames = knownNameStack.pop();
                }
            },
            ObjectField: function ObjectField(node) {
                var fieldName = node.name.value;
                if (knownNames[fieldName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                    knownNames[fieldName],
                    node.name
                ]));
                else knownNames[fieldName] = node.name;
            }
        };
    }
});
parcelRegister("beSbb", function(module, exports) {
    $parcel$export(module.exports, "LoneSchemaDefinitionRule", ()=>$82eb0766008462c1$export$9eae4c44f9d64405);
    var $g5yZB;
    function $82eb0766008462c1$export$9eae4c44f9d64405(context) {
        var _ref, _ref2, _oldSchema$astNode;
        var oldSchema = context.getSchema();
        var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
        var schemaDefinitionsCount = 0;
        return {
            SchemaDefinition: function SchemaDefinition(node) {
                if (alreadyDefined) {
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Cannot define a new schema within a schema extension.', node));
                    return;
                }
                if (schemaDefinitionsCount > 0) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)('Must provide only one schema definition.', node));
                ++schemaDefinitionsCount;
            }
        };
    }
});
parcelRegister("gBAc1", function(module, exports) {
    $parcel$export(module.exports, "UniqueOperationTypesRule", ()=>$c16c2d2ce33c43fe$export$d9750570c6d13894);
    var $g5yZB;
    function $c16c2d2ce33c43fe$export$d9750570c6d13894(context) {
        var schema = context.getSchema();
        var definedOperationTypes = Object.create(null);
        var existingOperationTypes = schema ? {
            query: schema.getQueryType(),
            mutation: schema.getMutationType(),
            subscription: schema.getSubscriptionType()
        } : {};
        return {
            SchemaDefinition: checkOperationTypes,
            SchemaExtension: checkOperationTypes
        };
        function checkOperationTypes(node) {
            var _node$operationTypes;
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
                var operationType = operationTypesNodes[_i2];
                var operation = operationType.operation;
                var alreadyDefinedOperationType = definedOperationTypes[operation];
                if (existingOperationTypes[operation]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
                else if (alreadyDefinedOperationType) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                    alreadyDefinedOperationType,
                    operationType
                ]));
                else definedOperationTypes[operation] = operationType;
            }
            return false;
        }
    }
});
parcelRegister("3iH5k", function(module, exports) {
    $parcel$export(module.exports, "UniqueTypeNamesRule", ()=>$2674794b3064400c$export$380307ee0123f80e);
    var $g5yZB;
    function $2674794b3064400c$export$380307ee0123f80e(context) {
        var knownTypeNames = Object.create(null);
        var schema = context.getSchema();
        return {
            ScalarTypeDefinition: checkTypeName,
            ObjectTypeDefinition: checkTypeName,
            InterfaceTypeDefinition: checkTypeName,
            UnionTypeDefinition: checkTypeName,
            EnumTypeDefinition: checkTypeName,
            InputObjectTypeDefinition: checkTypeName
        };
        function checkTypeName(node) {
            var typeName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
                context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
                return;
            }
            if (knownTypeNames[typeName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
                knownTypeNames[typeName],
                node.name
            ]));
            else knownTypeNames[typeName] = node.name;
            return false;
        }
    }
});
parcelRegister("j74Ua", function(module, exports) {
    $parcel$export(module.exports, "UniqueEnumValueNamesRule", ()=>$dea279ceaaf7e545$export$f5a22bb45cdc635d);
    var $g5yZB;
    var $8oLgk;
    function $dea279ceaaf7e545$export$f5a22bb45cdc635d(context) {
        var schema = context.getSchema();
        var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
        var knownValueNames = Object.create(null);
        return {
            EnumTypeDefinition: checkValueUniqueness,
            EnumTypeExtension: checkValueUniqueness
        };
        function checkValueUniqueness(node) {
            var _node$values;
            var typeName = node.name.value;
            if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
            var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            var valueNames = knownValueNames[typeName];
            for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
                var valueDef = valueNodes[_i2];
                var valueName = valueDef.name.value;
                var existingType = existingTypeMap[typeName];
                if ((0, (0, parcelRequire("8oLgk")).isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
                else if (valueNames[valueName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                    valueNames[valueName],
                    valueDef.name
                ]));
                else valueNames[valueName] = valueDef.name;
            }
            return false;
        }
    }
});
parcelRegister("9mu02", function(module, exports) {
    $parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", ()=>$6d0d7072a4eb089d$export$b3dfc0de81924308);
    var $g5yZB;
    var $8oLgk;
    function $6d0d7072a4eb089d$export$b3dfc0de81924308(context) {
        var schema = context.getSchema();
        var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
        var knownFieldNames = Object.create(null);
        return {
            InputObjectTypeDefinition: checkFieldUniqueness,
            InputObjectTypeExtension: checkFieldUniqueness,
            InterfaceTypeDefinition: checkFieldUniqueness,
            InterfaceTypeExtension: checkFieldUniqueness,
            ObjectTypeDefinition: checkFieldUniqueness,
            ObjectTypeExtension: checkFieldUniqueness
        };
        function checkFieldUniqueness(node) {
            var _node$fields;
            var typeName = node.name.value;
            if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
            var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            var fieldNames = knownFieldNames[typeName];
            for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
                var fieldDef = fieldNodes[_i2];
                var fieldName = fieldDef.name.value;
                if ($6d0d7072a4eb089d$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
                else if (fieldNames[fieldName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                    fieldNames[fieldName],
                    fieldDef.name
                ]));
                else fieldNames[fieldName] = fieldDef.name;
            }
            return false;
        }
    }
    function $6d0d7072a4eb089d$var$hasField(type, fieldName) {
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type) || (0, (0, parcelRequire("8oLgk")).isInterfaceType)(type) || (0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) return type.getFields()[fieldName] != null;
        return false;
    }
});
parcelRegister("6i9pg", function(module, exports) {
    $parcel$export(module.exports, "UniqueDirectiveNamesRule", ()=>$494bb872ab7f38a5$export$b06952068b20c86f);
    var $g5yZB;
    function $494bb872ab7f38a5$export$b06952068b20c86f(context) {
        var knownDirectiveNames = Object.create(null);
        var schema = context.getSchema();
        return {
            DirectiveDefinition: function DirectiveDefinition(node) {
                var directiveName = node.name.value;
                if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                    return;
                }
                if (knownDirectiveNames[directiveName]) context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                    knownDirectiveNames[directiveName],
                    node.name
                ]));
                else knownDirectiveNames[directiveName] = node.name;
                return false;
            }
        };
    }
});
parcelRegister("ixjnC", function(module, exports) {
    $parcel$export(module.exports, "PossibleTypeExtensionsRule", ()=>$d7ea578843014dc3$export$50309357bc4f0e8b);
    var $yEDl8;
    var $fM9AB;
    var $h4f6N;
    var $gXVhx;
    var $g5yZB;
    var $bzIlO;
    var $Zbk4Z;
    var $8oLgk;
    var $d7ea578843014dc3$var$_defKindToExtKind;
    function $d7ea578843014dc3$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $d7ea578843014dc3$export$50309357bc4f0e8b(context) {
        var schema = context.getSchema();
        var definedTypes = Object.create(null);
        for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
            var def = _context$getDocument$2[_i2];
            if ((0, (0, parcelRequire("Zbk4Z")).isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
        }
        return {
            ScalarTypeExtension: checkExtension,
            ObjectTypeExtension: checkExtension,
            InterfaceTypeExtension: checkExtension,
            UnionTypeExtension: checkExtension,
            EnumTypeExtension: checkExtension,
            InputObjectTypeExtension: checkExtension
        };
        function checkExtension(node) {
            var typeName = node.name.value;
            var defNode = definedTypes[typeName];
            var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
            var expectedKind;
            if (defNode) expectedKind = $d7ea578843014dc3$var$defKindToExtKind[defNode.kind];
            else if (existingType) expectedKind = $d7ea578843014dc3$var$typeToExtKind(existingType);
            if (expectedKind) {
                if (expectedKind !== node.kind) {
                    var kindStr = $d7ea578843014dc3$var$extensionKindToTypeName(node.kind);
                    context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                        defNode,
                        node
                    ] : node));
                }
            } else {
                var allTypeNames = Object.keys(definedTypes);
                if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
                var suggestedTypes = (0, (0, parcelRequire("gXVhx")).default)(typeName, allTypeNames);
                context.reportError(new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, (0, parcelRequire("h4f6N")).default)(suggestedTypes), node.name));
            }
        }
    }
    var $d7ea578843014dc3$var$defKindToExtKind = ($d7ea578843014dc3$var$_defKindToExtKind = {}, $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION), $d7ea578843014dc3$var$_defKindToExtKind);
    function $d7ea578843014dc3$var$typeToExtKind(type) {
        if ((0, (0, parcelRequire("8oLgk")).isScalarType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION;
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION;
        if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION;
        if ((0, (0, parcelRequire("8oLgk")).isUnionType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION;
        if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION;
        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) return (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION;
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
    }
    function $d7ea578843014dc3$var$extensionKindToTypeName(kind) {
        switch(kind){
            case (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION:
                return 'scalar';
            case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION:
                return 'object';
            case (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION:
                return 'interface';
            case (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION:
                return 'union';
            case (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION:
                return 'enum';
            case (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION:
                return 'input object';
        }
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected kind: ' + (0, (0, parcelRequire("yEDl8")).default)(kind));
    }
});
parcelRegister("1zF5q", function(module, exports) {
    $parcel$export(module.exports, "SDLValidationContext", ()=>$1258ee3b2554d4d5$export$62ce401b55355c79);
    $parcel$export(module.exports, "ValidationContext", ()=>$1258ee3b2554d4d5$export$d452675449e81987);
    var $bzIlO;
    var $12QNw;
    var $jjG8c;
    function $1258ee3b2554d4d5$var$_inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var $1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b = function() {
        function ASTValidationContext(ast, onError) {
            this._ast = ast;
            this._fragments = undefined;
            this._fragmentSpreads = new Map();
            this._recursivelyReferencedFragments = new Map();
            this._onError = onError;
        }
        var _proto = ASTValidationContext.prototype;
        _proto.reportError = function reportError(error) {
            this._onError(error);
        };
        _proto.getDocument = function getDocument() {
            return this._ast;
        };
        _proto.getFragment = function getFragment(name) {
            var fragments = this._fragments;
            if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
                if (statement.kind === (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
                return frags;
            }, Object.create(null));
            return fragments[name];
        };
        _proto.getFragmentSpreads = function getFragmentSpreads(node) {
            var spreads = this._fragmentSpreads.get(node);
            if (!spreads) {
                spreads = [];
                var setsToVisit = [
                    node
                ];
                while(setsToVisit.length !== 0){
                    var set = setsToVisit.pop();
                    for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                        var selection = _set$selections2[_i2];
                        if (selection.kind === (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD) spreads.push(selection);
                        else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                    }
                }
                this._fragmentSpreads.set(node, spreads);
            }
            return spreads;
        };
        _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
            var fragments = this._recursivelyReferencedFragments.get(operation);
            if (!fragments) {
                fragments = [];
                var collectedNames = Object.create(null);
                var nodesToVisit = [
                    operation.selectionSet
                ];
                while(nodesToVisit.length !== 0){
                    var node = nodesToVisit.pop();
                    for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                        var spread = _this$getFragmentSpre2[_i4];
                        var fragName = spread.name.value;
                        if (collectedNames[fragName] !== true) {
                            collectedNames[fragName] = true;
                            var fragment = this.getFragment(fragName);
                            if (fragment) {
                                fragments.push(fragment);
                                nodesToVisit.push(fragment.selectionSet);
                            }
                        }
                    }
                }
                this._recursivelyReferencedFragments.set(operation, fragments);
            }
            return fragments;
        };
        return ASTValidationContext;
    }();
    var $1258ee3b2554d4d5$export$62ce401b55355c79 = function(_ASTValidationContext) {
        $1258ee3b2554d4d5$var$_inheritsLoose(SDLValidationContext, _ASTValidationContext);
        function SDLValidationContext(ast, schema, onError) {
            var _this;
            _this = _ASTValidationContext.call(this, ast, onError) || this;
            _this._schema = schema;
            return _this;
        }
        var _proto2 = SDLValidationContext.prototype;
        _proto2.getSchema = function getSchema() {
            return this._schema;
        };
        return SDLValidationContext;
    }($1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b);
    var $1258ee3b2554d4d5$export$d452675449e81987 = function(_ASTValidationContext2) {
        $1258ee3b2554d4d5$var$_inheritsLoose(ValidationContext, _ASTValidationContext2);
        function ValidationContext(schema, ast, typeInfo, onError) {
            var _this2;
            _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
            _this2._schema = schema;
            _this2._typeInfo = typeInfo;
            _this2._variableUsages = new Map();
            _this2._recursiveVariableUsages = new Map();
            return _this2;
        }
        var _proto3 = ValidationContext.prototype;
        _proto3.getSchema = function getSchema() {
            return this._schema;
        };
        _proto3.getVariableUsages = function getVariableUsages(node) {
            var usages = this._variableUsages.get(node);
            if (!usages) {
                var newUsages = [];
                var typeInfo = new (0, (0, parcelRequire("jjG8c")).TypeInfo)(this._schema);
                (0, (0, parcelRequire("12QNw")).visit)(node, (0, (0, parcelRequire("jjG8c")).visitWithTypeInfo)(typeInfo, {
                    VariableDefinition: function VariableDefinition() {
                        return false;
                    },
                    Variable: function Variable(variable) {
                        newUsages.push({
                            node: variable,
                            type: typeInfo.getInputType(),
                            defaultValue: typeInfo.getDefaultValue()
                        });
                    }
                }));
                usages = newUsages;
                this._variableUsages.set(node, usages);
            }
            return usages;
        };
        _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
            var usages = this._recursiveVariableUsages.get(operation);
            if (!usages) {
                usages = this.getVariableUsages(operation);
                for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                    var frag = _this$getRecursivelyR2[_i6];
                    usages = usages.concat(this.getVariableUsages(frag));
                }
                this._recursiveVariableUsages.set(operation, usages);
            }
            return usages;
        };
        _proto3.getType = function getType() {
            return this._typeInfo.getType();
        };
        _proto3.getParentType = function getParentType() {
            return this._typeInfo.getParentType();
        };
        _proto3.getInputType = function getInputType() {
            return this._typeInfo.getInputType();
        };
        _proto3.getParentInputType = function getParentInputType() {
            return this._typeInfo.getParentInputType();
        };
        _proto3.getFieldDef = function getFieldDef() {
            return this._typeInfo.getFieldDef();
        };
        _proto3.getDirective = function getDirective() {
            return this._typeInfo.getDirective();
        };
        _proto3.getArgument = function getArgument() {
            return this._typeInfo.getArgument();
        };
        _proto3.getEnumValue = function getEnumValue() {
            return this._typeInfo.getEnumValue();
        };
        return ValidationContext;
    }($1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b);
});
parcelRegister("8mJYM", function(module, exports) {
    $parcel$export(module.exports, "extendSchema", ()=>$61740b5c0596c7dc$export$35f5fe5f3e862ea3);
    $parcel$export(module.exports, "extendSchemaImpl", ()=>$61740b5c0596c7dc$export$97eac8f938300c6f);
    $parcel$export(module.exports, "getDescription", ()=>$61740b5c0596c7dc$export$67580b1c13935958);
    var $isVmt;
    var $aRWmX;
    var $yEDl8;
    var $eqSe6;
    var $fM9AB;
    var $a1qmV;
    var $bzIlO;
    var $2z7TS;
    var $541Mz;
    var $Zbk4Z;
    var $c6jur;
    var $7dqoX;
    var $lUVCX;
    var $djKly;
    var $4Hpke;
    var $35Smo;
    var $8oLgk;
    var $9aGhX;
    function $61740b5c0596c7dc$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $61740b5c0596c7dc$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) $61740b5c0596c7dc$var$ownKeys(Object(source), true).forEach(function(key) {
                $61740b5c0596c7dc$var$_defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else $61740b5c0596c7dc$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $61740b5c0596c7dc$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $61740b5c0596c7dc$export$35f5fe5f3e862ea3(schema, documentAST, options) {
        (0, (0, parcelRequire("lUVCX")).assertSchema)(schema);
        documentAST != null && documentAST.kind === (0, (0, parcelRequire("bzIlO")).Kind).DOCUMENT || (0, (0, parcelRequire("a1qmV")).default)(0, 'Must provide valid Document AST.');
        if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, (0, parcelRequire("c6jur")).assertValidSDLExtension)(documentAST, schema);
        var schemaConfig = schema.toConfig();
        var extendedConfig = $61740b5c0596c7dc$export$97eac8f938300c6f(schemaConfig, documentAST, options);
        return schemaConfig === extendedConfig ? schema : new (0, (0, parcelRequire("lUVCX")).GraphQLSchema)(extendedConfig);
    }
    function $61740b5c0596c7dc$export$97eac8f938300c6f(schemaConfig, documentAST, options) {
        var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
        var typeDefs = [];
        var typeExtensionsMap = Object.create(null);
        var directiveDefs = [];
        var schemaDef;
        var schemaExtensions = [];
        for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
            var def = _documentAST$definiti2[_i2];
            if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION) schemaDef = def;
            else if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
            else if ((0, (0, parcelRequire("Zbk4Z")).isTypeDefinitionNode)(def)) typeDefs.push(def);
            else if ((0, (0, parcelRequire("Zbk4Z")).isTypeExtensionNode)(def)) {
                var extendedTypeName = def.name.value;
                var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
                typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                    def
                ]) : [
                    def
                ];
            } else if (def.kind === (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
        }
        if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
        var typeMap = Object.create(null);
        for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
            var existingType = _schemaConfig$types2[_i4];
            typeMap[existingType.name] = extendNamedType(existingType);
        }
        for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
            var _stdTypeMap$name;
            var typeNode = typeDefs[_i6];
            var name = typeNode.name.value;
            typeMap[name] = (_stdTypeMap$name = $61740b5c0596c7dc$var$stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
        }
        var operationTypes = $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({
            query: schemaConfig.query && replaceNamedType(schemaConfig.query),
            mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
            subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
        }, schemaDef && getOperationTypes([
            schemaDef
        ])), getOperationTypes(schemaExtensions));
        return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({
            description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
        }, operationTypes), {}, {
            types: (0, (0, parcelRequire("isVmt")).default)(typeMap),
            directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
            extensions: undefined,
            astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
            extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
            assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
        });
        function replaceType(type) {
            if ((0, (0, parcelRequire("8oLgk")).isListType)(type)) return new (0, (0, parcelRequire("8oLgk")).GraphQLList)(replaceType(type.ofType));
            if ((0, (0, parcelRequire("8oLgk")).isNonNullType)(type)) return new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(replaceType(type.ofType));
            return replaceNamedType(type);
        }
        function replaceNamedType(type) {
            return typeMap[type.name];
        }
        function replaceDirective(directive) {
            var config = directive.toConfig();
            return new (0, (0, parcelRequire("35Smo")).GraphQLDirective)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                args: (0, (0, parcelRequire("eqSe6")).default)(config.args, extendArg)
            }));
        }
        function extendNamedType(type) {
            if ((0, (0, parcelRequire("4Hpke")).isIntrospectionType)(type) || (0, (0, parcelRequire("djKly")).isSpecifiedScalarType)(type)) return type;
            if ((0, (0, parcelRequire("8oLgk")).isScalarType)(type)) return extendScalarType(type);
            if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type)) return extendObjectType(type);
            if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) return extendInterfaceType(type);
            if ((0, (0, parcelRequire("8oLgk")).isUnionType)(type)) return extendUnionType(type);
            if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) return extendEnumType(type);
            if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) return extendInputObjectType(type);
            (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
        }
        function extendInputObjectType(type) {
            var _typeExtensionsMap$co;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
            return new (0, (0, parcelRequire("8oLgk")).GraphQLInputObjectType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                fields: function fields() {
                    return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, (0, parcelRequire("eqSe6")).default)(config.fields, function(field) {
                        return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, field), {}, {
                            type: replaceType(field.type)
                        });
                    })), buildInputFieldMap(extensions));
                },
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendEnumType(type) {
            var _typeExtensionsMap$ty;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
            return new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                values: $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config.values), buildEnumValueMap(extensions)),
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendScalarType(type) {
            var _typeExtensionsMap$co2;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
            var specifiedByUrl = config.specifiedByUrl;
            for(var _i8 = 0; _i8 < extensions.length; _i8++){
                var _getSpecifiedByUrl;
                var extensionNode = extensions[_i8];
                specifiedByUrl = (_getSpecifiedByUrl = $61740b5c0596c7dc$var$getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
            }
            return new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                specifiedByUrl: specifiedByUrl,
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendObjectType(type) {
            var _typeExtensionsMap$co3;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
            return new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                interfaces: function interfaces() {
                    return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
                },
                fields: function fields() {
                    return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, (0, parcelRequire("eqSe6")).default)(config.fields, extendField)), buildFieldMap(extensions));
                },
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendInterfaceType(type) {
            var _typeExtensionsMap$co4;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
            return new (0, (0, parcelRequire("8oLgk")).GraphQLInterfaceType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                interfaces: function interfaces() {
                    return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
                },
                fields: function fields() {
                    return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, (0, parcelRequire("eqSe6")).default)(config.fields, extendField)), buildFieldMap(extensions));
                },
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendUnionType(type) {
            var _typeExtensionsMap$co5;
            var config = type.toConfig();
            var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
            return new (0, (0, parcelRequire("8oLgk")).GraphQLUnionType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
                types: function types() {
                    return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
                },
                extensionASTNodes: config.extensionASTNodes.concat(extensions)
            }));
        }
        function extendField(field) {
            return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, field), {}, {
                type: replaceType(field.type),
                args: (0, (0, parcelRequire("eqSe6")).default)(field.args, extendArg)
            });
        }
        function extendArg(arg) {
            return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, arg), {}, {
                type: replaceType(arg.type)
            });
        }
        function getOperationTypes(nodes) {
            var opTypes = {};
            for(var _i10 = 0; _i10 < nodes.length; _i10++){
                var _node$operationTypes;
                var node = nodes[_i10];
                var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
                for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                    var operationType = operationTypesNodes[_i12];
                    opTypes[operationType.operation] = getNamedType(operationType.type);
                }
            }
            return opTypes;
        }
        function getNamedType(node) {
            var _stdTypeMap$name2;
            var name = node.name.value;
            var type = (_stdTypeMap$name2 = $61740b5c0596c7dc$var$stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
            if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
            return type;
        }
        function getWrappedType(node) {
            if (node.kind === (0, (0, parcelRequire("bzIlO")).Kind).LIST_TYPE) return new (0, (0, parcelRequire("8oLgk")).GraphQLList)(getWrappedType(node.type));
            if (node.kind === (0, (0, parcelRequire("bzIlO")).Kind).NON_NULL_TYPE) return new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(getWrappedType(node.type));
            return getNamedType(node);
        }
        function buildDirective(node) {
            var locations = node.locations.map(function(_ref) {
                var value = _ref.value;
                return value;
            });
            return new (0, (0, parcelRequire("35Smo")).GraphQLDirective)({
                name: node.name.value,
                description: $61740b5c0596c7dc$export$67580b1c13935958(node, options),
                locations: locations,
                isRepeatable: node.repeatable,
                args: buildArgumentMap(node.arguments),
                astNode: node
            });
        }
        function buildFieldMap(nodes) {
            var fieldConfigMap = Object.create(null);
            for(var _i14 = 0; _i14 < nodes.length; _i14++){
                var _node$fields;
                var node = nodes[_i14];
                var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
                for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                    var field = nodeFields[_i16];
                    fieldConfigMap[field.name.value] = {
                        type: getWrappedType(field.type),
                        description: $61740b5c0596c7dc$export$67580b1c13935958(field, options),
                        args: buildArgumentMap(field.arguments),
                        deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(field),
                        astNode: field
                    };
                }
            }
            return fieldConfigMap;
        }
        function buildArgumentMap(args) {
            var argsNodes = args !== null && args !== void 0 ? args : [];
            var argConfigMap = Object.create(null);
            for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
                var arg = argsNodes[_i18];
                var type = getWrappedType(arg.type);
                argConfigMap[arg.name.value] = {
                    type: type,
                    description: $61740b5c0596c7dc$export$67580b1c13935958(arg, options),
                    defaultValue: (0, (0, parcelRequire("9aGhX")).valueFromAST)(arg.defaultValue, type),
                    deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(arg),
                    astNode: arg
                };
            }
            return argConfigMap;
        }
        function buildInputFieldMap(nodes) {
            var inputFieldMap = Object.create(null);
            for(var _i20 = 0; _i20 < nodes.length; _i20++){
                var _node$fields2;
                var node = nodes[_i20];
                var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
                for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                    var field = fieldsNodes[_i22];
                    var type = getWrappedType(field.type);
                    inputFieldMap[field.name.value] = {
                        type: type,
                        description: $61740b5c0596c7dc$export$67580b1c13935958(field, options),
                        defaultValue: (0, (0, parcelRequire("9aGhX")).valueFromAST)(field.defaultValue, type),
                        deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(field),
                        astNode: field
                    };
                }
            }
            return inputFieldMap;
        }
        function buildEnumValueMap(nodes) {
            var enumValueMap = Object.create(null);
            for(var _i24 = 0; _i24 < nodes.length; _i24++){
                var _node$values;
                var node = nodes[_i24];
                var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
                for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                    var value = valuesNodes[_i26];
                    enumValueMap[value.name.value] = {
                        description: $61740b5c0596c7dc$export$67580b1c13935958(value, options),
                        deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(value),
                        astNode: value
                    };
                }
            }
            return enumValueMap;
        }
        function buildInterfaces(nodes) {
            var interfaces = [];
            for(var _i28 = 0; _i28 < nodes.length; _i28++){
                var _node$interfaces;
                var node = nodes[_i28];
                var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
                for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                    var type = interfacesNodes[_i30];
                    interfaces.push(getNamedType(type));
                }
            }
            return interfaces;
        }
        function buildUnionTypes(nodes) {
            var types = [];
            for(var _i32 = 0; _i32 < nodes.length; _i32++){
                var _node$types;
                var node = nodes[_i32];
                var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
                for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                    var type = typeNodes[_i34];
                    types.push(getNamedType(type));
                }
            }
            return types;
        }
        function buildType(astNode) {
            var _typeExtensionsMap$na;
            var name = astNode.name.value;
            var description = $61740b5c0596c7dc$export$67580b1c13935958(astNode, options);
            var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
            switch(astNode.kind){
                case (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_DEFINITION:
                    var extensionASTNodes = extensionNodes;
                    var allNodes = [
                        astNode
                    ].concat(extensionASTNodes);
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
                        name: name,
                        description: description,
                        interfaces: function interfaces() {
                            return buildInterfaces(allNodes);
                        },
                        fields: function fields() {
                            return buildFieldMap(allNodes);
                        },
                        astNode: astNode,
                        extensionASTNodes: extensionASTNodes
                    });
                case (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_DEFINITION:
                    var _extensionASTNodes = extensionNodes;
                    var _allNodes = [
                        astNode
                    ].concat(_extensionASTNodes);
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLInterfaceType)({
                        name: name,
                        description: description,
                        interfaces: function interfaces() {
                            return buildInterfaces(_allNodes);
                        },
                        fields: function fields() {
                            return buildFieldMap(_allNodes);
                        },
                        astNode: astNode,
                        extensionASTNodes: _extensionASTNodes
                    });
                case (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_DEFINITION:
                    var _extensionASTNodes2 = extensionNodes;
                    var _allNodes2 = [
                        astNode
                    ].concat(_extensionASTNodes2);
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
                        name: name,
                        description: description,
                        values: buildEnumValueMap(_allNodes2),
                        astNode: astNode,
                        extensionASTNodes: _extensionASTNodes2
                    });
                case (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_DEFINITION:
                    var _extensionASTNodes3 = extensionNodes;
                    var _allNodes3 = [
                        astNode
                    ].concat(_extensionASTNodes3);
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLUnionType)({
                        name: name,
                        description: description,
                        types: function types() {
                            return buildUnionTypes(_allNodes3);
                        },
                        astNode: astNode,
                        extensionASTNodes: _extensionASTNodes3
                    });
                case (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_DEFINITION:
                    var _extensionASTNodes4 = extensionNodes;
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
                        name: name,
                        description: description,
                        specifiedByUrl: $61740b5c0596c7dc$var$getSpecifiedByUrl(astNode),
                        astNode: astNode,
                        extensionASTNodes: _extensionASTNodes4
                    });
                case (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION:
                    var _extensionASTNodes5 = extensionNodes;
                    var _allNodes4 = [
                        astNode
                    ].concat(_extensionASTNodes5);
                    return new (0, (0, parcelRequire("8oLgk")).GraphQLInputObjectType)({
                        name: name,
                        description: description,
                        fields: function fields() {
                            return buildInputFieldMap(_allNodes4);
                        },
                        astNode: astNode,
                        extensionASTNodes: _extensionASTNodes5
                    });
            }
            (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected type definition node: ' + (0, (0, parcelRequire("yEDl8")).default)(astNode));
        }
    }
    var $61740b5c0596c7dc$var$stdTypeMap = (0, (0, parcelRequire("aRWmX")).default)((0, (0, parcelRequire("djKly")).specifiedScalarTypes).concat((0, (0, parcelRequire("4Hpke")).introspectionTypes)), function(type) {
        return type.name;
    });
    function $61740b5c0596c7dc$var$getDeprecationReason(node) {
        var deprecated = (0, (0, parcelRequire("7dqoX")).getDirectiveValues)((0, (0, parcelRequire("35Smo")).GraphQLDeprecatedDirective), node);
        return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
    }
    function $61740b5c0596c7dc$var$getSpecifiedByUrl(node) {
        var specifiedBy = (0, (0, parcelRequire("7dqoX")).getDirectiveValues)((0, (0, parcelRequire("35Smo")).GraphQLSpecifiedByDirective), node);
        return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
    }
    function $61740b5c0596c7dc$export$67580b1c13935958(node, options) {
        if (node.description) return node.description.value;
        if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
            var rawValue = $61740b5c0596c7dc$var$getLeadingCommentBlock(node);
            if (rawValue !== undefined) return (0, (0, parcelRequire("541Mz")).dedentBlockStringValue)('\n' + rawValue);
        }
    }
    function $61740b5c0596c7dc$var$getLeadingCommentBlock(node) {
        var loc = node.loc;
        if (!loc) return;
        var comments = [];
        var token = loc.startToken.prev;
        while(token != null && token.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
            var value = String(token.value);
            comments.push(value);
            token = token.prev;
        }
        return comments.length > 0 ? comments.reverse().join('\n') : undefined;
    }
});
parcelRegister("b06Gv", function(module, exports) {
    var $8024e1333e60e731$var$__assign = module.exports && module.exports.__assign || function() {
        $8024e1333e60e731$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $8024e1333e60e731$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $bzIlO;
    function $8024e1333e60e731$var$filterExtensionDefinitions(ast) {
        var extensionDefs = ast.definitions.filter(function(def) {
            return def.kind !== (0, parcelRequire("bzIlO")).Kind.OBJECT_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.INTERFACE_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.INPUT_OBJECT_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.UNION_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.ENUM_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.SCALAR_TYPE_EXTENSION && def.kind !== (0, parcelRequire("bzIlO")).Kind.SCHEMA_EXTENSION;
        });
        return $8024e1333e60e731$var$__assign($8024e1333e60e731$var$__assign({}, ast), {
            definitions: extensionDefs
        });
    }
    module.exports.default = $8024e1333e60e731$var$filterExtensionDefinitions;
});
parcelRegister("fZSSc", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    function $ba571e3447b21cbd$var$chainResolvers(resolvers) {
        return function(root, args, ctx, info) {
            return resolvers.reduce(function(prev, curResolver) {
                if (curResolver) return curResolver(prev, args, ctx, info);
                return (0, parcelRequire("mP8zZ")).defaultFieldResolver(prev, args, ctx, info);
            }, root);
        };
    }
    module.exports.chainResolvers = $ba571e3447b21cbd$var$chainResolvers;
});
parcelRegister("3xw8r", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $l9QLJ = parcelRequire("l9QLJ");
    function $293d618a4e8045fb$var$checkForResolveTypeResolver(schema, requireResolversForResolveType) {
        Object.keys(schema.getTypeMap()).map(function(typeName) {
            return schema.getType(typeName);
        }).forEach(function(type) {
            if (!(type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType || type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType)) return;
            if (!type.resolveType) {
                if (requireResolversForResolveType === false) return;
                if (requireResolversForResolveType === true) throw new $l9QLJ.SchemaError("Type \"" + type.name + "\" is missing a \"resolveType\" resolver");
                console.warn("Type \"" + type.name + "\" is missing a \"__resolveType\" resolver. Pass false into " + "\"resolverValidationOptions.requireResolversForResolveType\" to disable this warning.");
            }
        });
    }
    module.exports.default = $293d618a4e8045fb$var$checkForResolveTypeResolver;
});
parcelRegister("7Bsga", function(module, exports) {
    var $5891e8edaaf7aa7f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $1c8Um;
    var $l9QLJ = parcelRequire("l9QLJ");
    function $5891e8edaaf7aa7f$var$concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
        if (calledFunctionRefs === void 0) calledFunctionRefs = [];
        var resolvedTypeDefinitions = [];
        typeDefinitionsAry.forEach(function(typeDef) {
            if (typeDef.kind !== undefined) typeDef = (0, parcelRequire("1c8Um")).print(typeDef);
            if (typeof typeDef === 'function') {
                if (calledFunctionRefs.indexOf(typeDef) === -1) {
                    calledFunctionRefs.push(typeDef);
                    resolvedTypeDefinitions = resolvedTypeDefinitions.concat($5891e8edaaf7aa7f$var$concatenateTypeDefs(typeDef(), calledFunctionRefs));
                }
            } else if (typeof typeDef === 'string') resolvedTypeDefinitions.push(typeDef.trim());
            else {
                var type = typeof typeDef;
                throw new $l9QLJ.SchemaError("typeDef array must contain only strings and functions, got " + type);
            }
        });
        return $5891e8edaaf7aa7f$var$uniq(resolvedTypeDefinitions.map(function(x) {
            return x.trim();
        })).join('\n');
    }
    function $5891e8edaaf7aa7f$var$uniq(array) {
        return array.reduce(function(accumulator, currentValue) {
            return accumulator.indexOf(currentValue) === -1 ? $5891e8edaaf7aa7f$var$__spreadArrays(accumulator, [
                currentValue
            ]) : accumulator;
        }, []);
    }
    module.exports.default = $5891e8edaaf7aa7f$var$concatenateTypeDefs;
});
parcelRegister("3qMTx", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    function $27f9ba4487d8128b$var$decorateWithLogger(fn, logger, hint) {
        if (typeof fn === 'undefined') fn = (0, parcelRequire("mP8zZ")).defaultFieldResolver;
        var logError = function(e) {
            var newE = new Error();
            newE.stack = e.stack;
            if (hint) {
                newE['originalMessage'] = e.message;
                newE['message'] = "Error in resolver " + hint + "\n" + e.message;
            }
            logger.log(newE);
        };
        return function(root, args, ctx, info) {
            try {
                var result = fn(root, args, ctx, info);
                if (result && typeof result.then === 'function' && typeof result.catch === 'function') result.catch(function(reason) {
                    var error = reason instanceof Error ? reason : new Error(reason);
                    logError(error);
                    return reason;
                });
                return result;
            } catch (e) {
                logError(e);
                throw e;
            }
        };
    }
    module.exports.default = $27f9ba4487d8128b$var$decorateWithLogger;
});
parcelRegister("gk7uh", function(module, exports) {
    var $be24526cbd37b195$var$__assign = module.exports && module.exports.__assign || function() {
        $be24526cbd37b195$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $be24526cbd37b195$var$__assign.apply(this, arguments);
    };
    var $be24526cbd37b195$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    function $be24526cbd37b195$var$extendResolversFromInterfaces(schema, resolvers) {
        var typeNames = Object.keys($be24526cbd37b195$var$__assign($be24526cbd37b195$var$__assign({}, schema.getTypeMap()), resolvers));
        var extendedResolvers = {};
        typeNames.forEach(function(typeName) {
            var typeResolvers = resolvers[typeName];
            var type = schema.getType(typeName);
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
                var interfaceResolvers = type.getInterfaces().map(function(iFace) {
                    return resolvers[iFace.name];
                });
                extendedResolvers[typeName] = Object.assign.apply(Object, $be24526cbd37b195$var$__spreadArrays([
                    {}
                ], interfaceResolvers, [
                    typeResolvers
                ]));
            } else if (typeResolvers) extendedResolvers[typeName] = typeResolvers;
        });
        return extendedResolvers;
    }
    module.exports.default = $be24526cbd37b195$var$extendResolversFromInterfaces;
});
parcelRegister("cfI70", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8eb91a74a0b54807$var$newExtensionDefinitionKind = 'ObjectTypeExtension';
    var $8eb91a74a0b54807$var$interfaceExtensionDefinitionKind = 'InterfaceTypeExtension';
    var $8eb91a74a0b54807$var$inputObjectExtensionDefinitionKind = 'InputObjectTypeExtension';
    var $8eb91a74a0b54807$var$unionExtensionDefinitionKind = 'UnionTypeExtension';
    var $8eb91a74a0b54807$var$enumExtensionDefinitionKind = 'EnumTypeExtension';
    function $8eb91a74a0b54807$var$extractExtensionDefinitions(ast) {
        var extensionDefs = ast.definitions.filter(function(def) {
            return def.kind === $8eb91a74a0b54807$var$newExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$interfaceExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$inputObjectExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$unionExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$enumExtensionDefinitionKind;
        });
        return Object.assign({}, ast, {
            definitions: extensionDefs
        });
    }
    module.exports.default = $8eb91a74a0b54807$var$extractExtensionDefinitions;
});
parcelRegister("izDlb", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    function $d85a031d97c1df1b$var$forEachField(schema, fn) {
        var typeMap = schema.getTypeMap();
        Object.keys(typeMap).forEach(function(typeName) {
            var type = typeMap[typeName];
            if (!(0, parcelRequire("8oLgk")).getNamedType(type).name.startsWith('__') && type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
                var fields_1 = type.getFields();
                Object.keys(fields_1).forEach(function(fieldName) {
                    var field = fields_1[fieldName];
                    fn(field, typeName, fieldName);
                });
            }
        });
    }
    module.exports.default = $d85a031d97c1df1b$var$forEachField;
});
parcelRegister("5gUcG", function(module, exports) {
    var $3d6a0b3bbe13496e$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3d6a0b3bbe13496e$var$SchemaError = function(_super) {
        $3d6a0b3bbe13496e$var$__extends(SchemaError, _super);
        function SchemaError(message) {
            var _this = _super.call(this, message) || this;
            _this.message = message;
            Error.captureStackTrace(_this, _this.constructor);
            return _this;
        }
        return SchemaError;
    }(Error);
    module.exports.default = $3d6a0b3bbe13496e$var$SchemaError;
});
parcelRegister("cCTSK", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $cQaSR;
    var $lUVCX;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $gIDuj = parcelRequire("gIDuj");
    function $931461a66c79b285$var$mockServer(schema, mocks, preserveResolvers) {
        if (preserveResolvers === void 0) preserveResolvers = false;
        var mySchema;
        if (!(schema instanceof (0, parcelRequire("lUVCX")).GraphQLSchema)) mySchema = $gIDuj.buildSchemaFromTypeDefinitions(schema);
        else mySchema = schema;
        $931461a66c79b285$var$addMockFunctionsToSchema({
            schema: mySchema,
            mocks: mocks,
            preserveResolvers: preserveResolvers
        });
        return {
            query: function(query, vars) {
                return (0, parcelRequire("cQaSR")).graphql(mySchema, query, {}, {}, vars);
            }
        };
    }
    module.exports.mockServer = $931461a66c79b285$var$mockServer;
    var $931461a66c79b285$var$defaultMockMap = new Map();
    $931461a66c79b285$var$defaultMockMap.set('Int', function() {
        return Math.round(Math.random() * 200) - 100;
    });
    $931461a66c79b285$var$defaultMockMap.set('Float', function() {
        return Math.random() * 200 - 100;
    });
    $931461a66c79b285$var$defaultMockMap.set('String', function() {
        return 'Hello World';
    });
    $931461a66c79b285$var$defaultMockMap.set('Boolean', function() {
        return Math.random() > 0.5;
    });
    $931461a66c79b285$var$defaultMockMap.set('ID', function() {
        return $7Jxgt.v4();
    });
    function $931461a66c79b285$var$addMockFunctionsToSchema(_a) {
        var schema = _a.schema, _b = _a.mocks, mocks = _b === void 0 ? {} : _b, _c = _a.preserveResolvers, preserveResolvers = _c === void 0 ? false : _c;
        if (!schema) throw new Error('Must provide schema to mock');
        if (!(schema instanceof (0, parcelRequire("lUVCX")).GraphQLSchema)) throw new Error('Value at "schema" must be of type GraphQLSchema');
        if (!$931461a66c79b285$var$isObject(mocks)) throw new Error('mocks must be of type Object');
        var mockFunctionMap = new Map();
        Object.keys(mocks).forEach(function(typeName) {
            mockFunctionMap.set(typeName, mocks[typeName]);
        });
        mockFunctionMap.forEach(function(mockFunction, mockTypeName) {
            if (typeof mockFunction !== 'function') throw new Error("mockFunctionMap[" + mockTypeName + "] must be a function");
        });
        var mockType = function(type, typeName, fieldName) {
            return function(root, args, context, info) {
                var fieldType = (0, parcelRequire("8oLgk")).getNullableType(type);
                var namedFieldType = (0, parcelRequire("8oLgk")).getNamedType(fieldType);
                if (root && typeof root[fieldName] !== 'undefined') {
                    var result = void 0;
                    if (typeof root[fieldName] === 'function') {
                        result = root[fieldName](root, args, context, info);
                        if (result instanceof $931461a66c79b285$var$MockList) result = result.mock(root, args, context, info, fieldType, mockType);
                    } else result = root[fieldName];
                    if (mockFunctionMap.has(namedFieldType.name)) result = $931461a66c79b285$var$mergeMocks(mockFunctionMap.get(namedFieldType.name).bind(null, root, args, context, info), result);
                    return result;
                }
                if (fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLList || fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLNonNull) return [
                    mockType(fieldType.ofType)(root, args, context, info),
                    mockType(fieldType.ofType)(root, args, context, info)
                ];
                if (mockFunctionMap.has(fieldType.name) && !(fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType || fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType)) return mockFunctionMap.get(fieldType.name)(root, args, context, info);
                if (fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) return {};
                if (fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType || fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) {
                    var implementationType = void 0;
                    if (mockFunctionMap.has(fieldType.name)) {
                        var interfaceMockObj = mockFunctionMap.get(fieldType.name)(root, args, context, info);
                        if (!interfaceMockObj || !interfaceMockObj.__typename) return Error("Please return a __typename in \"" + fieldType.name + "\"");
                        implementationType = schema.getType(interfaceMockObj.__typename);
                    } else {
                        var possibleTypes = schema.getPossibleTypes(fieldType);
                        implementationType = $931461a66c79b285$var$getRandomElement(possibleTypes);
                    }
                    return Object.assign({
                        __typename: implementationType
                    }, mockType(implementationType)(root, args, context, info));
                }
                if (fieldType instanceof (0, parcelRequire("8oLgk")).GraphQLEnumType) return $931461a66c79b285$var$getRandomElement(fieldType.getValues()).value;
                if ($931461a66c79b285$var$defaultMockMap.has(fieldType.name)) return $931461a66c79b285$var$defaultMockMap.get(fieldType.name)(root, args, context, info);
                return Error("No mock defined for type \"" + fieldType.name + "\"");
            };
        };
        $gIDuj.forEachField(schema, function(field, typeName, fieldName) {
            $931461a66c79b285$var$assignResolveType(field.type, preserveResolvers);
            var mockResolver;
            var isOnQueryType = schema.getQueryType() && schema.getQueryType().name === typeName;
            var isOnMutationType = schema.getMutationType() && schema.getMutationType().name === typeName;
            if (isOnQueryType || isOnMutationType) {
                if (mockFunctionMap.has(typeName)) {
                    var rootMock_1 = mockFunctionMap.get(typeName);
                    if (typeof rootMock_1(undefined, {}, {}, {})[fieldName] === 'function') mockResolver = function(root, args, context, info) {
                        var updatedRoot = root || {};
                        updatedRoot[fieldName] = rootMock_1(root, args, context, info)[fieldName];
                        return mockType(field.type, typeName, fieldName)(updatedRoot, args, context, info);
                    };
                }
            }
            if (!mockResolver) mockResolver = mockType(field.type, typeName, fieldName);
            if (!preserveResolvers || !field.resolve) field.resolve = mockResolver;
            else {
                var oldResolver_1 = field.resolve;
                field.resolve = function(rootObject, args, context, info) {
                    return Promise.all([
                        mockResolver(rootObject, args, context, info),
                        oldResolver_1(rootObject, args, context, info)
                    ]).then(function(values) {
                        var mockedValue = values[0], resolvedValue = values[1];
                        if (mockedValue instanceof Error) {
                            if (undefined === resolvedValue) throw mockedValue;
                            return resolvedValue;
                        }
                        if (resolvedValue instanceof Date && mockedValue instanceof Date) return undefined !== resolvedValue ? resolvedValue : mockedValue;
                        if ($931461a66c79b285$var$isObject(mockedValue) && $931461a66c79b285$var$isObject(resolvedValue)) {
                            var emptyObject = Object.create(Object.getPrototypeOf(resolvedValue));
                            return $931461a66c79b285$var$copyOwnProps(emptyObject, resolvedValue, mockedValue);
                        }
                        return undefined !== resolvedValue ? resolvedValue : mockedValue;
                    });
                };
            }
        });
    }
    module.exports.addMockFunctionsToSchema = $931461a66c79b285$var$addMockFunctionsToSchema;
    function $931461a66c79b285$var$isObject(thing) {
        return thing === Object(thing) && !Array.isArray(thing);
    }
    function $931461a66c79b285$var$getRandomElement(ary) {
        var sample = Math.floor(Math.random() * ary.length);
        return ary[sample];
    }
    function $931461a66c79b285$var$mergeObjects(a, b) {
        return Object.assign(a, b);
    }
    function $931461a66c79b285$var$copyOwnPropsIfNotPresent(target, source) {
        Object.getOwnPropertyNames(source).forEach(function(prop) {
            if (!Object.getOwnPropertyDescriptor(target, prop)) Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
        });
    }
    function $931461a66c79b285$var$copyOwnProps(target) {
        var sources = [];
        for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
        sources.forEach(function(source) {
            var chain = source;
            while(chain){
                $931461a66c79b285$var$copyOwnPropsIfNotPresent(target, chain);
                chain = Object.getPrototypeOf(chain);
            }
        });
        return target;
    }
    function $931461a66c79b285$var$mergeMocks(genericMockFunction, customMock) {
        if (Array.isArray(customMock)) return customMock.map(function(el) {
            return $931461a66c79b285$var$mergeMocks(genericMockFunction, el);
        });
        if ($931461a66c79b285$var$isObject(customMock)) return $931461a66c79b285$var$mergeObjects(genericMockFunction(), customMock);
        return customMock;
    }
    function $931461a66c79b285$var$getResolveType(namedFieldType) {
        if (namedFieldType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType || namedFieldType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) return namedFieldType.resolveType;
        else return undefined;
    }
    function $931461a66c79b285$var$assignResolveType(type, preserveResolvers) {
        var fieldType = (0, parcelRequire("8oLgk")).getNullableType(type);
        var namedFieldType = (0, parcelRequire("8oLgk")).getNamedType(fieldType);
        var oldResolveType = $931461a66c79b285$var$getResolveType(namedFieldType);
        if (preserveResolvers && oldResolveType && oldResolveType.length) return;
        if (namedFieldType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType || namedFieldType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) namedFieldType.resolveType = function(data, context, info) {
            return info.schema.getType(data.__typename);
        };
    }
    var $931461a66c79b285$var$MockList = function() {
        function MockList(len, wrappedFunction) {
            this.len = len;
            if (typeof wrappedFunction !== 'undefined') {
                if (typeof wrappedFunction !== 'function') throw new Error('Second argument to MockList must be a function or undefined');
                this.wrappedFunction = wrappedFunction;
            }
        }
        MockList.prototype.mock = function(root, args, context, info, fieldType, mockTypeFunc) {
            var arr;
            if (Array.isArray(this.len)) arr = new Array(this.randint(this.len[0], this.len[1]));
            else arr = new Array(this.len);
            for(var i = 0; i < arr.length; i++)if (typeof this.wrappedFunction === 'function') {
                var res = this.wrappedFunction(root, args, context, info);
                if (res instanceof MockList) {
                    var nullableType = (0, parcelRequire("8oLgk")).getNullableType(fieldType.ofType);
                    arr[i] = res.mock(root, args, context, info, nullableType, mockTypeFunc);
                } else arr[i] = res;
            } else arr[i] = mockTypeFunc(fieldType.ofType)(root, args, context, info);
            return arr;
        };
        MockList.prototype.randint = function(low, high) {
            return Math.floor(Math.random() * (high - low + 1) + low);
        };
        return MockList;
    }();
    module.exports.MockList = $931461a66c79b285$var$MockList;
});
parcelRegister("cQaSR", function(module, exports) {
    $parcel$export(module.exports, "graphql", ()=>$9592c8b00f2b6e28$export$1eb4e7c0ed67b035);
    var $jMqAK;
    var $8uUC9;
    var $c6jur;
    var $bKGOe;
    var $mP8zZ;
    function $9592c8b00f2b6e28$export$1eb4e7c0ed67b035(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
        var _arguments = arguments;
        return new Promise(function(resolve) {
            return resolve(_arguments.length === 1 ? $9592c8b00f2b6e28$var$graphqlImpl(argsOrSchema) : $9592c8b00f2b6e28$var$graphqlImpl({
                schema: argsOrSchema,
                source: source,
                rootValue: rootValue,
                contextValue: contextValue,
                variableValues: variableValues,
                operationName: operationName,
                fieldResolver: fieldResolver,
                typeResolver: typeResolver
            }));
        });
    }
    function $9592c8b00f2b6e28$export$51b1816fb8b0711e(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
        var result = arguments.length === 1 ? $9592c8b00f2b6e28$var$graphqlImpl(argsOrSchema) : $9592c8b00f2b6e28$var$graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        });
        if ((0, (0, parcelRequire("jMqAK")).default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
        return result;
    }
    function $9592c8b00f2b6e28$var$graphqlImpl(args) {
        var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver;
        var schemaValidationErrors = (0, (0, parcelRequire("bKGOe")).validateSchema)(schema);
        if (schemaValidationErrors.length > 0) return {
            errors: schemaValidationErrors
        };
        var document;
        try {
            document = (0, (0, parcelRequire("8uUC9")).parse)(source);
        } catch (syntaxError) {
            return {
                errors: [
                    syntaxError
                ]
            };
        }
        var validationErrors = (0, (0, parcelRequire("c6jur")).validate)(schema, document);
        if (validationErrors.length > 0) return {
            errors: validationErrors
        };
        return (0, (0, parcelRequire("mP8zZ")).execute)({
            schema: schema,
            document: document,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        });
    }
});
parcelRegister("h3H2i", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $ebVkX = parcelRequire("ebVkX");
    module.exports.makeRemoteExecutableSchema = $ebVkX.default;
    module.exports.defaultCreateRemoteResolver = $ebVkX.createResolver;
    var $hedUd = parcelRequire("hedUd");
    module.exports.introspectSchema = $hedUd.default;
    var $5Cx8V = parcelRequire("5Cx8V");
    module.exports.mergeSchemas = $5Cx8V.default;
    var $bkP2b = parcelRequire("bkP2b");
    module.exports.delegateToSchema = $bkP2b.default;
    var $kptle = parcelRequire("kptle");
    module.exports.defaultMergedResolver = $kptle.default;
});
parcelRegister("ebVkX", function(module, exports) {
    var $a54e91b71ba2d067$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $a54e91b71ba2d067$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var $a54e91b71ba2d067$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $dQXZA;
    var $djKly;
    var $8oLgk;
    var $bzIlO;
    var $2dbGi;
    var $kd1Ee = parcelRequire("kd1Ee");
    var $bZzKT = parcelRequire("bZzKT");
    var $gIDuj = parcelRequire("gIDuj");
    var $cPwLY = parcelRequire("cPwLY");
    var $akAWC = parcelRequire("akAWC");
    var $kptle = parcelRequire("kptle");
    var $2JIWi = parcelRequire("2JIWi");
    var $0qKk1 = parcelRequire("0qKk1");
    function $a54e91b71ba2d067$var$makeRemoteExecutableSchema(_a) {
        var _b;
        var schema = _a.schema, link = _a.link, fetcher = _a.fetcher, _c = _a.createResolver, customCreateResolver = _c === void 0 ? $a54e91b71ba2d067$var$createResolver : _c, buildSchemaOptions = _a.buildSchemaOptions, _d = _a.printSchemaOptions, printSchemaOptions = _d === void 0 ? {
            commentDescriptions: true
        } : _d;
        if (!fetcher && link) fetcher = $kd1Ee.default(link);
        var typeDefs;
        if (typeof schema === 'string') {
            typeDefs = schema;
            schema = (0, parcelRequire("dQXZA")).buildSchema(typeDefs, buildSchemaOptions);
        } else typeDefs = (0, parcelRequire("2dbGi")).printSchema(schema, printSchemaOptions);
        var queryResolvers = {};
        var queryType = schema.getQueryType();
        var queries = queryType.getFields();
        Object.keys(queries).forEach(function(key) {
            queryResolvers[key] = customCreateResolver(fetcher);
        });
        var mutationResolvers = {};
        var mutationType = schema.getMutationType();
        if (mutationType) {
            var mutations = mutationType.getFields();
            Object.keys(mutations).forEach(function(key) {
                mutationResolvers[key] = customCreateResolver(fetcher);
            });
        }
        var subscriptionResolvers = {};
        var subscriptionType = schema.getSubscriptionType();
        if (subscriptionType) {
            var subscriptions = subscriptionType.getFields();
            Object.keys(subscriptions).forEach(function(key) {
                subscriptionResolvers[key] = {
                    subscribe: $a54e91b71ba2d067$var$createSubscriptionResolver(key, link)
                };
            });
        }
        var resolvers = (_b = {}, _b[queryType.name] = queryResolvers, _b);
        if (!$bZzKT.default(mutationResolvers)) resolvers[mutationType.name] = mutationResolvers;
        if (!$bZzKT.default(subscriptionResolvers)) resolvers[subscriptionType.name] = subscriptionResolvers;
        var typeMap = schema.getTypeMap();
        var types = Object.keys(typeMap).map(function(name) {
            return typeMap[name];
        });
        var _loop_1 = function(type) {
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType || type instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) resolvers[type.name] = {
                __resolveType: function(parent, context, info) {
                    return $akAWC.default(parent, info.schema);
                }
            };
            else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) {
                if (!(type === (0, parcelRequire("djKly")).GraphQLID || type === (0, parcelRequire("djKly")).GraphQLString || type === (0, parcelRequire("djKly")).GraphQLFloat || type === (0, parcelRequire("djKly")).GraphQLBoolean || type === (0, parcelRequire("djKly")).GraphQLInt)) resolvers[type.name] = $cPwLY.recreateType(type, function(name) {
                    return null;
                }, false);
            } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType && type.name.slice(0, 2) !== '__' && type !== queryType && type !== mutationType && type !== subscriptionType) {
                var resolver_1 = {};
                Object.keys(type.getFields()).forEach(function(field) {
                    resolver_1[field] = $kptle.default;
                });
                resolvers[type.name] = resolver_1;
            }
        };
        for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
            var type = types_1[_i];
            _loop_1(type);
        }
        return $gIDuj.makeExecutableSchema({
            typeDefs: typeDefs,
            resolvers: resolvers
        });
    }
    module.exports.default = $a54e91b71ba2d067$var$makeRemoteExecutableSchema;
    function $a54e91b71ba2d067$var$createResolver(fetcher) {
        var _this = this;
        return function(root, args, context, info) {
            return $a54e91b71ba2d067$var$__awaiter(_this, void 0, void 0, function() {
                var fragments, document, result;
                return $a54e91b71ba2d067$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fragments = Object.keys(info.fragments).map(function(fragment) {
                                return info.fragments[fragment];
                            });
                            document = {
                                kind: (0, parcelRequire("bzIlO")).Kind.DOCUMENT,
                                definitions: $a54e91b71ba2d067$var$__spreadArrays([
                                    info.operation
                                ], fragments)
                            };
                            return [
                                4,
                                fetcher({
                                    query: document,
                                    variables: info.variableValues,
                                    context: {
                                        graphqlContext: context
                                    }
                                })
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2,
                                $2JIWi.checkResultAndHandleErrors(result, info)
                            ];
                    }
                });
            });
        };
    }
    module.exports.createResolver = $a54e91b71ba2d067$var$createResolver;
    function $a54e91b71ba2d067$var$createSubscriptionResolver(name, link) {
        return function(root, args, context, info) {
            var fragments = Object.keys(info.fragments).map(function(fragment) {
                return info.fragments[fragment];
            });
            var document = {
                kind: (0, parcelRequire("bzIlO")).Kind.DOCUMENT,
                definitions: $a54e91b71ba2d067$var$__spreadArrays([
                    info.operation
                ], fragments)
            };
            var operation = {
                query: document,
                variables: info.variableValues,
                context: {
                    graphqlContext: context
                }
            };
            var observable = $kd1Ee.execute(link, operation);
            return $0qKk1.observableToAsyncIterable(observable);
        };
    }
});
parcelRegister("2dbGi", function(module, exports) {
    $parcel$export(module.exports, "printSchema", ()=>$19c5db4b93436126$export$f7c984b74d0fc2e7);
    var $isVmt;
    var $yEDl8;
    var $fM9AB;
    var $1c8Um;
    var $541Mz;
    var $4Hpke;
    var $djKly;
    var $35Smo;
    var $8oLgk;
    var $d1i3Z;
    function $19c5db4b93436126$export$f7c984b74d0fc2e7(schema, options) {
        return $19c5db4b93436126$var$printFilteredSchema(schema, function(n) {
            return !(0, (0, parcelRequire("35Smo")).isSpecifiedDirective)(n);
        }, $19c5db4b93436126$var$isDefinedType, options);
    }
    function $19c5db4b93436126$export$436bfe9e87d1be55(schema, options) {
        return $19c5db4b93436126$var$printFilteredSchema(schema, (0, (0, parcelRequire("35Smo")).isSpecifiedDirective), (0, (0, parcelRequire("4Hpke")).isIntrospectionType), options);
    }
    function $19c5db4b93436126$var$isDefinedType(type) {
        return !(0, (0, parcelRequire("djKly")).isSpecifiedScalarType)(type) && !(0, (0, parcelRequire("4Hpke")).isIntrospectionType)(type);
    }
    function $19c5db4b93436126$var$printFilteredSchema(schema, directiveFilter, typeFilter, options) {
        var directives = schema.getDirectives().filter(directiveFilter);
        var types = (0, (0, parcelRequire("isVmt")).default)(schema.getTypeMap()).filter(typeFilter);
        return [
            $19c5db4b93436126$var$printSchemaDefinition(schema)
        ].concat(directives.map(function(directive) {
            return $19c5db4b93436126$var$printDirective(directive, options);
        }), types.map(function(type) {
            return $19c5db4b93436126$export$199528f8b0f9bf49(type, options);
        })).filter(Boolean).join('\n\n') + '\n';
    }
    function $19c5db4b93436126$var$printSchemaDefinition(schema) {
        if (schema.description == null && $19c5db4b93436126$var$isSchemaOfCommonNames(schema)) return;
        var operationTypes = [];
        var queryType = schema.getQueryType();
        if (queryType) operationTypes.push("  query: ".concat(queryType.name));
        var mutationType = schema.getMutationType();
        if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
        var subscriptionType = schema.getSubscriptionType();
        if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
        return $19c5db4b93436126$var$printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
    }
    function $19c5db4b93436126$var$isSchemaOfCommonNames(schema) {
        var queryType = schema.getQueryType();
        if (queryType && queryType.name !== 'Query') return false;
        var mutationType = schema.getMutationType();
        if (mutationType && mutationType.name !== 'Mutation') return false;
        var subscriptionType = schema.getSubscriptionType();
        if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
        return true;
    }
    function $19c5db4b93436126$export$199528f8b0f9bf49(type, options) {
        if ((0, (0, parcelRequire("8oLgk")).isScalarType)(type)) return $19c5db4b93436126$var$printScalar(type, options);
        if ((0, (0, parcelRequire("8oLgk")).isObjectType)(type)) return $19c5db4b93436126$var$printObject(type, options);
        if ((0, (0, parcelRequire("8oLgk")).isInterfaceType)(type)) return $19c5db4b93436126$var$printInterface(type, options);
        if ((0, (0, parcelRequire("8oLgk")).isUnionType)(type)) return $19c5db4b93436126$var$printUnion(type, options);
        if ((0, (0, parcelRequire("8oLgk")).isEnumType)(type)) return $19c5db4b93436126$var$printEnum(type, options);
        if ((0, (0, parcelRequire("8oLgk")).isInputObjectType)(type)) return $19c5db4b93436126$var$printInputObject(type, options);
        (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected type: ' + (0, (0, parcelRequire("yEDl8")).default)(type));
    }
    function $19c5db4b93436126$var$printScalar(type, options) {
        return $19c5db4b93436126$var$printDescription(options, type) + "scalar ".concat(type.name) + $19c5db4b93436126$var$printSpecifiedByUrl(type);
    }
    function $19c5db4b93436126$var$printImplementedInterfaces(type) {
        var interfaces = type.getInterfaces();
        return interfaces.length ? ' implements ' + interfaces.map(function(i) {
            return i.name;
        }).join(' & ') : '';
    }
    function $19c5db4b93436126$var$printObject(type, options) {
        return $19c5db4b93436126$var$printDescription(options, type) + "type ".concat(type.name) + $19c5db4b93436126$var$printImplementedInterfaces(type) + $19c5db4b93436126$var$printFields(options, type);
    }
    function $19c5db4b93436126$var$printInterface(type, options) {
        return $19c5db4b93436126$var$printDescription(options, type) + "interface ".concat(type.name) + $19c5db4b93436126$var$printImplementedInterfaces(type) + $19c5db4b93436126$var$printFields(options, type);
    }
    function $19c5db4b93436126$var$printUnion(type, options) {
        var types = type.getTypes();
        var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
        return $19c5db4b93436126$var$printDescription(options, type) + 'union ' + type.name + possibleTypes;
    }
    function $19c5db4b93436126$var$printEnum(type, options) {
        var values = type.getValues().map(function(value, i) {
            return $19c5db4b93436126$var$printDescription(options, value, '  ', !i) + '  ' + value.name + $19c5db4b93436126$var$printDeprecated(value.deprecationReason);
        });
        return $19c5db4b93436126$var$printDescription(options, type) + "enum ".concat(type.name) + $19c5db4b93436126$var$printBlock(values);
    }
    function $19c5db4b93436126$var$printInputObject(type, options) {
        var fields = (0, (0, parcelRequire("isVmt")).default)(type.getFields()).map(function(f, i) {
            return $19c5db4b93436126$var$printDescription(options, f, '  ', !i) + '  ' + $19c5db4b93436126$var$printInputValue(f);
        });
        return $19c5db4b93436126$var$printDescription(options, type) + "input ".concat(type.name) + $19c5db4b93436126$var$printBlock(fields);
    }
    function $19c5db4b93436126$var$printFields(options, type) {
        var fields = (0, (0, parcelRequire("isVmt")).default)(type.getFields()).map(function(f, i) {
            return $19c5db4b93436126$var$printDescription(options, f, '  ', !i) + '  ' + f.name + $19c5db4b93436126$var$printArgs(options, f.args, '  ') + ': ' + String(f.type) + $19c5db4b93436126$var$printDeprecated(f.deprecationReason);
        });
        return $19c5db4b93436126$var$printBlock(fields);
    }
    function $19c5db4b93436126$var$printBlock(items) {
        return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
    }
    function $19c5db4b93436126$var$printArgs(options, args) {
        var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        if (args.length === 0) return '';
        if (args.every(function(arg) {
            return !arg.description;
        })) return '(' + args.map($19c5db4b93436126$var$printInputValue).join(', ') + ')';
        return '(\n' + args.map(function(arg, i) {
            return $19c5db4b93436126$var$printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + $19c5db4b93436126$var$printInputValue(arg);
        }).join('\n') + '\n' + indentation + ')';
    }
    function $19c5db4b93436126$var$printInputValue(arg) {
        var defaultAST = (0, (0, parcelRequire("d1i3Z")).astFromValue)(arg.defaultValue, arg.type);
        var argDecl = arg.name + ': ' + String(arg.type);
        if (defaultAST) argDecl += " = ".concat((0, (0, parcelRequire("1c8Um")).print)(defaultAST));
        return argDecl + $19c5db4b93436126$var$printDeprecated(arg.deprecationReason);
    }
    function $19c5db4b93436126$var$printDirective(directive, options) {
        return $19c5db4b93436126$var$printDescription(options, directive) + 'directive @' + directive.name + $19c5db4b93436126$var$printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
    }
    function $19c5db4b93436126$var$printDeprecated(reason) {
        if (reason == null) return '';
        var reasonAST = (0, (0, parcelRequire("d1i3Z")).astFromValue)(reason, (0, (0, parcelRequire("djKly")).GraphQLString));
        if (reasonAST && reason !== (0, (0, parcelRequire("35Smo")).DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, (0, parcelRequire("1c8Um")).print)(reasonAST) + ')';
        return ' @deprecated';
    }
    function $19c5db4b93436126$var$printSpecifiedByUrl(scalar) {
        if (scalar.specifiedByUrl == null) return '';
        var url = scalar.specifiedByUrl;
        var urlAST = (0, (0, parcelRequire("d1i3Z")).astFromValue)(url, (0, (0, parcelRequire("djKly")).GraphQLString));
        urlAST || (0, (0, parcelRequire("fM9AB")).default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
        return ' @specifiedBy(url: ' + (0, (0, parcelRequire("1c8Um")).print)(urlAST) + ')';
    }
    function $19c5db4b93436126$var$printDescription(options, def) {
        var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var description = def.description;
        if (description == null) return '';
        if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return $19c5db4b93436126$var$printDescriptionWithComments(description, indentation, firstInBlock);
        var preferMultipleLines = description.length > 70;
        var blockString = (0, (0, parcelRequire("541Mz")).printBlockString)(description, '', preferMultipleLines);
        var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
        return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
    }
    function $19c5db4b93436126$var$printDescriptionWithComments(description, indentation, firstInBlock) {
        var prefix = indentation && !firstInBlock ? '\n' : '';
        var comment = description.split('\n').map(function(line) {
            return indentation + (line !== '' ? '# ' + line : '#');
        }).join('\n');
        return prefix + comment + '\n';
    }
});
parcelRegister("kd1Ee", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $clSzL;
    var $clSzL;
    module.exports.execute = (0, parcelRequire("clSzL")).execute;
    function $eb664ccd27fb29eb$var$linkToFetcher(link) {
        return function(fetcherOperation) {
            return (0, parcelRequire("clSzL")).makePromise((0, parcelRequire("clSzL")).execute(link, fetcherOperation));
        };
    }
    module.exports.default = $eb664ccd27fb29eb$var$linkToFetcher;
});
parcelRegister("bZzKT", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    function $8bb1207673418f48$var$isEmptyObject(obj) {
        if (!obj) return true;
        for(var key in obj){
            if (Object.hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    module.exports.default = $8bb1207673418f48$var$isEmptyObject;
});
parcelRegister("0qKk1", function(module, exports) {
    var $0014bf6d11b17ae1$var$__assign = module.exports && module.exports.__assign || function() {
        $0014bf6d11b17ae1$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $0014bf6d11b17ae1$var$__assign.apply(this, arguments);
    };
    var $0014bf6d11b17ae1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $0014bf6d11b17ae1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $6PRDg = parcelRequire("6PRDg");
    function $0014bf6d11b17ae1$var$observableToAsyncIterable(observable) {
        var _a;
        var pullQueue = [];
        var pushQueue = [];
        var listening = true;
        var pushValue = function(_a) {
            var data = _a.data;
            if (pullQueue.length !== 0) pullQueue.shift()({
                value: data,
                done: false
            });
            else pushQueue.push({
                value: data
            });
        };
        var pushError = function(error) {
            if (pullQueue.length !== 0) pullQueue.shift()({
                value: {
                    errors: [
                        error
                    ]
                },
                done: false
            });
            else pushQueue.push({
                value: {
                    errors: [
                        error
                    ]
                }
            });
        };
        var pullValue = function() {
            return new Promise(function(resolve) {
                if (pushQueue.length !== 0) {
                    var element = pushQueue.shift();
                    resolve($0014bf6d11b17ae1$var$__assign($0014bf6d11b17ae1$var$__assign({}, element), {
                        done: false
                    }));
                } else pullQueue.push(resolve);
            });
        };
        var subscription = observable.subscribe({
            next: function(value) {
                pushValue(value);
            },
            error: function(err) {
                pushError(err);
            }
        });
        var emptyQueue = function() {
            if (listening) {
                listening = false;
                subscription.unsubscribe();
                pullQueue.forEach(function(resolve) {
                    return resolve({
                        value: undefined,
                        done: true
                    });
                });
                pullQueue.length = 0;
                pushQueue.length = 0;
            }
        };
        return _a = {
            next: function() {
                return $0014bf6d11b17ae1$var$__awaiter(this, void 0, void 0, function() {
                    return $0014bf6d11b17ae1$var$__generator(this, function(_a) {
                        return [
                            2,
                            listening ? pullValue() : this.return()
                        ];
                    });
                });
            },
            return: function() {
                emptyQueue();
                return Promise.resolve({
                    value: undefined,
                    done: true
                });
            },
            throw: function(error) {
                emptyQueue();
                return Promise.reject(error);
            }
        }, _a[$6PRDg.$$asyncIterator] = function() {
            return this;
        }, _a;
    }
    module.exports.observableToAsyncIterable = $0014bf6d11b17ae1$var$observableToAsyncIterable;
});
parcelRegister("6PRDg", function(module, exports) {
    $parcel$export(module.exports, "$$asyncIterator", ()=>$4fa11bc3c2ea1320$export$5ee754c34122a0ae);
    var $4fa11bc3c2ea1320$var$SYMBOL = typeof Symbol === 'function' ? Symbol : void 0;
    var $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR = $4fa11bc3c2ea1320$var$SYMBOL && $4fa11bc3c2ea1320$var$SYMBOL.iterator;
    var $4fa11bc3c2ea1320$export$9785f547d3164dac = $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR || '@@iterator';
    function $4fa11bc3c2ea1320$export$9652023d9040757(obj) {
        return !!$4fa11bc3c2ea1320$export$23f5ee39f998bf6f(obj);
    }
    function $4fa11bc3c2ea1320$export$1e2f57719e155213(obj) {
        var length = obj != null && obj.length;
        return typeof length === 'number' && length >= 0 && length % 1 === 0;
    }
    function $4fa11bc3c2ea1320$export$cea7aa84e978eba5(obj) {
        return Object(obj) === obj && ($4fa11bc3c2ea1320$export$1e2f57719e155213(obj) || $4fa11bc3c2ea1320$export$9652023d9040757(obj));
    }
    function $4fa11bc3c2ea1320$export$6731da38428a8625(iterable) {
        var method = $4fa11bc3c2ea1320$export$23f5ee39f998bf6f(iterable);
        if (method) return method.call(iterable);
    }
    function $4fa11bc3c2ea1320$export$23f5ee39f998bf6f(iterable) {
        if (iterable != null) {
            var method = $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR && iterable[$4fa11bc3c2ea1320$var$SYMBOL_ITERATOR] || iterable['@@iterator'];
            if (typeof method === 'function') return method;
        }
    }
    function $4fa11bc3c2ea1320$export$7342c78d7e13e778(collection) {
        if (collection != null) {
            var iterator = $4fa11bc3c2ea1320$export$6731da38428a8625(collection);
            if (iterator) return iterator;
            if ($4fa11bc3c2ea1320$export$1e2f57719e155213(collection)) return new $4fa11bc3c2ea1320$var$ArrayLikeIterator(collection);
        }
    }
    function $4fa11bc3c2ea1320$var$ArrayLikeIterator(obj) {
        this._o = obj;
        this._i = 0;
    }
    $4fa11bc3c2ea1320$var$ArrayLikeIterator.prototype[$4fa11bc3c2ea1320$export$9785f547d3164dac] = function() {
        return this;
    };
    $4fa11bc3c2ea1320$var$ArrayLikeIterator.prototype.next = function() {
        if (this._o === void 0 || this._i >= this._o.length) {
            this._o = void 0;
            return {
                value: void 0,
                done: true
            };
        }
        return {
            value: this._o[this._i++],
            done: false
        };
    };
    function $4fa11bc3c2ea1320$export$4b80e395e36b5a56(collection, callback, thisArg) {
        if (collection != null) {
            if (typeof collection.forEach === 'function') return collection.forEach(callback, thisArg);
            var i = 0;
            var iterator = $4fa11bc3c2ea1320$export$6731da38428a8625(collection);
            if (iterator) {
                var step;
                while(!(step = iterator.next()).done){
                    callback.call(thisArg, step.value, i++, collection);
                    if (i > 9999999) throw new TypeError('Near-infinite iteration.');
                }
            } else if ($4fa11bc3c2ea1320$export$1e2f57719e155213(collection)) {
                for(; i < collection.length; i++)if (collection.hasOwnProperty(i)) callback.call(thisArg, collection[i], i, collection);
            }
        }
    }
    var $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR = $4fa11bc3c2ea1320$var$SYMBOL && $4fa11bc3c2ea1320$var$SYMBOL.asyncIterator;
    var $4fa11bc3c2ea1320$export$5ee754c34122a0ae = $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
    function $4fa11bc3c2ea1320$export$edb10ab8dd75a915(obj) {
        return !!$4fa11bc3c2ea1320$export$b39a85787ec1202f(obj);
    }
    function $4fa11bc3c2ea1320$export$d5127502cdffbf83(asyncIterable) {
        var method = $4fa11bc3c2ea1320$export$b39a85787ec1202f(asyncIterable);
        if (method) return method.call(asyncIterable);
    }
    function $4fa11bc3c2ea1320$export$b39a85787ec1202f(asyncIterable) {
        if (asyncIterable != null) {
            var method = $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR && asyncIterable[$4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
            if (typeof method === 'function') return method;
        }
    }
    function $4fa11bc3c2ea1320$export$86c18c6347f4a8c4(source) {
        if (source != null) {
            var asyncIterator = $4fa11bc3c2ea1320$export$d5127502cdffbf83(source);
            if (asyncIterator) return asyncIterator;
            var iterator = $4fa11bc3c2ea1320$export$7342c78d7e13e778(source);
            if (iterator) return new $4fa11bc3c2ea1320$var$AsyncFromSyncIterator(iterator);
        }
    }
    function $4fa11bc3c2ea1320$var$AsyncFromSyncIterator(iterator) {
        this._i = iterator;
    }
    $4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype[$4fa11bc3c2ea1320$export$5ee754c34122a0ae] = function() {
        return this;
    };
    $4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.next = function(value) {
        return $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'next', value);
    };
    $4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.return = function(value) {
        return this._i.return ? $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({
            value: value,
            done: true
        });
    };
    $4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.throw = function(value) {
        return this._i.throw ? $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
    };
    function $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(iterator, fn, value) {
        var step;
        return new Promise(function(resolve) {
            step = iterator[fn](value);
            resolve(step.value);
        }).then(function(value) {
            return {
                value: value,
                done: step.done
            };
        });
    }
    function $4fa11bc3c2ea1320$export$186aebae43ba1fda(source, callback, thisArg) {
        var asyncIterator = $4fa11bc3c2ea1320$export$86c18c6347f4a8c4(source);
        if (asyncIterator) {
            var i = 0;
            return new Promise(function(resolve, reject) {
                function next() {
                    asyncIterator.next().then(function(step) {
                        if (!step.done) Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
                        else resolve();
                        return null;
                    }).catch(reject);
                    return null;
                }
                next();
            });
        }
    }
});
parcelRegister("hedUd", function(module, exports) {
    var $c8ae87e141aaa748$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $c8ae87e141aaa748$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $eqS1b;
    var $8uUC9;
    var $kOX49;
    var $kd1Ee = parcelRequire("kd1Ee");
    var $c8ae87e141aaa748$var$parsedIntrospectionQuery = (0, parcelRequire("8uUC9")).parse((0, parcelRequire("kOX49")).getIntrospectionQuery());
    function $c8ae87e141aaa748$var$introspectSchema(fetcher, linkContext) {
        return $c8ae87e141aaa748$var$__awaiter(this, void 0, void 0, function() {
            var introspectionResult, schema;
            return $c8ae87e141aaa748$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (fetcher.request) fetcher = $kd1Ee.default(fetcher);
                        return [
                            4,
                            fetcher({
                                query: $c8ae87e141aaa748$var$parsedIntrospectionQuery,
                                context: linkContext
                            })
                        ];
                    case 1:
                        introspectionResult = _a.sent();
                        if (introspectionResult.errors && introspectionResult.errors.length || !introspectionResult.data.__schema) throw introspectionResult.errors;
                        else {
                            schema = (0, parcelRequire("eqS1b")).buildClientSchema(introspectionResult.data);
                            return [
                                2,
                                schema
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
    }
    module.exports.default = $c8ae87e141aaa748$var$introspectSchema;
});
parcelRegister("eqS1b", function(module, exports) {
    $parcel$export(module.exports, "buildClientSchema", ()=>$a81d653f06430efe$export$de8c236cf09c987c);
    var $isVmt;
    var $yEDl8;
    var $a1qmV;
    var $2gSpW;
    var $cJPdE;
    var $8uUC9;
    var $lUVCX;
    var $35Smo;
    var $djKly;
    var $4Hpke;
    var $8oLgk;
    var $9aGhX;
    function $a81d653f06430efe$export$de8c236cf09c987c(introspection, options) {
        (0, (0, parcelRequire("cJPdE")).default)(introspection) && (0, (0, parcelRequire("cJPdE")).default)(introspection.__schema) || (0, (0, parcelRequire("a1qmV")).default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, (0, parcelRequire("yEDl8")).default)(introspection), "."));
        var schemaIntrospection = introspection.__schema;
        var typeMap = (0, (0, parcelRequire("2gSpW")).default)(schemaIntrospection.types, function(typeIntrospection) {
            return typeIntrospection.name;
        }, function(typeIntrospection) {
            return buildType(typeIntrospection);
        });
        for(var _i2 = 0, _ref2 = [].concat((0, (0, parcelRequire("djKly")).specifiedScalarTypes), (0, (0, parcelRequire("4Hpke")).introspectionTypes)); _i2 < _ref2.length; _i2++){
            var stdType = _ref2[_i2];
            if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
        }
        var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
        var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
        var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null;
        var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : [];
        return new (0, (0, parcelRequire("lUVCX")).GraphQLSchema)({
            description: schemaIntrospection.description,
            query: queryType,
            mutation: mutationType,
            subscription: subscriptionType,
            types: (0, (0, parcelRequire("isVmt")).default)(typeMap),
            directives: directives,
            assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
        });
        function getType(typeRef) {
            if (typeRef.kind === (0, (0, parcelRequire("4Hpke")).TypeKind).LIST) {
                var itemRef = typeRef.ofType;
                if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
                return new (0, (0, parcelRequire("8oLgk")).GraphQLList)(getType(itemRef));
            }
            if (typeRef.kind === (0, (0, parcelRequire("4Hpke")).TypeKind).NON_NULL) {
                var nullableRef = typeRef.ofType;
                if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
                var nullableType = getType(nullableRef);
                return new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("8oLgk")).assertNullableType)(nullableType));
            }
            return getNamedType(typeRef);
        }
        function getNamedType(typeRef) {
            var typeName = typeRef.name;
            if (!typeName) throw new Error("Unknown type reference: ".concat((0, (0, parcelRequire("yEDl8")).default)(typeRef), "."));
            var type = typeMap[typeName];
            if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
            return type;
        }
        function getObjectType(typeRef) {
            return (0, (0, parcelRequire("8oLgk")).assertObjectType)(getNamedType(typeRef));
        }
        function getInterfaceType(typeRef) {
            return (0, (0, parcelRequire("8oLgk")).assertInterfaceType)(getNamedType(typeRef));
        }
        function buildType(type) {
            if (type != null && type.name != null && type.kind != null) switch(type.kind){
                case (0, (0, parcelRequire("4Hpke")).TypeKind).SCALAR:
                    return buildScalarDef(type);
                case (0, (0, parcelRequire("4Hpke")).TypeKind).OBJECT:
                    return buildObjectDef(type);
                case (0, (0, parcelRequire("4Hpke")).TypeKind).INTERFACE:
                    return buildInterfaceDef(type);
                case (0, (0, parcelRequire("4Hpke")).TypeKind).UNION:
                    return buildUnionDef(type);
                case (0, (0, parcelRequire("4Hpke")).TypeKind).ENUM:
                    return buildEnumDef(type);
                case (0, (0, parcelRequire("4Hpke")).TypeKind).INPUT_OBJECT:
                    return buildInputObjectDef(type);
            }
            var typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
            throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
        }
        function buildScalarDef(scalarIntrospection) {
            return new (0, (0, parcelRequire("8oLgk")).GraphQLScalarType)({
                name: scalarIntrospection.name,
                description: scalarIntrospection.description,
                specifiedByUrl: scalarIntrospection.specifiedByUrl
            });
        }
        function buildImplementationsList(implementingIntrospection) {
            if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, (0, parcelRequire("4Hpke")).TypeKind).INTERFACE) return [];
            if (!implementingIntrospection.interfaces) {
                var implementingIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(implementingIntrospection);
                throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
            }
            return implementingIntrospection.interfaces.map(getInterfaceType);
        }
        function buildObjectDef(objectIntrospection) {
            return new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
                name: objectIntrospection.name,
                description: objectIntrospection.description,
                interfaces: function interfaces() {
                    return buildImplementationsList(objectIntrospection);
                },
                fields: function fields() {
                    return buildFieldDefMap(objectIntrospection);
                }
            });
        }
        function buildInterfaceDef(interfaceIntrospection) {
            return new (0, (0, parcelRequire("8oLgk")).GraphQLInterfaceType)({
                name: interfaceIntrospection.name,
                description: interfaceIntrospection.description,
                interfaces: function interfaces() {
                    return buildImplementationsList(interfaceIntrospection);
                },
                fields: function fields() {
                    return buildFieldDefMap(interfaceIntrospection);
                }
            });
        }
        function buildUnionDef(unionIntrospection) {
            if (!unionIntrospection.possibleTypes) {
                var unionIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(unionIntrospection);
                throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
            }
            return new (0, (0, parcelRequire("8oLgk")).GraphQLUnionType)({
                name: unionIntrospection.name,
                description: unionIntrospection.description,
                types: function types() {
                    return unionIntrospection.possibleTypes.map(getObjectType);
                }
            });
        }
        function buildEnumDef(enumIntrospection) {
            if (!enumIntrospection.enumValues) {
                var enumIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(enumIntrospection);
                throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
            }
            return new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
                name: enumIntrospection.name,
                description: enumIntrospection.description,
                values: (0, (0, parcelRequire("2gSpW")).default)(enumIntrospection.enumValues, function(valueIntrospection) {
                    return valueIntrospection.name;
                }, function(valueIntrospection) {
                    return {
                        description: valueIntrospection.description,
                        deprecationReason: valueIntrospection.deprecationReason
                    };
                })
            });
        }
        function buildInputObjectDef(inputObjectIntrospection) {
            if (!inputObjectIntrospection.inputFields) {
                var inputObjectIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(inputObjectIntrospection);
                throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
            }
            return new (0, (0, parcelRequire("8oLgk")).GraphQLInputObjectType)({
                name: inputObjectIntrospection.name,
                description: inputObjectIntrospection.description,
                fields: function fields() {
                    return buildInputValueDefMap(inputObjectIntrospection.inputFields);
                }
            });
        }
        function buildFieldDefMap(typeIntrospection) {
            if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, (0, parcelRequire("yEDl8")).default)(typeIntrospection), "."));
            return (0, (0, parcelRequire("2gSpW")).default)(typeIntrospection.fields, function(fieldIntrospection) {
                return fieldIntrospection.name;
            }, buildField);
        }
        function buildField(fieldIntrospection) {
            var type = getType(fieldIntrospection.type);
            if (!(0, (0, parcelRequire("8oLgk")).isOutputType)(type)) {
                var typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
                throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
            }
            if (!fieldIntrospection.args) {
                var fieldIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(fieldIntrospection);
                throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
            }
            return {
                description: fieldIntrospection.description,
                deprecationReason: fieldIntrospection.deprecationReason,
                type: type,
                args: buildInputValueDefMap(fieldIntrospection.args)
            };
        }
        function buildInputValueDefMap(inputValueIntrospections) {
            return (0, (0, parcelRequire("2gSpW")).default)(inputValueIntrospections, function(inputValue) {
                return inputValue.name;
            }, buildInputValue);
        }
        function buildInputValue(inputValueIntrospection) {
            var type = getType(inputValueIntrospection.type);
            if (!(0, (0, parcelRequire("8oLgk")).isInputType)(type)) {
                var typeStr = (0, (0, parcelRequire("yEDl8")).default)(type);
                throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
            }
            var defaultValue = inputValueIntrospection.defaultValue != null ? (0, (0, parcelRequire("9aGhX")).valueFromAST)((0, (0, parcelRequire("8uUC9")).parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
            return {
                description: inputValueIntrospection.description,
                type: type,
                defaultValue: defaultValue,
                deprecationReason: inputValueIntrospection.deprecationReason
            };
        }
        function buildDirective(directiveIntrospection) {
            if (!directiveIntrospection.args) {
                var directiveIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(directiveIntrospection);
                throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
            }
            if (!directiveIntrospection.locations) {
                var _directiveIntrospectionStr = (0, (0, parcelRequire("yEDl8")).default)(directiveIntrospection);
                throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
            }
            return new (0, (0, parcelRequire("35Smo")).GraphQLDirective)({
                name: directiveIntrospection.name,
                description: directiveIntrospection.description,
                isRepeatable: directiveIntrospection.isRepeatable,
                locations: directiveIntrospection.locations.slice(),
                args: buildInputValueDefMap(directiveIntrospection.args)
            });
        }
    }
});
parcelRegister("kOX49", function(module, exports) {
    $parcel$export(module.exports, "getIntrospectionQuery", ()=>$f2864b6b34ba48ee$export$67a66015194c88d7);
    function $f2864b6b34ba48ee$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $f2864b6b34ba48ee$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) $f2864b6b34ba48ee$var$ownKeys(Object(source), true).forEach(function(key) {
                $f2864b6b34ba48ee$var$_defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else $f2864b6b34ba48ee$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $f2864b6b34ba48ee$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $f2864b6b34ba48ee$export$67a66015194c88d7(options) {
        var optionsWithDefault = $f2864b6b34ba48ee$var$_objectSpread({
            descriptions: true,
            specifiedByUrl: false,
            directiveIsRepeatable: false,
            schemaDescription: false,
            inputValueDeprecation: false
        }, options);
        var descriptions = optionsWithDefault.descriptions ? 'description' : '';
        var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
        var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
        var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
        function inputDeprecation(str) {
            return optionsWithDefault.inputValueDeprecation ? str : '';
        }
        return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
    }
});
parcelRegister("5Cx8V", function(module, exports) {
    var $417a35e0728175b6$var$__assign = module.exports && module.exports.__assign || function() {
        $417a35e0728175b6$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $417a35e0728175b6$var$__assign.apply(this, arguments);
    };
    var $417a35e0728175b6$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8mJYM;
    var $8oLgk;
    var $35Smo;
    var $lUVCX;
    var $bzIlO;
    var $8uUC9;
    var $gIDuj = parcelRequire("gIDuj");
    var $cPwLY = parcelRequire("cPwLY");
    var $bkP2b = parcelRequire("bkP2b");
    var $dfTWq = parcelRequire("dfTWq");
    var $810gP = parcelRequire("810gP");
    var $4Imtl = parcelRequire("4Imtl");
    var $48EbR = parcelRequire("48EbR");
    function $417a35e0728175b6$var$mergeSchemas(_a) {
        var schemas = _a.schemas, onTypeConflict = _a.onTypeConflict, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
        return $417a35e0728175b6$var$mergeSchemasImplementation({
            schemas: schemas,
            resolvers: resolvers,
            schemaDirectives: schemaDirectives,
            inheritResolversFromInterfaces: inheritResolversFromInterfaces,
            mergeDirectives: mergeDirectives
        });
    }
    module.exports.default = $417a35e0728175b6$var$mergeSchemas;
    function $417a35e0728175b6$var$mergeSchemasImplementation(_a) {
        var schemas = _a.schemas, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
        var allSchemas = [];
        var typeCandidates = {};
        var types = {};
        var extensions = [];
        var directives = [];
        var fragments = [];
        var resolveType = $cPwLY.createResolveType(function(name) {
            if (types[name] === undefined) throw new Error("Can't find type " + name + ".");
            return types[name];
        });
        schemas.forEach(function(schema) {
            if (schema instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) {
                allSchemas.push(schema);
                var queryType_1 = schema.getQueryType();
                var mutationType_1 = schema.getMutationType();
                var subscriptionType_1 = schema.getSubscriptionType();
                if (queryType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Query', {
                    schema: schema,
                    type: queryType_1
                });
                if (mutationType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Mutation', {
                    schema: schema,
                    type: mutationType_1
                });
                if (subscriptionType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Subscription', {
                    schema: schema,
                    type: subscriptionType_1
                });
                if (mergeDirectives) {
                    var directiveInstances = schema.getDirectives();
                    directiveInstances.forEach(function(directive) {
                        directives.push(directive);
                    });
                }
                var typeMap_1 = schema.getTypeMap();
                Object.keys(typeMap_1).forEach(function(typeName) {
                    var type = typeMap_1[typeName];
                    if ((0, parcelRequire("8oLgk")).isNamedType(type) && (0, parcelRequire("8oLgk")).getNamedType(type).name.slice(0, 2) !== '__' && type !== queryType_1 && type !== mutationType_1 && type !== subscriptionType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                        schema: schema,
                        type: type
                    });
                });
            } else if (typeof schema === 'string' || schema && schema.kind === (0, parcelRequire("bzIlO")).Kind.DOCUMENT) {
                var parsedSchemaDocument = typeof schema === 'string' ? (0, parcelRequire("8uUC9")).parse(schema) : schema;
                parsedSchemaDocument.definitions.forEach(function(def) {
                    var type = $dfTWq.default(def);
                    if (type instanceof (0, parcelRequire("35Smo")).GraphQLDirective && mergeDirectives) directives.push(type);
                    else if (type && !(type instanceof (0, parcelRequire("35Smo")).GraphQLDirective)) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                        type: type
                    });
                });
                var extensionsDocument = $gIDuj.extractExtensionDefinitions(parsedSchemaDocument);
                if (extensionsDocument.definitions.length > 0) extensions.push(extensionsDocument);
            } else if (Array.isArray(schema)) schema.forEach(function(type) {
                $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                    type: type
                });
            });
            else throw new Error("Invalid schema passed");
        });
        var mergeInfo = $417a35e0728175b6$var$createMergeInfo(allSchemas, fragments);
        if (!resolvers) resolvers = {};
        else if (typeof resolvers === 'function') {
            console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
            resolvers = resolvers(mergeInfo);
        } else if (Array.isArray(resolvers)) resolvers = resolvers.reduce(function(left, right) {
            if (typeof right === 'function') {
                console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
                right = right(mergeInfo);
            }
            return $4Imtl.default(left, right);
        }, {});
        var generatedResolvers = {};
        Object.keys(typeCandidates).forEach(function(typeName) {
            var resultType = $417a35e0728175b6$var$defaultVisitType(typeName, typeCandidates[typeName]);
            if (resultType === null) types[typeName] = null;
            else {
                var type = void 0;
                var typeResolvers = void 0;
                if ((0, parcelRequire("8oLgk")).isNamedType(resultType)) type = resultType;
                else if (resultType.type) {
                    type = resultType.type;
                    typeResolvers = resultType.resolvers;
                } else throw new Error("Invalid visitType result for type " + typeName);
                types[typeName] = $cPwLY.recreateType(type, resolveType, false);
                if (typeResolvers) generatedResolvers[typeName] = typeResolvers;
            }
        });
        var mergedSchema = new (0, parcelRequire("lUVCX")).GraphQLSchema({
            query: types.Query,
            mutation: types.Mutation,
            subscription: types.Subscription,
            types: Object.keys(types).map(function(key) {
                return types[key];
            }),
            directives: directives.map(function(directive) {
                return $cPwLY.recreateDirective(directive, resolveType);
            })
        });
        extensions.forEach(function(extension) {
            mergedSchema = (0, parcelRequire("8mJYM")).extendSchema(mergedSchema, extension, {
                commentDescriptions: true
            });
        });
        if (!resolvers) resolvers = {};
        else if (Array.isArray(resolvers)) resolvers = resolvers.reduce($4Imtl.default, {});
        Object.keys(resolvers).forEach(function(typeName) {
            var type = resolvers[typeName];
            if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType) return;
            Object.keys(type).forEach(function(fieldName) {
                var field = type[fieldName];
                if (field.fragment) fragments.push({
                    field: fieldName,
                    fragment: field.fragment
                });
            });
        });
        mergedSchema = $gIDuj.addResolveFunctionsToSchema({
            schema: mergedSchema,
            resolvers: $4Imtl.default(generatedResolvers, resolvers),
            inheritResolversFromInterfaces: inheritResolversFromInterfaces
        });
        $417a35e0728175b6$var$forEachField(mergedSchema, function(field) {
            if (field.resolve) {
                var fieldResolver_1 = field.resolve;
                field.resolve = function(parent, args, context, info) {
                    var newInfo = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, info), {
                        mergeInfo: mergeInfo
                    });
                    return fieldResolver_1(parent, args, context, newInfo);
                };
            }
            if (field.subscribe) {
                var fieldResolver_2 = field.subscribe;
                field.subscribe = function(parent, args, context, info) {
                    var newInfo = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, info), {
                        mergeInfo: mergeInfo
                    });
                    return fieldResolver_2(parent, args, context, newInfo);
                };
            }
        });
        if (schemaDirectives) $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(mergedSchema, schemaDirectives);
        return mergedSchema;
    }
    function $417a35e0728175b6$var$createMergeInfo(allSchemas, fragments) {
        return {
            delegate: function(operation, fieldName, args, context, info, transforms) {
                console.warn("`mergeInfo.delegate` is deprecated. Use `mergeInfo.delegateToSchema and pass explicit schema instances.");
                var schema = $417a35e0728175b6$var$guessSchemaByRootField(allSchemas, operation, fieldName);
                var expandTransforms = new $810gP.ExpandAbstractTypes(info.schema, schema);
                var fragmentTransform = new $810gP.ReplaceFieldWithFragment(schema, fragments);
                return $bkP2b.default({
                    schema: schema,
                    operation: operation,
                    fieldName: fieldName,
                    args: args,
                    context: context,
                    info: info,
                    transforms: $417a35e0728175b6$var$__spreadArrays(transforms || [], [
                        expandTransforms,
                        fragmentTransform
                    ])
                });
            },
            delegateToSchema: function(options) {
                return $bkP2b.default($417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, options), {
                    transforms: options.transforms
                }));
            },
            fragments: fragments
        };
    }
    function $417a35e0728175b6$var$guessSchemaByRootField(schemas, operation, fieldName) {
        for(var _i = 0, schemas_1 = schemas; _i < schemas_1.length; _i++){
            var schema = schemas_1[_i];
            var rootObject = void 0;
            if (operation === 'subscription') rootObject = schema.getSubscriptionType();
            else if (operation === 'mutation') rootObject = schema.getMutationType();
            else rootObject = schema.getQueryType();
            if (rootObject) {
                var fields = rootObject.getFields();
                if (fields[fieldName]) return schema;
            }
        }
        throw new Error("Could not find subschema with field `" + operation + "." + fieldName + "`");
    }
    function $417a35e0728175b6$var$createDelegatingResolver(schema, operation, fieldName) {
        return function(root, args, context, info) {
            return info.mergeInfo.delegateToSchema({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: args,
                context: context,
                info: info
            });
        };
    }
    function $417a35e0728175b6$var$forEachField(schema, fn) {
        var typeMap = schema.getTypeMap();
        Object.keys(typeMap).forEach(function(typeName) {
            var type = typeMap[typeName];
            if (!(0, parcelRequire("8oLgk")).getNamedType(type).name.startsWith('__') && type instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType) {
                var fields_1 = type.getFields();
                Object.keys(fields_1).forEach(function(fieldName) {
                    var field = fields_1[fieldName];
                    fn(field, typeName, fieldName);
                });
            }
        });
    }
    function $417a35e0728175b6$var$addTypeCandidate(typeCandidates, name, typeCandidate) {
        if (!typeCandidates[name]) typeCandidates[name] = [];
        typeCandidates[name].push(typeCandidate);
    }
    function $417a35e0728175b6$var$defaultVisitType(name, candidates, candidateSelector) {
        if (!candidateSelector) candidateSelector = function(cands) {
            return cands[cands.length - 1];
        };
        var resolveType = $cPwLY.createResolveType(function(_, type) {
            return type;
        });
        if (name === 'Query' || name === 'Mutation' || name === 'Subscription') {
            var fields_2 = {};
            var operationName_1;
            switch(name){
                case 'Query':
                    operationName_1 = 'query';
                    break;
                case 'Mutation':
                    operationName_1 = 'mutation';
                    break;
                case 'Subscription':
                    operationName_1 = 'subscription';
                    break;
                default:
                    break;
            }
            var resolvers_1 = {};
            var resolverKey_1 = operationName_1 === 'subscription' ? 'subscribe' : 'resolve';
            candidates.forEach(function(_a) {
                var candidateType = _a.type, schema = _a.schema;
                var candidateFields = candidateType.getFields();
                fields_2 = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, fields_2), candidateFields);
                Object.keys(candidateFields).forEach(function(fieldName) {
                    var _a;
                    resolvers_1[fieldName] = (_a = {}, _a[resolverKey_1] = $417a35e0728175b6$var$createDelegatingResolver(schema, operationName_1, fieldName), _a);
                });
            });
            var type = new (0, parcelRequire("8oLgk")).GraphQLObjectType({
                name: name,
                fields: $cPwLY.fieldMapToFieldConfigMap(fields_2, resolveType, false)
            });
            return {
                type: type,
                resolvers: resolvers_1
            };
        } else {
            var candidate = candidateSelector(candidates);
            return candidate.type;
        }
    }
});
parcelRegister("bkP2b", function(module, exports) {
    var $8409264dd9216e7f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $8409264dd9216e7f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var $8409264dd9216e7f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $mP8zZ;
    var $lUVCX;
    var $8oLgk;
    var $bzIlO;
    var $40hj3;
    var $c6jur;
    var $9CEZe = parcelRequire("9CEZe");
    var $4oDNM = parcelRequire("4oDNM");
    var $b9txq = parcelRequire("b9txq");
    var $5FnE9 = parcelRequire("5FnE9");
    var $XeiAr = parcelRequire("XeiAr");
    var $3Cwvd = parcelRequire("3Cwvd");
    var $6Qqmu = parcelRequire("6Qqmu");
    var $2WTvk = parcelRequire("2WTvk");
    var $iP6T0 = parcelRequire("iP6T0");
    function $8409264dd9216e7f$var$delegateToSchema(options) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (options instanceof (0, parcelRequire("lUVCX")).GraphQLSchema) throw new Error("Passing positional arguments to delegateToSchema is a deprecated. Please pass named parameters instead.");
        return $8409264dd9216e7f$var$delegateToSchemaImplementation(options);
    }
    module.exports.default = $8409264dd9216e7f$var$delegateToSchema;
    function $8409264dd9216e7f$var$delegateToSchemaImplementation(options) {
        return $8409264dd9216e7f$var$__awaiter(this, void 0, void 0, function() {
            var info, _a, args, operation, rawDocument, rawRequest, transforms, processedRequest, errors, _b, executionResult;
            return $8409264dd9216e7f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        info = options.info, _a = options.args, args = _a === void 0 ? {} : _a;
                        operation = options.operation || info.operation.operation;
                        rawDocument = $8409264dd9216e7f$var$createDocument(options.fieldName, operation, info.fieldNodes, Object.keys(info.fragments).map(function(fragmentName) {
                            return info.fragments[fragmentName];
                        }), info.operation.variableDefinitions, info.operation.name);
                        rawRequest = {
                            document: rawDocument,
                            variables: info.variableValues
                        };
                        transforms = $8409264dd9216e7f$var$__spreadArrays(options.transforms || [], [
                            new $6Qqmu.default(info.schema, options.schema)
                        ]);
                        if (info.mergeInfo && info.mergeInfo.fragments) transforms.push(new $2WTvk.default(options.schema, info.mergeInfo.fragments));
                        transforms = transforms.concat([
                            new $4oDNM.default(options.schema, args),
                            new $b9txq.default(options.schema),
                            new $5FnE9.default(options.schema),
                            new $XeiAr.default(info, options.fieldName)
                        ]);
                        if ((0, parcelRequire("8oLgk")).isEnumType(options.info.returnType)) transforms = transforms.concat(new $iP6T0.default(options.info.returnType));
                        processedRequest = $9CEZe.applyRequestTransforms(rawRequest, transforms);
                        if (!options.skipValidation) {
                            errors = (0, parcelRequire("c6jur")).validate(options.schema, processedRequest.document);
                            if (errors.length > 0) throw errors;
                        }
                        if (!(operation === 'query' || operation === 'mutation')) return [
                            3,
                            2
                        ];
                        _b = $9CEZe.applyResultTransforms;
                        return [
                            4,
                            (0, parcelRequire("mP8zZ")).execute(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                        ];
                    case 1:
                        return [
                            2,
                            _b.apply(void 0, [
                                _c.sent(),
                                transforms
                            ])
                        ];
                    case 2:
                        if (!(operation === 'subscription')) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0, parcelRequire("40hj3")).subscribe(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                        ];
                    case 3:
                        executionResult = _c.sent();
                        return [
                            2,
                            $3Cwvd.default(executionResult, function(result) {
                                var _a;
                                var transformedResult = $9CEZe.applyResultTransforms(result, transforms);
                                var subscriptionKey = Object.keys(result.data)[0];
                                return _a = {}, _a[subscriptionKey] = transformedResult, _a;
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }
    function $8409264dd9216e7f$var$createDocument(targetField, targetOperation, originalSelections, fragments, variables, operationName) {
        var selections = [];
        var args = [];
        originalSelections.forEach(function(field) {
            var fieldSelections = field.selectionSet ? field.selectionSet.selections : [];
            selections = selections.concat(fieldSelections);
            args = args.concat(field.arguments || []);
        });
        var selectionSet = null;
        if (selections.length > 0) selectionSet = {
            kind: (0, parcelRequire("bzIlO")).Kind.SELECTION_SET,
            selections: selections
        };
        var rootField = {
            kind: (0, parcelRequire("bzIlO")).Kind.FIELD,
            alias: null,
            arguments: args,
            selectionSet: selectionSet,
            name: {
                kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                value: targetField
            }
        };
        var rootSelectionSet = {
            kind: (0, parcelRequire("bzIlO")).Kind.SELECTION_SET,
            selections: [
                rootField
            ]
        };
        var operationDefinition = {
            kind: (0, parcelRequire("bzIlO")).Kind.OPERATION_DEFINITION,
            operation: targetOperation,
            variableDefinitions: variables,
            selectionSet: rootSelectionSet,
            name: operationName
        };
        return {
            kind: (0, parcelRequire("bzIlO")).Kind.DOCUMENT,
            definitions: $8409264dd9216e7f$var$__spreadArrays([
                operationDefinition
            ], fragments)
        };
    }
});
parcelRegister("40hj3", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$2ea4962eb4b8b875$export$ec068583843480e7);
    var $yEDl8;
    var $lLo68;
    var $hEo2F;
    var $g5yZB;
    var $csEv9;
    var $7dqoX;
    var $mP8zZ;
    var $etM9Y;
    var $iLnJr;
    function $2ea4962eb4b8b875$export$ec068583843480e7(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
        return arguments.length === 1 ? $2ea4962eb4b8b875$var$subscribeImpl(argsOrSchema) : $2ea4962eb4b8b875$var$subscribeImpl({
            schema: argsOrSchema,
            document: document,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            subscribeFieldResolver: subscribeFieldResolver
        });
    }
    function $2ea4962eb4b8b875$var$reportGraphQLError(error) {
        if (error instanceof (0, (0, parcelRequire("g5yZB")).GraphQLError)) return {
            errors: [
                error
            ]
        };
        throw error;
    }
    function $2ea4962eb4b8b875$var$subscribeImpl(args) {
        var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
        var sourcePromise = $2ea4962eb4b8b875$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver);
        var mapSourceToResponse = function mapSourceToResponse(payload) {
            return (0, (0, parcelRequire("mP8zZ")).execute)({
                schema: schema,
                document: document,
                rootValue: payload,
                contextValue: contextValue,
                variableValues: variableValues,
                operationName: operationName,
                fieldResolver: fieldResolver
            });
        };
        return sourcePromise.then(function(resultOrStream) {
            return (0, (0, parcelRequire("lLo68")).default)(resultOrStream) ? (0, (0, parcelRequire("iLnJr")).default)(resultOrStream, mapSourceToResponse, $2ea4962eb4b8b875$var$reportGraphQLError) : resultOrStream;
        });
    }
    function $2ea4962eb4b8b875$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
        (0, (0, parcelRequire("mP8zZ")).assertValidExecutionArguments)(schema, document, variableValues);
        return new Promise(function(resolve) {
            var exeContext = (0, (0, parcelRequire("mP8zZ")).buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
            resolve(Array.isArray(exeContext) ? {
                errors: exeContext
            } : $2ea4962eb4b8b875$var$executeSubscription(exeContext));
        }).catch($2ea4962eb4b8b875$var$reportGraphQLError);
    }
    function $2ea4962eb4b8b875$var$executeSubscription(exeContext) {
        var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
        var type = (0, (0, parcelRequire("etM9Y")).getOperationRootType)(schema, operation);
        var fields = (0, (0, parcelRequire("mP8zZ")).collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
        var responseNames = Object.keys(fields);
        var responseName = responseNames[0];
        var fieldNodes = fields[responseName];
        var fieldNode = fieldNodes[0];
        var fieldName = fieldNode.name.value;
        var fieldDef = (0, (0, parcelRequire("mP8zZ")).getFieldDef)(schema, type, fieldName);
        if (!fieldDef) throw new (0, (0, parcelRequire("g5yZB")).GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
        var path = (0, (0, parcelRequire("hEo2F")).addPath)(undefined, responseName, type.name);
        var info = (0, (0, parcelRequire("mP8zZ")).buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path);
        return new Promise(function(resolveResult) {
            var _fieldDef$subscribe;
            var args = (0, (0, parcelRequire("7dqoX")).getArgumentValues)(fieldDef, fieldNodes[0], variableValues);
            var contextValue = exeContext.contextValue;
            var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
            resolveResult(resolveFn(rootValue, args, contextValue, info));
        }).then(function(eventStream) {
            if (eventStream instanceof Error) throw (0, (0, parcelRequire("csEv9")).locatedError)(eventStream, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(path));
            if (!(0, (0, parcelRequire("lLo68")).default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, (0, parcelRequire("yEDl8")).default)(eventStream), "."));
            return eventStream;
        }, function(error) {
            throw (0, (0, parcelRequire("csEv9")).locatedError)(error, fieldNodes, (0, (0, parcelRequire("hEo2F")).pathToArray)(path));
        });
    }
});
parcelRegister("lLo68", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd80ae1b6a9b0f46$export$2e2bcd8739ae039);
    var $6DBwa;
    function $fd80ae1b6a9b0f46$export$2e2bcd8739ae039(maybeAsyncIterable) {
        return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, (0, parcelRequire("6DBwa")).SYMBOL_ASYNC_ITERATOR]) === 'function';
    }
});
parcelRegister("iLnJr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da8f0678f4258a56$export$2e2bcd8739ae039);
    var $6DBwa;
    function $da8f0678f4258a56$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $da8f0678f4258a56$export$2e2bcd8739ae039(iterable, callback, rejectCallback) {
        var iteratorMethod = iterable[0, (0, parcelRequire("6DBwa")).SYMBOL_ASYNC_ITERATOR];
        var iterator = iteratorMethod.call(iterable);
        var $return;
        var abruptClose;
        if (typeof iterator.return === 'function') {
            $return = iterator.return;
            abruptClose = function abruptClose(error) {
                var rethrow = function rethrow() {
                    return Promise.reject(error);
                };
                return $return.call(iterator).then(rethrow, rethrow);
            };
        }
        function mapResult(result) {
            return result.done ? result : $da8f0678f4258a56$var$asyncMapValue(result.value, callback).then($da8f0678f4258a56$var$iteratorResult, abruptClose);
        }
        var mapReject;
        if (rejectCallback) {
            var reject = rejectCallback;
            mapReject = function mapReject(error) {
                return $da8f0678f4258a56$var$asyncMapValue(error, reject).then($da8f0678f4258a56$var$iteratorResult, abruptClose);
            };
        }
        return $da8f0678f4258a56$var$_defineProperty({
            next: function next() {
                return iterator.next().then(mapResult, mapReject);
            },
            return: function _return() {
                return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                    value: undefined,
                    done: true
                });
            },
            throw: function _throw(error) {
                if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
                return Promise.reject(error).catch(abruptClose);
            }
        }, (0, (0, parcelRequire("6DBwa")).SYMBOL_ASYNC_ITERATOR), function() {
            return this;
        });
    }
    function $da8f0678f4258a56$var$asyncMapValue(value, callback) {
        return new Promise(function(resolve) {
            return resolve(callback(value));
        });
    }
    function $da8f0678f4258a56$var$iteratorResult(value) {
        return {
            value: value,
            done: false
        };
    }
});
parcelRegister("4oDNM", function(module, exports) {
    var $3338471fdbe5b1f4$var$__assign = module.exports && module.exports.__assign || function() {
        $3338471fdbe5b1f4$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $3338471fdbe5b1f4$var$__assign.apply(this, arguments);
    };
    var $3338471fdbe5b1f4$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bzIlO;
    var $3338471fdbe5b1f4$var$AddArgumentsAsVariablesTransform = function() {
        function AddArgumentsAsVariablesTransform(schema, args) {
            this.schema = schema;
            this.args = args;
        }
        AddArgumentsAsVariablesTransform.prototype.transformRequest = function(originalRequest) {
            var _a = $3338471fdbe5b1f4$var$addVariablesToRootField(this.schema, originalRequest.document, this.args), document = _a.document, newVariables = _a.newVariables;
            var variables = $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, originalRequest.variables), newVariables);
            return {
                document: document,
                variables: variables
            };
        };
        return AddArgumentsAsVariablesTransform;
    }();
    module.exports.default = $3338471fdbe5b1f4$var$AddArgumentsAsVariablesTransform;
    function $3338471fdbe5b1f4$var$addVariablesToRootField(targetSchema, document, args) {
        var operations = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.OPERATION_DEFINITION;
        });
        var fragments = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION;
        });
        var variableNames = {};
        var newOperations = operations.map(function(operation) {
            var existingVariables = operation.variableDefinitions.map(function(variableDefinition) {
                return variableDefinition.variable.name.value;
            });
            var variableCounter = 0;
            var variables = {};
            var generateVariableName = function(argName) {
                var varName;
                do {
                    varName = "_v" + variableCounter + "_" + argName;
                    variableCounter++;
                }while (existingVariables.indexOf(varName) !== -1)
                return varName;
            };
            var type;
            if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
            else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
            else type = targetSchema.getQueryType();
            var newSelectionSet = [];
            operation.selectionSet.selections.forEach(function(selection) {
                if (selection.kind === (0, parcelRequire("bzIlO")).Kind.FIELD) {
                    var newArgs_1 = {};
                    selection.arguments.forEach(function(argument) {
                        newArgs_1[argument.name.value] = argument;
                    });
                    var name_1 = selection.name.value;
                    var field = type.getFields()[name_1];
                    field.args.forEach(function(argument) {
                        if (argument.name in args) {
                            var variableName = generateVariableName(argument.name);
                            variableNames[argument.name] = variableName;
                            newArgs_1[argument.name] = {
                                kind: (0, parcelRequire("bzIlO")).Kind.ARGUMENT,
                                name: {
                                    kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                    value: argument.name
                                },
                                value: {
                                    kind: (0, parcelRequire("bzIlO")).Kind.VARIABLE,
                                    name: {
                                        kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                        value: variableName
                                    }
                                }
                            };
                            existingVariables.push(variableName);
                            variables[variableName] = {
                                kind: (0, parcelRequire("bzIlO")).Kind.VARIABLE_DEFINITION,
                                variable: {
                                    kind: (0, parcelRequire("bzIlO")).Kind.VARIABLE,
                                    name: {
                                        kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                        value: variableName
                                    }
                                },
                                type: $3338471fdbe5b1f4$var$typeToAst(argument.type)
                            };
                        }
                    });
                    newSelectionSet.push($3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, selection), {
                        arguments: Object.keys(newArgs_1).map(function(argName) {
                            return newArgs_1[argName];
                        })
                    }));
                } else newSelectionSet.push(selection);
            });
            return $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, operation), {
                variableDefinitions: operation.variableDefinitions.concat(Object.keys(variables).map(function(varName) {
                    return variables[varName];
                })),
                selectionSet: {
                    kind: (0, parcelRequire("bzIlO")).Kind.SELECTION_SET,
                    selections: newSelectionSet
                }
            });
        });
        var newVariables = {};
        Object.keys(variableNames).forEach(function(name) {
            newVariables[variableNames[name]] = args[name];
        });
        return {
            document: $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, document), {
                definitions: $3338471fdbe5b1f4$var$__spreadArrays(newOperations, fragments)
            }),
            newVariables: newVariables
        };
    }
    function $3338471fdbe5b1f4$var$typeToAst(type) {
        if (type instanceof (0, parcelRequire("8oLgk")).GraphQLNonNull) {
            var innerType = $3338471fdbe5b1f4$var$typeToAst(type.ofType);
            if (innerType.kind === (0, parcelRequire("bzIlO")).Kind.LIST_TYPE || innerType.kind === (0, parcelRequire("bzIlO")).Kind.NAMED_TYPE) return {
                kind: (0, parcelRequire("bzIlO")).Kind.NON_NULL_TYPE,
                type: innerType
            };
            else throw new Error('Incorrent inner non-null type');
        } else if (type instanceof (0, parcelRequire("8oLgk")).GraphQLList) return {
            kind: (0, parcelRequire("bzIlO")).Kind.LIST_TYPE,
            type: $3338471fdbe5b1f4$var$typeToAst(type.ofType)
        };
        else return {
            kind: (0, parcelRequire("bzIlO")).Kind.NAMED_TYPE,
            name: {
                kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                value: type.toString()
            }
        };
    }
});
parcelRegister("b9txq", function(module, exports) {
    var $81e7729e1342f8d1$var$__assign = module.exports && module.exports.__assign || function() {
        $81e7729e1342f8d1$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $81e7729e1342f8d1$var$__assign.apply(this, arguments);
    };
    var $81e7729e1342f8d1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bzIlO;
    var $4Hpke;
    var $12QNw;
    var $jdSTa = parcelRequire("jdSTa");
    var $81e7729e1342f8d1$var$FilterToSchema = function() {
        function FilterToSchema(targetSchema) {
            this.targetSchema = targetSchema;
        }
        FilterToSchema.prototype.transformRequest = function(originalRequest) {
            var document = $81e7729e1342f8d1$var$filterDocumentToSchema(this.targetSchema, originalRequest.document);
            return $81e7729e1342f8d1$var$__assign($81e7729e1342f8d1$var$__assign({}, originalRequest), {
                document: document
            });
        };
        return FilterToSchema;
    }();
    module.exports.default = $81e7729e1342f8d1$var$FilterToSchema;
    function $81e7729e1342f8d1$var$filterDocumentToSchema(targetSchema, document) {
        var operations = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.OPERATION_DEFINITION;
        });
        var fragments = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION;
        });
        var usedFragments = [];
        var newOperations = [];
        var newFragments = [];
        var validFragments = fragments.filter(function(fragment) {
            var typeName = fragment.typeCondition.name.value;
            return Boolean(targetSchema.getType(typeName));
        });
        var validFragmentsWithType = {};
        validFragments.forEach(function(fragment) {
            var typeName = fragment.typeCondition.name.value;
            var type = targetSchema.getType(typeName);
            validFragmentsWithType[fragment.name.value] = type;
        });
        var fragmentSet = Object.create(null);
        operations.forEach(function(operation) {
            var type;
            if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
            else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
            else type = targetSchema.getQueryType();
            var _a = $81e7729e1342f8d1$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, operation.selectionSet), selectionSet = _a.selectionSet, operationUsedFragments = _a.usedFragments, operationUsedVariables = _a.usedVariables;
            usedFragments = $81e7729e1342f8d1$var$union(usedFragments, operationUsedFragments);
            var _b = $81e7729e1342f8d1$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments), collectedUsedVariables = _b.usedVariables, collectedNewFragments = _b.newFragments, collectedFragmentSet = _b.fragmentSet;
            var fullUsedVariables = $81e7729e1342f8d1$var$union(operationUsedVariables, collectedUsedVariables);
            newFragments = collectedNewFragments;
            fragmentSet = collectedFragmentSet;
            var variableDefinitions = operation.variableDefinitions.filter(function(variable) {
                return fullUsedVariables.indexOf(variable.variable.name.value) !== -1;
            });
            newOperations.push({
                kind: (0, parcelRequire("bzIlO")).Kind.OPERATION_DEFINITION,
                operation: operation.operation,
                name: operation.name,
                directives: operation.directives,
                variableDefinitions: variableDefinitions,
                selectionSet: selectionSet
            });
        });
        return {
            kind: (0, parcelRequire("bzIlO")).Kind.DOCUMENT,
            definitions: $81e7729e1342f8d1$var$__spreadArrays(newOperations, newFragments)
        };
    }
    function $81e7729e1342f8d1$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments) {
        var usedVariables = [];
        var newFragments = [];
        var _loop_1 = function() {
            var nextFragmentName = usedFragments.pop();
            var fragment = validFragments.find(function(fr) {
                return fr.name.value === nextFragmentName;
            });
            if (fragment) {
                var name_1 = nextFragmentName;
                var typeName = fragment.typeCondition.name.value;
                var type = targetSchema.getType(typeName);
                var _a = $81e7729e1342f8d1$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, fragment.selectionSet), selectionSet = _a.selectionSet, fragmentUsedFragments = _a.usedFragments, fragmentUsedVariables = _a.usedVariables;
                usedFragments = $81e7729e1342f8d1$var$union(usedFragments, fragmentUsedFragments);
                usedVariables = $81e7729e1342f8d1$var$union(usedVariables, fragmentUsedVariables);
                if (!fragmentSet[name_1]) {
                    fragmentSet[name_1] = true;
                    newFragments.push({
                        kind: (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION,
                        name: {
                            kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                            value: name_1
                        },
                        typeCondition: fragment.typeCondition,
                        selectionSet: selectionSet
                    });
                }
            }
        };
        while(usedFragments.length !== 0)_loop_1();
        return {
            usedVariables: usedVariables,
            newFragments: newFragments,
            fragmentSet: fragmentSet
        };
    }
    function $81e7729e1342f8d1$var$filterSelectionSet(schema, type, validFragments, selectionSet) {
        var _a;
        var usedFragments = [];
        var usedVariables = [];
        var typeStack = [
            type
        ];
        var filteredSelectionSet = (0, parcelRequire("12QNw")).visit(selectionSet, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.FIELD] = {
            enter: function(node) {
                var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
                if (parentType instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType || parentType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) {
                    var fields = parentType.getFields();
                    var field = node.name.value === '__typename' ? (0, parcelRequire("4Hpke")).TypeNameMetaFieldDef : fields[node.name.value];
                    if (!field) return null;
                    else typeStack.push(field.type);
                    var argNames_1 = (field.args || []).map(function(arg) {
                        return arg.name;
                    });
                    if (node.arguments) {
                        var args = node.arguments.filter(function(arg) {
                            return argNames_1.indexOf(arg.name.value) !== -1;
                        });
                        if (args.length !== node.arguments.length) return $81e7729e1342f8d1$var$__assign($81e7729e1342f8d1$var$__assign({}, node), {
                            arguments: args
                        });
                    }
                } else if (parentType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType && node.name.value === '__typename') typeStack.push((0, parcelRequire("4Hpke")).TypeNameMetaFieldDef.type);
            },
            leave: function(node) {
                var _a;
                var currentType = typeStack.pop();
                var resolvedType = $81e7729e1342f8d1$var$resolveType(currentType);
                if (resolvedType instanceof (0, parcelRequire("8oLgk")).GraphQLObjectType || resolvedType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType) {
                    var selections = node.selectionSet && node.selectionSet.selections || null;
                    if (!selections || selections.length === 0) {
                        (0, parcelRequire("12QNw")).visit(node, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.VARIABLE] = function(variableNode) {
                            var index = usedVariables.indexOf(variableNode.name.value);
                            if (index !== -1) usedVariables.splice(index, 1);
                        }, _a));
                        return null;
                    }
                }
            }
        }, _a[(0, parcelRequire("bzIlO")).Kind.FRAGMENT_SPREAD] = function(node) {
            if (node.name.value in validFragments) {
                var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
                var innerType = validFragments[node.name.value];
                if (!$jdSTa.default(schema, parentType, innerType)) return null;
                else {
                    usedFragments.push(node.name.value);
                    return;
                }
            } else return null;
        }, _a[(0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT] = {
            enter: function(node) {
                if (node.typeCondition) {
                    var innerType = schema.getType(node.typeCondition.name.value);
                    var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
                    if ($jdSTa.default(schema, parentType, innerType)) typeStack.push(innerType);
                    else return null;
                }
            },
            leave: function(node) {
                typeStack.pop();
            }
        }, _a[(0, parcelRequire("bzIlO")).Kind.VARIABLE] = function(node) {
            usedVariables.push(node.name.value);
        }, _a));
        return {
            selectionSet: filteredSelectionSet,
            usedFragments: usedFragments,
            usedVariables: usedVariables
        };
    }
    function $81e7729e1342f8d1$var$resolveType(type) {
        var lastType = type;
        while(lastType instanceof (0, parcelRequire("8oLgk")).GraphQLNonNull || lastType instanceof (0, parcelRequire("8oLgk")).GraphQLList)lastType = lastType.ofType;
        return lastType;
    }
    function $81e7729e1342f8d1$var$union() {
        var arrays = [];
        for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
        var cache = {};
        var result = [];
        arrays.forEach(function(array) {
            array.forEach(function(item) {
                if (!cache[item]) {
                    cache[item] = true;
                    result.push(item);
                }
            });
        });
        return result;
    }
});
parcelRegister("jdSTa", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $9GswX;
    var $8oLgk;
    function $dfe9cef9f2476969$var$implementsAbstractType(schema, typeA, typeB) {
        if (typeA === typeB) return true;
        else if ((0, parcelRequire("8oLgk")).isCompositeType(typeA) && (0, parcelRequire("8oLgk")).isCompositeType(typeB)) return (0, parcelRequire("9GswX")).doTypesOverlap(schema, typeA, typeB);
        else return false;
    }
    module.exports.default = $dfe9cef9f2476969$var$implementsAbstractType;
});
parcelRegister("5FnE9", function(module, exports) {
    var $42031fc988697446$var$__assign = module.exports && module.exports.__assign || function() {
        $42031fc988697446$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $42031fc988697446$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bzIlO;
    var $jjG8c;
    var $12QNw;
    var $42031fc988697446$var$AddTypenameToAbstract = function() {
        function AddTypenameToAbstract(targetSchema) {
            this.targetSchema = targetSchema;
        }
        AddTypenameToAbstract.prototype.transformRequest = function(originalRequest) {
            var document = $42031fc988697446$var$addTypenameToAbstract(this.targetSchema, originalRequest.document);
            return $42031fc988697446$var$__assign($42031fc988697446$var$__assign({}, originalRequest), {
                document: document
            });
        };
        return AddTypenameToAbstract;
    }();
    module.exports.default = $42031fc988697446$var$AddTypenameToAbstract;
    function $42031fc988697446$var$addTypenameToAbstract(targetSchema, document) {
        var _a;
        var typeInfo = new (0, parcelRequire("jjG8c")).TypeInfo(targetSchema);
        return (0, parcelRequire("12QNw")).visit(document, (0, parcelRequire("jjG8c")).visitWithTypeInfo(typeInfo, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.SELECTION_SET] = function(node) {
            var parentType = typeInfo.getParentType();
            var selections = node.selections;
            if (parentType && (parentType instanceof (0, parcelRequire("8oLgk")).GraphQLInterfaceType || parentType instanceof (0, parcelRequire("8oLgk")).GraphQLUnionType) && !selections.find(function(_) {
                return _.kind === (0, parcelRequire("bzIlO")).Kind.FIELD && _.name.value === '__typename';
            })) selections = selections.concat({
                kind: (0, parcelRequire("bzIlO")).Kind.FIELD,
                name: {
                    kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                    value: '__typename'
                }
            });
            if (selections !== node.selections) return $42031fc988697446$var$__assign($42031fc988697446$var$__assign({}, node), {
                selections: selections
            });
        }, _a)));
    }
});
parcelRegister("XeiAr", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $2JIWi = parcelRequire("2JIWi");
    var $0b209a3e8eeada1f$var$CheckResultAndHandleErrors = function() {
        function CheckResultAndHandleErrors(info, fieldName) {
            this.info = info;
            this.fieldName = fieldName;
        }
        CheckResultAndHandleErrors.prototype.transformResult = function(result) {
            return $2JIWi.checkResultAndHandleErrors(result, this.info, this.fieldName);
        };
        return CheckResultAndHandleErrors;
    }();
    module.exports.default = $0b209a3e8eeada1f$var$CheckResultAndHandleErrors;
});
parcelRegister("3Cwvd", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $6PRDg = parcelRequire("6PRDg");
    function $2a2e2200b981df31$var$mapAsyncIterator(iterator, callback, rejectCallback) {
        var _a;
        var $return;
        var abruptClose;
        if (typeof iterator.return === 'function') {
            $return = iterator.return;
            abruptClose = function(error) {
                var rethrow = function() {
                    return Promise.reject(error);
                };
                return $return.call(iterator).then(rethrow, rethrow);
            };
        }
        function mapResult(result) {
            return result.done ? result : $2a2e2200b981df31$var$asyncMapValue(result.value, callback).then($2a2e2200b981df31$var$iteratorResult, abruptClose);
        }
        var mapReject;
        if (rejectCallback) {
            var reject_1 = rejectCallback;
            mapReject = function(error) {
                return $2a2e2200b981df31$var$asyncMapValue(error, reject_1).then($2a2e2200b981df31$var$iteratorResult, abruptClose);
            };
        }
        return _a = {
            next: function() {
                return iterator.next().then(mapResult, mapReject);
            },
            return: function() {
                return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                    value: undefined,
                    done: true
                });
            },
            throw: function(error) {
                if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
                return Promise.reject(error).catch(abruptClose);
            }
        }, _a[$6PRDg.$$asyncIterator] = function() {
            return this;
        }, _a;
    }
    module.exports.default = $2a2e2200b981df31$var$mapAsyncIterator;
    function $2a2e2200b981df31$var$asyncMapValue(value, callback) {
        return new Promise(function(resolve) {
            return resolve(callback(value));
        });
    }
    function $2a2e2200b981df31$var$iteratorResult(value) {
        return {
            value: value,
            done: false
        };
    }
});
parcelRegister("6Qqmu", function(module, exports) {
    var $4fbc0c488f64fb05$var$__assign = module.exports && module.exports.__assign || function() {
        $4fbc0c488f64fb05$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $4fbc0c488f64fb05$var$__assign.apply(this, arguments);
    };
    var $4fbc0c488f64fb05$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bzIlO;
    var $jjG8c;
    var $12QNw;
    var $jdSTa = parcelRequire("jdSTa");
    var $4fbc0c488f64fb05$var$ExpandAbstractTypes = function() {
        function ExpandAbstractTypes(transformedSchema, targetSchema) {
            this.targetSchema = targetSchema;
            this.mapping = $4fbc0c488f64fb05$var$extractPossibleTypes(transformedSchema, targetSchema);
            this.reverseMapping = $4fbc0c488f64fb05$var$flipMapping(this.mapping);
        }
        ExpandAbstractTypes.prototype.transformRequest = function(originalRequest) {
            var document = $4fbc0c488f64fb05$var$expandAbstractTypes(this.targetSchema, this.mapping, this.reverseMapping, originalRequest.document);
            return $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, originalRequest), {
                document: document
            });
        };
        return ExpandAbstractTypes;
    }();
    module.exports.default = $4fbc0c488f64fb05$var$ExpandAbstractTypes;
    function $4fbc0c488f64fb05$var$extractPossibleTypes(transformedSchema, targetSchema) {
        var typeMap = transformedSchema.getTypeMap();
        var mapping = {};
        Object.keys(typeMap).forEach(function(typeName) {
            var type = typeMap[typeName];
            if ((0, parcelRequire("8oLgk")).isAbstractType(type)) {
                var targetType = targetSchema.getType(typeName);
                if (!(0, parcelRequire("8oLgk")).isAbstractType(targetType)) {
                    var implementations = transformedSchema.getPossibleTypes(type) || [];
                    mapping[typeName] = implementations.filter(function(impl) {
                        return targetSchema.getType(impl.name);
                    }).map(function(impl) {
                        return impl.name;
                    });
                }
            }
        });
        return mapping;
    }
    function $4fbc0c488f64fb05$var$flipMapping(mapping) {
        var result = {};
        Object.keys(mapping).forEach(function(typeName) {
            var toTypeNames = mapping[typeName];
            toTypeNames.forEach(function(toTypeName) {
                if (!result[toTypeName]) result[toTypeName] = [];
                result[toTypeName].push(typeName);
            });
        });
        return result;
    }
    function $4fbc0c488f64fb05$var$expandAbstractTypes(targetSchema, mapping, reverseMapping, document) {
        var _a;
        var operations = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.OPERATION_DEFINITION;
        });
        var fragments = document.definitions.filter(function(def) {
            return def.kind === (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION;
        });
        var existingFragmentNames = fragments.map(function(fragment) {
            return fragment.name.value;
        });
        var fragmentCounter = 0;
        var generateFragmentName = function(typeName) {
            var fragmentName;
            do {
                fragmentName = "_" + typeName + "_Fragment" + fragmentCounter;
                fragmentCounter++;
            }while (existingFragmentNames.indexOf(fragmentName) !== -1)
            return fragmentName;
        };
        var newFragments = [];
        var fragmentReplacements = {};
        fragments.forEach(function(fragment) {
            newFragments.push(fragment);
            var possibleTypes = mapping[fragment.typeCondition.name.value];
            if (possibleTypes) {
                fragmentReplacements[fragment.name.value] = [];
                possibleTypes.forEach(function(possibleTypeName) {
                    var name = generateFragmentName(possibleTypeName);
                    existingFragmentNames.push(name);
                    var newFragment = {
                        kind: (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION,
                        name: {
                            kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                            value: name
                        },
                        typeCondition: {
                            kind: (0, parcelRequire("bzIlO")).Kind.NAMED_TYPE,
                            name: {
                                kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                value: possibleTypeName
                            }
                        },
                        selectionSet: fragment.selectionSet
                    };
                    newFragments.push(newFragment);
                    fragmentReplacements[fragment.name.value].push({
                        fragmentName: name,
                        typeName: possibleTypeName
                    });
                });
            }
        });
        var newDocument = $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, document), {
            definitions: $4fbc0c488f64fb05$var$__spreadArrays(operations, newFragments)
        });
        var typeInfo = new (0, parcelRequire("jjG8c")).TypeInfo(targetSchema);
        return (0, parcelRequire("12QNw")).visit(newDocument, (0, parcelRequire("jjG8c")).visitWithTypeInfo(typeInfo, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.SELECTION_SET] = function(node) {
            var newSelections = $4fbc0c488f64fb05$var$__spreadArrays(node.selections);
            var parentType = (0, parcelRequire("8oLgk")).getNamedType(typeInfo.getParentType());
            node.selections.forEach(function(selection) {
                if (selection.kind === (0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT) {
                    var possibleTypes = mapping[selection.typeCondition.name.value];
                    if (possibleTypes) possibleTypes.forEach(function(possibleType) {
                        if ($jdSTa.default(targetSchema, parentType, targetSchema.getType(possibleType))) newSelections.push({
                            kind: (0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT,
                            typeCondition: {
                                kind: (0, parcelRequire("bzIlO")).Kind.NAMED_TYPE,
                                name: {
                                    kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                    value: possibleType
                                }
                            },
                            selectionSet: selection.selectionSet
                        });
                    });
                } else if (selection.kind === (0, parcelRequire("bzIlO")).Kind.FRAGMENT_SPREAD) {
                    var fragmentName = selection.name.value;
                    var replacements = fragmentReplacements[fragmentName];
                    if (replacements) replacements.forEach(function(replacement) {
                        var typeName = replacement.typeName;
                        if ($jdSTa.default(targetSchema, parentType, targetSchema.getType(typeName))) newSelections.push({
                            kind: (0, parcelRequire("bzIlO")).Kind.FRAGMENT_SPREAD,
                            name: {
                                kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                                value: replacement.fragmentName
                            }
                        });
                    });
                }
            });
            if (parentType && reverseMapping[parentType.name]) newSelections.push({
                kind: (0, parcelRequire("bzIlO")).Kind.FIELD,
                name: {
                    kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                    value: '__typename'
                }
            });
            if (newSelections.length !== node.selections.length) return $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, node), {
                selections: newSelections
            });
        }, _a)));
    }
});
parcelRegister("2WTvk", function(module, exports) {
    var $225c0d909bed3526$var$__assign = module.exports && module.exports.__assign || function() {
        $225c0d909bed3526$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $225c0d909bed3526$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $bzIlO;
    var $8uUC9;
    var $jjG8c;
    var $12QNw;
    var $225c0d909bed3526$var$ReplaceFieldWithFragment = function() {
        function ReplaceFieldWithFragment(targetSchema, fragments) {
            this.targetSchema = targetSchema;
            this.mapping = {};
            for(var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++){
                var _a = fragments_1[_i], field = _a.field, fragment = _a.fragment;
                var parsedFragment = $225c0d909bed3526$var$parseFragmentToInlineFragment(fragment);
                var actualTypeName = parsedFragment.typeCondition.name.value;
                this.mapping[actualTypeName] = this.mapping[actualTypeName] || {};
                if (this.mapping[actualTypeName][field]) this.mapping[actualTypeName][field].push(parsedFragment);
                else this.mapping[actualTypeName][field] = [
                    parsedFragment
                ];
            }
        }
        ReplaceFieldWithFragment.prototype.transformRequest = function(originalRequest) {
            var document = $225c0d909bed3526$var$replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
            return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, originalRequest), {
                document: document
            });
        };
        return ReplaceFieldWithFragment;
    }();
    module.exports.default = $225c0d909bed3526$var$ReplaceFieldWithFragment;
    function $225c0d909bed3526$var$replaceFieldsWithFragments(targetSchema, document, mapping) {
        var _a;
        var typeInfo = new (0, parcelRequire("jjG8c")).TypeInfo(targetSchema);
        return (0, parcelRequire("12QNw")).visit(document, (0, parcelRequire("jjG8c")).visitWithTypeInfo(typeInfo, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.SELECTION_SET] = function(node) {
            var parentType = typeInfo.getParentType();
            if (parentType) {
                var parentTypeName_1 = parentType.name;
                var selections_1 = node.selections;
                if (mapping[parentTypeName_1]) node.selections.forEach(function(selection) {
                    if (selection.kind === (0, parcelRequire("bzIlO")).Kind.FIELD) {
                        var name_1 = selection.name.value;
                        var fragments = mapping[parentTypeName_1][name_1];
                        if (fragments && fragments.length > 0) {
                            var fragment = $225c0d909bed3526$var$concatInlineFragments(parentTypeName_1, fragments);
                            selections_1 = selections_1.concat(fragment);
                        }
                    }
                });
                if (selections_1 !== node.selections) return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, node), {
                    selections: selections_1
                });
            }
        }, _a)));
    }
    function $225c0d909bed3526$var$parseFragmentToInlineFragment(definitions) {
        if (definitions.trim().startsWith('fragment')) {
            var document_1 = (0, parcelRequire("8uUC9")).parse(definitions);
            for(var _i = 0, _a = document_1.definitions; _i < _a.length; _i++){
                var definition = _a[_i];
                if (definition.kind === (0, parcelRequire("bzIlO")).Kind.FRAGMENT_DEFINITION) return {
                    kind: (0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT,
                    typeCondition: definition.typeCondition,
                    selectionSet: definition.selectionSet
                };
            }
        }
        var query = (0, parcelRequire("8uUC9")).parse("{" + definitions + "}").definitions[0];
        for(var _b = 0, _c = query.selectionSet.selections; _b < _c.length; _b++){
            var selection = _c[_b];
            if (selection.kind === (0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT) return selection;
        }
        throw new Error('Could not parse fragment');
    }
    function $225c0d909bed3526$var$concatInlineFragments(type, fragments) {
        var fragmentSelections = fragments.reduce(function(selections, fragment) {
            return selections.concat(fragment.selectionSet.selections);
        }, []);
        var deduplicatedFragmentSelection = $225c0d909bed3526$var$deduplicateSelection(fragmentSelections);
        return {
            kind: (0, parcelRequire("bzIlO")).Kind.INLINE_FRAGMENT,
            typeCondition: {
                kind: (0, parcelRequire("bzIlO")).Kind.NAMED_TYPE,
                name: {
                    kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                    value: type
                }
            },
            selectionSet: {
                kind: (0, parcelRequire("bzIlO")).Kind.SELECTION_SET,
                selections: deduplicatedFragmentSelection
            }
        };
    }
    function $225c0d909bed3526$var$deduplicateSelection(nodes) {
        var selectionMap = nodes.reduce(function(map, node) {
            var _a, _b, _c;
            switch(node.kind){
                case 'Field':
                    if (node.alias) {
                        if (map.hasOwnProperty(node.alias.value)) return map;
                        else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_a = {}, _a[node.alias.value] = node, _a));
                    } else {
                        if (map.hasOwnProperty(node.name.value)) return map;
                        else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_b = {}, _b[node.name.value] = node, _b));
                    }
                case 'FragmentSpread':
                    if (map.hasOwnProperty(node.name.value)) return map;
                    else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_c = {}, _c[node.name.value] = node, _c));
                case 'InlineFragment':
                    if (map.__fragment) {
                        var fragment = map.__fragment;
                        return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), {
                            __fragment: $225c0d909bed3526$var$concatInlineFragments(fragment.typeCondition.name.value, [
                                fragment,
                                node
                            ])
                        });
                    } else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), {
                        __fragment: node
                    });
                default:
                    return map;
            }
        }, {});
        var selection = Object.keys(selectionMap).reduce(function(selectionList, node) {
            return selectionList.concat(selectionMap[node]);
        }, []);
        return selection;
    }
});
parcelRegister("iP6T0", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $db4254e23189f1df$var$ConvertEnumResponse = function() {
        function ConvertEnumResponse(enumNode) {
            this.enumNode = enumNode;
        }
        ConvertEnumResponse.prototype.transformResult = function(result) {
            var value = this.enumNode.getValue(result);
            if (value) return value.value;
            return result;
        };
        return ConvertEnumResponse;
    }();
    module.exports.default = $db4254e23189f1df$var$ConvertEnumResponse;
});
parcelRegister("dfTWq", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jADQJ;
    var $8mJYM;
    var $35Smo;
    var $8oLgk;
    var $djKly;
    var $bzIlO;
    var $9aGhX;
    var $akAWC = parcelRequire("akAWC");
    var $9a6811dc9fc4c35f$var$backcompatOptions = {
        commentDescriptions: true
    };
    function $9a6811dc9fc4c35f$var$typeFromAST(node) {
        switch(node.kind){
            case (0, parcelRequire("bzIlO")).Kind.OBJECT_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeObjectType(node);
            case (0, parcelRequire("bzIlO")).Kind.INTERFACE_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeInterfaceType(node);
            case (0, parcelRequire("bzIlO")).Kind.ENUM_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeEnumType(node);
            case (0, parcelRequire("bzIlO")).Kind.UNION_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeUnionType(node);
            case (0, parcelRequire("bzIlO")).Kind.SCALAR_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeScalarType(node);
            case (0, parcelRequire("bzIlO")).Kind.INPUT_OBJECT_TYPE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeInputObjectType(node);
            case (0, parcelRequire("bzIlO")).Kind.DIRECTIVE_DEFINITION:
                return $9a6811dc9fc4c35f$var$makeDirective(node);
            default:
                return null;
        }
    }
    module.exports.default = $9a6811dc9fc4c35f$var$typeFromAST;
    function $9a6811dc9fc4c35f$var$makeObjectType(node) {
        return new (0, parcelRequire("8oLgk")).GraphQLObjectType({
            name: node.name.value,
            fields: function() {
                return $9a6811dc9fc4c35f$var$makeFields(node.fields);
            },
            interfaces: function() {
                return node.interfaces.map(function(iface) {
                    return $9a6811dc9fc4c35f$var$createNamedStub(iface.name.value, 'interface');
                });
            },
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
        });
    }
    function $9a6811dc9fc4c35f$var$makeInterfaceType(node) {
        return new (0, parcelRequire("8oLgk")).GraphQLInterfaceType({
            name: node.name.value,
            fields: function() {
                return $9a6811dc9fc4c35f$var$makeFields(node.fields);
            },
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
            resolveType: function(parent, context, info) {
                return $akAWC.default(parent, info.schema);
            }
        });
    }
    function $9a6811dc9fc4c35f$var$makeEnumType(node) {
        var values = {};
        node.values.forEach(function(value) {
            values[value.name.value] = {
                description: (0, parcelRequire("8mJYM")).getDescription(value, $9a6811dc9fc4c35f$var$backcompatOptions)
            };
        });
        return new (0, parcelRequire("8oLgk")).GraphQLEnumType({
            name: node.name.value,
            values: values,
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
        });
    }
    function $9a6811dc9fc4c35f$var$makeUnionType(node) {
        return new (0, parcelRequire("8oLgk")).GraphQLUnionType({
            name: node.name.value,
            types: function() {
                return node.types.map(function(type) {
                    return $9a6811dc9fc4c35f$var$resolveType(type, 'object');
                });
            },
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
            resolveType: function(parent, context, info) {
                return $akAWC.default(parent, info.schema);
            }
        });
    }
    function $9a6811dc9fc4c35f$var$makeScalarType(node) {
        return new (0, parcelRequire("8oLgk")).GraphQLScalarType({
            name: node.name.value,
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
            serialize: function() {
                return null;
            },
            parseValue: function() {
                return false;
            },
            parseLiteral: function() {
                return false;
            }
        });
    }
    function $9a6811dc9fc4c35f$var$makeInputObjectType(node) {
        return new (0, parcelRequire("8oLgk")).GraphQLInputObjectType({
            name: node.name.value,
            fields: function() {
                return $9a6811dc9fc4c35f$var$makeValues(node.fields);
            },
            description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
        });
    }
    function $9a6811dc9fc4c35f$var$makeFields(nodes) {
        var result = {};
        nodes.forEach(function(node) {
            var deprecatedDirective = node.directives.find(function(directive) {
                return directive && directive.name && directive.name.value === 'deprecated';
            });
            var deprecatedArgument = deprecatedDirective && deprecatedDirective.arguments && deprecatedDirective.arguments.find(function(arg) {
                return arg && arg.name && arg.name.value === 'reason';
            });
            var deprecationReason = deprecatedArgument && deprecatedArgument.value && deprecatedArgument.value.value;
            result[node.name.value] = {
                type: $9a6811dc9fc4c35f$var$resolveType(node.type, 'object'),
                args: $9a6811dc9fc4c35f$var$makeValues(node.arguments),
                description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
                deprecationReason: deprecationReason
            };
        });
        return result;
    }
    function $9a6811dc9fc4c35f$var$makeValues(nodes) {
        var result = {};
        nodes.forEach(function(node) {
            var type = $9a6811dc9fc4c35f$var$resolveType(node.type, 'input');
            result[node.name.value] = {
                type: type,
                defaultValue: (0, parcelRequire("9aGhX")).valueFromAST(node.defaultValue, type),
                description: (0, parcelRequire("8mJYM")).getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
            };
        });
        return result;
    }
    function $9a6811dc9fc4c35f$var$resolveType(node, type) {
        switch(node.kind){
            case (0, parcelRequire("bzIlO")).Kind.LIST_TYPE:
                return new (0, parcelRequire("8oLgk")).GraphQLList($9a6811dc9fc4c35f$var$resolveType(node.type, type));
            case (0, parcelRequire("bzIlO")).Kind.NON_NULL_TYPE:
                return new (0, parcelRequire("8oLgk")).GraphQLNonNull($9a6811dc9fc4c35f$var$resolveType(node.type, type));
            default:
                return $9a6811dc9fc4c35f$var$createNamedStub(node.name.value, type);
        }
    }
    function $9a6811dc9fc4c35f$var$createNamedStub(name, type) {
        var constructor;
        if (type === 'object') constructor = (0, parcelRequire("8oLgk")).GraphQLObjectType;
        else if (type === 'interface') constructor = (0, parcelRequire("8oLgk")).GraphQLInterfaceType;
        else constructor = (0, parcelRequire("8oLgk")).GraphQLInputObjectType;
        return new constructor({
            name: name,
            fields: {
                __fake: {
                    type: (0, parcelRequire("djKly")).GraphQLString
                }
            }
        });
    }
    function $9a6811dc9fc4c35f$var$makeDirective(node) {
        var locations = [];
        node.locations.forEach(function(location) {
            if (location.value in (0, parcelRequire("jADQJ")).DirectiveLocation) locations.push(location.value);
        });
        return new (0, parcelRequire("35Smo")).GraphQLDirective({
            name: node.name.value,
            description: node.description ? node.description.value : null,
            args: $9a6811dc9fc4c35f$var$makeValues(node.arguments),
            locations: locations
        });
    }
});
parcelRegister("810gP", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $2QBPc = parcelRequire("2QBPc");
    module.exports.transformSchema = $2QBPc.default;
    var $4oDNM = parcelRequire("4oDNM");
    module.exports.AddArgumentsAsVariables = $4oDNM.default;
    var $XeiAr = parcelRequire("XeiAr");
    module.exports.CheckResultAndHandleErrors = $XeiAr.default;
    var $2WTvk = parcelRequire("2WTvk");
    module.exports.ReplaceFieldWithFragment = $2WTvk.default;
    var $5FnE9 = parcelRequire("5FnE9");
    module.exports.AddTypenameToAbstract = $5FnE9.default;
    var $b9txq = parcelRequire("b9txq");
    module.exports.FilterToSchema = $b9txq.default;
    var $3G9my = parcelRequire("3G9my");
    module.exports.RenameTypes = $3G9my.default;
    var $c3TFq = parcelRequire("c3TFq");
    module.exports.FilterTypes = $c3TFq.default;
    var $jRU8r = parcelRequire("jRU8r");
    module.exports.TransformRootFields = $jRU8r.default;
    var $kG751 = parcelRequire("kG751");
    module.exports.RenameRootFields = $kG751.default;
    var $4NN8S = parcelRequire("4NN8S");
    module.exports.FilterRootFields = $4NN8S.default;
    var $6Qqmu = parcelRequire("6Qqmu");
    module.exports.ExpandAbstractTypes = $6Qqmu.default;
    var $bORvX = parcelRequire("bORvX");
    module.exports.ExtractField = $bORvX.default;
    var $d9ptK = parcelRequire("d9ptK");
    module.exports.WrapQuery = $d9ptK.default;
});
parcelRegister("2QBPc", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $gIDuj = parcelRequire("gIDuj");
    var $1e7FQ = parcelRequire("1e7FQ");
    var $9CEZe = parcelRequire("9CEZe");
    var $1cuZu = parcelRequire("1cuZu");
    function $212dc74e242b95ff$var$transformSchema(targetSchema, transforms) {
        var schema = $1e7FQ.visitSchema(targetSchema, {}, true);
        var mapping = $1cuZu.generateSimpleMapping(targetSchema);
        var resolvers = $1cuZu.generateProxyingResolvers(targetSchema, transforms, mapping);
        schema = $gIDuj.addResolveFunctionsToSchema({
            schema: schema,
            resolvers: resolvers,
            resolverValidationOptions: {
                allowResolversNotInSchema: true
            }
        });
        schema = $9CEZe.applySchemaTransforms(schema, transforms);
        schema.transforms = transforms;
        return schema;
    }
    module.exports.default = $212dc74e242b95ff$var$transformSchema;
});
parcelRegister("1cuZu", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $bkP2b = parcelRequire("bkP2b");
    function $0dfef39330e66398$var$generateProxyingResolvers(targetSchema, transforms, mapping) {
        var result = {};
        Object.keys(mapping).forEach(function(name) {
            result[name] = {};
            var innerMapping = mapping[name];
            Object.keys(innerMapping).forEach(function(from) {
                var _a;
                var to = innerMapping[from];
                var resolverType = to.operation === 'subscription' ? 'subscribe' : 'resolve';
                result[name][from] = (_a = {}, _a[resolverType] = $0dfef39330e66398$var$createProxyingResolver(targetSchema, to.operation, to.name, transforms), _a);
            });
        });
        return result;
    }
    module.exports.generateProxyingResolvers = $0dfef39330e66398$var$generateProxyingResolvers;
    function $0dfef39330e66398$var$generateSimpleMapping(targetSchema) {
        var query = targetSchema.getQueryType();
        var mutation = targetSchema.getMutationType();
        var subscription = targetSchema.getSubscriptionType();
        var result = {};
        if (query) result[query.name] = $0dfef39330e66398$var$generateMappingFromObjectType(query, 'query');
        if (mutation) result[mutation.name] = $0dfef39330e66398$var$generateMappingFromObjectType(mutation, 'mutation');
        if (subscription) result[subscription.name] = $0dfef39330e66398$var$generateMappingFromObjectType(subscription, 'subscription');
        return result;
    }
    module.exports.generateSimpleMapping = $0dfef39330e66398$var$generateSimpleMapping;
    function $0dfef39330e66398$var$generateMappingFromObjectType(type, operation) {
        var result = {};
        var fields = type.getFields();
        Object.keys(fields).forEach(function(fieldName) {
            result[fieldName] = {
                name: fieldName,
                operation: operation
            };
        });
        return result;
    }
    module.exports.generateMappingFromObjectType = $0dfef39330e66398$var$generateMappingFromObjectType;
    function $0dfef39330e66398$var$createProxyingResolver(schema, operation, fieldName, transforms) {
        return function(parent, args, context, info) {
            return $bkP2b.default({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: {},
                context: context,
                info: info,
                transforms: transforms
            });
        };
    }
});
parcelRegister("3G9my", function(module, exports) {
    var $2adc8e96c4519a95$var$__assign = module.exports && module.exports.__assign || function() {
        $2adc8e96c4519a95$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $2adc8e96c4519a95$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bzIlO;
    var $12QNw;
    var $7qT3x = parcelRequire("7qT3x");
    var $1e7FQ = parcelRequire("1e7FQ");
    var $2adc8e96c4519a95$var$RenameTypes = function() {
        function RenameTypes(renamer, options) {
            this.renamer = renamer;
            this.reverseMap = {};
            var _a = options || {}, _b = _a.renameBuiltins, renameBuiltins = _b === void 0 ? false : _b, _c = _a.renameScalars, renameScalars = _c === void 0 ? true : _c;
            this.renameBuiltins = renameBuiltins;
            this.renameScalars = renameScalars;
        }
        RenameTypes.prototype.transformSchema = function(originalSchema) {
            var _a;
            var _this = this;
            return $1e7FQ.visitSchema(originalSchema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.TYPE] = function(type) {
                if ($7qT3x.default(type) && !_this.renameBuiltins) return undefined;
                if (type instanceof (0, parcelRequire("8oLgk")).GraphQLScalarType && !_this.renameScalars) return undefined;
                var newName = _this.renamer(type.name);
                if (newName && newName !== type.name) {
                    _this.reverseMap[newName] = type.name;
                    var newType = Object.assign(Object.create(type), type);
                    newType.name = newName;
                    return newType;
                }
            }, _a[$1e7FQ.VisitSchemaKind.ROOT_OBJECT] = function(type) {
                return undefined;
            }, _a));
        };
        RenameTypes.prototype.transformRequest = function(originalRequest) {
            var _a;
            var _this = this;
            var newDocument = (0, parcelRequire("12QNw")).visit(originalRequest.document, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.NAMED_TYPE] = function(node) {
                var name = node.name.value;
                if (name in _this.reverseMap) return $2adc8e96c4519a95$var$__assign($2adc8e96c4519a95$var$__assign({}, node), {
                    name: {
                        kind: (0, parcelRequire("bzIlO")).Kind.NAME,
                        value: _this.reverseMap[name]
                    }
                });
            }, _a));
            return {
                document: newDocument,
                variables: originalRequest.variables
            };
        };
        RenameTypes.prototype.transformResult = function(result) {
            if (result.data) {
                var data = this.renameTypes(result.data, 'data');
                if (data !== result.data) return $2adc8e96c4519a95$var$__assign($2adc8e96c4519a95$var$__assign({}, result), {
                    data: data
                });
            }
            return result;
        };
        RenameTypes.prototype.renameTypes = function(value, name) {
            var _this = this;
            if (name === '__typename') return this.renamer(value);
            if (value && typeof value === 'object') {
                var newValue_1 = Array.isArray(value) ? [] : Object.create(Object.getPrototypeOf(value));
                var returnNewValue_1 = false;
                Object.keys(value).forEach(function(key) {
                    var oldChild = value[key];
                    var newChild = _this.renameTypes(oldChild, key);
                    newValue_1[key] = newChild;
                    if (newChild !== oldChild) returnNewValue_1 = true;
                });
                if (returnNewValue_1) return newValue_1;
            }
            return value;
        };
        return RenameTypes;
    }();
    module.exports.default = $2adc8e96c4519a95$var$RenameTypes;
});
parcelRegister("c3TFq", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $1e7FQ = parcelRequire("1e7FQ");
    var $8c80f22a6477398d$var$FilterTypes = function() {
        function FilterTypes(filter) {
            this.filter = filter;
        }
        FilterTypes.prototype.transformSchema = function(schema) {
            var _a;
            var _this = this;
            return $1e7FQ.visitSchema(schema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.TYPE] = function(type) {
                if (_this.filter(type)) return undefined;
                else return null;
            }, _a));
        };
        return FilterTypes;
    }();
    module.exports.default = $8c80f22a6477398d$var$FilterTypes;
});
parcelRegister("jRU8r", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8oLgk;
    var $bZzKT = parcelRequire("bZzKT");
    var $1e7FQ = parcelRequire("1e7FQ");
    var $cPwLY = parcelRequire("cPwLY");
    var $e76e82d2793e197c$var$TransformRootFields = function() {
        function TransformRootFields(transform) {
            this.transform = transform;
        }
        TransformRootFields.prototype.transformSchema = function(originalSchema) {
            var _a;
            var _this = this;
            return $1e7FQ.visitSchema(originalSchema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.QUERY] = function(type) {
                return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                    return _this.transform('Query', fieldName, field);
                });
            }, _a[$1e7FQ.VisitSchemaKind.MUTATION] = function(type) {
                return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                    return _this.transform('Mutation', fieldName, field);
                });
            }, _a[$1e7FQ.VisitSchemaKind.SUBSCRIPTION] = function(type) {
                return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                    return _this.transform('Subscription', fieldName, field);
                });
            }, _a));
        };
        return TransformRootFields;
    }();
    module.exports.default = $e76e82d2793e197c$var$TransformRootFields;
    function $e76e82d2793e197c$var$transformFields(type, transformer) {
        var resolveType = $cPwLY.createResolveType(function(name, originalType) {
            return originalType;
        });
        var fields = type.getFields();
        var newFields = {};
        Object.keys(fields).forEach(function(fieldName) {
            var field = fields[fieldName];
            var newField = transformer(fieldName, field);
            if (typeof newField === 'undefined') newFields[fieldName] = $cPwLY.fieldToFieldConfig(field, resolveType, true);
            else if (newField !== null) {
                if (newField.name) newFields[newField.name] = newField.field;
                else newFields[fieldName] = newField;
            }
        });
        if ($bZzKT.default(newFields)) return null;
        else return new (0, parcelRequire("8oLgk")).GraphQLObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: newFields
        });
    }
});
parcelRegister("kG751", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $cPwLY = parcelRequire("cPwLY");
    var $jRU8r = parcelRequire("jRU8r");
    var $f0dd38d15cd69b70$var$RenameRootFields = function() {
        function RenameRootFields(renamer) {
            var resolveType = $cPwLY.createResolveType(function(name, type) {
                return type;
            });
            this.transformer = new $jRU8r.default(function(operation, fieldName, field) {
                return {
                    name: renamer(operation, fieldName, field),
                    field: $cPwLY.fieldToFieldConfig(field, resolveType, true)
                };
            });
        }
        RenameRootFields.prototype.transformSchema = function(originalSchema) {
            return this.transformer.transformSchema(originalSchema);
        };
        return RenameRootFields;
    }();
    module.exports.default = $f0dd38d15cd69b70$var$RenameRootFields;
});
parcelRegister("4NN8S", function(module, exports) {
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jRU8r = parcelRequire("jRU8r");
    var $37f1dba7a5891a8d$var$FilterRootFields = function() {
        function FilterRootFields(filter) {
            this.transformer = new $jRU8r.default(function(operation, fieldName, field) {
                if (filter(operation, fieldName, field)) return undefined;
                else return null;
            });
        }
        FilterRootFields.prototype.transformSchema = function(originalSchema) {
            return this.transformer.transformSchema(originalSchema);
        };
        return FilterRootFields;
    }();
    module.exports.default = $37f1dba7a5891a8d$var$FilterRootFields;
});
parcelRegister("bORvX", function(module, exports) {
    var $89ade00df5ab3c69$var$__assign = module.exports && module.exports.__assign || function() {
        $89ade00df5ab3c69$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $89ade00df5ab3c69$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $12QNw;
    var $bzIlO;
    var $89ade00df5ab3c69$var$ExtractField = function() {
        function ExtractField(_a) {
            var from = _a.from, to = _a.to;
            this.from = from;
            this.to = to;
        }
        ExtractField.prototype.transformRequest = function(originalRequest) {
            var _a, _b;
            var fromSelection;
            var ourPathFrom = JSON.stringify(this.from);
            var ourPathTo = JSON.stringify(this.to);
            var fieldPath = [];
            (0, parcelRequire("12QNw")).visit(originalRequest.document, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.FIELD] = {
                enter: function(node) {
                    fieldPath.push(node.name.value);
                    if (ourPathFrom === JSON.stringify(fieldPath)) {
                        fromSelection = node.selectionSet;
                        return (0, parcelRequire("12QNw")).BREAK;
                    }
                },
                leave: function(node) {
                    fieldPath.pop();
                }
            }, _a));
            fieldPath = [];
            var newDocument = (0, parcelRequire("12QNw")).visit(originalRequest.document, (_b = {}, _b[(0, parcelRequire("bzIlO")).Kind.FIELD] = {
                enter: function(node) {
                    fieldPath.push(node.name.value);
                    if (ourPathTo === JSON.stringify(fieldPath) && fromSelection) return $89ade00df5ab3c69$var$__assign($89ade00df5ab3c69$var$__assign({}, node), {
                        selectionSet: fromSelection
                    });
                },
                leave: function(node) {
                    fieldPath.pop();
                }
            }, _b));
            return $89ade00df5ab3c69$var$__assign($89ade00df5ab3c69$var$__assign({}, originalRequest), {
                document: newDocument
            });
        };
        return ExtractField;
    }();
    module.exports.default = $89ade00df5ab3c69$var$ExtractField;
});
parcelRegister("d9ptK", function(module, exports) {
    var $992fe12a2cb75340$var$__assign = module.exports && module.exports.__assign || function() {
        $992fe12a2cb75340$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $992fe12a2cb75340$var$__assign.apply(this, arguments);
    };
    var $992fe12a2cb75340$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $bzIlO;
    var $12QNw;
    var $992fe12a2cb75340$var$WrapQuery = function() {
        function WrapQuery(path, wrapper, extractor) {
            this.path = path;
            this.wrapper = wrapper;
            this.extractor = extractor;
        }
        WrapQuery.prototype.transformRequest = function(originalRequest) {
            var _a;
            var _this = this;
            var document = originalRequest.document;
            var fieldPath = [];
            var ourPath = JSON.stringify(this.path);
            var newDocument = (0, parcelRequire("12QNw")).visit(document, (_a = {}, _a[(0, parcelRequire("bzIlO")).Kind.FIELD] = {
                enter: function(node) {
                    fieldPath.push(node.name.value);
                    if (ourPath === JSON.stringify(fieldPath)) {
                        var wrapResult = _this.wrapper(node.selectionSet);
                        var selectionSet = wrapResult.kind === (0, parcelRequire("bzIlO")).Kind.SELECTION_SET ? wrapResult : {
                            kind: (0, parcelRequire("bzIlO")).Kind.SELECTION_SET,
                            selections: [
                                wrapResult
                            ]
                        };
                        return $992fe12a2cb75340$var$__assign($992fe12a2cb75340$var$__assign({}, node), {
                            selectionSet: selectionSet
                        });
                    }
                },
                leave: function(node) {
                    fieldPath.pop();
                }
            }, _a));
            return $992fe12a2cb75340$var$__assign($992fe12a2cb75340$var$__assign({}, originalRequest), {
                document: newDocument
            });
        };
        WrapQuery.prototype.transformResult = function(originalResult) {
            var rootData = originalResult.data;
            if (rootData) {
                var data = rootData;
                var path = $992fe12a2cb75340$var$__spreadArrays(this.path);
                while(path.length > 1){
                    var next = path.shift();
                    if (data[next]) data = data[next];
                }
                data[path[0]] = this.extractor(data[path[0]]);
            }
            return {
                data: rootData,
                errors: originalResult.errors
            };
        };
        return WrapQuery;
    }();
    module.exports.default = $992fe12a2cb75340$var$WrapQuery;
});
parcelRegister("6nlEk", function(module, exports) {
    $parcel$export(module.exports, "getCustomResolversFetch", ()=>$7a81278f397cc3f8$export$18b0a4b86a372cdb);
    class $7a81278f397cc3f8$export$26e841bcf1aeb894 extends Error {
        constructor(response, resBody){
            super(`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`);
            this.status = response.status;
            this.response = response;
            this.responseBody = resBody;
            this.name = this.constructor.name;
        }
    }
    function $7a81278f397cc3f8$var$removeEmptyProp(obj) {
        const result = {
            ...obj
        };
        Object.entries(result).forEach(([key, val])=>{
            if (val === undefined || val === null) delete result[key];
        });
        return result;
    }
    async function $7a81278f397cc3f8$var$handleFetchCommonResponse(res) {
        if (!res.ok) {
            let resBody;
            try {
                resBody = await res.json();
            } catch (e) {}
            throw new $7a81278f397cc3f8$export$26e841bcf1aeb894(res, resBody);
        }
        return res;
    }
    const $7a81278f397cc3f8$export$18b0a4b86a372cdb = ({ fetch: fetch, statusCodeHandlers: statusCodeHandlers = {} })=>(url, fetchOptions = {})=>{
            const headers = {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            };
            return fetch(url, {
                credentials: 'include',
                ...fetchOptions,
                headers: $7a81278f397cc3f8$var$removeEmptyProp(headers)
            }).then((response)=>{
                const { status: status } = response;
                const handler = statusCodeHandlers[status];
                if (typeof handler === 'function') handler(response);
                return response;
            }).then($7a81278f397cc3f8$var$handleFetchCommonResponse);
        };
});
parcelRegister("5nPJy", function(module, exports) {
    $parcel$export(module.exports, "isCustomQuery", ()=>$f2d64422727bcb47$export$e722a3789f7fabfb);
    var $8nGR4;
    const $f2d64422727bcb47$var$isDefinitionObjectHasDirective = (def, directiveName)=>{
        if (!def) return false;
        for (const node of def){
            const { operation: type, directives: directives } = node;
            if (type === 'query' || type === 'mutation') return directives && directives.some((directive)=>directive.name.value === directiveName);
        }
    };
    const $f2d64422727bcb47$var$isQueryContainDirective = (opt, directiveName)=>{
        const globalDef = opt.query && opt.query.definitions;
        const childDef = opt.query && opt.query[opt.operationName] && opt.query[opt.operationName].definitions;
        return !!($f2d64422727bcb47$var$isDefinitionObjectHasDirective(globalDef, directiveName) || $f2d64422727bcb47$var$isDefinitionObjectHasDirective(childDef, directiveName));
    };
    const $f2d64422727bcb47$export$e722a3789f7fabfb = (opt)=>{
        return $f2d64422727bcb47$var$isQueryContainDirective(opt, (0, (0, parcelRequire("8nGR4")).Directives).CUSTOM);
    };
});
parcelRegister("8nGR4", function(module, exports) {
    $parcel$export(module.exports, "Directives", ()=>$7bcc26b335b36b53$export$129646a0e1af8d85);
    $parcel$export(module.exports, "CustomDirective", ()=>$7bcc26b335b36b53$export$97a7ea7443254e53);
    var $jADQJ;
    var $35Smo;
    var $7bcc26b335b36b53$export$129646a0e1af8d85;
    (function(Directives) {
        Directives["CUSTOM"] = "custom";
    })($7bcc26b335b36b53$export$129646a0e1af8d85 || ($7bcc26b335b36b53$export$129646a0e1af8d85 = {}));
    const $7bcc26b335b36b53$export$97a7ea7443254e53 = new (0, (0, parcelRequire("35Smo")).GraphQLDirective)({
        name: "custom",
        locations: [
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).QUERY,
            (0, (0, parcelRequire("jADQJ")).DirectiveLocation).MUTATION
        ]
    });
});
parcelRegister("lgZyO", function(module, exports) {
    $parcel$export(module.exports, "createDirectoryHttpLink", ()=>$7f8fd4d02dd0d168$export$bacc55ff336c5f9d);
    var $JPsIz;
    const $7f8fd4d02dd0d168$export$bacc55ff336c5f9d = ({ url: url, getCloudId: getCloudId })=>{
        const customFetch = async (uri, options)=>{
            const body = JSON.parse(options.body);
            const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;
            if (body.variables && body.variables._withCloudId && getCloudId) {
                delete body.variables._withCloudId;
                body.variables.cloudId = getCloudId();
                options.body = JSON.stringify(body);
            }
            return fetch(uriWithOps, options);
        };
        return new (0, (0, parcelRequire("JPsIz")).HttpLink)({
            uri: url,
            credentials: 'include',
            fetch: customFetch
        });
    };
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("gUX0t", function(module, exports) {
    $parcel$export(module.exports, "createErrorLink", ()=>$75c4c6af2e9a4797$export$d0106730d0f8f3b5);
    var $h4ppL;
    var $c8bmx;
    const $75c4c6af2e9a4797$export$d0106730d0f8f3b5 = ({ statusCodeHandlers: statusCodeHandlers })=>(0, (0, parcelRequire("h4ppL")).onError)((errorResponse)=>{
            const networkError = errorResponse.networkError;
            const graphQLErrors = errorResponse.graphQLErrors;
            if (graphQLErrors) console.error((0, (0, parcelRequire("c8bmx")).GraphQLError).from(errorResponse.graphQLErrors));
            if (networkError) {
                const statusCode = networkError.statusCode;
                const handler = statusCodeHandlers[statusCode];
                if (typeof handler === 'function') {
                    handler();
                    return;
                }
            }
        });
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("c8bmx", function(module, exports) {
    $parcel$export(module.exports, "GraphQLError", ()=>$c1adbf414349ecc3$export$92d6ed0888e7cb7f);
    class $c1adbf414349ecc3$var$CommonError extends Error {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            this.message = message;
            this.stack = new Error(message).stack || '';
        }
    }
    class $c1adbf414349ecc3$export$c73ca302efeda3b4 extends $c1adbf414349ecc3$var$CommonError {
        constructor({ message: message }){
            super(message || 'UnknownError');
            Object.setPrototypeOf(this, $c1adbf414349ecc3$export$c73ca302efeda3b4.prototype);
        }
    }
    class $c1adbf414349ecc3$export$20de9a0e470e95aa extends $c1adbf414349ecc3$var$CommonError {
        constructor({ message: message }){
            super(`SentryIgnore: ${message || 'UnknownError'}`);
            Object.setPrototypeOf(this, $c1adbf414349ecc3$export$20de9a0e470e95aa.prototype);
        }
    }
    class $c1adbf414349ecc3$export$65bd6083489bd8bb extends $c1adbf414349ecc3$var$CommonError {
        constructor({ message: message, status: status }){
            super(message);
            Object.setPrototypeOf(this, $c1adbf414349ecc3$export$65bd6083489bd8bb.prototype);
            this.status = status;
        }
    }
    class $c1adbf414349ecc3$export$92d6ed0888e7cb7f extends $c1adbf414349ecc3$var$CommonError {
        constructor({ message: message = 'unknown', category: category = 'default', fields: fields }){
            super(message);
            Object.setPrototypeOf(this, $c1adbf414349ecc3$export$92d6ed0888e7cb7f.prototype);
            this.category = category;
            if (fields) this.fields = fields;
        }
        static{
            this.from = (rawErrors)=>{
                const firstError = rawErrors[0];
                const errorData = {
                    category: firstError.category,
                    message: firstError.message
                };
                if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                    obj[item.field] = item.message;
                    return obj;
                }, {});
                return new $c1adbf414349ecc3$export$92d6ed0888e7cb7f(errorData);
            };
        }
    }
});
parcelRegister("9NFua", function(module, exports) {
    $parcel$export(module.exports, "createRetryLink", ()=>$0f1b6aff8ee2fdd7$export$91ceafe7c6f4a732);
    var $lC4FX;
    const $0f1b6aff8ee2fdd7$export$8f4286bf21155381 = {
        INITIAL_DELAY: 200,
        MAX_RETRIES: 5,
        JITTER: true
    };
    function $0f1b6aff8ee2fdd7$export$55b2fbd5d4a32495(status) {
        return 500 <= status && status <= 599;
    }
    const $0f1b6aff8ee2fdd7$export$91ceafe7c6f4a732 = (retryOptions)=>new (0, (0, parcelRequire("lC4FX")).RetryLink)({
            delay: {
                initial: $0f1b6aff8ee2fdd7$export$8f4286bf21155381.INITIAL_DELAY,
                max: Infinity,
                jitter: $0f1b6aff8ee2fdd7$export$8f4286bf21155381.JITTER,
                ...retryOptions.delay
            },
            attempts: {
                max: $0f1b6aff8ee2fdd7$export$8f4286bf21155381.MAX_RETRIES,
                retryIf: (error, operation)=>{
                    const context = operation.getContext();
                    const response = context.response;
                    const noRetry = context.noRetry;
                    return $0f1b6aff8ee2fdd7$export$55b2fbd5d4a32495(response && response.status) && !noRetry;
                },
                ...retryOptions.attempts
            }
        });
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("520qQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$864a14104690bac3$export$2e2bcd8739ae039);
    var $6dsHP;
    var $2qbup;
    var $kLH9x;
    var $92KUp;
    var $9Lcvn;
    var $dACgH;
    var $1dBFl;
    var $3zv5O;
    var $7HG9Z;
    var $8Lsct;
    var $9HXhp;
    var $cZqkM;
    var $7PnNo;
    var $lodcS;
    var $3rczO;
    var $2jxTA;
    const $864a14104690bac3$var$resolvers = {
        Query: {
            User: (0, parcelRequire("9HXhp")).default,
            MyAvatar: (0, parcelRequire("92KUp")).default,
            UserOrganization: (0, parcelRequire("2jxTA")).default,
            UserManageConfig: (0, parcelRequire("cZqkM")).default,
            UserManagePrivacySettings: (0, parcelRequire("lodcS")).default,
            UserManageLinkedAccounts: (0, parcelRequire("7PnNo")).default,
            UserManagePrivacySettingsAllowed: (0, parcelRequire("3rczO")).default,
            TeamInSlack: (0, parcelRequire("9Lcvn")).default,
            Containers: (0, parcelRequire("6dsHP")).default,
            TeamLinkIcons: (0, parcelRequire("dACgH")).default
        },
        Mutation: {
            updateUser: (0, parcelRequire("3zv5O")).default,
            deleteUserAvatar: (0, parcelRequire("2qbup")).default,
            updateUserAvatar: (0, parcelRequire("7HG9Z")).default,
            updateUserPrivacySettings: (0, parcelRequire("8Lsct")).default,
            updateTeamInSlack: (0, parcelRequire("1dBFl")).default,
            disconnectTeamInSlack: (0, parcelRequire("kLH9x")).default
        }
    };
    var $864a14104690bac3$export$2e2bcd8739ae039 = $864a14104690bac3$var$resolvers;
});
parcelRegister("6dsHP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a74ed4ce4e9c75ec$export$2e2bcd8739ae039);
    const $a74ed4ce4e9c75ec$var$Containers = async (_, args, context, info)=>{
        const { userId: userId, maxNumberOfResults: maxNumberOfResults, principalId: principalId, siteId: siteId, sessionId: sessionId } = args;
        return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                context: {
                    contextType: 'atlassianDirectory',
                    principalId: principalId,
                    siteId: siteId,
                    sessionId: sessionId
                },
                containerTypes: [
                    'confluenceSpace',
                    'jiraProject'
                ],
                maxNumberOfResults: maxNumberOfResults,
                userId: userId,
                expanded: true
            })
        }).then((res)=>{
            return res.json();
        });
    };
    var $a74ed4ce4e9c75ec$export$2e2bcd8739ae039 = $a74ed4ce4e9c75ec$var$Containers;
});
parcelRegister("2qbup", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67a9ab0faae6b462$export$2e2bcd8739ae039);
    const $67a9ab0faae6b462$var$deleteUserAvatar = async (_, args, context)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
        return context.fetch(url, {
            method: 'DELETE'
        }).then(()=>true);
    };
    var $67a9ab0faae6b462$export$2e2bcd8739ae039 = $67a9ab0faae6b462$var$deleteUserAvatar;
});
parcelRegister("kLH9x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fdf6e324cf4d15a7$export$2e2bcd8739ae039);
    const $fdf6e324cf4d15a7$var$disconnectTeamInSlack = async (_, args, context)=>{
        const { teamId: teamId } = args;
        const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}`;
        return context.fetch(url, {
            method: 'DELETE'
        }).then((data)=>data.json()).then((data)=>({
                id: teamId,
                ...data
            }));
    };
    var $fdf6e324cf4d15a7$export$2e2bcd8739ae039 = $fdf6e324cf4d15a7$var$disconnectTeamInSlack;
});
parcelRegister("92KUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a029f0b60e7ebfbf$export$2e2bcd8739ae039);
    const $a029f0b60e7ebfbf$var$myAvatar = async (root, args, context)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
        return context.fetch(url).then((data)=>data.json());
    };
    var $a029f0b60e7ebfbf$export$2e2bcd8739ae039 = $a029f0b60e7ebfbf$var$myAvatar;
});
parcelRegister("9Lcvn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0604cba82f8d7c18$export$2e2bcd8739ae039);
    const $0604cba82f8d7c18$var$teamInSlack = async (root, args, context)=>{
        const { teamId: teamId, teamName: teamName } = args;
        const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;
        return context.fetch(url).then((data)=>data.json()).then((data)=>({
                id: teamId,
                ...data
            }));
    };
    var $0604cba82f8d7c18$export$2e2bcd8739ae039 = $0604cba82f8d7c18$var$teamInSlack;
});
parcelRegister("dACgH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$215746dd9554c245$export$2e2bcd8739ae039);
    var $eC6Ef;
    const $215746dd9554c245$var$TeamLinkIcons = async (_, args, context, info)=>{
        const requestBody = args.teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        const options = {
            method: 'POST',
            body: JSON.stringify(requestBody)
        };
        return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then((res)=>res.json()).then((0, (0, parcelRequire("eC6Ef")).transformIconData));
    };
    var $215746dd9554c245$export$2e2bcd8739ae039 = $215746dd9554c245$var$TeamLinkIcons;
});
parcelRegister("eC6Ef", function(module, exports) {
    $parcel$export(module.exports, "transformIconData", ()=>$4feb5d90951be4fd$export$39f4468adf4cb57c);
    var $4feb5d90951be4fd$var$ProviderNames;
    (function(ProviderNames) {
        ProviderNames["CONFLUENCE"] = "Confluence";
        ProviderNames["JIRA"] = "Jira";
    })($4feb5d90951be4fd$var$ProviderNames || ($4feb5d90951be4fd$var$ProviderNames = {}));
    const $4feb5d90951be4fd$export$c64ca1c808335e8b = (jsonLd)=>{
        const { url: url, generator: { name: name, icon: icon } } = jsonLd;
        switch(name){
            case "Confluence":
                return {
                    linkUrl: url,
                    iconUrl: $4feb5d90951be4fd$var$getConfluenceFavicon(url),
                    productName: name
                };
            case "Jira":
                return {
                    linkUrl: url,
                    iconUrl: $4feb5d90951be4fd$var$getJiraFavicon(url),
                    productName: name
                };
            default:
                return {
                    linkUrl: url,
                    iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                    productName: name
                };
        }
    };
    const $4feb5d90951be4fd$var$isIconItemSuccess = (response)=>{
        return response.status === 200;
    };
    const $4feb5d90951be4fd$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($4feb5d90951be4fd$var$isIconItemSuccess).map((resp)=>resp.body.data).map($4feb5d90951be4fd$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
    const $4feb5d90951be4fd$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
    const $4feb5d90951be4fd$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;
});
parcelRegister("1dBFl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c80ee249d3f6e534$export$2e2bcd8739ae039);
    const $c80ee249d3f6e534$var$updateTeamInSlack = async (_, args, context)=>{
        const { teamId: teamId, channelId: channelId, usergroupHandle: usergroupHandle } = args;
        const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
        return context.fetch(url, {
            method: 'POST'
        }).then((data)=>data.json()).then((data)=>({
                id: teamId,
                ...data
            }));
    };
    var $c80ee249d3f6e534$export$2e2bcd8739ae039 = $c80ee249d3f6e534$var$updateTeamInSlack;
});
parcelRegister("3zv5O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec063aa6a1a46ccd$export$2e2bcd8739ae039);
    var $8kgIp;
    const $ec063aa6a1a46ccd$var$updateUser = async (_, args, context, info)=>{
        const { id: id, input: input } = args;
        const url = `${context.url.stargateRoot}/users/${id}/manage/profile`;
        const body = JSON.stringify((0, parcelRequire("8kgIp")).toManageAPIInput(input));
        return context.fetch(url, {
            method: 'PATCH',
            body: body
        }).then((data)=>data.json()).then((res)=>(0, parcelRequire("8kgIp")).fromManageAPIResponse(res));
    };
    var $ec063aa6a1a46ccd$export$2e2bcd8739ae039 = $ec063aa6a1a46ccd$var$updateUser;
});
parcelRegister("8kgIp", function(module, exports) {
    $parcel$export(module.exports, "fromManageAPIResponse", ()=>$d63b66a056be63bd$export$5299664357e4f3dd);
    $parcel$export(module.exports, "toManageAPIInput", ()=>$d63b66a056be63bd$export$7b103107c889cb67);
    parcelRequire("5hsG5");
    var $2GMyI;
    const $d63b66a056be63bd$var$PROFILE_PROPS_MAP = new Map([
        [
            'id',
            'account_id'
        ],
        [
            'fullName',
            'name'
        ],
        [
            'nickname',
            'nickname'
        ],
        [
            'timezone',
            'zoneinfo'
        ],
        [
            'locale',
            'locale'
        ],
        [
            'avatarUrl',
            'picture'
        ],
        [
            'email',
            'email'
        ]
    ]);
    const $d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
        [
            'title',
            'job_title'
        ],
        [
            'department',
            'department'
        ],
        [
            'companyName',
            'organization'
        ],
        [
            'location',
            'location'
        ],
        [
            'phoneNumber',
            'phone_number'
        ]
    ]);
    const $d63b66a056be63bd$export$5299664357e4f3dd = (res)=>{
        const data = res.account;
        const extendedData = data && data.extended_profile || {};
        if (!data) return null;
        const timeZone = data.zoneinfo;
        const localTime = ({ format: format })=>{
            if (!timeZone) return null;
            try {
                return (0, (0, parcelRequire("2GMyI")).default)(new Date(), timeZone, format);
            } catch (error) {
                return null;
            }
        };
        const profileProps = Array.from($d63b66a056be63bd$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
            if ($d63b66a056be63bd$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$d63b66a056be63bd$var$PROFILE_PROPS_MAP.get(key)];
            return acc;
        }, {});
        const extendedProfileProps = Array.from($d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
            if ($d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
            return acc;
        }, {});
        return {
            ...profileProps,
            ...extendedProfileProps,
            localTime: localTime
        };
    };
    const $d63b66a056be63bd$export$7b103107c889cb67 = (input)=>{
        const output = {
            extended_profile: {}
        };
        Object.keys(input).forEach((key)=>{
            if ($d63b66a056be63bd$var$PROFILE_PROPS_MAP.has(key)) output[$d63b66a056be63bd$var$PROFILE_PROPS_MAP.get(key)] = input[key];
            if ($d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$d63b66a056be63bd$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
        });
        return output;
    };
});
parcelRegister("5hsG5", function(module, exports) {
    $parcel$export(module.exports, "formatInTimeZone", ()=>(parcelRequire("2GMyI")).default);
    var $2GMyI;
});
parcelRegister("2GMyI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f552bcbeaf94f61$export$2e2bcd8739ae039);
    var $fwbX5;
    var $8ORnH;
    var $4UeZ4;
    function $1f552bcbeaf94f61$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("8ORnH")).default)((0, (0, parcelRequire("4UeZ4")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("8ORnH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66bc66a44ca72b59$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $fjlI3;
    var $9Mj9C;
    var $66bc66a44ca72b59$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $66bc66a44ca72b59$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($66bc66a44ca72b59$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("9Mj9C")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("fjlI3")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("fjlI3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b25978731b67b37e$export$2e2bcd8739ae039);
    var $e969Q = parcelRequire("e969Q");
    var $7gYFo = parcelRequire("7gYFo");
    var $b25978731b67b37e$var$MILLISECONDS_IN_MINUTE = 60000;
    var $b25978731b67b37e$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $b25978731b67b37e$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $b25978731b67b37e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $b25978731b67b37e$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $b25978731b67b37e$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $b25978731b67b37e$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $b25978731b67b37e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $b25978731b67b37e$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $b25978731b67b37e$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $b25978731b67b37e$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $b25978731b67b37e$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $b25978731b67b37e$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $e969Q.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $e969Q.default)('long', date, options);
            }
        }
    };
    function $b25978731b67b37e$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $7gYFo.default)(timeZone, originalDate, true) / $b25978731b67b37e$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $b25978731b67b37e$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $b25978731b67b37e$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $b25978731b67b37e$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $b25978731b67b37e$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $b25978731b67b37e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $b25978731b67b37e$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $b25978731b67b37e$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $b25978731b67b37e$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $b25978731b67b37e$var$addLeadingZeros(minutes, 2);
    }
    var $b25978731b67b37e$export$2e2bcd8739ae039 = $b25978731b67b37e$var$formatters;
});
parcelRegister("e969Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4c6aec52da31e93$export$2e2bcd8739ae039);
    function $a4c6aec52da31e93$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $a4c6aec52da31e93$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $a4c6aec52da31e93$var$partsTimeZone(dtf, date) : $a4c6aec52da31e93$var$hackyTimeZone(dtf, date);
    }
    function $a4c6aec52da31e93$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $a4c6aec52da31e93$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $a4c6aec52da31e93$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("7gYFo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54b916228bee453b$export$2e2bcd8739ae039);
    var $aRZFy = parcelRequire("aRZFy");
    var $kublf = parcelRequire("kublf");
    var $54b916228bee453b$var$MILLISECONDS_IN_HOUR = 3600000;
    var $54b916228bee453b$var$MILLISECONDS_IN_MINUTE = 60000;
    var $54b916228bee453b$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $54b916228bee453b$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $54b916228bee453b$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $54b916228bee453b$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$54b916228bee453b$var$validateTimezone(hours)) return NaN;
            return -(hours * $54b916228bee453b$var$MILLISECONDS_IN_HOUR);
        }
        token = $54b916228bee453b$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$54b916228bee453b$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $54b916228bee453b$var$MILLISECONDS_IN_HOUR + minutes * $54b916228bee453b$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($54b916228bee453b$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $54b916228bee453b$var$toUtcDate(date);
            var offset = $54b916228bee453b$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $54b916228bee453b$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $54b916228bee453b$var$toUtcDate(date) {
        return (0, $kublf.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $54b916228bee453b$var$calcOffset(date, timezoneString) {
        var tokens = (0, $aRZFy.default)(date, timezoneString);
        var asUTC = (0, $kublf.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $54b916228bee453b$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $54b916228bee453b$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $54b916228bee453b$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $54b916228bee453b$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $54b916228bee453b$var$validIANATimezoneCache = {};
    function $54b916228bee453b$var$isValidTimezoneIANAString(timeZoneString) {
        if ($54b916228bee453b$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $54b916228bee453b$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("aRZFy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e9eb0d77679cae2$export$2e2bcd8739ae039);
    function $7e9eb0d77679cae2$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $7e9eb0d77679cae2$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $7e9eb0d77679cae2$var$partsOffset(dtf, date) : $7e9eb0d77679cae2$var$hackyOffset(dtf, date);
    }
    var $7e9eb0d77679cae2$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $7e9eb0d77679cae2$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $7e9eb0d77679cae2$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $7e9eb0d77679cae2$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $7e9eb0d77679cae2$var$dtfCache = {};
    function $7e9eb0d77679cae2$var$getDateTimeFormat(timeZone) {
        if (!$7e9eb0d77679cae2$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $7e9eb0d77679cae2$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $7e9eb0d77679cae2$var$dtfCache[timeZone];
    }
});
parcelRegister("kublf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee9f683a3541be97$export$2e2bcd8739ae039);
    function $ee9f683a3541be97$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("9Mj9C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71e77458abd39cb4$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $7gYFo = parcelRequire("7gYFo");
    var $bclA9 = parcelRequire("bclA9");
    var $71e77458abd39cb4$var$MILLISECONDS_IN_HOUR = 3600000;
    var $71e77458abd39cb4$var$MILLISECONDS_IN_MINUTE = 60000;
    var $71e77458abd39cb4$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $71e77458abd39cb4$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $bclA9.default)
    };
    function $71e77458abd39cb4$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $71e77458abd39cb4$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $71e77458abd39cb4$var$splitDateString(argument);
        var parseYearResult = $71e77458abd39cb4$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $71e77458abd39cb4$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $71e77458abd39cb4$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $7gYFo.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $71e77458abd39cb4$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $71e77458abd39cb4$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $71e77458abd39cb4$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $71e77458abd39cb4$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $71e77458abd39cb4$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $71e77458abd39cb4$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $71e77458abd39cb4$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $71e77458abd39cb4$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $71e77458abd39cb4$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $71e77458abd39cb4$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $71e77458abd39cb4$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$71e77458abd39cb4$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $71e77458abd39cb4$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$71e77458abd39cb4$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $71e77458abd39cb4$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$71e77458abd39cb4$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $71e77458abd39cb4$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$71e77458abd39cb4$var$validateWeekDate(year, week)) return new Date(NaN);
            return $71e77458abd39cb4$var$dayOfISOWeekYear(year, week);
        }
        token = $71e77458abd39cb4$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$71e77458abd39cb4$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $71e77458abd39cb4$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $71e77458abd39cb4$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $71e77458abd39cb4$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$71e77458abd39cb4$var$validateTime(hours)) return NaN;
            return hours % 24 * $71e77458abd39cb4$var$MILLISECONDS_IN_HOUR;
        }
        token = $71e77458abd39cb4$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$71e77458abd39cb4$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $71e77458abd39cb4$var$MILLISECONDS_IN_HOUR + minutes * $71e77458abd39cb4$var$MILLISECONDS_IN_MINUTE;
        }
        token = $71e77458abd39cb4$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$71e77458abd39cb4$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $71e77458abd39cb4$var$MILLISECONDS_IN_HOUR + minutes * $71e77458abd39cb4$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $71e77458abd39cb4$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $71e77458abd39cb4$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $71e77458abd39cb4$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $71e77458abd39cb4$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $71e77458abd39cb4$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $71e77458abd39cb4$var$isLeapYearIndex(year);
            if (isLeapYear && date > $71e77458abd39cb4$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $71e77458abd39cb4$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $71e77458abd39cb4$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $71e77458abd39cb4$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $71e77458abd39cb4$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $71e77458abd39cb4$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("bclA9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82718e73747872da$export$2e2bcd8739ae039);
    var $82718e73747872da$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $82718e73747872da$export$2e2bcd8739ae039 = $82718e73747872da$var$tzPattern;
});
parcelRegister("4UeZ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$392803e3bd46b1ec$export$2e2bcd8739ae039);
    var $7gYFo = parcelRequire("7gYFo");
    var $9Mj9C;
    function $392803e3bd46b1ec$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("9Mj9C")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $7gYFo.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("7HG9Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$567eea48b3d1e206$export$2e2bcd8739ae039);
    var $lXd6Z;
    const $567eea48b3d1e206$var$updateUserAvatar = async (_, args, context)=>{
        const { userId: userId, fileURI: fileURI } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
        const fileObject = (0, (0, parcelRequire("lXd6Z")).dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const fetchOptions = {
            method: 'PUT',
            body: formData,
            headers: {
                'Content-Type': undefined
            }
        };
        return context.fetch(url, fetchOptions).then(()=>({
                url: fileURI
            }));
    };
    var $567eea48b3d1e206$export$2e2bcd8739ae039 = $567eea48b3d1e206$var$updateUserAvatar;
});
parcelRegister("lXd6Z", function(module, exports) {
    $parcel$export(module.exports, "dataURItoFile", ()=>$042e4f56babbdd2a$export$80d19edb7b1ae293);
    function $042e4f56babbdd2a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
        if (dataURI.length === 0) throw new Error('dataURI not found');
        const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
        let mimeString;
        try {
            mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        } catch (e) {
            mimeString = 'unknown';
        }
        const intArray = new Uint8Array(byteString.length);
        for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
        const blob = new Blob([
            intArray
        ], {
            type: mimeString
        });
        try {
            return new File([
                blob
            ], filename, {
                type: mimeString
            });
        } catch (e) {
            return blob;
        }
    }
});
parcelRegister("8Lsct", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdcc51170fc06f13$export$2e2bcd8739ae039);
    var $b5Svc;
    const $bdcc51170fc06f13$var$updateUserPrivacySettings = async (_, args, context, info)=>{
        const { id: id, input: input } = args;
        const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
        const body = JSON.stringify((0, (0, parcelRequire("b5Svc")).transformPrivacySettingsFormatFromSchemaToApi)(input));
        return context.fetch(url, {
            method: 'PATCH',
            body: body
        }).then((data)=>data.json()).then((data)=>(0, (0, parcelRequire("b5Svc")).transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
                ...data,
                id: id
            }));
    };
    var $bdcc51170fc06f13$export$2e2bcd8739ae039 = $bdcc51170fc06f13$var$updateUserPrivacySettings;
});
parcelRegister("b5Svc", function(module, exports) {
    $parcel$export(module.exports, "PRIVACY_SETTINGS_SCHEMA_TO_API_MAP", ()=>$99ea7e24c71958cb$export$4154b9b275895abf);
    $parcel$export(module.exports, "transformPrivacySettingsFormatFromApiToSchema", ()=>$99ea7e24c71958cb$export$bfc3808f21c9d49d);
    $parcel$export(module.exports, "transformPrivacySettingsFormatFromSchemaToApi", ()=>$99ea7e24c71958cb$export$f5a6643bba95b2d0);
    var $7lhw1;
    const $99ea7e24c71958cb$var$manageUserPrivacySettingsKeys = [
        'name',
        'nickname',
        'zoneinfo',
        'picture',
        'email',
        'phoneNumber',
        'jobTitle',
        'organization',
        'department',
        'location'
    ];
    const $99ea7e24c71958cb$var$schemaKeys = {
        name: 'name',
        nickname: 'nickname',
        zoneinfo: 'zoneinfo',
        picture: 'picture',
        email: 'email',
        phoneNumber: 'phoneNumber',
        jobTitle: 'jobTitle',
        organization: 'organization',
        department: 'department',
        location: 'location'
    };
    const $99ea7e24c71958cb$var$apiKeys = {
        name: 'name',
        nickname: 'nickname',
        zoneinfo: 'zoneinfo',
        picture: 'picture',
        email: 'email',
        phoneNumber: 'extended_profile.phone_number',
        jobTitle: 'extended_profile.job_title',
        organization: 'extended_profile.organization',
        department: 'extended_profile.department',
        location: 'extended_profile.location'
    };
    const $99ea7e24c71958cb$export$4154b9b275895abf = {
        [$99ea7e24c71958cb$var$schemaKeys.name]: $99ea7e24c71958cb$var$apiKeys.name,
        [$99ea7e24c71958cb$var$schemaKeys.nickname]: $99ea7e24c71958cb$var$apiKeys.nickname,
        [$99ea7e24c71958cb$var$schemaKeys.zoneinfo]: $99ea7e24c71958cb$var$apiKeys.zoneinfo,
        [$99ea7e24c71958cb$var$schemaKeys.picture]: $99ea7e24c71958cb$var$apiKeys.picture,
        [$99ea7e24c71958cb$var$schemaKeys.email]: $99ea7e24c71958cb$var$apiKeys.email,
        [$99ea7e24c71958cb$var$schemaKeys.phoneNumber]: $99ea7e24c71958cb$var$apiKeys.phoneNumber,
        [$99ea7e24c71958cb$var$schemaKeys.jobTitle]: $99ea7e24c71958cb$var$apiKeys.jobTitle,
        [$99ea7e24c71958cb$var$schemaKeys.organization]: $99ea7e24c71958cb$var$apiKeys.organization,
        [$99ea7e24c71958cb$var$schemaKeys.department]: $99ea7e24c71958cb$var$apiKeys.department,
        [$99ea7e24c71958cb$var$schemaKeys.location]: $99ea7e24c71958cb$var$apiKeys.location
    };
    const $99ea7e24c71958cb$export$bfc3808f21c9d49d = (data)=>Object.keys($99ea7e24c71958cb$export$4154b9b275895abf).reduce((memo, schemaValue)=>{
            const apiResponseKey = $99ea7e24c71958cb$export$4154b9b275895abf[schemaValue];
            const privacySetting = data[apiResponseKey];
            memo[schemaValue] = (0, (0, parcelRequire("7lhw1")).toUpperCase)(privacySetting);
            return memo;
        }, {});
    const $99ea7e24c71958cb$export$64774399daaaf8ff = {
        [$99ea7e24c71958cb$var$apiKeys.name]: $99ea7e24c71958cb$var$schemaKeys.name,
        [$99ea7e24c71958cb$var$apiKeys.nickname]: $99ea7e24c71958cb$var$schemaKeys.nickname,
        [$99ea7e24c71958cb$var$apiKeys.zoneinfo]: $99ea7e24c71958cb$var$schemaKeys.zoneinfo,
        [$99ea7e24c71958cb$var$apiKeys.picture]: $99ea7e24c71958cb$var$schemaKeys.picture,
        [$99ea7e24c71958cb$var$apiKeys.email]: $99ea7e24c71958cb$var$schemaKeys.email,
        [$99ea7e24c71958cb$var$apiKeys.phoneNumber]: $99ea7e24c71958cb$var$schemaKeys.phoneNumber,
        [$99ea7e24c71958cb$var$apiKeys.jobTitle]: $99ea7e24c71958cb$var$schemaKeys.jobTitle,
        [$99ea7e24c71958cb$var$apiKeys.organization]: $99ea7e24c71958cb$var$schemaKeys.organization,
        [$99ea7e24c71958cb$var$apiKeys.department]: $99ea7e24c71958cb$var$schemaKeys.department,
        [$99ea7e24c71958cb$var$apiKeys.location]: $99ea7e24c71958cb$var$schemaKeys.location
    };
    const $99ea7e24c71958cb$export$f5a6643bba95b2d0 = (data)=>Object.keys($99ea7e24c71958cb$export$64774399daaaf8ff).reduce((memo, apiValue)=>{
            const apiResponseKey = $99ea7e24c71958cb$export$64774399daaaf8ff[apiValue];
            const privacySetting = data[apiResponseKey];
            if (privacySetting) memo[apiValue] = privacySetting.toLowerCase();
            return memo;
        }, {});
});
parcelRegister("7lhw1", function(module, exports) {
    $parcel$export(module.exports, "toUpperCase", ()=>$e0ef2a66fa982f78$export$d80c591a9e16646);
    const $e0ef2a66fa982f78$export$d80c591a9e16646 = (input)=>{
        if (typeof input === 'string') return input.toUpperCase();
        return null;
    };
});
parcelRegister("9HXhp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23bb77c5e891f5fc$export$2e2bcd8739ae039);
    var $8kgIp;
    const $23bb77c5e891f5fc$var$User = async (_, args, context, info)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/profile`;
        return context.fetch(url).then((data)=>data.json()).then((res)=>(0, parcelRequire("8kgIp")).fromManageAPIResponse(res));
    };
    var $23bb77c5e891f5fc$export$2e2bcd8739ae039 = $23bb77c5e891f5fc$var$User;
});
parcelRegister("cZqkM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e460e5d2e6d13e7a$export$2e2bcd8739ae039);
    var $8HBGQ;
    const $e460e5d2e6d13e7a$var$UserManageConfig = async (_, args, context)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage`;
        return context.fetch(url).then((data)=>data.json()).then((data)=>(0, (0, parcelRequire("8HBGQ")).transformUserManageConfig)(data));
    };
    var $e460e5d2e6d13e7a$export$2e2bcd8739ae039 = $e460e5d2e6d13e7a$var$UserManageConfig;
});
parcelRegister("8HBGQ", function(module, exports) {
    $parcel$export(module.exports, "transformUserManageConfig", ()=>$1023da290cd2a286$export$d7725d3d27b80a68);
    const $1023da290cd2a286$var$MUTABILITY_DETAILS_MAP = {
        fullName: 'name',
        nickname: 'nickname',
        timezone: 'zoneinfo',
        locale: 'locale',
        email: 'email',
        title: 'extended_profile.job_title',
        phoneNumber: 'extended_profile.phone_number',
        companyName: 'extended_profile.organization',
        department: 'extended_profile.department',
        location: 'extended_profile.location'
    };
    const $1023da290cd2a286$var$CUSTOM_FIELD_PLACE = {
        email: 'email.initiateChange',
        picture: 'avatar'
    };
    const $1023da290cd2a286$var$getFieldConfig = (data, field)=>{
        if ((field === 'email' || field === 'picture') && $1023da290cd2a286$var$CUSTOM_FIELD_PLACE[field]) return data[$1023da290cd2a286$var$CUSTOM_FIELD_PLACE[field]];
        const mappedFieldKey = $1023da290cd2a286$var$MUTABILITY_DETAILS_MAP[field];
        return data['profile.write'][mappedFieldKey];
    };
    const $1023da290cd2a286$var$getMutabilityConstraintFor = (data, field)=>{
        const fieldConfig = $1023da290cd2a286$var$getFieldConfig(data, field);
        if (!fieldConfig || fieldConfig.allowed) return null;
        const reason = fieldConfig.reason;
        return {
            field: field,
            reason: reason && reason.key || null
        };
    };
    const $1023da290cd2a286$export$d7725d3d27b80a68 = (data)=>({
            mutabilityConstraints: Object.keys($1023da290cd2a286$var$MUTABILITY_DETAILS_MAP).map((field)=>$1023da290cd2a286$var$getMutabilityConstraintFor(data, field)).filter((truthy)=>truthy)
        });
});
parcelRegister("7PnNo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b81f6938eb5cd116$export$2e2bcd8739ae039);
    const $b81f6938eb5cd116$var$UserManageLinkedAccounts = (_, args, context, info)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
        return context.fetch(url).then((res)=>res.json()).then((data)=>{
            return {
                google: Boolean(data && data.google && data.google.linked),
                microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
                apple: Boolean(data && data.apple && data.apple.linked),
                saml: Boolean(data && data.saml && data.saml.linked)
            };
        });
    };
    var $b81f6938eb5cd116$export$2e2bcd8739ae039 = $b81f6938eb5cd116$var$UserManageLinkedAccounts;
});
parcelRegister("lodcS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40a7f0cbd26abdd6$export$2e2bcd8739ae039);
    var $b5Svc;
    const $40a7f0cbd26abdd6$var$UserManagePrivacySettings = async (_, args, context, info)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
        return context.fetch(url).then((data)=>data.json()).then((data)=>(0, (0, parcelRequire("b5Svc")).transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
                ...data,
                id: userId
            }));
    };
    var $40a7f0cbd26abdd6$export$2e2bcd8739ae039 = $40a7f0cbd26abdd6$var$UserManagePrivacySettings;
});
parcelRegister("3rczO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bef0d90b7a78c667$export$2e2bcd8739ae039);
    var $4G9yX;
    const $bef0d90b7a78c667$var$UserManagePrivacySettingsAllowed = async (_, args, context, info)=>{
        const { userId: userId } = args;
        const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
        return context.fetch(url).then((data)=>data.json()).then((data)=>(0, (0, parcelRequire("4G9yX")).transformUserManagePrivacySettingsAllowed)(data));
    };
    var $bef0d90b7a78c667$export$2e2bcd8739ae039 = $bef0d90b7a78c667$var$UserManagePrivacySettingsAllowed;
});
parcelRegister("4G9yX", function(module, exports) {
    $parcel$export(module.exports, "transformUserManagePrivacySettingsAllowed", ()=>$3f6c8752aaa8f8c7$export$3f9c63641eb8459e);
    var $7lhw1;
    var $b5Svc;
    const $3f6c8752aaa8f8c7$var$getAllowedPrivacySettingsFor = (data, schemaValue)=>{
        const apiResponseKey = (0, (0, parcelRequire("b5Svc")).PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)[schemaValue];
        const allowedPrivacySettings = data[apiResponseKey];
        if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
        return allowedPrivacySettings.map((0, (0, parcelRequire("7lhw1")).toUpperCase));
    };
    const $3f6c8752aaa8f8c7$export$3f9c63641eb8459e = (data)=>Object.keys((0, (0, parcelRequire("b5Svc")).PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)).reduce((memo, schemaValue)=>{
            memo[schemaValue] = $3f6c8752aaa8f8c7$var$getAllowedPrivacySettingsFor(data, schemaValue);
            return memo;
        }, {});
});
parcelRegister("2jxTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f384651357982e89$export$2e2bcd8739ae039);
    const $f384651357982e89$var$UserOrganization = async (_, args, context, info)=>{
        const url = `${context.url.stargateRoot}/my-orgs`;
        return context.fetch(url).then((data)=>data.json()).then((res)=>({
                cloudId: res.managedBy && res.managedBy.id || null,
                name: res.managedBy && res.managedBy.name || null
            }));
    };
    var $f384651357982e89$export$2e2bcd8739ae039 = $f384651357982e89$var$UserOrganization;
});
parcelRegister("2WwVh", function(module, exports) {
    $parcel$export(module.exports, "schema", ()=>$13abf97d63ba8c24$export$4902baddc787debb);
    var $lUVCX;
    var $8nGR4;
    var $6fked;
    var $jMc16;
    const $13abf97d63ba8c24$export$4902baddc787debb = new (0, (0, parcelRequire("lUVCX")).GraphQLSchema)({
        directives: [
            (0, (0, parcelRequire("8nGR4")).CustomDirective)
        ],
        query: (0, (0, parcelRequire("jMc16")).default),
        mutation: (0, (0, parcelRequire("6fked")).default)
    });
});
parcelRegister("6fked", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$608d65297e10dba5$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $bKGO7;
    var $boBP5;
    var $cG2YC;
    var $3yPZ5;
    const $608d65297e10dba5$var$MutationRoot = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            updateUser: {
                type: (0, (0, parcelRequire("cG2YC")).default),
                args: {
                    id: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    input: {
                        type: (0, (0, parcelRequire("cG2YC")).UserInput)
                    }
                }
            },
            deleteUserAvatar: {
                description: "Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
                type: (0, (0, parcelRequire("djKly")).GraphQLBoolean),
                args: {
                    userId: {
                        description: "User's Atlassian account ID",
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            updateUserAvatar: {
                description: 'Upload an Atlassian account avatar.',
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
                    fields: {
                        url: {
                            type: (0, (0, parcelRequire("djKly")).GraphQLString)
                        }
                    },
                    name: (0, (0, parcelRequire("bKGO7")).TypeNames).AVATAR,
                    description: 'New avatar URL after uploading successfully'
                }),
                args: {
                    userId: {
                        description: "User's Atlassian account ID",
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    fileURI: {
                        description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            updateUserPrivacySettings: {
                description: "Updates a user\u2019s privacy settings.",
                type: (0, (0, parcelRequire("3yPZ5")).default),
                args: {
                    id: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    input: {
                        type: (0, (0, parcelRequire("3yPZ5")).UserPrivacySettingsInput)
                    }
                }
            },
            updateTeamInSlack: {
                type: (0, (0, parcelRequire("boBP5")).default),
                args: {
                    teamId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    channelId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    usergroupHandle: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            disconnectTeamInSlack: {
                type: (0, (0, parcelRequire("boBP5")).default),
                args: {
                    teamId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            }
        },
        name: 'Mutation'
    });
    var $608d65297e10dba5$export$2e2bcd8739ae039 = $608d65297e10dba5$var$MutationRoot;
});
parcelRegister("bKGO7", function(module, exports) {
    $parcel$export(module.exports, "TypeNames", ()=>$19795ce89fa632cc$export$df40df59413bc65c);
    var $19795ce89fa632cc$export$df40df59413bc65c;
    (function(TypeNames) {
        TypeNames["USER"] = "_custom_User";
        TypeNames["USER_INPUT"] = "_custom_UserInput";
        TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
        TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
        TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
        TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
        TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
        TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
        TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
        TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
        TypeNames["USER_PLACE"] = "_custom_UserPlace";
        TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
        TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
        TypeNames["AVATAR"] = "_custom_Avatar";
        TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
        TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
        TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
        TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
        TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
        TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
        TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
        TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
        TypeNames["API_TOKEN"] = "_custom_ApiToken";
        TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
        TypeNames["SESSION"] = "_custom_Session";
        TypeNames["DEVICE"] = "_custom_Device";
        TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
        TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
        TypeNames["CONTAINERS"] = "_custom_Containers";
        TypeNames["CONTAINER"] = "_custom_Container";
        TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
        TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
        TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
    })($19795ce89fa632cc$export$df40df59413bc65c || ($19795ce89fa632cc$export$df40df59413bc65c = {}));
});
parcelRegister("boBP5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f786bbe9965dc645$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $bKGO7;
    const $f786bbe9965dc645$var$TeamInSlackStatusType = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            id: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            connected: {
                type: (0, (0, parcelRequire("djKly")).GraphQLBoolean)
            },
            slackChannelId: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            slackChannelName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            usergroupHandle: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).TeamSlackStatus,
        description: 'Whether the team has opted in to being synced with slack'
    });
    var $f786bbe9965dc645$export$2e2bcd8739ae039 = $f786bbe9965dc645$var$TeamInSlackStatusType;
});
parcelRegister("cG2YC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e1c4c48da448750$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "UserInput", ()=>$8e1c4c48da448750$export$3ac5e585cf392ee0);
    var $8oLgk;
    var $djKly;
    var $bKGO7;
    const $8e1c4c48da448750$var$User = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            id: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            fullName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            nickname: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            timezone: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            locale: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            avatarUrl: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            email: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            status: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            title: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            companyName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            department: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            location: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            phoneNumber: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            localTime: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString),
                args: {
                    format: {
                        description: 'moment.js format string',
                        type: (0, (0, parcelRequire("djKly")).GraphQLString),
                        defaultValue: ''
                    },
                    locale: {
                        description: 'locale for output',
                        type: (0, (0, parcelRequire("djKly")).GraphQLString),
                        defaultValue: 'en'
                    }
                }
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER,
        description: 'All User related data will be behind this GraphQL section'
    });
    var $8e1c4c48da448750$export$2e2bcd8739ae039 = $8e1c4c48da448750$var$User;
    const $8e1c4c48da448750$export$3ac5e585cf392ee0 = new (0, (0, parcelRequire("8oLgk")).GraphQLInputObjectType)({
        fields: {
            fullName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            nickname: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            timezone: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            locale: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            email: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            status: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            title: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            companyName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            department: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            location: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            phoneNumber: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER_INPUT
    });
});
parcelRegister("3yPZ5", function(module, exports) {
    $parcel$export(module.exports, "UserPrivacySettingsInput", ()=>$cc0b067a6f578757$export$5d92383dfb6e3588);
    $parcel$export(module.exports, "PrivacyValue", ()=>$cc0b067a6f578757$export$8d71fec0dbffb7e5);
    $parcel$export(module.exports, "default", ()=>$cc0b067a6f578757$export$2e2bcd8739ae039);
    var $8oLgk;
    var $djKly;
    var $bKGO7;
    const $cc0b067a6f578757$export$5c97c5d10d84e13c = new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).PRIVACY_VALUE_INPUT,
        values: {
            PUBLIC: {
                value: 'public'
            },
            COLLABORATOR: {
                value: 'collaborator'
            },
            PRIVATE: {
                value: 'private'
            }
        }
    });
    const $cc0b067a6f578757$export$5d92383dfb6e3588 = new (0, (0, parcelRequire("8oLgk")).GraphQLInputObjectType)({
        fields: {
            name: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            nickname: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            jobTitle: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            department: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            organization: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            location: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            zoneinfo: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            email: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            phoneNumber: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            picture: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            teamType: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).PRIVACY_SETTINGS_INPUT,
        description: 'User privacy settings values to be set'
    });
    const $cc0b067a6f578757$var$DefaultPrivacyValue = new (0, (0, parcelRequire("8oLgk")).GraphQLEnumType)({
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).PRIVACY_VALUE,
        values: {
            PUBLIC: {
                value: 'PUBLIC'
            },
            COLLABORATOR: {
                value: 'COLLABORATOR'
            },
            PRIVATE: {
                value: 'PRIVATE'
            }
        }
    });
    const $cc0b067a6f578757$export$8d71fec0dbffb7e5 = new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($cc0b067a6f578757$var$DefaultPrivacyValue);
    const $cc0b067a6f578757$var$UserManagePrivacySettings = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            id: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
            },
            name: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            nickname: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            jobTitle: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            department: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            organization: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            location: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            zoneinfo: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            email: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            phoneNumber: {
                type: $cc0b067a6f578757$var$DefaultPrivacyValue
            },
            picture: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            },
            teamType: {
                type: $cc0b067a6f578757$export$8d71fec0dbffb7e5
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).PRIVACY_SETTINGS,
        description: 'User privacy settings values'
    });
    var $cc0b067a6f578757$export$2e2bcd8739ae039 = $cc0b067a6f578757$var$UserManagePrivacySettings;
});
parcelRegister("jMc16", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7f56eeb68477d09$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $7tije;
    var $boBP5;
    var $dt3Ov;
    var $cG2YC;
    var $hGy7x;
    var $7DhMW;
    var $3yPZ5;
    var $4JhGG;
    var $hHTXo;
    var $8VejV;
    const $a7f56eeb68477d09$var$QueryRoot = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            UserOrganization: {
                type: (0, (0, parcelRequire("hHTXo")).default)
            },
            User: {
                type: (0, (0, parcelRequire("cG2YC")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            MyAvatar: {
                type: (0, (0, parcelRequire("7tije")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            UserManageConfig: {
                type: (0, (0, parcelRequire("hGy7x")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            UserManagePrivacySettings: {
                type: (0, (0, parcelRequire("3yPZ5")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            UserManagePrivacySettingsAllowed: {
                type: (0, (0, parcelRequire("4JhGG")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            UserManageLinkedAccounts: {
                type: (0, (0, parcelRequire("7DhMW")).default),
                args: {
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            TeamInSlack: {
                type: (0, (0, parcelRequire("boBP5")).default),
                args: {
                    teamId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    teamName: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            Containers: {
                type: (0, (0, parcelRequire("8VejV")).default),
                args: {
                    principalId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    siteId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    userId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    },
                    maxNumberOfResults: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLInt))
                    },
                    sessionId: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            },
            TeamLinkIcons: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)((0, (0, parcelRequire("dt3Ov")).default)),
                args: {
                    teamLinkUrls: {
                        type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)((0, (0, parcelRequire("djKly")).GraphQLString))
                    }
                }
            }
        },
        name: 'Query'
    });
    var $a7f56eeb68477d09$export$2e2bcd8739ae039 = $a7f56eeb68477d09$var$QueryRoot;
});
parcelRegister("7tije", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c23334a31a1a318$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $bKGO7;
    const $2c23334a31a1a318$var$MyAvatar = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            url: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            uploaded: {
                type: (0, (0, parcelRequire("djKly")).GraphQLBoolean)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).MY_AVATAR,
        description: "Get meta-data about current user\u2019s avatar"
    });
    var $2c23334a31a1a318$export$2e2bcd8739ae039 = $2c23334a31a1a318$var$MyAvatar;
});
parcelRegister("dt3Ov", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d61a58654b7474f$export$2e2bcd8739ae039);
    var $8oLgk;
    var $djKly;
    var $bKGO7;
    const $0d61a58654b7474f$var$TeamLinkIcon = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            linkUrl: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            iconUrl: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            productName: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).TEAM_LINK_ICON,
        description: 'Icon URL to use for a link'
    });
    var $0d61a58654b7474f$export$2e2bcd8739ae039 = $0d61a58654b7474f$var$TeamLinkIcon;
});
parcelRegister("hGy7x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f9c4b860995dc5$export$2e2bcd8739ae039);
    var $8oLgk;
    var $djKly;
    var $bKGO7;
    const $b3f9c4b860995dc5$var$MutabilityConstraints = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            field: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            reason: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER_DETAILS_MUTABILITY_CONSTRAINTS
    });
    const $b3f9c4b860995dc5$var$UserManageConfig = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            mutabilityConstraints: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLList)($b3f9c4b860995dc5$var$MutabilityConstraints)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER_MANAGE_CONFIG,
        description: 'User mutability constraints values'
    });
    var $b3f9c4b860995dc5$export$2e2bcd8739ae039 = $b3f9c4b860995dc5$var$UserManageConfig;
});
parcelRegister("7DhMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc785fe321e36b91$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $bKGO7;
    const $bc785fe321e36b91$var$LinkedAccounts = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            google: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean))
            },
            microsoft: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean))
            },
            apple: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean))
            },
            saml: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLBoolean))
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER_MANAGE_LINKED_ACCOUNTS
    });
    var $bc785fe321e36b91$export$2e2bcd8739ae039 = $bc785fe321e36b91$var$LinkedAccounts;
});
parcelRegister("4JhGG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57d90ca9e23b6c61$export$2e2bcd8739ae039);
    var $8oLgk;
    var $bKGO7;
    var $3yPZ5;
    const $57d90ca9e23b6c61$var$AllowedPrivacyValue = new (0, (0, parcelRequire("8oLgk")).GraphQLList)((0, (0, parcelRequire("3yPZ5")).PrivacyValue));
    const $57d90ca9e23b6c61$var$UserManagePrivacySettingsAllowed = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            name: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            nickname: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            jobTitle: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            department: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            organization: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            location: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            zoneinfo: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            email: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            phoneNumber: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            picture: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            },
            teamType: {
                type: $57d90ca9e23b6c61$var$AllowedPrivacyValue
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).PRIVACY_VALUES_CONFIG,
        description: 'User privacy settings allowed values'
    });
    var $57d90ca9e23b6c61$export$2e2bcd8739ae039 = $57d90ca9e23b6c61$var$UserManagePrivacySettingsAllowed;
});
parcelRegister("hHTXo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbc097356de12be2$export$2e2bcd8739ae039);
    var $8oLgk;
    var $djKly;
    var $bKGO7;
    const $bbc097356de12be2$var$UserPlace = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            cloudId: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            name: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).USER_ORGANIZATION,
        description: 'Organization a user belongs to'
    });
    var $bbc097356de12be2$export$2e2bcd8739ae039 = $bbc097356de12be2$var$UserPlace;
});
parcelRegister("8VejV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff4f8b096cd43a63$export$2e2bcd8739ae039);
    var $djKly;
    var $8oLgk;
    var $bKGO7;
    const $ff4f8b096cd43a63$var$ContainerDetails = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            id: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
            },
            key: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            name: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            url: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            },
            iconUrl: {
                type: (0, (0, parcelRequire("djKly")).GraphQLString)
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).CONTAINER_DETAILS
    });
    const $ff4f8b096cd43a63$var$Container = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            id: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
            },
            entityType: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
            },
            containerType: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLString))
            },
            score: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)((0, (0, parcelRequire("djKly")).GraphQLFloat))
            },
            containerDetails: {
                type: $ff4f8b096cd43a63$var$ContainerDetails
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).CONTAINER
    });
    const $ff4f8b096cd43a63$var$Containers = new (0, (0, parcelRequire("8oLgk")).GraphQLObjectType)({
        fields: {
            collaborationGraphEntities: {
                type: new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)(new (0, (0, parcelRequire("8oLgk")).GraphQLList)(new (0, (0, parcelRequire("8oLgk")).GraphQLNonNull)($ff4f8b096cd43a63$var$Container)))
            }
        },
        name: (0, (0, parcelRequire("bKGO7")).TypeNames).CONTAINERS,
        description: 'A list of Places Spaces/Projects'
    });
    var $ff4f8b096cd43a63$export$2e2bcd8739ae039 = $ff4f8b096cd43a63$var$Containers;
});
parcelRegister("f5deG", function(module, exports) {
    $parcel$export(module.exports, "withDefaultExponentialBackoff", ()=>$fe882ca8e63df7d3$export$455df4c93665fa4a);
    const $fe882ca8e63df7d3$export$8f4286bf21155381 = {
        INITIAL_DELAY: 200,
        MAX_RETRIES: 5,
        JITTER: true
    };
    function $fe882ca8e63df7d3$export$55b2fbd5d4a32495(status) {
        return 500 <= status && status <= 599;
    }
    const $fe882ca8e63df7d3$var$defaultRetryIfCallback = (a)=>!a;
    const $fe882ca8e63df7d3$var$defaultOptions = {
        initial: 200,
        jitter: false,
        max: 5,
        retryIf: $fe882ca8e63df7d3$var$defaultRetryIfCallback
    };
    function $fe882ca8e63df7d3$export$20eaa22f2295996f(toTry, hofOptions = $fe882ca8e63df7d3$var$defaultOptions) {
        const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
        let attemptsRemaining = max;
        let delay = initial;
        return async function tryWithExponentialBackoff(...args) {
            const result = await toTry(...args);
            --attemptsRemaining;
            if (retryIf && retryIf(result) && attemptsRemaining > 0) {
                await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
                delay *= 2;
                return tryWithExponentialBackoff(...args);
            }
            return result;
        };
    }
    function $fe882ca8e63df7d3$export$455df4c93665fa4a(fetchOp) {
        return $fe882ca8e63df7d3$export$20eaa22f2295996f(fetchOp, {
            initial: $fe882ca8e63df7d3$export$8f4286bf21155381.INITIAL_DELAY,
            jitter: $fe882ca8e63df7d3$export$8f4286bf21155381.JITTER,
            max: $fe882ca8e63df7d3$export$8f4286bf21155381.MAX_RETRIES,
            retryIf: (response)=>$fe882ca8e63df7d3$export$55b2fbd5d4a32495(response.status)
        });
    }
});
parcelRegister("8gRFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b3e4dbc7b87f932$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsgq;
    var $bSOOm;
    var $gWLfS;
    var $hp0Uy;
    var $cIr29;
    var $03Q1P;
    var $c5gm9;
    var $5WmsO;
    var $4ArtL;
    var $gaG9X;
    var $hNjFi;
    var $6laLp;
    var $jCvwN;
    var $it4ti;
    var $fNJQT;
    var $bmfV0;
    var $b8wBX;
    var $3UaSs;
    var $bCUYQ;
    function $3b3e4dbc7b87f932$export$2e2bcd8739ae039(props) {
        const { appName: appName, analytics: analytics, apolloClient: apolloClient, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled } = props;
        const [, { setCloudId: setCloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const [, { setOrgId: setOrgId }] = (0, (0, parcelRequire("c5gm9")).useOrg)();
        const [, { initTeamCentral: initTeamCentral }] = (0, (0, parcelRequire("4ArtL")).useTeamCentralStoreApi)();
        const { isJiraAvailable: isJiraAvailable } = (0, (0, parcelRequire("gaG9X")).useJiraCheckService)(cloudId);
        const expTracker = analytics.expTracker();
        const analyticsClient = analytics.getAnalyticsWebClient();
        (0, $5uXOq.useEffect)(()=>{
            if (orgId) analyticsClient?.setOrgInfo(orgId);
        }, [
            analyticsClient,
            orgId
        ]);
        const appConfig = (0, $5uXOq.useMemo)(()=>({
                env: env,
                appName: appName,
                contextSpaPaths: contextSpaPaths,
                contextEntryPoint: contextEntryPoint,
                push: push,
                replace: replace,
                addFlag: addFlag,
                locale: locale,
                docTitle: docTitle,
                cloudId: cloudId,
                orgId: orgId,
                productFeatureFlags: productFeatureFlags,
                stargateRoot: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot,
                isJiraAvailable: isJiraAvailable,
                isAIEnabled: isAIEnabled
            }), [
            env,
            appName,
            contextSpaPaths,
            contextEntryPoint,
            isJiraAvailable,
            push,
            replace,
            addFlag,
            locale,
            docTitle,
            cloudId,
            orgId,
            productFeatureFlags,
            isAIEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (statusCodeHandlers) (0, (0, parcelRequire("03Q1P")).statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
        }, [
            statusCodeHandlers
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setCloudId(cloudId);
        }, [
            cloudId,
            setCloudId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setOrgId(orgId);
        }, [
            orgId,
            setOrgId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            initTeamCentral(appName, cloudId, teamCentralHandlers);
        }, [
            appName,
            cloudId,
            teamCentralHandlers,
            initTeamCentral
        ]);
        const handleTransition = (0, $5uXOq.useCallback)((pathname)=>{
            if (expTracker) expTracker.abort({
                reason: 'Route changes.'
            });
            (0, (0, parcelRequire("6laLp")).addBreadcrumb)(pathname);
        }, [
            expTracker
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIr29")).default), {
            messagesConfig: (0, (0, parcelRequire("it4ti")).default),
            skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
            locale: locale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b8wBX")).default), {
            analytics: analytics,
            appName: appName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hNjFi")).TeamsWrapper), {
            appConfig: appConfig
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bmfV0")).default), {
            env: env,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            docTitle: docTitle,
            appName: appName,
            addFlag: addFlag,
            push: push,
            locale: locale,
            replace: replace,
            history: history,
            cloudId: cloudId,
            orgId: orgId,
            isJiraAvailable: isJiraAvailable,
            teamCentralHandlers: teamCentralHandlers,
            productFeatureFlags: productFeatureFlags,
            invitePeopleHandlers: invitePeopleHandlers,
            isAIEnabled: isAIEnabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gWLfS")).default), {
            analytics: analytics
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext).Provider, {
            value: analytics.expTracker()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("3UaSs")).RelativeWrapperOfHeaderImage, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
            client: apolloClient
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hp0Uy")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bCUYQ")).default), {
            appName: appName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNJQT")).default), {
            contextEntryPoint: contextEntryPoint,
            history: history,
            onTransition: handleTransition
        })))))))))));
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("gWLfS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ace605a0fda56a58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7vgP9;
    class $ace605a0fda56a58$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7vgP9")).AnalyticsContext).Provider, {
                value: this.state
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                analytics: this.props.analytics
            };
        }
    }
});
parcelRegister("7vgP9", function(module, exports) {
    $parcel$export(module.exports, "defaultAnalyticsClient", ()=>$3737225ef4ce92db$export$7fa70eb12a96b7d1);
    $parcel$export(module.exports, "AnalyticsContext", ()=>$3737225ef4ce92db$export$83cd6c3eba7d8d9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $a2luh;
    const $3737225ef4ce92db$var$defaultAnalyticsMethod = ()=>{
        console.warn('No analytics client has been provided.');
        (0, (0, parcelRequire("a2luh")).logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
    };
    const $3737225ef4ce92db$export$7fa70eb12a96b7d1 = {
        getAnalyticsWebClient: ()=>{
            $3737225ef4ce92db$var$defaultAnalyticsMethod();
            return;
        },
        pushTrackEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
        pushScreenEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
        pushUIEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
        pushOperationalEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
        startUIViewedEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
        expTracker: ()=>{
            throw new Error('No analytics client has been provided');
        },
        setTeamId: ()=>{
            throw new Error('No analytics client has been provided');
        }
    };
    const $3737225ef4ce92db$var$AnalyticsContextState = {
        analytics: $3737225ef4ce92db$export$7fa70eb12a96b7d1
    };
    const $3737225ef4ce92db$export$83cd6c3eba7d8d9e = (0, ($parcel$interopDefault($5uXOq))).createContext($3737225ef4ce92db$var$AnalyticsContextState);
});
parcelRegister("hp0Uy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$608b62e0f12beeea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5v4Ut;
    var $jEb7N;
    const $608b62e0f12beeea$var$initialStates = {
        DialogComponent: null,
        dialogProps: null,
        isOpen: false
    };
    function $608b62e0f12beeea$var$dialogReducer(state, action) {
        switch(action.type){
            case 'open':
                return {
                    ...state,
                    DialogComponent: action.payload?.DialogComponent || null,
                    dialogProps: action.payload?.dialogProps || null,
                    isOpen: true
                };
            case 'close':
                return {
                    ...state,
                    DialogComponent: null,
                    dialogProps: null,
                    isOpen: false
                };
            default:
                throw new Error();
        }
    }
    function $608b62e0f12beeea$export$2e2bcd8739ae039(props) {
        const { children: children } = props;
        const [stateDialogProvider, dispatch] = (0, $5uXOq.useReducer)($608b62e0f12beeea$var$dialogReducer, $608b62e0f12beeea$var$initialStates);
        const valueProvider = (0, $5uXOq.useMemo)(()=>({
                openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                        type: 'open',
                        payload: {
                            DialogComponent: DialogComponent,
                            dialogProps: dialogProps
                        }
                    }),
                closeDialog: ()=>dispatch({
                        type: 'close'
                    })
            }), []);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jEb7N")).DialogsContext).Provider, {
            value: valueProvider
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5v4Ut")).default), stateDialogProvider)));
    }
});
parcelRegister("5v4Ut", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7bcdd061a77cbb4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $jEb7N;
    function $f7bcdd061a77cbb4$export$2e2bcd8739ae039(props) {
        const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
        const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, (0, parcelRequire("jEb7N")).DialogsContext));
        if (!DialogComponent) return null;
        const handleCloseDialog = ()=>{
            closeDialog();
            if (onClose) onClose();
            if (dialogProps?.onClose) dialogProps.onClose();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement(DialogComponent, {
            ...dialogProps,
            onClose: handleCloseDialog
        }));
    }
});
parcelRegister("jEb7N", function(module, exports) {
    $parcel$export(module.exports, "DialogsContext", ()=>$2f7aa3668b03ace3$export$412f7f691e39b0da);
    var $5uXOq = parcelRequire("5uXOq");
    const $2f7aa3668b03ace3$var$dialogsContextState = {
        openDialog: ()=>null,
        closeDialog: ()=>null
    };
    const $2f7aa3668b03ace3$export$412f7f691e39b0da = (0, ($parcel$interopDefault($5uXOq))).createContext($2f7aa3668b03ace3$var$dialogsContextState);
});
parcelRegister("cIr29", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$939256824ae02946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $a2luh;
    var $71zQI;
    const $939256824ae02946$var$NO_MESSAGES = {};
    class $939256824ae02946$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        componentDidMount() {
            if (this.props.skip !== true) this.loadData();
        }
        async loadData() {
            const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
            const locale = await (0, (0, parcelRequire("71zQI")).getEffectiveLocale)(predefinedLocale);
            if (locale === (0, (0, parcelRequire("71zQI")).DEFAULT_LOCALE)) {
                this.setState({
                    locale: (0, (0, parcelRequire("71zQI")).DEFAULT_LOCALE),
                    messages: {}
                });
                return;
            }
            try {
                const messages = await (0, (0, parcelRequire("71zQI")).loadIntlData)(messagesConfig, locale);
                this.setState({
                    locale: locale,
                    messages: messages || $939256824ae02946$var$NO_MESSAGES
                });
            } catch (error) {
                (0, (0, parcelRequire("a2luh")).logException)(error, 'Error loading translations.', {
                    locale: locale
                });
                this.setState({
                    locale: (0, (0, parcelRequire("71zQI")).DEFAULT_LOCALE),
                    messages: $939256824ae02946$var$NO_MESSAGES
                });
            }
        }
        render() {
            const { skip: skip } = this.props;
            if (skip) return this.props.children;
            const { locale: locale, messages: messages } = this.state;
            if (!messages) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                key: `intl-provider-5-${locale}`,
                "data-test-language": locale,
                locale: locale,
                defaultLocale: (0, (0, parcelRequire("71zQI")).DEFAULT_LOCALE),
                messages: messages
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                locale: (0, (0, parcelRequire("71zQI")).DEFAULT_LOCALE),
                messages: undefined
            };
        }
    }
});
parcelRegister("71zQI", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$3675bcd7e4fae498$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "getEffectiveLocale", ()=>$3675bcd7e4fae498$export$5211f28df9ef284a);
    $parcel$export(module.exports, "loadIntlData", ()=>$3675bcd7e4fae498$export$d225990554fb28f7);
    var $8mCW3 = parcelRequire("8mCW3");
    var $dyczo = parcelRequire("dyczo");
    var $ctZPp;
    const $3675bcd7e4fae498$export$1af4c7e47ad72f44 = 'en';
    const $3675bcd7e4fae498$export$b6a046f0eef1bb2 = [
        'cs',
        'cs-CZ',
        'da',
        'da-DK',
        'de',
        'de-DE',
        'en',
        'en-GB',
        'en-US',
        'en-ZZ',
        'es',
        'es-ES',
        'et',
        'et-EE',
        'fi',
        'fi-FI',
        'fr',
        'fr-FR',
        'hu',
        'hu-HU',
        'is',
        'is-IS',
        'it',
        'it-IT',
        'ja',
        'ja-JP',
        'ko',
        'ko-KR',
        'nb',
        'nb-NO',
        'nl',
        'nl-NL',
        'pl',
        'pl-PL',
        'pt',
        'pt-BR',
        'pt-PT',
        'ro',
        'ro-RO',
        'ru',
        'ru-RU',
        'sk',
        'sk-SK',
        'sv',
        'sv-SE',
        'tr',
        'tr-TR',
        'th',
        'th-TH',
        'uk',
        'uk-UA',
        'vi',
        'vi-VN',
        'zh',
        'zh-TW',
        'zh-HK',
        'zh-ZH',
        'zh-CN'
    ];
    const $3675bcd7e4fae498$var$getLocaleFromUrl = ()=>{
        const { locale: locale } = (0, ($parcel$interopDefault($8mCW3))).parse((0, ($parcel$interopDefault($dyczo))).location.search);
        const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
        return localeFromUrl;
    };
    function $3675bcd7e4fae498$var$getSupportedLocale(locale) {
        if (typeof locale !== 'string') return null;
        locale = locale.replace('_', '-');
        if ($3675bcd7e4fae498$export$b6a046f0eef1bb2.includes(locale)) return locale;
        const languageCode = locale.substring(0, 2);
        if ($3675bcd7e4fae498$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
    }
    const $3675bcd7e4fae498$export$5211f28df9ef284a = async (predefinedLocale)=>{
        const receivedLocale = $3675bcd7e4fae498$var$getSupportedLocale(predefinedLocale);
        if (receivedLocale) return receivedLocale;
        const localeInUrl = $3675bcd7e4fae498$var$getSupportedLocale($3675bcd7e4fae498$var$getLocaleFromUrl());
        if (localeInUrl) return localeInUrl;
        let userLocale;
        try {
            userLocale = (await (0, (0, parcelRequire("ctZPp")).userInfoProvider).get()).locale;
        } catch (e) {
            userLocale = $3675bcd7e4fae498$export$1af4c7e47ad72f44;
        }
        return $3675bcd7e4fae498$var$getSupportedLocale(userLocale) || $3675bcd7e4fae498$export$1af4c7e47ad72f44;
    };
    const $3675bcd7e4fae498$export$d225990554fb28f7 = (localesConfig, locale)=>{
        const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
        const loader = pickedConfig?.loader;
        if (!loader) return Promise.resolve(null);
        return new Promise((resolve, reject)=>{
            const rejectTimer = setTimeout(reject, 30000);
            loader().then((res)=>{
                clearTimeout(rejectTimer);
                resolve(res && res.default || res);
            });
        });
    };
});
parcelRegister("8mCW3", function(module, exports) {
    $parcel$export(module.exports, "extract", ()=>$616e948c9a94d77d$export$f9380c9a627682d3, (v)=>$616e948c9a94d77d$export$f9380c9a627682d3 = v);
    $parcel$export(module.exports, "parse", ()=>$616e948c9a94d77d$export$98e6a39c04603d36, (v)=>$616e948c9a94d77d$export$98e6a39c04603d36 = v);
    $parcel$export(module.exports, "stringify", ()=>$616e948c9a94d77d$export$fac44ee5b035f737, (v)=>$616e948c9a94d77d$export$fac44ee5b035f737 = v);
    $parcel$export(module.exports, "parseUrl", ()=>$616e948c9a94d77d$export$7a5253c0f62e0150, (v)=>$616e948c9a94d77d$export$7a5253c0f62e0150 = v);
    $parcel$export(module.exports, "stringifyUrl", ()=>$616e948c9a94d77d$export$a8c1621ea79325d3, (v)=>$616e948c9a94d77d$export$a8c1621ea79325d3 = v);
    $parcel$export(module.exports, "pick", ()=>$616e948c9a94d77d$export$357523c63a2253b9, (v)=>$616e948c9a94d77d$export$357523c63a2253b9 = v);
    $parcel$export(module.exports, "exclude", ()=>$616e948c9a94d77d$export$44c361b8ec72ef7f, (v)=>$616e948c9a94d77d$export$44c361b8ec72ef7f = v);
    var $616e948c9a94d77d$export$f9380c9a627682d3;
    var $616e948c9a94d77d$export$98e6a39c04603d36;
    var $616e948c9a94d77d$export$fac44ee5b035f737;
    var $616e948c9a94d77d$export$7a5253c0f62e0150;
    var $616e948c9a94d77d$export$a8c1621ea79325d3;
    var $616e948c9a94d77d$export$357523c63a2253b9;
    var $616e948c9a94d77d$export$44c361b8ec72ef7f;
    'use strict';
    var $hlggt = parcelRequire("hlggt");
    var $aCrRe = parcelRequire("aCrRe");
    var $gjKya = parcelRequire("gjKya");
    var $cNVkY = parcelRequire("cNVkY");
    const $616e948c9a94d77d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
    const $616e948c9a94d77d$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
    function $616e948c9a94d77d$var$encoderForArrayFormat(options) {
        switch(options.arrayFormat){
            case 'index':
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                '[',
                                index,
                                ']'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                '[',
                                $616e948c9a94d77d$var$encode(index, options),
                                ']=',
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'bracket':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                '[]'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                '[]=',
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'colon-list-separator':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                ':list='
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                ':list=',
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'comma':
            case 'separator':
            case 'bracket-separator':
                {
                    const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                            value = value === null ? '' : value;
                            if (result.length === 0) return [
                                [
                                    $616e948c9a94d77d$var$encode(key, options),
                                    keyValueSep,
                                    $616e948c9a94d77d$var$encode(value, options)
                                ].join('')
                            ];
                            return [
                                [
                                    result,
                                    $616e948c9a94d77d$var$encode(value, options)
                                ].join(options.arrayFormatSeparator)
                            ];
                        };
                }
            default:
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            $616e948c9a94d77d$var$encode(key, options)
                        ];
                        return [
                            ...result,
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                '=',
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join('')
                        ];
                    };
        }
    }
    function $616e948c9a94d77d$var$parserForArrayFormat(options) {
        let result;
        switch(options.arrayFormat){
            case 'index':
                return (key, value, accumulator)=>{
                    result = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) accumulator[key] = {};
                    accumulator[key][result[1]] = value;
                };
            case 'bracket':
                return (key, value, accumulator)=>{
                    result = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'colon-list-separator':
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'comma':
            case 'separator':
                return (key, value, accumulator)=>{
                    const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === 'string' && !isArray && $616e948c9a94d77d$var$decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? $616e948c9a94d77d$var$decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$616e948c9a94d77d$var$decode(item, options)) : value === null ? value : $616e948c9a94d77d$var$decode(value, options);
                    accumulator[key] = newValue;
                };
            case 'bracket-separator':
                return (key, value, accumulator)=>{
                    const isArray = /(\[\])$/.test(key);
                    key = key.replace(/\[\]$/, '');
                    if (!isArray) {
                        accumulator[key] = value ? $616e948c9a94d77d$var$decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$616e948c9a94d77d$var$decode(item, options));
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], arrayValue);
                };
            default:
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
        }
    }
    function $616e948c9a94d77d$var$validateArrayFormatSeparator(value) {
        if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
    }
    function $616e948c9a94d77d$var$encode(value, options) {
        if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
        return value;
    }
    function $616e948c9a94d77d$var$decode(value, options) {
        if (options.decode) return $aCrRe(value);
        return value;
    }
    function $616e948c9a94d77d$var$keysSorter(input) {
        if (Array.isArray(input)) return input.sort();
        if (typeof input === 'object') return $616e948c9a94d77d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
        return input;
    }
    function $616e948c9a94d77d$var$removeHash(input) {
        const hashStart = input.indexOf('#');
        if (hashStart !== -1) input = input.slice(0, hashStart);
        return input;
    }
    function $616e948c9a94d77d$var$getHash(url) {
        let hash = '';
        const hashStart = url.indexOf('#');
        if (hashStart !== -1) hash = url.slice(hashStart);
        return hash;
    }
    function $616e948c9a94d77d$var$extract(input) {
        input = $616e948c9a94d77d$var$removeHash(input);
        const queryStart = input.indexOf('?');
        if (queryStart === -1) return '';
        return input.slice(queryStart + 1);
    }
    function $616e948c9a94d77d$var$parseValue(value, options) {
        if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
        else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
        return value;
    }
    function $616e948c9a94d77d$var$parse(query, options) {
        options = Object.assign({
            decode: true,
            sort: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ',',
            parseNumbers: false,
            parseBooleans: false
        }, options);
        $616e948c9a94d77d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const formatter = $616e948c9a94d77d$var$parserForArrayFormat(options);
        const ret = Object.create(null);
        if (typeof query !== 'string') return ret;
        query = query.trim().replace(/^[?#&]/, '');
        if (!query) return ret;
        for (const param of query.split('&')){
            if (param === '') continue;
            let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
            value = value === undefined ? null : [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? value : $616e948c9a94d77d$var$decode(value, options);
            formatter($616e948c9a94d77d$var$decode(key, options), value, ret);
        }
        for (const key of Object.keys(ret)){
            const value = ret[key];
            if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $616e948c9a94d77d$var$parseValue(value[k], options);
            else ret[key] = $616e948c9a94d77d$var$parseValue(value, options);
        }
        if (options.sort === false) return ret;
        return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
            const value = ret[key];
            if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) result[key] = $616e948c9a94d77d$var$keysSorter(value);
            else result[key] = value;
            return result;
        }, Object.create(null));
    }
    $616e948c9a94d77d$export$f9380c9a627682d3 = $616e948c9a94d77d$var$extract;
    $616e948c9a94d77d$export$98e6a39c04603d36 = $616e948c9a94d77d$var$parse;
    $616e948c9a94d77d$export$fac44ee5b035f737 = (object, options)=>{
        if (!object) return '';
        options = Object.assign({
            encode: true,
            strict: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ','
        }, options);
        $616e948c9a94d77d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const shouldFilter = (key)=>options.skipNull && $616e948c9a94d77d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
        const formatter = $616e948c9a94d77d$var$encoderForArrayFormat(options);
        const objectCopy = {};
        for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
        const keys = Object.keys(objectCopy);
        if (options.sort !== false) keys.sort(options.sort);
        return keys.map((key)=>{
            const value = object[key];
            if (value === undefined) return '';
            if (value === null) return $616e948c9a94d77d$var$encode(key, options);
            if (Array.isArray(value)) {
                if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $616e948c9a94d77d$var$encode(key, options) + '[]';
                return value.reduce(formatter(key), []).join('&');
            }
            return $616e948c9a94d77d$var$encode(key, options) + '=' + $616e948c9a94d77d$var$encode(value, options);
        }).filter((x)=>x.length > 0).join('&');
    };
    $616e948c9a94d77d$export$7a5253c0f62e0150 = (url, options)=>{
        options = Object.assign({
            decode: true
        }, options);
        const [url_, hash] = $gjKya(url, '#');
        return Object.assign({
            url: url_.split('?')[0] || '',
            query: $616e948c9a94d77d$var$parse($616e948c9a94d77d$var$extract(url), options)
        }, options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $616e948c9a94d77d$var$decode(hash, options)
        } : {});
    };
    $616e948c9a94d77d$export$a8c1621ea79325d3 = (object, options)=>{
        options = Object.assign({
            encode: true,
            strict: true,
            [$616e948c9a94d77d$var$encodeFragmentIdentifier]: true
        }, options);
        const url = $616e948c9a94d77d$var$removeHash(object.url).split('?')[0] || '';
        const queryFromUrl = $616e948c9a94d77d$export$f9380c9a627682d3(object.url);
        const parsedQueryFromUrl = $616e948c9a94d77d$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        });
        const query = Object.assign(parsedQueryFromUrl, object.query);
        let queryString = $616e948c9a94d77d$export$fac44ee5b035f737(query, options);
        if (queryString) queryString = `?${queryString}`;
        let hash = $616e948c9a94d77d$var$getHash(object.url);
        if (object.fragmentIdentifier) hash = `#${options[$616e948c9a94d77d$var$encodeFragmentIdentifier] ? $616e948c9a94d77d$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
        return `${url}${queryString}${hash}`;
    };
    $616e948c9a94d77d$export$357523c63a2253b9 = (input, filter, options)=>{
        options = Object.assign({
            parseFragmentIdentifier: true,
            [$616e948c9a94d77d$var$encodeFragmentIdentifier]: false
        }, options);
        const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $616e948c9a94d77d$export$7a5253c0f62e0150(input, options);
        return $616e948c9a94d77d$export$a8c1621ea79325d3({
            url: url,
            query: $cNVkY(query, filter),
            fragmentIdentifier: fragmentIdentifier
        }, options);
    };
    $616e948c9a94d77d$export$44c361b8ec72ef7f = (input, filter, options)=>{
        const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
        return $616e948c9a94d77d$export$357523c63a2253b9(input, exclusionFilter, options);
    };
});
parcelRegister("ctZPp", function(module, exports) {
    $parcel$export(module.exports, "userInfoProvider", ()=>$873f8fc415d06144$export$30a852ca4cb27370);
    var $jCvwN;
    class $873f8fc415d06144$var$FetchError extends Error {
        constructor(response){
            super(`Request failed with status ${response.status}`);
            this.response = response;
            this.name = this.constructor.name;
        }
    }
    class $873f8fc415d06144$export$dc10e400a1189789 {
        get(fetchOp = fetch) {
            if (this.promise) return this.promise;
            const getJson = (url)=>fetchOp(url, {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response)=>{
                    if (!response.ok) throw new $873f8fc415d06144$var$FetchError(response);
                    return response.json();
                });
            this.promise = getJson(`${(0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot}/me`).then((me)=>{
                return {
                    userId: me.account_id,
                    locale: me.locale,
                    fullName: me.name,
                    avatarUrl: me.picture,
                    email: me.email,
                    title: me.extended_profile?.job_title
                };
            });
            return this.promise;
        }
    }
    const $873f8fc415d06144$export$30a852ca4cb27370 = new $873f8fc415d06144$export$dc10e400a1189789();
});
parcelRegister("03Q1P", function(module, exports) {
    $parcel$export(module.exports, "statusCodeHandlersProvider", ()=>$4ac67c876d5328b4$export$8c005e458e12d501);
    $parcel$export(module.exports, "handleResponse", ()=>$4ac67c876d5328b4$export$c113a67a6762ad2e);
    const $4ac67c876d5328b4$export$8c005e458e12d501 = {
        handlers: {},
        get () {
            return $4ac67c876d5328b4$export$8c005e458e12d501.handlers;
        },
        setHandlers (handlers) {
            $4ac67c876d5328b4$export$8c005e458e12d501.handlers = handlers;
        }
    };
    function $4ac67c876d5328b4$export$c113a67a6762ad2e(response) {
        const { status: status } = response;
        const handler = $4ac67c876d5328b4$export$8c005e458e12d501.get()[status];
        if (typeof handler === 'function') handler(response);
    }
});
parcelRegister("c5gm9", function(module, exports) {
    $parcel$export(module.exports, "useOrg", ()=>$11a92b2a8aefe8e7$export$7f785727a26e156);
    var $3sQ5x;
    var $woaYX;
    const $11a92b2a8aefe8e7$export$7f785727a26e156 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("woaYX")).Store));
});
parcelRegister("woaYX", function(module, exports) {
    $parcel$export(module.exports, "Store", ()=>$07b7dde0a7e966ee$export$390f32400eaf98c9);
    var $iXqE5;
    const $07b7dde0a7e966ee$var$actions = {
        setOrgId: (orgId)=>({ setState: setState })=>{
                setState({
                    orgId: orgId
                });
            }
    };
    const $07b7dde0a7e966ee$var$initialState = {
        orgId: undefined
    };
    const $07b7dde0a7e966ee$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $07b7dde0a7e966ee$var$initialState,
        actions: $07b7dde0a7e966ee$var$actions,
        name: 'Org'
    });
});
parcelRegister("5WmsO", function(module, exports) {
    $parcel$export(module.exports, "useSite", ()=>$2334f40708093356$export$7870fa8e7cdd59f8);
    $parcel$export(module.exports, "useCloudId", ()=>$2334f40708093356$export$9da0f7c65f28ed16);
    var $3sQ5x;
    var $9X1pV;
    const $2334f40708093356$export$7870fa8e7cdd59f8 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("9X1pV")).Store));
    const $2334f40708093356$export$9da0f7c65f28ed16 = ()=>$2334f40708093356$export$7870fa8e7cdd59f8()[0].cloudId;
});
parcelRegister("9X1pV", function(module, exports) {
    $parcel$export(module.exports, "Store", ()=>$2c6a7fe3c9c74788$export$390f32400eaf98c9);
    var $iXqE5;
    const $2c6a7fe3c9c74788$var$actions = {
        setCloudId: (cloudId)=>({ setState: setState })=>{
                setState({
                    cloudId: cloudId
                });
            }
    };
    const $2c6a7fe3c9c74788$var$initialState = {
        cloudId: ''
    };
    const $2c6a7fe3c9c74788$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2c6a7fe3c9c74788$var$initialState,
        actions: $2c6a7fe3c9c74788$var$actions,
        name: 'Site'
    });
});
parcelRegister("4ArtL", function(module, exports) {
    $parcel$export(module.exports, "useTeamCentralStore", ()=>$ed1928058adb05a8$export$39314e672c06693f);
    $parcel$export(module.exports, "useTeamCentralStoreApi", ()=>$ed1928058adb05a8$export$7c58a39ba496932b);
    $parcel$export(module.exports, "useIsTeamCentral", ()=>$ed1928058adb05a8$export$9da989c55553d02d);
    $parcel$export(module.exports, "useTeamCentralPresent", ()=>$ed1928058adb05a8$export$20f07b26e9a56b9);
    var $3sQ5x;
    var $iXqE5;
    var $kTK0a;
    var $VSDnB;
    var $jCvwN;
    var $65HPA;
    const $ed1928058adb05a8$var$initialState = {
        isTeamCentral: false,
        hasWorkspace: false,
        orgHasWorkspace: false,
        teamCentralHandlers: {},
        teamCentralUrl: undefined
    };
    const $ed1928058adb05a8$var$actions = {
        initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
                const isTeamCentral = appName === 'teamcentral-directory';
                let teamCentralUrlPromise;
                if ((0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) {
                    if ((0, (0, parcelRequire("jCvwN")).getConfig)().teamCentralDisabled === true) teamCentralUrlPromise = Promise.resolve(undefined);
                    else teamCentralUrlPromise = (0, (0, parcelRequire("65HPA")).default).isGlobalExperienceWorkspaceForCloudId(cloudId).then((isGlobalExperience)=>{
                        return isGlobalExperience ? (0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home') : (0, (0, parcelRequire("kTK0a")).getATLContextUrl)('team');
                    });
                } else teamCentralUrlPromise = Promise.resolve((0, (0, parcelRequire("jCvwN")).getConfig)().teamCentralUrl);
                if (isTeamCentral) teamCentralUrlPromise.then((teamCentralUrl)=>{
                    setState({
                        isTeamCentral: isTeamCentral,
                        hasWorkspace: true,
                        orgHasWorkspace: true,
                        teamCentralHandlers: teamCentralHandlers,
                        teamCentralUrl: teamCentralUrl
                    });
                });
                else {
                    const requests = [
                        (0, (0, parcelRequire("65HPA")).default).hasWorkspaceForCloudId(cloudId),
                        (0, (0, parcelRequire("65HPA")).default).doesOrgContainAnyWorkspace(cloudId),
                        teamCentralUrlPromise
                    ];
                    Promise.all(requests).then(([hasWorkspace, orgHasWorkspace, teamCentralUrl])=>{
                        setState({
                            isTeamCentral: false,
                            hasWorkspace: hasWorkspace,
                            orgHasWorkspace: orgHasWorkspace,
                            teamCentralHandlers: teamCentralHandlers,
                            teamCentralUrl: teamCentralUrl
                        });
                    });
                }
            }
    };
    const $ed1928058adb05a8$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $ed1928058adb05a8$var$initialState,
        actions: $ed1928058adb05a8$var$actions,
        name: 'SearchHomePage'
    });
    const $ed1928058adb05a8$export$39314e672c06693f = (0, (0, parcelRequire("3sQ5x")).createHook)($ed1928058adb05a8$var$Store);
    const $ed1928058adb05a8$export$7c58a39ba496932b = (0, (0, parcelRequire("3sQ5x")).createHook)($ed1928058adb05a8$var$Store, {
        selector: null
    });
    const $ed1928058adb05a8$export$9da989c55553d02d = (0, (0, parcelRequire("3sQ5x")).createHook)($ed1928058adb05a8$var$Store, {
        selector: (s)=>s.isTeamCentral
    });
    const $ed1928058adb05a8$export$20f07b26e9a56b9 = (0, (0, parcelRequire("3sQ5x")).createHook)($ed1928058adb05a8$var$Store, {
        selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
    });
});
parcelRegister("65HPA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11304638e828f937$export$2e2bcd8739ae039);
    var $VSDnB;
    var $jCvwN;
    var $csox3;
    class $11304638e828f937$export$424050aeba67e883 extends (0, (0, parcelRequire("csox3")).default) {
        constructor(){
            super({
                serviceUrl: (0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot
            });
        }
        async hasWorkspaceForCloudId(cloudId) {
            const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
            try {
                await this.getResource(`${maybeShardedPrefix}/workspace/exists?cloudId=${cloudId}`);
                return true;
            } catch (err) {
                return false;
            }
        }
        async doesOrgContainAnyWorkspace(cloudId) {
            const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
            try {
                await this.getResource(`${maybeShardedPrefix}/organization/containsAnyWorkspace?cloudId=${cloudId}`);
                return true;
            } catch (err) {
                return false;
            }
        }
        async isGlobalExperienceWorkspaceForCloudId(cloudId) {
            const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
            try {
                const res = await this.makeRequest(`${maybeShardedPrefix}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                    headers: {
                        Accept: 'text/plain'
                    }
                });
                return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
            } catch (err) {
                return Promise.resolve(false);
            }
        }
        buildMaybeShardedPrefix(cloudId) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return `/townsquare/s/${cloudId}`;
            else return '/watermelon';
        }
    }
    var $11304638e828f937$export$2e2bcd8739ae039 = new $11304638e828f937$export$424050aeba67e883();
});
parcelRegister("csox3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4dc819ac862569b6$export$2e2bcd8739ae039);
    var $1UikQ = parcelRequire("1UikQ");
    var $bxYf9 = parcelRequire("bxYf9");
    var $jjM7Z;
    var $4Y6oo;
    var $4BpOs;
    var $f5deG;
    var $03Q1P;
    const $4dc819ac862569b6$var$defaultFetchOptions = {
        credentials: 'include',
        headers: {
            Accept: 'application/json'
        },
        mode: 'cors'
    };
    const $4dc819ac862569b6$var$fetchWithExponentialBackoff = (0, (0, parcelRequire("f5deG")).withDefaultExponentialBackoff)(fetch);
    function $4dc819ac862569b6$var$parseResponse(response) {
        const responseStatusCode = response.status;
        if (responseStatusCode === 204 || responseStatusCode === 202) return null;
        const contentType = response.headers.get('content-type');
        if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
        if (contentType.includes('application/json')) return response.json();
        return null;
    }
    async function $4dc819ac862569b6$export$91c32f1b22d29b2d(response) {
        let json;
        const text = await response.text();
        try {
            json = JSON.parse(text);
        } catch (err) {
            return text;
        }
        delete json.timestamp;
        if (json.errors) {
            const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, (0, parcelRequire("4BpOs")).DirectoryErrorCode).MISSING_ERROR_MESSAGE);
            return errs.join('\n - ');
        }
        return JSON.stringify(json);
    }
    let $4dc819ac862569b6$var$incrementRedirectCount;
    let $4dc819ac862569b6$var$clearRedirectCount;
    $4dc819ac862569b6$export$7a0fc52d8c359feb();
    function $4dc819ac862569b6$export$7a0fc52d8c359feb() {
        $4dc819ac862569b6$var$incrementRedirectCount = (0, ($parcel$interopDefault($bxYf9)))(()=>(0, (0, parcelRequire("4Y6oo")).setCookie)((0, (0, parcelRequire("4Y6oo")).REDIRECT_COUNT), (0, (0, parcelRequire("4Y6oo")).getCookieAsInteger)((0, (0, parcelRequire("4Y6oo")).REDIRECT_COUNT)) + 1));
        $4dc819ac862569b6$var$clearRedirectCount = (0, ($parcel$interopDefault($bxYf9)))(()=>(0, (0, parcelRequire("4Y6oo")).clearCookie)((0, (0, parcelRequire("4Y6oo")).REDIRECT_COUNT)));
    }
    class $4dc819ac862569b6$var$RestClient {
        constructor({ serviceUrl: serviceUrl = '' } = {}){
            this.preventInfiniteRedirectLoop = (response)=>{
                if (!response.ok) {
                    const responseStatusCode = response.status;
                    if (responseStatusCode === 401) $4dc819ac862569b6$var$incrementRedirectCount();
                } else $4dc819ac862569b6$var$clearRedirectCount();
            };
            this.serviceUrl = serviceUrl;
        }
        async getResource(path) {
            return this.makeRequest(path);
        }
        async postResource(path, data, fetchOptions = {}) {
            return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
        }
        async postResourceRaw(path, data, fetchOptions = {}) {
            fetchOptions = {
                method: 'post',
                headers: {},
                ...fetchOptions
            };
            if (data) fetchOptions = {
                body: data,
                ...fetchOptions,
                headers: {
                    'Content-Type': 'application/json',
                    ...fetchOptions.headers
                }
            };
            return this.makeRequest(path, fetchOptions);
        }
        async patchResource(path, data) {
            let fetchOptions = {
                method: 'PATCH'
            };
            if (data) fetchOptions = {
                ...fetchOptions,
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return this.makeRequest(path, fetchOptions);
        }
        async putResource(path, data, additionalFetchOptions = {}) {
            const fetchOptions = {
                method: 'put'
            };
            if (data) Object.assign(fetchOptions, {
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return this.makeRequest(path, {
                ...fetchOptions,
                ...additionalFetchOptions
            });
        }
        async deleteResource(path, options = {}) {
            const fetchOptions = {
                ...options,
                method: 'delete'
            };
            return this.makeRequest(path, fetchOptions);
        }
        async makeRequest(path, additionalFetchOptions = {}) {
            const url = this.serviceUrl + path;
            const options = (0, ($parcel$interopDefault($1UikQ)))({}, $4dc819ac862569b6$var$defaultFetchOptions, additionalFetchOptions);
            const response = await $4dc819ac862569b6$var$fetchWithExponentialBackoff(url, options);
            this.preventInfiniteRedirectLoop(response);
            (0, (0, parcelRequire("03Q1P")).handleResponse)(response);
            const responseStatusCode = response.status;
            const traceId = response.headers.get('atl-traceid');
            if (!response.ok) {
                if (responseStatusCode === 401) throw new (0, (0, parcelRequire("jjM7Z")).SentryIgnoreError)({
                    message: 'Unauthorized Request - incrementing redirect count'
                });
                else {
                    const message = await $4dc819ac862569b6$export$91c32f1b22d29b2d(response);
                    throw new (0, (0, parcelRequire("jjM7Z")).HttpError)({
                        message: message,
                        status: responseStatusCode,
                        traceId: traceId ?? undefined
                    });
                }
            }
            return additionalFetchOptions.ignoreResponse ? null : $4dc819ac862569b6$var$parseResponse(response);
        }
    }
    var $4dc819ac862569b6$export$2e2bcd8739ae039 = $4dc819ac862569b6$var$RestClient;
});
parcelRegister("jjM7Z", function(module, exports) {
    $parcel$export(module.exports, "SentryIgnoreError", ()=>$0468019abd35294d$export$20de9a0e470e95aa);
    $parcel$export(module.exports, "HttpError", ()=>$0468019abd35294d$export$65bd6083489bd8bb);
    class $0468019abd35294d$var$CommonError extends Error {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            this.message = message;
            this.stack = new Error(message).stack || '';
        }
    }
    class $0468019abd35294d$export$c73ca302efeda3b4 extends $0468019abd35294d$var$CommonError {
        constructor({ message: message }){
            super(message || 'UnknownError');
            Object.setPrototypeOf(this, $0468019abd35294d$export$c73ca302efeda3b4.prototype);
        }
    }
    class $0468019abd35294d$export$20de9a0e470e95aa extends $0468019abd35294d$var$CommonError {
        constructor({ message: message }){
            super(`SentryIgnore: ${message || 'UnknownError'}`);
            Object.setPrototypeOf(this, $0468019abd35294d$export$20de9a0e470e95aa.prototype);
        }
    }
    class $0468019abd35294d$export$65bd6083489bd8bb extends $0468019abd35294d$var$CommonError {
        constructor({ message: message, status: status, traceId: traceId }){
            super(message);
            Object.setPrototypeOf(this, $0468019abd35294d$export$65bd6083489bd8bb.prototype);
            this.status = status;
            this.traceId = traceId;
        }
    }
    class $0468019abd35294d$export$92d6ed0888e7cb7f extends $0468019abd35294d$var$CommonError {
        constructor({ message: message, category: category = 'default', fields: fields }){
            super(message);
            Object.setPrototypeOf(this, $0468019abd35294d$export$92d6ed0888e7cb7f.prototype);
            this.category = category;
            if (fields) this.fields = fields;
        }
        static{
            this.from = (rawErrors)=>{
                const firstError = rawErrors[0];
                const errorData = {
                    category: firstError.category,
                    message: firstError.message
                };
                if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                    obj[item.field] = item.message;
                    return obj;
                }, {});
                return new $0468019abd35294d$export$92d6ed0888e7cb7f(errorData);
            };
        }
    }
});
parcelRegister("4Y6oo", function(module, exports) {
    $parcel$export(module.exports, "REDIRECT_COUNT", ()=>$a67eb8f909662980$export$f6101897f0230549);
    $parcel$export(module.exports, "setCookie", ()=>$a67eb8f909662980$export$110700823644f4a6);
    $parcel$export(module.exports, "getCookieAsInteger", ()=>$a67eb8f909662980$export$6a289e5003f59269);
    $parcel$export(module.exports, "clearCookie", ()=>$a67eb8f909662980$export$ad3506281d5a5e5d);
    const $a67eb8f909662980$export$f6101897f0230549 = 'redirectCount';
    const $a67eb8f909662980$export$5a7d8afb87170e45 = 'avatar.csrf.token';
    function $a67eb8f909662980$export$110700823644f4a6(key, value) {
        document.cookie = `${key}=${value};path=/;max-age=30`;
    }
    function $a67eb8f909662980$export$6a289e5003f59269(key, defaultValue = 0) {
        const regex = new RegExp(`${key}=(\\d+)`);
        const result = document.cookie.match(regex);
        return result ? parseInt(result[1], 10) : defaultValue;
    }
    function $a67eb8f909662980$export$ad3506281d5a5e5d(key) {
        document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
});
parcelRegister("gaG9X", function(module, exports) {
    $parcel$export(module.exports, "useJiraCheckService", ()=>$b67c9a626cb8466f$export$b998d6ed276aaffa);
    var $5uXOq = parcelRequire("5uXOq");
    var $k3Vai;
    var $dRejs;
    const $b67c9a626cb8466f$export$3847702755d66eb8 = (cloudId, options)=>{
        const [request, controller] = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("dRejs")).defaultRequestAbort)(cloudId), [
            cloudId
        ]);
        const [getJiraCheck, result] = (0, (0, parcelRequire("k3Vai")).useLazyService)(request, controller, {
            initialState: {
                ...options?.initialState
            }
        });
        return [
            getJiraCheck,
            {
                ...result,
                isJiraAvailable: Boolean(result.data?.permitted)
            }
        ];
    };
    const $b67c9a626cb8466f$export$b998d6ed276aaffa = (...[cloudId, options])=>{
        const [getJiraCheck, result] = $b67c9a626cb8466f$export$3847702755d66eb8(cloudId, options);
        (0, $5uXOq.useEffect)(()=>{
            if (cloudId) getJiraCheck();
        }, [
            cloudId,
            getJiraCheck
        ]);
        return result;
    };
});
parcelRegister("k3Vai", function(module, exports) {
    $parcel$export(module.exports, "useLazyService", ()=>$cdb6ee0683636986$export$1a85343b4dbf3bf5);
    $parcel$export(module.exports, "useService", ()=>$cdb6ee0683636986$export$6de4685a6c88b4e9);
    $parcel$export(module.exports, "useServiceLight", ()=>$cdb6ee0683636986$export$fb699d9076441ae7);
    var $5uXOq = parcelRequire("5uXOq");
    var $6L4IE;
    const $cdb6ee0683636986$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
        const [state, setState] = (0, $5uXOq.useState)({
            loading: false,
            error: undefined,
            data: undefined,
            ...options?.initialState
        });
        const getData = (0, $5uXOq.useCallback)(async ()=>{
            setState((s)=>({
                    ...s,
                    loading: true
                }));
            try {
                const response = await request();
                const traceId = response?.headers?.get('atl-traceid');
                let jsonResponse;
                let isResponseText = false;
                const resText = await response?.text() || '{}';
                try {
                    jsonResponse = JSON.parse(resText);
                } catch  {
                    isResponseText = true;
                }
                if (!response?.ok || isResponseText) {
                    if (options?.ErrorHandler) throw new options.ErrorHandler({
                        ...jsonResponse,
                        traceId: traceId,
                        status: response?.status,
                        statusText: response?.statusText || resText
                    });
                    else throw new (0, (0, parcelRequire("6L4IE")).HttpError)(response?.status, response?.statusText || resText, traceId);
                }
                setState((s)=>({
                        ...s,
                        loading: false,
                        data: jsonResponse
                    }));
                return response;
            } catch (error) {
                setState((s)=>({
                        ...s,
                        loading: false,
                        error: error
                    }));
            }
        }, [
            request,
            options?.ErrorHandler
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                controller.abort();
            };
        }, [
            controller
        ]);
        return [
            getData,
            state
        ];
    };
    const $cdb6ee0683636986$export$6de4685a6c88b4e9 = (...[request, controller, options])=>{
        const [getData, state] = $cdb6ee0683636986$export$1a85343b4dbf3bf5(request, controller, {
            ...options,
            initialState: {
                ...options?.initialState,
                loading: true
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            getData();
        }, [
            getData
        ]);
        return state;
    };
    const $cdb6ee0683636986$export$fb699d9076441ae7 = (request, initialState = {})=>{
        const [state, setStateRaw] = (0, $5uXOq.useState)({
            loading: false,
            ...initialState
        });
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        });
        const setState = (0, $5uXOq.useCallback)((state)=>{
            if (isMounted.current) setStateRaw(state);
        }, []);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request();
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
            } catch (error) {
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
            }
        }, [
            request,
            setState
        ]);
        return {
            ...state,
            fetchData: fetchData
        };
    };
});
parcelRegister("6L4IE", function(module, exports) {
    $parcel$export(module.exports, "requestWithAbort", ()=>$2e31c1e967db2964$export$970d18814fa0cb04);
    $parcel$export(module.exports, "HttpError", ()=>$2e31c1e967db2964$export$65bd6083489bd8bb);
    var $7qHT9;
    const $2e31c1e967db2964$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                ...options
            });
    const $2e31c1e967db2964$export$970d18814fa0cb04 = (url, options = {})=>{
        const controller = new (0, (0, parcelRequire("7qHT9")).AbortControllerFacade)();
        return [
            $2e31c1e967db2964$export$b5fe3f66a567bec0(url, {
                signal: controller.signal,
                ...options
            }),
            controller
        ];
    };
    class $2e31c1e967db2964$export$65bd6083489bd8bb extends Error {
        constructor(code, reason, traceId){
            super(reason);
            this.code = code;
            this.traceId = traceId;
        }
    }
});
parcelRegister("7qHT9", function(module, exports) {
    $parcel$export(module.exports, "AbortControllerFacade", ()=>$ccaa19bf10bf39e9$export$f5cffffa581a7d2c);
    class $ccaa19bf10bf39e9$var$AbortSignalFacade {
        constructor(){
            this.aborted = false;
            this.reason = '';
            this.onabort = ()=>{};
            this.throwIfAborted = ()=>{};
            this.addEventListener = ()=>{};
            this.removeEventListener = ()=>{};
            this.dispatchEvent = ()=>false;
        }
    }
    class $ccaa19bf10bf39e9$export$f5cffffa581a7d2c {
        abort() {}
        constructor(){
            this.signal = new $ccaa19bf10bf39e9$var$AbortSignalFacade();
            if (typeof window === 'object' && window.AbortController) {
                const controller = new AbortController();
                this.abort = controller.abort.bind(controller);
                this.signal = controller.signal;
            }
        }
    }
});
parcelRegister("dRejs", function(module, exports) {
    $parcel$export(module.exports, "defaultRequestAbort", ()=>$408d0402e79d4487$export$46f584bffbc74fe);
    var $6L4IE;
    const $408d0402e79d4487$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
    const $408d0402e79d4487$export$fcd6a587480f569c = (cloudId)=>({
            permissionId: 'write',
            resourceId: `ari:cloud:jira-software::site/${cloudId}`
        });
    const $408d0402e79d4487$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, (0, parcelRequire("6L4IE")).requestWithAbort)($408d0402e79d4487$export$5cf469f83bcf3f9e, {
            body: JSON.stringify($408d0402e79d4487$export$fcd6a587480f569c(cloudId))
        }) : [
            ()=>Promise.resolve(new Response()),
            new AbortController()
        ];
});
parcelRegister("hNjFi", function(module, exports) {
    $parcel$export(module.exports, "TeamsWrapper", ()=>$e875d248d53e26f2$export$7d5cea3023a4360c);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FH71;
    var $f0K80;
    var $3VSOD;
    var $lRyV6;
    var $8VfUC;
    var $ffeEQ;
    const $e875d248d53e26f2$var$IS_LOCAL = false;
    function $e875d248d53e26f2$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
        (0, (0, parcelRequire("3VSOD")).useTeamsSentryClientSetup)(!$e875d248d53e26f2$var$IS_LOCAL, {
            env: appConfig.env,
            appName: appConfig.appName ? `${appConfig.appName}` : undefined
        });
        (0, (0, parcelRequire("lRyV6")).useSetAppConfig)(appConfig);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8VfUC")).AppConfigProvider), appConfig, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffeEQ")).ProfileCardClientConfigProvider), appConfig, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FH71")).WrappedPeopleTeamsAnalyticsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f0K80")).DialogProvider), null, children))));
    }
});
parcelRegister("3FH71", function(module, exports) {
    $parcel$export(module.exports, "WrappedPeopleTeamsAnalyticsProvider", ()=>$26f504506e3b41ef$export$b73a44d03ba9da78);
    $parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", ()=>$26f504506e3b41ef$export$48acf7e27d4331f);
    $parcel$export(module.exports, "useTeamsExperienceTracker", ()=>$26f504506e3b41ef$export$5792e6ebc464482e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1PVpv = parcelRequire("1PVpv");
    var $8OWwQ;
    var $1URky;
    var $bwDHF;
    var $jsDzq;
    const $26f504506e3b41ef$var$defaultAnalyticsContextData = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    function $26f504506e3b41ef$export$b73a44d03ba9da78({ analyticsContextData: analyticsContextData, children: children }) {
        const data = (0, $5uXOq.useMemo)(()=>{
            if (typeof analyticsContextData === 'object') return {
                ...$26f504506e3b41ef$var$defaultAnalyticsContextData,
                ...analyticsContextData
            };
            return $26f504506e3b41ef$var$defaultAnalyticsContextData;
        }, [
            analyticsContextData
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.PeopleTeamsAnalyticsContext), {
            data: data
        }, children);
    }
    const $26f504506e3b41ef$export$48acf7e27d4331f = ()=>{
        const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, (0, parcelRequire("8OWwQ")).usePeopleTeamsAnalyticsSubcontext)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("bwDHF")).useAnalyticsEvents)();
        const fireEventWithSubcontextAttributesInjected = (0, $5uXOq.useCallback)((...params)=>{
            const [event, attributes] = params;
            const eventWithSubcontextAttributes = {
                ...attributes,
                ...injectedEventAttributes
            };
            fireEvent(event, eventWithSubcontextAttributes);
        }, [
            fireEvent,
            injectedEventAttributes
        ]);
        return {
            fireEvent: fireEventWithSubcontextAttributesInjected,
            setInjectedEventAttributes: setEventAttributes
        };
    };
    const $26f504506e3b41ef$export$b72f2eb2a11f7b8 = ()=>(0, (0, parcelRequire("jsDzq")).useAnalyticsEventsWithTags)();
    const $26f504506e3b41ef$export$5792e6ebc464482e = ()=>{
        const { fireEvent: fireEvent } = $26f504506e3b41ef$export$48acf7e27d4331f();
        const fireExperienceEvent = (0, $5uXOq.useCallback)((action, subject, attributes)=>{
            fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
                ...attributes,
                source: 'clientMetrics'
            });
        }, [
            fireEvent
        ]);
        const experienceTracker = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1URky")).createTeamsExperienceTracker)(fireExperienceEvent), [
            fireExperienceEvent
        ]);
        return experienceTracker;
    };
});
parcelRegister("8OWwQ", function(module, exports) {
    $parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", ()=>$b8ad165f1200bcd3$export$86448e866930ba8d);
    $parcel$export(module.exports, "useInjectedEventAttribute", ()=>$b8ad165f1200bcd3$export$831917a198e22e70);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    const $b8ad165f1200bcd3$var$initialState = {
        eventAttributes: {}
    };
    const $b8ad165f1200bcd3$var$actions = {
        setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
                const existingEventAttributes = getState().eventAttributes;
                const newEventAttributes = {
                    ...existingEventAttributes,
                    ...eventAttributes
                };
                Object.keys(newEventAttributes).forEach((keyString)=>{
                    const key = keyString;
                    if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
                });
                setState({
                    eventAttributes: newEventAttributes
                });
            }
    };
    const $b8ad165f1200bcd3$var$AnalyticsSubcontextStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $b8ad165f1200bcd3$var$initialState,
        actions: $b8ad165f1200bcd3$var$actions
    });
    const $b8ad165f1200bcd3$export$86448e866930ba8d = (0, (0, parcelRequire("3sQ5x")).createHook)($b8ad165f1200bcd3$var$AnalyticsSubcontextStore);
    const $b8ad165f1200bcd3$export$831917a198e22e70 = (key, value)=>{
        const { setEventAttributes: setEventAttributes } = $b8ad165f1200bcd3$export$86448e866930ba8d()[1];
        (0, $5uXOq.useEffect)(()=>{
            setEventAttributes({
                [key]: value
            });
            return ()=>setEventAttributes({
                    [key]: undefined
                });
        }, [
            key,
            value,
            setEventAttributes
        ]);
    };
});
parcelRegister("1URky", function(module, exports) {
    $parcel$export(module.exports, "createTeamsExperienceTracker", ()=>$f8ce0cd94612cc89$export$c0c885a04612b38d);
    var $cBeZP;
    var $7i7RM;
    var $hnAwz;
    function $f8ce0cd94612cc89$export$c0c885a04612b38d(fireExperienceEvent, options) {
        const tracker = new (0, (0, parcelRequire("7i7RM")).TeamsExperienceTracker)({
            isNetworkOfflineError: (0, (0, parcelRequire("hnAwz")).isNetworkError)
        });
        tracker.subscribe((event)=>{
            if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
                const performanceAttributes = (0, (0, parcelRequire("hnAwz")).computePerformanceAttributes)(event);
                const errorAttributes = (0, (0, parcelRequire("hnAwz")).computeErrorAttributes)(event);
                const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                    isStandalone: !!options?.isStandalone,
                    hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
                });
                fireExperienceEvent(event.action, event.name, finalErrorDetails);
                if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
            }
        });
        (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'unload',
                listener: ()=>tracker.abort({
                        reason: 'Abort due to Window unloading',
                        attributes: {
                            cause: 'WINDOW_UNLOAD'
                        }
                    })
            },
            {
                type: 'pagehide',
                listener: ()=>{
                    tracker.abort({
                        reason: 'Window unloading',
                        attributes: {
                            cause: 'PAGE_HIDE'
                        }
                    });
                }
            }
        ]);
        return tracker;
    }
});
parcelRegister("7i7RM", function(module, exports) {
    $parcel$export(module.exports, "TeamsExperienceTracker", ()=>$df8b2ce13ecbfe34$export$9e9a48cf2c297bd1);
    var $ha42n;
    var $15mL0;
    class $df8b2ce13ecbfe34$export$9e9a48cf2c297bd1 extends (0, (0, parcelRequire("ha42n")).ExperienceTracker) {
        _errorNameInIgnoredList(error) {
            const name = error && error.constructor.name;
            return this._ignoredErrors.includes(name) ? name : undefined;
        }
        constructor(options){
            super(options), this._ignoredErrors = [
                'SentryIgnoreError'
            ];
        }
        stopOnError({ name: name, error: error }) {
            if ((0, (0, parcelRequire("15mL0")).isAuthError)(error)) {
                this.abort({
                    name: name,
                    reason: 'Abort due to user unauthenticated',
                    attributes: {
                        cause: 'USER_UNAUTHENTICATED',
                        error: error
                    },
                    checkForTimeout: false
                });
                return;
            }
            if ((0, (0, parcelRequire("15mL0")).isErrorStatusCode)((0, (0, parcelRequire("15mL0")).StatusCode).GONE, error)) {
                this.abort({
                    name: name,
                    reason: 'Abort due to unavailable resource',
                    attributes: {
                        cause: 'GONE',
                        error: error
                    },
                    checkForTimeout: false
                });
                return;
            }
            const ignoredErrorName = this._errorNameInIgnoredList(error);
            if (ignoredErrorName) {
                this.abort({
                    name: name,
                    reason: 'Abort due to an error in ignore list',
                    attributes: {
                        cause: ignoredErrorName
                    },
                    checkForTimeout: false
                });
                return;
            }
            super.stopOnError({
                name: name,
                error: error
            });
        }
    }
});
parcelRegister("15mL0", function(module, exports) {
    $parcel$export(module.exports, "StatusCode", ()=>$d52079d97606e8b0$export$f66f92b8741acd5b);
    $parcel$export(module.exports, "isAuthError", ()=>$d52079d97606e8b0$export$cde1786a482f9a1c);
    $parcel$export(module.exports, "isErrorStatusCode", ()=>$d52079d97606e8b0$export$9677d7c364ada66c);
    var $d52079d97606e8b0$export$f66f92b8741acd5b;
    (function(StatusCode) {
        StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
        StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
        StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
        StatusCode[StatusCode["GONE"] = 410] = "GONE";
        StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    })($d52079d97606e8b0$export$f66f92b8741acd5b || ($d52079d97606e8b0$export$f66f92b8741acd5b = {}));
    function $d52079d97606e8b0$export$cde1786a482f9a1c(error) {
        return $d52079d97606e8b0$export$9677d7c364ada66c(401, error) || $d52079d97606e8b0$export$9677d7c364ada66c(403, error);
    }
    function $d52079d97606e8b0$export$9677d7c364ada66c(statusCode, error) {
        if (!error) return false;
        if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
        const reg = new RegExp(`status (code)?.*(${statusCode})`);
        return !!error?.message?.match(reg);
    }
});
parcelRegister("hnAwz", function(module, exports) {
    $parcel$export(module.exports, "isNetworkError", ()=>$f0235a5352096b37$export$476aa014e2fd89d5);
    $parcel$export(module.exports, "computeErrorAttributes", ()=>$f0235a5352096b37$export$5e7501d1cb9a5aa0);
    $parcel$export(module.exports, "computePerformanceAttributes", ()=>$f0235a5352096b37$export$b978343735080139);
    var $hhYjW;
    function $f0235a5352096b37$export$476aa014e2fd89d5(error) {
        return error && !!error.message && (error.message.includes('NetworkError') || error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || !!(error['graphQLErrors'] && error['networkError']));
    }
    function $f0235a5352096b37$export$5e7501d1cb9a5aa0(event) {
        const attributes = {};
        if ($f0235a5352096b37$var$isFailEvent(event)) attributes.failError = event.error;
        if ($f0235a5352096b37$var$isAbortEvent(event)) attributes.abortReason = event.reason;
        return attributes;
    }
    function $f0235a5352096b37$export$b978343735080139(event) {
        if ($f0235a5352096b37$var$isStopEvent(event)) {
            const duration = event.duration;
            const latencySlo = event.attributes && $f0235a5352096b37$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
            if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
            return {
                sloSatisfied: duration <= latencySlo,
                taskDuration: duration,
                latencySlo: latencySlo
            };
        }
        return {};
    }
    function $f0235a5352096b37$var$isStopEvent(e) {
        return (0, (0, parcelRequire("hhYjW")).isStop)(e);
    }
    function $f0235a5352096b37$var$isFailEvent(e) {
        return e.action === 'taskFail';
    }
    function $f0235a5352096b37$var$isAbortEvent(e) {
        return e.action === 'taskAbort';
    }
    function $f0235a5352096b37$var$hasLatencySLO(attributes) {
        return Object(attributes).hasOwnProperty('latencySlo');
    }
});
parcelRegister("hhYjW", function(module, exports) {
    $parcel$export(module.exports, "isStop", ()=>$aa0bafdc1aa29e5b$export$16e3f1b03b231b35);
    $parcel$export(module.exports, "hasName", ()=>$aa0bafdc1aa29e5b$export$57069f5b2ecc9128);
    const $aa0bafdc1aa29e5b$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
    const $aa0bafdc1aa29e5b$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
});
parcelRegister("bwDHF", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsEvents", ()=>$39c115f9536efeab$export$5bf35293e545f20c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $44uzI;
    var $2RmMy;
    const $39c115f9536efeab$export$5bf35293e545f20c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
            const event = createAnalyticsEvent((0, (0, parcelRequire("2RmMy")).default)(...params));
            event.fire((0, (0, parcelRequire("44uzI")).EVENT_CHANNEL));
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEvent: fireEvent
        };
    };
});
parcelRegister("44uzI", function(module, exports) {
    $parcel$export(module.exports, "EVENT_CHANNEL", ()=>$ed8690ca9a47d1ea$export$3f072f06b90c3985);
    var $dWAZk = parcelRequire("dWAZk");
    const $ed8690ca9a47d1ea$export$3f072f06b90c3985 = (0, $dWAZk.FabricChannel).peopleTeams;
});
parcelRegister("2RmMy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed85a00ce3587d53$export$2e2bcd8739ae039);
    const $ed85a00ce3587d53$var$createEventPayload = (eventKey, ...[attributes])=>{
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        };
    };
    var $ed85a00ce3587d53$export$2e2bcd8739ae039 = $ed85a00ce3587d53$var$createEventPayload;
});
parcelRegister("jsDzq", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsEventsWithTags", ()=>$44e55e13c7ee3294$export$e8e0cef07f76dd91);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $44uzI;
    var $2RmMy;
    const $44e55e13c7ee3294$export$e8e0cef07f76dd91 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireEventWithTags = (0, $5uXOq.useCallback)((tags, ...params)=>{
            const event = createAnalyticsEvent((0, (0, parcelRequire("2RmMy")).default)(...params));
            if (event.payload) event.payload.tags = tags;
            event.fire((0, (0, parcelRequire("44uzI")).EVENT_CHANNEL));
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEventWithTags: fireEventWithTags
        };
    };
});
parcelRegister("f0K80", function(module, exports) {
    $parcel$export(module.exports, "DialogProvider", ()=>$3685775d51863c8a$export$7ab5cfe96fae86d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $doKCe;
    const $3685775d51863c8a$var$dialogProviderReducer = (state, action)=>{
        switch(action.type){
            case 'open':
                return {
                    ...state,
                    DialogComponent: action.payload?.DialogComponent || null,
                    isOpen: true
                };
            case 'close':
                return {
                    ...state,
                    DialogComponent: null,
                    dialogProps: null,
                    isOpen: false
                };
            default:
                throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
        }
    };
    const $3685775d51863c8a$export$b52337b35cd3c980 = (props)=>{
        const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
        const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, (0, parcelRequire("doKCe")).DialogContext));
        if (!DialogComponent) return null;
        const handleCloseDialog = ()=>{
            closeDialog();
            if (onClose) onClose();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).cloneElement(DialogComponent, {
            onClose: handleCloseDialog
        }));
    };
    const $3685775d51863c8a$export$7ab5cfe96fae86d3 = ({ children: children })=>{
        const [dialogProviderState, dispatch] = (0, $5uXOq.useReducer)($3685775d51863c8a$var$dialogProviderReducer, {
            DialogComponent: null,
            isOpen: false
        });
        const value = (0, $5uXOq.useMemo)(()=>({
                openDialog: (DialogComponent)=>dispatch({
                        type: 'open',
                        payload: {
                            DialogComponent: DialogComponent
                        }
                    }),
                closeDialog: ()=>dispatch({
                        type: 'close'
                    })
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("doKCe")).DialogContext).Provider, {
            value: value
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($3685775d51863c8a$export$b52337b35cd3c980, dialogProviderState));
    };
});
parcelRegister("doKCe", function(module, exports) {
    $parcel$export(module.exports, "DialogContext", ()=>$90f232376a728add$export$8b93a07348a7730c);
    var $5uXOq = parcelRequire("5uXOq");
    const $90f232376a728add$export$8b93a07348a7730c = (0, $5uXOq.createContext)({
        openDialog: ()=>null,
        closeDialog: ()=>null
    });
});
parcelRegister("3VSOD", function(module, exports) {
    $parcel$export(module.exports, "useTeamsSentryClientSetup", ()=>$d5d9cf45ee09d769$export$e30f49f36a0eeaeb);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jQUd;
    const $d5d9cf45ee09d769$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
        const [sentryInitialised, setSentryInitialised] = (0, $5uXOq.useState)(false);
        const setupSentry = (0, $5uXOq.useCallback)(async ()=>{
            if (!sentryInitialised && isSentryEnabled && !(0, (0, parcelRequire("6jQUd")).sentryClient)) await (0, (0, parcelRequire("6jQUd")).setupSentryClient)(config);
        }, [
            config,
            isSentryEnabled,
            sentryInitialised
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setupSentry().then(()=>setSentryInitialised(true));
        }, [
            setupSentry
        ]);
        return 0, (0, parcelRequire("6jQUd")).sentryClient;
    };
});
parcelRegister("lRyV6", function(module, exports) {
    $parcel$export(module.exports, "useSetAppConfig", ()=>$aff9d2f176575204$export$338e93cfada2e9d7);
    var $4Cv4w;
    var $Zt6ds;
    var $lkPoa;
    const $aff9d2f176575204$export$338e93cfada2e9d7 = (appConfig)=>{
        (0, (0, parcelRequire("4Cv4w")).useSetClientConfig)({
            cloudId: appConfig.cloudId,
            stargateRoot: appConfig.stargateRoot,
            env: appConfig.env,
            orgId: appConfig.orgId,
            principalUserId: appConfig.principalUserId
        });
        (0, (0, parcelRequire("lkPoa")).useSetTeamsProductConfig)({
            appName: appConfig.appName,
            productName: appConfig.productName,
            isJiraAvailable: appConfig.isJiraAvailable,
            subProduct: appConfig.subProduct,
            locale: appConfig.locale,
            productFeatureFlags: appConfig.productFeatureFlags
        });
        (0, (0, parcelRequire("Zt6ds")).useSetTeamsNavigationConfig)({
            contextSpaPaths: appConfig.contextSpaPaths,
            contextEntryPoint: appConfig.contextEntryPoint
        });
    };
});
parcelRegister("4Cv4w", function(module, exports) {
    $parcel$export(module.exports, "useSetClientConfig", ()=>$7f60e8ba3749bb71$export$2f68760d90a1443f);
    var $5uXOq = parcelRequire("5uXOq");
    var $1ldwM;
    var $3WNaH;
    const $7f60e8ba3749bb71$export$2f68760d90a1443f = (clientConfig)=>{
        const { setClientConfig: setClientConfig } = (0, (0, parcelRequire("3WNaH")).useSetTeamsConfigActions)();
        (0, (0, parcelRequire("1ldwM")).useTeamsClientSetupNext)({
            stargateRoot: clientConfig.stargateRoot,
            cloudId: clientConfig.cloudId,
            orgId: clientConfig.orgId,
            principalUserId: clientConfig.principalUserId
        });
        (0, $5uXOq.useEffect)(()=>{
            setClientConfig(clientConfig);
        }, [
            setClientConfig,
            clientConfig
        ]);
    };
});
parcelRegister("1ldwM", function(module, exports) {
    $parcel$export(module.exports, "useTeamsClientSetupNext", ()=>$fbe216300c0f5fd0$export$5eae9f59196893ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $dmOdc;
    var $6laLp;
    const $fbe216300c0f5fd0$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId, principalUserId)=>{
        $fbe216300c0f5fd0$export$5eae9f59196893ac({
            stargateRoot: stargateRoot,
            cloudId: cloudId,
            orgId: orgId,
            principalUserId: principalUserId
        });
    };
    const $fbe216300c0f5fd0$export$5eae9f59196893ac = ({ stargateRoot: stargateRoot, cloudId: cloudId, orgId: orgId, principalUserId: principalUserId })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!stargateRoot) return;
            (0, (0, parcelRequire("dmOdc")).teamsClient).setBaseUrl(stargateRoot);
        }, [
            stargateRoot
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("dmOdc")).teamsClient).setContext({
                cloudId: cloudId,
                orgId: orgId,
                userId: principalUserId
            });
            if (!orgId) (0, (0, parcelRequire("6laLp")).logInfoMessage)(`No orgId set - useTeamsClientSetup`, {
                cloudId: cloudId
            });
        }, [
            cloudId,
            orgId,
            principalUserId
        ]);
    };
});
parcelRegister("3WNaH", function(module, exports) {
    $parcel$export(module.exports, "useAppConfigStoreState", ()=>$5f2ed7b62647a462$export$ace1f350f4f044c0);
    $parcel$export(module.exports, "useSetTeamsConfigActions", ()=>$5f2ed7b62647a462$export$b652cf4936246835);
    $parcel$export(module.exports, "useNavigationState", ()=>$5f2ed7b62647a462$export$e482f4662aebc4a0);
    var $3sQ5x;
    var $iXqE5;
    const $5f2ed7b62647a462$var$defaultNavigationState = {
        contextSpaPaths: [],
        contextEntryPoint: null
    };
    const $5f2ed7b62647a462$var$defaultClientConfigState = {
        cloudId: null,
        stargateRoot: '',
        env: undefined
    };
    const $5f2ed7b62647a462$var$defaultTeamsProductConfigState = {
        appName: null,
        productName: null,
        isJiraAvailable: false
    };
    const $5f2ed7b62647a462$var$defaultState = {
        ...$5f2ed7b62647a462$var$defaultNavigationState,
        ...$5f2ed7b62647a462$var$defaultClientConfigState,
        ...$5f2ed7b62647a462$var$defaultTeamsProductConfigState,
        docTitle: {}
    };
    const $5f2ed7b62647a462$var$actions = {
        setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
                setState({
                    ...navigationConfig
                });
            },
        setClientConfig: (clientConfig)=>({ setState: setState })=>{
                setState({
                    ...clientConfig
                });
            },
        setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
                setState({
                    ...teamsProductConfig
                });
            },
        setAppConfig: (appConfig)=>({ setState: setState })=>{
                setState({
                    ...appConfig
                });
            }
    };
    const $5f2ed7b62647a462$var$AppConfigStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $5f2ed7b62647a462$var$defaultState,
        actions: $5f2ed7b62647a462$var$actions
    });
    const $5f2ed7b62647a462$export$61884cfbde7fd829 = (0, (0, parcelRequire("3sQ5x")).createHook)($5f2ed7b62647a462$var$AppConfigStore);
    const $5f2ed7b62647a462$var$useAppConfigActions = (0, (0, parcelRequire("3sQ5x")).createHook)($5f2ed7b62647a462$var$AppConfigStore, {
        selector: null
    });
    const $5f2ed7b62647a462$export$ace1f350f4f044c0 = ()=>$5f2ed7b62647a462$export$61884cfbde7fd829()[0];
    const $5f2ed7b62647a462$export$b652cf4936246835 = ()=>{
        return $5f2ed7b62647a462$var$useAppConfigActions()[1];
    };
    const $5f2ed7b62647a462$export$7b278989f04c1040 = ()=>$5f2ed7b62647a462$export$ace1f350f4f044c0().appName;
    const $5f2ed7b62647a462$export$e482f4662aebc4a0 = ()=>{
        const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $5f2ed7b62647a462$export$ace1f350f4f044c0();
        return {
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint
        };
    };
});
parcelRegister("Zt6ds", function(module, exports) {
    $parcel$export(module.exports, "useSetTeamsNavigationConfig", ()=>$230024e91a993ec4$export$254030771a907fca);
    var $5uXOq = parcelRequire("5uXOq");
    var $3WNaH;
    const $230024e91a993ec4$export$254030771a907fca = (config)=>{
        const { setNavigationConfig: setNavigationConfig } = (0, (0, parcelRequire("3WNaH")).useSetTeamsConfigActions)();
        (0, $5uXOq.useEffect)(()=>{
            setNavigationConfig(config);
        }, [
            setNavigationConfig,
            config
        ]);
    };
});
parcelRegister("lkPoa", function(module, exports) {
    $parcel$export(module.exports, "useSetTeamsProductConfig", ()=>$981daa1620d2012d$export$f8296902b02e4ba1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3WNaH;
    const $981daa1620d2012d$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
        const { setTeamsProductConfig: setTeamsProductConfig } = (0, (0, parcelRequire("3WNaH")).useSetTeamsConfigActions)();
        (0, $5uXOq.useEffect)(()=>{
            setTeamsProductConfig(teamsProductConfig);
        }, [
            setTeamsProductConfig,
            teamsProductConfig
        ]);
    };
});
parcelRegister("8VfUC", function(module, exports) {
    $parcel$export(module.exports, "AppConfigProvider", ()=>$b64948f6a4087dd8$export$42f491f31057ae78);
    $parcel$export(module.exports, "useNavigationActions", ()=>$b64948f6a4087dd8$export$d52b0df9de5d0e40);
    $parcel$export(module.exports, "useAddFlag", ()=>$b64948f6a4087dd8$export$6d75236f0e3dc17e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwXrd;
    var $4GZE5;
    var $3WNaH;
    const $b64948f6a4087dd8$var$error = new Error('AppConfig is not setup in RSS');
    const $b64948f6a4087dd8$var$defaultValue = {
        push: ()=>{
            throw $b64948f6a4087dd8$var$error;
        },
        replace: ()=>{
            throw $b64948f6a4087dd8$var$error;
        },
        addFlag: ()=>{
            throw $b64948f6a4087dd8$var$error;
        }
    };
    const $b64948f6a4087dd8$var$AppConfigContext = (0, ($parcel$interopDefault($5uXOq))).createContext($b64948f6a4087dd8$var$defaultValue);
    function $b64948f6a4087dd8$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
        const { contextEntryPoint: contextEntryPoint } = (0, (0, parcelRequire("3WNaH")).useNavigationState)();
        const addFlag = (0, $5uXOq.useCallback)((props)=>{
            const { type: type, ...rest } = props;
            addFlagProp({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, (0, parcelRequire("bwXrd")).getTypeIcon)(type)
            });
        }, [
            addFlagProp
        ]);
        const push = (0, $5uXOq.useCallback)((path)=>{
            const finalPath = (0, (0, parcelRequire("4GZE5")).prefixWithContextEntryPoint)(path, contextEntryPoint);
            return pushProp(finalPath);
        }, [
            pushProp,
            contextEntryPoint
        ]);
        const replace = (0, $5uXOq.useCallback)((path)=>{
            const finalPath = (0, (0, parcelRequire("4GZE5")).prefixWithContextEntryPoint)(path, contextEntryPoint);
            return replaceProp(finalPath);
        }, [
            contextEntryPoint,
            replaceProp
        ]);
        const configValue = (0, $5uXOq.useMemo)(()=>({
                addFlag: addFlag,
                push: push,
                replace: replace
            }), [
            addFlag,
            push,
            replace
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b64948f6a4087dd8$var$AppConfigContext.Provider, {
            value: configValue
        }, children);
    }
    const $b64948f6a4087dd8$var$useAppConfigProvider = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($b64948f6a4087dd8$var$AppConfigContext);
    const $b64948f6a4087dd8$export$d52b0df9de5d0e40 = ()=>{
        const { push: push, replace: replace } = $b64948f6a4087dd8$var$useAppConfigProvider();
        return {
            push: push,
            replace: replace
        };
    };
    const $b64948f6a4087dd8$export$6d75236f0e3dc17e = ()=>{
        const { addFlag: addFlag } = $b64948f6a4087dd8$var$useAppConfigProvider();
        return addFlag;
    };
});
parcelRegister("bwXrd", function(module, exports) {
    $parcel$export(module.exports, "getTypeIcon", ()=>$bedc8f0d150e3169$export$672f92b0d52b7cfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $dD7Zc;
    var $c2i4s;
    var $bU3PY;
    const $bedc8f0d150e3169$var$flagIconByType = {
        error: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            spacing: "spacious",
            label: "",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        }),
        warning: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            spacing: "spacious",
            label: "",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`
        })
    };
    const $bedc8f0d150e3169$var$DefaultIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
    });
    const $bedc8f0d150e3169$export$672f92b0d52b7cfe = (type = 'normal')=>$bedc8f0d150e3169$var$flagIconByType[type] || $bedc8f0d150e3169$var$DefaultIcon;
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("4GZE5", function(module, exports) {
    $parcel$export(module.exports, "isAbsoluteLink", ()=>$4b3484dc00e942f2$export$895d6838d29edd02);
    $parcel$export(module.exports, "prefixWithContextEntryPoint", ()=>$4b3484dc00e942f2$export$715c8f9057ac0c01);
    $parcel$export(module.exports, "getRelativeUrl", ()=>$4b3484dc00e942f2$export$d614758658023fd);
    $parcel$export(module.exports, "EXTERNAL_LINKS", ()=>$4b3484dc00e942f2$export$4cf71c31cd7fa836);
    var $bJMK1;
    var $2bf04;
    const $4b3484dc00e942f2$export$895d6838d29edd02 = (url)=>{
        return url.startsWith('http') || url.startsWith('www');
    };
    const $4b3484dc00e942f2$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
        if ($4b3484dc00e942f2$export$895d6838d29edd02(path) || contextEntryPoint && path.startsWith(contextEntryPoint) || path.startsWith('/')) return path;
        return `${contextEntryPoint}/${path}`;
    };
    const $4b3484dc00e942f2$export$d614758658023fd = (url)=>{
        if (!$4b3484dc00e942f2$export$895d6838d29edd02(url)) return url;
        try {
            const { pathname: pathname, search: search, hash: hash } = new URL(url);
            return `${pathname}${search}${hash}`;
        } catch (error) {
            (0, (0, parcelRequire("2bf04")).logException)(error, 'Cannot parse URL in getRelativeUrl', {
                url: url
            });
        }
        return url;
    };
    const $4b3484dc00e942f2$export$4cf71c31cd7fa836 = {
        TEAM_INVITE_LEARN_MORE: `${(0, (0, parcelRequire("bJMK1")).getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
    };
});
parcelRegister("bJMK1", function(module, exports) {
    $parcel$export(module.exports, "getAtlassianContextUrl", ()=>$8008ce60aa2556c9$export$9986ff99701c314f);
    $parcel$export(module.exports, "getAtlassianContextDomain", ()=>$8008ce60aa2556c9$export$50f0d77e468746eb);
    var $kTK0a;
    var $jCvwN;
    function $8008ce60aa2556c9$export$9986ff99701c314f(domainKey) {
        if ((0, (0, parcelRequire("jCvwN")).isFedramp)()) return (0, (0, parcelRequire("kTK0a")).getATLContextUrl)(domainKey);
        else return `https://${domainKey}.atlassian.com`;
    }
    function $8008ce60aa2556c9$export$50f0d77e468746eb(domainKey) {
        if ((0, (0, parcelRequire("jCvwN")).isFedramp)()) return (0, (0, parcelRequire("kTK0a")).getATLContextDomain)(domainKey);
        else return `${domainKey}.atlassian.com`;
    }
});
parcelRegister("ffeEQ", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardClientConfigProvider", ()=>$49410c66d97e848d$export$47bd48f80e3bc7b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $9d8RB;
    var $1EY90;
    function $49410c66d97e848d$export$47bd48f80e3bc7b3({ children: children, ...props }) {
        const profileCardClient = (0, (0, parcelRequire("1EY90")).useProfileClient)();
        const config = (0, $5uXOq.useMemo)(()=>({
                ...props,
                profileCardClient: profileCardClient
            }), [
            props,
            profileCardClient
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9d8RB")).ProfileCardClientConfigContext).Provider, {
            value: config
        }, children);
    }
});
parcelRegister("9d8RB", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardClientConfigContext", ()=>$ae07aa3da9b5b704$export$c804cb3b184b670f);
    $parcel$export(module.exports, "useProfileCardClientConfig", ()=>$ae07aa3da9b5b704$export$a3c560c84e5d436d);
    var $5uXOq = parcelRequire("5uXOq");
    const $ae07aa3da9b5b704$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
    const $ae07aa3da9b5b704$var$defaultState = {
        addFlag: ()=>{
            console.error($ae07aa3da9b5b704$var$error);
        },
        push: ()=>{
            console.error($ae07aa3da9b5b704$var$error);
        },
        contextEntryPoint: null,
        cloudId: null
    };
    const $ae07aa3da9b5b704$export$c804cb3b184b670f = (0, ($parcel$interopDefault($5uXOq))).createContext($ae07aa3da9b5b704$var$defaultState);
    const $ae07aa3da9b5b704$export$a3c560c84e5d436d = ()=>(0, $5uXOq.useContext)($ae07aa3da9b5b704$export$c804cb3b184b670f);
});
parcelRegister("1EY90", function(module, exports) {
    $parcel$export(module.exports, "useProfileClient", ()=>$dda16fc33e0d8aa1$export$d43dc22a8337ee9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    var $blw2B = parcelRequire("blw2B");
    var $mw4O5;
    const $dda16fc33e0d8aa1$var$CACHE_MAX_AGE = 60000;
    const $dda16fc33e0d8aa1$var$actions = {
        createClient: (stargateRoot, enableTeamCentral = false)=>({ setState: setState })=>{
                const profileClient = new (0, $blw2B.default)({
                    gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                    url: `${stargateRoot}/directory/graphql`,
                    teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                    teamCentralDisabled: !enableTeamCentral,
                    cacheSize: 20,
                    cacheMaxAge: $dda16fc33e0d8aa1$var$CACHE_MAX_AGE
                });
                setState({
                    profileClient: profileClient
                });
                return profileClient;
            }
    };
    const $dda16fc33e0d8aa1$var$ProfileClientStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $dda16fc33e0d8aa1$var$actions
    });
    const $dda16fc33e0d8aa1$var$useProfileClientState = (0, (0, parcelRequire("3sQ5x")).createHook)($dda16fc33e0d8aa1$var$ProfileClientStore);
    const $dda16fc33e0d8aa1$export$d43dc22a8337ee9f = ()=>{
        const [{ profileClient: profileClient }, { createClient: createClient }] = $dda16fc33e0d8aa1$var$useProfileClientState();
        const { stargateRoot: stargateRoot } = (0, (0, parcelRequire("mw4O5")).useAppConfig)();
        (0, $5uXOq.useEffect)(()=>{
            createClient(stargateRoot);
        }, [
            createClient,
            stargateRoot
        ]);
        return profileClient;
    };
});
parcelRegister("blw2B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b628efa3a075dd4$export$2e2bcd8739ae039);
    var $cZg4V = parcelRequire("cZg4V");
    var $bp5g1 = parcelRequire("bp5g1");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    var $2b628efa3a075dd4$export$2e2bcd8739ae039 = (0, $bp5g1.default);
});
parcelRegister("cZg4V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e76084040147eae1$export$2e2bcd8739ae039);
    var $iwKVT = parcelRequire("iwKVT");
    class $e76084040147eae1$export$2e2bcd8739ae039 {
        constructor(config){
            const defaults = {
                cacheSize: 10,
                cacheMaxAge: 0
            };
            this.config = {
                ...defaults,
                ...config
            };
            this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
            this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
            if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
            this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
        }
        setCachedProfile(cacheIdentifier, profile) {
            this.cache && this.cache.set(cacheIdentifier, {
                expire: Date.now() + this.config.cacheMaxAge,
                profile: profile
            });
        }
        getCachedProfile(cacheIdentifier) {
            if (!this.cache) return null;
            const cached = this.cache.get(cacheIdentifier);
            if (!cached) return null;
            if (cached.expire < Date.now()) {
                this.cache.delete(cacheIdentifier);
                return null;
            }
            this.setCachedProfile(cacheIdentifier, cached.profile);
            return cached.profile;
        }
        flushCache() {
            if (this.cache) this.cache.clear();
        }
    }
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("bp5g1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35fb800f6bdcf84a$export$2e2bcd8739ae039);
    var $kTK0a;
    var $aIZdc;
    var $VSDnB;
    var $4zh20 = parcelRequire("4zh20");
    var $4mT2s = parcelRequire("4mT2s");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    const $35fb800f6bdcf84a$var$defaultConfig = {
        gatewayGraphqlUrl: '/gateway/api/graphql'
    };
    class $35fb800f6bdcf84a$var$ProfileCardClient {
        constructor(config, clients){
            const withDefaultConfig = {
                ...$35fb800f6bdcf84a$var$defaultConfig,
                ...config,
                gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
            };
            this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
            this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
            this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
            this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
        }
        flushCache() {
            this.userClient.flushCache();
            this.teamClient.flushCache();
            this.tcClient?.flushCache();
            this.rovoAgentClient?.flushCache();
        }
        getProfile(cloudId, userId, analytics) {
            return this.userClient.getProfile(cloudId, userId, analytics);
        }
        getTeamProfile(teamId, orgId, analytics) {
            return this.teamClient.getProfile(teamId, orgId, analytics);
        }
        getReportingLines(userId) {
            return this.tcClient?.getReportingLines(userId) || Promise.resolve({
                managers: [],
                reports: []
            });
        }
        async getTeamCentralBaseUrl(teamCentralScopes) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(this.tcClient?.options.teamCentralBaseUrl);
            if (this.tcClient === undefined) return Promise.resolve(undefined);
            const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
            if (!isGlobalExperienceWorkspace) return Promise.resolve((0, (0, parcelRequire("kTK0a")).getATLContextUrl)('team'));
            let suffix = '';
            if (teamCentralScopes !== undefined) {
                const orgId = await this.tcClient.getOrgId();
                if (orgId === null) return Promise.resolve(undefined);
                suffix += `/o/${orgId}`;
                if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
            }
            return Promise.resolve(`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}${suffix}`);
        }
        async shouldShowGiveKudos() {
            if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
            return this.tcClient.checkWorkspaceExists();
        }
        getRovoAgentProfile(id, analytics) {
            return this.rovoAgentClient?.getProfile(id, analytics);
        }
        getRovoAgentPermissions(id, fireAnalytics) {
            return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
        }
        deleteAgent(id, analytics) {
            return this.rovoAgentClient?.deleteAgent(id, analytics);
        }
        setFavouriteAgent(id, isFavourite, analytics) {
            return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
        }
    }
    function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
        if (clients?.teamCentralClient) return clients.teamCentralClient;
        const teamCentralEnabled = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? config.teamCentralDisabled !== true : config.teamCentralUrl;
        return teamCentralEnabled ? new (0, $4mT2s.default)({
            ...config
        }) : undefined;
    }
    var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;
});
parcelRegister("4zh20", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23b1bd6752a000ab$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
        const headers = new Headers({
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId || ''
        });
        if (isBodyJson) headers.set('Content-Type', 'application/json');
        return headers;
    };
    class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(id, cloudId) {
            const product = this.options.productIdentifier || 'rovo';
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
            return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
        }
        getProfile(id, analytics) {
            if (!id.value) return Promise.reject(new Error('Id is missing'));
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            const cache = this.getCachedProfile(id.value);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                    if (this.cache) this.setCachedProfile(id.value, data);
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        deleteAgent(agentId, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                    method: 'DELETE',
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        setFavouriteAgent(agentId, isFavourite, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise(async (resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
                const requestMethod = isFavourite ? 'POST' : 'DELETE';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                    method: requestMethod,
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        getPermissions(id, fireAnalytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
                fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                    method: 'POST',
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers,
                    body: JSON.stringify({
                        permission_ids: [
                            'AGENT_CREATE',
                            'AGENT_UPDATE',
                            'AGENT_DELETE',
                            'AGENT_DEACTIVATE',
                            'AGENT_READ'
                        ]
                    })
                })).then((response)=>response.json()).then((data)=>{
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("ivXTE", function(module, exports) {
    $parcel$export(module.exports, "fireEvent", ()=>$533bc31bb6af10e0$export$43835e9acf248a15);
    $parcel$export(module.exports, "cardTriggered", ()=>$533bc31bb6af10e0$export$d50ab8a3b6975c);
    $parcel$export(module.exports, "teamRequestAnalytics", ()=>$533bc31bb6af10e0$export$c9b0e37b229a297b);
    $parcel$export(module.exports, "userRequestAnalytics", ()=>$533bc31bb6af10e0$export$12dae48763368ac9);
    $parcel$export(module.exports, "profileCardRendered", ()=>$533bc31bb6af10e0$export$41816a317479160b);
    $parcel$export(module.exports, "actionClicked", ()=>$533bc31bb6af10e0$export$fdcd134fbeb1f921);
    $parcel$export(module.exports, "reportingLinesClicked", ()=>$533bc31bb6af10e0$export$93260987012593be);
    $parcel$export(module.exports, "moreActionsClicked", ()=>$533bc31bb6af10e0$export$79befd155063a6a7);
    $parcel$export(module.exports, "teamAvatarClicked", ()=>$533bc31bb6af10e0$export$2703289b35687fde);
    $parcel$export(module.exports, "moreMembersClicked", ()=>$533bc31bb6af10e0$export$b4411a7661cf2d3f);
    $parcel$export(module.exports, "errorRetryClicked", ()=>$533bc31bb6af10e0$export$c86679da702d560e);
    $parcel$export(module.exports, "agentRequestAnalytics", ()=>$533bc31bb6af10e0$export$a9f8c9f412cf5664);
    var $6TKEY = parcelRequire("6TKEY");
    const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
    const $533bc31bb6af10e0$var$runItLater = (cb)=>{
        const requestIdleCallback = window.requestIdleCallback;
        if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
        if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
        return ()=>setTimeout(cb);
    };
    const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $533bc31bb6af10e0$var$runItLater(()=>{
            createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
        });
    };
    const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
    const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
    const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
    const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local",
                ...attributes,
                firedAt: Math.round((0, $6TKEY.getPageTime)())
            }
        });
    const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
        switch(type){
            case 'user':
                return $533bc31bb6af10e0$var$USER_SUBJECT;
            case 'team':
                return $533bc31bb6af10e0$var$TEAM_SUBJECT;
            case 'agent':
                return $533bc31bb6af10e0$var$AGENT_SUBJECT;
            default:
                return 'user';
        }
    };
    const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method)=>{
        return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
            method: method
        });
    };
    const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
    const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
    const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
    const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
    const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
    const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
    const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
    const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
});
parcelRegister("6TKEY", function(module, exports) {
    $parcel$export(module.exports, "getPageTime", ()=>$83ec369559ddc36d$export$e9faea7c41053334);
    const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
    };
    const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
    const $83ec369559ddc36d$var$initialPageTime = Date.now();
    const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
        if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
        return Date.now() - $83ec369559ddc36d$var$initialPageTime;
    };
});
parcelRegister("f3Zb8", function(module, exports) {
    $parcel$export(module.exports, "getErrorAttributes", ()=>$b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
    $parcel$export(module.exports, "handleDirectoryGraphQLErrors", ()=>$b5fa858d1f1072ea$export$7642af465ceb7f05);
    $parcel$export(module.exports, "handleAGGErrors", ()=>$b5fa858d1f1072ea$export$d9ad65d422ee3f8c);
    var $fcA5f = parcelRequire("fcA5f");
    const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
        'NotPermitted',
        'Gone',
        'IdentityUserNotFoundError'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
        'IdentityUserNotFoundError',
        'TEAMS_FORBIDDEN',
        'TEAMS_TEAM_DELETED'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
        'Gone'
    ];
    function $b5fa858d1f1072ea$var$isIgnoredError(error) {
        if (!error) return false;
        if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
        else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
        return false;
    }
    const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
        if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
            errorMessage: error.message,
            errorCategory: error.category,
            errorType: error.type,
            errorPath: error.path,
            errorNumber: error.errorNumber,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
        };
        else if (error instanceof (0, $fcA5f.AGGErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.AGGError)) return {
            errorMessage: error.message,
            errorType: error.errorType,
            errorStatusCode: error.statusCode,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
            errorCategory: error.classification
        };
        else if (error instanceof Error) {
            if (error.message.startsWith('Unable to fetch user:')) {
                if (error.hasOwnProperty('cause')) {
                    const causeError = error.cause;
                    if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
                }
                return {
                    errorMessage: error.message,
                    isSLOFailure: false
                };
            }
            return {
                errorMessage: error.message,
                isSLOFailure: true
            };
        }
        return {
            errorMessage: 'Unknown error',
            isSLOFailure: true
        };
    };
    const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
        throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
    };
    const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
        throw new (0, $fcA5f.AGGErrors)(errors, traceId);
    };
});
parcelRegister("fcA5f", function(module, exports) {
    $parcel$export(module.exports, "HttpError", ()=>$7db90b14dd6e48a6$export$65bd6083489bd8bb);
    $parcel$export(module.exports, "DirectoryGraphQLError", ()=>$7db90b14dd6e48a6$export$c1e4d0de940c06a2);
    $parcel$export(module.exports, "DirectoryGraphQLErrors", ()=>$7db90b14dd6e48a6$export$5a5fbfed34a590a1);
    $parcel$export(module.exports, "AGGError", ()=>$7db90b14dd6e48a6$export$4a696f048dcc929);
    $parcel$export(module.exports, "AGGErrors", ()=>$7db90b14dd6e48a6$export$60d8267243755b9c);
    class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
        constructor(code, reason, traceId){
            super(reason);
            this.code = code;
            this.traceId = traceId;
        }
    }
    class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
        constructor(message, category, type, extensions = {}, path = []){
            super(message);
            this.category = category;
            this.type = type;
            this.path = path.join('.');
            const { errorNumber: errorNumber, ...unknownExtension } = extensions;
            this.errorNumber = extensions.errorNumber;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
        constructor(errors, traceId){
            super('DirectoryGraphQLErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
            else this.errors = [];
        }
    }
    class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
        constructor(message, extensions, path = []){
            super(message);
            this.path = path?.join('.');
            const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
            this.statusCode = statusCode;
            this.errorType = errorType;
            this.classification = classification;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
        constructor(errors, traceId){
            super('AGGErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
            else this.errors = [];
        }
    }
});
parcelRegister("4mT2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8d68ade6ab7f448$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cZg4V = parcelRequire("cZg4V");
    var $a6hGK = parcelRequire("a6hGK");
    var $hnIbm = parcelRequire("hnIbm");
    const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
            query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
            variables: {
                aaid: aaid
            }
        });
    let $b8d68ade6ab7f448$var$isTCReadyPromiseMap = new Map();
    const $b8d68ade6ab7f448$var$globalExperiencePromiseCache = new Map();
    const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
    class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
            this.bypassOnFailure = false;
            this.isTCReadyPromise = this.createTcReadyPromise(options);
            this.isGlobalExperienceWorkspacePromise = this.preloadIsGlobalExperienceWorkspace(options.cloudId);
            this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
        }
        createTcReadyPromise(config) {
            if (config.cloudId) {
                let promise = $b8d68ade6ab7f448$var$isTCReadyPromiseMap.get(config.cloudId);
                if (!promise) {
                    promise = this.hasTCWorkspace(config);
                    $b8d68ade6ab7f448$var$isTCReadyPromiseMap.set(config.cloudId, promise);
                }
                return promise;
            }
            return Promise.resolve(true);
        }
        getReportingLines(userId) {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) {
                    if (!userId) return Promise.reject(new Error('userId missing'));
                    const cache = this.getCachedProfile(userId);
                    if (cache) return Promise.resolve(cache);
                    if (this.bypassOnFailure) return Promise.resolve({});
                    return new Promise((resolve)=>{
                        this.makeRequest(userId).then((data)=>{
                            const enhancedData = {
                                managers: this.filterReportingLinesUser(data?.managers),
                                reports: this.filterReportingLinesUser(data?.reports)
                            };
                            if (this.cache) this.setCachedProfile(userId, enhancedData);
                            resolve(enhancedData);
                        }).catch((error)=>{
                            if (error?.status === 401 || error?.status === 403) this.bypassOnFailure = true;
                            resolve({});
                        });
                    });
                }
                return Promise.resolve({
                    managers: [],
                    reports: []
                });
            }, ()=>Promise.resolve({
                    managers: [],
                    reports: []
                }));
        }
        async makeRequest(userId) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) {
                if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
                return response.reportingLines;
            } else {
                if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
                return response.reportingLines;
            }
        }
        checkWorkspaceExists() {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) return Promise.resolve(true);
                return Promise.resolve(false);
            }, ()=>Promise.resolve(false));
        }
        getIsGlobalExperienceWorkspace() {
            return this.isGlobalExperienceWorkspacePromise;
        }
        getOrgId() {
            return this.orgIdPromise;
        }
        preloadIsGlobalExperienceWorkspace(cloudId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(false);
            if (cloudId === undefined) return Promise.resolve(false);
            const maybeIsGlobalExperienceWorkspaceForCloudIdPromise = $b8d68ade6ab7f448$var$globalExperiencePromiseCache.get(cloudId);
            if (maybeIsGlobalExperienceWorkspaceForCloudIdPromise !== undefined) return maybeIsGlobalExperienceWorkspaceForCloudIdPromise;
            const isGlobalExperienceWorkspaceForCloudIdPromise = this.isGlobalExperienceWorkspaceForCloudId(cloudId);
            $b8d68ade6ab7f448$var$globalExperiencePromiseCache.set(cloudId, isGlobalExperienceWorkspaceForCloudIdPromise);
            return isGlobalExperienceWorkspaceForCloudIdPromise;
        }
        hasTCWorkspace(config) {
            if (config.cloudId) {
                const maybeShardedApiPath = this.getMaybeShardedApiPath(config.cloudId);
                return fetch(`${maybeShardedApiPath}/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
                    return !res || res && res.ok;
                });
            } else return Promise.resolve(false);
        }
        async isGlobalExperienceWorkspaceForCloudId(cloudId) {
            const maybeShardedApiPath = this.getMaybeShardedApiPath(cloudId);
            try {
                const response = await fetch(`${maybeShardedApiPath}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const workspaceType = await response.text();
                    return Promise.resolve(workspaceType === 'GLOBAL_EXPERIENCE');
                }
                return Promise.resolve(false);
            } catch (err) {
                return Promise.resolve(false);
            }
        }
        preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(null);
            if (cloudId === undefined) return Promise.resolve(null);
            if (orgId !== undefined) return Promise.resolve(orgId);
            const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
            if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
            const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
            $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
            return orgIdForCloudIdPromise;
        }
        getMaybeShardedApiPath(cloudId) {
            const maybeShardedPath = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${cloudId}` : '/watermelon';
            return `/gateway/api${maybeShardedPath}`;
        }
        filterReportingLinesUser(users = []) {
            return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
        }
    }
    var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;
});
parcelRegister("a6hGK", function(module, exports) {
    $parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", ()=>$9b806d5a2251e5d5$export$d38a536fd806c68f);
    var $hnIbm = parcelRequire("hnIbm");
    const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
    const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
        const query = {
            query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
            variables: {
                cloudId: cloudId
            }
        };
        try {
            const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
            if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
            return tenantContexts[0].orgId;
        } catch (err) {
            return null;
        }
    }
});
parcelRegister("hnIbm", function(module, exports) {
    $parcel$export(module.exports, "directoryGraphqlQuery", ()=>$7fa677c30fceb004$export$a5b5995619d4fe36);
    $parcel$export(module.exports, "AGGQuery", ()=>$7fa677c30fceb004$export$a14afb5f82fe705);
    var $fcA5f = parcelRequire("fcA5f");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $7fa677c30fceb004$var$buildHeaders = ()=>{
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    const $7fa677c30fceb004$var$id = (headers)=>headers;
    async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
    }
    async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
    }
    async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
        const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
        const response = await fetch(new Request(serviceUrl, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify(query)
        }));
        const traceIdFromHeaders = response?.headers?.get('atl-traceid');
        if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
        const json = await response.json();
        if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
        return json.data;
    }
});
parcelRegister("fjEAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb2f761841b49fec$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $5Uw6l = parcelRequire("5Uw6l");
    class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(teamId, _orgId) {
            if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
            return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
        }
        getProfile(teamId, orgId, analytics) {
            if (!teamId) return Promise.reject(new Error('teamId is missing'));
            const cache = this.getCachedProfile(teamId);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
                this.makeRequest(teamId, orgId).then((data)=>{
                    if (this.cache) this.setCachedProfile(teamId, data);
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("5Uw6l", function(module, exports) {
    $parcel$export(module.exports, "getTeamFromAGG", ()=>$c02eddc07333bc73$export$26a8aad0c7182dd6);
    var $hnIbm = parcelRequire("hnIbm");
    const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
        const slashPos = ari.indexOf('/');
        const id = ari.slice(slashPos + 1);
        return id;
    };
    const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
        return `ari:cloud:identity::team/${teamId}`;
    };
    const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
        const { team: team } = result;
        return {
            ...team,
            id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
            members: team.members?.nodes.map(({ member: member })=>({
                    id: member.accountId,
                    fullName: member.name,
                    avatarUrl: member.picture
                }))
        };
    };
    const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
    const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
    const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
            query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
            variables: {
                teamId: $c02eddc07333bc73$export$681597d03c8a0fd2(teamId),
                siteId: siteId || 'None'
            }
        });
    const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
        headers.append('X-ExperimentalApi', 'teams-beta');
        headers.append('X-ExperimentalApi', 'team-members-beta');
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
        const query = $c02eddc07333bc73$export$695d743d1401e038({
            teamId: teamId,
            siteId: siteId
        });
        const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
        return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
    }
});
parcelRegister("dFLsP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eafd789fd4bdf3ff$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $2qnn4 = parcelRequire("2qnn4");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $hnIbm = parcelRequire("hnIbm");
    const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
        const data = {
            ...response.User
        };
        const localWeekdayIndex = new Date().getDay().toString();
        if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
        return {
            isBot: data.isBot,
            isCurrentUser: data.isCurrentUser,
            status: data.status,
            statusModifiedDate: data.statusModifiedDate || undefined,
            avatarUrl: data.avatarUrl || undefined,
            email: data.email || undefined,
            fullName: data.fullName || undefined,
            location: data.location || undefined,
            meta: data.meta || undefined,
            nickname: data.nickname || undefined,
            companyName: data.companyName || undefined,
            timestring: data.remoteTimeString || undefined,
            accountType: data.accountType || undefined
        };
    };
    const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
            query: `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`,
            variables: {
                userId: userId
            }
        });
    const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
        const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
        const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
        return user;
    };
    class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        async makeRequest(cloudId, userId) {
            const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
            const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
            const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                isAgent: user.appType === 'agent',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        }
        getProfile(cloudId, userId, analytics) {
            if (!userId) return Promise.reject(new Error('userId missing'));
            const cacheIdentifier = `${cloudId}/${userId}`;
            const cache = this.getCachedProfile(cacheIdentifier);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
                this.makeRequest(cloudId, userId).then((data)=>{
                    if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error)
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("2qnn4", function(module, exports) {
    $parcel$export(module.exports, "localTime", ()=>$de778707e3f7ab0e$export$f0dfd716e7b023cd);
    parcelRequire("7UQ5i");
    var $9uIbX;
    const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
        if (!timezone) return null;
        try {
            return (0, (0, parcelRequire("9uIbX")).default)(new Date(), timezone, format);
        } catch (error) {
            return null;
        }
    };
});
parcelRegister("7UQ5i", function(module, exports) {
    $parcel$export(module.exports, "formatInTimeZone", ()=>(parcelRequire("9uIbX")).default);
    var $9uIbX;
});
parcelRegister("9uIbX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e9932008c468ee4$export$2e2bcd8739ae039);
    var $fwbX5;
    var $cmObS;
    var $2b4cP;
    function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("cmObS")).default)((0, (0, parcelRequire("2b4cP")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("cmObS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$900e78e49c474eed$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $920RE;
    var $2q3K8;
    var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("2q3K8")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("920RE")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("920RE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6934f899b8aefb37$export$2e2bcd8739ae039);
    var $927cR = parcelRequire("927cR");
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
    var $6934f899b8aefb37$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $927cR.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $927cR.default)('long', date, options);
            }
        }
    };
    function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
    }
    var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;
});
parcelRegister("927cR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6939e400b4f30595$export$2e2bcd8739ae039);
    function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
    }
    function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("6JaJ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e5f43d4fc19099f$export$2e2bcd8739ae039);
    var $gTcao = parcelRequire("gTcao");
    var $6Bk9v = parcelRequire("6Bk9v");
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
    var $4e5f43d4fc19099f$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
            return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
        }
        token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
            var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $4e5f43d4fc19099f$var$toUtcDate(date) {
        return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
        var tokens = (0, $gTcao.default)(date, timezoneString);
        var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
    function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
        if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("gTcao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4bb38695b1c145f$export$2e2bcd8739ae039);
    function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
    }
    var $c4bb38695b1c145f$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $c4bb38695b1c145f$var$dtfCache = {};
    function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
        if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $c4bb38695b1c145f$var$dtfCache[timeZone];
    }
});
parcelRegister("6Bk9v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ce5d4976aa71227$export$2e2bcd8739ae039);
    function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("2q3K8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c30e9c4205eee83$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $jxCgc = parcelRequire("jxCgc");
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
    var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $1c30e9c4205eee83$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $jxCgc.default)
    };
    function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
        var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $1c30e9c4205eee83$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $1c30e9c4205eee83$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
        }
        token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $1c30e9c4205eee83$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $1c30e9c4205eee83$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
            if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("jxCgc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e39ec715b89452b2$export$2e2bcd8739ae039);
    var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;
});
parcelRegister("2b4cP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$195fdf0d1f4870c0$export$2e2bcd8739ae039);
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $2q3K8;
    function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("2q3K8")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("mw4O5", function(module, exports) {
    $parcel$export(module.exports, "useNavigation", ()=>$d3d9116e20618ad2$export$d0fd4b7106de2769);
    $parcel$export(module.exports, "useAppConfig", ()=>$d3d9116e20618ad2$export$a3e0ece8c3f698d7);
    var $8VfUC;
    var $3WNaH;
    var $3WNaH;
    const $d3d9116e20618ad2$export$d0fd4b7106de2769 = ()=>{
        const state = (0, (0, parcelRequire("3WNaH")).useNavigationState)();
        const actions = (0, (0, parcelRequire("8VfUC")).useNavigationActions)();
        return {
            ...actions,
            ...state
        };
    };
    const $d3d9116e20618ad2$export$a3e0ece8c3f698d7 = ()=>{
        const storeState = (0, (0, parcelRequire("3WNaH")).useAppConfigStoreState)();
        const navigation = $d3d9116e20618ad2$export$d0fd4b7106de2769();
        const addFlag = (0, (0, parcelRequire("8VfUC")).useAddFlag)();
        return {
            ...storeState,
            ...navigation,
            addFlag: addFlag
        };
    };
});
parcelRegister("it4ti", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d65d33568e00a730$export$2e2bcd8739ae039);
    const $d65d33568e00a730$var$messagesConfig = [
        {
            locales: [
                'cs',
                'cs-CZ'
            ],
            loader: ()=>(parcelRequire("lfoIl"))
        },
        {
            locales: [
                'da',
                'da-DK'
            ],
            loader: ()=>(parcelRequire("7xYrO"))
        },
        {
            locales: [
                'de',
                'de-DE'
            ],
            loader: ()=>(parcelRequire("5aO6h"))
        },
        {
            locales: [
                'es',
                'es-ES'
            ],
            loader: ()=>(parcelRequire("jtjz5"))
        },
        {
            locales: [
                'fi',
                'fi-FI'
            ],
            loader: ()=>(parcelRequire("lR2gw"))
        },
        {
            locales: [
                'fr',
                'fr-FR'
            ],
            loader: ()=>(parcelRequire("4MToq"))
        },
        {
            locales: [
                'hu',
                'hu-HU'
            ],
            loader: ()=>(parcelRequire("l3xL0"))
        },
        {
            locales: [
                'is',
                'is-IS'
            ],
            loader: ()=>(parcelRequire("dkwXN"))
        },
        {
            locales: [
                'it',
                'it-IT'
            ],
            loader: ()=>(parcelRequire("d6C7M"))
        },
        {
            locales: [
                'ja',
                'ja-JP'
            ],
            loader: ()=>(parcelRequire("2q0op"))
        },
        {
            locales: [
                'ko',
                'ko-KR'
            ],
            loader: ()=>(parcelRequire("aCtg9"))
        },
        {
            locales: [
                'nl',
                'nl-NL'
            ],
            loader: ()=>(parcelRequire("3h8Hj"))
        },
        {
            locales: [
                'nb',
                'nb-NO'
            ],
            loader: ()=>(parcelRequire("5nDQu"))
        },
        {
            locales: [
                'pl',
                'pl-PL'
            ],
            loader: ()=>(parcelRequire("6tkau"))
        },
        {
            locales: [
                'pt-BR'
            ],
            loader: ()=>(parcelRequire("15vHC"))
        },
        {
            locales: [
                'ro',
                'ro-RO'
            ],
            loader: ()=>(parcelRequire("9TeCO"))
        },
        {
            locales: [
                'ru',
                'ru-RU'
            ],
            loader: ()=>(parcelRequire("hlJIO"))
        },
        {
            locales: [
                'sv',
                'sv-SE'
            ],
            loader: ()=>(parcelRequire("ggNyC"))
        },
        {
            locales: [
                'zh',
                'zh-CN',
                'zh-Hans'
            ],
            loader: ()=>(parcelRequire("1xUEE"))
        },
        {
            locales: [
                'zh-TW',
                'zh-HK',
                'zh-Hant'
            ],
            loader: ()=>(parcelRequire("bzylB"))
        },
        {
            locales: [
                'tr',
                'tr-TR'
            ],
            loader: ()=>(parcelRequire("82toM"))
        },
        {
            locales: [
                'th',
                'th-TH'
            ],
            loader: ()=>(parcelRequire("4RrCm"))
        },
        {
            locales: [
                'uk',
                'uk-UA'
            ],
            loader: ()=>(parcelRequire("l5Ie7"))
        },
        {
            locales: [
                'vi',
                'vi-VN'
            ],
            loader: ()=>(parcelRequire("fuoOC"))
        },
        {
            locales: [
                'en-GB'
            ],
            loader: ()=>(parcelRequire("kvw1u"))
        },
        {
            locales: [
                'en',
                'en-US'
            ],
            loader: ()=>(parcelRequire("17PrR"))
        },
        {
            locales: [
                'en-ZZ'
            ],
            loader: ()=>(parcelRequire("fkOjP"))
        }
    ];
    var $d65d33568e00a730$export$2e2bcd8739ae039 = $d65d33568e00a730$var$messagesConfig;
});
parcelRegister("lfoIl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("tyDev").then(()=>parcelRequire('fAhDz'));
});
parcelRegister("7xYrO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("q1lAC").then(()=>parcelRequire('64grG'));
});
parcelRegister("5aO6h", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8gMe3").then(()=>parcelRequire('hpCQd'));
});
parcelRegister("jtjz5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8dCUZ").then(()=>parcelRequire('l8MeX'));
});
parcelRegister("lR2gw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9O0vm").then(()=>parcelRequire('6Gm5S'));
});
parcelRegister("4MToq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iF2cC").then(()=>parcelRequire('kj5nH'));
});
parcelRegister("l3xL0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("69GI3").then(()=>parcelRequire('iYn1e'));
});
parcelRegister("dkwXN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7ZKgE").then(()=>parcelRequire('arfwR'));
});
parcelRegister("d6C7M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4TG5X").then(()=>parcelRequire('ljVDr'));
});
parcelRegister("2q0op", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k3alA").then(()=>parcelRequire('9BxE5'));
});
parcelRegister("aCtg9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1FnAV").then(()=>parcelRequire('0vQzK'));
});
parcelRegister("3h8Hj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7lg8W").then(()=>parcelRequire('3tF1z'));
});
parcelRegister("5nDQu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6dv1L").then(()=>parcelRequire('5ovxF'));
});
parcelRegister("6tkau", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6cH7F").then(()=>parcelRequire('e9uUQ'));
});
parcelRegister("15vHC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cLRQA").then(()=>parcelRequire('h843c'));
});
parcelRegister("9TeCO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93CMU").then(()=>parcelRequire('2pAXM'));
});
parcelRegister("hlJIO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhlHK").then(()=>parcelRequire('csx0J'));
});
parcelRegister("ggNyC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jXdgx").then(()=>parcelRequire('2X5b0'));
});
parcelRegister("1xUEE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("knnmZ").then(()=>parcelRequire('4TJVi'));
});
parcelRegister("bzylB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("KizUZ").then(()=>parcelRequire('dmOFJ'));
});
parcelRegister("82toM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lIqMr").then(()=>parcelRequire('13ldR'));
});
parcelRegister("4RrCm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4hfwL").then(()=>parcelRequire('3yAa3'));
});
parcelRegister("l5Ie7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaA0K").then(()=>parcelRequire('5yNzL'));
});
parcelRegister("fuoOC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7VxDU").then(()=>parcelRequire('7yfBB'));
});
parcelRegister("kvw1u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3L2n2").then(()=>parcelRequire('grA3K'));
});
parcelRegister("17PrR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("96Pa3").then(()=>parcelRequire('hzZHZ'));
});
parcelRegister("fkOjP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("giwHg").then(()=>parcelRequire('ia1WU'));
});
parcelRegister("fNJQT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e70a838d2f4a95a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fCZyz;
    var $heJqE;
    var $fj1sb;
    var $5hWov;
    var $kxdtg;
    var $9ADns;
    var $fiymB;
    var $8qmUa;
    var $fj1iI;
    var $aHh7I;
    var $hEEh7;
    var $9Wt9a;
    var $jM6Gv;
    var $9jKbC;
    var $9PUJF;
    var $bVufh;
    const $4e70a838d2f4a95a$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fj1sb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            exact: true,
            path: `${contextEntryPoint}/`,
            render: (0, (0, parcelRequire("8qmUa")).default)
        }), !canViewTeams && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/search/teams`,
            render: (0, (0, parcelRequire("hEEh7")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/search`,
            render: (0, (0, parcelRequire("aHh7I")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/kudos/:uuid`,
            render: (0, (0, parcelRequire("9ADns")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            exact: true,
            path: `${contextEntryPoint}/team`,
            render: (0, (0, parcelRequire("jM6Gv")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fj1iI")).RouteWithOrgIdLoading), {
            path: `${contextEntryPoint}/team/:teamId`,
            render: (0, (0, parcelRequire("9Wt9a")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/agent/:agentId`,
            render: (0, (0, parcelRequire("kxdtg")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/:userId/work`,
            render: (0, (0, parcelRequire("bVufh")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/:userId/*`,
            render: (0, (0, parcelRequire("9PUJF")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/me`,
            render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiymB")).default), {
                    ...props,
                    contextEntryPoint: contextEntryPoint
                })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), {
            path: `${contextEntryPoint}/:userId`,
            render: (0, (0, parcelRequire("9jKbC")).default)
        }));
    };
    function $4e70a838d2f4a95a$var$AppRoutes(props) {
        const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
        const { permissions: { canViewTeams: canViewTeams } } = (0, (0, parcelRequire("5hWov")).useTeamVisibility)();
        (0, $5uXOq.useEffect)(()=>{
            if (!onTransition) return;
            let unsubscribeBlockingHistory = ()=>{};
            let unsubscribeListeningHistory = ()=>{};
            if (history) {
                let lastHistoryLocation;
                unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                    lastHistoryLocation = pathname;
                });
                unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                    if (lastHistoryLocation !== pathname) onTransition(pathname);
                });
            }
            return ()=>{
                unsubscribeBlockingHistory();
                unsubscribeListeningHistory();
            };
        }, [
            onTransition,
            history
        ]);
        const routes = $4e70a838d2f4a95a$var$renderRoutes(contextEntryPoint, canViewTeams);
        return history ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heJqE")).default), {
            history: history
        }, routes) : routes;
    }
    var $4e70a838d2f4a95a$export$2e2bcd8739ae039 = $4e70a838d2f4a95a$var$AppRoutes;
});
parcelRegister("fCZyz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60a277c7a1030b5$export$2e2bcd8739ae039);
    var $e0XoQ;
    var $b60a277c7a1030b5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("e0XoQ")).default);
});
parcelRegister("e0XoQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a33f2454f0f795a6$export$2e2bcd8739ae039);
    var $hBYjV = parcelRequire("hBYjV");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $70VoX;
    var $a33f2454f0f795a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $a33f2454f0f795a6$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $a33f2454f0f795a6$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $a33f2454f0f795a6$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $a33f2454f0f795a6$var$isEmptyChildren = function isEmptyChildren(children) {
        return (0, ($parcel$interopDefault($5uXOq))).Children.count(children) === 0;
    };
    var $a33f2454f0f795a6$var$Route = function(_React$Component) {
        $a33f2454f0f795a6$var$_inherits(Route, _React$Component);
        function Route() {
            var _temp, _this, _ret;
            $a33f2454f0f795a6$var$_classCallCheck(this, Route);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a33f2454f0f795a6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = {
                match: _this.computeMatch(_this.props, _this.context.router)
            }, _temp), $a33f2454f0f795a6$var$_possibleConstructorReturn(_this, _ret);
        }
        Route.prototype.getChildContext = function getChildContext() {
            return {
                router: $a33f2454f0f795a6$var$_extends({}, this.context.router, {
                    route: {
                        location: this.props.location || this.context.router.route.location,
                        match: this.state.match
                    }
                })
            };
        };
        Route.prototype.computeMatch = function computeMatch(_ref, router) {
            var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
            if (computedMatch) return computedMatch;
            (0, ($parcel$interopDefault($aE1Lc)))(router, "You should not use <Route> or withRouter() outside a <Router>");
            var route = router.route;
            var pathname = (location || route.location).pathname;
            return (0, (0, parcelRequire("70VoX")).default)(pathname, {
                path: path,
                strict: strict,
                exact: exact,
                sensitive: sensitive
            }, route.match);
        };
        Route.prototype.componentWillMount = function componentWillMount() {
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.render && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
        };
        Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
            (0, ($parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
            (0, ($parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
            this.setState({
                match: this.computeMatch(nextProps, nextContext.router)
            });
        };
        Route.prototype.render = function render() {
            var match = this.state.match;
            var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
            var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
            var location = this.props.location || route.location;
            var props = {
                match: match,
                location: location,
                history: history,
                staticContext: staticContext
            };
            if (component) return match ? (0, ($parcel$interopDefault($5uXOq))).createElement(component, props) : null;
            if (render) return match ? render(props) : null;
            if (typeof children === "function") return children(props);
            if (children && !$a33f2454f0f795a6$var$isEmptyChildren(children)) return (0, ($parcel$interopDefault($5uXOq))).Children.only(children);
            return null;
        };
        return Route;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $a33f2454f0f795a6$var$Route.propTypes = {
        computedMatch: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object,
        path: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        exact: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        strict: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        sensitive: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        component: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        render: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        children: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).node
        ]),
        location: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
    };
    $a33f2454f0f795a6$var$Route.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired,
            route: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired,
            staticContext: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        })
    };
    $a33f2454f0f795a6$var$Route.childContextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired
    };
    var $a33f2454f0f795a6$export$2e2bcd8739ae039 = $a33f2454f0f795a6$var$Route;
});
parcelRegister("heJqE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8c6fbb4471fedde$export$2e2bcd8739ae039);
    var $12Lcw;
    var $c8c6fbb4471fedde$export$2e2bcd8739ae039 = (0, (0, parcelRequire("12Lcw")).default);
});
parcelRegister("12Lcw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c2a978068c36407$export$2e2bcd8739ae039);
    var $hBYjV = parcelRequire("hBYjV");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $0c2a978068c36407$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $0c2a978068c36407$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $0c2a978068c36407$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $0c2a978068c36407$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $0c2a978068c36407$var$Router = function(_React$Component) {
        $0c2a978068c36407$var$_inherits(Router, _React$Component);
        function Router() {
            var _temp, _this, _ret;
            $0c2a978068c36407$var$_classCallCheck(this, Router);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $0c2a978068c36407$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = {
                match: _this.computeMatch(_this.props.history.location.pathname)
            }, _temp), $0c2a978068c36407$var$_possibleConstructorReturn(_this, _ret);
        }
        Router.prototype.getChildContext = function getChildContext() {
            return {
                router: $0c2a978068c36407$var$_extends({}, this.context.router, {
                    history: this.props.history,
                    route: {
                        location: this.props.history.location,
                        match: this.state.match
                    }
                })
            };
        };
        Router.prototype.computeMatch = function computeMatch(pathname) {
            return {
                path: "/",
                url: "/",
                params: {},
                isExact: pathname === "/"
            };
        };
        Router.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var _props = this.props, children = _props.children, history = _props.history;
            (0, ($parcel$interopDefault($aE1Lc)))(children == null || (0, ($parcel$interopDefault($5uXOq))).Children.count(children) === 1, "A <Router> may have only one child element");
            this.unlisten = history.listen(function() {
                _this2.setState({
                    match: _this2.computeMatch(history.location.pathname)
                });
            });
        };
        Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            (0, ($parcel$interopDefault($hBYjV)))(this.props.history === nextProps.history, "You cannot change <Router history>");
        };
        Router.prototype.componentWillUnmount = function componentWillUnmount() {
            this.unlisten();
        };
        Router.prototype.render = function render() {
            var children = this.props.children;
            return children ? (0, ($parcel$interopDefault($5uXOq))).Children.only(children) : null;
        };
        return Router;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $0c2a978068c36407$var$Router.propTypes = {
        history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired,
        children: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).node
    };
    $0c2a978068c36407$var$Router.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
    };
    $0c2a978068c36407$var$Router.childContextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired
    };
    var $0c2a978068c36407$export$2e2bcd8739ae039 = $0c2a978068c36407$var$Router;
});
parcelRegister("fj1sb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b249c201006a228b$export$2e2bcd8739ae039);
    var $hd3Qv;
    var $b249c201006a228b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hd3Qv")).default);
});
parcelRegister("hd3Qv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c876a245a4c7da8b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $hBYjV = parcelRequire("hBYjV");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $70VoX;
    function $c876a245a4c7da8b$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $c876a245a4c7da8b$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $c876a245a4c7da8b$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $c876a245a4c7da8b$var$Switch = function(_React$Component) {
        $c876a245a4c7da8b$var$_inherits(Switch, _React$Component);
        function Switch() {
            $c876a245a4c7da8b$var$_classCallCheck(this, Switch);
            return $c876a245a4c7da8b$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        Switch.prototype.componentWillMount = function componentWillMount() {
            (0, ($parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Switch> outside a <Router>");
        };
        Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            (0, ($parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
            (0, ($parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        };
        Switch.prototype.render = function render() {
            var route = this.context.router.route;
            var children = this.props.children;
            var location = this.props.location || route.location;
            var match = void 0, child = void 0;
            (0, ($parcel$interopDefault($5uXOq))).Children.forEach(children, function(element) {
                if (match == null && (0, ($parcel$interopDefault($5uXOq))).isValidElement(element)) {
                    var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                    var path = pathProp || from;
                    child = element;
                    match = (0, (0, parcelRequire("70VoX")).default)(location.pathname, {
                        path: path,
                        exact: exact,
                        strict: strict,
                        sensitive: sensitive
                    }, route.match);
                }
            });
            return match ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                location: location,
                computedMatch: match
            }) : null;
        };
        return Switch;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $c876a245a4c7da8b$var$Switch.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            route: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired
        }).isRequired
    };
    $c876a245a4c7da8b$var$Switch.propTypes = {
        children: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).node,
        location: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
    };
    var $c876a245a4c7da8b$export$2e2bcd8739ae039 = $c876a245a4c7da8b$var$Switch;
});
parcelRegister("5hWov", function(module, exports) {
    $parcel$export(module.exports, "useTeamVisibility", ()=>$92a54380ceb72523$export$acf57ff2f92f51c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FH71;
    var $95nUS;
    var $2bf04;
    var $1VnzL;
    var $fff3y;
    var $5WmsO;
    const $92a54380ceb72523$export$7d97a022bd09a6fb = ()=>{
        return {
            isTeamsVisiblityEnabled: true,
            failOpenSites: false
        };
    };
    const $92a54380ceb72523$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("3FH71")).usePeopleTeamAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (error) {
                (0, (0, parcelRequire("2bf04")).logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
                const { status: status, path: path } = error instanceof Error ? {
                    status: 'unknown',
                    path: 'unknown'
                } : error;
                fireEvent('operational.teamsPermissionsRequest.failed', {
                    message: error.message,
                    status: status,
                    path: path
                });
            }
        }, [
            error,
            fireEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
                canCreateTeams: permissions.canCreateTeams,
                canViewTeams: permissions.canViewTeams,
                canAdminTeams: !!permissions.canAdminTeams
            });
        }, [
            data,
            fireEvent,
            permissions
        ]);
    };
    const $92a54380ceb72523$export$acf57ff2f92f51c1 = ()=>{
        const { orgId: orgId } = (0, (0, parcelRequire("1VnzL")).useV3OrgIdStatus)();
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const result = (0, (0, parcelRequire("95nUS")).useTeamsPermissionsService)({
            orgId: orgId,
            cloudId: cloudId
        }, {
            enabled: !!cloudId,
            attributes: {
                userId: principalUserId
            }
        });
        $92a54380ceb72523$var$useTeamPermissionsAnalytics(result);
        return {
            isLoading: !cloudId || result.isLoading,
            permissions: result.permissions
        };
    };
});
parcelRegister("1VnzL", function(module, exports) {
    $parcel$export(module.exports, "useV3OrgIdStatus", ()=>$4ffd0c9428c29f08$export$52558c271a487a01);
    var $c5gm9;
    function $4ffd0c9428c29f08$export$52558c271a487a01() {
        const [{ orgId: orgId }] = (0, (0, parcelRequire("c5gm9")).useOrg)();
        return {
            orgId: orgId,
            isOrgLoading: !orgId
        };
    }
});
parcelRegister("fff3y", function(module, exports) {
    $parcel$export(module.exports, "usePrincipalUser", ()=>$76bb8fd9cfa2a2cd$export$33e3bf16c7530dd4);
    $parcel$export(module.exports, "useAvatarUploadedStatus", ()=>$76bb8fd9cfa2a2cd$export$b26d2c7f264f51a8);
    var $3sQ5x;
    var $iXqE5;
    var $dmOdc;
    var $l6Kxh;
    const $76bb8fd9cfa2a2cd$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
            if (!cloudId) {
                setState({
                    isSiteAdmin: false
                });
                return;
            }
            let isSiteAdmin = false;
            try {
                isSiteAdmin = await (0, (0, parcelRequire("dmOdc")).teamsClient).getIsSiteAdmin(cloudId);
            } catch (e) {} finally{
                setState({
                    isSiteAdmin: isSiteAdmin
                });
            }
        };
    const $76bb8fd9cfa2a2cd$var$getMutability = (userId)=>async ({ setState: setState })=>{
            try {
                const data = await (0, (0, parcelRequire("dmOdc")).teamsClient).getProfileWithMutability(userId);
                setState({
                    mutabilityConstraints: data
                });
            } catch (e) {}
        };
    const $76bb8fd9cfa2a2cd$var$getAvatarUploadedStatus = (userId)=>async ({ setState: setState })=>{
            try {
                setState({
                    avatarUploaded: {
                        isLoading: true,
                        error: undefined,
                        uploaded: undefined
                    }
                });
                const data = await (0, (0, parcelRequire("dmOdc")).teamsClient).getMyAvatarUploadedStatus(userId);
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        uploaded: data.uploaded
                    }
                });
            } catch (e) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        error: e instanceof Error ? e : new Error('Unknown error'),
                        uploaded: undefined
                    }
                });
            }
        };
    const $76bb8fd9cfa2a2cd$var$actions = {
        getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
                if (getState().isFetching || getState().hasLoaded) return;
                setState({
                    isFetching: true,
                    hasLoaded: false
                });
                try {
                    const userBasicData = await (0, (0, parcelRequire("l6Kxh")).userInfoProvider).get();
                    setState({
                        principalUserId: userBasicData.userId,
                        ...userBasicData
                    });
                    dispatch($76bb8fd9cfa2a2cd$var$getIsSiteAdmin(cloudId));
                    dispatch($76bb8fd9cfa2a2cd$var$getMutability(userBasicData.userId));
                    setState({
                        hasLoaded: true
                    });
                } catch (e) {
                    setState({
                        hasError: true,
                        hasLoaded: false
                    });
                } finally{
                    setState({
                        isFetching: false
                    });
                }
            },
        getAvatarUploadedStatus: (userId)=>({ dispatch: dispatch })=>{
                dispatch($76bb8fd9cfa2a2cd$var$getAvatarUploadedStatus(userId));
            },
        setAvatarUploadedStatus: (uploaded)=>({ setState: setState })=>{
                setState({
                    avatarUploaded: {
                        uploaded: uploaded,
                        isLoading: false
                    }
                });
            }
    };
    const $76bb8fd9cfa2a2cd$var$initialState = {
        principalUserId: '',
        avatarUrl: '',
        email: '',
        fullName: '',
        title: '',
        isSiteAdmin: false,
        isFetching: false,
        hasError: false,
        hasLoaded: false,
        avatarUploaded: {
            isLoading: false
        }
    };
    const $76bb8fd9cfa2a2cd$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $76bb8fd9cfa2a2cd$var$initialState,
        actions: $76bb8fd9cfa2a2cd$var$actions,
        name: 'PrincipalUser'
    });
    const $76bb8fd9cfa2a2cd$export$33e3bf16c7530dd4 = (0, (0, parcelRequire("3sQ5x")).createHook)($76bb8fd9cfa2a2cd$var$Store);
    const $76bb8fd9cfa2a2cd$export$b26d2c7f264f51a8 = (0, (0, parcelRequire("3sQ5x")).createHook)($76bb8fd9cfa2a2cd$var$Store, {
        selector: (state)=>state.avatarUploaded
    });
});
parcelRegister("l6Kxh", function(module, exports) {
    $parcel$export(module.exports, "userInfoProvider", ()=>$6f1f375ecfa03356$export$30a852ca4cb27370);
    var $aOgFy;
    class $6f1f375ecfa03356$var$FetchError extends Error {
        constructor(response){
            super(`Request failed with status ${response.status}`);
            this.response = response;
            this.name = this.constructor.name;
        }
    }
    class $6f1f375ecfa03356$export$dc10e400a1189789 {
        get(fetchOp = fetch) {
            if (this.promise) return this.promise;
            const getJson = (url)=>fetchOp(url, {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response)=>{
                    if (!response.ok) throw new $6f1f375ecfa03356$var$FetchError(response);
                    return response.json();
                });
            this.promise = getJson(`${(0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
                return {
                    userId: me.account_id,
                    locale: me.locale,
                    fullName: me.name,
                    avatarUrl: me.picture,
                    email: me.email,
                    title: me.extended_profile?.job_title
                };
            });
            return this.promise;
        }
    }
    const $6f1f375ecfa03356$export$30a852ca4cb27370 = new $6f1f375ecfa03356$export$dc10e400a1189789();
});
parcelRegister("kxdtg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5508adbbd4a46619$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $yLsiT;
    var $gc5DR;
    const $5508adbbd4a46619$var$AgentProfileRoute = ({ match: match })=>{
        const { agentId: agentId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("yLsiT")).default), {
            agentId: decodeURIComponent(agentId)
        }));
    };
    var $5508adbbd4a46619$export$2e2bcd8739ae039 = $5508adbbd4a46619$var$AgentProfileRoute;
});
parcelRegister("ioKz4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f401b0c783fa617$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $38ra6;
    const $3f401b0c783fa617$export$430619e48d4c20bb = (props)=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const { name: name } = props;
        (0, $5uXOq.useEffect)(()=>{
            analytics.pushOperationalEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: name,
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).MOUNTED
            });
        }, [
            analytics,
            name
        ]);
        return null;
    };
    var $3f401b0c783fa617$export$2e2bcd8739ae039 = $3f401b0c783fa617$export$430619e48d4c20bb;
});
parcelRegister("38ra6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc4f8d47e736230d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7vgP9;
    const $fc4f8d47e736230d$var$useAnalytics = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("7vgP9")).AnalyticsContext)).analytics;
    var $fc4f8d47e736230d$export$2e2bcd8739ae039 = $fc4f8d47e736230d$var$useAnalytics;
});
parcelRegister("yLsiT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fc2013a5814c03e$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    var $9ZX3L;
    const $9fc2013a5814c03e$var$LazyAgentProfile = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("7U47G")),
        loading: ()=>null
    });
    $9fc2013a5814c03e$var$LazyAgentProfile.displayName = 'lazy(AgentProfile)';
    var $9fc2013a5814c03e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9ZX3L")).AgentProfilePageComponent);
});
parcelRegister("9ZX3L", function(module, exports) {
    $parcel$export(module.exports, "AgentProfilePageComponent", ()=>$c935d714d2d4e066$export$555f6d88454da0bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $8S93R;
    var $5OOAU;
    var $77Oft;
    var $fygPX;
    var $eZJjh;
    var $52VhE;
    var $jdXUD;
    var $3FH71;
    var $4BpOs;
    var $7m1xZ;
    var $aOf1o;
    var $lHKVj;
    var $fff3y;
    var $bA8uW;
    var $5WmsO;
    var $7YTpJ;
    var $8ZB0E;
    var $3UaSs;
    var $2FwA3;
    var $9zycQ;
    var $aKmPs;
    var $eX5cl;
    var $bKeYn;
    var $gujzl;
    var $lgzkR;
    var $7zl35;
    var $iegaf;
    var $5vaD6;
    var $6i45Z;
    var $6eD5g;
    var $j9p2O;
    var $l9Oyp;
    var $i9EPN;
    const $c935d714d2d4e066$var$AGENT_PROFILE_PAGE_LATENCY_TARGET = 1000;
    const $c935d714d2d4e066$var$mainColumnStyle = (0, (0, parcelRequire("8CUq3")).xcss)({});
    const $c935d714d2d4e066$var$bannerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.500',
        marginInline: 'space.negative.400'
    });
    const $c935d714d2d4e066$var$avatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.300'
    });
    const $c935d714d2d4e066$export$555f6d88454da0bb = (props)=>{
        const { agentId: agentId } = props;
        const { productName: productName } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const [{ agentData: agentData }, { setAgentInfo: setAgentInfo }] = (0, (0, parcelRequire("8ZB0E")).useRovoAgentData)();
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("3FH71")).usePeopleTeamAnalyticsEvents)();
        const product = (0, $5uXOq.useMemo)(()=>productName?.toLowerCase(), [
            productName
        ]);
        const [starCount, setStarCount] = (0, $5uXOq.useState)(0);
        const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
        const { data: data, error: error, isFetching: isFetching } = (0, (0, parcelRequire("jdXUD")).useAgentDetailsController)({
            agentId: agentId,
            enabled: agentData?.id !== agentId,
            assistanceServiceParams: {
                touchpointSource: 'agent-profile-page',
                experienceId: 'profile-page',
                product: product || 'rovo'
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('screen.agentProfile.viewed', {});
        }, [
            fireEvent
        ]);
        (0, (0, parcelRequire("aOf1o")).useExpTrackerStart)({
            id: agentId,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).AGENT_PROFILE_PAGE,
            latencySloMs: $c935d714d2d4e066$var$AGENT_PROFILE_PAGE_LATENCY_TARGET
        });
        (0, (0, parcelRequire("lHKVj")).useExpTrackerStop)({
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).AGENT_PROFILE_PAGE,
            checkShouldAbort: (error)=>{
                if (!(0, (0, parcelRequire("4BpOs")).isAuthError)(error)) return;
                return error.message;
            },
            error: error
        });
        const agentIdentityId = (0, $5uXOq.useMemo)(()=>{
            return agentData?.identity_account_id ? (0, (0, parcelRequire("7YTpJ")).trimUserARI)(agentData?.identity_account_id) : '';
        }, [
            agentData?.identity_account_id
        ]);
        const isAgentCreatedByCurrentUser = (0, $5uXOq.useMemo)(()=>{
            return agentData?.creator_type === 'CUSTOMER' ? (0, (0, parcelRequire("7YTpJ")).trimUserARI)(agentData?.creator || '') === principalUserId : false;
        }, [
            agentData?.creator,
            agentData?.creator_type,
            principalUserId
        ]);
        const { openDialog: openDialog } = (0, (0, parcelRequire("7m1xZ")).useDialog)();
        (0, $5uXOq.useEffect)(()=>{
            if (data) {
                setAgentInfo(data);
                setStarCount(data.favourite_count);
                setIsStarred(data.favourite);
            }
        }, [
            data,
            setAgentInfo
        ]);
        const { setFavouriteAgent: setFavouriteAgent, editAgent: editAgent, copyAgent: copyAgent, duplicateAgent: duplicateAgent, deleteAgent: deleteAgent, onChatWithAgent: onChatWithAgent, startConversation: startConversation } = (0, (0, parcelRequire("i9EPN")).useAgentActions)({
            agentId: agentData?.id,
            agentIdentityAccountId: agentData?.identity_account_id,
            product: product,
            cloudId: cloudId,
            agentName: agentData?.name
        });
        const handleOnDeleteAgent = ()=>{
            openDialog((0, (0, parcelRequire("l9Oyp")).default), {
                agentName: agentData?.name,
                agentId: agentData?.id,
                onDelete: deleteAgent,
                onClose: ()=>{}
            });
        };
        const isForgeAgent = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'THIRD_PARTY' || agentData?.creator_type === 'FORGE', [
            agentData?.creator_type
        ]);
        const handleCopyInstructions = ()=>{
            if (agentData?.system_prompt_template) navigator.clipboard.writeText(agentData?.system_prompt_template.toString());
        };
        if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7zl35")).ErrorScreen), {
            error: error,
            key: agentId
        });
        if (isFetching) (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3UaSs")).App), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
        if (!agentData) return null;
        const handleFavouriteAgent = async ()=>{
            const onSuccessCallBack = ()=>{
                setStarCount(isStarred ? starCount - 1 : starCount + 1);
                setIsStarred(!isStarred);
            };
            setFavouriteAgent(!isStarred, onSuccessCallBack);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKmPs")).default), {
            title: agentData.name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3UaSs")).App), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c935d714d2d4e066$var$bannerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).AgentBanner), {
            agentId: agentData.id,
            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
            agentIdentityAccountId: agentData.identity_account_id,
            height: 192
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKeYn")).Body), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lgzkR")).ResponsiveSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eX5cl")).AsideColumn), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c935d714d2d4e066$var$avatarStyles,
            style: {
                marginTop: '-105px'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
            agentId: agentData.id,
            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
            agentIdentityAccountId: agentData.identity_account_id,
            size: "xxlarge",
            isForgeAgent: agentData.creator_type === 'FORGE' || agentData.creator_type === 'THIRD_PARTY',
            forgeAgentIconUrl: agentData.icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileInfo), {
            agentName: agentData?.name,
            isStarred: isStarred,
            onStarToggle: ()=>handleFavouriteAgent(),
            creatorRender: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9p2O")).AgentCreator), {
                create_type: agentData.creator_type,
                creator: agentData.creator || undefined
            }),
            starCountRender: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fygPX")).AgentStarCount), {
                isLoading: isFetching,
                starCount: starCount
            }),
            agentDescription: agentData.description,
            isHidden: agentData.visibility === 'PRIVATE'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6i45Z")).AgentActions), {
            agentId: agentData.id,
            isAgentCreatedByUser: isAgentCreatedByCurrentUser,
            onEditAgent: editAgent,
            onCopyAgent: copyAgent,
            onDuplicateAgent: duplicateAgent,
            onDeleteAgent: handleOnDeleteAgent,
            onChatClick: onChatWithAgent,
            isForgeAgent: isForgeAgent
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5vaD6")).AgentAboutPanel), {
            agent: agentData
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gujzl")).MainColumn), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.500",
            xcss: $c935d714d2d4e066$var$mainColumnStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6eD5g")).AgentConversationStartersSection), {
            isAgentDefault: agentData.is_default,
            userDefinedConversationStarters: agentData.user_defined_conversation_starters?.map((starter)=>{
                return {
                    message: starter,
                    type: 'user-defined'
                };
            }),
            onConversationStarterClick: (conversationStarter)=>{
                startConversation(conversationStarter.message);
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("52VhE")).AgentInstructions), {
            promptTemplate: agentData.system_prompt_template,
            onCopy: handleCopyInstructions,
            isForgeAgent: isForgeAgent,
            fullHeightText: false
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iegaf")).default), {
            userId: agentIdentityId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9zycQ")).default), {
            userId: agentIdentityId,
            status: agentData.deactivated ? 'inactive' : 'active',
            userFullName: agentData.name
        }))))))));
    };
});
parcelRegister("8S93R", function(module, exports) {
    $parcel$export(module.exports, "AgentAvatar", ()=>$5b0f0a8770070c77$export$38b71b080e1832c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    var $5OOAU;
    const $5b0f0a8770070c77$var$agentAvatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$innerShapeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '95%',
        width: '95%',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%'
    });
    const $5b0f0a8770070c77$var$avatarContentContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5b0f0a8770070c77$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
        const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-label": label,
            xcss: $5b0f0a8770070c77$var$agentAvatarStyles,
            style: {
                height: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                width: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                ...showBorder ? {
                    backgroundColor: '#fff'
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$innerShapeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$avatarContentContainer
        }, imgUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "img",
            xcss: $5b0f0a8770070c77$var$imageStyles,
            src: imgUrl,
            alt: name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: size
        }))));
    };
});
parcelRegister("5OOAU", function(module, exports) {
    $parcel$export(module.exports, "AgentBanner", ()=>$5bf0564183cfbb33$export$6efaefb8ad2fba40);
    $parcel$export(module.exports, "GeneratedAvatar", ()=>$5bf0564183cfbb33$export$96bb253b7de22616);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    const $5bf0564183cfbb33$var$AutoDevAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4J75T")));
    const $5bf0564183cfbb33$var$AutoFixAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("dY96i")));
    const $5bf0564183cfbb33$var$AutoReviewAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8S39z")));
    const $5bf0564183cfbb33$var$BacklogBuddyAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("5f7dz")));
    const $5bf0564183cfbb33$var$CommsCrafterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4GtXx")));
    const $5bf0564183cfbb33$var$CultureAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("ejYg5")));
    const $5bf0564183cfbb33$var$CustomerInsightAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("cVv8a")));
    const $5bf0564183cfbb33$var$DecisionDirectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("laQbH")));
    const $5bf0564183cfbb33$var$FeatureFlagAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fAXjZ")));
    const $5bf0564183cfbb33$var$GenericAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kQ0nL")));
    const $5bf0564183cfbb33$var$HireWriterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8upBE")));
    const $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("1DMmf")));
    const $5bf0564183cfbb33$var$MyUserManualAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hF1ay")));
    const $5bf0564183cfbb33$var$OkrOracleAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("57MJs")));
    const $5bf0564183cfbb33$var$OpsAgentAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("l1q3R")));
    const $5bf0564183cfbb33$var$PitchPerfectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("15btr")));
    const $5bf0564183cfbb33$var$ProductRequirementAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fRK36")));
    const $5bf0564183cfbb33$var$ReleaseNotesAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kYLpd")));
    const $5bf0564183cfbb33$var$ResearchScoutAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hvWnv")));
    const $5bf0564183cfbb33$var$SocialMediaScribeAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("eV9lH")));
    const $5bf0564183cfbb33$var$TeamConnectionAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("jux1s")));
    const $5bf0564183cfbb33$var$yellowColor = {
        primary: '#FCA700',
        secondary: '#FFC716'
    };
    const $5bf0564183cfbb33$var$purpleColor = {
        primary: '#BF63F3',
        secondary: '#D8A0F7'
    };
    const $5bf0564183cfbb33$var$greenColor = {
        primary: '#82B536',
        secondary: '#B3DF72'
    };
    const $5bf0564183cfbb33$var$blueColor = {
        primary: '#357DE8',
        secondary: '#669DF1'
    };
    const $5bf0564183cfbb33$var$colorList = [
        $5bf0564183cfbb33$var$yellowColor,
        $5bf0564183cfbb33$var$purpleColor,
        $5bf0564183cfbb33$var$greenColor,
        $5bf0564183cfbb33$var$blueColor
    ];
    const $5bf0564183cfbb33$var$avatarList = [
        $5bf0564183cfbb33$var$CustomerInsightAvatar,
        $5bf0564183cfbb33$var$BacklogBuddyAvatar,
        $5bf0564183cfbb33$var$DecisionDirectorAvatar,
        $5bf0564183cfbb33$var$CommsCrafterAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$OkrOracleAvatar,
        $5bf0564183cfbb33$var$CultureAvatar,
        $5bf0564183cfbb33$var$SocialMediaScribeAvatar,
        $5bf0564183cfbb33$var$TeamConnectionAvatar,
        $5bf0564183cfbb33$var$HireWriterAvatar,
        $5bf0564183cfbb33$var$OpsAgentAvatar,
        $5bf0564183cfbb33$var$ResearchScoutAvatar,
        $5bf0564183cfbb33$var$ReleaseNotesAvatar,
        $5bf0564183cfbb33$var$MyUserManualAvatar,
        $5bf0564183cfbb33$var$PitchPerfectorAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$AutoFixAvatar,
        $5bf0564183cfbb33$var$AutoReviewAvatar,
        $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar,
        $5bf0564183cfbb33$var$FeatureFlagAvatar,
        $5bf0564183cfbb33$var$ProductRequirementAvatar
    ];
    const $5bf0564183cfbb33$export$a834793a4d0d739e = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
    const $5bf0564183cfbb33$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar = {
        decision_director_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$DecisionDirectorAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        user_manual_writer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$MyUserManualAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        product_requirements_expert_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$ProductRequirementAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        issue_organizer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$BacklogBuddyAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        it_ops_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$OpsAgentAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$purpleColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$purpleColor.secondary
                }),
            color: $5bf0564183cfbb33$var$purpleColor
        }
    };
    const $5bf0564183cfbb33$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
        const idForAgentAvatar = agentIdentityAccountId || agentId;
        if (idForAgentAvatar) {
            const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
            const parsedId = parseInt(trimmedId, 16);
            if (isNaN(parsedId)) return 0;
            else return parsedId;
        }
        return null;
    };
    const $5bf0564183cfbb33$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
        if (typeof agentNamedId === 'string' && $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId]) {
            const ootbAvatarResult = $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId];
            return {
                render: ootbAvatarResult.getRender(size),
                color: ootbAvatarResult.color
            };
        }
        const numberId = $5bf0564183cfbb33$export$c84eb7708138dd4({
            agentIdentityAccountId: agentIdentityAccountId,
            agentId: agentId
        });
        if (numberId !== null) {
            const totalCombinations = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
            const combinationIndex = numberId % totalCombinations;
            const avatarIndex = Math.floor(combinationIndex / $5bf0564183cfbb33$var$colorList.length);
            const colorIndex = combinationIndex % $5bf0564183cfbb33$var$colorList.length;
            const Avatar = $5bf0564183cfbb33$var$avatarList[avatarIndex];
            const color = $5bf0564183cfbb33$var$colorList[colorIndex];
            return {
                render: (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: color.primary,
                    secondaryColor: color.secondary
                }),
                color: color
            };
        }
        return {
            render: (0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$GenericAvatar, {
                size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$var$blueColor.primary,
                secondaryColor: $5bf0564183cfbb33$var$blueColor.secondary
            }),
            color: $5bf0564183cfbb33$var$blueColor
        };
    };
    const $5bf0564183cfbb33$var$bannerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $5bf0564183cfbb33$var$bannerFillSpaceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    });
    const $5bf0564183cfbb33$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
        const { color: color } = $5bf0564183cfbb33$var$getAvatarRender({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: 'medium'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5bf0564183cfbb33$var$bannerStyles,
                fillSpace ? $5bf0564183cfbb33$var$bannerFillSpaceStyles : undefined
            ],
            style: {
                backgroundColor: color.primary,
                height: height ? `${height}px` : undefined
            }
        });
    };
    const $5bf0564183cfbb33$export$96bb253b7de22616 = (props)=>{
        const { render: render, color: color } = $5bf0564183cfbb33$var$getAvatarRender(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5bf0564183cfbb33$var$imageStyles,
            style: {
                backgroundColor: color.primary
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, render));
    };
});
parcelRegister("4J75T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4lyg6").then(()=>parcelRequire('lOwq3'));
});
parcelRegister("dY96i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lnSiC").then(()=>parcelRequire('k9HyI'));
});
parcelRegister("8S39z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOKtw").then(()=>parcelRequire('7r7QW'));
});
parcelRegister("5f7dz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lRNUS").then(()=>parcelRequire('27sCb'));
});
parcelRegister("4GtXx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("92TBI").then(()=>parcelRequire('k9RFh'));
});
parcelRegister("ejYg5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kX91W").then(()=>parcelRequire('dB6SD'));
});
parcelRegister("cVv8a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5L9bA").then(()=>parcelRequire('kbU5P'));
});
parcelRegister("laQbH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fJ8GX").then(()=>parcelRequire('4Ta6A'));
});
parcelRegister("fAXjZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2ZaYM").then(()=>parcelRequire('cT52Z'));
});
parcelRegister("kQ0nL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6qpze").then(()=>parcelRequire('fvSGg'));
});
parcelRegister("8upBE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2V8QL").then(()=>parcelRequire('kOgKS'));
});
parcelRegister("1DMmf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lHm9").then(()=>parcelRequire('gDfXS'));
});
parcelRegister("hF1ay", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jp977").then(()=>parcelRequire('6fzX4'));
});
parcelRegister("57MJs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hRLjL").then(()=>parcelRequire('1sn78'));
});
parcelRegister("l1q3R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6zpoJ").then(()=>parcelRequire('ljkz0'));
});
parcelRegister("15btr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cs1IH").then(()=>parcelRequire('djrSm'));
});
parcelRegister("fRK36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5gEFD").then(()=>parcelRequire('W7C9N'));
});
parcelRegister("kYLpd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dMdTv").then(()=>parcelRequire('3pZFQ'));
});
parcelRegister("hvWnv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gLnrh").then(()=>parcelRequire('icyRb'));
});
parcelRegister("eV9lH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fj5lF").then(()=>parcelRequire('f4CgX'));
});
parcelRegister("jux1s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hZXlA").then(()=>parcelRequire('l3PeX'));
});
parcelRegister("77Oft", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCreator", ()=>$180d99d4c1dac440$export$f35b2eeaa7e3db15);
    $parcel$export(module.exports, "AgentProfileInfo", ()=>$180d99d4c1dac440$export$e02348ba0b01a210);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l1N8i;
    var $2pMF0;
    var $hqZzc;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $3bDjY;
    var $f18hZ;
    var $kDYSZ;
    var $cCr29;
    const $180d99d4c1dac440$var$clickableItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    });
    const $180d99d4c1dac440$var$nameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    });
    const $180d99d4c1dac440$var$descriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.0',
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100,
                    borderRadius: 3
                })
            });
            if (!creator) return null;
            if (creator.type === 'SYSTEM') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2pMF0")).AtlassianIcon), {
                    size: "small",
                    appearance: "brand"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "Atlassian"))
            });
            if (creator.type === 'CUSTOMER') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, (0, parcelRequire("cCr29")).messages).agentDeactivated))
            });
            if (creator.type === 'THIRD_PARTY') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        const creatorRender = getCreatorRender();
        return creatorRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$clickableItemStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqZzc")).RovoIcon), {
            appearance: "brand",
            size: "small"
        }), creatorRender) : null;
    };
    const $180d99d4c1dac440$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$var$tooltipWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginInline: 'space.100',
        position: 'relative',
        bottom: 'space.025'
    });
    const $180d99d4c1dac440$var$headingWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $180d99d4c1dac440$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $180d99d4c1dac440$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $180d99d4c1dac440$var$nameStyles,
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$headingWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "span",
            size: "xlarge"
        }, agentName), isHidden && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$tooltipWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenTooltip),
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f18hZ")).HiddenIcon), {
            label: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenIcon)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDYSZ")).StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle
        })), creatorRender, !!agentDescription && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$descriptionStyles,
            as: "p"
        }, agentDescription), starCountRender);
    };
});
parcelRegister("2pMF0", function(module, exports) {
    $parcel$export(module.exports, "AtlassianIcon", ()=>$f254a283aa81cf60$export$8a485e2e7ed91e8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $f254a283aa81cf60$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
    };
    const $f254a283aa81cf60$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor, testId: testId })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $f254a283aa81cf60$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
    };
});
parcelRegister("1DVhQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4b6b583e25d0959$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $d4b6b583e25d0959$var$shimmerKeyframes = null;
    const $d4b6b583e25d0959$var$skeletonStyles = null;
    const $d4b6b583e25d0959$var$activeShimmerStyles = null;
    const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            style: {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
                '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
            },
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
                isShimmering && "",
                isShimmering && "_j7hq1y0p"
            ])
        });
    };
    var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;
});
parcelRegister("f18hZ", function(module, exports) {
    $parcel$export(module.exports, "HiddenIcon", ()=>$33a2f5af6a5e0c92$export$bce21421c351deb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $6C81H;
    const $33a2f5af6a5e0c92$export$bce21421c351deb1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6C81H"))))), props);
});
parcelRegister("6C81H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $013e232b862e20a6$var$_react = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $013e232b862e20a6$var$_UNSAFE_baseNew = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $013e232b862e20a6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $013e232b862e20a6$var$EyeOpenStrikethroughIcon = (props)=>$013e232b862e20a6$var$_react.default.createElement($013e232b862e20a6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1 1 2.919 2.919M15 15l-2.92-2.92M3.92 3.92C2.524 4.792 1.436 6.096.871 7.638a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25c1.493 0 2.898-.43 4.08-1.17M3.92 3.92l2.49 2.49m5.672 5.672L9.59 9.59m0 0a2.25 2.25 0 0 1-3.182-3.182M9.59 9.59 6.409 6.409m.005-3.495A7.7 7.7 0 0 1 8 2.75c3.255 0 6.086 2.039 7.129 4.888.085.234.085.49 0 .724a7.2 7.2 0 0 1-1.187 2.08"/>`
        }, props));
    $013e232b862e20a6$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
    var $013e232b862e20a6$var$_default = module.exports.default = $013e232b862e20a6$var$EyeOpenStrikethroughIcon;
});
parcelRegister("kDYSZ", function(module, exports) {
    $parcel$export(module.exports, "StarIconButton", ()=>$ca4e80d09e432419$export$703abb8bd2abdfa5);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7piTm;
    var $bH1hf;
    var $5ILhZ;
    var $8CUq3;
    var $6cbg1;
    const $ca4e80d09e432419$var$pressableStarIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'transparent',
        padding: 'space.0',
        height: '32px',
        width: '32px'
    });
    const $ca4e80d09e432419$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca4e80d09e432419$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $ca4e80d09e432419$var$pressableStarIconStyles,
                !visible && $ca4e80d09e432419$var$hiddenStyles
            ],
            onClick: handleToggle,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false)
        }, isStarred || isHovered ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).removeFromFavouritesLabel),
            primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).clickToFavouriteLabel),
            color: 'var(--ds-text-accent-gray)'
        }));
    };
});
parcelRegister("7piTm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));
    var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $564985c3728d4aa2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>$564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
        }, props));
    $564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;
});
parcelRegister("6cbg1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3eaaeba7b25cecb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3eaaeba7b25cecb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeFromFavouritesLabel: {
            id: 'rovo-chat.browse-agents.remove-from-favourites-label',
            defaultMessage: 'Remove from favourites',
            description: 'Remove from favourites label'
        },
        clickToFavouriteLabel: {
            id: 'rovo-chat.browse-agents.click-to-favourite-label',
            defaultMessage: 'Not favourited, click to favourite',
            description: 'Click to favourite agent label'
        }
    });
});
parcelRegister("cCr29", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$34e6f75bfc23da7b$export$defe85febe8b728c);
    var $7VHMR;
    const $34e6f75bfc23da7b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentCreatedBy: {
            id: 'ai-mate.agent-profile-info.created-by',
            defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
            description: 'Message to show who created this Rovo agent'
        },
        agentDeactivated: {
            id: 'ai-mate.agent-profile-info.deactivated',
            defaultMessage: '(deactivated)',
            description: 'Message to show that this agent is deactivated'
        },
        starredCount: {
            id: 'ai-mate.agent-profile-info.starred-count',
            defaultMessage: '{count} starred',
            description: 'Message to show how many times this agent has been starred by users'
        },
        hiddenIcon: {
            id: 'ai-mate.agent-profile-info.hidden-icon',
            defaultMessage: 'Hidden',
            description: 'Icon to show that this agent is hidden'
        },
        hiddenTooltip: {
            id: 'ai-mate.agent-profile-info.hidden-tooltip',
            defaultMessage: "Agent won't show in search results",
            description: 'Tooltip to explain what strikethough eye icon means'
        },
        starAgentTooltip: {
            id: 'ai-mate.agent-profile-info.star-agent-tooltip',
            defaultMessage: 'Star Agent',
            description: 'Tooltip to explain what star icon does'
        }
    });
});
parcelRegister("fygPX", function(module, exports) {
    $parcel$export(module.exports, "AgentStarCount", ()=>$82bf86c773cd27a9$export$65f8fe094f79ae2);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l8fTj;
    var $dC5iT;
    var $8CUq3;
    var $1DVhQ;
    var $3aPFe;
    var $6cFwt;
    const $82bf86c773cd27a9$var$countStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050',
        paddingInlineStart: 'space.025'
    });
    const $82bf86c773cd27a9$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((starCount === null || starCount === undefined) && !isLoading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82bf86c773cd27a9$var$countStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("l8fTj"))))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        }), isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            testId: "agent-profile-info-star-count-skeleton",
            isShimmering: true,
            height: 16,
            width: 75,
            borderRadius: 3
        }) : formatMessage((0, (0, parcelRequire("3aPFe")).messages).starredCount, {
            starCount: (0, (0, parcelRequire("6cFwt")).formatNumber)(starCount ?? 0)
        }));
    };
});
parcelRegister("l8fTj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f626abf9a5007502$var$_react = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f626abf9a5007502$var$_starUnstarred = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("1Cvrw")));
    var $f626abf9a5007502$var$_star = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $f626abf9a5007502$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f626abf9a5007502$var$StarUnstarredIcon = (props)=>$f626abf9a5007502$var$_react.default.createElement($f626abf9a5007502$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $f626abf9a5007502$var$_star.default
        }, props));
    $f626abf9a5007502$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $f626abf9a5007502$var$_default = module.exports.default = $f626abf9a5007502$var$StarUnstarredIcon;
});
parcelRegister("3aPFe", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$056b41d8fa6dcf86$export$defe85febe8b728c);
    var $7VHMR;
    const $056b41d8fa6dcf86$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starredCount: {
            id: 'ai-mate.agent-profile-info.starred-count',
            defaultMessage: '{starCount} {starCount, plural, one {user} other {users}}',
            description: 'Text showing the number of times an agent has been favourited or starred'
        }
    });
});
parcelRegister("6cFwt", function(module, exports) {
    $parcel$export(module.exports, "formatNumber", ()=>$60c3ed960e6d0ab5$export$f5dd818bff069720);
    const $60c3ed960e6d0ab5$export$f5dd818bff069720 = (inputNumber)=>{
        if (inputNumber >= 1e9) return (inputNumber / 1e9).toFixed(1) + 'B';
        else if (inputNumber >= 1e6) return (inputNumber / 1e6).toFixed(1) + 'M';
        else if (inputNumber >= 1e3) return (inputNumber / 1e3).toFixed(1) + 'k';
        else return inputNumber.toString();
    };
});
parcelRegister("52VhE", function(module, exports) {
    $parcel$export(module.exports, "AgentInstructions", ()=>$f2aed02320efb724$export$48d253a044b54931);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8w53e;
    var $a3mGm;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $3bDjY;
    var $47kny;
    const $f2aed02320efb724$var$copyButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '32px',
        height: '32px',
        backgroundColor: 'color.background.accent.gray.subtlest',
        ':hover': {
            backgroundColor: 'color.background.accent.gray.subtlest.hovered'
        },
        borderRadius: "var(--ds-border-radius-100, 3px)"
    });
    const $f2aed02320efb724$var$fullSizeTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: '100%',
        overflowY: 'auto'
    });
    const $f2aed02320efb724$var$instructionsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
        borderRadius: 'border.radius.100',
        whiteSpace: 'pre-line',
        position: 'relative',
        padding: 'space.100',
        flex: '1'
    });
    const $f2aed02320efb724$var$smallTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: '400px',
        overflowY: 'scroll'
    });
    const $f2aed02320efb724$var$copyContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: '10px',
        right: '10px'
    });
    const $f2aed02320efb724$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $f2aed02320efb724$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        letterSpacing: 'normal'
    });
    const $f2aed02320efb724$var$forgeAgentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxShadow: 'elevation.shadow.raised',
        padding: 'space.200',
        borderRadius: 'border.radius.100'
    });
    const $f2aed02320efb724$export$48d253a044b54931 = ({ promptTemplate: promptTemplate, onCopy: onCopy, isForgeAgent: isForgeAgent, fullHeightText: fullHeightText = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [instructionsHovered, setInstructionsHovered] = (0, $5uXOq.useState)(false);
        const getInstructionsRender = ()=>{
            if (isForgeAgent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $f2aed02320efb724$var$forgeAgentWrapperStyles,
                space: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a3mGm"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold"
            }, formatMessage((0, (0, parcelRequire("47kny")).default).privateInstructionsTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                size: "small"
            }, formatMessage((0, (0, parcelRequire("47kny")).default).privateInstructionsDescription))));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $f2aed02320efb724$var$instructionsContainerStyles,
                    fullHeightText ? $f2aed02320efb724$var$fullSizeTextStyles : $f2aed02320efb724$var$smallTextStyles
                ],
                onMouseEnter: ()=>{
                    setInstructionsHovered(true);
                },
                onMouseLeave: ()=>{
                    setInstructionsHovered(false);
                }
            }, promptTemplate ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, promptTemplate), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $f2aed02320efb724$var$copyContainerStyles,
                    !instructionsHovered && $f2aed02320efb724$var$hiddenStyles
                ]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("47kny")).default).copyInstructionsTooltip),
                position: "top"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                xcss: $f2aed02320efb724$var$copyButtonStyles,
                onBlur: ()=>setInstructionsHovered(false),
                onFocus: ()=>setInstructionsHovered(true),
                onClick: ()=>onCopy(promptTemplate)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))), {
                color: "var(--ds-icon)",
                label: ""
            }))))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "em",
                color: "color.text.subtle"
            }, formatMessage((0, (0, parcelRequire("47kny")).default).noInstructionPlaceholder)));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "h2",
            xcss: $f2aed02320efb724$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "large",
            color: "color.text.subtle",
            weight: "semibold"
        }, formatMessage((0, (0, parcelRequire("47kny")).default).instructionsLabel))), getInstructionsRender()));
    };
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("a3mGm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));
    var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
    function $751bc76853fe58bc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $751bc76853fe58bc$var$LockLockedIcon = (props)=>$751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
            LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
        }, props));
    $751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
    var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;
});
parcelRegister("bwyQI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $863db7350f859785$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $863db7350f859785$var$LockLockedIcon = (props)=>$863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;
});
parcelRegister("3G2gB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
    function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ad70d7fd26028c0$var$LockIcon = (props)=>$2ad70d7fd26028c0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
        }, props, {
            newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
        }));
    $2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
    var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;
});
parcelRegister("47kny", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcb9c9370154d79f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dcb9c9370154d79f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        instructionsLabel: {
            id: 'rovo-chat.view-agent.instructions-label',
            defaultMessage: 'Instructions',
            description: 'Label for instructions'
        },
        copyInstructionsLabel: {
            id: 'rovo-chat.view-agent.copy-instructions-label',
            defaultMessage: 'Copy',
            description: 'Label for copy instructions button'
        },
        copyInstructionsTooltip: {
            id: 'rovo-chat.view-agent.copy-instructions-tooltip',
            defaultMessage: 'Copy instructions',
            description: 'Label for copy instructions tooltip'
        },
        noInstructionPlaceholder: {
            id: 'rovo-chat.view-agent.no-instruction-placeholder',
            defaultMessage: 'This Agent has no custom instructions',
            description: 'Placeholder for no instructions'
        },
        privateInstructionsTitle: {
            id: 'rovo-chat.view-agent.hidden-instructions-title',
            defaultMessage: 'These instructions are private',
            description: 'Title of the instructions section, this is displayed when instructions are purposely hidden'
        },
        privateInstructionsDescription: {
            id: 'rovo-chat.view-agent.hidden-instructions-description',
            defaultMessage: 'Forge Agents built with code have their instructions hidden for privacy.',
            description: 'Description of the instructions section, this is displayed when instructions are purposely hidden'
        }
    });
});
parcelRegister("jdXUD", function(module, exports) {
    $parcel$export(module.exports, "useAgentDetailsController", ()=>$31fd280abbc83947$export$e65200649bbc56ce);
    $parcel$export(module.exports, "useAgentDetailsByIdentityAccountId", ()=>$31fd280abbc83947$export$7d1c308c0d5404ad);
    var $91cKc;
    var $cK3Jm;
    var $4ojTZ;
    const $31fd280abbc83947$export$e65200649bbc56ce = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
        const queryResult = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'fetchAgentDetails',
                agentId
            ],
            queryFn: ()=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_AGENT_ID
                });
                return assistanceService.getAgentDetails(agentId);
            },
            onSuccess: ()=>{
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_AGENT_ID
                });
            },
            onError: (error)=>{
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                    error: error
                });
            },
            enabled: enabled
        });
        return queryResult;
    });
    const $31fd280abbc83947$export$7d1c308c0d5404ad = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ identityAccountId: identityAccountId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true })=>{
        const queryResult = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'fetchAgentDetails',
                identityAccountId
            ],
            queryFn: ()=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
                });
                return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
            },
            onSuccess: ()=>{
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
                });
            },
            onError: (error)=>{
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                    error: error
                });
            },
            enabled: enabled
        });
        return queryResult;
    });
});
parcelRegister("91cKc", function(module, exports) {
    $parcel$export(module.exports, "ExperienceName", ()=>$8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1);
    const $8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1 = {
        LOAD_PANEL: 'aiMateLoadPanel',
        LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
        LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
        FETCH_CHAT: 'aiMateFetchChat',
        FETCH_AGENTS: 'aiMateFetchAgents',
        FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
        FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
        CREATE_AGENT: 'aiMateCreateAgent',
        UPDATE_AGENT: 'aiMateUpdateAgent',
        DELETE_AGENT: 'aiMateDeleteAgent',
        FAVOURITE_AGENT: 'aiMateFavouriteAgent',
        UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
        CLEAR_CHAT: 'aiMateClearChat',
        SEND_MESSAGE: 'aiMateSendMessage',
        ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
        FETCH_FEATURES: 'aiMateFetchFeatures',
        GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
        UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
        CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
        PUBSUB_LISTENER: 'aiMatePubSubListener',
        FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
        RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
        MESSAGE_RENDERER: 'aiMateMessageRenderer',
        FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
        GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
        FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
        FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
        FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
        CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
        GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions'
    };
});
parcelRegister("cK3Jm", function(module, exports) {
    $parcel$export(module.exports, "AssistanceServiceBase", ()=>$23f77fef74bdf9a2$export$40a7802808e2fbe3);
    $parcel$export(module.exports, "AssistanceServiceImpl", ()=>$23f77fef74bdf9a2$export$a522c5f4ccda1c94);
    $parcel$export(module.exports, "AssistanceServiceProvider", ()=>$23f77fef74bdf9a2$export$8fe647eb935c33db);
    $parcel$export(module.exports, "useAssistanceService", ()=>$23f77fef74bdf9a2$export$7e31a1844ebbaf85);
    $parcel$export(module.exports, "createHookWithAssistanceService", ()=>$23f77fef74bdf9a2$export$5a9ea20fc196ec62);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $VSDnB;
    var $cSxED;
    var $7qdbi;
    var $cNqSS;
    var $4c7JV;
    var $lb2g6;
    var $khfvG;
    var $3zcGU;
    var $f7UWp;
    const $23f77fef74bdf9a2$var$PRODUCT_HEADER = 'x-product';
    const $23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
    class $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
        constructor(props){
            this.endpointSpecificBaseUrl = {
                chat: '/gateway/api/assist/chat/v1',
                agent: '/gateway/api/assist/agents/v1',
                agentConfiguration: '/gateway/api/assist/agents/configuration/v1'
            };
            this.getConfig = ()=>{
                return {
                    ...this.config
                };
            };
            const defaultBaseUrl = '/gateway/api/assist';
            const defaultConfig = {
                baseUrl: defaultBaseUrl,
                headers: {}
            };
            this.config = {
                ...props,
                baseUrl: props.baseUrl || defaultConfig.baseUrl,
                headers: {
                    ...props.headers || defaultConfig.headers
                }
            };
        }
        createHeaders(init) {
            return new Headers({
                [$23f77fef74bdf9a2$var$PRODUCT_HEADER]: this.config.product,
                [$23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
                ...this.config.headers || {},
                ...init || {}
            });
        }
        async fetch({ path: path, options: options, endpointGroup: endpointGroup }) {
            const { baseUrl: configBaseUrl } = this.config;
            let baseUrlOverride = endpointGroup ? this.endpointSpecificBaseUrl[endpointGroup] : undefined;
            const baseUrl = baseUrlOverride ?? configBaseUrl;
            const requestUrl = (0, (0, parcelRequire("lb2g6")).addPath)(baseUrl, path);
            const response = await (0, (0, parcelRequire("f7UWp")).fetchFn)(requestUrl, options);
            return (0, (0, parcelRequire("lb2g6")).processResponse)({
                response: response
            });
        }
        async fetchJson(options) {
            const response = await this.fetch(options);
            const json = await response.json();
            return json;
        }
        async fetchStream(options) {
            const response = await this.fetch(options);
            return {
                responseData: {
                    traceId: (0, (0, parcelRequire("lb2g6")).getTraceIdFromResponse)(response)
                },
                generator: (0, (0, parcelRequire("cNqSS")).readJsonStream)(response)
            };
        }
    }
    class $23f77fef74bdf9a2$export$a522c5f4ccda1c94 extends $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
        constructor(props){
            super(props), this.getAgentActions = async ()=>{
                const response = await this.fetchJson({
                    path: '/actions',
                    options: {
                        method: 'GET',
                        headers: this.createHeaders()
                    },
                    endpointGroup: 'agentConfiguration'
                });
                return response.actions;
            }, this.getAgentKnowledgeConfiguration = ()=>{
                return this.fetchJson({
                    path: '/knowledge',
                    options: {
                        method: 'GET',
                        headers: this.createHeaders()
                    },
                    endpointGroup: 'agentConfiguration'
                });
            }, this.getAgentPermissions = (agentId, payload)=>{
                return this.fetchJson({
                    path: `/api/rovo/v2/permissions/agents/${agentId}`,
                    options: {
                        method: 'POST',
                        headers: this.createHeaders({
                            'content-type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify(payload)
                    }
                });
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_convo_ai_migration')) {
                this.endpointSpecificBaseUrl.chat = '/gateway/api/assist/rovo/v1/chat';
                this.endpointSpecificBaseUrl.agent = '/gateway/api/assist/rovo/v1/agents';
                this.endpointSpecificBaseUrl.agentConfiguration = '/gateway/api/assist/rovo/v1/agents/configuration';
            }
        }
        async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext }) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
            const body = {
                content: message,
                context: {
                    browser_url: url,
                    ...editorContext ? {
                        editor: editorContext
                    } : {},
                    ...browserContext ? {
                        browser: {
                            htmlBody: browserContext.context?.htmlBody,
                            canvasText: browserContext.context?.canvasText
                        }
                    } : {},
                    ...additionalContext
                },
                recipient_agent_named_id: agentNamedId,
                agent_id: agentId,
                mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
                store_message: (0, (0, parcelRequire("VSDnB")).fg)('ai_mate_show_store_messages') ? storeMessage : false,
                citations_enabled: citationsEnabled
            };
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                signal: controller?.signal
            };
            return this.fetchStream({
                path: `/channel/${conversationId}/message/stream`,
                options: options,
                endpointGroup: 'chat'
            });
        }
        async getChat(conversationId) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers
            };
            const rawChat = await this.fetchJson({
                path: `/channel/${conversationId}/messages`,
                options: options,
                endpointGroup: 'chat'
            });
            const chatArray = 'items' in rawChat ? rawChat.items : rawChat;
            return chatArray.map((message)=>(0, (0, parcelRequire("4c7JV")).isHumanMessage)(message) ? message : (0, (0, parcelRequire("3zcGU")).toStreamResponse)(message));
        }
        async deleteChat(conversationId, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            await this.fetch({
                path: `/channel/${conversationId}`,
                options: options,
                endpointGroup: 'chat'
            });
        }
        async getFeatures(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: 'features',
                options: options
            });
        }
        async getAgents(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: '',
                options: options,
                endpointGroup: 'agent'
            });
        }
        async getAgentDetails(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `/${id}`,
                options: options,
                endpointGroup: 'agent'
            });
        }
        async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `accountid/${identityAccountId}`,
                options: options,
                endpointGroup: 'agent'
            });
        }
        async getAgentFileUploadToken(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: 'agents/v1/media/upload/credentials',
                options: options
            });
        }
        async createAgent(payload, controller) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller?.signal
            };
            return this.fetchJson({
                path: '',
                options: options,
                endpointGroup: 'agent'
            });
        }
        async updateAgent(id, payload, controller) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller?.signal
            };
            const response = await this.fetchJson({
                path: `/${id}`,
                options: options,
                endpointGroup: 'agent'
            });
            return response;
        }
        async deleteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `/${id}`,
                options: options,
                endpointGroup: 'agent'
            });
        }
        async favouriteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'POST',
                headers: headers,
                signal: controller?.signal
            };
            this.fetch({
                path: `/${id}/favourite`,
                options: options,
                endpointGroup: 'agent'
            });
        }
        async unfavouriteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            this.fetch({
                path: `/${id}/favourite`,
                options: options,
                endpointGroup: 'agent'
            });
        }
        async createConversationChannel(options) {
            return this.fetchJson({
                path: `/channel`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        name: options?.name ?? (0, (0, parcelRequire("khfvG")).generateConversationName)(),
                        dialogues: options?.dialogues ?? undefined
                    })
                },
                endpointGroup: 'chat'
            });
        }
        async getConversationChannels() {
            const result = await this.fetchJson({
                path: `/channels`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                endpointGroup: 'chat'
            });
            const channels = 'items' in result ? result.items : result;
            return channels;
        }
        updateConversationChannel(id, payload) {
            return this.fetchJson({
                path: `/channel/${id}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                endpointGroup: 'chat'
            });
        }
        async resolveConversationAction(id, payload) {
            return this.fetchJson({
                path: `/channel/${id}/action`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        ...payload,
                        context: {
                            ...payload.context,
                            browser_url: window.location.href
                        }
                    })
                },
                endpointGroup: 'chat'
            });
        }
        async speechToText(blob) {
            const formData = new FormData();
            formData.append('audio_recording', blob);
            const response = await this.fetchJson({
                path: '/speech/inference',
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                }
            });
            return response.transcription;
        }
        async generateConversationStarters(payload) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            };
            return this.fetchJson({
                path: '/suggest-conversation-starter',
                options: options,
                endpointGroup: 'agent'
            });
        }
        async generateContextualConversationStarters(payload) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            };
            return this.fetchStream({
                path: '/conversation-starter',
                options: options,
                endpointGroup: 'agent'
            });
        }
    }
    const $23f77fef74bdf9a2$var$AssistanceServiceContext = (0, $5uXOq.createContext)(new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
        baseUrl: '',
        product: '',
        experienceId: ''
    }));
    const $23f77fef74bdf9a2$export$8fe647eb935c33db = ({ value: value, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($23f77fef74bdf9a2$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
    const $23f77fef74bdf9a2$export$7e31a1844ebbaf85 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, $5uXOq.useContext), $23f77fef74bdf9a2$export$a522c5f4ccda1c94);
        const service = (0, $5uXOq.useContext)($23f77fef74bdf9a2$var$AssistanceServiceContext);
        (0, (0, parcelRequire("7qdbi")).setRovoChatProduct)(props?.product ?? service.getConfig().product);
        if (!props || !props.experienceId && !props.product && !props.headers) return service;
        const product = props.product ?? service.getConfig().product;
        const experienceId = props.experienceId ?? service.getConfig().experienceId;
        const headers = props.headers ?? service.getConfig().headers;
        return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
            ...service.getConfig(),
            product: product,
            experienceId: experienceId,
            headers: headers
        });
    };
    const $23f77fef74bdf9a2$export$5a9ea20fc196ec62 = (originalHook)=>{
        return (props)=>{
            (0, (0, parcelRequire("gKZoD")).di)($23f77fef74bdf9a2$export$a522c5f4ccda1c94, (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker));
            const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
            const experienceTracker = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)({
                touchpointSource: assistanceServiceParams.touchpointSource
            });
            const assistanceService = (0, $5uXOq.useMemo)(()=>{
                return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
                    product: assistanceServiceParams.product,
                    experienceId: assistanceServiceParams.experienceId,
                    headers: assistanceServiceParams.headers
                });
            }, [
                assistanceServiceParams.experienceId,
                assistanceServiceParams.headers,
                assistanceServiceParams.product
            ]);
            const result = originalHook({
                ...restProps,
                assistanceServiceInjectedParams: {
                    ...assistanceServiceParams,
                    experienceTracker: experienceTracker,
                    assistanceService: assistanceService
                }
            });
            return result;
        };
    };
});
parcelRegister("cSxED", function(module, exports) {
    $parcel$export(module.exports, "useAIMateExperienceTracker", ()=>$0ff262dad5216a84$export$412c53791574f6f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ha42n;
    var $jXUCh;
    var $3kN8f;
    var $jSnf2;
    const $0ff262dad5216a84$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
    class $0ff262dad5216a84$var$ExperienceTrackerHandler {
        constructor(){
            this.experienceTracker = new (0, (0, parcelRequire("ha42n")).ExperienceTracker)();
            this.sendAnalyticsEvent = null;
            this.experienceTracker.subscribe((event)=>{
                if ('error' in event) {
                    if ((0, (0, parcelRequire("jXUCh")).isClientFetchError)(event.error)) return;
                    let filteredErrorAttributes = {};
                    if ($0ff262dad5216a84$var$isRovoInstrumentedError(event.error)) {
                        const errorAttributes = event.error.errorAttributes;
                        filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([_, value])=>value !== undefined));
                        if (errorAttributes?.statusCode && errorAttributes?.statusCode >= 500) return;
                    }
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const touchpointSource = event.attributes?.touchpointSource;
                    (0, (0, parcelRequire("3kN8f")).logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributes,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            }
                        }
                    });
                }
                this.sendAnalyticsEvent?.({
                    eventType: 'operational',
                    action: event.action,
                    actionSubject: 'ui',
                    attributes: {
                        task: event.name,
                        taskId: event.id,
                        startTime: event.startTime,
                        ...event.attributes
                    }
                }, {
                    removeDefaultTags: true
                });
            });
        }
        setSendAnalyticsEvent(sendAnalyticsEvent) {
            this.sendAnalyticsEvent = sendAnalyticsEvent;
        }
        static getInstance() {
            if (!$0ff262dad5216a84$var$ExperienceTrackerHandler.instance) $0ff262dad5216a84$var$ExperienceTrackerHandler.instance = new $0ff262dad5216a84$var$ExperienceTrackerHandler();
            return $0ff262dad5216a84$var$ExperienceTrackerHandler.instance;
        }
    }
    const $0ff262dad5216a84$export$412c53791574f6f0 = (params)=>{
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            const experienceTracker = $0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance();
            experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
        }, [
            sendAnalyticsEvent
        ]);
        const experienceTrackerProxy = (0, $5uXOq.useMemo)(()=>{
            const proxyHandler = {
                get: (target, prop)=>{
                    if (prop === 'fail') return (failParams)=>{
                        target.fail({
                            ...failParams,
                            attributes: {
                                ...failParams.attributes,
                                touchpointSource: params?.touchpointSource
                            }
                        });
                    };
                    return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
                }
            };
            return new Proxy($0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
        }, [
            params?.touchpointSource
        ]);
        return experienceTrackerProxy;
    };
});
parcelRegister("jXUCh", function(module, exports) {
    $parcel$export(module.exports, "isClientFetchError", ()=>$750b6f13fd837870$export$2e7adc44463c3f4f);
    const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS = [
        '... is not valid JSON',
        'server with the specified hostname could not be found',
        'cannot parse response',
        'connection failure',
        'Failed to fetch',
        'in JSON at position 0',
        'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
        'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
        'Load failed',
        'Network request failed',
        'NetworkError',
        'Syntax or http error',
        'The request timed out',
        'The network connection was lost',
        'The operation was aborted',
        'Unable to fetch manifest',
        'Unexpected end of input',
        'Unexpected end of JSON input',
        'dynamically imported module',
        'Importing a module script failed'
    ];
    const $750b6f13fd837870$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$750b6f13fd837870$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
    const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES = [
        'AbortError',
        'AuthError',
        'ChunkLoadError',
        'NetworkError'
    ];
    const $750b6f13fd837870$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.cause.message)));
});
parcelRegister("3kN8f", function(module, exports) {
    $parcel$export(module.exports, "setupSentryClient", ()=>$083186225bc5f71c$export$d8bd0edf6c978788);
    $parcel$export(module.exports, "logException", ()=>$083186225bc5f71c$export$f86b2a1a2ce291b3);
    var $5AZpC;
    var $jXUCh;
    var $9It69;
    var $2aeVO;
    const $083186225bc5f71c$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("8Xuap")));
    let $083186225bc5f71c$var$sentryClient;
    const $083186225bc5f71c$var$DISABLED_INTEGRATIONS = [
        'onerror',
        'onunhandledrejection',
        'Dedupe'
    ];
    const $083186225bc5f71c$var$getEnvironment = ()=>{
        return 'production';
    };
    const $083186225bc5f71c$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride } = {})=>{
        let accountId = 'UNKNOWN_AAID';
        let product = productOverride ?? (0, (0, parcelRequire("9It69")).getRovoChatProduct)();
        try {
            const profileData = await (0, (0, parcelRequire("5AZpC")).performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        } catch (_) {}
        if ($083186225bc5f71c$var$sentryClient) {
            $083186225bc5f71c$var$sentryClient.setTag('product', product);
            $083186225bc5f71c$var$sentryClient.setUser({
                id: accountId
            });
            return;
        }
        let importedSentry;
        try {
            importedSentry = await $083186225bc5f71c$var$importSentryAsync();
        } catch (e) {
            console.warn('Failed to load conversation-assistant sentry', e);
            return;
        }
        const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
        importedSentry.init({
            dsn: customSentryDsn || defaultSentryDsn,
            environment: $083186225bc5f71c$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $083186225bc5f71c$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: packageName || '@atlassian/conversation-assistant',
                    product: product
                }
            },
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                if ((0, (0, parcelRequire("jXUCh")).isClientFetchError)(exception)) return null;
                if (!event.tags?.name) return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com')) return null;
                    updatedEvent.request.url = (0, (0, parcelRequire("2aeVO")).normaliseUrl)(updatedEvent.request.url);
                }
                return updatedEvent;
            },
            attachStacktrace: true
        });
        $083186225bc5f71c$var$sentryClient = importedSentry;
    };
    const $083186225bc5f71c$var$getSentryClient = async ()=>{
        if (!$083186225bc5f71c$var$sentryClient) await $083186225bc5f71c$export$d8bd0edf6c978788();
        return $083186225bc5f71c$var$sentryClient;
    };
    const $083186225bc5f71c$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
        const sentryClient = await $083186225bc5f71c$var$getSentryClient();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            scope.setTag('name', name);
            if (tags) scope.setTags(tags);
            sentryClient.captureException(exception, scope);
        });
    };
});
parcelRegister("5AZpC", function(module, exports) {
    $parcel$export(module.exports, "performHttpFetch", ()=>$e3205999c8add5e6$export$a38d93aa782475f6);
    var $b0RFn;
    class $e3205999c8add5e6$var$HttpApiError extends Error {
        constructor(message, errorAttributes){
            super(message), this.message = message, this.errorAttributes = errorAttributes;
        }
    }
    const $e3205999c8add5e6$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
        try {
            const response = await fetch(path, options);
            if (!response.ok || response.status >= 400) await $e3205999c8add5e6$var$processHttpErrorResponse({
                response: response
            });
            return await response.json();
        } catch (err) {
            throw new (0, (0, parcelRequire("b0RFn")).FetchError)(`performHttpFetch error whle fetching ${path}`, {
                cause: err
            });
        }
    };
    const $e3205999c8add5e6$var$processHttpErrorResponse = async ({ response: response })=>{
        throw new $e3205999c8add5e6$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
            statusCode: response.status
        });
    };
});
parcelRegister("b0RFn", function(module, exports) {
    $parcel$export(module.exports, "FetchError", ()=>$b201945370d0e866$export$26e841bcf1aeb894);
    class $b201945370d0e866$export$26e841bcf1aeb894 extends Error {
        constructor(message, cause){
            super(message), this.cause = cause;
            this.name = 'FetchError';
            if (cause) this.cause = cause;
        }
    }
});
parcelRegister("9It69", function(module, exports) {
    $parcel$export(module.exports, "getRovoChatProduct", ()=>$8e07af78c7c996fd$export$d4fdfa93c283ffc);
    const $8e07af78c7c996fd$export$d4fdfa93c283ffc = ()=>{
        let product = 'UNKNOWN';
        if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
        return product;
    };
});
parcelRegister("2aeVO", function(module, exports) {
    $parcel$export(module.exports, "normaliseUrl", ()=>$f1e1fab54a39e125$export$d57ae76c6dc57a5);
    const $f1e1fab54a39e125$var$pathnamePrefixes = [
        '/jira/',
        '/wiki/',
        '/browse/'
    ];
    const $f1e1fab54a39e125$var$ATLAS_HOST = 'home.atlassian.com';
    const $f1e1fab54a39e125$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
    const $f1e1fab54a39e125$export$d57ae76c6dc57a5 = (url)=>{
        try {
            let parsedUrl = new URL(url);
            let normalizedPath = '/any/';
            if (parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_HOST || parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_TEAM_HOST) normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
            const prefixRegex = new RegExp(`^(${$f1e1fab54a39e125$var$pathnamePrefixes.join('|')})`);
            if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
            const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
            return normalizedUrl;
        } catch (error) {
            return 'https://could-not-parse.example.com';
        }
    };
});
parcelRegister("7qdbi", function(module, exports) {
    $parcel$export(module.exports, "setRovoChatProduct", ()=>$247284f3c41a7fa5$export$caa27b16709bc2df);
    const $247284f3c41a7fa5$export$caa27b16709bc2df = (product)=>{
        if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
    };
});
parcelRegister("cNqSS", function(module, exports) {
    $parcel$export(module.exports, "readJsonStream", ()=>$2504014003f7f3a1$export$1f24b2b263bcfa75);
    var $2uI0R;
    async function* $2504014003f7f3a1$export$1f24b2b263bcfa75(response) {
        const reader = (0, (0, parcelRequire("2uI0R")).getBufferReader)(response);
        let doneStreaming = false;
        let remainder = '';
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            if (value) try {
                const processedChunks = `${remainder}${value}`.split('\n');
                remainder = '';
                for (let chunk of processedChunks)try {
                    yield JSON.parse(chunk);
                } catch (e) {
                    remainder = chunk;
                }
            } catch (e) {
                const error = new Error(`Error Processing Stream Data: ${value}`);
                throw error;
            }
        } catch (e) {
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else throw e;
        }
        while (!doneStreaming)
    }
});
parcelRegister("2uI0R", function(module, exports) {
    $parcel$export(module.exports, "getBufferReader", ()=>$2735314bca0a1e9a$export$f6383c3ea1307da9);
    const $2735314bca0a1e9a$export$f6383c3ea1307da9 = (response)=>{
        if (!response.body) throw new Error('Response body is empty');
        return response.body.pipeThrough(new TextDecoderStream()).getReader();
    };
});
parcelRegister("4c7JV", function(module, exports) {
    $parcel$export(module.exports, "isHumanMessage", ()=>$228fb1e7a583589a$export$a69fab2afb88c2eb);
    $parcel$export(module.exports, "isAssistantMessage", ()=>$228fb1e7a583589a$export$6f965deda7f0960c);
    $parcel$export(module.exports, "isStreamResponse", ()=>$228fb1e7a583589a$export$b4631726cbc1440a);
    $parcel$export(module.exports, "isAgentResponse", ()=>$228fb1e7a583589a$export$a6e5100ca2770191);
    $parcel$export(module.exports, "isStreamError", ()=>$228fb1e7a583589a$export$d422a2733a3b5def);
    $parcel$export(module.exports, "isStreamAUPError", ()=>$228fb1e7a583589a$export$1e1cf807ece63df4);
    $parcel$export(module.exports, "isStreamAnswerPart", ()=>$228fb1e7a583589a$export$e45102edbc73b240);
    $parcel$export(module.exports, "isStreamTrace", ()=>$228fb1e7a583589a$export$fd5a05be03f147a0);
    $parcel$export(module.exports, "isStreamPluginInvocation", ()=>$228fb1e7a583589a$export$51a1b4e474708d74);
    $parcel$export(module.exports, "isFollowUpMessage", ()=>$228fb1e7a583589a$export$aeae5b4fda357302);
    $parcel$export(module.exports, "isChannelNotFoundError", ()=>$228fb1e7a583589a$export$6ce1ccc24e75456f);
    $parcel$export(module.exports, "isRateLimitedError", ()=>$228fb1e7a583589a$export$bc96a6a479480590);
    $parcel$export(module.exports, "isConversationChannelDataMessage", ()=>$228fb1e7a583589a$export$b454081350f4a578);
    var $gRLdW;
    const $228fb1e7a583589a$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
    const $228fb1e7a583589a$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
    const $228fb1e7a583589a$export$fb661125ffb29bd6 = (message)=>{
        return $228fb1e7a583589a$export$a69fab2afb88c2eb(message) || $228fb1e7a583589a$export$6f965deda7f0960c(message) || $228fb1e7a583589a$export$b4631726cbc1440a(message);
    };
    const $228fb1e7a583589a$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
    const $228fb1e7a583589a$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
    const $228fb1e7a583589a$export$a6e5100ca2770191 = (message)=>message instanceof Object && $228fb1e7a583589a$export$6f965deda7f0960c(message.message);
    const $228fb1e7a583589a$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
    const $228fb1e7a583589a$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
    const $228fb1e7a583589a$export$1e1cf807ece63df4 = (message)=>$228fb1e7a583589a$export$d422a2733a3b5def(message) && message.message?.message_template === $228fb1e7a583589a$export$c424fe9570a5f2d9;
    const $228fb1e7a583589a$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
    const $228fb1e7a583589a$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
    const $228fb1e7a583589a$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
    const $228fb1e7a583589a$export$821c27cda9a33379 = (message)=>message instanceof Object && message.role === 'PLUGIN_INVOCATION';
    const $228fb1e7a583589a$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
    const $228fb1e7a583589a$export$6ce1ccc24e75456f = (error)=>(0, (0, parcelRequire("gRLdW")).isApiError)(error) && error.errorAttributes?.errorCode === $228fb1e7a583589a$export$5945515082cc2cbf;
    const $228fb1e7a583589a$export$bc96a6a479480590 = (error)=>(0, (0, parcelRequire("gRLdW")).isApiError)(error) && error.errorAttributes.statusCode === 429;
    const $228fb1e7a583589a$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
});
parcelRegister("gRLdW", function(module, exports) {
    $parcel$export(module.exports, "ApiError", ()=>$884e41a84621b493$export$f2e832acab1bdd79);
    $parcel$export(module.exports, "isApiError", ()=>$884e41a84621b493$export$89d83cc97c52a37);
    $parcel$export(module.exports, "mapErrorToApiError", ()=>$884e41a84621b493$export$3c02d1a328d4d808);
    class $884e41a84621b493$export$f2e832acab1bdd79 extends Error {
        constructor(message, errorAttributes){
            super(message), this.message = message, this.errorAttributes = errorAttributes;
        }
    }
    const $884e41a84621b493$export$89d83cc97c52a37 = (error)=>error instanceof $884e41a84621b493$export$f2e832acab1bdd79;
    const $884e41a84621b493$export$3c02d1a328d4d808 = (error)=>{
        if ($884e41a84621b493$export$89d83cc97c52a37(error)) return error;
        return new $884e41a84621b493$export$f2e832acab1bdd79(error.message, {
            statusCode: 0
        });
    };
});
parcelRegister("lb2g6", function(module, exports) {
    $parcel$export(module.exports, "addPath", ()=>$d75893d8e1262208$export$4c25481b843feb0b);
    $parcel$export(module.exports, "getTraceIdFromResponse", ()=>$d75893d8e1262208$export$9f229e40eb65abfc);
    $parcel$export(module.exports, "processResponse", ()=>$d75893d8e1262208$export$21fcb6cfd5628534);
    var $gRLdW;
    const $d75893d8e1262208$export$4c25481b843feb0b = (baseUrl, path)=>{
        if (path === '') return baseUrl;
        const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
        const url = [
            urlWithTrailingSlash,
            pathWithoutLeadingSlash
        ].join('');
        return url;
    };
    const $d75893d8e1262208$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
    const $d75893d8e1262208$var$processErrorResponse = async ({ response: response })=>{
        let errorCode;
        let outputErrorMessage;
        const responseText = await response.text();
        let rawErrorMessage;
        try {
            const errorBodyJson = JSON.parse(responseText);
            const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage } = errorBodyJson;
            rawErrorMessage = errorMessage ?? error_message;
            if (errors?.length) errorCode = errors[0];
            else if (error_code) errorCode = error_code;
            else errorCode = message_template;
            if (!errorCode || !rawErrorMessage) outputErrorMessage = responseText;
            else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
        } catch (err) {
            outputErrorMessage = responseText;
        }
        throw new (0, (0, parcelRequire("gRLdW")).ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
            errorCode: errorCode,
            statusCode: response.status,
            rawErrorMessage: rawErrorMessage,
            traceId: $d75893d8e1262208$export$9f229e40eb65abfc(response)
        });
    };
    const $d75893d8e1262208$export$21fcb6cfd5628534 = async ({ response: response })=>{
        if (!response.ok || response.status >= 400) await $d75893d8e1262208$var$processErrorResponse({
            response: response
        });
        return response;
    };
});
parcelRegister("khfvG", function(module, exports) {
    $parcel$export(module.exports, "generateConversationName", ()=>$1d5a08981e582a14$export$11cc4786742ed7c2);
    const $1d5a08981e582a14$export$11cc4786742ed7c2 = ()=>{
        const date = new Date();
        const formattedDate = date.toLocaleDateString(undefined, {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
        });
        const formattedTime = date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const name = `${formattedDate} ${formattedTime}`;
        return name;
    };
});
parcelRegister("3zcGU", function(module, exports) {
    $parcel$export(module.exports, "getId", ()=>$c587188fcee2b8b3$export$218c8c3169c024d2);
    $parcel$export(module.exports, "updatePluginInvocation", ()=>$c587188fcee2b8b3$export$a76cc257b3881cb7);
    $parcel$export(module.exports, "addAnswerPart", ()=>$c587188fcee2b8b3$export$6e5609c05ab74cc7);
    $parcel$export(module.exports, "removeSensitiveData", ()=>$c587188fcee2b8b3$export$efd4f6b5d168b654);
    $parcel$export(module.exports, "createHumanMessage", ()=>$c587188fcee2b8b3$export$4010f996e89e886a);
    $parcel$export(module.exports, "toStreamResponse", ()=>$c587188fcee2b8b3$export$3220a4ff7b3a96df);
    var $4c7JV;
    const $c587188fcee2b8b3$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
    const $c587188fcee2b8b3$var$updatePluginInvocationAssistantMessage = (response, streamPluginInvocation)=>{
        const { message: pluginInvocation } = streamPluginInvocation;
        const pluginInvocationMessage = {
            message_id: response.id,
            ...pluginInvocation
        };
        const updatedMessage = {
            ...response
        };
        const updatedPluginInvocations = [
            ...updatedMessage.plugin_invocations
        ];
        const currentIndex = updatedPluginInvocations.findIndex((pi)=>pi.plugin_name === pluginInvocationMessage.plugin_name);
        if (currentIndex === -1) updatedPluginInvocations.push(pluginInvocationMessage);
        else updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
        updatedMessage.plugin_invocations = updatedPluginInvocations;
        return updatedMessage;
    };
    const $c587188fcee2b8b3$var$updatePluginInvocationAgentResponse = (response, streamPluginInvocation)=>({
            ...response,
            message: $c587188fcee2b8b3$var$updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
        });
    const $c587188fcee2b8b3$export$a76cc257b3881cb7 = (response, streamPluginInvocation)=>({
            ...response,
            message: $c587188fcee2b8b3$var$updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
        });
    const $c587188fcee2b8b3$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
        const content = `${response.content}${answerPart.message.content}`;
        const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
        return {
            ...response,
            content: cleanedContent
        };
    };
    const $c587188fcee2b8b3$var$addAnswerPartAgentResponse = (response, answerPart)=>({
            ...response,
            message: $c587188fcee2b8b3$var$addAnswerPartAssistantMessage(response.message, answerPart)
        });
    const $c587188fcee2b8b3$export$6e5609c05ab74cc7 = (response, answerPart)=>({
            ...response,
            message: $c587188fcee2b8b3$var$addAnswerPartAgentResponse(response.message, answerPart)
        });
    const $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage = (message)=>{
        const { plugin_invocations: plugin_invocations, ...rest } = message;
        return {
            ...rest,
            plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                    ...pluginInvocation,
                    plugin_output: '--PRIVATE--'
                }))
        };
    };
    const $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse = (message)=>({
            ...message,
            message: $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage(message.message)
        });
    const $c587188fcee2b8b3$export$efd4f6b5d168b654 = (message)=>({
            ...message,
            message: $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse(message.message)
        });
    const $c587188fcee2b8b3$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId)=>{
        return {
            role: 'HUMAN',
            id: id,
            content: content,
            time_created: new Date().toISOString(),
            user_ari: 'unknown',
            plugin_invocations: [],
            isFromSeededConversation: isFromSeededConversation,
            requestId: requestId
        };
    };
    const $c587188fcee2b8b3$export$3220a4ff7b3a96df = (message)=>{
        if ((0, (0, parcelRequire("4c7JV")).isAgentResponse)(message)) return {
            type: 'FINAL_RESPONSE',
            message: message
        };
        return {
            type: 'FINAL_RESPONSE',
            message: {
                message: message
            }
        };
    };
    const $c587188fcee2b8b3$export$6304914e90dcefe0 = ()=>({
            account_id: '',
            cloud_id: '',
            env: '',
            env_type: '',
            model: '',
            ai_enabled_on_site: false,
            assistance_feature_enabled: false,
            debug_enabled: false
        });
});
parcelRegister("f7UWp", function(module, exports) {
    $parcel$export(module.exports, "fetchFn", ()=>$083f568d1e8b8dc8$export$10f0d162cb6dae7c);
    const $083f568d1e8b8dc8$export$10f0d162cb6dae7c = window.fetch;
});
parcelRegister("4ojTZ", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$667e963723dc9f11$export$dd0a697e1782aedd);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $VSDnB;
    var $gRLdW;
    const $667e963723dc9f11$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            cache: {}
        },
        actions: {
            updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                    const state = getState();
                    const currentCacheEntry = state.cache[key] ?? {
                        data: null,
                        error: null,
                        isFetching: false
                    };
                    const newCacheEntry = {
                        ...currentCacheEntry,
                        ...value
                    };
                    setState({
                        cache: {
                            ...state.cache,
                            [key]: newCacheEntry
                        }
                    });
                },
            getCacheEntry: (key)=>({ getState: getState })=>{
                    const state = getState();
                    return state.cache[key];
                }
        }
    });
    const $667e963723dc9f11$var$selector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
            data: null,
            error: null,
            isFetching: false
        });
    const $667e963723dc9f11$var$useCacheEntry = (0, (0, parcelRequire("3sQ5x")).createHook)($667e963723dc9f11$var$store, {
        selector: $667e963723dc9f11$var$selector
    });
    const $667e963723dc9f11$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
        const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
        const queryFnRef = (0, $5uXOq.useRef)(queryFn);
        queryFnRef.current = queryFn;
        const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
        onSuccessRef.current = onSuccess;
        const onErrorRef = (0, $5uXOq.useRef)(onError);
        onErrorRef.current = onError;
        const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $667e963723dc9f11$var$useCacheEntry(queryKey);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            updateCacheEntry(queryKey, {
                isFetching: true
            });
            try {
                const response = await queryFnRef.current();
                updateCacheEntry(queryKey, {
                    data: response
                });
                onSuccessRef.current?.(response);
                return response;
            } catch (error) {
                const apiError = (0, (0, parcelRequire("gRLdW")).mapErrorToApiError)(error);
                updateCacheEntry(queryKey, {
                    error: apiError
                });
                onErrorRef.current?.(apiError);
            } finally{
                updateCacheEntry(queryKey, {
                    isFetching: false
                });
            }
            return null;
        }, [
            updateCacheEntry,
            queryKey
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (enabled && refetchOnWindowFocus) {
                const unbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: (0, (0, parcelRequire("VSDnB")).fg)('rovo_refocus_use_visibilitychange') ? 'visibilitychange' : 'focus',
                    listener: ()=>{
                        if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_refocus_use_visibilitychange')) {
                                if (document.visibilityState === 'visible') fetchData();
                            } else fetchData();
                        }
                    }
                });
                return unbind;
            }
        }, [
            enabled,
            fetchData,
            getCacheEntry,
            queryKey,
            refetchOnWindowFocus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!getCacheEntry(queryKey) && enabled) fetchData();
        }, [
            queryKey,
            fetchData,
            enabled,
            getCacheEntry
        ]);
        return {
            data: cache.data,
            error: cache.error,
            isFetching: cache.isFetching,
            refetch: fetchData
        };
    };
});
parcelRegister("7m1xZ", function(module, exports) {
    $parcel$export(module.exports, "useDialog", ()=>$a473b7b94d8a74c9$export$d55e7ee900f34e93);
    var $5uXOq = parcelRequire("5uXOq");
    var $jEb7N;
    const $a473b7b94d8a74c9$export$d55e7ee900f34e93 = ()=>{
        return (0, $5uXOq.useContext)((0, (0, parcelRequire("jEb7N")).DialogsContext));
    };
});
parcelRegister("aOf1o", function(module, exports) {
    $parcel$export(module.exports, "useExpTrackerStart", ()=>$9471edc08800666d$export$3ec42c6cc9df311c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LvDD;
    var $38ra6;
    function $9471edc08800666d$export$3ec42c6cc9df311c(options) {
        const { id: id, name: name, timeout: timeout, isTriggerOnMount: isTriggerOnMount = true, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const tracker = analytics.expTracker();
        const triggerStartEvent = (0, $5uXOq.useCallback)(()=>{
            const options = {
                id: id,
                name: name,
                timeout: timeout,
                collect: undefined,
                attributes: startAttributes,
                onSuccess: onSuccess
            };
            if (subExperiences) options.collect = (0, (0, parcelRequire("5LvDD")).collectAll)(subExperiences);
            if (latencySloMs) options.attributes = {
                latencySlo: latencySloMs
            };
            tracker.start(options);
        }, [
            id,
            name,
            timeout,
            startAttributes,
            onSuccess,
            subExperiences,
            latencySloMs,
            tracker
        ]);
        const triggerSuccessEvent = (0, $5uXOq.useCallback)(()=>{
            tracker.succeed({
                name: name
            });
        }, [
            name,
            tracker
        ]);
        const triggerFailEvent = (0, $5uXOq.useCallback)((error)=>{
            tracker.stopOnError({
                name: name,
                error: error
            });
        }, [
            name,
            tracker
        ]);
        const triggerAbortEvent = (0, $5uXOq.useCallback)((reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        }, [
            name,
            tracker
        ]);
        (0, $5uXOq.useState)(()=>{
            if (isTriggerOnMount) triggerStartEvent();
        });
        return {
            start: triggerStartEvent,
            succeed: triggerSuccessEvent,
            abort: triggerAbortEvent,
            fail: triggerFailEvent
        };
    }
});
parcelRegister("5LvDD", function(module, exports) {
    $parcel$export(module.exports, "collectAll", ()=>$e8cb564f08d00082$export$feb7963ae429f97f);
    $parcel$export(module.exports, "collectAny", ()=>$e8cb564f08d00082$export$79dbdd3e43727beb);
    var $hhYjW;
    function $e8cb564f08d00082$export$feb7963ae429f97f(experienceNames) {
        const experienceNameSet = new Set(experienceNames);
        return (events, experience)=>{
            experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
            events.forEach((event)=>{
                if ((0, (0, parcelRequire("hhYjW")).isStop)(event)) experienceNameSet.delete(event.name);
            });
            if (experienceNameSet.size === 0) experience.succeed();
        };
    }
    function $e8cb564f08d00082$export$79dbdd3e43727beb(experienceNames) {
        return (events, experience)=>experience.stopOn(events.find((event)=>(0, (0, parcelRequire("hhYjW")).isStop)(event) && (0, (0, parcelRequire("hhYjW")).hasName)(event, ...experienceNames)));
    }
});
parcelRegister("lHKVj", function(module, exports) {
    $parcel$export(module.exports, "useExpTrackerStop", ()=>$0116da51a3eb5ecd$export$432668e70196929c);
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $38ra6;
    function $0116da51a3eb5ecd$export$432668e70196929c(options) {
        const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const tracker = analytics.expTracker();
        (0, $5uXOq.useEffect)(()=>{
            const triggerStopEvent = ()=>{
                if (!error) return;
                if ($0116da51a3eb5ecd$var$isRateLimitError(error)) {
                    abortExpTracker(`Ignoring 429 error: ${error.message}`);
                    return;
                }
                tracker.stopOnError({
                    name: name,
                    error: error
                });
            };
            const abortExpTracker = (reason)=>{
                tracker.abort({
                    name: name,
                    reason: reason
                });
            };
            if (error) {
                const reason = checkShouldAbort ? checkShouldAbort(error) : undefined;
                if (typeof reason === 'string' || $0116da51a3eb5ecd$var$isRateLimitError(error)) abortExpTracker(reason ?? `Ignoring 429 error: ${error.message}`);
                else triggerStopEvent();
            }
        }, [
            checkShouldAbort,
            error,
            name,
            tracker
        ]);
    }
    const $0116da51a3eb5ecd$var$isRateLimitError = (error)=>{
        if (error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError) && error.networkError) return $0116da51a3eb5ecd$var$isRateLimitError(error.networkError);
        return 'statusCode' in error && error.statusCode === 429 || 'status' in error && error.status === 429 || error.message.includes('429');
    };
});
parcelRegister("bA8uW", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_TIMEOUT_USER_EXP", ()=>$909c5e43d630b80c$export$6a2b57b882ff619b);
    $parcel$export(module.exports, "UserExperienceNames", ()=>$909c5e43d630b80c$export$aff1d63763bf8a44);
    $parcel$export(module.exports, "TEAM_PROFILE_PAGE_SUB_EVENT_NAMES", ()=>$909c5e43d630b80c$export$f6872ed66cc3dc3a);
    $parcel$export(module.exports, "USER_PROFILE_PAGE_SUB_EVENT_NAMES", ()=>$909c5e43d630b80c$export$e302f7a9166a33eb);
    $parcel$export(module.exports, "SEARCH_HOME_PAGE_SUB_EVENT_NAMES", ()=>$909c5e43d630b80c$export$ab5c192ffd15cb07);
    $parcel$export(module.exports, "CREATE_TEAM_FLOW_SUB_EVENT_NAMES", ()=>$909c5e43d630b80c$export$bebaacf4c0d1b056);
    const $909c5e43d630b80c$export$6a2b57b882ff619b = 60000;
    const $909c5e43d630b80c$export$c816bd9ab77da948 = 15000;
    var $909c5e43d630b80c$export$aff1d63763bf8a44;
    (function(UserExperienceNames) {
        UserExperienceNames["CREATE_TEAM"] = "createTeam";
        UserExperienceNames["CREATE_TEAM_OPEN_DIALOG"] = "createTeam/openDialog";
        UserExperienceNames["CREATE_TEAM_SUBMIT"] = "createTeam/create";
        UserExperienceNames["TEAM_PROFILE_PAGE"] = "teamProfile/render";
        UserExperienceNames["TEAM_PROFILE_MEMBERS"] = "teamProfile/membersPanel";
        UserExperienceNames["TEAM_PROFILE_LINKS"] = "teamProfile/links";
        UserExperienceNames["TEAM_PROFILE_WORKED_ON"] = "teamProfile/workedOn";
        UserExperienceNames["TEAM_PROFILE_TEAM_ABOUT"] = "teamProfile/teamAboutPanel";
        UserExperienceNames["TEAM_PROFILE_PROJECTS_AND_GOALS"] = "teamProfile/projectsAndGoals";
        UserExperienceNames["TEAM_PROFILE_HELP_POINTERS"] = "teamProfile/helpPointers";
        UserExperienceNames["TEAM_PROFILE_KUDOS"] = "teamProfile/kudos";
        UserExperienceNames["TEAM_PROFILE_SOFTWARE_COMPONENTS"] = "teamProfile/softwareComponents";
        UserExperienceNames["USER_PROFILE_AI_TOPICS"] = "userProfile/aiTopics";
        UserExperienceNames["USER_PROFILE_PAGE"] = "userProfile/render";
        UserExperienceNames["USER_PROFILE_PAGE_SLOW"] = "userProfile/renderSlow";
        UserExperienceNames["USER_PROFILE_WORKED_ON"] = "userProfile/workedOn";
        UserExperienceNames["USER_PROFILE_CONTAINERS"] = "userProfile/container";
        UserExperienceNames["USER_PROFILE_USER_ABOUT"] = "userProfile/userAbout";
        UserExperienceNames["USER_PROFILE_COLLABORATORS"] = "userProfile/collaborators";
        UserExperienceNames["USER_PROFILE_USERS_TEAMS"] = "userProfile/usersTeams";
        UserExperienceNames["USER_PROFILE_USER_MANAGER"] = "userProfile/userManager";
        UserExperienceNames["USER_PROFILE_TAG"] = "userProfile/tag";
        UserExperienceNames["SEARCH_HOME_PAGE"] = "searchHomePage/render";
        UserExperienceNames["SEARCH_HOME_PAGE_COLLABORATORS"] = "searchHomePage/collaborators";
        UserExperienceNames["SEARCH_HOME_PAGE_YOUR_TEAMS"] = "searchHomePage/yourTeams";
        UserExperienceNames["USER_PROFILE_PROJECTS_AND_GOALS"] = "userProfile/projectsAndGoals";
        UserExperienceNames["USER_PROFILE_MANAGERS_AND_TEAMS"] = "userProfile/managersAndTeams";
        UserExperienceNames["USER_PROFILE_KUDOS"] = "userProfile/kudos";
        UserExperienceNames["EDIT_TEAM_NAME_OR_DESCRIPTION"] = "editTeamNameOrDescription";
        UserExperienceNames["REMOVE_TEAM_MEMBER"] = "removeTeamMember";
        UserExperienceNames["REMOVE_TEAM_MEMBER_OPEN_DIALOG"] = "removeTeamMember/openDialog";
        UserExperienceNames["REMOVE_TEAM_MEMBER_SUBMIT"] = "removeTeamMember/submit";
        UserExperienceNames["UPLOAD_USER_AVATAR"] = "uploadUserAvatar";
        UserExperienceNames["UPLOAD_HEADER_IMAGE"] = "uploadHeaderImage";
        UserExperienceNames["MEMBERSHIP_CONTROL_CHANGE"] = "membershipControl/change";
        UserExperienceNames["MEMBERSHIP_CONTROL_HANDLE_REQUESTS"] = "membershipControl/handleRequests";
        UserExperienceNames["MEMBERSHIP_CONTROL_TEAM_TYPE"] = "membershipControl/teamType";
        UserExperienceNames["AGENT_PROFILE_PAGE"] = "agentProfile/render";
    })($909c5e43d630b80c$export$aff1d63763bf8a44 || ($909c5e43d630b80c$export$aff1d63763bf8a44 = {}));
    const $909c5e43d630b80c$export$f6872ed66cc3dc3a = [
        "teamProfile/membersPanel",
        "teamProfile/links",
        "teamProfile/workedOn",
        "teamProfile/teamAboutPanel"
    ];
    const $909c5e43d630b80c$export$e302f7a9166a33eb = [
        "userProfile/userAbout",
        "userProfile/usersTeams",
        "userProfile/workedOn",
        "userProfile/container",
        "userProfile/collaborators"
    ];
    const $909c5e43d630b80c$export$ab5c192ffd15cb07 = [
        "searchHomePage/collaborators",
        "searchHomePage/yourTeams"
    ];
    const $909c5e43d630b80c$export$bebaacf4c0d1b056 = [
        "createTeam/openDialog",
        "createTeam/create"
    ];
    const $909c5e43d630b80c$export$74d8df99c7474c3b = [
        "removeTeamMember/openDialog",
        "removeTeamMember/submit"
    ];
});
parcelRegister("7YTpJ", function(module, exports) {
    $parcel$export(module.exports, "filterExcludedMessages", ()=>$70081da22e1ca189$export$c29ee7cc86cf93b3);
    $parcel$export(module.exports, "ORG_ARI_PREFIX", ()=>$70081da22e1ca189$export$1c01d3601a97c3b);
    $parcel$export(module.exports, "fromV2ToTeamSearchViewFormat", ()=>$70081da22e1ca189$export$af61e778dfb162b1);
    $parcel$export(module.exports, "trimUserARI", ()=>$70081da22e1ca189$export$4fd803d471120b8f);
    const $70081da22e1ca189$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES = [
        'TeamDeleted'
    ];
    function $70081da22e1ca189$export$c29ee7cc86cf93b3(errors) {
        return errors.filter((error)=>$70081da22e1ca189$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES.every((excludedMessage)=>!error.message.includes(excludedMessage)) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED');
    }
    const $70081da22e1ca189$export$ec4e6762fd0f4a48 = 'ari:cloud:teams::team/';
    const $70081da22e1ca189$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
    const $70081da22e1ca189$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
    const $70081da22e1ca189$export$1c01d3601a97c3b = 'ari:cloud:platform::org/';
    const $70081da22e1ca189$export$af61e778dfb162b1 = (nodes)=>{
        return nodes.map((node)=>{
            return {
                id: $70081da22e1ca189$export$5916b2f8faacfe5a(node.team.id),
                orgId: node.team.organizationId,
                membershipSettings: node.team.membershipSettings,
                description: node.team.description,
                displayName: node.team.displayName,
                state: node.team.state,
                largeAvatarImageUrl: node.team.largeAvatarImageUrl,
                smallAvatarImageUrl: node.team.smallAvatarImageUrl,
                largeHeaderImageUrl: node.team.largeHeaderImageUrl,
                smallHeaderImageUrl: node.team.smallHeaderImageUrl,
                members: node.team.members?.nodes?.filter((memberNode)=>memberNode.member?.id)?.map((memberNode)=>({
                        id: $70081da22e1ca189$export$4fd803d471120b8f(memberNode.member?.id),
                        status: memberNode.member?.accountStatus,
                        fullName: memberNode.member?.name || '',
                        avatarUrl: memberNode.member?.picture
                    })),
                memberCount: node.memberCount,
                includesYou: node.includesYou,
                isVerified: node.team.isVerified
            };
        });
    };
    const $70081da22e1ca189$export$5916b2f8faacfe5a = (teamId = '')=>{
        return teamId.replace($70081da22e1ca189$export$cfedc369802e0c68, '').replace($70081da22e1ca189$export$ec4e6762fd0f4a48, '');
    };
    const $70081da22e1ca189$export$4fd803d471120b8f = (userId = '')=>{
        return userId.replace($70081da22e1ca189$export$470b0d72e4fdc43a, '');
    };
    const $70081da22e1ca189$export$a94a044414e86bdc = (orgId)=>{
        return orgId?.replace($70081da22e1ca189$export$1c01d3601a97c3b, '');
    };
});
parcelRegister("8ZB0E", function(module, exports) {
    $parcel$export(module.exports, "useRovoAgentData", ()=>$4edf914651e30a7b$export$763c7f4444e7eb2d);
    var $3sQ5x;
    var $iXqE5;
    const $4edf914651e30a7b$var$setAgentInfo = (data)=>({ setState: setState })=>{
            setState({
                agentData: data
            });
        };
    const $4edf914651e30a7b$var$actions = {
        setAgentInfo: $4edf914651e30a7b$var$setAgentInfo
    };
    const $4edf914651e30a7b$var$RovoAgentStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            agentData: undefined
        },
        actions: $4edf914651e30a7b$var$actions
    });
    const $4edf914651e30a7b$export$6301922aaad7e8f5 = (0, (0, parcelRequire("3sQ5x")).createHook)($4edf914651e30a7b$var$RovoAgentStore, {
        selector: (state)=>state.agentData
    });
    const $4edf914651e30a7b$export$763c7f4444e7eb2d = (0, (0, parcelRequire("3sQ5x")).createHook)($4edf914651e30a7b$var$RovoAgentStore);
});
parcelRegister("3UaSs", function(module, exports) {
    $parcel$export(module.exports, "App", ()=>$83a3ab3c620955c6$export$86fbec116b87613f);
    $parcel$export(module.exports, "RelativeWrapperOfHeaderImage", ()=>$83a3ab3c620955c6$export$c0d0370fa0c37541);
    var $47bDC = parcelRequire("47bDC");
    const $83a3ab3c620955c6$export$86fbec116b87613f = (0, $47bDC.default).div.withConfig({
        componentId: "ccxr90-0"
    })`height:100%;*{box-sizing:border-box;}a:hover{text-decoration:none;}`;
    const $83a3ab3c620955c6$export$c0d0370fa0c37541 = (0, $47bDC.default).div.withConfig({
        componentId: "ccxr90-1"
    })`position:relative;`;
});
parcelRegister("2FwA3", function(module, exports) {
    $parcel$export(module.exports, "useAppConfig", ()=>$4d516aa0d4ed8764$export$a3e0ece8c3f698d7);
    $parcel$export(module.exports, "default", ()=>$4d516aa0d4ed8764$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $4d516aa0d4ed8764$var$error = new Error('AppConfigProvider is not found in higher components');
    const $4d516aa0d4ed8764$var$defaultState = {
        addFlag: ()=>{
            throw $4d516aa0d4ed8764$var$error;
        },
        push: ()=>{
            throw $4d516aa0d4ed8764$var$error;
        },
        replace: ()=>{
            throw $4d516aa0d4ed8764$var$error;
        },
        history: undefined,
        contextSpaPaths: [],
        contextEntryPoint: '',
        docTitle: {},
        appName: '',
        productName: '',
        env: undefined,
        cloudId: '',
        isJiraAvailable: false,
        productFeatureFlags: {},
        orgId: undefined
    };
    const $4d516aa0d4ed8764$var$AppConfigContext = (0, ($parcel$interopDefault($5uXOq))).createContext($4d516aa0d4ed8764$var$defaultState);
    const $4d516aa0d4ed8764$export$a3e0ece8c3f698d7 = ()=>{
        return (0, $5uXOq.useContext)($4d516aa0d4ed8764$var$AppConfigContext);
    };
    var $4d516aa0d4ed8764$export$2e2bcd8739ae039 = $4d516aa0d4ed8764$var$AppConfigContext;
});
parcelRegister("9zycQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e61ddbfe684411c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fff3y;
    var $h6cEF;
    var $8sQBu;
    var $dXPcV;
    function $e61ddbfe684411c0$var$ContainersInProfilePage(props) {
        const { userId: userId, status: status, userFullName: userFullName } = props;
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const { error: error, hasError: hasError, data: data, loading: loading } = (0, (0, parcelRequire("dXPcV")).default)({
            userId: userId,
            maxNumberOfCards: (0, (0, parcelRequire("h6cEF")).DEFAULT_CARDS_SIZE)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8sQBu")).default), {
            hasLoaded: !!data && !loading,
            isCurrentUser: principalUserId === userId,
            userStatus: status,
            hasError: hasError,
            error: error,
            items: data,
            userId: userId,
            userFullName: userFullName
        });
    }
    var $e61ddbfe684411c0$export$2e2bcd8739ae039 = $e61ddbfe684411c0$var$ContainersInProfilePage;
});
parcelRegister("h6cEF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CARDS_SIZE", ()=>$64e4aa33d08e84c4$export$eea11e2ee6ebb03f);
    var $8sQBu;
    const $64e4aa33d08e84c4$export$eea11e2ee6ebb03f = 4;
});
parcelRegister("8sQBu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aebc9202d6bd8a73$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $bA8uW;
    var $jDqI3;
    var $aOf1o;
    var $lHKVj;
    var $afcOx;
    var $h4k2d;
    var $hIjCF;
    var $36A8W;
    var $49Zpb;
    const $aebc9202d6bd8a73$var$MAX_PLACES_LIMIT = 50;
    function $aebc9202d6bd8a73$var$ProfilePlaces(props) {
        const { hasError: hasError, error: error, hasLoaded: hasLoaded, isCurrentUser: isCurrentUser, userStatus: userStatus, items: items = [], userId: userId, userFullName: userFullName } = props;
        (0, (0, parcelRequire("aOf1o")).useExpTrackerStart)({
            id: userId,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_CONTAINERS,
            timeout: (0, (0, parcelRequire("bA8uW")).DEFAULT_TIMEOUT_USER_EXP)
        });
        (0, (0, parcelRequire("lHKVj")).useExpTrackerStop)({
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_CONTAINERS,
            error: error
        });
        const renderSkeleton = ()=>{
            const defaultNumOfPlaces = 4;
            return Array(defaultNumOfPlaces).fill(undefined).map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36A8W")).default), {
                    key: `item-${index}`,
                    type: "space",
                    name: "",
                    path: "",
                    hasLoaded: false
                }));
        };
        const renderPlacesList = ()=>{
            const places = items.slice(0, $aebc9202d6bd8a73$var$MAX_PLACES_LIMIT);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("49Zpb")).ProfilePlacesList, {
                "data-test-selector": "profile-places"
            }, hasLoaded ? places.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36A8W")).default), {
                    key: `${item.type}-${item.name}`,
                    type: item.type,
                    name: item.name,
                    path: item.path,
                    icon: item.icon,
                    hasLoaded: true
                })) : renderSkeleton());
        };
        const headline = isCurrentUser ? $aebc9202d6bd8a73$export$defe85febe8b728c.ownerHeadline : userStatus === (0, (0, parcelRequire("afcOx")).UserStatus).inactive || userStatus === (0, (0, parcelRequire("afcOx")).UserStatus).closed ? $aebc9202d6bd8a73$export$defe85febe8b728c.otherHeadlinePast : $aebc9202d6bd8a73$export$defe85febe8b728c.otherHeadline;
        if (hasLoaded && !hasError && items.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), headline))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("49Zpb")).EmptyPlacesList, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h4k2d")).default), {
            isCurrentUser: isCurrentUser || false,
            userFullName: userFullName,
            userStatus: userStatus
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDqI3")).ExperienceSuccess), {
            hasLoaded: true,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_CONTAINERS
        }));
        if (hasError) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), headline))), renderPlacesList(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDqI3")).ExperienceSuccess), {
            hasLoaded: hasLoaded && !hasError,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_CONTAINERS
        }));
    }
    const $aebc9202d6bd8a73$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ownerHeadline: {
            id: 'pf-home.profile-page.places-list.owner.headline',
            defaultMessage: 'Places you work in',
            description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to profile owner'
        },
        otherHeadline: {
            id: 'pf-home.profile-page.places-list.other.headline',
            defaultMessage: 'Places they work in',
            description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to a profile visitor'
        },
        otherHeadlinePast: {
            id: 'pf-home.profile-page.places-list.other.headline-past',
            defaultMessage: 'Places they work in',
            description: 'Section headline for Places where a deactivated or deleted users personal Confluence space and Jira boards shown to a profile visitor'
        }
    });
    var $aebc9202d6bd8a73$export$2e2bcd8739ae039 = $aebc9202d6bd8a73$var$ProfilePlaces;
});
parcelRegister("jDqI3", function(module, exports) {
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$eed2d630b0ff4506$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $oRoJ1;
    function $eed2d630b0ff4506$export$4962f3898bd5c829(props) {
        const { hasLoaded: hasLoaded, name: name, attributes: attributes } = props;
        if (!hasLoaded) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oRoJ1")).ExperienceSuccess), {
            name: name,
            attributes: attributes
        });
    }
});
parcelRegister("oRoJ1", function(module, exports) {
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$c3bbc3576721f681$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSOOm;
    function $c3bbc3576721f681$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
        const experienceTracker = (0, $5uXOq.useContext)((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext));
        (0, $5uXOq.useEffect)(()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            }), [
            name,
            attributes,
            experienceTracker
        ]);
        return null;
    }
});
parcelRegister("afcOx", function(module, exports) {
    $parcel$export(module.exports, "UserStatus", ()=>$2e4870bf45f0be88$export$a82073022ded66e8);
    $parcel$export(module.exports, "FieldType", ()=>$2e4870bf45f0be88$export$ed12481c953b8653);
    var $2e4870bf45f0be88$export$ef730685c1b8e238;
    (function(UserPrivacyLevel) {
        UserPrivacyLevel["private"] = "private";
        UserPrivacyLevel["domain"] = "domain";
        UserPrivacyLevel["public"] = "public";
    })($2e4870bf45f0be88$export$ef730685c1b8e238 || ($2e4870bf45f0be88$export$ef730685c1b8e238 = {}));
    var $2e4870bf45f0be88$export$a82073022ded66e8;
    (function(UserStatus) {
        UserStatus["active"] = "active";
        UserStatus["inactive"] = "inactive";
        UserStatus["closed"] = "closed";
    })($2e4870bf45f0be88$export$a82073022ded66e8 || ($2e4870bf45f0be88$export$a82073022ded66e8 = {}));
    var $2e4870bf45f0be88$export$ed12481c953b8653;
    (function(FieldType) {
        FieldType["FullName"] = "fullName";
        FieldType["Nickname"] = "nickname";
        FieldType["Title"] = "title";
        FieldType["Department"] = "department";
        FieldType["CompanyName"] = "companyName";
        FieldType["Location"] = "location";
        FieldType["Timezone"] = "timezone";
        FieldType["Email"] = "email";
        FieldType["PhoneNumber"] = "phoneNumber";
        FieldType["Avatar"] = "picture";
        FieldType["Language"] = "language";
        FieldType["LocalTime"] = "localTime";
        FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
        FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
        FieldType["RemoteTimeString"] = "remoteTimeString";
    })($2e4870bf45f0be88$export$ed12481c953b8653 || ($2e4870bf45f0be88$export$ed12481c953b8653 = {}));
    var $2e4870bf45f0be88$export$a9678af7d3f0f4cb;
    (function(IdentityFieldName) {
        IdentityFieldName["PHONE_NUMBER"] = "phone_number";
        IdentityFieldName["JOB_TITLE"] = "job_title";
        IdentityFieldName["DEPARTMENT"] = "department";
        IdentityFieldName["COMPANY_NAME"] = "organization";
        IdentityFieldName["LOCATION"] = "location";
        IdentityFieldName["ZONEINFO"] = "zoneinfo";
        IdentityFieldName["NAME"] = "name";
        IdentityFieldName["EMAIL"] = "email";
    })($2e4870bf45f0be88$export$a9678af7d3f0f4cb || ($2e4870bf45f0be88$export$a9678af7d3f0f4cb = {}));
});
parcelRegister("h4k2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31ae20232f92a5d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $afcOx;
    var $k3GIb;
    var $hDnTz = parcelRequire("hDnTz");
    const $31ae20232f92a5d0$var$EmptyPlacesListState = ({ isCurrentUser: isCurrentUser, userFullName: userFullName, userStatus: userStatus })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const renderDescText = ()=>{
            const descMessage = isCurrentUser ? $31ae20232f92a5d0$var$messages.noPlacesListOwnerDesc : userStatus === (0, (0, parcelRequire("afcOx")).UserStatus).inactive || userStatus === (0, (0, parcelRequire("afcOx")).UserStatus).closed ? $31ae20232f92a5d0$var$messages.noPlacesListPastUserDesc : $31ae20232f92a5d0$var$messages.noPlacesListOtherDesc;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...descMessage,
                values: {
                    user: userFullName
                }
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3GIb")).default), {
            title: intl.formatMessage($31ae20232f92a5d0$var$messages.noPlacesListTitle),
            description: renderDescText(),
            imageUrl: (0, ($parcel$interopDefault($hDnTz)))
        });
    };
    const $31ae20232f92a5d0$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPlacesListTitle: {
            id: 'ptc-directory.profile-page.places-list.no-places-list.title',
            defaultMessage: "We don\u2019t have places to show here yet",
            description: 'Title of the message displayed when there is no places associated to the profile that is being viewed'
        },
        noPlacesListOwnerDesc: {
            id: 'ptc-directory.profile-page.places-list.no-places-list.owner.description',
            defaultMessage: "There are no projects or spaces you\u2019ve worked in across the last 90 days.",
            description: 'Description of the message displayed when there is no places associated to the owner profile that is being viewed'
        },
        noPlacesListOtherDesc: {
            id: 'ptc-directory.profile-page.places-list.no-places-list.other.description',
            defaultMessage: "{user} hasn\u2019t worked in any projects or spaces in the last 90 days.",
            description: 'Description of the message displayed when there is no places associated to the person profile that is being viewed'
        },
        noPlacesListPastUserDesc: {
            id: 'ptc-directory.profile-page.places-list.no-places-list.past-user.description',
            defaultMessage: "{user}\u2019s account is deactivated or deleted. We can\u2019t show the projects or spaces {user} worked in across the last 90 days.",
            description: 'Description of the message displayed when there is no places associated to a deactivated or deleted users profile that is being viewed'
        }
    });
    var $31ae20232f92a5d0$export$2e2bcd8739ae039 = $31ae20232f92a5d0$var$EmptyPlacesListState;
});
parcelRegister("k3GIb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$285cf07fe4a32b56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9mq25;
    function $285cf07fe4a32b56$export$c696c866211ccfa4({ title: title, description: description, image: image, imageUrl: imageUrl, actions: actions, py: py, px: px, testId: testId }) {
        const img = imageUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateImage), {
            src: imageUrl
        }) : image;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateContainer), {
            py: py,
            px: px,
            "data-testid": testId
        }, img && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateImageContainer), null, img), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateBody), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateTitle), null, title), description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateDescription), null, description), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9mq25")).EmptyStateActions), null, actions)));
    }
    var $285cf07fe4a32b56$export$2e2bcd8739ae039 = $285cf07fe4a32b56$export$c696c866211ccfa4;
});
parcelRegister("9mq25", function(module, exports) {
    $parcel$export(module.exports, "EmptyStateContainer", ()=>$8566c66dc785b8a1$export$2a511c47e1cb5779);
    $parcel$export(module.exports, "EmptyStateImageContainer", ()=>$8566c66dc785b8a1$export$bd5d2fea0a40a42f);
    $parcel$export(module.exports, "EmptyStateImage", ()=>$8566c66dc785b8a1$export$a7907bb86a15af4e);
    $parcel$export(module.exports, "EmptyStateBody", ()=>$8566c66dc785b8a1$export$df244a6e5075ebb4);
    $parcel$export(module.exports, "EmptyStateTitle", ()=>$8566c66dc785b8a1$export$54260be545246e4e);
    $parcel$export(module.exports, "EmptyStateDescription", ()=>$8566c66dc785b8a1$export$242239d9c1732d0a);
    $parcel$export(module.exports, "EmptyStateActions", ()=>$8566c66dc785b8a1$export$725343b91068621d);
    var $k5uoT;
    var $bWGt6 = parcelRequire("bWGt6");
    function $8566c66dc785b8a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8566c66dc785b8a1$var$gridSizeTimes = (factor)=>(0, (0, parcelRequire("k5uoT")).gridSize)() * factor;
    const $8566c66dc785b8a1$export$2a511c47e1cb5779 = (0, $bWGt6.default)("div", {
        target: "e1i83sxm6"
    })((props)=>({
            position: 'relative',
            padding: `${$8566c66dc785b8a1$var$gridSizeTimes(props.py || 4)}px ${$8566c66dc785b8a1$var$gridSizeTimes(props.px || 7)}px`,
            transition: 'box-shadow 0.25s ease',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        }));
    const $8566c66dc785b8a1$export$bd5d2fea0a40a42f = (0, $bWGt6.default)("div", {
        target: "e1i83sxm5"
    })({
        display: 'flex',
        flex: '0 0 auto',
        width: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
        maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
        marginRight: `${$8566c66dc785b8a1$var$gridSizeTimes(4)}px`,
        justifyContent: 'center',
        alignItems: 'center',
        svg: {
            maxWidth: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
            maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`
        }
    });
    const $8566c66dc785b8a1$export$a7907bb86a15af4e = (0, $bWGt6.default)("img", {
        target: "e1i83sxm4"
    })({
        maxWidth: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
        maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`
    });
    const $8566c66dc785b8a1$export$df244a6e5075ebb4 = (0, $bWGt6.default)("div", {
        target: "e1i83sxm3"
    })({
        name: "p4355k",
        styles: "min-width:180px"
    });
    const $8566c66dc785b8a1$export$54260be545246e4e = (0, $bWGt6.default)("h3", {
        target: "e1i83sxm2"
    })({
        marginBottom: `${$8566c66dc785b8a1$var$gridSizeTimes(2)}px`
    });
    const $8566c66dc785b8a1$export$242239d9c1732d0a = (0, $bWGt6.default)("p", {
        target: "e1i83sxm1"
    })({
        name: "0",
        styles: ""
    });
    const $8566c66dc785b8a1$export$725343b91068621d = (0, $bWGt6.default)("div", {
        target: "e1i83sxm0"
    })({
        marginTop: `${$8566c66dc785b8a1$var$gridSizeTimes(2)}px`
    });
});
parcelRegister("hDnTz", function(module, exports) {
    module.exports = new URL("PlacesListEmpty_ptc.36d458cf.svg", import.meta.url).toString();
});
parcelRegister("hIjCF", function(module, exports) {
    $parcel$export(module.exports, "PanelContent", ()=>$7533baea2253dd05$export$d30ae7d97aafb468);
    $parcel$export(module.exports, "PanelContentHeader", ()=>$7533baea2253dd05$export$eb71a19746598b2f);
    $parcel$export(module.exports, "PanelContentTitle", ()=>$7533baea2253dd05$export$c703356189ebc2de);
    $parcel$export(module.exports, "PanelContentBody", ()=>$7533baea2253dd05$export$c75fef9a59663656);
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    const $7533baea2253dd05$export$d30ae7d97aafb468 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1r5dj51-0"
    })``;
    const $7533baea2253dd05$export$eb71a19746598b2f = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1r5dj51-1"
    })`display:flex;flex-direction:row;justify-content:space-between;margin-bottom:${(props)=>props.hasSubInfo ? "var(--ds-space-050, 4px)" : "var(--ds-space-200, 16px)"};position:relative;`;
    const $7533baea2253dd05$export$c703356189ebc2de = (0, $47bDC.default).h2.withConfig({
        componentId: "sc-1r5dj51-2"
    })`${(0, (0, parcelRequire("3RZIb")).h500)};margin-top:0;word-break:break-all;`;
    const $7533baea2253dd05$export$58f06e463130acb4 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1r5dj51-3"
    })`background:${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-100, 8px)"};`;
    const $7533baea2253dd05$export$c75fef9a59663656 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1r5dj51-4"
    })`background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};padding-top:${"var(--ds-space-200, 16px)"};padding-bottom:${"var(--ds-space-200, 16px)"};padding-left:${"var(--ds-space-075, 6px)"};padding-right:${"var(--ds-space-075, 6px)"};`;
});
parcelRegister("36A8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5d7bf0b894092bc$export$2e2bcd8739ae039);
    var $5EtDt;
    var $d5d7bf0b894092bc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5EtDt")).default);
});
parcelRegister("5EtDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1e9b8002a005154$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $9xuGL;
    var $dME4E;
    var $8woxI;
    var $iwwXK;
    var $k5uoT;
    var $fyzT1;
    var $gBNI9;
    var $grAcD;
    var $38ra6;
    var $la5R9;
    const $c1e9b8002a005154$export$d4349a8ff634836e = (0, parcelRequire("la5R9")).PlaceLink;
    const $c1e9b8002a005154$var$MainIcon = ({ icon: icon, type: type })=>{
        if (icon) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).BaseIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "small",
            src: icon,
            appearance: "square"
        }));
        if (type === 'space') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).SpaceIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9xuGL"))))), {
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("8woxI"))))),
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }));
        else if (type === 'board') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).BoardIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dME4E"))))), {
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }));
        return null;
    };
    const $c1e9b8002a005154$var$HeaderIcon = ({ type: type })=>{
        switch(type){
            case 'space':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gBNI9")).default), {
                    size: "xsmall",
                    productKey: (0, (0, parcelRequire("grAcD")).ShortProductKey).CONFLUENCE
                });
            case 'board':
            case 'project':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gBNI9")).default), {
                    size: "xsmall",
                    productKey: (0, (0, parcelRequire("grAcD")).ShortProductKey).JIRA
                });
            default:
                return null;
        }
    };
    function $c1e9b8002a005154$var$typeToTitle(type) {
        switch(type){
            case 'space':
                return 'Confluence';
            case 'board':
            case 'project':
                return 'Jira';
            default:
                return '';
        }
    }
    const $c1e9b8002a005154$export$a67ff5ee53b7f29a = (props)=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const { name: name, path: path, type: type, hasLoaded: hasLoaded } = props;
        const handleAnchorClick = ()=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'placesLink',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                attributes: {
                    type: type
                }
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).PlacesItem, null, hasLoaded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).HeaderIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c1e9b8002a005154$var$HeaderIcon, {
            type: type
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).HeaderTitle, null, $c1e9b8002a005154$var$typeToTitle(type))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).Content, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c1e9b8002a005154$var$MainIcon, props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("la5R9")).Details, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c1e9b8002a005154$export$d4349a8ff634836e, {
            href: path,
            onClick: handleAnchorClick
        }, name)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            isShimmering: true,
            cssFn: ()=>({
                    minHeight: (0, (0, parcelRequire("k5uoT")).gridSize)() * 2,
                    width: (0, (0, parcelRequire("k5uoT")).gridSize)() * 18.75,
                    marginBottom: "var(--ds-space-050, 4px)",
                    paddingLeft: 0,
                    paddingRight: 0
                })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true,
            cssFn: ()=>({
                    minHeight: (0, (0, parcelRequire("k5uoT")).gridSize)() * 3.5,
                    paddingLeft: 0,
                    paddingRight: 0
                })
        })));
    };
    var $c1e9b8002a005154$export$2e2bcd8739ae039 = $c1e9b8002a005154$export$a67ff5ee53b7f29a;
});
parcelRegister("dME4E", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a08ed7e863649bfd$var$_react = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a08ed7e863649bfd$var$_board = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("8EsNC")));
    var $a08ed7e863649bfd$var$_board2 = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("v8Zna")));
    function $a08ed7e863649bfd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a08ed7e863649bfd$var$BoardIcon = (props)=>$a08ed7e863649bfd$var$_react.default.createElement($a08ed7e863649bfd$var$_board.default, Object.assign({
            LEGACY_fallbackIcon: $a08ed7e863649bfd$var$_board2.default
        }, props));
    $a08ed7e863649bfd$var$BoardIcon.Name = 'BoardIconMigration';
    var $a08ed7e863649bfd$var$_default = module.exports.default = $a08ed7e863649bfd$var$BoardIcon;
});
parcelRegister("8EsNC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $64c8661ab6d81803$var$_UNSAFE_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $64c8661ab6d81803$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64c8661ab6d81803$var$BoardIcon = (props)=>$64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
        }, props));
    $64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
    var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;
});
parcelRegister("v8Zna", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
    function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $05d9de5ec3a4369b$var$BoardIcon = (props)=>$05d9de5ec3a4369b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
        }, props, {
            newIcon: $05d9de5ec3a4369b$var$_board.default
        }));
    $05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
    var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;
});
parcelRegister("8woxI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63445998dc5f82bb$var$_react = $63445998dc5f82bb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $63445998dc5f82bb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63445998dc5f82bb$var$FolderFilledIcon = (props)=>$63445998dc5f82bb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.2 6h7.81C21.108 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.99 1.992H3.99A1.99 1.99 0 0 1 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
        }, props));
    $63445998dc5f82bb$var$FolderFilledIcon.displayName = 'FolderFilledIcon';
    var $63445998dc5f82bb$var$_default = module.exports.default = $63445998dc5f82bb$var$FolderFilledIcon;
});
parcelRegister("gBNI9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f7789eb0040e355$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iMzG0;
    var $7anl7;
    var $29YN9;
    var $epnSS;
    var $JDSfd;
    var $gOcFi;
    var $grAcD;
    function $6f7789eb0040e355$export$2e2bcd8739ae039(props) {
        const { productKey: productKey, size: size = 'small', defaultIcon: defaultIcon = null, productName: productName } = props;
        const mapProductKeyToIcon = {
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).JIRA]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                size: size,
                label: productName || 'Jira',
                appearance: "brand"
            }),
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).CONFLUENCE]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                size: size,
                label: productName || 'Confluence',
                appearance: "brand"
            }),
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).JIRA_SOFTWARE]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("JDSfd")).JiraSoftwareIcon), {
                size: size,
                label: productName || 'Jira',
                appearance: "brand"
            }),
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).JIRA_SERVICE_DESK]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("epnSS")).JiraServiceManagementIcon), {
                size: size,
                label: productName || 'Jira',
                appearance: "brand"
            }),
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).JIRA_CORE]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gOcFi")).JiraWorkManagementIcon), {
                size: size,
                label: productName || 'Jira',
                appearance: "brand"
            }),
            [(0, (0, parcelRequire("grAcD")).ShortProductKey).BITBUCKET]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMzG0")).BitbucketIcon), {
                size: size,
                label: productName || 'Bitbucket',
                appearance: "brand"
            })
        };
        return productKey && mapProductKeyToIcon[productKey] ? mapProductKeyToIcon[productKey] : defaultIcon;
    }
});
parcelRegister("iMzG0", function(module, exports) {
    $parcel$export(module.exports, "BitbucketIcon", ()=>$0af9b15279bc8ff1$export$5fc1066e677788d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $0af9b15279bc8ff1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
    };
    const $0af9b15279bc8ff1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $0af9b15279bc8ff1$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("7anl7", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceIcon", ()=>$1c9c2365ff37a453$export$68f3db7f6af48bcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
    };
    const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $1c9c2365ff37a453$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("JDSfd", function(module, exports) {
    $parcel$export(module.exports, "JiraSoftwareIcon", ()=>$96323ff1b52d1676$export$c3835feba2a66e67);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $96323ff1b52d1676$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
        let colors = {
            iconGradientStart: (0, (0, parcelRequire("lEsIP")).legacyDefaultLogoParams).iconGradientStart,
            iconGradientStop: (0, (0, parcelRequire("lEsIP")).legacyDefaultLogoParams).iconGradientStart,
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearanceOldLogos)(appearance, colorMode);
        return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
    };
    const $96323ff1b52d1676$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const id = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $96323ff1b52d1676$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode, id),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("gOcFi", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkManagementIcon", ()=>$1e0c574ab61cf9f9$export$7330b9fc5718fd30);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1e0c574ab61cf9f9$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
        let colors = {
            iconGradientStart: (0, (0, parcelRequire("lEsIP")).legacyDefaultLogoParams).iconGradientStart,
            iconGradientStop: (0, (0, parcelRequire("lEsIP")).legacyDefaultLogoParams).iconGradientStart,
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearanceOldLogos)(appearance, colorMode);
        return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
    };
    const $1e0c574ab61cf9f9$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const id = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $1e0c574ab61cf9f9$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode, id),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("grAcD", function(module, exports) {
    $parcel$export(module.exports, "ShortProductKey", ()=>$8afd1569bdb4f7a5$export$736dd0bf2ecc436f);
    $parcel$export(module.exports, "ProductName", ()=>$8afd1569bdb4f7a5$export$acdfad52bc8c6626);
    var $8afd1569bdb4f7a5$export$736dd0bf2ecc436f;
    (function(ShortProductKey) {
        ShortProductKey["CONFLUENCE"] = "confluence";
        ShortProductKey["JIRA"] = "jira";
        ShortProductKey["JIRA_CORE"] = "jira_core";
        ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
        ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
        ShortProductKey["BITBUCKET"] = "bitbucket";
    })($8afd1569bdb4f7a5$export$736dd0bf2ecc436f || ($8afd1569bdb4f7a5$export$736dd0bf2ecc436f = {}));
    var $8afd1569bdb4f7a5$export$acdfad52bc8c6626;
    (function(ProductName) {
        ProductName["CONFLUENCE"] = "Confluence";
        ProductName["JIRA"] = "Jira";
        ProductName["JIRA_CORE"] = "Jira Core";
        ProductName["JIRA_SOFTWARE"] = "Jira Software";
        ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
        ProductName["BITBUCKET"] = "Bitbucket";
        ProductName["TEAM_CENTRAL"] = "Team Central";
        ProductName["ATLAS"] = "Atlas";
        ProductName["HOME"] = "Atlassian Home";
    })($8afd1569bdb4f7a5$export$acdfad52bc8c6626 || ($8afd1569bdb4f7a5$export$acdfad52bc8c6626 = {}));
    var $8afd1569bdb4f7a5$export$fc3a4bf3fb08b1b4;
    (function(LongProductKey) {
        LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
        LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
        LongProductKey["CONFLUENCE"] = "confluence.ondemand";
        LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
        LongProductKey["BITBUCKET"] = "bitbucket";
    })($8afd1569bdb4f7a5$export$fc3a4bf3fb08b1b4 || ($8afd1569bdb4f7a5$export$fc3a4bf3fb08b1b4 = {}));
});
parcelRegister("la5R9", function(module, exports) {
    $parcel$export(module.exports, "BaseIcon", ()=>$b9651884ef5baecb$export$20931e2295160b07);
    $parcel$export(module.exports, "PlacesItem", ()=>$b9651884ef5baecb$export$834d50fab48eb11a);
    $parcel$export(module.exports, "Header", ()=>$b9651884ef5baecb$export$8b251419efc915eb);
    $parcel$export(module.exports, "HeaderIcon", ()=>$b9651884ef5baecb$export$3a4bb31ac4bd7451);
    $parcel$export(module.exports, "HeaderTitle", ()=>$b9651884ef5baecb$export$edb76fdb8665f52);
    $parcel$export(module.exports, "Content", ()=>$b9651884ef5baecb$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "SpaceIcon", ()=>$b9651884ef5baecb$export$38ffce4a7986ba20);
    $parcel$export(module.exports, "BoardIcon", ()=>$b9651884ef5baecb$export$2f9da8868573b55d);
    $parcel$export(module.exports, "Details", ()=>$b9651884ef5baecb$export$3e8048d3cf2ba3fd);
    $parcel$export(module.exports, "PlaceLink", ()=>$b9651884ef5baecb$export$d4349a8ff634836e);
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $3FhRS;
    const $b9651884ef5baecb$export$20931e2295160b07 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-0"
    })`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};color:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};margin-left:${"var(--ds-space-050, 4px)"};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${"var(--ds-space-150, 12px)"};span{display:flex;align-items:center;justify-content:center;}svg{width:${"var(--ds-space-250, 20px)"};height:${"var(--ds-space-250, 20px)"};}img{width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};}`;
    const $b9651884ef5baecb$export$834d50fab48eb11a = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-1"
    })`position:relative;border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};transition:box-shadow 0.25s ease;overflow:hidden;display:flex;flex-direction:column;&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};}`;
    const $b9651884ef5baecb$export$8b251419efc915eb = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-2"
    })`display:flex;flex-direction:row;align-items:center;margin-bottom:${"var(--ds-space-050, 4px)"};`;
    const $b9651884ef5baecb$export$3a4bb31ac4bd7451 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-3"
    })`display:flex;margin-left:${"var(--ds-space-025, 2px)"};margin-right:${"var(--ds-space-050, 4px)"};width:${"var(--ds-space-200, 16px)"};height:${"var(--ds-space-200, 16px)"};color:${`var(--ds-icon-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`;
    const $b9651884ef5baecb$export$edb76fdb8665f52 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-4"
    })`${(0, (0, parcelRequire("3RZIb")).h200)};margin-top:0px;`;
    const $b9651884ef5baecb$export$7c6e2c02157bb7d2 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-5"
    })`display:flex;align-items:center;`;
    const $b9651884ef5baecb$export$38ffce4a7986ba20 = (0, $47bDC.default)($b9651884ef5baecb$export$20931e2295160b07).withConfig({
        componentId: "sc-6lxli0-6"
    })`background:${`var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};display:grid;place-items:center;`;
    const $b9651884ef5baecb$export$2f9da8868573b55d = (0, $47bDC.default)($b9651884ef5baecb$export$20931e2295160b07).withConfig({
        componentId: "sc-6lxli0-7"
    })`background:${`var(--ds-icon-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`;
    const $b9651884ef5baecb$export$3e8048d3cf2ba3fd = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6lxli0-8"
    })`display:flex;flex-direction:column;min-width:0;white-space:nowrap;`;
    const $b9651884ef5baecb$export$d4349a8ff634836e = (0, $47bDC.default)((0, (0, parcelRequire("3FhRS")).default)).withConfig({
        componentId: "sc-6lxli0-9"
    })`${(0, (0, parcelRequire("3RZIb")).h500)};margin-top:${"var(--ds-space-025, 2px)"};text-overflow:ellipsis;overflow:hidden;&:focus{box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`};outline:none;border-radius:${"var(--ds-border-radius-100, 3px)"};}`;
});
parcelRegister("3FhRS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5832523139a7a4e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $38ra6;
    var $39CLR;
    var $2FwA3;
    const $5832523139a7a4e6$var$isModified = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    const $5832523139a7a4e6$var$getSpaAndRelativePath = (href, contextSpaPaths)=>{
        const relativePath = (0, (0, parcelRequire("39CLR")).getRelativeUrl)(href);
        const isSPA = (0, (0, parcelRequire("39CLR")).isSPALink)(relativePath, contextSpaPaths);
        return {
            isSPA: isSPA,
            relativePath: relativePath
        };
    };
    const $5832523139a7a4e6$export$a6c7ac8248d6e38a = ({ href: href, onClick: onClick, target: target, ...rest })=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        (0, $5uXOq.useEffect)(()=>{
            if (!href) analytics.pushOperationalEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: 'link',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).FAILED,
                attributes: {
                    contextSpaPaths: contextSpaPaths,
                    contextEntryPoint: contextEntryPoint
                },
                tags: [
                    'error'
                ]
            });
        }, [
            analytics,
            contextEntryPoint,
            contextSpaPaths,
            href
        ]);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) onClick(event);
            if (href) {
                const { relativePath: relativePath, isSPA: isSPA } = $5832523139a7a4e6$var$getSpaAndRelativePath(href, contextSpaPaths);
                if (isSPA && !event.defaultPrevented && event.button === 0 && (!target || target === '_self') && !$5832523139a7a4e6$var$isModified(event)) {
                    event.preventDefault();
                    push(relativePath);
                }
            }
        }, [
            onClick,
            href,
            contextSpaPaths,
            push,
            target
        ]);
        if (href) {
            const { isSPA: isSPA } = $5832523139a7a4e6$var$getSpaAndRelativePath(href, contextSpaPaths);
            const props = {
                href: (0, (0, parcelRequire("39CLR")).prefixWithContextEntryPoint)(href, contextEntryPoint),
                ...target ? {
                    target: target
                } : isSPA ? {} : {
                    target: '_blank'
                },
                ...isSPA ? {} : {
                    rel: 'noopener noreferrer'
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                ...rest,
                onClick: handleClick,
                ...props
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            ...rest,
            onClick: onClick
        });
    };
    var $5832523139a7a4e6$export$2e2bcd8739ae039 = $5832523139a7a4e6$export$a6c7ac8248d6e38a;
});
parcelRegister("39CLR", function(module, exports) {
    $parcel$export(module.exports, "getDomainFromLinkUri", ()=>$8eae38f2ed4e3aaa$export$cda14c9dfe45538);
    $parcel$export(module.exports, "getRelativeUrl", ()=>$8eae38f2ed4e3aaa$export$d614758658023fd);
    $parcel$export(module.exports, "prefixWithContextEntryPoint", ()=>$8eae38f2ed4e3aaa$export$715c8f9057ac0c01);
    $parcel$export(module.exports, "isSPALink", ()=>$8eae38f2ed4e3aaa$export$82ba20246315fbed);
    var $a2luh;
    const $8eae38f2ed4e3aaa$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
    const $8eae38f2ed4e3aaa$export$cda14c9dfe45538 = (url)=>{
        let hostname;
        try {
            try {
                hostname = $8eae38f2ed4e3aaa$export$eb5a321f13bbb969(url);
            } catch (noProtocolError) {
                hostname = $8eae38f2ed4e3aaa$export$eb5a321f13bbb969('http://' + url);
            }
        } catch (error) {
            return '';
        }
        return hostname.replace(/^www\./, '');
    };
    const $8eae38f2ed4e3aaa$export$eb5a321f13bbb969 = (url)=>{
        const urlObj = new URL(url);
        return urlObj.hostname;
    };
    const $8eae38f2ed4e3aaa$export$c8d36b71889c2b08 = (email)=>{
        const parts = email.split('@');
        if (parts.length === 1) return null;
        else if (parts.length === 2 && !parts[0]) return null;
        else if (!parts[parts.length - 1]) return null;
        return parts[parts.length - 1];
    };
    const $8eae38f2ed4e3aaa$export$d614758658023fd = (url)=>{
        if (!$8eae38f2ed4e3aaa$var$isAbsoluteLink(url)) return url;
        try {
            const { pathname: pathname, search: search, hash: hash } = new URL(url);
            return `${pathname}${search}${hash}`;
        } catch (error) {
            (0, (0, parcelRequire("a2luh")).logException)(error, 'Cannot parse URL in getRelativeUrl', {
                url: url
            });
        }
        return url;
    };
    const $8eae38f2ed4e3aaa$var$isAbsoluteLink = (url)=>{
        return url.startsWith('http') || url.startsWith('www');
    };
    const $8eae38f2ed4e3aaa$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
        if ($8eae38f2ed4e3aaa$var$isAbsoluteLink(path) || contextEntryPoint && path.startsWith(contextEntryPoint) || path.startsWith('/')) return path;
        return `${contextEntryPoint}/${path}`;
    };
    const $8eae38f2ed4e3aaa$export$82ba20246315fbed = (url, contextSpaPaths)=>{
        if (!contextSpaPaths || !contextSpaPaths.length) return false;
        let isStartWithContextSPA;
        if ($8eae38f2ed4e3aaa$var$isAbsoluteLink(url)) try {
            const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
            const relativeUrl = `${pathname}${search}${hash}`;
            const isSameDomain = window.location.href.includes(origin);
            isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
                return relativeUrl.startsWith(contextPath);
            });
            return isStartWithContextSPA && isSameDomain;
        } catch (error) {
            (0, (0, parcelRequire("a2luh")).logException)(error, 'Cannot parse URL in isSPALink', {
                url: url
            });
            return false;
        }
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return url.startsWith(contextPath);
        });
        return isStartWithContextSPA || !url.startsWith('/');
    };
});
parcelRegister("49Zpb", function(module, exports) {
    $parcel$export(module.exports, "ProfilePlacesList", ()=>$b49bb4864d30f319$export$f092d7408da4b0d);
    $parcel$export(module.exports, "EmptyPlacesList", ()=>$b49bb4864d30f319$export$f88a6b5813accf5a);
    var $47bDC = parcelRequire("47bDC");
    const $b49bb4864d30f319$export$f092d7408da4b0d = (0, $47bDC.default).div.withConfig({
        componentId: "sc-114isdp-0"
    })`padding:${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};background:${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;
    const $b49bb4864d30f319$export$f88a6b5813accf5a = (0, $47bDC.default).div.withConfig({
        componentId: "sc-114isdp-1"
    })`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;
});
parcelRegister("dXPcV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$313efcd2742b09c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $VSDnB;
    var $fyzT1;
    var $e7caa;
    var $38ra6;
    var $fff3y;
    var $5WmsO;
    var $dmOdc;
    var $k3Vai;
    var $8btfM;
    var $l84Dn;
    const $313efcd2742b09c5$var$getCurrentTime = ()=>window && window.performance ? window.performance.now() : Date.now();
    function $313efcd2742b09c5$var$useContainersQuery(props) {
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const [sessionId] = (0, $5uXOq.useState)((0, ($parcel$interopDefault($7Jxgt)))());
        const [startTime, setStartTime] = (0, $5uXOq.useState)(0);
        const userId = props.userId || principalUserId;
        const request = (0, $5uXOq.useCallback)(()=>{
            return (0, (0, parcelRequire("dmOdc")).teamsClient).getUserContainers({
                siteId: cloudId,
                userId: userId,
                principalId: principalUserId,
                maxNumberOfResults: props.maxNumberOfCards,
                sessionId: sessionId
            });
        }, [
            cloudId,
            principalUserId,
            props.maxNumberOfCards,
            sessionId,
            userId
        ]);
        const { fetchData: fetchData, loading: loadingNext, data: dataNext, error: errorNext } = (0, (0, parcelRequire("k3Vai")).useServiceLight)(request);
        const loadingRef = (0, $5uXOq.useRef)(loadingNext);
        (0, $5uXOq.useEffect)(()=>{
            setStartTime($313efcd2742b09c5$var$getCurrentTime());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('enable_teams_graphql_migration')) {
                if (principalUserId) fetchData();
            }
        }, [
            fetchData,
            principalUserId
        ]);
        const triggerAnalyticsEvent = (0, $5uXOq.useCallback)((elapsedTimeMs, data)=>{
            const containers = data.Containers && data.Containers.collaborationGraphEntities || [];
            const ids = containers.map(({ id: id })=>id);
            analytics.pushOperationalEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'collaboration-graph',
                attributes: {
                    resultLength: ids.length,
                    sessionId: sessionId,
                    resultIds: ids,
                    endpoint: 'userToContainer',
                    userId: userId,
                    elapsedTimeMs: elapsedTimeMs
                },
                action: 'requested'
            });
        }, [
            userId,
            analytics,
            sessionId
        ]);
        const handleOnCompleted = (0, $5uXOq.useCallback)((data)=>{
            const end = $313efcd2742b09c5$var$getCurrentTime();
            const diff = end - startTime;
            triggerAnalyticsEvent(diff, data || {});
        }, [
            startTime,
            triggerAnalyticsEvent
        ]);
        const { loading: loading, error: error, data: data } = (0, (0, parcelRequire("5tTFS")).useQuery)((0, (0, parcelRequire("8btfM")).default), {
            client: (0, (0, parcelRequire("e7caa")).getApolloClient)(),
            variables: {
                siteId: cloudId,
                userId: userId,
                principalId: principalUserId,
                maxNumberOfResults: props.maxNumberOfCards,
                sessionId: sessionId
            },
            errorPolicy: 'all',
            skip: !principalUserId || (0, (0, parcelRequire("VSDnB")).fg)('enable_teams_graphql_migration'),
            onCompleted: handleOnCompleted
        });
        if ((0, (0, parcelRequire("VSDnB")).fg)('enable_teams_graphql_migration')) {
            if (loadingRef.current !== loadingNext) {
                loadingRef.current = loadingNext;
                if (!loadingNext) {
                    const end = $313efcd2742b09c5$var$getCurrentTime();
                    const diff = end - startTime;
                    triggerAnalyticsEvent(diff, {
                        Containers: dataNext || {
                            collaborationGraphEntities: []
                        }
                    });
                }
            }
            return {
                data: dataNext ? (0, (0, parcelRequire("l84Dn")).toContainersViewFormat)(dataNext.collaborationGraphEntities) : [],
                loading: loadingNext,
                hasError: !!errorNext,
                error: errorNext
            };
        }
        return {
            data: data ? (0, (0, parcelRequire("l84Dn")).toContainersViewFormat)(data.Containers?.collaborationGraphEntities) : [],
            loading: loading,
            hasError: !!error,
            error: error
        };
    }
    var $313efcd2742b09c5$export$2e2bcd8739ae039 = $313efcd2742b09c5$var$useContainersQuery;
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("8btfM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef890af786b2b16f$export$2e2bcd8739ae039);
    var $5cllN;
    var $ef890af786b2b16f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5cllN")).default)`
	query ContainersQuery(
		$userId: String!
		$principalId: String!
		$siteId: String!
		$sessionId: String
		$maxNumberOfResults: Int!
	) @custom {
		Containers(
			principalId: $principalId
			userId: $userId
			siteId: $siteId
			sessionId: $sessionId
			maxNumberOfResults: $maxNumberOfResults
		) {
			collaborationGraphEntities {
				id
				containerType
				entityType
				containerDetails {
					id
					key
					name
					url
					iconUrl
				}
			}
		}
	}
`;
});
parcelRegister("l84Dn", function(module, exports) {
    $parcel$export(module.exports, "toContainersViewFormat", ()=>$db4f064ec519a677$export$1700279c740b8615);
    const $db4f064ec519a677$var$getType = ({ containerType: containerType })=>{
        switch(containerType){
            case 'jiraProject':
                return 'project';
            case 'confluenceSpace':
                return 'space';
            default:
                return 'project';
        }
    };
    function $db4f064ec519a677$export$1700279c740b8615(nodes) {
        if (!nodes) return [];
        return nodes.filter((container)=>!!container).filter(({ containerType: containerType = '' })=>containerType === 'jiraProject' || containerType === 'confluenceSpace').map((node)=>{
            if (!node || !node.containerDetails) return;
            return {
                id: node?.id,
                name: node?.containerDetails?.name,
                icon: node?.containerDetails?.iconUrl,
                type: $db4f064ec519a677$var$getType(node),
                path: node?.containerDetails?.url,
                hasLoaded: true
            };
        }).filter((it)=>!!it);
    }
});
parcelRegister("aKmPs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ced19670b4a49108$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9uQ9L = parcelRequire("9uQ9L");
    var $2zjbs;
    function $ced19670b4a49108$export$dd5ad0b65cf665da(props) {
        const { children: children, docTitle: docTitle, title: title } = props;
        const resultTitle = [
            docTitle.start,
            title,
            docTitle.end
        ].filter((s)=>Boolean(s)).join(docTitle.delimiter || ' - ');
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($9uQ9L))), {
            title: resultTitle
        }, children));
    }
    var $ced19670b4a49108$export$2e2bcd8739ae039 = (0, (0, parcelRequire("2zjbs")).default)($ced19670b4a49108$export$dd5ad0b65cf665da);
});
parcelRegister("9uQ9L", function(module, exports) {
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $qB6JE = parcelRequire("qB6JE");
    function $6e9f5f93a6c394a7$var$reducePropsToState(propsList) {
        var innermostProps = propsList[propsList.length - 1];
        if (innermostProps) return innermostProps.title;
    }
    function $6e9f5f93a6c394a7$var$handleStateChangeOnClient(title) {
        var nextTitle = title || '';
        if (nextTitle !== document.title) document.title = nextTitle;
    }
    function $6e9f5f93a6c394a7$var$DocumentTitle() {}
    $6e9f5f93a6c394a7$var$DocumentTitle.prototype = Object.create($5uXOq.Component.prototype);
    $6e9f5f93a6c394a7$var$DocumentTitle.displayName = 'DocumentTitle';
    $6e9f5f93a6c394a7$var$DocumentTitle.propTypes = {
        title: (0, parcelRequire("8rCP3")).string.isRequired
    };
    $6e9f5f93a6c394a7$var$DocumentTitle.prototype.render = function() {
        if (this.props.children) return $5uXOq.Children.only(this.props.children);
        else return null;
    };
    module.exports = $qB6JE($6e9f5f93a6c394a7$var$reducePropsToState, $6e9f5f93a6c394a7$var$handleStateChangeOnClient)($6e9f5f93a6c394a7$var$DocumentTitle);
});
parcelRegister("qB6JE", function(module, exports) {
    'use strict';
    function $04ff36a02ec98ee9$var$_interopDefault(ex) {
        return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $04ff36a02ec98ee9$var$React__default = $04ff36a02ec98ee9$var$_interopDefault($5uXOq);
    var $04ff36a02ec98ee9$var$shallowEqual = $04ff36a02ec98ee9$var$_interopDefault((parcelRequire("oRlQ1")));
    function $04ff36a02ec98ee9$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $04ff36a02ec98ee9$var$_inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var $04ff36a02ec98ee9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    function $04ff36a02ec98ee9$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
        if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
        if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
        if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
        function getDisplayName(WrappedComponent) {
            return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }
        return function wrap(WrappedComponent) {
            if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
            var mountedInstances = [];
            var state;
            function emitChange() {
                state = reducePropsToState(mountedInstances.map(function(instance) {
                    return instance.props;
                }));
                if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
                else if (mapStateOnServer) state = mapStateOnServer(state);
            }
            var SideEffect = function(_Component) {
                $04ff36a02ec98ee9$var$_inheritsLoose(SideEffect, _Component);
                function SideEffect() {
                    return _Component.apply(this, arguments) || this;
                }
                SideEffect.peek = function peek() {
                    return state;
                };
                SideEffect.rewind = function rewind() {
                    if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                    var recordedState = state;
                    state = undefined;
                    mountedInstances = [];
                    return recordedState;
                };
                var _proto = SideEffect.prototype;
                _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                    return !$04ff36a02ec98ee9$var$shallowEqual(nextProps, this.props);
                };
                _proto.componentWillMount = function componentWillMount() {
                    mountedInstances.push(this);
                    emitChange();
                };
                _proto.componentDidUpdate = function componentDidUpdate() {
                    emitChange();
                };
                _proto.componentWillUnmount = function componentWillUnmount() {
                    var index = mountedInstances.indexOf(this);
                    mountedInstances.splice(index, 1);
                    emitChange();
                };
                _proto.render = function render() {
                    return $04ff36a02ec98ee9$var$React__default.createElement(WrappedComponent, this.props);
                };
                return SideEffect;
            }($5uXOq.Component);
            $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
            $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "canUseDOM", $04ff36a02ec98ee9$var$canUseDOM);
            return SideEffect;
        };
    }
    module.exports = $04ff36a02ec98ee9$var$withSideEffect;
});
parcelRegister("oRlQ1", function(module, exports) {
    module.exports = function shallowEqual(objA, objB, compare, compareContext) {
        var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
        if (ret !== void 0) return !!ret;
        if (objA === objB) return true;
        if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key)) return false;
            var valueA = objA[key];
            var valueB = objB[key];
            ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
            if (ret === false || ret === void 0 && valueA !== valueB) return false;
        }
        return true;
    };
});
parcelRegister("2zjbs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$046c20baa687bf07$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2FwA3;
    function $046c20baa687bf07$export$2e2bcd8739ae039(WrappedComponent) {
        const nameOfWrapperComponent = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        class WithDocumentTitleComponent extends (0, $5uXOq.PureComponent) {
            static{
                this.displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;
            }
            render() {
                const wrappedComponentProps = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FwA3")).default).Consumer, null, ({ docTitle: docTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...wrappedComponentProps,
                        docTitle: docTitle
                    }));
            }
        }
        return WithDocumentTitleComponent;
    }
});
parcelRegister("eX5cl", function(module, exports) {
    $parcel$export(module.exports, "AsideColumn", ()=>$62433294b4f19257$export$7fd6f44981b465b2);
    $parcel$export(module.exports, "AsideColumnItem", ()=>$62433294b4f19257$export$f634bf5b1a9553c4);
    var $47bDC = parcelRequire("47bDC");
    var $9aSzh;
    var $5mXu0;
    const $62433294b4f19257$export$7fd6f44981b465b2 = (0, $47bDC.default).aside.withConfig({
        componentId: "xyb5d3-0"
    })`${(0, (0, parcelRequire("9aSzh")).baseColumnStyles)};flex:0 0 ${(0, (0, parcelRequire("5mXu0")).profileGridSizeTimes)(4)}px;margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
    const $62433294b4f19257$export$f634bf5b1a9553c4 = (0, $47bDC.default).div.withConfig({
        componentId: "xyb5d3-1"
    })`&:not(:last-child){margin-bottom:${"var(--ds-space-300, 24px)"};}`;
});
parcelRegister("9aSzh", function(module, exports) {
    $parcel$export(module.exports, "baseColumnStyles", ()=>$3c52d2a79f187e72$export$d0f72508c56edec0);
    var $47bDC = parcelRequire("47bDC");
    var $5mXu0;
    const $3c52d2a79f187e72$export$d0f72508c56edec0 = (0, $47bDC.css)`padding:0 ${(0, (0, parcelRequire("5mXu0")).halfGutterSize)}px;min-width:${(0, (0, parcelRequire("5mXu0")).minColumnWidth)}px;@media (max-width:${(0, (0, parcelRequire("5mXu0")).responsiveThreshold)}px){flex:1 1;padding:0;}`;
});
parcelRegister("5mXu0", function(module, exports) {
    $parcel$export(module.exports, "profileGridSizeTimes", ()=>$f33c72287e19aa69$export$4ee2721235c833ba);
    $parcel$export(module.exports, "halfGutterSize", ()=>$f33c72287e19aa69$export$a5c9f6dcfaa13620);
    $parcel$export(module.exports, "minColumnWidth", ()=>$f33c72287e19aa69$export$78f737406522d217);
    $parcel$export(module.exports, "responsiveThreshold", ()=>$f33c72287e19aa69$export$e52bb911ec277d52);
    const $f33c72287e19aa69$export$4ee2721235c833ba = (n)=>80 * n;
    const $f33c72287e19aa69$export$a5c9f6dcfaa13620 = 20;
    const $f33c72287e19aa69$export$78f737406522d217 = $f33c72287e19aa69$export$4ee2721235c833ba(3);
    const $f33c72287e19aa69$export$a3fc3c10977fa604 = 768;
    const $f33c72287e19aa69$export$e52bb911ec277d52 = $f33c72287e19aa69$export$a3fc3c10977fa604 + 64;
});
parcelRegister("bKeYn", function(module, exports) {
    $parcel$export(module.exports, "Body", ()=>$f7775499e5b59e81$export$4b2c32e08f77ff18);
    var $5uXOq = parcelRequire("5uXOq");
    var $a6rxo;
    const $f7775499e5b59e81$export$4b2c32e08f77ff18 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("a6rxo")).Body, null, children);
    const $f7775499e5b59e81$export$77acdd2a63439b4c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("a6rxo")).WideBody, null, children);
    var $f7775499e5b59e81$export$2e2bcd8739ae039 = $f7775499e5b59e81$export$4b2c32e08f77ff18;
});
parcelRegister("a6rxo", function(module, exports) {
    $parcel$export(module.exports, "Body", ()=>$2509b468bd9c9d4f$export$4b2c32e08f77ff18);
    $parcel$export(module.exports, "WideBody", ()=>$2509b468bd9c9d4f$export$77acdd2a63439b4c);
    var $47bDC = parcelRequire("47bDC");
    var $VSDnB;
    var $5mXu0;
    const $2509b468bd9c9d4f$export$4b2c32e08f77ff18 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g7almm-0"
    })`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, (0, parcelRequire("5mXu0")).profileGridSizeTimes)((0, (0, parcelRequire("VSDnB")).fg)('directory-cards-visual-refresh') ? 14 : 12.5)}px;margin:0 auto;padding:0 ${(0, (0, parcelRequire("5mXu0")).halfGutterSize)}px;@media (max-width:${(0, (0, parcelRequire("5mXu0")).responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
    const $2509b468bd9c9d4f$export$77acdd2a63439b4c = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g7almm-1"
    })`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, (0, parcelRequire("5mXu0")).profileGridSizeTimes)(18)}px;margin:0 auto;padding:0 ${(0, (0, parcelRequire("5mXu0")).halfGutterSize)}px;@media (max-width:${(0, (0, parcelRequire("5mXu0")).responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
});
parcelRegister("gujzl", function(module, exports) {
    $parcel$export(module.exports, "MainColumn", ()=>$77d5409b05600d3e$export$2d9aae88ab6846ab);
    $parcel$export(module.exports, "MainColumnItem", ()=>$77d5409b05600d3e$export$a3de91dc1c7d9c74);
    var $47bDC = parcelRequire("47bDC");
    var $k5uoT;
    var $9aSzh;
    var $5mXu0;
    const $77d5409b05600d3e$export$2d9aae88ab6846ab = (0, $47bDC.default).main.withConfig({
        componentId: "e4gbwm-0"
    })`${(0, (0, parcelRequire("9aSzh")).baseColumnStyles)};flex:0 1 ${(0, (0, parcelRequire("5mXu0")).profileGridSizeTimes)(8)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
    const $77d5409b05600d3e$export$a3de91dc1c7d9c74 = (0, $47bDC.default).div.withConfig({
        componentId: "e4gbwm-1"
    })`scroll-margin-top:${(0, (0, parcelRequire("k5uoT")).gridSize)() * 23}px;&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`;
    const $77d5409b05600d3e$export$b59f717f8d137994 = (0, $47bDC.default).main.withConfig({
        componentId: "e4gbwm-2"
    })`${(0, (0, parcelRequire("9aSzh")).baseColumnStyles)};flex:0 1 ${(0, (0, parcelRequire("5mXu0")).profileGridSizeTimes)(12)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
});
parcelRegister("lgzkR", function(module, exports) {
    $parcel$export(module.exports, "ResponsiveSection", ()=>$3cf83c5295d7c080$export$6f5ca33df9ef97dc);
    var $47bDC = parcelRequire("47bDC");
    var $5mXu0;
    var $7MQWS;
    const $3cf83c5295d7c080$export$6f5ca33df9ef97dc = (0, $47bDC.default)((0, (0, parcelRequire("7MQWS")).Section)).withConfig({
        componentId: "uvj1rq-0"
    })`@media (max-width:${(0, (0, parcelRequire("5mXu0")).responsiveThreshold)}px){flex-direction:column;justify-content:flex-start;}`;
});
parcelRegister("7MQWS", function(module, exports) {
    $parcel$export(module.exports, "Section", ()=>$f5d37ed89170413e$export$6e2c8f0811a474ce);
    var $47bDC = parcelRequire("47bDC");
    const $f5d37ed89170413e$export$6e2c8f0811a474ce = (0, $47bDC.default).div.withConfig({
        componentId: "jfynxk-0"
    })`display:flex;flex-direction:row;justify-content:center;`;
});
parcelRegister("7zl35", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreen", ()=>$bab77af7fdfb31e0$export$42f84e610f279c31);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $iiI2P;
    var $38ra6;
    var $iHA6C;
    var $lAVIa;
    var $gTfPe;
    const $bab77af7fdfb31e0$export$db8be4c3614e42ec = new Map([
        [
            (0, (0, parcelRequire("iHA6C")).ErrorCategory).NotFound,
            (0, (0, parcelRequire("lAVIa")).UserNotFound)
        ]
    ]);
    const $bab77af7fdfb31e0$export$42f84e610f279c31 = ({ error: error })=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        (0, $5uXOq.useEffect)(()=>{
            analytics.pushTrackEvent({
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).FAILED,
                actionSubject: `${(0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN}Load`,
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN
            });
        }, [
            analytics
        ]);
        const errorCategory = (0, (0, parcelRequire("iHA6C")).parseErrorObjectToErrorCategory)(error);
        const ErrorComponent = errorCategory !== '' && $bab77af7fdfb31e0$export$db8be4c3614e42ec.has(errorCategory) ? $bab77af7fdfb31e0$export$db8be4c3614e42ec.get(errorCategory) : (0, (0, parcelRequire("iiI2P")).GenericErrorPage);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("gTfPe")).LoadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(ErrorComponent, null));
    };
});
parcelRegister("iiI2P", function(module, exports) {
    $parcel$export(module.exports, "GenericErrorPage", ()=>$3bcfcb1d3bcb026c$export$5d76009b056f3e5d);
    $parcel$export(module.exports, "default", ()=>$3bcfcb1d3bcb026c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $fVnbM;
    var $bJMK1;
    var $bCNuj = parcelRequire("bCNuj");
    var $jzj7m;
    const $3bcfcb1d3bcb026c$export$2369ec80391a4c8c = (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).ErrorImage, {
        src: (0, ($parcel$interopDefault($bCNuj)))
    });
    const $3bcfcb1d3bcb026c$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).Container, {
            "data-test-selector": "error-page"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).ImageOuter, null, image || $3bcfcb1d3bcb026c$export$2369ec80391a4c8c), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).ErrorTextContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).TitleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).Title, null, title)), body && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).DescriptionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).Description, null, body))), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("jzj7m")).ButtonContainer, null, actions));
    };
    const $3bcfcb1d3bcb026c$export$5d76009b056f3e5d = (props)=>{
        const actions = props.hasSupportLink && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            rel: "noopener noreferrer",
            target: "_blank",
            href: `${(0, (0, parcelRequire("bJMK1")).getAtlassianContextUrl)('support')}/contact/#/`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $3bcfcb1d3bcb026c$var$messages.contactUs));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3bcfcb1d3bcb026c$export$c120a0e80fd44ca6, {
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $3bcfcb1d3bcb026c$var$messages.title),
            body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $3bcfcb1d3bcb026c$var$messages.description),
            actions: actions || undefined
        });
    };
    const $3bcfcb1d3bcb026c$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'pf-home.generic-error-title',
            defaultMessage: 'Something went wrong'
        },
        contactUs: {
            id: 'ptc-directory.error-boundary.message-link-text',
            defaultMessage: 'Contact support',
            description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
        },
        description: {
            id: 'pf-home.generic-error-description',
            defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
        }
    });
    var $3bcfcb1d3bcb026c$export$2e2bcd8739ae039 = $3bcfcb1d3bcb026c$export$c120a0e80fd44ca6;
});
parcelRegister("bCNuj", function(module, exports) {
    module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();
});
parcelRegister("jzj7m", function(module, exports) {
    $parcel$export(module.exports, "ErrorImage", ()=>$9534cd56a74aa25f$export$7326e6d938a8137b);
    $parcel$export(module.exports, "Container", ()=>$9534cd56a74aa25f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ImageOuter", ()=>$9534cd56a74aa25f$export$6cce79b2fcc860dc);
    $parcel$export(module.exports, "TitleWrapper", ()=>$9534cd56a74aa25f$export$585a3b23e887288b);
    $parcel$export(module.exports, "ButtonContainer", ()=>$9534cd56a74aa25f$export$eddf54ea3db8d0f0);
    $parcel$export(module.exports, "Title", ()=>$9534cd56a74aa25f$export$f99233281efd08a0);
    $parcel$export(module.exports, "DescriptionWrapper", ()=>$9534cd56a74aa25f$export$2bf1f2b0d31b60fc);
    $parcel$export(module.exports, "Description", ()=>$9534cd56a74aa25f$export$393edc798c47379d);
    $parcel$export(module.exports, "ErrorTextContainer", ()=>$9534cd56a74aa25f$export$5086488b1ac4411e);
    var $47bDC = parcelRequire("47bDC");
    const $9534cd56a74aa25f$export$7326e6d938a8137b = (0, $47bDC.default).img.withConfig({
        componentId: "kvymlk-0"
    })`width:263px;margin:0 0 ${"var(--ds-space-600, 48px)"} 0;display:flex;`;
    const $9534cd56a74aa25f$export$42a852a2b6b56249 = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-1"
    })`align-items:center;justify-content:center;display:flex;flex-wrap:wrap;margin:${"var(--ds-space-1000, 80px)"} auto 0;max-width:600px;flex-direction:column;@media (max-width:640px){flex-direction:column;}`;
    const $9534cd56a74aa25f$export$6cce79b2fcc860dc = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-2"
    })`flex:none;flex-basis:200px;justify-content:center;@media (max-width:640px){margin-right:0;flex-basis:auto;& img{max-width:100%;padding:0 ${"var(--ds-space-300, 24px)"};}}`;
    const $9534cd56a74aa25f$export$585a3b23e887288b = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-3"
    })`display:flex;margin-bottom:${"var(--ds-space-150, 12px)"};@media (max-width:640px){text-align:center;}`;
    const $9534cd56a74aa25f$export$eddf54ea3db8d0f0 = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-4"
    })`display:flex;justify-content:center;text-align:center;margin-top:${"var(--ds-space-200, 16px)"};`;
    const $9534cd56a74aa25f$export$f99233281efd08a0 = (0, $47bDC.default).h1.withConfig({
        componentId: "kvymlk-5"
    })``;
    const $9534cd56a74aa25f$export$2bf1f2b0d31b60fc = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-6"
    })`display:flex;flex-wrap:wrap;`;
    const $9534cd56a74aa25f$export$393edc798c47379d = (0, $47bDC.default).p.withConfig({
        componentId: "kvymlk-7"
    })`font-size:1em;line-height:24px;color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};@media (max-width:640px){text-align:center;}`;
    const $9534cd56a74aa25f$export$5086488b1ac4411e = (0, $47bDC.default).div.withConfig({
        componentId: "kvymlk-8"
    })`display:flex;justify-content:center;text-align:center;flex-wrap:wrap;width:80%;flex-direction:column;align-items:center;@media (max-width:640px){max-width:304px;width:100%;}`;
});
parcelRegister("iHA6C", function(module, exports) {
    $parcel$export(module.exports, "ErrorCategory", ()=>$f63c3d8e2c241724$export$fe4bb20808298551);
    $parcel$export(module.exports, "isRealErrorUserProfile", ()=>$f63c3d8e2c241724$export$ad79d1c90d717965);
    $parcel$export(module.exports, "errorUserNotFound", ()=>$f63c3d8e2c241724$export$10bf856e639f2ac5);
    $parcel$export(module.exports, "parseErrorObjectToErrorCategory", ()=>$f63c3d8e2c241724$export$cf76974422373a05);
    $parcel$export(module.exports, "parseTeamErrorCategory", ()=>$f63c3d8e2c241724$export$cd92fd5c21ce6635);
    var $hxoeG;
    var $f63c3d8e2c241724$export$fe4bb20808298551;
    (function(ErrorCategory) {
        ErrorCategory["NotFound"] = "NotFound";
        ErrorCategory["NotPermitted"] = "NotPermitted";
        ErrorCategory["MalformedInput"] = "MalformedInput";
        ErrorCategory["Internal"] = "Internal";
    })($f63c3d8e2c241724$export$fe4bb20808298551 || ($f63c3d8e2c241724$export$fe4bb20808298551 = {}));
    const $f63c3d8e2c241724$export$ad79d1c90d717965 = (error)=>{
        if (!error) return false;
        if (error?.message?.includes('User not found') || error?.message?.includes('Access is denied') || error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')) return false;
        if (!error.graphQLErrors) return true;
        return !error.graphQLErrors.every((e)=>!e || e.category === "NotFound" || e.category === "NotPermitted");
    };
    const $f63c3d8e2c241724$export$10bf856e639f2ac5 = new Error('User not found');
    function $f63c3d8e2c241724$export$cf76974422373a05(error) {
        if (!error) return '';
        if (error?.message === $f63c3d8e2c241724$export$10bf856e639f2ac5.message) return "NotFound";
        return error.graphQLErrors?.[0]?.category;
    }
    const $f63c3d8e2c241724$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP = {
        403: (0, (0, parcelRequire("hxoeG")).TeamProfileErrorType).NO_PERMISSION,
        404: (0, (0, parcelRequire("hxoeG")).TeamProfileErrorType).TEAM_MISSING,
        410: (0, (0, parcelRequire("hxoeG")).TeamProfileErrorType).TEAM_DELETED
    };
    const $f63c3d8e2c241724$export$cd92fd5c21ce6635 = (error)=>error ? $f63c3d8e2c241724$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || (0, (0, parcelRequire("hxoeG")).TeamProfileErrorType).UNKNOWN : null;
});
parcelRegister("hxoeG", function(module, exports) {
    $parcel$export(module.exports, "TeamProfileErrorType", ()=>$fca2dbb71bb98d64$export$b89d4f1cb2ee533c);
    var $fca2dbb71bb98d64$export$b89d4f1cb2ee533c;
    (function(TeamProfileErrorType) {
        TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
        TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
        TeamProfileErrorType["TEAM_DELETED"] = "deleted";
        TeamProfileErrorType["UNKNOWN"] = "unknown";
        TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
    })($fca2dbb71bb98d64$export$b89d4f1cb2ee533c || ($fca2dbb71bb98d64$export$b89d4f1cb2ee533c = {}));
});
parcelRegister("lAVIa", function(module, exports) {
    $parcel$export(module.exports, "UserNotFound", ()=>$9c9c968fed3671fa$export$d1f0ba24af7dd9bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $eCeGD;
    var $iiI2P;
    var $38ra6;
    var $kNbZP = parcelRequire("kNbZP");
    var $3FhRS;
    var $cjsF8;
    const $9c9c968fed3671fa$var$Actions = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FhRS")).default), {
            href: "search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $9c9c968fed3671fa$var$messages.buttonText)));
    const $9c9c968fed3671fa$var$NOT_FOUND_IMAGE_WIDTH = 497;
    const $9c9c968fed3671fa$export$d1f0ba24af7dd9bb = ()=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const expTracker = analytics.expTracker();
        (0, $5uXOq.useEffect)(()=>{
            expTracker.abort({
                reason: 'User Not Found'
            });
        }, [
            expTracker
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iiI2P")).default), {
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $9c9c968fed3671fa$var$messages.notFoundTitle),
            body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $9c9c968fed3671fa$var$messages.notFoundDescription1), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $9c9c968fed3671fa$var$messages.notFoundDescription2)),
            image: (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("cjsF8")).NotFoundImage, {
                src: (0, ($parcel$interopDefault($kNbZP))),
                width: $9c9c968fed3671fa$var$NOT_FOUND_IMAGE_WIDTH
            }),
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement($9c9c968fed3671fa$var$Actions, null)
        });
    };
    const $9c9c968fed3671fa$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundTitle: {
            id: 'ptc-directory.profile-page.not-found.title',
            defaultMessage: "Looks like we\u2019re off the beaten track",
            description: 'The title of the error page when a user tries to view a user but the user id does not exist'
        },
        notFoundDescription1: {
            id: 'ptc-directory.profile-page.not-found.description.first',
            defaultMessage: 'We landed here for a user that does not exist.',
            description: 'The first line of the description when a user landed on an invalid page'
        },
        notFoundDescription2: {
            id: 'ptc-directory.profile-page.not-found.description.second',
            defaultMessage: 'Head back to the directory to search for another user.',
            description: 'The second line of the description when a user landed on an invalid page'
        },
        buttonText: {
            id: 'ptc-directory.profile-page.error.home.button',
            defaultMessage: 'Back to directory',
            description: 'The button text to return to the search page'
        }
    });
});
parcelRegister("kNbZP", function(module, exports) {
    module.exports = new URL("svg-user-not-found_ptc.0205a184.svg", import.meta.url).toString();
});
parcelRegister("cjsF8", function(module, exports) {
    $parcel$export(module.exports, "NotFoundImage", ()=>$8f9737ac80b2ded5$export$22dc9752913c971e);
    var $47bDC = parcelRequire("47bDC");
    const $8f9737ac80b2ded5$export$22dc9752913c971e = (0, $47bDC.default).img.withConfig({
        componentId: "sc-1wghneo-0"
    })`margin:0 0 ${"var(--ds-space-500, 40px)"} 0;display:flex;`;
});
parcelRegister("gTfPe", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$7c8966fd68543407$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "AvatarWrapper", ()=>$7c8966fd68543407$export$f7513421c53ce141);
    $parcel$export(module.exports, "Details", ()=>$7c8966fd68543407$export$3e8048d3cf2ba3fd);
    $parcel$export(module.exports, "Name", ()=>$7c8966fd68543407$export$c7bd411105e2dec3);
    $parcel$export(module.exports, "Nickname", ()=>$7c8966fd68543407$export$445f45ad592d8c5);
    $parcel$export(module.exports, "LoadingWrapper", ()=>$7c8966fd68543407$export$43a792a870d28db2);
    $parcel$export(module.exports, "NonActiveUserLozenge", ()=>$7c8966fd68543407$export$184eb2c877f30f66);
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    const $7c8966fd68543407$export$3f46768c2c1337f2 = -91;
    const $7c8966fd68543407$export$49e8f7b58a4df4ea = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-0"
    })`margin-top:${$7c8966fd68543407$export$3f46768c2c1337f2}px;`;
    const $7c8966fd68543407$export$b4afcc4b43e79a52 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-1"
    })`height:0;padding:0;margin:${"var(--ds-space-250, 20px)"} 0 0 0;`;
    const $7c8966fd68543407$export$f7513421c53ce141 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-2"
    })`position:relative;display:inline-block;height:134px;width:134px;border-radius:50%;margin-bottom:${"var(--ds-space-200, 16px)"};`;
    const $7c8966fd68543407$export$3e8048d3cf2ba3fd = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-3"
    })`display:flex;flex-direction:column;`;
    const $7c8966fd68543407$export$c7bd411105e2dec3 = (0, $47bDC.default).h1.withConfig({
        componentId: "sc-1oxac7m-4"
    })`${(0, (0, parcelRequire("3RZIb")).h700)} margin-top:0;margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
    const $7c8966fd68543407$export$445f45ad592d8c5 = (0, $47bDC.default).span.withConfig({
        componentId: "sc-1oxac7m-5"
    })`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
    const $7c8966fd68543407$export$43a792a870d28db2 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-6"
    })`opacity:${(props)=>props.isLoading ? 0 : 1};`;
    const $7c8966fd68543407$export$184eb2c877f30f66 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1oxac7m-7"
    })`margin-bottom:${"var(--ds-space-250, 20px)"};margin-top:${"var(--ds-space-050, 4px)"};`;
});
parcelRegister("iegaf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc754503aa074ff7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $HsQKd;
    const $fc754503aa074ff7$var$WorkedOnListContainer = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("HsQKd")).default), props);
    };
    var $fc754503aa074ff7$export$2e2bcd8739ae039 = $fc754503aa074ff7$var$WorkedOnListContainer;
});
parcelRegister("HsQKd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4dee281c1c05402c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fff3y;
    var $jFpmD;
    var $hd01g;
    var $f8Dur;
    var $9m4mL;
    const $4dee281c1c05402c$var$ProfileRecentWorkClient = (props)=>{
        const { userId: userId } = props;
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const [activities, setActivities] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const activityClient = (0, (0, parcelRequire("jFpmD")).useActivityClient)('v3', 'people');
        const { data: data } = (0, (0, parcelRequire("hd01g")).useTeamsUser)(userId, !userId);
        const loadActivities = (0, $5uXOq.useCallback)(async ()=>{
            setIsLoading(true);
            try {
                const fetchedActivities = await activityClient.fetchActivities([
                    50,
                    125,
                    250
                ], {
                    limit: 50,
                    actors: [
                        `ari:cloud:identity::user/${userId}`
                    ]
                }, [
                    'workedOn'
                ]);
                const translated = (0, (0, parcelRequire("f8Dur")).transformDataFromRecentWorkClient)(fetchedActivities.workedOn);
                setActivities(translated);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                setError(error);
            }
        }, [
            activityClient,
            userId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (userId) loadActivities();
        }, [
            loadActivities,
            userId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9m4mL")).default), {
            userFullName: data?.fullName,
            userId: userId,
            currentUserId: principalUserId,
            error: error,
            hasError: !!error,
            isLoading: isLoading,
            activities: activities
        });
    };
    var $4dee281c1c05402c$export$2e2bcd8739ae039 = $4dee281c1c05402c$var$ProfileRecentWorkClient;
});
parcelRegister("hd01g", function(module, exports) {
    $parcel$export(module.exports, "useTeamsUser", ()=>$1b1e413e1dacd172$export$14c10fb40f456eef);
    var $5uXOq = parcelRequire("5uXOq");
    var $03VaI;
    const $1b1e413e1dacd172$export$14c10fb40f456eef = (userId, skip)=>{
        const [users, { getUser: getUser, setUserData: setUserData }] = (0, (0, parcelRequire("03VaI")).useUser)();
        const userState = users[userId];
        (0, $5uXOq.useEffect)(()=>{
            if (!skip) getUser(userId);
        }, [
            getUser,
            skip,
            userId
        ]);
        return {
            data: userState?.user,
            isLoading: userState?.isLoading,
            error: userState?.error,
            refetch: ()=>getUser(userId, true),
            setUserData: (data)=>setUserData(userId, data)
        };
    };
});
parcelRegister("03VaI", function(module, exports) {
    $parcel$export(module.exports, "useUser", ()=>$80e8b6a666360a4d$export$23bbbc4533528f03);
    var $3sQ5x;
    var $iXqE5;
    var $dmOdc;
    const $80e8b6a666360a4d$var$CACHE_MAX_AGE = 300000;
    const $80e8b6a666360a4d$var$CACHE_MAX_SIZE = 5;
    const $80e8b6a666360a4d$var$initialState = {};
    const $80e8b6a666360a4d$export$e324594224ef24da = {
        getUser: (userId, isRefetching)=>async ({ getState: getState, setState: setState })=>{
                const userState = getState()[userId];
                if (!isRefetching && userState && (userState.isLoading || userState.exp > Date.now())) return;
                const userIds = Object.keys(getState());
                if (userIds.length >= $80e8b6a666360a4d$var$CACHE_MAX_SIZE) {
                    const mutableState = {
                        ...getState()
                    };
                    const oldestUserId = userIds.reduce((oldest, current)=>mutableState[current].exp < mutableState[oldest].exp ? current : oldest);
                    delete mutableState[oldestUserId];
                    setState({
                        ...mutableState
                    });
                }
                setState({
                    [userId]: {
                        isLoading: true,
                        error: undefined,
                        user: undefined,
                        exp: -1
                    }
                });
                try {
                    const userCheckPromise = (0, (0, parcelRequire("dmOdc")).teamsClient).getUserInSiteUserBase(userId);
                    const userQueryPromise = (0, (0, parcelRequire("dmOdc")).teamsClient).queryAGGUser(userId);
                    const checkUserPresentInSiteRes = await userCheckPromise;
                    if (!checkUserPresentInSiteRes.isPresent) {
                        setState({
                            [userId]: {
                                isLoading: false,
                                exp: -1
                            }
                        });
                        return;
                    }
                    const user = await userQueryPromise;
                    setState({
                        [userId]: {
                            isLoading: false,
                            exp: Date.now() + $80e8b6a666360a4d$var$CACHE_MAX_AGE,
                            user: {
                                ...user,
                                fullName: user.name,
                                title: user.extendedProfile?.jobTitle,
                                timezone: user.zoneinfo,
                                locale: user.locale,
                                location: user.extendedProfile?.location,
                                companyName: user.extendedProfile?.organization,
                                department: user.extendedProfile?.department,
                                avatarUrl: user.picture,
                                status: user.accountStatus,
                                isBot: user.__typename === 'AppUser',
                                userType: 'user',
                                phoneNumber: user.extendedProfile?.phoneNumbers && user.extendedProfile?.phoneNumbers[0]?.value,
                                isAgent: user.appType === 'agent'
                            }
                        }
                    });
                } catch (error) {
                    setState({
                        [userId]: {
                            error: error instanceof Error ? error : new Error('Unknown error'),
                            isLoading: false,
                            exp: -1
                        }
                    });
                }
            },
        setUserData: (userId, data)=>({ getState: getState, setState: setState })=>{
                const userState = getState()[userId];
                if (!userState || !userState.user) return;
                setState({
                    [userId]: {
                        ...userState,
                        user: userState.user && {
                            ...userState.user,
                            ...data
                        }
                    }
                });
            }
    };
    const $80e8b6a666360a4d$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $80e8b6a666360a4d$var$initialState,
        actions: $80e8b6a666360a4d$export$e324594224ef24da,
        name: 'User'
    });
    const $80e8b6a666360a4d$export$23bbbc4533528f03 = (0, (0, parcelRequire("3sQ5x")).createHook)($80e8b6a666360a4d$var$Store);
});
parcelRegister("f8Dur", function(module, exports) {
    $parcel$export(module.exports, "transformDataFromRecentWorkClient", ()=>$7e0107138655b701$export$25e790c9ec501a25);
    var $k2jAn;
    function $7e0107138655b701$var$getDirectContainer(node) {
        let container = '';
        const len = node.containers?.length || 0;
        if (node.containers && len > 0) container = node.containers[len - 1].name;
        const provider = (0, (0, parcelRequire("k2jAn")).toTitleCase)((0, (0, parcelRequire("k2jAn")).replaceUnderscoresToSpace)((0, (0, parcelRequire("k2jAn")).replaceHypensToSpace)(node.object.product.toLowerCase())));
        return container || provider;
    }
    function $7e0107138655b701$var$transformContributorToActivity(contributor, type = '', date = null) {
        return {
            date: date,
            user: {
                id: contributor.accountId,
                fullName: contributor.name
            },
            type: type
        };
    }
    function $7e0107138655b701$var$transformNodeToWorkLensActivityObject(node) {
        const { name: name = '', url: url = '', icon: icon = null, product: product = '' } = node.object || {};
        return {
            name: name || '',
            url: url,
            cloudId: '',
            iconUrl: icon ? icon.value : '',
            provider: product,
            container: $7e0107138655b701$var$getDirectContainer(node)
        };
    }
    function $7e0107138655b701$var$transformContributersForActor({ actor: actor, contributors: contributors, eventType: eventType, timestamp: timestamp }) {
        const updatedContributors = !contributors.length && actor ? [
            actor
        ] : contributors;
        return updatedContributors.map((contributor)=>$7e0107138655b701$var$transformContributorToActivity(contributor, eventType, timestamp));
    }
    function $7e0107138655b701$export$25e790c9ec501a25(nodes) {
        return nodes.map((node)=>{
            const { object: { id: objectId }, timestamp: timestamp } = node;
            return {
                objectId: objectId,
                lastModification: timestamp,
                activity: $7e0107138655b701$var$transformContributersForActor(node),
                object: {
                    ...$7e0107138655b701$var$transformNodeToWorkLensActivityObject(node)
                }
            };
        });
    }
});
parcelRegister("k2jAn", function(module, exports) {
    $parcel$export(module.exports, "toTitleCase", ()=>$c30e14583f2605d7$export$f06f8b3003f18927);
    $parcel$export(module.exports, "replaceUnderscoresToSpace", ()=>$c30e14583f2605d7$export$d3895e5768a00fee);
    $parcel$export(module.exports, "replaceHypensToSpace", ()=>$c30e14583f2605d7$export$568995155ea86c06);
    const $c30e14583f2605d7$export$1270e6249ad1a81f = (text)=>typeof text === 'string' ? text.charAt(0).toUpperCase() + text.substr(1) : '';
    const $c30e14583f2605d7$export$f06f8b3003f18927 = (text)=>{
        if (typeof text !== 'string') return '';
        const words = text.split(' ');
        return words.map((word)=>$c30e14583f2605d7$export$1270e6249ad1a81f(word)).join(' ');
    };
    const $c30e14583f2605d7$export$d3895e5768a00fee = (text)=>typeof text === 'string' ? text.replace(/_/g, ' ').replace(/ +/g, ' ') : '';
    const $c30e14583f2605d7$export$568995155ea86c06 = (text)=>typeof text === 'string' ? text.replace(/-/g, ' ').replace(/ +/g, ' ') : '';
});
parcelRegister("9m4mL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5b99589eda8f874$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $bA8uW;
    var $jDqI3;
    var $38ra6;
    var $aOf1o;
    var $lHKVj;
    var $iHA6C;
    var $4HgYh;
    var $hyK1p;
    var $brGTJ;
    function $d5b99589eda8f874$export$c8678fe90ec246e0(props) {
        const { activities: activities, userId: userId, currentUserId: currentUserId, isLoading: isLoading, userFullName: userFullName, hasError: hasError, error: error } = props;
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const onClickViewAllLink = (0, $5uXOq.useCallback)((location)=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'viewAllWork',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                attributes: {
                    location: location
                }
            });
        }, [
            analytics
        ]);
        const onClickShowMore = (0, $5uXOq.useCallback)((numItemsDisplayed)=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'moreWork',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                attributes: {
                    numItemsDisplayed: numItemsDisplayed
                }
            });
        }, [
            analytics
        ]);
        const onActivityEntryClick = (0, $5uXOq.useCallback)((provider, entryIndex)=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'activityEntry',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                attributes: {
                    provider: provider.toUpperCase(),
                    entryIndex: entryIndex
                }
            });
        }, [
            analytics
        ]);
        (0, (0, parcelRequire("aOf1o")).useExpTrackerStart)({
            id: userId,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_WORKED_ON,
            timeout: (0, (0, parcelRequire("bA8uW")).DEFAULT_TIMEOUT_USER_EXP)
        });
        (0, (0, parcelRequire("lHKVj")).useExpTrackerStop)({
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_WORKED_ON,
            error: error,
            checkShouldAbort: (error)=>{
                if ((0, (0, parcelRequire("iHA6C")).isRealErrorUserProfile)(error)) return;
                return `Aborted because of ${error.message}`;
            }
        });
        let emptyView;
        if (hasError) emptyView = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyK1p")).default), {
            userFullName: userFullName,
            userId: userId
        });
        else emptyView = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HgYh")).default), {
            isCurrentUser: !!userId && userId === currentUserId,
            userFullName: userFullName,
            isForTable: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("brGTJ")).default), {
            activities: activities,
            currentUserId: currentUserId,
            viewAllLink: `${userId}/work`,
            isLoading: isLoading,
            onClickViewAllLink: onClickViewAllLink,
            onClickShowMore: onClickShowMore,
            onClickActivityEntry: onActivityEntryClick,
            emptyView: emptyView,
            userId: userId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDqI3")).ExperienceSuccess), {
            hasLoaded: !hasError && !isLoading,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_WORKED_ON
        }));
    }
    var $d5b99589eda8f874$export$2e2bcd8739ae039 = $d5b99589eda8f874$export$c8678fe90ec246e0;
});
parcelRegister("4HgYh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4908c45b819c3a39$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $hTEpF;
    var $k3GIb;
    var $cCMOA = parcelRequire("cCMOA");
    var $hpYon;
    function $4908c45b819c3a39$var$EmptyWorkState(props) {
        const { isForTable: isForTable, userId: userId, userFullName: userFullName, isCurrentUser: isCurrentUser } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const renderDescText = ()=>{
            const descMessage = isCurrentUser ? $4908c45b819c3a39$var$messages.noWorkListDescForYou : $4908c45b819c3a39$var$messages.noWorkListPersonDesc;
            return userFullName ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...descMessage,
                values: {
                    user: userFullName
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $4908c45b819c3a39$var$messages.noWorkListTeamDesc);
        };
        if (isForTable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: intl.formatMessage($4908c45b819c3a39$var$messages.noWorkListTitle),
            description: renderDescText(),
            imageUrl: (0, ($parcel$interopDefault($cCMOA))),
            primaryAction: userId && userFullName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hpYon")).default), {
                isInEmptyState: true,
                userId: userId,
                userFullName: userFullName
            })
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3GIb")).default), {
            title: intl.formatMessage($4908c45b819c3a39$var$messages.noWorkListTitle),
            description: renderDescText(),
            imageUrl: (0, ($parcel$interopDefault($cCMOA))),
            actions: userId && userFullName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hpYon")).default), {
                isInEmptyState: true,
                userId: userId,
                userFullName: userFullName
            })
        });
    }
    const $4908c45b819c3a39$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noWorkListTitle: {
            id: 'ptc-directory.profile-page.work-list.no-work-list.title',
            defaultMessage: 'There is no work to see here',
            description: 'Title of the message displayed when there is no work associated to the profile that is being viewed'
        },
        noWorkListTeamDesc: {
            id: 'ptc-directory.profile-page.work-list.no-work-list.team.description',
            defaultMessage: 'Things the team created, edited or commented on in the last 90 days',
            description: 'Description of the message displayed when there is no work associated to the team profile that is being viewed'
        },
        noWorkListPersonDesc: {
            id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description',
            defaultMessage: 'Things {user} created, edited or commented on in the last 90 days.',
            description: 'Description of the message displayed when there is no work associated to the person profile that is being viewed'
        },
        noWorkListDescForYou: {
            id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description.you',
            defaultMessage: 'Things you created, edited or commented on in the last 90 days.',
            description: 'Description of the message displayed when there is no work associated to the current logged-in person profile that is being viewed'
        }
    });
    var $4908c45b819c3a39$export$2e2bcd8739ae039 = $4908c45b819c3a39$var$EmptyWorkState;
});
parcelRegister("cCMOA", function(module, exports) {
    module.exports = new URL("WorkListEmpty_ptc.c984a049.svg", import.meta.url).toString();
});
parcelRegister("hpYon", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b174b66200cd5524$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $cgL5K;
    var $fyzT1;
    var $38ra6;
    var $e9Zmx;
    const $b174b66200cd5524$var$getConfluenceSearchLink = (userId)=>{
        return `/wiki/search?contributors=${encodeURIComponent(userId)}&lastModified=lastMonth`;
    };
    const $b174b66200cd5524$var$getJiraSearchLink = (userId)=>{
        const jql = `assignee in (${userId})` + ` OR reporter in (${userId})` + ` OR creator in (${userId})` + ` OR watcher in (${userId})` + ' ORDER BY updated DESC';
        return `/issues/?jql=${encodeURIComponent(jql)}`;
    };
    const $b174b66200cd5524$var$SearchLink = (props)=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const { container: container, userId: userId } = props;
        const onClickSearchLink = ()=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_WORK_SCREEN,
                actionSubject: 'searchMoreLink',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                attributes: {
                    container: container
                }
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9Zmx")).StyledLink), {
            href: container === 'Confluence' ? $b174b66200cd5524$var$getConfluenceSearchLink(userId) : $b174b66200cd5524$var$getJiraSearchLink(userId),
            target: "_blank",
            "data-test-selector": container.toLowerCase(),
            onClick: onClickSearchLink
        }, container);
    };
    const $b174b66200cd5524$var$SearchMoreWork = (props)=>{
        const { isInEmptyState: isInEmptyState, userId: userId, userFullName: userFullName } = props;
        if (!userId || !userFullName) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, isInEmptyState ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $b174b66200cd5524$var$messages.searchInEmptyState) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $b174b66200cd5524$var$messages.searchNotInEmptyState), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement($b174b66200cd5524$var$SearchLink, {
            container: "Confluence",
            userId: userId
        }), " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $b174b66200cd5524$var$messages.or), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement($b174b66200cd5524$var$SearchLink, {
            container: "Jira",
            userId: userId
        }));
    };
    const $b174b66200cd5524$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchInEmptyState: {
            id: 'ptc-directory.profile-page.work-list.search.in.empty.state',
            defaultMessage: 'You can also search in',
            description: 'A part of a full message is which "You can also search in Confluence or Jira". This is used in empty state of work list component'
        },
        searchNotInEmptyState: {
            id: 'ptc-directory.profile-page.work-list.search.in.not.empty.state',
            defaultMessage: 'Search for more in',
            description: 'A part of a full message is which "Search for more in in Confluence or Jira". This is used in empty state of work list table component'
        },
        or: {
            id: 'ptc-directory.profile-page.work-list.or',
            defaultMessage: 'or',
            description: ''
        }
    });
    var $b174b66200cd5524$export$2e2bcd8739ae039 = $b174b66200cd5524$var$SearchMoreWork;
});
parcelRegister("e9Zmx", function(module, exports) {
    $parcel$export(module.exports, "StyledLink", ()=>$6e31ab205a549ca5$export$9048d548939551ee);
    var $47bDC = parcelRequire("47bDC");
    var $3FhRS;
    const $6e31ab205a549ca5$var$getColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})` : `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    const $6e31ab205a549ca5$var$getHoverColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})` : `var(--ds-link, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
    const $6e31ab205a549ca5$var$getActiveColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})` : `var(--ds-link-pressed, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
    const $6e31ab205a549ca5$export$9048d548939551ee = (0, $47bDC.default)((0, (0, parcelRequire("3FhRS")).default)).withConfig({
        componentId: "ae9szl-0"
    })`color:${(props)=>$6e31ab205a549ca5$var$getColor(props)};&&:hover{color:${(props)=>$6e31ab205a549ca5$var$getHoverColor(props)};text-decoration:underline;}&&:focus{outline:2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};outline-offset:2px;}&&:active{color:${(props)=>$6e31ab205a549ca5$var$getActiveColor(props)};outline:none;text-decoration:none;}`;
});
parcelRegister("hyK1p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d79b87cc8a30f7cd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $hTEpF;
    var $bJMK1;
    var $iCnp6 = parcelRequire("iCnp6");
    var $hpYon;
    const $d79b87cc8a30f7cd$var$SUPPORT_LINK_URI = (0, (0, parcelRequire("bJMK1")).getAtlassianContextUrl)('support');
    const $d79b87cc8a30f7cd$var$SUPPORT_LINK = (0, (0, parcelRequire("bJMK1")).getAtlassianContextDomain)('support');
    function $d79b87cc8a30f7cd$var$ErrorWorkState(props) {
        const { userId: userId, userFullName: userFullName } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: intl.formatMessage($d79b87cc8a30f7cd$var$messages.errorTitle),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...$d79b87cc8a30f7cd$var$messages.errorDesc,
                values: {
                    a: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                            "data-testid": "support-link",
                            href: $d79b87cc8a30f7cd$var$SUPPORT_LINK_URI,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, $d79b87cc8a30f7cd$var$SUPPORT_LINK)
                }
            }),
            imageUrl: (0, ($parcel$interopDefault($iCnp6))),
            primaryAction: userFullName && userId && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hpYon")).default), {
                isInEmptyState: true,
                userId: userId,
                userFullName: userFullName
            })
        });
    }
    const $d79b87cc8a30f7cd$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            id: 'ptc-directory.profile-page.table-work-list.error.title',
            defaultMessage: 'We seem to have lost the connection',
            description: 'Title of error UI when fetching work list fails'
        },
        errorDesc: {
            id: 'ptc-directory.profile-page.table-work-list.error.desc',
            defaultMessage: 'Wait a few moments, then try refreshing the page. If this keeps happening, let us know at <a></a>.',
            description: 'Description of error UI when fetching work list fails'
        }
    });
    var $d79b87cc8a30f7cd$export$2e2bcd8739ae039 = $d79b87cc8a30f7cd$var$ErrorWorkState;
});
parcelRegister("iCnp6", function(module, exports) {
    module.exports = new URL("WorkListError_ptc.b9457501.svg", import.meta.url).toString();
});
parcelRegister("brGTJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7674ab23854abda9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $jUV4i;
    var $5Q1Ge;
    var $5GuIO;
    const $7674ab23854abda9$var$timeFormatOptions = {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    };
    const $7674ab23854abda9$var$getDescription = (activityObject, currentUserId)=>{
        if (activityObject.activity.length <= 0 || !activityObject.activity[0].user) return null;
        const description = activityObject.activity.length > 1 ? (0, (0, parcelRequire("5Q1Ge")).getI18nDataForManyEntries)(activityObject.activity, currentUserId) : (0, (0, parcelRequire("5Q1Ge")).getI18nDataForSingleEntry)(activityObject.activity[0], currentUserId);
        return description;
    };
    const $7674ab23854abda9$var$isDefined = (prop)=>{
        return !!prop;
    };
    function $7674ab23854abda9$export$ad0c9978cddbc3ff(activities, currentUserId) {
        return activities.map((activityObject)=>{
            const i18nForDescription = $7674ab23854abda9$var$getDescription(activityObject, currentUserId);
            if (!i18nForDescription) return null;
            if (i18nForDescription && 'time' in i18nForDescription.params && typeof i18nForDescription.params.time === 'string') i18nForDescription.params.time = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                ...$7674ab23854abda9$var$timeFormatOptions,
                value: i18nForDescription.params.time
            });
            const { name: name = '', iconUrl: iconUrl = '', url: url = '', container: container = '', provider: provider = '' } = activityObject?.object || {};
            return {
                objectName: name,
                objectIconUrl: iconUrl,
                objectUrl: url,
                containerName: container,
                provider: provider,
                description: i18nForDescription ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...i18nForDescription.key,
                    values: i18nForDescription.params
                }) : ''
            };
        }).filter($7674ab23854abda9$var$isDefined);
    }
    const $7674ab23854abda9$var$getInfoText = (userId, currentUserId)=>{
        if (!userId || !currentUserId || userId !== currentUserId) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("5GuIO")).messages).privacyAssuringInfoText);
    };
    function $7674ab23854abda9$export$2e2bcd8739ae039(props) {
        const { activities: activities, currentUserId: currentUserId, userId: userId, titleText: titleText, emptyView: emptyView, isLoading: isLoading, ...otherProps } = props;
        const workItems = $7674ab23854abda9$export$ad0c9978cddbc3ff(activities || [], currentUserId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUV4i")).default), {
            ...otherProps,
            workItems: workItems,
            isInitiallyExpanded: false,
            emptyView: emptyView,
            titleText: titleText,
            infoText: $7674ab23854abda9$var$getInfoText(userId, currentUserId),
            isLoading: isLoading
        });
    }
});
parcelRegister("jUV4i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03f4b8fbd8be4192$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $eZEvj;
    var $e9Zmx;
    var $hIjCF;
    var $7aQTI;
    var $8oKfA;
    const $03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7 = (props)=>{
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(props.isInitiallyExpanded);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onShowMore = (e)=>{
            e.preventDefault();
            const { workItems: workItems, onClickShowMore: onClickShowMore, limitExpanded: limitExpanded } = props;
            setIsExpanded(true);
            const workItemsCount = workItems.length;
            if (onClickShowMore) onClickShowMore(!limitExpanded ? workItemsCount : workItemsCount <= limitExpanded ? workItemsCount : limitExpanded);
        };
        const onClickViewAllLink = (location)=>()=>{
                if (props.onClickViewAllLink) props.onClickViewAllLink(location);
            };
        const onClickActivityEntry = (provider, entryIndex)=>()=>{
                if (props.onClickActivityEntry) props.onClickActivityEntry(provider, entryIndex);
            };
        const renderShowMoreButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).FooterLink, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9Zmx")).StyledLink), {
                appearance: "subtle",
                onClick: onShowMore,
                href: "#",
                "aria-label": formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.showMoreLinkLabel)
            }, formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.showMoreLink)));
        const renderViewAllFooterButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).FooterLink, {
                "data-testid": "view-all-link__footer"
            }, renderViewAllLink({
                appearance: 'subtle',
                location: 'footer'
            }));
        const renderViewAllHeaderButton = ()=>props.workItems.length > 0 && props.viewAllLink && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).HeaderLink, {
                "data-testid": "view-all-link__header"
            }, renderViewAllLink({
                location: 'header'
            }));
        const renderViewAllLink = (linkOptions)=>{
            const { appearance: appearance = 'default', location: location } = linkOptions;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9Zmx")).StyledLink), {
                appearance: appearance,
                href: props.viewAllLink,
                onClick: onClickViewAllLink(location),
                "aria-label": formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.viewAllLinkLabel)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $03f4b8fbd8be4192$export$defe85febe8b728c.viewAllLink));
        };
        const renderFooterButtons = ()=>{
            const { viewAllLink: viewAllLink, workItems: workItems, limitDefault: limitDefault } = props;
            const workItemsCount = workItems.length;
            const canExpand = workItemsCount > limitDefault;
            if (workItemsCount === 0) return null;
            if (!isExpanded && canExpand) return renderShowMoreButton();
            if (viewAllLink) return renderViewAllFooterButton();
            return null;
        };
        const renderWorkItems = ()=>{
            const { workItems: workItems, limitDefault: limitDefault, limitExpanded: limitExpanded, emptyView: emptyView, isLoading: isLoading } = props;
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZEvj")).default), {
                hasIcon: true,
                isShimmering: true,
                cssFn: ()=>({
                        paddingLeft: "var(--ds-space-100, 8px)",
                        paddingRight: "var(--ds-space-100, 8px)"
                    }),
                itemCount: limitDefault || 0
            }));
            if (!workItems.length) return emptyView;
            const limit = isExpanded ? limitExpanded : limitDefault;
            return workItems.slice(0, limit).map((resourceItem, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7aQTI")).default), {
                    key: `work-item-${idx}`,
                    objectName: resourceItem.objectName,
                    description: resourceItem.description,
                    objectUrl: resourceItem.objectUrl,
                    objectIconUrl: resourceItem.objectIconUrl,
                    containerName: resourceItem.containerName,
                    provider: resourceItem.provider,
                    onClick: onClickActivityEntry(resourceItem.provider, idx)
                }));
        };
        const { titleText: titleText, infoText: infoText } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContent), {
            "data-testid": "profile-work-list"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentHeader), {
            hasSubInfo: !!infoText,
            "data-testid": "profile-work-list-header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hIjCF")).PanelContentTitle), null, titleText || formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.listTitle)), renderViewAllHeaderButton()), infoText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).WorkListInfoText, {
            "data-testid": "profile-work-list-info"
        }, infoText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("8oKfA")).WorkListItems, null, renderWorkItems(), renderFooterButtons()));
    };
    $03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7.defaultProps = {
        isInitiallyExpanded: false,
        workItems: [],
        limitDefault: 5,
        limitExpanded: 10,
        onClickViewAllLink: ()=>null,
        onClickShowMore: ()=>null,
        onClickActivityEntry: ()=>null
    };
    const $03f4b8fbd8be4192$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        listTitle: {
            id: 'ptc-directory.profile-page.work-list.title',
            defaultMessage: 'Worked on'
        },
        showMoreLink: {
            id: 'ptc-directory.profile-page.work-list.show-more.link',
            defaultMessage: 'Show more',
            description: 'Link to reveal more work associated to the profile that is being viewed'
        },
        showMoreLinkLabel: {
            id: 'ptc-directory.profile-page.work-list.show-more.label',
            defaultMessage: 'Show more about worked on pages',
            description: 'Helper text for screen reader users. It is announced by screen reader when user focus the show more link'
        },
        viewAllLink: {
            id: 'ptc-directory.profile-page.work-list.view-all.link',
            defaultMessage: 'View all',
            description: 'Link to navigate to Work child page'
        },
        viewAllLinkLabel: {
            id: 'ptc-directory.profile-page.work-list.view-all.label',
            defaultMessage: 'View all worked on pages',
            description: 'Helper text for screen reader users. It is announced by screen reader when user focus the view all link'
        }
    });
    var $03f4b8fbd8be4192$export$2e2bcd8739ae039 = $03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7;
});
parcelRegister("eZEvj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f0881c3fa7e502b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    const $2f0881c3fa7e502b$var$SkeletonList = ({ hasIcon: hasIcon, hasAvatar: hasAvatar, isShimmering: isShimmering, cssFn: cssFn, itemCount: itemCount })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, Array(itemCount).fill(undefined).map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                key: `skeleton-${index}`,
                hasAvatar: hasAvatar,
                hasIcon: hasIcon,
                isShimmering: isShimmering,
                cssFn: cssFn
            })));
    };
    var $2f0881c3fa7e502b$export$2e2bcd8739ae039 = $2f0881c3fa7e502b$var$SkeletonList;
});
parcelRegister("7aQTI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab598b54597e1e85$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $lj8SI;
    var $cgL5K;
    var $5Q1Ge;
    var $kG2FO;
    const $ab598b54597e1e85$export$314aaaef607a8c3a = (props)=>{
        const { provider: provider, objectIconUrl: objectIconUrl, objectName: objectName, containerName: containerName, description: description, objectUrl: objectUrl, onClick: onClick } = props;
        const renderDraftStatus = ()=>{
            if (!(0, (0, parcelRequire("5Q1Ge")).isConfluenceDraft)(provider, objectUrl)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).LozengeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "inprogress"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $ab598b54597e1e85$var$messages.draft)));
        };
        const renderBody = ()=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).Content, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).ContentIcon, {
                src: objectIconUrl,
                alt: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).Details, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).DetailsHeadline, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "p"
            }, objectName), renderDraftStatus()), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).DetailsDescription, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).ContainerName, null, containerName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).Description, null, description))));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("kG2FO")).WorkItemLink, {
            href: objectUrl,
            onClick: onClick
        }, renderBody());
    };
    const $ab598b54597e1e85$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        draft: {
            id: 'ptc-directory.profile-page.work-item.draft',
            defaultMessage: 'Draft',
            description: 'A status of Confluence draft page. Draft pages are pages that have not yet been published. This text shows in a lozenge and in work list'
        }
    });
    var $ab598b54597e1e85$export$2e2bcd8739ae039 = $ab598b54597e1e85$export$314aaaef607a8c3a;
});
parcelRegister("5Q1Ge", function(module, exports) {
    $parcel$export(module.exports, "getI18nDataForSingleEntry", ()=>$877c8ce535842865$export$8d4c96888e68a4cb);
    $parcel$export(module.exports, "getI18nDataForManyEntries", ()=>$877c8ce535842865$export$a8eeb0c18ec4b955);
    $parcel$export(module.exports, "isConfluenceDraft", ()=>$877c8ce535842865$export$c73d42331d87b9d8);
    var $9JptI;
    var $iMVUf;
    var $5GuIO;
    const $877c8ce535842865$export$493c11ff22f45a24 = (activityDate)=>{
        if ((0, (0, parcelRequire("iMVUf")).default)(activityDate)) return 'Yesterday';
        if ((0, (0, parcelRequire("9JptI")).default)(activityDate)) return 'Today';
        return 'Time';
    };
    var $877c8ce535842865$export$5f5db21fc2e4c897;
    (function(ActivityType) {
        ActivityType["EDITED"] = "Edited";
        ActivityType["COMMENTED"] = "Commented";
        ActivityType["CREATED"] = "Created";
        ActivityType["WORKED"] = "Worked";
        ActivityType["ASSIGNED"] = "Assigned";
        ActivityType["UNASSIGNED"] = "Unassigned";
        ActivityType["LIKED"] = "Liked";
        ActivityType["PUBLISHED"] = "Published";
        ActivityType["UPDATED"] = "Updated";
    })($877c8ce535842865$export$5f5db21fc2e4c897 || ($877c8ce535842865$export$5f5db21fc2e4c897 = {}));
    const $877c8ce535842865$export$72f0c8726f4b058c = (activityType)=>{
        const allActivityVerbs = Object.values($877c8ce535842865$export$5f5db21fc2e4c897);
        const supportedVerb = allActivityVerbs.find((actionType)=>{
            return actionType.toLowerCase() === activityType.toLowerCase();
        });
        return supportedVerb || "Worked";
    };
    const $877c8ce535842865$export$8d4c96888e68a4cb = (activityEntry, currentUserId)=>{
        const whoMadeActivity = activityEntry.user && activityEntry.user.id === currentUserId ? 'you' : 'other';
        const activityVerb = $877c8ce535842865$export$72f0c8726f4b058c(activityEntry.type);
        const activityTime = $877c8ce535842865$export$493c11ff22f45a24(activityEntry.date ? new Date(activityEntry.date) : new Date());
        const params = {
            name: activityEntry.user.fullName || ''
        };
        if (activityTime === 'Time') params.time = activityEntry.date || undefined;
        return {
            key: (0, (0, parcelRequire("5GuIO")).messages)[whoMadeActivity + 'Individual' + activityVerb + activityTime],
            params: params
        };
    };
    const $877c8ce535842865$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE = {
        you: {
            '2': (0, (0, parcelRequire("5GuIO")).messages).youDoubleWorkedOn,
            '3': (0, (0, parcelRequire("5GuIO")).messages).youTripleWorkedOn,
            many: (0, (0, parcelRequire("5GuIO")).messages).youManyWorkedOn
        },
        others: {
            '2': (0, (0, parcelRequire("5GuIO")).messages).othersDoubleWorkedOn,
            '3': (0, (0, parcelRequire("5GuIO")).messages).othersTripleWorkedOn,
            many: (0, (0, parcelRequire("5GuIO")).messages).othersManyWorkedOn
        }
    };
    const $877c8ce535842865$export$a8eeb0c18ec4b955 = (userActivityEntries, currentUser)=>{
        const containsCurrentUser = userActivityEntries.some((activity)=>activity.user.id === currentUser);
        const otherUserFullNames = userActivityEntries.filter((activity)=>activity.user.id !== currentUser).map((activity)=>activity.user.fullName);
        const othersCount = otherUserFullNames.length - (containsCurrentUser ? 1 : 2);
        const names = {};
        otherUserFullNames.forEach((userFullName, idx)=>{
            names[`name${idx + 1}`] = userFullName;
        });
        const activitiesCount = userActivityEntries.length;
        const collabAmount = activitiesCount <= 3 ? activitiesCount : 'many';
        const collabType = containsCurrentUser ? 'you' : 'others';
        return {
            key: $877c8ce535842865$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE[collabType][collabAmount],
            params: {
                count: othersCount,
                ...names
            }
        };
    };
    function $877c8ce535842865$export$c73d42331d87b9d8(provider, objectUrl) {
        if (!provider || !objectUrl) return false;
        return provider.toLowerCase() === 'confluence' && (objectUrl.includes('draftId=') || objectUrl.includes('draftShareId='));
    }
});
parcelRegister("5GuIO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$10c2dc679ea19de0$export$defe85febe8b728c);
    var $7VHMR;
    var $5qQ7p;
    var $2GJ1r;
    var $ePTdu;
    var $hJW8u;
    const $10c2dc679ea19de0$var$otherMsg = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        privacyAssuringInfoText: {
            id: 'ptc-directory.work-activity.privacy-assurity',
            defaultMessage: 'Others will only see what they can access.',
            description: "Appears next to a list of recently worked on items on a user\u2019s own profile page. Only appears when viewing yourself. Text assuring the user that private activity items will not appear to others who view this page. Visibility is subject to each individual\u2019s privileges."
        }
    });
    const $10c2dc679ea19de0$export$defe85febe8b728c = {
        ...$10c2dc679ea19de0$var$otherMsg,
        ...(0, (0, parcelRequire("5qQ7p")).messages),
        ...(0, (0, parcelRequire("2GJ1r")).messages),
        ...(0, (0, parcelRequire("hJW8u")).messages),
        ...(0, (0, parcelRequire("ePTdu")).messages)
    };
});
parcelRegister("5qQ7p", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f233f745d6bd71fd$export$defe85febe8b728c);
    var $7VHMR;
    const $f233f745d6bd71fd$var$msgForCommented = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualCommentedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.today',
            defaultMessage: '{name} commented here today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work today."
        },
        otherIndividualCommentedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.yesterday',
            defaultMessage: '{name} commented here yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work yesterday."
        },
        otherIndividualCommentedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.time',
            defaultMessage: '{name} commented here on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work earlier than yesterday."
        }
    });
    const $f233f745d6bd71fd$var$msgForCreated = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualCreatedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.created.today',
            defaultMessage: '{name} created this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work today."
        },
        otherIndividualCreatedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.created.yesterday',
            defaultMessage: '{name} created this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work yesterday"
        },
        otherIndividualCreatedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.created.time',
            defaultMessage: '{name} created this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work earlier than yesterday."
        }
    });
    const $f233f745d6bd71fd$var$msgForEdited = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualEditedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.today',
            defaultMessage: '{name} edited this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work today"
        },
        otherIndividualEditedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.yesterday',
            defaultMessage: '{name} edited this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work yesterday"
        },
        otherIndividualEditedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.time',
            defaultMessage: '{name} edited this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForWorked = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualWorkedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.today',
            defaultMessage: '{name} worked on this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work today"
        },
        otherIndividualWorkedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.yesterday',
            defaultMessage: '{name} worked on this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work yesterday"
        },
        otherIndividualWorkedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.time',
            defaultMessage: '{name} worked on this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForAssigned = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualAssignedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.today',
            defaultMessage: '{name} was assigned this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work today"
        },
        otherIndividualAssignedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.yesterday',
            defaultMessage: '{name} was assigned this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work yesterday"
        },
        otherIndividualAssignedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.time',
            defaultMessage: '{name} was assigned this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForUnassigned = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualUnassignedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.today',
            defaultMessage: '{name} was unassigned this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work today"
        },
        otherIndividualUnassignedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.yesterday',
            defaultMessage: '{name} was unassigned this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work yesterday"
        },
        otherIndividualUnassignedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.time',
            defaultMessage: '{name} was unassigned this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForLiked = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualLikedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.today',
            defaultMessage: '{name} liked this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work today"
        },
        otherIndividualLikedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.yesterday',
            defaultMessage: '{name} liked this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work yesterday"
        },
        otherIndividualLikedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.time',
            defaultMessage: '{name} liked this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForPublished = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualPublishedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.published.today',
            defaultMessage: '{name} published this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work today"
        },
        otherIndividualPublishedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.published.yesterday',
            defaultMessage: '{name} published this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work yesterday"
        },
        otherIndividualPublishedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.published.time',
            defaultMessage: '{name} published this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$var$msgForUpdated = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherIndividualUpdatedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.today',
            defaultMessage: '{name} updated this today',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work today"
        },
        otherIndividualUpdatedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.yesterday',
            defaultMessage: '{name} updated this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work yesterday"
        },
        otherIndividualUpdatedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.time',
            defaultMessage: '{name} updated this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work earlier than yesterday"
        }
    });
    const $f233f745d6bd71fd$export$defe85febe8b728c = {
        ...$f233f745d6bd71fd$var$msgForCommented,
        ...$f233f745d6bd71fd$var$msgForCreated,
        ...$f233f745d6bd71fd$var$msgForEdited,
        ...$f233f745d6bd71fd$var$msgForWorked,
        ...$f233f745d6bd71fd$var$msgForAssigned,
        ...$f233f745d6bd71fd$var$msgForUnassigned,
        ...$f233f745d6bd71fd$var$msgForLiked,
        ...$f233f745d6bd71fd$var$msgForPublished,
        ...$f233f745d6bd71fd$var$msgForUpdated
    };
});
parcelRegister("2GJ1r", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ed9271a4a426003e$export$defe85febe8b728c);
    var $7VHMR;
    const $ed9271a4a426003e$var$msgForWorked = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualWorkedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.today',
            defaultMessage: 'You worked on this today',
            description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work today"
        },
        youIndividualWorkedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.yesterday',
            defaultMessage: 'You worked on this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work yesterday"
        },
        youIndividualWorkedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.time',
            defaultMessage: 'You worked on this {time}',
            description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForCommented = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualCommentedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.today',
            defaultMessage: 'You commented here today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work today"
        },
        youIndividualCommentedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.yesterday',
            defaultMessage: 'You commented here yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work yesterday"
        },
        youIndividualCommentedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.time',
            defaultMessage: 'You commented here on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForCreated = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualCreatedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.created.today',
            defaultMessage: 'You created this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user created the work today"
        },
        youIndividualCreatedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.created.yesterday',
            defaultMessage: 'You created this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user created the work yesterday"
        },
        youIndividualCreatedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.created.time',
            defaultMessage: 'You created this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user created the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForEdited = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualEditedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.today',
            defaultMessage: 'You edited this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work today"
        },
        youIndividualEditedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.yesterday',
            defaultMessage: 'You edited this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work yesterday"
        },
        youIndividualEditedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.time',
            defaultMessage: 'You edited this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForAssigned = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualAssignedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.today',
            defaultMessage: 'You were assigned this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work today"
        },
        youIndividualAssignedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.yesterday',
            defaultMessage: 'You were assigned this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
        },
        youIndividualAssignedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.time',
            defaultMessage: 'You were assigned this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForUnassigned = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualUnassignedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.today',
            defaultMessage: 'You were unassigned this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work today"
        },
        youIndividualUnassignedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.yesterday',
            defaultMessage: 'You were unassigned this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
        },
        youIndividualUnassignedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.time',
            defaultMessage: 'You were unassigned this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForLiked = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualLikedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.today',
            defaultMessage: 'You liked this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work today"
        },
        youIndividualLikedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.yesterday',
            defaultMessage: 'You liked this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
        },
        youIndividualLikedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.time',
            defaultMessage: 'You liked this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForPublished = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualPublishedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.published.today',
            defaultMessage: 'You published this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user published the work today"
        },
        youIndividualPublishedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.published.yesterday',
            defaultMessage: 'You published this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
        },
        youIndividualPublishedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.published.time',
            defaultMessage: 'You published this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user published the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$var$msgForUpdated = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        youIndividualUpdatedToday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.today',
            defaultMessage: 'You updated this today',
            description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work today"
        },
        youIndividualUpdatedYesterday: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.yesterday',
            defaultMessage: 'You updated this yesterday',
            description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
        },
        youIndividualUpdatedTime: {
            id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.time',
            defaultMessage: 'You updated this on {time}',
            description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work earlier than yesterday"
        }
    });
    const $ed9271a4a426003e$export$defe85febe8b728c = {
        ...$ed9271a4a426003e$var$msgForWorked,
        ...$ed9271a4a426003e$var$msgForCommented,
        ...$ed9271a4a426003e$var$msgForCreated,
        ...$ed9271a4a426003e$var$msgForEdited,
        ...$ed9271a4a426003e$var$msgForAssigned,
        ...$ed9271a4a426003e$var$msgForUnassigned,
        ...$ed9271a4a426003e$var$msgForLiked,
        ...$ed9271a4a426003e$var$msgForPublished,
        ...$ed9271a4a426003e$var$msgForUpdated
    };
});
parcelRegister("ePTdu", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$436aca3b2f77fbf0$export$defe85febe8b728c);
    var $7VHMR;
    const $436aca3b2f77fbf0$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        othersManyWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.many.others.worked',
            defaultMessage: '{name1}, {name2}, and {count} others have all worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when more than three users that arent you worked on an object"
        },
        youManyWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.many.you.worked',
            defaultMessage: 'You, {name1}, and {count} others have all worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when more than three users including the current user worked on an object"
        }
    });
});
parcelRegister("hJW8u", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$42c6e3d10907095e$export$defe85febe8b728c);
    var $7VHMR;
    const $42c6e3d10907095e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        othersDoubleWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.double.others.worked',
            defaultMessage: '{name1} and {name2} have both worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when two users that arent you worked on an object"
        },
        youDoubleWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.double.you.worked',
            defaultMessage: 'You and {name1} have both worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when two users including the current user worked on an object"
        },
        othersTripleWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.triple.others.worked',
            defaultMessage: '{name1}, {name2}, and {name3} have all worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when three users that arent you worked on an object"
        },
        youTripleWorkedOn: {
            id: 'ptc-directory.team-profile-page.team-work.triple.you.worked',
            defaultMessage: 'You, {name1}, and {name2} have all worked on this',
            description: "This message appears in work list area of the user profile pageand indicate when three users including the current user worked on an object"
        }
    });
});
parcelRegister("kG2FO", function(module, exports) {
    $parcel$export(module.exports, "WorkItemLink", ()=>$9080898bf1dcbb39$export$337f3677fd9cf9c1);
    $parcel$export(module.exports, "Content", ()=>$9080898bf1dcbb39$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "ContentIcon", ()=>$9080898bf1dcbb39$export$a1ea799cb5c1b499);
    $parcel$export(module.exports, "Details", ()=>$9080898bf1dcbb39$export$3e8048d3cf2ba3fd);
    $parcel$export(module.exports, "DetailsHeadline", ()=>$9080898bf1dcbb39$export$505f19144b08f91a);
    $parcel$export(module.exports, "DetailsDescription", ()=>$9080898bf1dcbb39$export$6ac35bf2875b1dd9);
    $parcel$export(module.exports, "ContainerName", ()=>$9080898bf1dcbb39$export$b7e45c2cd09f088a);
    $parcel$export(module.exports, "Description", ()=>$9080898bf1dcbb39$export$393edc798c47379d);
    $parcel$export(module.exports, "LozengeWrapper", ()=>$9080898bf1dcbb39$export$75180efdd3f4d9c2);
    var $47bDC = parcelRequire("47bDC");
    var $3FhRS;
    const $9080898bf1dcbb39$export$337f3677fd9cf9c1 = (0, $47bDC.default)((0, (0, parcelRequire("3FhRS")).default)).withConfig({
        componentId: "sc-1brh7h6-0"
    })`position:relative;margin:0;overflow:hidden;display:block;padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};}&:focus{outline:0;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};}& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;
    const $9080898bf1dcbb39$export$7c6e2c02157bb7d2 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1brh7h6-1"
    })`display:flex;`;
    const $9080898bf1dcbb39$export$a1ea799cb5c1b499 = (0, $47bDC.default).img.withConfig({
        componentId: "sc-1brh7h6-2"
    })`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;flex-shrink:0;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};margin-top:${"var(--ds-space-100, 8px)"};margin-bottom:${"var(--ds-space-100, 8px)"};`;
    const $9080898bf1dcbb39$export$3e8048d3cf2ba3fd = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1brh7h6-3"
    })`display:flex;flex-direction:column;margin-left:${"var(--ds-space-200, 16px)"};justify-content:center;min-width:0;`;
    const $9080898bf1dcbb39$export$505f19144b08f91a = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1brh7h6-4"
    })`padding-right:${"var(--ds-space-150, 12px)"};padding-bottom:${"var(--ds-space-025, 2px)"};display:flex;align-items:center;p{display:inline-block;font-size:14px;line-height:16px;margin:0;color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}`;
    const $9080898bf1dcbb39$export$6ac35bf2875b1dd9 = (0, $47bDC.default).p.withConfig({
        componentId: "sc-1brh7h6-5"
    })`font-size:11px;line-height:14px;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:${"var(--ds-space-150, 12px)"};`;
    const $9080898bf1dcbb39$export$b7e45c2cd09f088a = (0, $47bDC.default).span.withConfig({
        componentId: "sc-1brh7h6-6"
    })`&:after{content:'\\00B7';padding-right:${"var(--ds-space-050, 4px)"};padding-left:${"var(--ds-space-050, 4px)"};}`;
    const $9080898bf1dcbb39$export$393edc798c47379d = (0, $47bDC.default).span.withConfig({
        componentId: "sc-1brh7h6-7"
    })``;
    const $9080898bf1dcbb39$export$75180efdd3f4d9c2 = (0, $47bDC.default).span.withConfig({
        componentId: "sc-1brh7h6-8"
    })`margin-left:${"var(--ds-space-050, 4px)"};`;
});
parcelRegister("8oKfA", function(module, exports) {
    $parcel$export(module.exports, "HeaderLink", ()=>$da07566774d8264f$export$29c3409e43add430);
    $parcel$export(module.exports, "FooterLink", ()=>$da07566774d8264f$export$e0513c91be1318ca);
    $parcel$export(module.exports, "WorkListInfoText", ()=>$da07566774d8264f$export$fff90b174811109c);
    $parcel$export(module.exports, "WorkListItems", ()=>$da07566774d8264f$export$3af7e1e011c8bee1);
    $parcel$export(module.exports, "SkeletonWrapper", ()=>$da07566774d8264f$export$6069cbe61f690103);
    var $47bDC = parcelRequire("47bDC");
    var $6PHb3;
    const $da07566774d8264f$export$29c3409e43add430 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-0"
    })`margin-left:${"var(--ds-space-300, 24px)"};`;
    const $da07566774d8264f$export$e0513c91be1318ca = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-1"
    })`font-size:11px;margin-left:${"var(--ds-space-150, 12px)"};margin-top:${"var(--ds-space-200, 16px)"};display:flex;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};`;
    const $da07566774d8264f$export$fff90b174811109c = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-2"
    })`display:flex;align-items:center;width:100%;${(0, (0, parcelRequire("6PHb3")).smallTextTypography)};`;
    const $da07566774d8264f$export$3af7e1e011c8bee1 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-3"
    })`border-radius:${"var(--ds-border-radius-100, 3px)"};background-color:${"var(--ds-surface-raised, transparent)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};${$da07566774d8264f$export$fff90b174811109c} + &{margin-top:${"var(--ds-space-200, 16px)"};}`;
    const $da07566774d8264f$export$7fd31be4a556b1a0 = (0, $47bDC.default).img.withConfig({
        componentId: "sc-12dsuy4-4"
    })`height:${144}px;`;
    const $da07566774d8264f$export$475f8a59614a59ca = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-5"
    })`margin-left:${"var(--ds-space-400, 32px)"};min-width:180px;`;
    const $da07566774d8264f$export$a4f85c7f5a5731ac = (0, $47bDC.default).h3.withConfig({
        componentId: "sc-12dsuy4-6"
    })`margin-bottom:${"var(--ds-space-200, 16px)"};`;
    const $da07566774d8264f$export$cb03cebe08ab9b6a = (0, $47bDC.default).p.withConfig({
        componentId: "sc-12dsuy4-7"
    })``;
    const $da07566774d8264f$export$6069cbe61f690103 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12dsuy4-8"
    })`& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;
});
parcelRegister("6PHb3", function(module, exports) {
    $parcel$export(module.exports, "ellipsis", ()=>$074079ff2807afce$export$a5b94313d6908893);
    $parcel$export(module.exports, "twoLineEllipsis", ()=>$074079ff2807afce$export$e6fc941710bd9bc7);
    $parcel$export(module.exports, "ellipsisInFlexChild", ()=>$074079ff2807afce$export$58ca30256a534b20);
    $parcel$export(module.exports, "smallTextTypography", ()=>$074079ff2807afce$export$64de456cd1a0ab3f);
    $parcel$export(module.exports, "linkShadowItem", ()=>$074079ff2807afce$export$37da6d213fb80270);
    $parcel$export(module.exports, "MultilineEllipsis", ()=>$074079ff2807afce$export$7252344cf484ff6d);
    var $47bDC = parcelRequire("47bDC");
    var $cLkWx;
    const $074079ff2807afce$export$a5b94313d6908893 = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
    const $074079ff2807afce$export$e6fc941710bd9bc7 = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
    const $074079ff2807afce$export$58ca30256a534b20 = (0, $47bDC.css)`min-width:0;${$074079ff2807afce$export$a5b94313d6908893};`;
    const $074079ff2807afce$export$2c2e9c688ff3eaac = (0, $47bDC.css)`font-size:14px;font-weight:400;letter-spacing:-0.005em;color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};line-height:20px;`;
    const $074079ff2807afce$export$64de456cd1a0ab3f = (0, $47bDC.css)`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};font-size:12px;line-height:${14 / 12};`;
    const $074079ff2807afce$export$37da6d213fb80270 = (0, $47bDC.css)`background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.25s ease;box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};}`;
    const $074079ff2807afce$export$7252344cf484ff6d = (maxLines = 1, lineHeight = (0, (0, parcelRequire("cLkWx")).rootAbsoluteLineHeight))=>(0, $47bDC.css)`overflow:hidden;-webkit-line-clamp:${maxLines};-webkit-box-orient:vertical;display:-webkit-box;text-overflow:ellipsis;max-height:${maxLines * lineHeight}px;`;
});
parcelRegister("cLkWx", function(module, exports) {
    $parcel$export(module.exports, "rootAbsoluteLineHeight", ()=>$7f54b0a49ce10b0a$export$914d38d0b781a6d3);
    $parcel$export(module.exports, "getGlobalTheme", ()=>$7f54b0a49ce10b0a$export$813ecdf77207a053);
    const $7f54b0a49ce10b0a$export$3abda77ebd0bb50f = 1.42857143;
    const $7f54b0a49ce10b0a$export$a22cfca5dbca7fb5 = 14;
    const $7f54b0a49ce10b0a$export$914d38d0b781a6d3 = $7f54b0a49ce10b0a$export$3abda77ebd0bb50f * $7f54b0a49ce10b0a$export$a22cfca5dbca7fb5;
    const $7f54b0a49ce10b0a$export$813ecdf77207a053 = ()=>{
        const documentElement = document.documentElement;
        const rawTheme = documentElement.getAttribute('data-theme');
        return rawTheme === 'dark' ? 'dark' : 'light';
    };
});
parcelRegister("5vaD6", function(module, exports) {
    $parcel$export(module.exports, "AgentAboutPanel", ()=>$469befa4d2561ce6$export$a9a242371bd64127);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $kaa7g;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $1j6y9;
    var $55jwW;
    var $dQjNg;
    var $9XSXa;
    var $fyzT1;
    var $5WmsO;
    var $7YTpJ;
    var $2FwA3;
    var $19iJP;
    const $469befa4d2561ce6$var$agentAboutPanelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxShadow: 'elevation.shadow.raised',
        borderRadius: '6px',
        padding: 'space.300',
        display: 'flex',
        flexDirection: 'column'
    });
    const $469befa4d2561ce6$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textTransform: 'uppercase',
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $469befa4d2561ce6$var$AbouSectionHeaders = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $469befa4d2561ce6$var$headingStyles
        }, children);
    const $469befa4d2561ce6$export$eceb80593c9ade2e = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $469befa4d2561ce6$var$agentAboutPanelStyles,
            space: "space.300"
        }, children);
    const $469befa4d2561ce6$export$a9a242371bd64127 = ({ agent: agent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const agentIdentityId = (0, (0, parcelRequire("7YTpJ")).trimUserARI)(agent?.identity_account_id || '');
        const { productName: productName } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const product = (0, $5uXOq.useMemo)(()=>productName?.toLowerCase(), [
            productName
        ]);
        const { getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent } = (0, (0, parcelRequire("9XSXa")).useKnowledgeProductsRender)({
            headers: {
                'X-Cloudid': cloudId
            },
            product: product || 'rovo',
            experienceId: 'profile-page'
        });
        const isForgeAgent = agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($469befa4d2561ce6$export$eceb80593c9ade2e, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($469befa4d2561ce6$var$AbouSectionHeaders, null, formatMessage($469befa4d2561ce6$var$messages.aboutLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kaa7g"))))), {
            label: "",
            color: "currentColor"
        }), formatMessage($469befa4d2561ce6$var$messages.rovoAgentLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($469befa4d2561ce6$var$AbouSectionHeaders, null, formatMessage($469befa4d2561ce6$var$messages.knowledgeLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("55jwW")).AgentKnowledgeSection), {
            aris: (0, (0, parcelRequire("dQjNg")).getEnabledKnowlegeArisFromAgent)(agent),
            isForgeAgent: isForgeAgent,
            knowledgeProductsRender: getKnowledgeProductsRenderForAgent({
                sources: agent.knowledge_sources?.sources ?? [],
                cloudUrl: undefined,
                knowledgeScopeEnabled: agent.knowledge_sources?.enabled ?? false
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($469befa4d2561ce6$var$AbouSectionHeaders, null, formatMessage($469befa4d2561ce6$var$messages.actionLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1j6y9")).ActionsSection), {
            actions: agent.action_config || []
        })), (0, (0, parcelRequire("VSDnB")).fg)('enable_teams_for_agents') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("19iJP")).default), {
            userId: agentIdentityId,
            isActiveUser: !agent.deactivated,
            userFullName: agent.name,
            analyticsSource: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN
        }))));
    };
    const $469befa4d2561ce6$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aboutLabel: {
            id: 'ptc-directory.agent-profile.about-agent.about-label',
            defaultMessage: 'About',
            description: 'Label for about section of the agent'
        },
        rovoAgentLabel: {
            id: 'ptc-directory.agent-profile.about-agent.rovo-agent-label',
            defaultMessage: 'Rovo Agent',
            description: 'The content inside About section, indicating this profile is a Rovo Agent'
        },
        knowledgeLabel: {
            id: 'ptc-directory.agent-profile.about-agent.knowledge-label',
            defaultMessage: 'Knowledge',
            description: 'Label for knowledge section of the agent'
        },
        actionLabel: {
            id: 'ptc-directory.agent-profile.about-agent.action-label',
            defaultMessage: 'Actions',
            description: 'Label for action section of the agent'
        },
        teamsLabel: {
            id: 'ptc-directory.agent-profile.about-agent.teams-label',
            defaultMessage: 'Teams',
            description: 'Label for teams section of the agent'
        },
        createTeamLabel: {
            id: 'ptc-directory.agent-profile.about-agent.teams-label',
            defaultMessage: 'Create a team together',
            description: 'Label for teams section of the agent'
        }
    });
});
parcelRegister("kaa7g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eadc96b253df8830$var$_react = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eadc96b253df8830$var$_UNSAFE_baseNew = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eadc96b253df8830$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eadc96b253df8830$var$BriefcaseIcon = (props)=>$eadc96b253df8830$var$_react.default.createElement($eadc96b253df8830$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V6c0-.69.56-1.25 1.25-1.25h1.75m-3 4H8m6.25 0V6c0-.69-.56-1.25-1.25-1.25h-1.75m3 4H8m0 0V11M4.75 4.75V3c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1.75m-6.5 0h6.5"/>`
        }, props));
    $eadc96b253df8830$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
    var $eadc96b253df8830$var$_default = module.exports.default = $eadc96b253df8830$var$BriefcaseIcon;
});
parcelRegister("1j6y9", function(module, exports) {
    $parcel$export(module.exports, "ActionsSection", ()=>$332617cbd994d021$export$62272bfa980718f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $luBm6;
    var $cgL5K;
    var $icliG;
    var $bfx6e;
    const $332617cbd994d021$export$62272bfa980718f8 = ({ actions: actions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!actions.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("bfx6e")).default).noActions));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, actions.map((action)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("icliG")).AgentActionPill), {
                key: action.id,
                action: action
            })));
    };
});
parcelRegister("icliG", function(module, exports) {
    $parcel$export(module.exports, "AgentActionPill", ()=>$a88d4af8adb322fd$export$af13476fcb733bb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $cgL5K;
    var $8CUq3;
    var $dekey;
    const $a88d4af8adb322fd$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: `1px solid ${"var(--ds-border, #091E4224)"}`,
        borderRadius: "var(--ds-border-radius-100, 0.25rem)",
        padding: 'space.050',
        width: 'fit-content'
    });
    const $a88d4af8adb322fd$var$pillIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.brand.subtlest',
        borderRadius: "var(--ds-border-radius-100, 0.25rem)",
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $a88d4af8adb322fd$export$af13476fcb733bb1 = ({ action: { name: name, id: id } })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $a88d4af8adb322fd$var$wrapperStyles,
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a88d4af8adb322fd$var$pillIconStyles
        }, (0, (0, parcelRequire("dekey")).getAgentActionIcon)(id)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, name));
    };
});
parcelRegister("dekey", function(module, exports) {
    $parcel$export(module.exports, "getAgentActionIcon", ()=>$8ddb066a239459cd$export$8dc132872471a5e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZbEw;
    var $4ldhu;
    var $bFmnZ;
    var $4IrpZ;
    var $5nRKm;
    var $jB3w5;
    var $kdfZa;
    var $1bKdn;
    var $8mG85;
    var $hMDWV;
    const $8ddb066a239459cd$export$8dc132872471a5e1 = (actionKey)=>{
        switch(actionKey){
            case 'agent_action_jira_issue_create':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_confluence_page_create':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kdfZa"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_comment':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_confluence_page_comment':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_move':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8mG85"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_delete':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4IrpZ"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_assign':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_edit':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5nRKm"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_issue_transition':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hMDWV"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            case 'agent_action_jira_epics_suggest':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jB3w5"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                    label: "",
                    color: "var(--ds-icon-brand)"
                });
        }
    };
});
parcelRegister("4ldhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $32936cf628dec798$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32936cf628dec798$var$AutomationIcon = (props)=>$32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
        }, props));
    $32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
    var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;
});
parcelRegister("bFmnZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e4e36d6c115ce9$var$_UNSAFE_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e4e36d6c115ce9$var$CommentIcon = (props)=>$87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
        }, props));
    $87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
    var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;
});
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_UNSAFE_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("5nRKm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3eb8cab3ab465b93$var$_UNSAFE_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb8cab3ab465b93$var$EditIcon = (props)=>$3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
    var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;
});
parcelRegister("jB3w5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e44433503bdca276$var$_react = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e44433503bdca276$var$_UNSAFE_baseNew = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e44433503bdca276$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e44433503bdca276$var$IssueIcon = (props)=>$e44433503bdca276$var$_react.default.createElement($e44433503bdca276$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5 7.875 2 2.375 4-4.75m-9 7.75h12c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $e44433503bdca276$var$IssueIcon.displayName = 'IssueIcon';
    var $e44433503bdca276$var$_default = module.exports.default = $e44433503bdca276$var$IssueIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("8mG85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $61710ed7f2aa84a3$var$_UNSAFE_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61710ed7f2aa84a3$var$SprintIcon = (props)=>$61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
    var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;
});
parcelRegister("hMDWV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cf25e87f153b8182$var$_react = $cf25e87f153b8182$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cf25e87f153b8182$var$_UNSAFE_baseNew = $cf25e87f153b8182$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $cf25e87f153b8182$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cf25e87f153b8182$var$TransitionIcon = (props)=>$cf25e87f153b8182$var$_react.default.createElement($cf25e87f153b8182$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 12.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h1.438A1.813 1.813 0 0 0 8 10.938V5.062c0-1 .811-1.812 1.813-1.812h1.437m0 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"/>`
        }, props));
    $cf25e87f153b8182$var$TransitionIcon.displayName = 'TransitionIcon';
    var $cf25e87f153b8182$var$_default = module.exports.default = $cf25e87f153b8182$var$TransitionIcon;
});
parcelRegister("bfx6e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c1ed0113a077566$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c1ed0113a077566$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noActions: {
            id: 'rovo-chat.view-agent.no-actions',
            defaultMessage: 'No actions',
            description: 'Text to display when there are no actions for the agent'
        }
    });
});
parcelRegister("55jwW", function(module, exports) {
    $parcel$export(module.exports, "AgentKnowledgeSection", ()=>$ae4edb0fce8469f8$export$b1c40600d1679d39);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $1jWct;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $1DVhQ;
    var $kVZJG;
    var $8dO33;
    var $4ojTZ;
    var $jNfmW;
    var $50H8f;
    var $itLPw;
    const $ae4edb0fce8469f8$export$b1c40600d1679d39 = ({ aris: aris, isForgeAgent: isForgeAgent, knowledgeProductsRender: knowledgeProductsRender })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("50H8f")).useKnowledgeFilterService));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getEntitiesByAris: getEntitiesByAris } = (0, (0, parcelRequire("50H8f")).useKnowledgeFilterService)();
        const { isFetching: isFetching, data: urls } = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'getEntitiesByAris'
            ].concat(aris || []),
            queryFn: async ()=>{
                if (!aris?.length) return [];
                const entities = await getEntitiesByAris({
                    aris: aris
                });
                const links = entities.map((entity)=>entity.url);
                return links;
            },
            enabled: !isForgeAgent
        });
        const getKnowledgeRender = ()=>{
            if (isForgeAgent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                space: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                size: "small"
            }, formatMessage((0, (0, parcelRequire("itLPw")).default).forgeKnowledgeDescription))));
            if (!urls?.length && !knowledgeProductsRender && !isFetching) return formatMessage((0, (0, parcelRequire("itLPw")).default).noKnowledgeAdded);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.050"
            }, isFetching ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                height: 22,
                width: 200,
                borderRadius: 8,
                isShimmering: true
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                height: 22,
                width: 150,
                borderRadius: 8,
                isShimmering: true
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                height: 22,
                width: 200,
                borderRadius: 8,
                isShimmering: true
            })) : urls?.map((url)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVZJG")).Card), {
                    key: url,
                    fallbackComponent: (0, (0, parcelRequire("jNfmW")).smartLinkFallback)(url),
                    appearance: "inline",
                    url: url
                })), knowledgeProductsRender);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "view-agent-knowledge-cards"
        }, getKnowledgeRender()));
    };
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("kVZJG", function(module, exports) {
    $parcel$export(module.exports, "Card", ()=>$fc8afc0c39cee453$export$60332b2344f7fe41);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i5FdW;
    var $994MI;
    var $cb25w;
    var $fzJZi;
    var $lpxJ1;
    class $fc8afc0c39cee453$var$PlainCard extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lpxJ1")).CardWithURLRenderer), this.props);
            return this.props.intl ? content : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: "en"
            }, content);
        }
    }
    const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, (0, parcelRequire("994MI")).default)((0, (0, parcelRequire("fzJZi")).context))((0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("8RXs9")).default)($fc8afc0c39cee453$var$PlainCard, {
        enforceContext: false
    })));
});
parcelRegister("fzJZi", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$3b4d25437cc28513$export$85183a312807388d);
    $parcel$export(module.exports, "context", ()=>$3b4d25437cc28513$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "TrackQuickActionType", ()=>$3b4d25437cc28513$export$72af824fa910c33e);
    $parcel$export(module.exports, "TrackQuickActionFailureReason", ()=>$3b4d25437cc28513$export$c89e475f7f7174c2);
    $parcel$export(module.exports, "SmartLinkEvents", ()=>$3b4d25437cc28513$export$b91e0203b928470c);
    $parcel$export(module.exports, "resolvedEvent", ()=>$3b4d25437cc28513$export$e2e1bab8375c3115);
    $parcel$export(module.exports, "unresolvedEvent", ()=>$3b4d25437cc28513$export$331b399cdebbb8d4);
    $parcel$export(module.exports, "invokeSucceededEvent", ()=>$3b4d25437cc28513$export$237caeb1002642ba);
    $parcel$export(module.exports, "invokeFailedEvent", ()=>$3b4d25437cc28513$export$ac488bf3e4c7f93);
    $parcel$export(module.exports, "connectSucceededEvent", ()=>$3b4d25437cc28513$export$5f549b8ba38f19b1);
    $parcel$export(module.exports, "connectFailedEvent", ()=>$3b4d25437cc28513$export$fdfcba182edbb89a);
    $parcel$export(module.exports, "uiAuthEvent", ()=>$3b4d25437cc28513$export$5318734335f1d8b8);
    $parcel$export(module.exports, "uiAuthAlternateAccountEvent", ()=>$3b4d25437cc28513$export$14f2ce8523ccb652);
    $parcel$export(module.exports, "uiCardClickedEvent", ()=>$3b4d25437cc28513$export$8b5d1f55370347a1);
    $parcel$export(module.exports, "uiActionClickedEvent", ()=>$3b4d25437cc28513$export$e00b9d79d3367530);
    $parcel$export(module.exports, "uiClosedAuthEvent", ()=>$3b4d25437cc28513$export$fe5b1f066ca3365d);
    $parcel$export(module.exports, "uiRenderSuccessEvent", ()=>$3b4d25437cc28513$export$bd308326cf1076aa);
    $parcel$export(module.exports, "uiRenderFailedEvent", ()=>$3b4d25437cc28513$export$1543b6391f48a5e2);
    $parcel$export(module.exports, "uiHoverCardViewedEvent", ()=>$3b4d25437cc28513$export$e80a2f97cccab3b1);
    $parcel$export(module.exports, "uiHoverCardDismissedEvent", ()=>$3b4d25437cc28513$export$3d10c6f90bc461d3);
    $parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", ()=>$3b4d25437cc28513$export$ad3275d7dff50d21);
    $parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", ()=>$3b4d25437cc28513$export$925348ae8d2e0bf3);
    $parcel$export(module.exports, "chunkloadFailedEvent", ()=>$3b4d25437cc28513$export$2b6bbed3753f06f9);
    $parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", ()=>$3b4d25437cc28513$export$94c3643533642ab);
    $parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", ()=>$3b4d25437cc28513$export$18dfe458db0b743d);
    $parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", ()=>$3b4d25437cc28513$export$9a352e2e15b3de89);
    $parcel$export(module.exports, "uiServerActionClicked", ()=>$3b4d25437cc28513$export$a66dc699502b5d28);
    var $T540Y;
    var $5vDFA;
    const $3b4d25437cc28513$export$85183a312807388d = 'media';
    const $3b4d25437cc28513$export$a078c61943f9dbbe = {
        componentName: 'smart-cards',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    var $3b4d25437cc28513$export$72af824fa910c33e;
    (function(TrackQuickActionType) {
        TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    })($3b4d25437cc28513$export$72af824fa910c33e || ($3b4d25437cc28513$export$72af824fa910c33e = {}));
    var $3b4d25437cc28513$export$c89e475f7f7174c2;
    (function(TrackQuickActionFailureReason) {
        TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
        TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
        TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    })($3b4d25437cc28513$export$c89e475f7f7174c2 || ($3b4d25437cc28513$export$c89e475f7f7174c2 = {}));
    const $3b4d25437cc28513$export$bbd674aacb40a160 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'Follow',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
    };
    const $3b4d25437cc28513$export$baf70a532f8c6fa6 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
    };
    const $3b4d25437cc28513$var$uiActionSubjectIds = {
        DownloadAction: 'downloadDocument',
        PreviewAction: 'invokePreviewScreen',
        ViewAction: 'shortcutGoToLink',
        StatusAction: 'issueStatusUpdate'
    };
    class $3b4d25437cc28513$export$b91e0203b928470c {
        insertSmartLink(url, type, createAnalyticsEvent) {
            $3b4d25437cc28513$export$2a123f7ee48a122c({
                action: 'inserted',
                actionSubject: 'smartLink',
                eventType: 'track',
                attributes: {
                    type: type
                },
                nonPrivacySafeAttributes: {
                    domainName: url
                }
            }, createAnalyticsEvent);
        }
    }
    const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
        if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
    };
    const $3b4d25437cc28513$export$e2e1bab8375c3115 = (props)=>({
            action: 'resolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...props,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
            action: 'unresolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                id: id,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...definitionId ? {
                    definitionId: definitionId
                } : {},
                ...extensionKey ? {
                    extensionKey: extensionKey
                } : {},
                ...resourceType ? {
                    resourceType: resourceType
                } : {},
                ...destinationSubproduct ? {
                    destinationSubproduct: destinationSubproduct
                } : {},
                ...destinationProduct ? {
                    destinationProduct: destinationProduct
                } : {},
                ...location ? {
                    location: location
                } : {},
                reason: status,
                error: error ? {
                    message: error?.message,
                    kind: error?.kind,
                    type: error?.type
                } : undefined
            }
        });
    const $3b4d25437cc28513$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'resolved') : undefined;
        return {
            action: 'resolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                extensionKey: extensionKey,
                duration: measure?.duration
            }
        };
    };
    const $3b4d25437cc28513$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'errored') : undefined;
        return {
            action: 'unresolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                duration: measure?.duration,
                reason: reason
            }
        };
    };
    const $3b4d25437cc28513$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connectSucceeded',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
            action: 'connectFailed',
            actionSubject: 'smartLink',
            actionSubjectId: reason,
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                reason: reason,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'tryAnotherAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                isModifierKeyPressed: isModifierKeyPressed,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$var$uiActionSubjectIds[actionType],
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                display: display,
                actionType: actionType,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'closed',
            actionSubject: 'consentModal',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
            action: 'renderSuccess',
            actionSubject: 'smartLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display,
                canBeDatasource: canBeDatasource
            }
        });
    const $3b4d25437cc28513$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'smartLink',
            action: 'renderFailed',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'viewed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'dismissed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                hoverTime: hoverTime,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shortcutGoToLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod
            }
        });
    const $3b4d25437cc28513$export$925348ae8d2e0bf3 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'chunkLoadFailed',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$94c3643533642ab = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusLozenge',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$18dfe458db0b743d = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusListItem',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$9a352e2e15b3de89 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusOpenPreview',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
});
parcelRegister("T540Y", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkActionType", ()=>$171ae91e706973ef$export$6324b7946ad663e9);
    $parcel$export(module.exports, "InvokeError", ()=>$171ae91e706973ef$export$d4d72202bff63658);
    var $171ae91e706973ef$export$6324b7946ad663e9;
    (function(SmartLinkActionType) {
        SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
        SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
        SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
        SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    })($171ae91e706973ef$export$6324b7946ad663e9 || ($171ae91e706973ef$export$6324b7946ad663e9 = {}));
    class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
        constructor(message, errorCode){
            super(message);
            this.errorCode = errorCode;
        }
    }
});
parcelRegister("5vDFA", function(module, exports) {
    $parcel$export(module.exports, "clearMarks", ()=>$483ef2a5b4b04745$export$1a717feb4df1a945);
    $parcel$export(module.exports, "clearMeasures", ()=>$483ef2a5b4b04745$export$de42547d395c8271);
    $parcel$export(module.exports, "getMeasure", ()=>$483ef2a5b4b04745$export$d6e97a903ae9a3aa);
    $parcel$export(module.exports, "mark", ()=>$483ef2a5b4b04745$export$bf7f2fce5c1cf636);
    $parcel$export(module.exports, "create", ()=>$483ef2a5b4b04745$export$185802fd694ee1f5);
    const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
    const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
    const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
    const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
            marks.forEach((mark)=>performance.clearMarks(mark.name));
        }
    };
    const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
            measures.forEach((measure)=>performance.clearMeasures(measure.name));
        }
    };
    const $483ef2a5b4b04745$var$getMark = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            const marks = performance.getEntriesByName(name);
            if (marks.length > 0) return marks[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measures = performance.getEntriesByName(name);
            if (measures.length > 0) return measures[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            performance.mark(name);
        }
    };
    const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
            if (!measure) {
                const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
                const endMark = $483ef2a5b4b04745$var$getMark(id, status);
                if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
            }
        }
    };
});
parcelRegister("lpxJ1", function(module, exports) {
    $parcel$export(module.exports, "CardWithURLRenderer", ()=>$422a0598dbbdc42a$export$e00a7788e30dc998);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $gKZoD;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $kXQmf;
    var $kxcRq;
    var $91tw3;
    var $5vDFA;
    var $i41Ob;
    const $422a0598dbbdc42a$export$a7690c318cd6a95e = (0, $5uXOq.lazy)(()=>(0, (0, parcelRequire("kxcRq")).importWithRetry)(()=>(parcelRequire("4kgag"))));
    function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
        (0, (0, parcelRequire("gKZoD")).di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
        const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, ($parcel$interopDefault($7Jxgt)))());
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                (0, (0, parcelRequire("5vDFA")).clearMarks)(id);
                (0, (0, parcelRequire("5vDFA")).clearMeasures)(id);
            };
        }, [
            id
        ]);
        const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
        const analytics = (0, (0, parcelRequire("kXQmf")).useSmartLinkAnalytics)(url ?? '', id);
        const isFlexibleUi = (0, (0, parcelRequire("91tw3")).isFlexibleUiCard)(children);
        const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
            const { componentStack: componentStack } = info;
            const errorInfo = {
                componentStack: componentStack
            };
            if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
                display: appearance,
                error: error,
                errorInfo: errorInfo
            });
            else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id,
                error: error,
                errorInfo: errorInfo
            });
            onError && onError({
                status: 'errored',
                url: url ?? '',
                err: error
            });
        }, [
            analytics.operational,
            analytics.ui,
            appearance,
            id,
            onError,
            url,
            isFlexibleUi
        ]);
        if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
        const defaultFallBackComponent = ()=>null;
        const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
        const ErrorFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(FallbackComponent, null);
        const cardWithUrlProps = {
            id: id,
            url: url,
            appearance: appearance,
            onClick: onClick,
            isSelected: isSelected,
            isHovered: isHovered,
            frameStyle: frameStyle,
            container: container,
            onResolve: onResolve,
            onError: onError,
            testId: testId,
            actionOptions: actionOptions,
            inheritDimensions: inheritDimensions,
            platform: platform,
            embedIframeRef: embedIframeRef,
            embedIframeUrlType: embedIframeUrlType,
            inlinePreloaderStyle: inlinePreloaderStyle,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            showAuthTooltip: showAuthTooltip,
            placeholder: placeholder,
            removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
            resolvingPlaceholder: resolvingPlaceholder,
            truncateInline: truncateInline
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            FallbackComponent: ErrorFallback,
            onError: errorHandler
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i41Ob")).LoadingCardLink), cardWithUrlProps)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($422a0598dbbdc42a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
    }
});
parcelRegister("kXQmf", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkAnalytics", ()=>$6bc8b728824e2d0a$export$57c7fece972c9472);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $cCcdH;
    var $fzJZi;
    var $1n7Qj;
    var $fzJZi;
    var $fgpl1;
    var $1VPdD;
    var $kaKBF;
    const $6bc8b728824e2d0a$var$applyCommonAttributes = (event, commonAttributes)=>{
        if (event && event.attributes) {
            for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
        }
        return event;
    };
    const $6bc8b728824e2d0a$export$57c7fece972c9472 = (url, id, defaultLocation)=>{
        const { dispatchAnalytics: dispatchAnalytics } = (0, (0, parcelRequire("kaKBF")).useDispatchAnalytics)();
        const defaultId = id || 'NULL';
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const state = store ? (0, (0, parcelRequire("cCcdH")).getUrl)(store, url) : undefined;
        const details = state ? state.details : undefined;
        const extractedDefinitionId = (0, (0, parcelRequire("fgpl1")).getDefinitionId)(details);
        const extractedExtensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(details);
        const extractedResourceType = (0, (0, parcelRequire("fgpl1")).getResourceType)(details);
        const extractedSubproduct = (0, (0, parcelRequire("fgpl1")).getSubproduct)(details);
        const extractedProduct = (0, (0, parcelRequire("fgpl1")).getProduct)(details);
        const extractedStatusDetails = (0, (0, parcelRequire("fgpl1")).getStatusDetails)(details);
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                id: defaultId,
                definitionId: extractedDefinitionId,
                extensionKey: extractedExtensionKey,
                resourceType: extractedResourceType,
                destinationObjectType: extractedResourceType,
                destinationSubproduct: extractedSubproduct,
                destinationProduct: extractedProduct,
                location: defaultLocation,
                statusDetails: extractedStatusDetails
            }), [
            defaultId,
            extractedDefinitionId,
            extractedExtensionKey,
            extractedResourceType,
            extractedSubproduct,
            extractedProduct,
            defaultLocation,
            extractedStatusDetails
        ]);
        const ui = (0, $5uXOq.useMemo)(()=>({
                authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthAlternateAccountEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                buttonClickedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiCardClickedEvent)({
                        id: id,
                        display: display,
                        status: status,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        isModifierKeyPressed: isModifierKeyPressed,
                        location: location,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        actionSubjectId: actionSubjectId
                    }), commonAttributes)),
                actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiActionClickedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardOpenLinkClickedEvent)({
                        id: defaultId,
                        previewDisplay: previewDisplay,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod
                    }), commonAttributes));
                },
                closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiClosedAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                modalClosedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'closed',
                        actionSubject: 'modal',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-rendered', experienceId, {
                        extensionKey: extensionKey,
                        display: display
                    });
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-authenticated', experienceId, {
                        display: display
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderSuccessEvent)({
                        display: display,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        canBeDatasource: canBeDatasource
                    }), commonAttributes));
                },
                renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-authenticated', experienceId);
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardViewedEvent)({
                        id: id,
                        previewDisplay: previewDisplay,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardDismissedEvent)({
                        previewDisplay: previewDisplay,
                        id: id,
                        hoverTime: hoverTime,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                learnMoreClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiLearnMoreLinkClickedEvent)(), commonAttributes)),
                smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
                smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiServerActionClicked)(props), commonAttributes))
            }), [
            dispatchAnalytics,
            commonAttributes,
            defaultId,
            extractedExtensionKey
        ]);
        const operational = (0, $5uXOq.useMemo)(()=>({
                invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeSucceededEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeFailedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: 'success'
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectSucceededEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: reason
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectFailedEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                    const event = (0, (0, parcelRequire("1n7Qj")).instrumentEvent)({
                        ...commonAttributes,
                        id: id,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        error: error
                    });
                    if (event) dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes(event, commonAttributes));
                },
                chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).chunkloadFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                }
            }), [
            defaultId,
            commonAttributes,
            dispatchAnalytics
        ]);
        const screen = (0, $5uXOq.useMemo)(()=>({
                modalViewedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'viewed',
                        actionSubject: data.name,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'screen',
                        name: data.name
                    }, commonAttributes))
            }), [
            commonAttributes,
            dispatchAnalytics
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                ui: ui,
                operational: operational,
                screen: screen
            }), [
            ui,
            operational,
            screen
        ]);
    };
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("1n7Qj", function(module, exports) {
    $parcel$export(module.exports, "instrumentEvent", ()=>$a8cb699408687216$export$860cf9c079ed505);
    var $5vDFA;
    var $fzJZi;
    const $a8cb699408687216$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
        const measure = (0, (0, parcelRequire("5vDFA")).getMeasure)(id, status) || {
            duration: undefined
        };
        if (status === 'resolved') {
            const event = (0, (0, parcelRequire("fzJZi")).resolvedEvent)({
                id: id,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        } else if (error?.type !== 'ResolveUnsupportedError') {
            const event = (0, (0, parcelRequire("fzJZi")).unresolvedEvent)({
                id: id,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                error: error
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        }
    };
});
parcelRegister("fgpl1", function(module, exports) {
    $parcel$export(module.exports, "getByDefinitionId", ()=>$8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
    $parcel$export(module.exports, "getClickUrl", ()=>$8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
    $parcel$export(module.exports, "getDefinitionId", ()=>$8cbc55b0be5f7abb$export$46fa3e7718c82e41);
    $parcel$export(module.exports, "getExtensionKey", ()=>$8cbc55b0be5f7abb$export$218d96312e385949);
    $parcel$export(module.exports, "getResourceType", ()=>$8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
    $parcel$export(module.exports, "getProduct", ()=>$8cbc55b0be5f7abb$export$e2005c9600188ac7);
    $parcel$export(module.exports, "getSubproduct", ()=>$8cbc55b0be5f7abb$export$f8fdefc70357968e);
    $parcel$export(module.exports, "getServices", ()=>$8cbc55b0be5f7abb$export$a009e3a1163d46fb);
    $parcel$export(module.exports, "getStatusDetails", ()=>$8cbc55b0be5f7abb$export$a752a116d184ffbd);
    $parcel$export(module.exports, "isFinalState", ()=>$8cbc55b0be5f7abb$export$d590d08942abc17a);
    $parcel$export(module.exports, "getCanBeDatasource", ()=>$8cbc55b0be5f7abb$export$ba6d13ab7b87c55c);
    $parcel$export(module.exports, "hasAuthScopeOverrides", ()=>$8cbc55b0be5f7abb$export$3f9446bb21b945a0);
    var $iCv9y;
    const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
        const urls = Object.keys(store);
        return urls.filter((url)=>{
            const { details: details } = store[url];
            return details && details.meta.definitionId === definitionId;
        });
    };
    const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
        if (jsonLd && jsonLd.data) {
            const visitUrl = (0, (0, parcelRequire("iCv9y")).extractVisitUrl)(jsonLd.data);
            if (visitUrl) return visitUrl;
        }
        return url;
    };
    const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
    const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
    const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
    const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
    const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
    const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
    const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
    const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
    const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
    const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
        return details?.meta?.requestAccess?.accessType;
    };
    const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
        return [
            'unauthorized',
            'forbidden',
            'errored',
            'resolved',
            'not_found'
        ].indexOf(status) > -1;
    };
    const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
    const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
        const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
        return !!datasources && datasources.length > 0;
    };
    const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
});
parcelRegister("iCv9y", function(module, exports) {
    $parcel$export(module.exports, "extractVisitUrl", ()=>$28ad1893a5a5e6d3$export$c81497d3681f24f4);
    const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
        return jsonLd['atlassian:visitUrl'];
    };
});
parcelRegister("1VPdD", function(module, exports) {
    $parcel$export(module.exports, "startUfoExperience", ()=>$2308e6f5aae12b86$export$5e9287b6a10f8075);
    $parcel$export(module.exports, "succeedUfoExperience", ()=>$2308e6f5aae12b86$export$c5a5cf072c836c0e);
    $parcel$export(module.exports, "failUfoExperience", ()=>$2308e6f5aae12b86$export$8dda83bafca11b77);
    $parcel$export(module.exports, "addMetadataToExperience", ()=>$2308e6f5aae12b86$export$4084c0df4a03a6af);
    var $cBycP;
    var $7Zbvr;
    const $2308e6f5aae12b86$var$inlineExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$renderExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    };
    const $2308e6f5aae12b86$var$aiExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$ufoExperiences = {
        'smart-link-rendered': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
        'smart-link-authenticated': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-action-invocation': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-ai-summary': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
    };
    const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.start();
        if (properties) experience.addMetadata(properties);
    };
    const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.success({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.failure({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
        $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
    };
});
parcelRegister("cBycP", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);
    var $dCAsn;
    var $boHLC;
    class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("boHLC")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("dCAsn", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$c8856379f9e2d7e8$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$c8856379f9e2d7e8$export$d53d07b6034c4560);
    class $c8856379f9e2d7e8$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
    const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
    };
    const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("boHLC", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$69d53cdb5241e240$export$c00d22927c60484a);
    var $iLwDN;
    class $69d53cdb5241e240$export$c00d22927c60484a extends (0, (0, parcelRequire("iLwDN")).UFOAbstractExperience) {
    }
});
parcelRegister("iLwDN", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$cc70575b2203e361$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1vlV8;
    var $dCAsn;
    var $dlucd;
    var $blQsS;
    var $9tjMO;
    var $1CRHx;
    var $jZA09;
    var $hM2B6;
    var $7Zbvr;
    const $cc70575b2203e361$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("blQsS")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("blQsS")).PageVisibleState).HIDDEN;
    };
    const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("9tjMO")).roundPerfNow)();
    };
    class $cc70575b2203e361$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("blQsS")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("hM2B6")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).unsubscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("dCAsn")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("dCAsn")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("dCAsn")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).subscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("blQsS")).FMP_MARK) && name !== (0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("dCAsn")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("dCAsn")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';
parcelRegister("1vlV8", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$d117cb8be5e8747a$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$d117cb8be5e8747a$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$d117cb8be5e8747a$export$7c957416596ca127);
    var $dCAsn;
    var $blQsS;
    const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("dCAsn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("blQsS", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$2d245cff606eb60d$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$2d245cff606eb60d$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$2d245cff606eb60d$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$2d245cff606eb60d$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$2d245cff606eb60d$export$837e0f79a8056912);
    var $2d245cff606eb60d$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($2d245cff606eb60d$export$96253c35c37cf96b || ($2d245cff606eb60d$export$96253c35c37cf96b = {}));
    var $2d245cff606eb60d$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($2d245cff606eb60d$export$a12c67b37a306b13 || ($2d245cff606eb60d$export$a12c67b37a306b13 = {}));
    var $2d245cff606eb60d$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$66b33c055cbb625e || ($2d245cff606eb60d$export$66b33c055cbb625e = {}));
    var $2d245cff606eb60d$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$3ce489cbe02dc21b || ($2d245cff606eb60d$export$3ce489cbe02dc21b = {}));
    var $2d245cff606eb60d$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($2d245cff606eb60d$export$341b330828bd3906 || ($2d245cff606eb60d$export$341b330828bd3906 = {}));
    var $2d245cff606eb60d$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($2d245cff606eb60d$export$b9b20160f581e4f8 || ($2d245cff606eb60d$export$b9b20160f581e4f8 = {}));
    const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
    const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("dlucd", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$46b8336a04974a29$export$13e680397ec8f3eb);
    var $1CRHx;
    class $46b8336a04974a29$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();
});
parcelRegister("1CRHx", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$5d24ea5e24f61a4f$export$15e172712955e18f);
    const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("9tjMO", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$29608d3bcf65c265$export$5f490af6b2b115cf);
    const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("jZA09", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$175f7a63840c5fab$export$81b70111112841a0);
    const $175f7a63840c5fab$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("hM2B6", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$6edf4365ea9733d4$export$178881f329fdb81f);
    var $jZA09;
    const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ]
    };
    const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
        return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("7Zbvr", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$e40e68027603de60$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$e40e68027603de60$export$cc26007c03242fff);
    var $e40e68027603de60$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($e40e68027603de60$export$994164cf3ae1cc9a || ($e40e68027603de60$export$994164cf3ae1cc9a = {}));
    var $e40e68027603de60$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($e40e68027603de60$export$cc26007c03242fff || ($e40e68027603de60$export$cc26007c03242fff = {}));
});
parcelRegister("kaKBF", function(module, exports) {
    $parcel$export(module.exports, "useDispatchAnalytics", ()=>$bbdf588730868cbb$export$5f37699fba0ba807);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $fzJZi;
    const $bbdf588730868cbb$export$5f37699fba0ba807 = (handler)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return {
            dispatchAnalytics: (0, $5uXOq.useMemo)(()=>{
                if (handler) return handler;
                return (payload)=>{
                    createAnalyticsEvent(payload).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                };
            }, [
                handler,
                createAnalyticsEvent
            ])
        };
    };
});
parcelRegister("kxcRq", function(module, exports) {
    $parcel$export(module.exports, "isSpecialEvent", ()=>$c53851cced73411d$export$efca2c4705678489);
    $parcel$export(module.exports, "getIconForFileType", ()=>$c53851cced73411d$export$4d685c85ebc7a1e3);
    $parcel$export(module.exports, "getIframeSandboxAttribute", ()=>$c53851cced73411d$export$9b7e6a102056a387);
    $parcel$export(module.exports, "handleOnClick", ()=>$c53851cced73411d$export$ffccab2ae3d093ef);
    $parcel$export(module.exports, "isIntersectionObserverSupported", ()=>$c53851cced73411d$export$6c837641a9ab03cb);
    $parcel$export(module.exports, "importWithRetry", ()=>$c53851cced73411d$export$aacbf48ace518c5a);
    $parcel$export(module.exports, "downloadUrl", ()=>$c53851cced73411d$export$8a96edb1c96563f4);
    $parcel$export(module.exports, "openUrl", ()=>$c53851cced73411d$export$a238cfe4a10e6279);
    $parcel$export(module.exports, "getPreviewUrlWithTheme", ()=>$c53851cced73411d$export$4470f298c61a79da);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $imVhc;
    const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
    const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
    const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
    const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
    const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
        if (!fileMimeType) return;
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label, importCb] = icon;
        if (!importCb) return;
        const Icon = (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importCb().then((module)=>module.default),
            loading: ()=>null
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            testId: "document-file-format-icon"
        });
    };
    const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label] = icon;
        return label;
    };
    const $c53851cced73411d$var$typeToIcon = {
        'text/plain': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.oasis.opendocument.text': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.apple.pages': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.google-apps.document': [
            'Google Doc',
            ()=>(parcelRequire("jXySI"))
        ],
        'application/msword': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/pdf': [
            'PDF document',
            ()=>(parcelRequire("5GIkh"))
        ],
        'application/vnd.oasis.opendocument.spreadsheet': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.apple.numbers': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.google-apps.spreadsheet': [
            'Google Sheet',
            ()=>(parcelRequire("5bX2p"))
        ],
        'application/vnd.ms-excel': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.oasis.opendocument.presentation': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.apple.keynote': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.google-apps.presentation': [
            'Google Slide',
            ()=>(parcelRequire("fZksg"))
        ],
        'application/vnd.ms-powerpoint': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.google-apps.form': [
            'Google Form',
            ()=>(parcelRequire("k7KGr"))
        ],
        'image/png': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/jpeg': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/bmp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/webp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/svg+xml': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/gif': [
            'GIF',
            ()=>(parcelRequire("gBOzU"))
        ],
        'audio/midi': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/mpeg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/webm': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/ogg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/wav': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'video/mp4': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/quicktime': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/mov': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/webm': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/ogg': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-ms-wmv': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-msvideo': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'application/zip': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-tar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-gtar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-7z-compressed': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-apple-diskimage': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/vnd.rar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/dmg': [
            'Executable',
            ()=>(parcelRequire("ayRxW"))
        ],
        'text/css': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'text/html': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/javascript': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/octet-stream': [
            'Binary file',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/invision.prototype': [
            'Prototype',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/sketch': [
            'Sketch',
            ()=>(parcelRequire("ktas1"))
        ],
        folder: [
            'Folder',
            ()=>(parcelRequire("2KgZP"))
        ]
    };
    const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
        if (isTrusted) return undefined;
        const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
        return sandboxPermissions;
    };
    const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            handler();
        };
    const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
    const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
        return new Promise((resolve)=>setTimeout(resolve, ms));
    };
    const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
        try {
            return await importFn();
        } catch (error) {
            if (error.name === 'ChunkLoadError' && retries > 0) {
                await $c53851cced73411d$export$e772c8ff12451969(interval);
                return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
            } else throw error;
        }
    };
    const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
        if (!url) return;
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        link.download = url;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
        if (!url) return;
        window.open(url, '_blank', 'noopener=yes');
    };
    const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
        try {
            const url = new URL(previewUrl);
            url.searchParams.append('themeState', (0, (0, parcelRequire("imVhc")).themeObjectToString)(themeState));
            return url.href;
        } catch  {
            return previewUrl;
        }
    };
});
parcelRegister("duwKf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9d277a30a5a98acd$var$Document16Icon = (props)=>$9d277a30a5a98acd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
    var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;
});
parcelRegister("jXySI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7EgS6").then(()=>parcelRequire('3KifV'));
});
parcelRegister("1HfN1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erQ4S").then(()=>parcelRequire('im5Hg'));
});
parcelRegister("5GIkh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d767x").then(()=>parcelRequire('5m93C'));
});
parcelRegister("dcnwM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQ9xE").then(()=>parcelRequire('2Bgv8'));
});
parcelRegister("5bX2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("izomc").then(()=>parcelRequire('iByEQ'));
});
parcelRegister("asJlG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5I4RC").then(()=>parcelRequire('eABwY'));
});
parcelRegister("dzrUL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iV5W6").then(()=>parcelRequire('h7zk4'));
});
parcelRegister("fZksg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jepjM").then(()=>parcelRequire('F35X1'));
});
parcelRegister("jHQ8I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3YI2r").then(()=>parcelRequire('kKp2J'));
});
parcelRegister("k7KGr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cwkUf").then(()=>parcelRequire('j8IiS'));
});
parcelRegister("17GQp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hVGrh").then(()=>parcelRequire('daL8e'));
});
parcelRegister("gBOzU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aAton").then(()=>parcelRequire('96Idm'));
});
parcelRegister("2P3xs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iDnD4").then(()=>parcelRequire('dOkKo'));
});
parcelRegister("8Cn4N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhQt8").then(()=>parcelRequire('lDRqn'));
});
parcelRegister("1u9rQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7QDLp").then(()=>parcelRequire('8njZH'));
});
parcelRegister("ayRxW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b2yZA").then(()=>parcelRequire('lp0fk'));
});
parcelRegister("boS7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5khw4").then(()=>parcelRequire('6cEsd'));
});
parcelRegister("5GE4g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c1Yqk").then(()=>parcelRequire('7BHMh'));
});
parcelRegister("ktas1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5lMy").then(()=>parcelRequire('lE6mu'));
});
parcelRegister("2KgZP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaqBx").then(()=>parcelRequire('bBHpS'));
});
parcelRegister("91tw3", function(module, exports) {
    $parcel$export(module.exports, "isFlexibleUiCard", ()=>$f30ba994fabdf720$export$3c94e0f4719f5c2a);
    $parcel$export(module.exports, "isFlexibleUiTitleBlock", ()=>$f30ba994fabdf720$export$df0092b19156b140);
    $parcel$export(module.exports, "isFlexibleUiBlock", ()=>$f30ba994fabdf720$export$b56fc89cf6e7d1e9);
    $parcel$export(module.exports, "isFlexibleUiElement", ()=>$f30ba994fabdf720$export$d7fc505bb0bd5756);
    $parcel$export(module.exports, "isFlexibleUiPreviewBlock", ()=>$f30ba994fabdf720$export$c0547b4405cae584);
    var $5uXOq = parcelRequire("5uXOq");
    var $66ZRy;
    var $buvhv;
    var $hYQw7;
    var $ietxm;
    var $eqoQu;
    const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children)=>{
        if (children && (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
        return false;
    };
    const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("66ZRy"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("eqoQu"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("buvhv")).default);
    const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("hYQw7")).default);
    const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("ietxm")).default);
});
parcelRegister("66ZRy", function(module, exports) {
    $parcel$export(module.exports, "FooterBlock", ()=>(parcelRequire("ietxm")).default);
    $parcel$export(module.exports, "MetadataBlock", ()=>(parcelRequire("gg6Qm")).default);
    $parcel$export(module.exports, "PreviewBlock", ()=>(parcelRequire("hYQw7")).default);
    $parcel$export(module.exports, "SnippetBlock", ()=>(parcelRequire("1JaZ4")).default);
    $parcel$export(module.exports, "TitleBlock", ()=>(parcelRequire("buvhv")).default);
    $parcel$export(module.exports, "CustomBlock", ()=>(parcelRequire("dghu0")).default);
    $parcel$export(module.exports, "InternalFooterBlock", ()=>(parcelRequire("5HrTg")).default);
    $parcel$export(module.exports, "AISummaryBlock", ()=>(parcelRequire("1qDIM")).default);
    $parcel$export(module.exports, "AIFooterBlock", ()=>(parcelRequire("85ffk")).default);
    $parcel$export(module.exports, "ActionBlock", ()=>(parcelRequire("fh9qw")).default);
    var $ietxm;
    var $gg6Qm;
    var $hYQw7;
    var $1JaZ4;
    var $buvhv;
    var $dghu0;
    var $5HrTg;
    var $1qDIM;
    var $85ffk;
    var $fh9qw;
});
parcelRegister("ietxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fcebb5ad9978d90$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $5HrTg;
    const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !alwaysShow) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HrTg")).default), {
            ...props,
            testId: testId
        });
    };
    var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;
});
parcelRegister("8dVIb", function(module, exports) {
    $parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", ()=>$ad6fd5c2f706e309$export$5c881701926acbef);
    $parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", ()=>$ad6fd5c2f706e309$export$93d67ab022d9f8d2);
    $parcel$export(module.exports, "CONTENT_URL_AI", ()=>$ad6fd5c2f706e309$export$70d24f0465ae60f8);
    $parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", ()=>$ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
    $parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", ()=>$ad6fd5c2f706e309$export$73b198e73554a323);
    $parcel$export(module.exports, "SmartLinkAlignment", ()=>$ad6fd5c2f706e309$export$8910bf86027fe6be);
    $parcel$export(module.exports, "SmartLinkDirection", ()=>$ad6fd5c2f706e309$export$60831686b0574c86);
    $parcel$export(module.exports, "SmartLinkPosition", ()=>$ad6fd5c2f706e309$export$d58e6377644d1dcf);
    $parcel$export(module.exports, "SmartLinkSize", ()=>$ad6fd5c2f706e309$export$51f13ced115cbdae);
    $parcel$export(module.exports, "SmartLinkStatus", ()=>$ad6fd5c2f706e309$export$61cff06be26816f);
    $parcel$export(module.exports, "SmartLinkTheme", ()=>$ad6fd5c2f706e309$export$aed0f1e801ad691f);
    $parcel$export(module.exports, "SmartLinkInternalTheme", ()=>$ad6fd5c2f706e309$export$9aafec380d7005da);
    $parcel$export(module.exports, "SmartLinkWidth", ()=>$ad6fd5c2f706e309$export$19c60054ee783de6);
    $parcel$export(module.exports, "ElementName", ()=>$ad6fd5c2f706e309$export$d65b168331104a46);
    $parcel$export(module.exports, "ActionName", ()=>$ad6fd5c2f706e309$export$9c95d6e1614bad84);
    $parcel$export(module.exports, "InternalActionName", ()=>$ad6fd5c2f706e309$export$4871a84b35cf8eb9);
    $parcel$export(module.exports, "IconType", ()=>$ad6fd5c2f706e309$export$13ff1290a9e22e77);
    $parcel$export(module.exports, "MediaType", ()=>$ad6fd5c2f706e309$export$483c11740a902fcd);
    $parcel$export(module.exports, "MediaPlacement", ()=>$ad6fd5c2f706e309$export$f9f4737e25ab90fa);
    $parcel$export(module.exports, "CardDisplay", ()=>$ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
    const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
    const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
    const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
    const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
    const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
    var $ad6fd5c2f706e309$export$8910bf86027fe6be;
    (function(SmartLinkAlignment) {
        SmartLinkAlignment["Left"] = "left";
        SmartLinkAlignment["Right"] = "right";
    })($ad6fd5c2f706e309$export$8910bf86027fe6be || ($ad6fd5c2f706e309$export$8910bf86027fe6be = {}));
    var $ad6fd5c2f706e309$export$60831686b0574c86;
    (function(SmartLinkDirection) {
        SmartLinkDirection["Horizontal"] = "horizontal";
        SmartLinkDirection["Vertical"] = "vertical";
    })($ad6fd5c2f706e309$export$60831686b0574c86 || ($ad6fd5c2f706e309$export$60831686b0574c86 = {}));
    var $ad6fd5c2f706e309$export$d58e6377644d1dcf;
    (function(SmartLinkPosition) {
        SmartLinkPosition["Top"] = "top";
        SmartLinkPosition["Center"] = "center";
    })($ad6fd5c2f706e309$export$d58e6377644d1dcf || ($ad6fd5c2f706e309$export$d58e6377644d1dcf = {}));
    var $ad6fd5c2f706e309$export$51f13ced115cbdae;
    (function(SmartLinkSize) {
        SmartLinkSize["XLarge"] = "xlarge";
        SmartLinkSize["Large"] = "large";
        SmartLinkSize["Medium"] = "medium";
        SmartLinkSize["Small"] = "small";
    })($ad6fd5c2f706e309$export$51f13ced115cbdae || ($ad6fd5c2f706e309$export$51f13ced115cbdae = {}));
    var $ad6fd5c2f706e309$export$61cff06be26816f;
    (function(SmartLinkStatus) {
        SmartLinkStatus["Pending"] = "pending";
        SmartLinkStatus["Resolving"] = "resolving";
        SmartLinkStatus["Resolved"] = "resolved";
        SmartLinkStatus["Forbidden"] = "forbidden";
        SmartLinkStatus["Errored"] = "errored";
        SmartLinkStatus["NotFound"] = "not_found";
        SmartLinkStatus["Unauthorized"] = "unauthorized";
        SmartLinkStatus["Fallback"] = "fallback";
    })($ad6fd5c2f706e309$export$61cff06be26816f || ($ad6fd5c2f706e309$export$61cff06be26816f = {}));
    var $ad6fd5c2f706e309$export$aed0f1e801ad691f;
    (function(SmartLinkTheme) {
        SmartLinkTheme["Black"] = "black";
        SmartLinkTheme["Link"] = "link";
    })($ad6fd5c2f706e309$export$aed0f1e801ad691f || ($ad6fd5c2f706e309$export$aed0f1e801ad691f = {}));
    var $ad6fd5c2f706e309$export$9aafec380d7005da;
    (function(SmartLinkInternalTheme) {
        SmartLinkInternalTheme["Grey"] = "grey";
    })($ad6fd5c2f706e309$export$9aafec380d7005da || ($ad6fd5c2f706e309$export$9aafec380d7005da = {}));
    var $ad6fd5c2f706e309$export$19c60054ee783de6;
    (function(SmartLinkWidth) {
        SmartLinkWidth["FitToContent"] = "fit-to-content";
        SmartLinkWidth["Flexible"] = "flexible";
    })($ad6fd5c2f706e309$export$19c60054ee783de6 || ($ad6fd5c2f706e309$export$19c60054ee783de6 = {}));
    var $ad6fd5c2f706e309$export$d65b168331104a46;
    (function(ElementName) {
        ElementName["AssignedTo"] = "AssignedTo";
        ElementName["AssignedToGroup"] = "AssignedToGroup";
        ElementName["AttachmentCount"] = "AttachmentCount";
        ElementName["AuthorGroup"] = "AuthorGroup";
        ElementName["ChecklistProgress"] = "ChecklistProgress";
        ElementName["CollaboratorGroup"] = "CollaboratorGroup";
        ElementName["CommentCount"] = "CommentCount";
        ElementName["CreatedBy"] = "CreatedBy";
        ElementName["CreatedOn"] = "CreatedOn";
        ElementName["DueOn"] = "DueOn";
        ElementName["LatestCommit"] = "LatestCommit";
        ElementName["LinkIcon"] = "LinkIcon";
        ElementName["Location"] = "Location";
        ElementName["ModifiedBy"] = "ModifiedBy";
        ElementName["ModifiedOn"] = "ModifiedOn";
        ElementName["OwnedBy"] = "OwnedBy";
        ElementName["OwnedByGroup"] = "OwnedByGroup";
        ElementName["Preview"] = "Preview";
        ElementName["Priority"] = "Priority";
        ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
        ElementName["Provider"] = "Provider";
        ElementName["ReactCount"] = "ReactCount";
        ElementName["ReadTime"] = "ReadTime";
        ElementName["Snippet"] = "Snippet";
        ElementName["SourceBranch"] = "SourceBranch";
        ElementName["State"] = "State";
        ElementName["SubscriberCount"] = "SubscriberCount";
        ElementName["SubTasksProgress"] = "SubTasksProgress";
        ElementName["StoryPoints"] = "StoryPoints";
        ElementName["TargetBranch"] = "TargetBranch";
        ElementName["Title"] = "Title";
        ElementName["ViewCount"] = "ViewCount";
        ElementName["VoteCount"] = "VoteCount";
        ElementName["SentOn"] = "SentOn";
    })($ad6fd5c2f706e309$export$d65b168331104a46 || ($ad6fd5c2f706e309$export$d65b168331104a46 = {}));
    var $ad6fd5c2f706e309$export$9c95d6e1614bad84;
    (function(ActionName) {
        ActionName["CopyLinkAction"] = "CopyLinkAction";
        ActionName["DeleteAction"] = "DeleteAction";
        ActionName["EditAction"] = "EditAction";
        ActionName["FollowAction"] = "FollowAction";
        ActionName["PreviewAction"] = "PreviewAction";
        ActionName["AutomationAction"] = "AutomationAction";
        ActionName["DownloadAction"] = "DownloadAction";
        ActionName["CustomAction"] = "CustomAction";
    })($ad6fd5c2f706e309$export$9c95d6e1614bad84 || ($ad6fd5c2f706e309$export$9c95d6e1614bad84 = {}));
    var $ad6fd5c2f706e309$export$4871a84b35cf8eb9;
    (function(InternalActionName) {
        InternalActionName["AISummaryAction"] = "AISummaryAction";
        InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    })($ad6fd5c2f706e309$export$4871a84b35cf8eb9 || ($ad6fd5c2f706e309$export$4871a84b35cf8eb9 = {}));
    var $ad6fd5c2f706e309$export$13ff1290a9e22e77;
    (function(IconType) {
        IconType["Archive"] = "FileType:Archive";
        IconType["Audio"] = "FileType:Audio";
        IconType["Blog"] = "FileType:Blog";
        IconType["Code"] = "FileType:Code";
        IconType["Document"] = "FileType:Document";
        IconType["Executable"] = "FileType:Executable";
        IconType["File"] = "FileType:File";
        IconType["Folder"] = "FileType:Folder";
        IconType["Generic"] = "FileType:Generic";
        IconType["GIF"] = "FileType:GIF";
        IconType["GoogleDocs"] = "FileType:GoogleDocs";
        IconType["GoogleForms"] = "FileType:GoogleForms";
        IconType["GoogleSheets"] = "FileType:GoogleSheets";
        IconType["GoogleSlides"] = "FileType:GoogleSlides";
        IconType["Image"] = "FileType.Image";
        IconType["MSExcel"] = "FileType:Excel";
        IconType["MSPowerpoint"] = "FileType:Powerpoint";
        IconType["MSWord"] = "FileType:WordDocument";
        IconType["PDF"] = "FileType:PDF";
        IconType["Presentation"] = "FileType:Presentation";
        IconType["Sketch"] = "FileType:Sketch";
        IconType["Spreadsheet"] = "FileType:Spreadsheet";
        IconType["Template"] = "FileType:Template";
        IconType["Video"] = "FileType:Video";
        IconType["Branch"] = "BitBucket:Branch";
        IconType["Commit"] = "BitBucket:Commit";
        IconType["Project"] = "BitBucket:Project";
        IconType["PullRequest"] = "BitBucket:PullRequest";
        IconType["Repo"] = "BitBucket:Repo";
        IconType["Bug"] = "Jira:Bug";
        IconType["Change"] = "Jira:Change";
        IconType["Epic"] = "Jira:Epic";
        IconType["Incident"] = "Jira:Incident";
        IconType["Problem"] = "Jira:Problem";
        IconType["ServiceRequest"] = "Jira:ServiceRequest";
        IconType["Story"] = "Jira:Story";
        IconType["SubTask"] = "Jira:SubTask";
        IconType["Task"] = "Jira:Task";
        IconType["Confluence"] = "Provider:Confluence";
        IconType["Jira"] = "Provider:Jira";
        IconType["Default"] = "Default";
        IconType["Error"] = "Default:Error";
        IconType["Forbidden"] = "Default:Forbidden";
        IconType["Attachment"] = "Badge:Attachment";
        IconType["CheckItem"] = "Badge:Task";
        IconType["Comment"] = "Badge:Comment";
        IconType["View"] = "Badge:View";
        IconType["React"] = "Badge:React";
        IconType["Vote"] = "Badge:Vote";
        IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
        IconType["PriorityCritical"] = "Badge:PriorityCritical";
        IconType["PriorityHigh"] = "Badge:PriorityHigh";
        IconType["PriorityHighest"] = "Badge:PriorityHighest";
        IconType["PriorityLow"] = "Badge:PriorityLow";
        IconType["PriorityLowest"] = "Badge:PriorityLowest";
        IconType["PriorityMajor"] = "Badge:PriorityMajor";
        IconType["PriorityMedium"] = "Badge:PriorityMedium";
        IconType["PriorityMinor"] = "Badge:PriorityMinor";
        IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
        IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
        IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
        IconType["Subscriber"] = "Badge:Subscriber";
        IconType["SubTasksProgress"] = "Badge:SubTask";
    })($ad6fd5c2f706e309$export$13ff1290a9e22e77 || ($ad6fd5c2f706e309$export$13ff1290a9e22e77 = {}));
    var $ad6fd5c2f706e309$export$483c11740a902fcd;
    (function(MediaType) {
        MediaType["Image"] = "image";
    })($ad6fd5c2f706e309$export$483c11740a902fcd || ($ad6fd5c2f706e309$export$483c11740a902fcd = {}));
    var $ad6fd5c2f706e309$export$f9f4737e25ab90fa;
    (function(MediaPlacement) {
        MediaPlacement["Left"] = "left";
        MediaPlacement["Right"] = "right";
    })($ad6fd5c2f706e309$export$f9f4737e25ab90fa || ($ad6fd5c2f706e309$export$f9f4737e25ab90fa = {}));
    var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804;
    (function(CardDisplay) {
        CardDisplay["Inline"] = "inline";
        CardDisplay["Block"] = "block";
        CardDisplay["Embed"] = "embed";
        CardDisplay["EmbedPreview"] = "embedPreview";
        CardDisplay["Flexible"] = "flexible";
        CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    })($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 || ($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = {}));
});
parcelRegister("5HrTg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8eaafd3e75b73f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $bubxq;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
        const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, hideProvider: hideProvider } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const hasActions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(actions, context)?.length > 0, [
            actions,
            context
        ]);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, !hideProvider && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actions && hasActions ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            testId: "smart-element-group-actions",
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            overrideCss: (0, (0, parcelRequire("akF1x")).getActionGroupStyles)(size),
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            onDropdownOpenChange: onDropdownOpenChange,
            items: actions,
            appearance: "default"
        })) : null);
    };
    var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;
});
parcelRegister("Nh1XU", function(module, exports) {
    $parcel$export(module.exports, "FlexibleUiContext", ()=>$79a38154bf117346$export$ca70b164b615de47);
    $parcel$export(module.exports, "useFlexibleUiContext", ()=>$79a38154bf117346$export$61d7957a243df7aa);
    $parcel$export(module.exports, "FlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$9296fed6018ca95b);
    $parcel$export(module.exports, "useFlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$80b8dfec38d1d85c);
    $parcel$export(module.exports, "FlexibleUiOptionContext", ()=>$79a38154bf117346$export$f7433dbd6c50e26a);
    $parcel$export(module.exports, "useFlexibleUiOptionContext", ()=>$79a38154bf117346$export$e6b5ad18b56e8f51);
    var $5uXOq = parcelRequire("5uXOq");
    const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
    const $79a38154bf117346$export$9296fed6018ca95b = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$80b8dfec38d1d85c = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$9296fed6018ca95b);
    const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);
});
parcelRegister("eqoQu", function(module, exports) {
    $parcel$export(module.exports, "AssignedTo", ()=>$ec376f2b71614cc0$export$d3af56c23f9e459b);
    $parcel$export(module.exports, "AssignedToGroup", ()=>$ec376f2b71614cc0$export$fbd18f11bf3a3444);
    $parcel$export(module.exports, "AttachmentCount", ()=>$ec376f2b71614cc0$export$3bc3c9693a40aa);
    $parcel$export(module.exports, "AuthorGroup", ()=>$ec376f2b71614cc0$export$2ae2af4435dd6144);
    $parcel$export(module.exports, "ChecklistProgress", ()=>$ec376f2b71614cc0$export$5742b38fd5cfe410);
    $parcel$export(module.exports, "CollaboratorGroup", ()=>$ec376f2b71614cc0$export$a1e647014985ddb9);
    $parcel$export(module.exports, "CommentCount", ()=>$ec376f2b71614cc0$export$f4c1466e6fdd07b);
    $parcel$export(module.exports, "CreatedOn", ()=>$ec376f2b71614cc0$export$53ced9403d373871);
    $parcel$export(module.exports, "CreatedBy", ()=>$ec376f2b71614cc0$export$db468caedefbb630);
    $parcel$export(module.exports, "DueOn", ()=>$ec376f2b71614cc0$export$fea59459cfa1625b);
    $parcel$export(module.exports, "LatestCommit", ()=>$ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
    $parcel$export(module.exports, "LinkIcon", ()=>$ec376f2b71614cc0$export$69387b41dfc808f7);
    $parcel$export(module.exports, "Location", ()=>$ec376f2b71614cc0$export$18a2be9195644f38);
    $parcel$export(module.exports, "ModifiedBy", ()=>$ec376f2b71614cc0$export$ebbbdcc68d717b7b);
    $parcel$export(module.exports, "ModifiedOn", ()=>$ec376f2b71614cc0$export$a6db3f4240728b58);
    $parcel$export(module.exports, "OwnedBy", ()=>$ec376f2b71614cc0$export$fa04b1f8d953704f);
    $parcel$export(module.exports, "OwnedByGroup", ()=>$ec376f2b71614cc0$export$90e81c873cca1e90);
    $parcel$export(module.exports, "Priority", ()=>$ec376f2b71614cc0$export$300334f671c43555);
    $parcel$export(module.exports, "ProgrammingLanguage", ()=>$ec376f2b71614cc0$export$7904b5485bf997ea);
    $parcel$export(module.exports, "Provider", ()=>$ec376f2b71614cc0$export$2881499e37b75b9a);
    $parcel$export(module.exports, "ReactCount", ()=>$ec376f2b71614cc0$export$f69df2decd5f729e);
    $parcel$export(module.exports, "ReadTime", ()=>$ec376f2b71614cc0$export$77dedcd16f070a20);
    $parcel$export(module.exports, "SentOn", ()=>$ec376f2b71614cc0$export$897b145a1ed39fe5);
    $parcel$export(module.exports, "SourceBranch", ()=>$ec376f2b71614cc0$export$387c3264a8f67d61);
    $parcel$export(module.exports, "State", ()=>$ec376f2b71614cc0$export$7254cc27399e90bd);
    $parcel$export(module.exports, "SubscriberCount", ()=>$ec376f2b71614cc0$export$cfafe90bba8a54db);
    $parcel$export(module.exports, "SubTasksProgress", ()=>$ec376f2b71614cc0$export$d441f34e4c8dd9e7);
    $parcel$export(module.exports, "StoryPoints", ()=>$ec376f2b71614cc0$export$634eef04d1a9a575);
    $parcel$export(module.exports, "TargetBranch", ()=>$ec376f2b71614cc0$export$b5e4199e062b8f44);
    $parcel$export(module.exports, "Title", ()=>$ec376f2b71614cc0$export$f99233281efd08a0);
    $parcel$export(module.exports, "ViewCount", ()=>$ec376f2b71614cc0$export$ae2d8be089b6cfe0);
    $parcel$export(module.exports, "VoteCount", ()=>$ec376f2b71614cc0$export$b080bef6ed7fa75a);
    $parcel$export(module.exports, "Preview", ()=>(parcelRequire("kDhrr")).default);
    $parcel$export(module.exports, "Snippet", ()=>(parcelRequire("kp8aU")).default);
    var $8dVIb;
    var $eCsaJ;
    var $kDhrr;
    var $kp8aU;
    const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo);
    const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup);
    const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount);
    const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup);
    const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress);
    const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup);
    const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CommentCount);
    const $ec376f2b71614cc0$export$53ced9403d373871 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn);
    const $ec376f2b71614cc0$export$db468caedefbb630 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy);
    const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).DueOn);
    const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit);
    const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon);
    const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Location);
    const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy);
    const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn);
    const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy);
    const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup);
    const $ec376f2b71614cc0$export$300334f671c43555 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Priority);
    const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage);
    const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Provider);
    const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReactCount);
    const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReadTime);
    const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SentOn);
    const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch);
    const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).State);
    const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount);
    const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress);
    const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints);
    const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch);
    const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Title);
    const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ViewCount);
    const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).VoteCount);
});
parcelRegister("eCsaJ", function(module, exports) {
    $parcel$export(module.exports, "createElement", ()=>$3c92d860530d8c8b$export$c8a8987d4410bf2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $9tslm;
    var $4ZXUA;
    var $7IZqM;
    var $bWpL0;
    var $aWyvu;
    var $3dV67;
    var $cJxXG;
    var $77cM6;
    var $k39kU;
    const $3c92d860530d8c8b$var$elementMappings = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Attachment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).CheckItem
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Comment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).View
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).React
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Vote
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Commit
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: {
            component: (0, (0, parcelRequire("aWyvu")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: {
            component: (0, (0, parcelRequire("77cM6")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Subscriber
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: {
            component: (0, (0, parcelRequire("9tslm")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: {
            component: (0, (0, parcelRequire("3dV67")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: {
            component: (0, (0, parcelRequire("3dV67")).default),
            props: {
                theme: (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey
            }
        }
    };
    const $3c92d860530d8c8b$var$getContextKey = (name)=>{
        return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
    };
    const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
        if (!context) return undefined;
        const data = context[contextKey];
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                const AvatarGroupsWithFallback = [
                    (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup
                ];
                const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
                return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ViewCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).VoteCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress:
                return $3c92d860530d8c8b$var$toBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints:
                return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).created_by, context.createdBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).assigned_to, context.assignedTo);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).owned_by, context.ownedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).DueOn:
                return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).modified_by, context.modifiedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SentOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReadTime:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).read_time, data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch:
            case (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch:
                return $3c92d860530d8c8b$var$toTextProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).Title:
                return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
            default:
                return typeof data === 'object' ? data : undefined;
        }
    };
    const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
        return items ? {
            items: items
        } : showFallbackAvatar ? {
            items: []
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
        return label ? {
            label: label
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
        return value ? {
            value: value
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
        if (dateString) {
            const text = Date.parse(dateString) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                value: new Date(dateString),
                year: "numeric",
                month: "short",
                day: "numeric",
                formatMatcher: "best fit"
            }) : dateString;
            return {
                text: text
            };
        }
    };
    const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
        return dateString ? {
            date: new Date(dateString),
            type: type
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
        return context ? {
            message: {
                descriptor: descriptor,
                values: {
                    context: context
                }
            }
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
        return text ? {
            text: text,
            url: url
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toTextProps = (content)=>{
        return content ? {
            content: content
        } : undefined;
    };
    const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
        const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
        const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
        if (!BaseElement) throw Error(`Element ${name} does not exist.`);
        return (overrides)=>{
            const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
            const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
            return data ? (0, ($parcel$interopDefault($5uXOq))).createElement(BaseElement, {
                ...props,
                ...data,
                ...overrides,
                name: name
            }) : null;
        };
    };
});
parcelRegister("7zaVw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a298b78183f16654$export$defe85febe8b728c);
    var $7VHMR;
    const $a298b78183f16654$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actions: {
            id: 'fabric.linking.actions',
            defaultMessage: 'Actions',
            description: ''
        },
        add_account: {
            id: 'fabric.linking.add_account',
            defaultMessage: 'Add account',
            description: 'Allows to add a new account'
        },
        ai_summarize: {
            id: 'fabric.linking.ai_summarize',
            defaultMessage: 'Summarize',
            description: 'Action to summarize link resource content with AI'
        },
        ai_summarized: {
            id: 'fabric.linking.ai_summarized',
            defaultMessage: 'Summarized by Atlassian Intelligence',
            description: 'Shown with the content summarised by AI.'
        },
        ai_summarized_abbreviation: {
            id: 'fabric.linking.ai_summarized_abbreviation',
            defaultMessage: 'Summarized by AI',
            description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
        },
        ai_summarized_info: {
            id: 'fabric.linking.ai_summarized_info',
            defaultMessage: 'Information quality may vary. <a>Learn more</a>',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarized_info_short: {
            id: 'fabric.linking.ai_summarized_info_short',
            defaultMessage: 'Content quality may vary',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarizing: {
            id: 'fabric.linking.ai_summarizing',
            defaultMessage: 'Atlassian Intelligence is working...',
            description: 'Shown when AI summary is summarising the link resource content.'
        },
        ai_summary_error_generic: {
            id: 'fabric.linking.ai_summary_error_generic',
            defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
            description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
        },
        ai_summary_error_acceptable_use_violation: {
            id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
            defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
            description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
        },
        ai_summary_error_hipaa_content_detected: {
            id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
            defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
            description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
        },
        ai_summary_error_exceeding_context_length_error: {
            id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
            defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
            description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
        },
        assigned_to: {
            id: 'fabric.linking.assigned_to',
            defaultMessage: 'Assigned to {context}',
            description: 'Indicates the person or entity that the resource is assigned to.'
        },
        automation_action_title: {
            id: 'fabric.linking.automation-action.title',
            defaultMessage: 'View automation rules',
            description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
        },
        automation_action_icon_label: {
            id: 'fabric.linking.automation-action.icon.label',
            defaultMessage: 'Automation icon',
            description: 'The label for the automation icon inside of the button opening the automation menu.'
        },
        automation_action_tooltip: {
            id: 'fabric.linking.automation-action.tooltip',
            defaultMessage: 'Select an automation rule to run',
            description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
        },
        automation_action_confluence_page_modal_title: {
            id: 'fabric.linking.automation-action.confluence.page.modal.title',
            defaultMessage: 'Page automations',
            description: 'The title of the automation modal when the SmartLink is a Confluence page'
        },
        automation_action_confluence_page_modal_description: {
            id: 'fabric.linking.automation-action.confluence.page.modal.description',
            defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
            description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
        },
        cancel: {
            id: 'fabric.linking.cancel',
            defaultMessage: 'Cancel',
            description: 'cancel'
        },
        beta: {
            id: 'fabric.linking.beta',
            defaultMessage: 'Beta',
            description: 'Indicates a beta phase of the feature.'
        },
        cannot_connect: {
            id: 'fabric.linking.cannot_connect',
            defaultMessage: "Can't connect, try again",
            description: 'Error for when a provided link is not found.'
        },
        cannot_find_link: {
            id: 'fabric.linking.cannot_find_link',
            defaultMessage: "Can't find link",
            description: 'Error for when a provided link is not found.'
        },
        click_to_join: {
            id: 'fabric.linking.click_to_join',
            defaultMessage: 'Join {context}',
            description: 'Allows the user join the product or service immediately'
        },
        click_to_join_description: {
            id: 'fabric.linking.click_to_join_description',
            defaultMessage: "You've been approved, so you can join {context} right away.",
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        close: {
            id: 'fabric.linking.close',
            defaultMessage: 'Close',
            description: ''
        },
        check_this_link: {
            id: 'fabric.linking.check_this_link',
            defaultMessage: 'Check this link',
            description: 'Link safety warning modal header'
        },
        connect_to: {
            id: 'fabric.linking.connect_to',
            defaultMessage: 'Connect to {name}',
            description: 'Allows the user to connect with different types of external services'
        },
        connect_account_description: {
            id: 'fabric.linking.connect_account_description',
            defaultMessage: "We'll open a new page to help you connect your {name} account",
            description: 'Explains what will happen when the users connects to a new account'
        },
        connect_link_account: {
            id: 'fabric.linking.connect_link_account',
            defaultMessage: 'Connect to preview',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
        },
        connect_link_account_card: {
            id: 'fabric.linking.connect_link_account_card_view',
            defaultMessage: 'Connect',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_link_account_card_name: {
            id: 'fabric.linking.connect_link_account_card_view_name',
            defaultMessage: 'Connect your {context} account',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
        },
        connect_link_account_card_description: {
            id: 'fabric.linking.connect_link_account_card_view_description',
            defaultMessage: 'To show a preview of this link, connect your {context} account.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
        },
        connect_unauthorised_account_action: {
            id: 'fabric.linking.connect_unauthorised_account_action',
            defaultMessage: 'Connect to {context}',
            description: 'Shown on a button to connect user external account to their Atlassian account.'
        },
        connect_unauthorised_account_description: {
            id: 'fabric.linking.connect_unauthorised_account_description',
            defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_unauthorised_account_description_no_provider: {
            id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
            defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
        },
        continue: {
            id: 'fabric.linking.continue',
            defaultMessage: 'Continue',
            description: 'continue'
        },
        copy_url_to_clipboard: {
            id: 'fabric.linking.copy_url_to_clipboard',
            defaultMessage: 'Copy link',
            description: ''
        },
        copied_url_to_clipboard: {
            id: 'fabric.linking.copied_url_to_clipboard',
            defaultMessage: 'Copied!',
            description: 'Url has been copied to the clipboard'
        },
        could_not_load_link: {
            id: 'fabric.linking.couldnt_load_link',
            defaultMessage: "We couldn't load this link for an unknown reason.",
            description: 'Error case for card view - link could not be loaded.'
        },
        created_by: {
            id: 'fabric.linking.created_by',
            defaultMessage: 'Created by {context}',
            description: 'Indicates the person or entity that created the resource.'
        },
        created_on_relative: {
            id: 'fabric.linking.create_on_relative',
            defaultMessage: 'Created {context}',
            description: 'Indicated when entity was created (relative form)'
        },
        created_on_absolute: {
            id: 'fabric.linking.create_on_absolute',
            defaultMessage: 'Created on {context}',
            description: 'Indicated when entity was created (absolute form)'
        },
        delete: {
            id: 'fabric.linking.delete',
            defaultMessage: 'Delete',
            description: 'Allow a user to delete a link'
        },
        download: {
            id: 'fabric.linking.download',
            defaultMessage: 'Download',
            description: ''
        },
        download_description: {
            id: 'fabric.linking.download_description',
            defaultMessage: 'Download this file into your local storage',
            description: 'Description on what Download does'
        },
        download_file: {
            id: 'fabric.linking.download_file',
            defaultMessage: 'Download file',
            description: 'Allow a user to download a file'
        },
        ai_summary_action: {
            id: 'fabric.linking.ai_summary_action',
            defaultMessage: 'Summarize with AI',
            description: 'Allow a user to summarize a link'
        },
        ai_summary_action_description: {
            id: 'fabric.linking.ai_summary_action_description',
            defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
            description: 'Description of what the summarize link with AI action does'
        },
        copy_summary_action: {
            id: 'fabric.linking.copy_summary_action',
            defaultMessage: 'Copy summary',
            description: 'Allow a user to copy a generated summary'
        },
        copy_summary_action_description: {
            id: 'fabric.linking.copy_summary_action_description',
            defaultMessage: 'Copy summary',
            description: 'Description of what the copy summary AI action does'
        },
        copied_summary_action_description: {
            id: 'fabric.linking.copied_summary_action_description',
            defaultMessage: 'Copied summary to clipboard',
            description: 'Confirmation to the user that the summry has been copied'
        },
        edit: {
            id: 'fabric.linking.edit',
            defaultMessage: 'Edit',
            description: 'Allow a user to edit a link'
        },
        follow: {
            id: 'fabric.linking.follow',
            defaultMessage: 'Follow',
            description: 'Click to follow a project.'
        },
        follow_project_description: {
            id: 'fabric.linking.follow_project_description',
            defaultMessage: 'Follow to get notifications on this project',
            description: 'Description on what Follow does'
        },
        follow_project: {
            id: 'fabric.linking.follow_project',
            defaultMessage: 'Follow project',
            description: 'Click to follow a project.'
        },
        follow_project_error: {
            id: 'fabric.linking.follow_project_error',
            defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas project'
        },
        follow_goal_description: {
            id: 'fabric.linking.follow_goal_description',
            defaultMessage: 'Follow this goal to get notifications on updates',
            description: 'Description on what Follow does'
        },
        follow_goal: {
            id: 'fabric.linking.follow_goal',
            defaultMessage: 'Follow goal',
            description: 'Click to follow a project.'
        },
        follow_goal_error: {
            id: 'fabric.linking.follow_goal_error',
            defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas goal'
        },
        go_back: {
            id: 'fabric.linking.go_back',
            defaultMessage: 'Go back',
            description: 'go back'
        },
        invalid_permissions: {
            id: 'fabric.linking.invalid_permissions',
            defaultMessage: 'Restricted content',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        invalid_permissions_description: {
            id: 'fabric.linking.invalid_permissions_description',
            defaultMessage: "You'll need to request access or try a different account to view this preview.",
            description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
        },
        join_to_view: {
            id: 'fabric.linking.join_to_view',
            defaultMessage: 'Join {context} to view this issue',
            description: 'Allows the user join the product or service immediately'
        },
        learn_more_about_smart_links: {
            id: 'fabric.linking.learn_more_about_smart_links',
            defaultMessage: 'Learn more about Smart Links.',
            description: 'An anchor link to redirect user to a page about Smart Links.'
        },
        learn_more_about_connecting_account: {
            id: 'fabric.linking.learn_more_about_connecting_account',
            defaultMessage: 'Learn more about connecting your account to Atlassian products.',
            description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
        },
        loading: {
            id: 'fabric.linking.loading',
            defaultMessage: 'Loading...',
            description: 'Indicates an element on a page is loading.'
        },
        modified_by: {
            id: 'fabric.linking.updated_by',
            defaultMessage: 'Modified by {context}',
            description: 'Indicates the person or entity that modified the resource.'
        },
        modified_on_relative: {
            id: 'fabric.linking.modified_on_relative',
            defaultMessage: 'Updated {context}',
            description: 'Indicated when entity was modified (relative form)'
        },
        modified_on_absolute: {
            id: 'fabric.linking.modified_on_absolute',
            defaultMessage: 'Updated on {context}',
            description: 'Indicated when entity was modified (absolute form)'
        },
        more_actions: {
            id: 'fabric.linking.more_actions',
            defaultMessage: 'More actions',
            description: 'Allows the users to see more link actions'
        },
        open_issue_in_jira: {
            id: 'fabric.linking.open_issue_in_jira',
            defaultMessage: 'Open issue in Jira',
            description: 'Click to open link in Jira'
        },
        open_link_in_a_new_tab: {
            id: 'fabric.linking.open_link_in_a_new_tab',
            defaultMessage: 'Open link in a new tab',
            description: 'Click to open link in a new tab'
        },
        owned_by: {
            id: 'fabric.linking.owned_by',
            defaultMessage: 'Owned by {context}',
            description: 'Indicates the person or entity that owns or maintains the resource.'
        },
        preview_description: {
            id: 'fabric.linking.preview_description',
            defaultMessage: 'Open a full screen preview of this link',
            description: 'Description on what Preview does'
        },
        preview_improved: {
            id: 'fabric.linking.preview_improved',
            defaultMessage: 'Open preview',
            description: 'Click to view a richer view of your content, without needing to navigate to it.'
        },
        preview_close: {
            id: 'fabric.linking.preview_close',
            defaultMessage: 'Close preview',
            description: 'Click to close embed preview modal.'
        },
        preview_max_size: {
            id: 'fabric.linking.preview_max_size',
            defaultMessage: 'View full screen',
            description: 'Click to increase embed preview modal size to a maximum viewing size.'
        },
        preview_min_size: {
            id: 'fabric.linking.preview_min_size',
            defaultMessage: 'Close full screen',
            description: 'Click to decrease embed preview modal size to a minimum viewing size.'
        },
        priority_blocker: {
            id: 'fabric.linking.priority_blocker',
            defaultMessage: 'Blocker',
            description: 'Indicated priority as blocker'
        },
        priority_critical: {
            id: 'fabric.linking.priority_critical',
            defaultMessage: 'Critical',
            description: 'Indicated priority as critical'
        },
        priority_high: {
            id: 'fabric.linking.priority_high',
            defaultMessage: 'High',
            description: 'Indicated priority as high'
        },
        priority_highest: {
            id: 'fabric.linking.priority_highest',
            defaultMessage: 'Highest',
            description: 'Indicated priority as highest'
        },
        priority_low: {
            id: 'fabric.linking.priority_low',
            defaultMessage: 'Low',
            description: 'Indicated priority as low'
        },
        priority_lowest: {
            id: 'fabric.linking.priority_lowest',
            defaultMessage: 'Lowest',
            description: 'Indicated priority as lowest'
        },
        priority_major: {
            id: 'fabric.linking.priority_major',
            defaultMessage: 'Major',
            description: 'Indicated priority as major'
        },
        priority_medium: {
            id: 'fabric.linking.priority_medium',
            defaultMessage: 'Medium',
            description: 'Indicated priority as medium'
        },
        priority_minor: {
            id: 'fabric.linking.priority_minor',
            defaultMessage: 'Minor',
            description: 'Indicated priority as minor'
        },
        priority_trivial: {
            id: 'fabric.linking.priority_trivial',
            defaultMessage: 'Trivial',
            description: 'Indicated priority as trivial'
        },
        priority_undefined: {
            id: 'fabric.linking.priority_undefined',
            defaultMessage: 'Undefined',
            description: 'Indicated priority as unknown'
        },
        forbidden_access: {
            id: 'fabric.linking.forbidden_access',
            defaultMessage: 'Your access is forbidden',
            description: 'Shown when a user does not have access to a resource behind the link.'
        },
        pending_request: {
            id: 'fabric.linking.pending_request',
            defaultMessage: 'Your access request is pending',
            description: 'Shown when a user has requested an access but status is pending.'
        },
        read_time: {
            id: 'fabric.linking.read_time',
            defaultMessage: '{context} min read',
            description: 'Estimated time to read this resource'
        },
        restricted_link: {
            id: 'fabric.linking.restricted_link',
            defaultMessage: 'Restricted link, try another account',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        request_access_to_view: {
            id: 'fabric.linking.request_access_to_view',
            defaultMessage: 'Request access to {context} to view this issue',
            description: 'Allows the user to request access to a product or service'
        },
        request_denied: {
            id: 'fabric.linking.request_denied',
            defaultMessage: 'Your access request was denied',
            description: 'The user had request access but the request was denied by a product or service'
        },
        retry: {
            id: 'fabric.linking.retry',
            defaultMessage: 'Retry',
            description: 'Allows user to perform an action again'
        },
        save: {
            id: 'fabric.linking.save',
            defaultMessage: 'Save',
            description: 'Just the "save" word'
        },
        sent_on_relative: {
            id: 'fabric.linking.sent_on_relative',
            defaultMessage: 'Sent {context}',
            description: 'Indicated when entity was sent (relative form)'
        },
        sent_on_absolute: {
            id: 'fabric.linking.sent_on_absolute',
            defaultMessage: 'Sent on {context}',
            description: 'Indicated when entity was sent (absolute form)'
        },
        status_change_load_error: {
            id: 'fabric.linking.status_change_load_error',
            defaultMessage: "We couldn\u2019t load the statuses and transitions",
            description: 'Informs the user that the loading of status transitions failed'
        },
        status_change_permission_error: {
            id: 'fabric.linking.status_change_permission_error',
            defaultMessage: "You don\u2019t have permission to transition this issue. ",
            description: 'Informs the user that they do not have enough permissions to update a status'
        },
        status_change_update_error: {
            id: 'fabric.linking.status_change_update_error',
            defaultMessage: "We couldn\u2019t update the status",
            description: "Occurs when a user tries to update an issue's status but fails to do so"
        },
        try_again: {
            id: 'fabric.linking.try_again',
            defaultMessage: 'Try again',
            description: 'Allow the user to try an action again'
        },
        try_another_account: {
            id: 'fabric.linking.try_another_account',
            defaultMessage: 'Try another account',
            description: 'Allows the user to try an action again with a different account'
        },
        link_safety_warning_message: {
            id: 'fabric.linking.link_safety_warning_message',
            defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
            description: 'Link safety check warning message'
        },
        unauthorised_account_description: {
            id: 'fabric.linking.unauthorised_account_description',
            defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_description_no_provider: {
            id: 'fabric.linking.unauthorised_account_description_no_provider',
            defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_name: {
            id: 'fabric.linking.unauthorised_account_name',
            defaultMessage: "We can't display private pages from {context}",
            description: 'Shown when a user does not have access to a link.'
        },
        unauthorised_account_name_no_provider: {
            id: 'fabric.linking.unauthorised_account_name_no_provider',
            defaultMessage: "We can't display private pages",
            description: 'Shown when a user does not have access to a link.'
        },
        unassigned: {
            id: 'fabric.linking.unassigned',
            defaultMessage: 'Unassigned',
            description: 'Shown as a tooltip text for a default unassigned fallback avatar'
        },
        unfollow: {
            id: 'fabric.linking.unfollow',
            defaultMessage: 'Unfollow',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_description: {
            id: 'fabric.linking.unfollow_project_description',
            defaultMessage: 'Unfollow to stop receiving project notifications',
            description: 'Description on what Unfollow does'
        },
        unfollow_project: {
            id: 'fabric.linking.unfollow_project',
            defaultMessage: 'Unfollow project',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_error: {
            id: 'fabric.linking.unfollow_project_error',
            defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
        },
        unfollow_goal_description: {
            id: 'fabric.linking.unfollow_goal_description',
            defaultMessage: 'Unfollow to stop receiving notifications for this goal',
            description: 'Description on what Unfollow does'
        },
        unfollow_goal: {
            id: 'fabric.linking.unfollow_goal',
            defaultMessage: 'Unfollow goal',
            description: 'Click to unfollow a project.'
        },
        unfollow_goal_error: {
            id: 'fabric.linking.unfollow_goal_error',
            defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
        },
        unlink_account: {
            id: 'fabric.linking.unlink_account',
            defaultMessage: 'Unlink Account',
            description: 'Allows to remove a connected account from the user'
        },
        view: {
            id: 'fabric.linking.view',
            defaultMessage: 'View',
            description: 'Go through to a piece of content to view it in its original context.'
        },
        viewIn: {
            id: 'fabric.linking.srclink',
            defaultMessage: 'View in',
            description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
        },
        viewOriginal: {
            id: 'fabric.linking.srclinkunknown',
            defaultMessage: 'View Original',
            description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
        },
        default_no_access_title: {
            id: 'fabric.linking.no_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they dont have access to certain content'
        },
        direct_access_title: {
            id: 'fabric.linking.direct_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access_description: {
            id: 'fabric.linking.direct_access_description',
            defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access: {
            id: 'fabric.linking.direct_access',
            defaultMessage: 'Join now',
            description: 'Allows the user join the product or service immediately'
        },
        request_access_description: {
            id: 'fabric.linking.request_access_description',
            defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
            description: 'Informs the user to request access to a product by talking to the website administrator'
        },
        request_access: {
            id: 'fabric.linking.request_access',
            defaultMessage: 'Request access',
            description: 'Allows the user to request access to a product or service'
        },
        request_access_pending_title: {
            id: 'fabric.linking.request_access_pending_title',
            defaultMessage: 'Access to {product} is pending',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_access_pending_description: {
            id: 'fabric.linking.request_access_pending_description',
            defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
            description: 'Informs the user that their request to view this content is pending website administrator approval'
        },
        request_access_pending: {
            id: 'fabric.linking.request_access_pending',
            defaultMessage: 'Pending approval',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_denied_description: {
            id: 'fabric.linking.request_denied_description',
            defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
            description: 'Informs the user that their request to view this content was denied'
        },
        access_exists_description: {
            id: 'fabric.linking.access_exists_description',
            defaultMessage: 'Request access to view this content from {hostname}.',
            description: 'Informs the user to contact the website administrator to request access to a product'
        },
        not_found_description: {
            id: 'fabric.linking.not_found_description',
            defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
            description: 'Error case for when a provided item is not found within the list of items'
        },
        not_found_title: {
            id: 'fabric.linking.not_found_title',
            defaultMessage: "We can't show you this {product} page",
            description: 'Error case for when a provided link is not found'
        },
        forbidden_title: {
            id: 'fabric.linking.forbidden_title',
            defaultMessage: "You don't have access to this content",
            description: 'Informs the user that they do not have access to the linked content.'
        },
        forbidden_description: {
            id: 'fabric.linking.forbidden_description',
            defaultMessage: 'Contact your admin to request access to {hostname}.',
            description: 'Informs the user that they must contact the site administrator for access.'
        },
        related: {
            id: 'fabric.linking.related',
            defaultMessage: 'Related',
            description: 'Informs the user about related resources'
        },
        generic_error_message: {
            id: 'fabric.linking.generic_error_message',
            defaultMessage: 'An error occurred',
            description: 'A generic error message to the user'
        },
        related_links_modal_title: {
            id: 'fabric.linking.related_links_modal_title',
            defaultMessage: 'Recent links',
            description: 'Shown as the title for the related links modal'
        },
        related_links_view_related_urls: {
            id: 'fabric.linking.related_links_view_related_urls',
            defaultMessage: 'View recent links',
            description: 'Action to view related links to the given resource'
        },
        related_links_found_in: {
            id: 'fabric.linking.related_links_found_in',
            defaultMessage: 'Found In',
            description: 'Informs the user of the resources are found in the given url'
        },
        related_links_not_found: {
            id: 'fabric.linking.related_links_not_found',
            defaultMessage: "We didn't find any links to show here.",
            description: 'Informs the user that there are no related resources for the given url'
        },
        related_links_includes_links_to: {
            id: 'fabric.linking.related_links_includes_links_to',
            defaultMessage: 'Includes Links To',
            description: 'Informs the user of the resources the url links to'
        },
        related_links_modal_error_header: {
            id: 'fabric.linking.related_links_modal_error_header',
            defaultMessage: 'Something went wrong',
            description: 'Title for related links error'
        },
        related_links_modal_error_message: {
            id: 'fabric.linking.related_links_modal_error_message',
            defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
            description: 'Informs the user that there was a problem loading related links'
        },
        related_links_modal_unavailable_header: {
            id: 'fabric.linking.related_links_modal_unavailable_header',
            defaultMessage: 'No recent links',
            description: 'Title for related links being unavailable'
        },
        related_links_modal_unavailable_message: {
            id: 'fabric.linking.related_links_modal_unavailable_message',
            defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
            description: 'Informs the user that related links were not found but may be available in the future'
        }
    });
});
parcelRegister("9tslm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf2a1e857857107e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $16T6Y;
    function $bf2a1e857857107e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bf2a1e857857107e$var$badgeStyles = {
        name: "qowjig",
        styles: "align-items:center;display:inline-flex"
    };
    const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
        if (!value) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $bf2a1e857857107e$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-atlaskit-badge": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("16T6Y")).default), null, value));
    };
    var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("4ZXUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e655d051c837701$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $jnhNB;
    var $8dVIb;
    var $7zaVw;
    var $fpDmE;
    function $1e655d051c837701$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1e655d051c837701$var$MAX_COUNT = 4;
    var $1e655d051c837701$var$_ref = {
        name: "1brfzli",
        styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
    };
    const $1e655d051c837701$var$getStyles = (size)=>{
        const styles = $1e655d051c837701$var$_ref;
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return styles;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
        }
    };
    const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).assigned_to, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).owned_by, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).created_by, personName);
            default:
                return personName;
        }
    };
    const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $5uXOq.useMemo)(()=>{
            if (!items.length && showFallbackAvatar) switch(name){
                case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                    return [
                        {
                            name: (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).unassigned)
                        }
                    ];
                default:
                    return [];
            }
            if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
                return {
                    ...person,
                    name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
                };
            });
            return items;
        }, [
            name,
            items,
            showNamePrefix,
            showFallbackAvatar,
            intl
        ]);
        if (!data.length) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $1e655d051c837701$var$getStyles(size),
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-avatar-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jnhNB")).default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        }));
    };
    var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;
});
parcelRegister("fpDmE", function(module, exports) {
    $parcel$export(module.exports, "sizeToButtonSpacing", ()=>$3ebf94f205ad0182$export$9d642f65a919fb93);
    $parcel$export(module.exports, "getFormattedMessage", ()=>$3ebf94f205ad0182$export$f1aa79f2218fb713);
    $parcel$export(module.exports, "getFormattedMessageAsString", ()=>$3ebf94f205ad0182$export$66ecb50a9dd1768);
    $parcel$export(module.exports, "getIconSizeStyles", ()=>$3ebf94f205ad0182$export$a5dfadfde90ee066);
    $parcel$export(module.exports, "getIconWidth", ()=>$3ebf94f205ad0182$export$fb10bc5609c6347e);
    $parcel$export(module.exports, "importIcon", ()=>$3ebf94f205ad0182$export$6dc831e1a0a7a851);
    $parcel$export(module.exports, "getLinkLineHeight", ()=>$3ebf94f205ad0182$export$1826e889cc97649);
    $parcel$export(module.exports, "getLinkSizeStyles", ()=>$3ebf94f205ad0182$export$7c3a25542ae9da0e);
    $parcel$export(module.exports, "getMaxLineHeight", ()=>$3ebf94f205ad0182$export$a681bd062fee88a5);
    $parcel$export(module.exports, "getMaxLines", ()=>$3ebf94f205ad0182$export$c2293adf1794c09);
    $parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", ()=>$3ebf94f205ad0182$export$475c391af8171fec);
    $parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", ()=>$3ebf94f205ad0182$export$1af10e3728e3a644);
    $parcel$export(module.exports, "getTruncateStyles", ()=>$3ebf94f205ad0182$export$8847c5561c06da49);
    $parcel$export(module.exports, "hasWhiteSpace", ()=>$3ebf94f205ad0182$export$619e376a425cb759);
    $parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", ()=>$3ebf94f205ad0182$export$7207d5a516d3bfa8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $4qBtX = parcelRequire("4qBtX");
    var $8dVIb;
    var $2Fcti;
    var $aWyvu;
    const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small]: 'none',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge]: 'default'
    };
    const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
        if (message) {
            const { descriptor: descriptor, values: values } = message;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...descriptor,
                values: values
            });
        }
    };
    const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
        const { formatMessage: formatMessage } = intl;
        return message ? formatMessage(message, {
            context: context
        }) : '';
    };
    const $3ebf94f205ad0182$var$getIconDimensionStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)({
            height: value,
            minHeight: value,
            maxHeight: value,
            width: value,
            minWidth: value,
            maxWidth: value
        });
    const $3ebf94f205ad0182$export$a5dfadfde90ee066 = (width)=>{
        const sizeStyles = $3ebf94f205ad0182$var$getIconDimensionStyles(width);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
    };
    const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '2rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return '1rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '.75rem';
        }
    };
    const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $3ebf94f205ad0182$export$1826e889cc97649 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $3ebf94f205ad0182$export$7c3a25542ae9da0e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '1.25rem',
                    fontWeight: 400,
                    letterSpacing: '-0.008em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    letterSpacing: '-0.003em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 400,
                    letterSpacing: '0em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
        }
    };
    const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1.75;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 1.5;
        }
    };
    const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
        if (value > max) return defaultValue;
        if (value < min) return min;
        return value;
    };
    const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.100';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.050';
        }
    };
    const $3ebf94f205ad0182$export$1af10e3728e3a644 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.300';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.100';
        }
    };
    const $3ebf94f205ad0182$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: wordBreak,
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical',
            '@supports not (-webkit-line-clamp: 1)': {
                maxHeight: `calc(${maxLines} * ${lineHeight})`
            }
        });
    const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
        return str.search(/\s/) >= 0;
    };
    const $3ebf94f205ad0182$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
        const icon = {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWyvu")).default), {
                ...linkIcon,
                size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large
            }),
            isFlexibleUi: true
        };
        return (0, (0, parcelRequire("2Fcti")).openEmbedModal)({
            ...props,
            icon: icon,
            origin: 'smartLinkCard'
        });
    };
});
parcelRegister("2Fcti", function(module, exports) {
    $parcel$export(module.exports, "openEmbedModal", ()=>$2555d47e7922f4ad$export$7859f96cd8cff034);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $i5FdW;
    const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
    const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';
    async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
        let popupMountPoint;
        popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
            popupMountPoint.setAttribute('data-testid', 'preview-modal');
            document.body.appendChild(popupMountPoint);
        }
        let Modal = await (parcelRequire("1khRa"));
        (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })), popupMountPoint);
    }
});
parcelRegister("1khRa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9ytm6")
    ]).then(()=>parcelRequire('amcti'));
});
parcelRegister("aWyvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6c193b1fc074556$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jOyH3;
    var $8dVIb;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $d6c193b1fc074556$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $d6c193b1fc074556$var$_ref = {
        name: "1xpq7g4",
        styles: "align-self:flex-start;margin:0"
    };
    var $d6c193b1fc074556$var$_ref2 = {
        name: "qbt5ty",
        styles: "align-self:center"
    };
    const $d6c193b1fc074556$var$getPositionStyles = (position)=>{
        switch(position){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center:
                return $d6c193b1fc074556$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top:
            default:
                return $d6c193b1fc074556$var$_ref;
        }
    };
    const $d6c193b1fc074556$var$getIconStyles = (position, width)=>(0, (0, parcelRequire("f8Sb3")).css)($d6c193b1fc074556$var$getPositionStyles(position), (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(width));
    const $d6c193b1fc074556$var$getCustomRenderStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, value), {
            lineHeight: value,
            fontSize: value,
            textAlign: 'center',
            textOverflow: 'clip',
            WebkitBoxOrient: 'unset',
            span: {
                margin: 0,
                padding: 0,
                verticalAlign: 'baseline'
            }
        });
    const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            testId: `${testId}-icon`
        });
    };
    const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            label: label,
            testId: `${testId}-default`,
            color: "currentColor"
        });
    const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            defaultIcon: defaultIcon,
            testId: testId,
            url: url
        });
    };
    const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
        const element = (0, $5uXOq.useMemo)(()=>{
            const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
            return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
        }, [
            overrideIcon,
            icon,
            label,
            render,
            testId,
            url
        ]);
        const width = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const styles = $d6c193b1fc074556$var$getIconStyles(position, width);
        const renderStyles = render ? $d6c193b1fc074556$var$getCustomRenderStyles(width) : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                styles,
                renderStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-icon": true,
            "data-testid": testId
        }, element);
    };
    var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;
});
parcelRegister("jOyH3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));
    var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
    function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e6cd993777d46e1b$var$LinkIcon = (props)=>$e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
        }, props));
    $e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
    var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("9Hdrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1647af7fe5459c6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $duwKf;
    var $61uoP;
    var $7anl7;
    var $29YN9;
    var $8dVIb;
    const $1647af7fe5459c6c$var$importIconMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).Archive]: ()=>(parcelRequire("1u9rQ")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Audio]: ()=>(parcelRequire("2P3xs")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Code]: ()=>(parcelRequire("boS7Q")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Executable]: ()=>(parcelRequire("ayRxW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).File]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Folder]: ()=>(parcelRequire("2KgZP")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Generic]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GIF]: ()=>(parcelRequire("gBOzU")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleDocs]: ()=>(parcelRequire("jXySI")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleForms]: ()=>(parcelRequire("k7KGr")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSheets]: ()=>(parcelRequire("5bX2p")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSlides]: ()=>(parcelRequire("fZksg")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Image]: ()=>(parcelRequire("17GQp")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSExcel]: ()=>(parcelRequire("asJlG")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSPowerpoint]: ()=>(parcelRequire("jHQ8I")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSWord]: ()=>(parcelRequire("1HfN1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PDF]: ()=>(parcelRequire("5GIkh")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Presentation]: ()=>(parcelRequire("dzrUL")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Sketch]: ()=>(parcelRequire("ktas1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Spreadsheet]: ()=>(parcelRequire("dcnwM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Template]: ()=>(parcelRequire("kLx2P")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Video]: ()=>(parcelRequire("8Cn4N")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Branch]: ()=>(parcelRequire("8OYab")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Commit]: ()=>(parcelRequire("9Ls0O")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).PullRequest]: ()=>(parcelRequire("bLx4v")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Repo]: ()=>(parcelRequire("g7B05")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Bug]: ()=>(parcelRequire("jcfjn")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Change]: ()=>(parcelRequire("hvvgH")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Epic]: ()=>(parcelRequire("i5w36")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Incident]: ()=>(parcelRequire("jCmVW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Problem]: ()=>(parcelRequire("jWILw")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ServiceRequest]: ()=>(parcelRequire("2A66E")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Story]: ()=>(parcelRequire("50cEq")),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTask]: ()=>(parcelRequire("4pfB7")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Task]: ()=>(parcelRequire("d15m6")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                    default: ConfluenceIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                    default: JiraIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Forbidden]: ()=>(parcelRequire("9xScK")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Attachment]: ()=>(parcelRequire("4zmmA")),
        [(0, (0, parcelRequire("8dVIb")).IconType).CheckItem]: ()=>(parcelRequire("dYx6r")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Comment]: ()=>(parcelRequire("kCKH6")),
        [(0, (0, parcelRequire("8dVIb")).IconType).View]: ()=>(parcelRequire("bUKCR")),
        [(0, (0, parcelRequire("8dVIb")).IconType).React]: ()=>(parcelRequire("gmFhf")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Vote]: ()=>(parcelRequire("oYZun")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: ()=>(parcelRequire("L5NMF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: ()=>(parcelRequire("dBeMd")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: ()=>(parcelRequire("1drkv")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: ()=>(parcelRequire("ivKwz")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: ()=>(parcelRequire("8XsoF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: ()=>(parcelRequire("a3VWM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: ()=>(parcelRequire("2Kdus")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: ()=>(parcelRequire("6UcdR")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: ()=>(parcelRequire("8eqKo")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: ()=>(parcelRequire("hHzrM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: ()=>(parcelRequire("fzaCl")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage]: ()=>(parcelRequire("6Hg82")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Subscriber]: ()=>(parcelRequire("ePXdx")),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress]: ()=>(parcelRequire("8B9kt"))
    };
    const $1647af7fe5459c6c$var$getIconImportFn = (icon)=>$1647af7fe5459c6c$var$importIconMapper[icon];
    const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Document:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("duwKf"))))), {
                    label: label || 'document',
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Blog:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61uoP"))))), {
                    label: label || 'blog',
                    testId: testId
                });
        }
        const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon);
        if (!importFn) return null;
        const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Confluence:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Jira:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Error:
            case (0, (0, parcelRequire("8dVIb")).IconType).Forbidden:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                });
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId
                });
        }
    };
    var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;
});
parcelRegister("61uoP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $462a6acb8358e55a$var$_react = $462a6acb8358e55a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $462a6acb8358e55a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $462a6acb8358e55a$var$Blog16Icon = (props)=>$462a6acb8358e55a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`
        }, props, {
            size: "small"
        }));
    $462a6acb8358e55a$var$Blog16Icon.displayName = 'Blog16Icon';
    var $462a6acb8358e55a$var$_default = module.exports.default = $462a6acb8358e55a$var$Blog16Icon;
});
parcelRegister("kLx2P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dtoNN").then(()=>parcelRequire('53J27'));
});
parcelRegister("8OYab", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a8V9r").then(()=>parcelRequire('36B8O'));
});
parcelRegister("9Ls0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OCkL").then(()=>parcelRequire('gSpCs'));
});
parcelRegister("bLx4v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVi2f").then(()=>parcelRequire('jXbwR'));
});
parcelRegister("g7B05", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("keZKc").then(()=>parcelRequire('9wmko'));
});
parcelRegister("jcfjn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lyRQ2").then(()=>parcelRequire('cQpjg'));
});
parcelRegister("hvvgH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aFtbU").then(()=>parcelRequire('lThgm'));
});
parcelRegister("i5w36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6i1Ed").then(()=>parcelRequire('lxe7t'));
});
parcelRegister("jCmVW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("huO2I").then(()=>parcelRequire('kiHC6'));
});
parcelRegister("jWILw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7GK64").then(()=>parcelRequire('eNbic'));
});
parcelRegister("2A66E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6XIJ0").then(()=>parcelRequire('lLgcu'));
});
parcelRegister("50cEq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Gz5Y").then(()=>parcelRequire('g2bjw'));
});
parcelRegister("4pfB7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("laRGo").then(()=>parcelRequire('ePeTp'));
});
parcelRegister("d15m6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6GAo3").then(()=>parcelRequire('eUrLn'));
});
parcelRegister("9xScK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j1srk").then(()=>parcelRequire('gs7PQ'));
});
parcelRegister("4zmmA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gWXGh").then(()=>parcelRequire('j3Vfq'));
});
parcelRegister("dYx6r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("geqFV").then(()=>parcelRequire('imUQY'));
});
parcelRegister("kCKH6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5nLi").then(()=>parcelRequire('DBbS0'));
});
parcelRegister("bUKCR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("97YHa").then(()=>parcelRequire('bH0nF'));
});
parcelRegister("gmFhf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cj5mx").then(()=>parcelRequire('kxkv9'));
});
parcelRegister("oYZun", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7SKVs").then(()=>parcelRequire('kAObg'));
});
parcelRegister("L5NMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2JrEQ").then(()=>parcelRequire('jJL9z'));
});
parcelRegister("dBeMd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("czPXX").then(()=>parcelRequire('3pKEh'));
});
parcelRegister("1drkv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bW2Ht").then(()=>parcelRequire('k7gBp'));
});
parcelRegister("ivKwz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jlDVs").then(()=>parcelRequire('Le10t'));
});
parcelRegister("8XsoF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9n8Rc").then(()=>parcelRequire('kc1MS'));
});
parcelRegister("a3VWM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0ALI").then(()=>parcelRequire('hfn9j'));
});
parcelRegister("2Kdus", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kFjg9").then(()=>parcelRequire('4zl0K'));
});
parcelRegister("6UcdR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("50gXn").then(()=>parcelRequire('cfbO3'));
});
parcelRegister("8eqKo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Bya1").then(()=>parcelRequire('jyFo7'));
});
parcelRegister("hHzrM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6xK7c").then(()=>parcelRequire('eJNZM'));
});
parcelRegister("fzaCl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8YLm9")
    ]).then(()=>parcelRequire('7QGmb'));
});
parcelRegister("6Hg82", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iY2wN").then(()=>parcelRequire('c2JK5'));
});
parcelRegister("ePXdx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9PWSC")
    ]).then(()=>parcelRequire('h8cgU'));
});
parcelRegister("8B9kt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("10dT8").then(()=>parcelRequire('gKopa'));
});
parcelRegister("l5Xsv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$951590e808a48e01$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bmnhy = parcelRequire("bmnhy");
    var $gU02S;
    const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($bmnhy))), {
            src: url,
            loading: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
                testId: `${testId}-loading`
            }),
            loaded: (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: defaultIcon,
            onError: onError,
            onLoad: onLoad
        });
    var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;
});
parcelRegister("bmnhy", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8453cf1ee7ef4644$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
    function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $8453cf1ee7ef4644$var$loading(image) {
        return {
            image: image,
            isLoaded: false,
            isErrored: false
        };
    }
    function $8453cf1ee7ef4644$var$loaded() {
        return {
            isLoaded: true
        };
    }
    function $8453cf1ee7ef4644$var$errored() {
        return {
            isErrored: true
        };
    }
    function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
        var prevSrc = prevProps.src;
        var nextSrc = nextProps.src;
        return prevSrc !== nextSrc;
    }
    var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
        $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
        function ImageRenderer() {
            var _ref;
            var _temp, _this, _ret;
            $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                isLoaded: false,
                isErrored: false
            }, _this.handleLoad = function() {
                var onLoad = _this.props.onLoad;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                    if (onLoad) onLoad();
                });
            }, _this.handleError = function() {
                var onError = _this.props.onError;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                    if (onError) onError();
                });
            }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
        }
        $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
            {
                key: 'load',
                value: function load() {
                    var src = this.props.src;
                    var image = this.state.image;
                    if (image) {
                        image.onload = this.handleLoad;
                        image.onerror = this.handleError;
                        image.src = src;
                    }
                }
            },
            {
                key: 'unload',
                value: function unload() {
                    var image = this.state.image;
                    if (image) {
                        image.onload = undefined;
                        image.onerror = undefined;
                    }
                }
            },
            {
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (typeof window === 'undefined') return;
                    this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.load();
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                        this.unload();
                        this.load();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.unload();
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                    var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                    if (isLoaded && loaded) return loaded;
                    if (isErrored && errored) return errored;
                    if (!isLoaded && !isErrored && loading) return loading;
                    if (children) return children({
                        image: isLoaded ? image : undefined,
                        loaded: isLoaded,
                        errored: isErrored
                    });
                    return null;
                }
            }
        ]);
        return ImageRenderer;
    }($8453cf1ee7ef4644$var$React.Component);
    module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;
});
parcelRegister("gU02S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$880176eb12ae8419$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $880176eb12ae8419$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
        const animationNameStyles = (0, (0, parcelRequire("f8Sb3")).keyframes)({
            '0%': {
                backgroundPosition: '50% 0'
            },
            '100%': {
                backgroundPosition: '-50% 0'
            }
        });
        const styles = (0, (0, parcelRequire("f8Sb3")).css)({
            width: `${width}rem`,
            height: `${height}rem`,
            borderRadius: '2px',
            userSelect: 'none',
            background: "var(--ds-skeleton-subtle, #f6f7f8)",
            backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '280% 100%',
            display: 'inline-block',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: animationNameStyles,
            animationTimingFunction: 'linear'
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: styles,
            "data-testid": testId
        });
    };
    var $880176eb12ae8419$export$2e2bcd8739ae039 = $880176eb12ae8419$var$LoadingSkeleton;
});
parcelRegister("7IZqM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aab9f19acb0d3ec1$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $7zaVw;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $aab9f19acb0d3ec1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $aab9f19acb0d3ec1$var$badgeStyles = {
        name: "9qxyko",
        styles: "align-items:center;display:inline-flex;min-width:fit-content"
    };
    const $aab9f19acb0d3ec1$var$iconStyles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
    const $aab9f19acb0d3ec1$var$labelStyles = {
        name: "8loelm",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
    };
    const $aab9f19acb0d3ec1$var$messageMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: (0, (0, parcelRequire("7zaVw")).messages).priority_blocker,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: (0, (0, parcelRequire("7zaVw")).messages).priority_critical,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: (0, (0, parcelRequire("7zaVw")).messages).priority_high,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: (0, (0, parcelRequire("7zaVw")).messages).priority_highest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: (0, (0, parcelRequire("7zaVw")).messages).priority_low,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: (0, (0, parcelRequire("7zaVw")).messages).priority_lowest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: (0, (0, parcelRequire("7zaVw")).messages).priority_major,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: (0, (0, parcelRequire("7zaVw")).messages).priority_medium,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: (0, (0, parcelRequire("7zaVw")).messages).priority_minor,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: (0, (0, parcelRequire("7zaVw")).messages).priority_trivial,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: (0, (0, parcelRequire("7zaVw")).messages).priority_undefined
    };
    const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
        if (icon) {
            const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
            if (descriptor) return (0, (0, parcelRequire("fpDmE")).getFormattedMessage)({
                descriptor: descriptor
            });
        }
    };
    const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            label: icon,
            testId: `${testId}-icon`
        });
    };
    const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: testId,
            url: url
        });
    };
    const $aab9f19acb0d3ec1$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
        const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
        const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
        if (!formattedMessageOrLabel || !badgeIcon) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $aab9f19acb0d3ec1$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-badge": true,
            "data-testid": testId
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$iconStyles
        }, badgeIcon), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$labelStyles,
            "data-testid": `${testId}-label`
        }, formattedMessageOrLabel));
    };
    var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;
});
parcelRegister("bWpL0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a4f7878d6976fe$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $j7anB;
    var $ousew;
    var $koVbs;
    var $7zaVw;
    var $fpDmE;
    const $66a4f7878d6976fe$var$styles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1));
    const $66a4f7878d6976fe$var$typeToDescriptorMap = {
        created: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).created_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).created_on_absolute
        },
        modified: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).modified_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).modified_on_absolute
        },
        sent: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).sent_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).sent_on_absolute
        }
    };
    const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
        const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        if (!type || !date) return null;
        const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
        let context;
        let typeVariant;
        if (isLongerThenWeek) {
            typeVariant = 'absolute';
            context = formatDate(date, {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        } else {
            const { value: value, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(date, Date.now());
            typeVariant = 'relative';
            context = formatRelativeTime(value, unit, {
                numeric: 'auto'
            });
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $66a4f7878d6976fe$var$styles,
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-date-time": true,
            "data-testid": testId
        }, text ? `${text} ${context}` : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        }));
    };
    var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;
});
parcelRegister("3dV67", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60bb11df77d728a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3bDjY;
    var $8dVIb;
    var $4URMI;
    var $fpDmE;
    function $b60bb11df77d728a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
    const $b60bb11df77d728a$var$containerStyles = {
        name: "mkkf9p",
        styles: "flex:1 1 auto"
    };
    var $b60bb11df77d728a$var$_ref = {
        name: "16ucc2m",
        styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref2 = {
        name: "1glvof",
        styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref3 = {
        name: "izk992",
        styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);}"
    };
    const $b60bb11df77d728a$var$getThemeStyles = (theme)=>{
        switch(theme){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey:
                return $b60bb11df77d728a$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Black:
                return $b60bb11df77d728a$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link:
            default:
                return $b60bb11df77d728a$var$_ref;
        }
    };
    const $b60bb11df77d728a$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;", sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), $b60bb11df77d728a$var$getThemeStyles(theme));
    };
    const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
        if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
        if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: content,
            testId: `${testId}-tooltip`,
            tag: "span"
        }, trigger);
    const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, (0, parcelRequire("fpDmE")).hasWhiteSpace)(text) : false, [
            text
        ]);
        const anchor = (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            css: [
                $b60bb11df77d728a$var$getAnchorStyles(size, theme, $b60bb11df77d728a$var$getMaxLines(maxLines), hasSpace),
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-link": true,
            "data-testid": testId,
            onClick: onClick,
            onMouseDown: onMouseDown,
            href: url,
            ...target !== '_self' && {
                target: target
            }
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b60bb11df77d728a$var$containerStyles
        }, hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId));
    };
    var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;
});
parcelRegister("4URMI", function(module, exports) {
    $parcel$export(module.exports, "useLinkClicked", ()=>$0d5ea96be37e2b5d$export$5993d3ca6c85f774);
    $parcel$export(module.exports, "useMouseDownEvent", ()=>$0d5ea96be37e2b5d$export$df67f318ded0283c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $g2eZ6;
    var $0d5ea96be37e2b5d$export$81a5b494baf0f17c;
    (function(ClickButton) {
        ClickButton[ClickButton["Left"] = 0] = "Left";
        ClickButton[ClickButton["Middle"] = 1] = "Middle";
        ClickButton[ClickButton["Right"] = 2] = "Right";
    })($0d5ea96be37e2b5d$export$81a5b494baf0f17c || ($0d5ea96be37e2b5d$export$81a5b494baf0f17c = {}));
    const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (handler, predicate)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((...args)=>{
            const [event] = args;
            handler?.apply(null, args);
            if (!predicate || predicate?.(event)) (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            handler,
            predicate,
            createAnalyticsEvent
        ]);
    };
    const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
    const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
        return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
    };
});
parcelRegister("g2eZ6", function(module, exports) {
    $parcel$export(module.exports, "fireLinkClickedEvent", ()=>$473b45d487f9fd1b$export$7987de3055fbdcb0);
    $parcel$export(module.exports, "withLinkClickedEvent", ()=>$473b45d487f9fd1b$export$263352d59c0c5966);
    var $5uXOq = parcelRequire("5uXOq");
    var $b6uPu;
    var $4URMI;
    var $fzJZi;
    const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
        [
            undefined,
            'none'
        ],
        [
            0,
            'left'
        ],
        [
            1,
            'middle'
        ],
        [
            2,
            'right'
        ]
    ]);
    const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
        return [
            'alt',
            'ctrl',
            'meta',
            'shift'
        ].filter((key)=>e[`${key}Key`] === true);
    };
    const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
        return el instanceof HTMLElement && el.isContentEditable;
    };
    function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
        const { mac: mac, safari: safari } = (0, (0, parcelRequire("b6uPu")).browser)();
        if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
            'left',
            'middle'
        ].includes(clickType)) return 'contentEditable';
        switch(clickType){
            case 'left':
            case 'keyboard':
                {
                    if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                    if (e.shiftKey) {
                        if (safari) return 'alt';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.ctrlKey) {
                        if (mac) return 'clickThrough';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.altKey) return 'alt';
                    const target = e.currentTarget.getAttribute('target');
                    if (target === '_blank') return 'clickThroughNewTabOrWindow';
                    return 'clickThrough';
                }
            case 'middle':
                return 'clickThroughNewTabOrWindow';
            case 'right':
                return 'contextMenu';
        }
        return 'unknown';
    }
    const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
            action: 'clicked',
            actionSubject: 'link',
            eventType: 'ui',
            attributes: {
                clickType: clickType,
                clickOutcome: clickOutcome,
                keysHeld: keysHeld,
                defaultPrevented: defaultPrevented
            }
        });
    const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
        const isKeyboard = event.nativeEvent.detail === 0;
        const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
        if (!clickType) return;
        const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
        const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
        const defaultPrevented = event.defaultPrevented;
        const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        });
        if (event.currentTarget instanceof HTMLAnchorElement) {
            const url = event.currentTarget.href;
            return {
                ...linkClickedEventResult,
                nonPrivacySafeAttributes: {
                    url: url
                }
            };
        } else return linkClickedEventResult;
    };
    const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
            const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
            if (payload) createAnalyticsEvent({
                ...payload,
                ...overrides,
                attributes: {
                    ...payload.attributes,
                    ...overrides?.attributes
                },
                nonPrivacySafeAttributes: {
                    ...payload.nonPrivacySafeAttributes,
                    ...overrides?.nonPrivacySafeAttributes
                }
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
    const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
        if (typeof WrappedComponent === 'string') return WrappedComponent;
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    };
    function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
        const Component = (props)=>{
            const onClick = (0, (0, parcelRequire("4URMI")).useLinkClicked)(props.onClick);
            const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)(props.onMouseDown);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                onClick: onClick,
                onMouseDown: onMouseDown
            });
        };
        Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
        return Component;
    }
});
parcelRegister("b6uPu", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
    const $7f7209ce5c1e8d08$var$result = {
        mac: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
        let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
    function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
        return $7f7209ce5c1e8d08$var$result;
    }
});
parcelRegister("cJxXG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af9c30eaf441ad65$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $lj8SI;
    var $Nh1XU;
    var $a4DH1;
    function $af9c30eaf441ad65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $af9c30eaf441ad65$var$styles = {
        name: "cvfhjc",
        styles: "display:inline-flex;line-height:inherit"
    };
    const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        if (!text) return null;
        const lozenge = action ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a4DH1")).default), {
            action: action,
            appearance: appearance,
            testId: testId,
            text: text,
            zIndex: ui?.zIndex
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance,
            style: style,
            testId: `${testId}-lozenge`
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af9c30eaf441ad65$var$styles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-lozenge": true,
            "data-testid": testId
        }, lozenge);
    };
    var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;
});
parcelRegister("a4DH1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ceba18caf6f022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $BLPHT;
    var $a1vqi;
    var $dlJZx;
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $gDUps;
    var $fzJZi;
    var $cLKee;
    var $dMzTJ;
    var $j6VJk;
    var $1s0lY;
    var $kf01E;
    var $4Dg4o;
    const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
        return items.filter((item)=>item.text !== text);
    };
    const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
        const [selected, setSelected] = (0, $5uXOq.useState)({
            appearance: appearance,
            text: text
        });
        const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [items, setItems] = (0, $5uXOq.useState)();
        const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            setSelected({
                text: text,
                appearance: appearance
            });
        }, [
            text,
            appearance
        ]);
        const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
        const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
            setIsOpen(args.isOpen);
            if (args.isOpen) {
                analytics?.ui.smartLinkLozengeActionClickedEvent();
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                });
                if (!isLoaded && action?.read) try {
                    setIsLoading(true);
                    const responseItems = await invoke(action.read, (0, (0, parcelRequire("dlJZx")).default));
                    const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                    setItems(validItems);
                    setIsLoaded(true);
                    if (validItems?.length === 0) {
                        fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).permissionLoadErrorAnalyticsPayload));
                        setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).noData);
                        setIsLoaded(false);
                    }
                } catch (err) {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).unknown);
                    setIsLoaded(false);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).unknownLoadErrorAnalyticsPayload));
                } finally{
                    setIsLoading(false);
                }
            }
            if (!args.isOpen) setErrorMessage(undefined);
        }, [
            action.read,
            analytics,
            invoke,
            isLoaded,
            text,
            fireEvent
        ]);
        const trigger = (0, $5uXOq.useCallback)((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4Dg4o")).default), {
                ...props,
                appearance: selected.appearance,
                isOpen: isOpen,
                testId: testId,
                text: selected.text
            }), [
            selected.appearance,
            selected.text,
            isOpen,
            testId
        ]);
        const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
            try {
                analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
                const updateAction = action?.update;
                if (updateAction && id) {
                    setIsLoading(true);
                    const request = (0, (0, parcelRequire("gDUps")).default)(updateAction, id);
                    await invoke(request);
                    setSelected({
                        appearance: appearance,
                        text: text
                    });
                    setIsLoading(false);
                    setIsLoaded(false);
                    setIsOpen(false);
                    setItems([]);
                    fireEvent('track.smartLinkQuickAction.success', {
                        smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                    });
                    if (url) await reload(url, true, undefined, linkId);
                }
            } catch (err) {
                setIsLoading(false);
                if ((0, (0, parcelRequire("euMlu")).isInvokeCustomError)(err)) {
                    setErrorMessage(err.message);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).validationUpdateErrorAnalyticsPayload));
                } else {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).updateFailed);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).unknownUpdateErrorAnalyticsPayload));
                }
            }
        }, [
            action?.update,
            analytics,
            invoke,
            linkId,
            reload,
            url,
            fireEvent
        ]);
        const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
            if (errorMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j6VJk")).default), {
                errorMessage: errorMessage,
                testId: testId,
                url: url,
                previewData: previewData
            });
            if (items && items.length > 0) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kf01E")).default), {
                testId: testId,
                items: items,
                onClick: handleItemClick
            });
        }, [
            errorMessage,
            handleItemClick,
            items,
            previewData,
            testId,
            url
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: isLoading,
            isOpen: isOpen,
            onOpenChange: handleOpenChange,
            testId: testId,
            trigger: trigger,
            zIndex: zIndex
        }, dropdownItemGroup);
    };
    var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cLKee")).default)($27ceba18caf6f022$var$LozengeAction);
});
parcelRegister("a1vqi", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsEvents", ()=>$91130a451fd4887d$export$5bf35293e545f20c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $1PQcU;
    const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
            const event = createAnalyticsEvent((0, (0, parcelRequire("1PQcU")).default)(...params));
            event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEvent: fireEvent
        };
    };
});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';
parcelRegister("1PQcU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$539e70e97f68df84$export$2e2bcd8739ae039);
    const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        };
    };
    var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;
});
parcelRegister("dlJZx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6eaacaffc693a3ec$export$2e2bcd8739ae039);
    const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
        const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
                appearance: appearance ?? 'default',
                id: id,
                text: name
            })) ?? [];
        return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
    };
    var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;
});
parcelRegister("3q2sI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5a60e7c58b54588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iiAnG;
    var $kECas;
    const $f5a60e7c58b54588$var$useInvoke = ()=>{
        const { connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const clientExt = (0, (0, parcelRequire("iiAnG")).useSmartLinkClientExtension)(connections.client);
        return (0, $5uXOq.useCallback)(async (req, cb)=>{
            const response = await clientExt.invoke(req);
            return cb ? cb(response) : response;
        }, [
            clientExt
        ]);
    };
    var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;
});
parcelRegister("iiAnG", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkClientExtension", ()=>$ffb669da1b6b71e8$export$303ede4eed148855);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV0Jy;
    var $T540Y;
    var $3b94d;
    const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
        const resolverUrl = (0, (0, parcelRequire("3b94d")).useResolverUrl)(cardClient);
        const invoke = (0, $5uXOq.useCallback)(async (data)=>{
            try {
                return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (err) {
                if (err && err.json && typeof err.json === 'function') {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, (0, parcelRequire("T540Y")).InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        }, [
            resolverUrl
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                invoke: invoke
            }), [
            invoke
        ]);
    };
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("3b94d", function(module, exports) {
    $parcel$export(module.exports, "useResolverUrl", ()=>$eebf021c5f687360$export$d08617a365fbe694);
    var $5uXOq = parcelRequire("5uXOq");
    var $itO4f;
    const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("itO4f")).getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
            cardClient?.baseUrlOverride,
            cardClient?.envKey
        ]);
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("euMlu", function(module, exports) {
    $parcel$export(module.exports, "getInvokeFailureReason", ()=>$0ad6fedaface02c5$export$65b3f792dff0bd60);
    $parcel$export(module.exports, "isInvokeCustomError", ()=>$0ad6fedaface02c5$export$1694272377fa07d8);
    var $fzJZi;
    const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
        if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        switch(err?.errorCode){
            case 403:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).PermissionError;
            default:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        }
    };
    const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
});
parcelRegister("f22ja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f48b36e6e5cada34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $8dVIb;
    var $1VPdD;
    var $nb8r1;
    const $f48b36e6e5cada34$var$useResolve = ()=>{
        const { store: store, connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState } = store;
        const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, (0, parcelRequire("nb8r1")).default)();
        return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
            const { details: details } = getState()[url] || {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const hasData = !!(details && details.data);
            if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
            else (0, (0, parcelRequire("1VPdD")).addMetadataToExperience)('smart-link-rendered', id, {
                cached: true
            });
        }, [
            connections.client,
            getState,
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;
});
parcelRegister("nb8r1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09545a48e55da9e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $kECas;
    var $2yPrN;
    var $kDZ6Z;
    var $fiKQs;
    var $8dVIb;
    var $aOsut;
    const $09545a48e55da9e9$var$useResponse = ()=>{
        const { store: store, config: config } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState, dispatch: dispatch } = store;
        const hasAuthFlowSupported = config.authFlow !== 'disabled';
        const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
            dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS), {
                url: url
            }, undefined, undefined, metadataStatus));
        }, [
            dispatch
        ]);
        const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
            const newState = {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const { details: details } = getState()[url] || newState;
            const hasData = !!(details && details.data);
            if (isMetadataRequest) {
                setMetadataStatus(url, 'errored');
                return;
            }
            if (error.kind === 'fatal') {
                if (hasData) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                    url: url
                }, details));
                else {
                    dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                        url: url
                    }, details, error));
                    throw error;
                }
            } else if (error.kind === 'auth') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: url
            }, (0, (0, parcelRequire("aOsut")).getUnauthorizedJsonLd)()));
            else if (error.kind === 'fallback') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK), {
                url: url
            }, response, error));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                url: url
            }, undefined, error));
        }, [
            getState,
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
            setMetadataStatus(resourceUrl, 'resolved');
            if (isReloading) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RELOADING), {
                url: resourceUrl
            }, response));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: resourceUrl
            }, response, undefined, undefined, isMetadataRequest));
        }, [
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
            const hostname = new URL(resourceUrl).hostname;
            const nextStatus = response ? (0, (0, parcelRequire("fiKQs")).getStatus)(response) : 'fatal';
            if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
                return;
            }
            if (!response || nextStatus === 'fatal') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
                return;
            }
            if (isMetadataRequest && nextStatus !== 'resolved') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
                return;
            }
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
            });
        }, [
            handleResolvedLinkError,
            handleResolvedLinkSuccess,
            hasAuthFlowSupported
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                handleResolvedLinkError: handleResolvedLinkError,
                handleResolvedLinkResponse: handleResolvedLinkResponse
            }), [
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("aOsut", function(module, exports) {
    $parcel$export(module.exports, "getEmptyJsonLd", ()=>$5dc57cbabb8840da$export$2796a804c6e44f63);
    $parcel$export(module.exports, "getUnauthorizedJsonLd", ()=>$5dc57cbabb8840da$export$b9482e0f6d365cc7);
    $parcel$export(module.exports, "getForbiddenJsonLd", ()=>$5dc57cbabb8840da$export$e32193033a594efb);
    const $5dc57cbabb8840da$var$emptyData = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        '@type': 'Object'
    };
    const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
    const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'unauthorized',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
    const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'forbidden',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
});
const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';
parcelRegister("gDUps", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66cd4b0a305f86bf$export$2e2bcd8739ae039);
    const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
            providerKey: request.providerKey,
            action: {
                ...request.action,
                payload: {
                    newStatusId: id
                }
            }
        });
    var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;
});
parcelRegister("cLKee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$061d6f2e0c766414$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lj8SI;
    const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
            const fallback = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                    appearance: props?.appearance,
                    testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
                }, props?.text), [
                props?.appearance,
                props?.testId,
                props?.text
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
                fallback: fallback
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props));
        };
    var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;
});
parcelRegister("dMzTJ", function(module, exports) {
    $parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2a568ff99500df53);
    $parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2de2d0ccc17b915f);
    $parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$c1c05f9d51f7c467);
    $parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$618660b8f2aa87e2);
    const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'PermissionError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'update'
    };
    const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'ValidationError',
        step: 'update'
    };
});
parcelRegister("j6VJk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $6B7KL;
    var $aRoVz;
    var $dD7Zc;
    var $7zaVw;
    var $Nh1XU;
    var $f22ja;
    var $fpDmE;
    var $ljnlf;
    const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
    const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const isPreviewAvailable = previewData && previewData.src !== undefined;
        const handlePreviewClose = (0, $5uXOq.useCallback)(()=>{
            if (url) reload(url, true);
        }, [
            reload,
            url
        ]);
        const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
            if (isPreviewAvailable) {
                analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
                return (0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                    ...previewData,
                    analytics: analytics,
                    onClose: handlePreviewClose
                });
            }
        }, [
            analytics,
            handlePreviewClose,
            isPreviewAvailable,
            previewData
        ]);
        const content = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).contentStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
                testId: `${testId}-icon`,
                LEGACY_size: "medium",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                label: 'error',
                spacing: "spacious"
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("ljnlf")).textStyles)(maxLineNumber),
                "data-testid": `${testId}-error-message`
            }, typeof errorMessage === 'string' ? errorMessage : (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(errorMessage))), isPreviewAvailable ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).linkStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                target: "_blank",
                "data-testid": `${testId}-open-embed`,
                onClick: handlePreviewOpen
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).open_issue_in_jira))) : null);
        }, [
            errorMessage,
            handlePreviewOpen,
            isPreviewAvailable,
            maxLineNumber,
            testId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("ljnlf")).dropdownItemGroupStyles),
            "data-testid": `${testId}-error-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            testId: `${testId}-error`
        }, content))));
    };
    var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("ljnlf", function(module, exports) {
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$83fdad0d8ffe5982$export$2c40d814aeff5db);
    $parcel$export(module.exports, "contentStyles", ()=>$83fdad0d8ffe5982$export$a38ecc1ac2e6fba);
    $parcel$export(module.exports, "linkStyles", ()=>$83fdad0d8ffe5982$export$4ea5976125a01ffa);
    $parcel$export(module.exports, "textStyles", ()=>$83fdad0d8ffe5982$export$6a54c24d15b0f6ba);
    var $f8Sb3;
    var $fpDmE;
    function $83fdad0d8ffe5982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $83fdad0d8ffe5982$export$2c40d814aeff5db = {
        name: "a7m7l8",
        styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
    };
    const $83fdad0d8ffe5982$var$sharedBlockStyles = {
        name: "gx0rja",
        styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
    };
    const $83fdad0d8ffe5982$export$a38ecc1ac2e6fba = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, {
        marginTop: "var(--ds-space-025, 2px)",
        alignItems: 'flex-start',
        '> span, > div': {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
        }
    });
    const $83fdad0d8ffe5982$export$4ea5976125a01ffa = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
    const $83fdad0d8ffe5982$export$6a54c24d15b0f6ba = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
});
parcelRegister("1s0lY", function(module, exports) {
    $parcel$export(module.exports, "LozengeActionErrorMessages", ()=>$47c640bee30204cc$export$4f2e371a667ad688);
    var $7zaVw;
    const $47c640bee30204cc$export$4f2e371a667ad688 = {
        noData: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_permission_error']
        },
        unknown: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_load_error']
        },
        updateFailed: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_update_error']
        }
    };
});
parcelRegister("kf01E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a0af43cfe2e114d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $aRoVz;
    var $hgsSZ;
    var $3UpeD;
    const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("3UpeD")).dropdownItemGroupStyles),
            "data-testid": `${testId}-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hgsSZ")).default), {
                ...item,
                key: idx,
                onClick: onClick,
                testId: `${testId}-item-${idx}`
            }))));
    var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;
});
parcelRegister("hgsSZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$419e60cbfb62c454$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $lj8SI;
    const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            if (onClick) onClick(id, text, appearance);
        }, [
            appearance,
            id,
            onClick,
            text
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
            e.currentTarget?.firstElementChild?.focus();
        }, []);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onMouseEnter: handleMouseEnter
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: handleClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance
        }, text))));
    };
    var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;
});
parcelRegister("3UpeD", function(module, exports) {
    $parcel$export(module.exports, "triggerButtonStyles", ()=>$c3acfc8ed6aa38b4$export$ae858546f0bfd05c);
    $parcel$export(module.exports, "triggerLozengeStyles", ()=>$c3acfc8ed6aa38b4$export$5717c7336384f3a6);
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$c3acfc8ed6aa38b4$export$2c40d814aeff5db);
    var $f8Sb3;
    function $c3acfc8ed6aa38b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c3acfc8ed6aa38b4$export$ae858546f0bfd05c = (0, (0, parcelRequire("f8Sb3")).css)({
        all: 'unset',
        backgroundColor: 'transparent',
        color: 'unset',
        cursor: 'pointer',
        fontFamily: 'unset',
        fontSize: 'unset',
        fontStyle: 'unset',
        fontWeight: 'unset',
        fontVariant: 'unset',
        lineHeight: 0,
        padding: 0,
        textTransform: 'unset',
        border: '2px solid transparent',
        margin: "var(--ds-space-025, 2px)",
        "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
            outline: 'none',
            boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
            borderRadius: '5px'
        }
    });
    const $c3acfc8ed6aa38b4$export$5717c7336384f3a6 = {
        name: "1vr7vmn",
        styles: "align-items:center;display:flex"
    };
    const $c3acfc8ed6aa38b4$export$2c40d814aeff5db = (0, (0, parcelRequire("f8Sb3")).css)({
        maxHeight: '300px',
        overflowY: 'auto',
        button: {
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            minHeight: '28px',
            width: '220px',
            '&:hover': {
                backgroundColor: 'inherit'
            },
            '&:focus, &:focus-visible': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
                boxSizing: 'border-box',
                boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
                outline: 'none'
            }
        }
    });
});
parcelRegister("4Dg4o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afa61527cd4f792e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $c8Oei;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3UpeD;
    const $afa61527cd4f792e$var$chevronDownStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        display: 'flex'
    });
    const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
        const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
        const lozenge = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
                appearance: appearance,
                isBold: isBold
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("3UpeD")).triggerLozengeStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, text), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                xcss: $afa61527cd4f792e$var$chevronDownStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                color: "currentColor",
                label: "options",
                LEGACY_size: "medium",
                LEGACY_margin: "-4px -8px -4px -7px"
            })))), [
            appearance,
            isBold,
            text
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            ...props,
            css: (0, (0, parcelRequire("3UpeD")).triggerButtonStyles),
            "data-action-open": isOpen,
            "data-testid": `${testId}--trigger`,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: triggerRef
        }, lozenge);
    };
    var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;
});
parcelRegister("77cM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a723b9f793426daa$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l5Xsv;
    function $a723b9f793426daa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a723b9f793426daa$var$styles = {
        name: "a50hvv",
        styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
    };
    const $a723b9f793426daa$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
        if (!type || !url) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $a723b9f793426daa$var$styles,
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-media": type,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        }));
    };
    var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;
});
parcelRegister("k39kU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af078338fe34f0f5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fpDmE;
    const $af078338fe34f0f5$var$getStyles = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
    const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
        if (!message && !content) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af078338fe34f0f5$var$getStyles(maxLines),
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-text": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(message) || content);
    };
    var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;
});
parcelRegister("kDhrr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5972a7cc25546c87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $Nh1XU;
    var $77cM6;
    const $5972a7cc25546c87$var$Preview = (props)=>{
        const { overrideUrl: overrideUrl, ...rest } = props ?? {};
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        const data = overrideUrl ? {
            url: overrideUrl,
            type: (0, (0, parcelRequire("8dVIb")).MediaType).Image
        } : context?.preview;
        if (!data) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("77cM6")).default), {
            ...rest,
            ...data
        });
    };
    var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;
});
parcelRegister("kp8aU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$673e9555bded0d05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $Nh1XU;
    var $k39kU;
    const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
    const $673e9555bded0d05$var$getSnippetStyles = (overrideCss)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", overrideCss);
    const $673e9555bded0d05$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k39kU")).default), {
            content: overrideContent ?? context?.snippet,
            maxLines: maxLines,
            overrideCss: $673e9555bded0d05$var$getSnippetStyles(overrideCss),
            ...props
        });
    };
    var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;
});
parcelRegister("bubxq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66554651c27d9387$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $gKZoD;
    var $ldJSL;
    var $fVnbM;
    var $BLPHT;
    var $bJeNF;
    var $3bDjY;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $akF1x;
    var $3Zm9O;
    function $66554651c27d9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $66554651c27d9387$var$styles = {
        name: "inf63k",
        styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
    };
    const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3Zm9O")).default), {
                item: item,
                key: idx,
                size: size,
                appearance: appearance,
                asDropDownItems: asDropDownItems,
                onActionItemClick: onActionItemClick
            }));
    const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("BLPHT")).default));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(items, context), [
            context,
            items
        ]);
        const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
        const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
            setIsOpen(attrs.isOpen);
            if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
        }, [
            onDropdownOpenChange
        ]);
        const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) onOpenChange({
                isOpen: false
            });
        }, [
            isOpen,
            onOpenChange
        ]);
        const actionButtons = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
            return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
        }, [
            appearance,
            isMoreThenTwoItems,
            onActionItemClick,
            renderableActionItems,
            size,
            visibleButtonsNum
        ]);
        const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
            if (actionItems.length > 0) {
                const spacing = (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size];
                const moreIcon = (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                    label: "more",
                    color: "currentColor"
                });
                const formatMessage = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).more_actions);
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                            content: formatMessage,
                            hideTooltipOnClick: true,
                            testId: "action-group-more-button-tooltip",
                            tag: "span"
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })),
                    testId: "action-group-dropdown",
                    zIndex: ui?.zIndex
                }, $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
            }
            return null;
        }, [
            appearance,
            isMoreThenTwoItems,
            isOpen,
            onActionItemClick,
            onOpenChange,
            renderableActionItems,
            size,
            ui?.zIndex,
            visibleButtonsNum
        ]);
        return renderableActionItems.length > 0 ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $66554651c27d9387$var$styles,
            className: "actions-button-group",
            "data-action-open": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldJSL")).default), null, actionButtons, moreActionDropdown)) : null;
    };
    var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;
});
parcelRegister("bJeNF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));
    var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
    function $889f60aca54b55ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>$889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
        }, props));
    $889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;
});
parcelRegister("akF1x", function(module, exports) {
    $parcel$export(module.exports, "getGapSize", ()=>$8ba323b39584fd77$export$ff20be09ae01c52e);
    $parcel$export(module.exports, "getBaseStyles", ()=>$8ba323b39584fd77$export$bff8031d86bb089);
    $parcel$export(module.exports, "highlightRemoveStyles", ()=>$8ba323b39584fd77$export$1928241a6f267c0d);
    $parcel$export(module.exports, "getActionGroupStyles", ()=>$8ba323b39584fd77$export$393b0054595c3748);
    $parcel$export(module.exports, "filterActionItems", ()=>$8ba323b39584fd77$export$adbd04236f07a7d8);
    $parcel$export(module.exports, "renderChildren", ()=>$8ba323b39584fd77$export$cd762ccf1a583d69);
    $parcel$export(module.exports, "renderElementItems", ()=>$8ba323b39584fd77$export$9678d3ca18bd7526);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $91tw3;
    var $eqoQu;
    var $bubxq;
    var $1BfaB;
    function $8ba323b39584fd77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ba323b39584fd77$export$f942619ce67b1a41 = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Snippet]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: [
            'inline'
        ]
    };
    var $8ba323b39584fd77$var$_ref2 = {
        name: "2rtvke",
        styles: "flex-direction:row;align-items:center"
    };
    var $8ba323b39584fd77$var$_ref3 = {
        name: "1ejri1g",
        styles: "flex-direction:column;align-items:flex-start"
    };
    const $8ba323b39584fd77$var$getDirectionStyles = (direction)=>{
        switch(direction){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical:
                return $8ba323b39584fd77$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal:
            default:
                return $8ba323b39584fd77$var$_ref2;
        }
    };
    const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 1.25;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 0.5;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 0.25;
        }
    };
    const $8ba323b39584fd77$export$bff8031d86bb089 = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            display: 'flex',
            gap: `${$8ba323b39584fd77$export$ff20be09ae01c52e(size)}rem`,
            lineHeight: '1rem',
            minWidth: 0,
            overflow: 'hidden'
        }, $8ba323b39584fd77$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
    const $8ba323b39584fd77$export$1928241a6f267c0d = {
        name: "1klm9nt",
        styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
    };
    const $8ba323b39584fd77$var$isActionGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("bubxq")).default);
    const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
        return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
    };
    const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
        return Boolean(children.type() === null);
    };
    const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, (0, parcelRequire("91tw3")).isFlexibleUiElement)(node) || node.type === (0, (0, parcelRequire("1BfaB")).default));
    var $8ba323b39584fd77$var$_ref = {
        name: "bceqwf",
        styles: "max-height:2rem"
    };
    const $8ba323b39584fd77$export$393b0054595c3748 = (size)=>{
        if (size === (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge) return $8ba323b39584fd77$var$_ref;
    };
    const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
        return items.filter((item)=>{
            switch(item.name){
                case (0, (0, parcelRequire("8dVIb")).ActionName).DeleteAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).EditAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).CustomAction:
                    return Boolean((0, (0, parcelRequire("8dVIb")).ActionName)[item.name]);
                default:
                    if (context?.actions === undefined) return false;
                    return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            }
        });
    };
    const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, ($parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
                const node = child;
                const { size: childSize } = node.props;
                return (0, ($parcel$interopDefault($5uXOq))).cloneElement(node, {
                    size: childSize || size
                });
            }
            return child;
        });
    const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
        const elements = items.reduce((acc, curr, idx)=>{
            const { name: name, ...props } = curr;
            const Element = (0, parcelRequire("eqoQu"))[name];
            const typedProps = props;
            if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
                const element = (0, ($parcel$interopDefault($5uXOq))).createElement(Element, {
                    key: idx,
                    ...typedProps
                });
                if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                    ...acc,
                    element
                ];
            }
            return acc;
        }, []);
        if (elements.length) return elements;
    };
});
parcelRegister("1BfaB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed56962f49dee3a8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $akF1x;
    function $ed56962f49dee3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $ed56962f49dee3a8$var$_ref = {
        name: "3l7cjm",
        styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
    };
    var $ed56962f49dee3a8$var$_ref2 = {
        name: "1ofqdyp",
        styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
    };
    const $ed56962f49dee3a8$var$getAlignmentStyles = (align)=>{
        switch(align){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right:
                return $ed56962f49dee3a8$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left:
            default:
                return $ed56962f49dee3a8$var$_ref;
        }
    };
    const $ed56962f49dee3a8$var$getGapStyles = (size, align)=>{
        const gap = (0, (0, parcelRequire("akF1x")).getGapSize)(size);
        if (align === (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right) return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginLeft: `${gap}rem`
            },
            '> span:first-child': {
                marginLeft: 'initial'
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginRight: `${gap}rem`,
                '&:last-child': {
                    marginRight: 'initial'
                }
            }
        });
    };
    const $ed56962f49dee3a8$var$getHorizontalDirectionStyles = (size, align)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("display:block;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ed56962f49dee3a8$var$getGapStyles(size, align), ";");
    };
    const $ed56962f49dee3a8$export$91d118d179d992a4 = (direction, size, align, width, position)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), $ed56962f49dee3a8$var$getAlignmentStyles(align), "min-width:10%;", width === (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible ? `flex: 1 3;` : '', direction === (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal ? $ed56962f49dee3a8$var$getHorizontalDirectionStyles(size, align) : '', position === (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
    const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).FitToContent, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $ed56962f49dee3a8$export$91d118d179d992a4(direction, size, align, width, position),
                overrideCss
            ],
            "data-smart-element-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;
});
parcelRegister("3Zm9O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70338cdeec0a99e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jRHKj;
    const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
        const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
        const handleOnClick = (0, $5uXOq.useCallback)(()=>{
            if (onActionItemClick) onActionItemClick();
            if (onClick) onClick();
        }, [
            onActionItemClick,
            onClick
        ]);
        const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
        if (!Action) return null;
        const actionProps = {
            ...props
        };
        if (hideContent && !asDropDownItems) actionProps.content = '';
        if (hideIcon) actionProps.icon = undefined;
        if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
            asDropDownItem: asDropDownItems,
            size: size,
            appearance: appearance,
            onClick: handleOnClick,
            isDisabled: isDisabled,
            ...actionProps
        });
    };
    var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;
});
parcelRegister("jRHKj", function(module, exports) {
    $parcel$export(module.exports, "CustomAction", ()=>(parcelRequire("23vM5")).default);
    $parcel$export(module.exports, "DeleteAction", ()=>(parcelRequire("96Kdz")).default);
    $parcel$export(module.exports, "EditAction", ()=>(parcelRequire("fEhHT")).default);
    $parcel$export(module.exports, "DownloadAction", ()=>(parcelRequire("g9G65")).default);
    $parcel$export(module.exports, "FollowAction", ()=>(parcelRequire("b6Mes")).default);
    $parcel$export(module.exports, "PreviewAction", ()=>(parcelRequire("9mTP8")).default);
    $parcel$export(module.exports, "CopyLinkAction", ()=>(parcelRequire("jep3X")).default);
    $parcel$export(module.exports, "AISummaryAction", ()=>(parcelRequire("ziZLe")).default);
    $parcel$export(module.exports, "AutomationAction", ()=>(parcelRequire("5OUwn")).default);
    $parcel$export(module.exports, "ViewRelatedLinksAction", ()=>(parcelRequire("faTeC")).default);
    var $23vM5;
    var $96Kdz;
    var $fEhHT;
    var $g9G65;
    var $b6Mes;
    var $9mTP8;
    var $jep3X;
    var $ziZLe;
    var $5OUwn;
    var $faTeC;
});
parcelRegister("23vM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bf7d27623ce3bf9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $f6kZQ;
    var $kuVc8;
    var $bhB72;
    var $1wpdl;
    const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
        if (!onClick) return null;
        const isStackItem = as === 'stack-item';
        const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
        const actionIcon = icon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: isStackItem,
            isDisabled: isDisabled,
            icon: icon,
            size: size,
            testId: testId
        });
        const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
        const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
        if (isStackItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1wpdl")).default), {
            content: content,
            icon: actionIcon,
            space: spaceInline,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onClick,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            xcss: xcss,
            tooltipOnHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown,
            hideTooltip: hideTooltip
        });
        if (isDropdownItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kuVc8")).default), {
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            testId: testId
        });
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f6kZQ")).default), {
            appearance: appearance,
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            overrideCss: overrideCss,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            isDisabled: isDisabled,
            href: href,
            ariaLabel: ariaLabel
        });
        return Wrapper !== undefined ? (0, (0, parcelRequire("f8Sb3")).jsx)(Wrapper, null, button) : button;
    };
    var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;
});
parcelRegister("f6kZQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3ee32ab04698fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2rqOp;
    var $3bDjY;
    var $8dVIb;
    var $fpDmE;
    function $b3ee32ab04698fad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $b3ee32ab04698fad$var$_ref = {
        name: "kaj2cp",
        styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
    };
    const $b3ee32ab04698fad$var$getButtonStyle = (size, iconOnly)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return iconOnly ? $b3ee32ab04698fad$var$_ref : '';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    lineHeight: '1rem',
                    'button, button:hover, button:focus, button:active': [
                        {
                            lineHeight: '1rem'
                        },
                        iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                    ]
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            default:
                return '';
        }
    };
    const $b3ee32ab04698fad$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
        const iconOnly = !content;
        const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
                e.preventDefault();
                handler();
            }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b3ee32ab04698fad$var$getButtonStyle(size, iconOnly),
                overrideCss
            ],
            "data-testid": `${testId}-button-wrapper`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2rqOp")).default), {
            appearance: appearance,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size],
            testId: testId,
            href: href,
            "aria-label": ariaLabel
        }, content)));
    };
    var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;
});
parcelRegister("kuVc8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e656bda53d041540$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $kxcRq;
    const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemAfter: iconAfter,
            elemBefore: iconBefore,
            isDisabled: isLoading,
            onClick: (0, (0, parcelRequire("kxcRq")).handleOnClick)(onClick),
            testId: testId
        }, content);
    var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;
});
parcelRegister("bhB72", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$345d01659b23eb38$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $8dVIb;
    var $fpDmE;
    function $345d01659b23eb38$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $345d01659b23eb38$var$getIconWidth = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $345d01659b23eb38$var$getIconStyles = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
        });
    const $345d01659b23eb38$var$stackItemIconSizeStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('20px');
    const $345d01659b23eb38$var$stackItemIconStyles = (0, (0, parcelRequire("f8Sb3")).css)($345d01659b23eb38$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
    const $345d01659b23eb38$var$newStackItemIconStyles = {
        name: "1pelf5a",
        styles: "display:inline-block;line-height:0"
    };
    const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $345d01659b23eb38$var$getIconStyles(isDisabled),
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? asStackItemIcon ? $345d01659b23eb38$var$stackItemIconStyles : (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)($345d01659b23eb38$var$getIconWidth(size)) : $345d01659b23eb38$var$newStackItemIconStyles
            ],
            "data-testid": `${testId}-icon`
        }, icon);
    var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;
});
parcelRegister("1wpdl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $5PILj;
    const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
            ...props,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage || content,
            onHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            }));
    var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;
});
parcelRegister("5PILj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$222d00bebc6cbf68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $eZJjh;
    var $fpDmE;
    var $bhB72;
    const $222d00bebc6cbf68$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        padding: 'space.050',
        width: '100%',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $222d00bebc6cbf68$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
        const space = spaceOption ?? (0, (0, parcelRequire("fpDmE")).getPrimitivesInlineSpaceBySize)(size);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
        }, [
            isDisabled,
            isLoading,
            onClickCallback
        ]);
        const icon = iconOption && isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: true,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                testId: `${testId}-loading`
            }),
            size: size
        }) : iconOption;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $222d00bebc6cbf68$var$buttonStyles,
                xcss
            ],
            ...tooltipProps,
            onClick: onClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            grow: "fill",
            space: space
        }, icon, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $222d00bebc6cbf68$var$contentStyles
        }, content))));
    };
    var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;
});
parcelRegister("96Kdz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddac835e19e975e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $84THj;
    var $7zaVw;
    var $23vM5;
    const $ddac835e19e975e0$var$DeleteAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Delete"
            }),
            testId: "smart-action-delete-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            ...props
        });
    var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;
});
parcelRegister("fEhHT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23e1c92ea69f35be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $4ChK1;
    var $7zaVw;
    var $23vM5;
    const $23e1c92ea69f35be$var$EditAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ChK1"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Edit"
            }),
            testId: "smart-action-edit-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            ...props
        });
    var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;
});
parcelRegister("4ChK1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));
    var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
    function $35c87913ec905242$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35c87913ec905242$var$EditIcon = (props)=>$35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
            LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
        }, props));
    $35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
    var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;
});
parcelRegister("gsEeL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
    function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfbe7921991bc4cb$var$EditIcon = (props)=>$bfbe7921991bc4cb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $bfbe7921991bc4cb$var$_edit.default
        }));
    $bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
    var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;
});
parcelRegister("g9G65", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fb79986052b65c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $d4dv2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $kxcRq;
    var $23vM5;
    const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data?.downloadUrl) {
                invoke({
                    actionType: (0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction,
                    actionFn: async ()=>(0, (0, parcelRequire("kxcRq")).downloadUrl)(data?.downloadUrl),
                    display: analytics?.display,
                    extensionKey: analytics?.extensionKey
                });
                if (onClickCallback) onClickCallback();
            }
        }, [
            analytics,
            data?.downloadUrl,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const label = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_file : (0, (0, parcelRequire("7zaVw")).messages).download;
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_description : (0, (0, parcelRequire("7zaVw")).messages).download;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d4dv2"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Download"
            }),
            onClick: onClick,
            testId: "smart-action-download-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props
        }) : null;
    };
    var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;
});
parcelRegister("d4dv2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));
    var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
    function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $98361ed174bfbb2b$var$DownloadIcon = (props)=>$98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
            LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
        }, props));
    $98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
    var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;
});
parcelRegister("EOGIN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $07ab0e2228a1635e$var$_UNSAFE_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07ab0e2228a1635e$var$DownloadIcon = (props)=>$07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
        }, props));
    $07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
    var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;
});
parcelRegister("5krT5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
    function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e1473e49ea22b68$var$DownloadIcon = (props)=>$3e1473e49ea22b68$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
        }, props, {
            newIcon: $3e1473e49ea22b68$var$_download.default
        }));
    $3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
    var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;
});
parcelRegister("iPVbQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a560b45251b869c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5vDFA;
    var $1VPdD;
    const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
    const $a560b45251b869c0$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $5uXOq.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
            const experienceId = (0, ($parcel$interopDefault($7Jxgt)))();
            const markName = `${experienceId}-${actionType}`;
            (0, parcelRequire("5vDFA")).mark(markName, 'pending');
            try {
                (0, (0, parcelRequire("1VPdD")).startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    invokeType: 'client'
                });
                analytics?.ui.actionClickedEvent({
                    actionType: actionType,
                    display: display
                });
                const result = await actionFn();
                (0, parcelRequire("5vDFA")).mark(markName, 'resolved');
                (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                analytics?.operational.invokeSucceededEvent({
                    actionType: actionType,
                    display: display
                });
                return result;
            } catch (err) {
                (0, parcelRequire("5vDFA")).mark(markName, 'errored');
                (0, (0, parcelRequire("1VPdD")).failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                const reason = typeof err === 'string' ? err : err?.message;
                analytics?.operational.invokeFailedEvent({
                    actionType: actionType,
                    display: display,
                    reason: reason
                });
            }
        }, [
            analytics?.operational,
            analytics?.ui
        ]);
    var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;
});
parcelRegister("b6Mes", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$879133cabfb6e190$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $3xnBw;
    var $itef5;
    const $879133cabfb6e190$var$importIconMapper = {
        goal: ()=>(parcelRequire("7p0py")).then(({ GoalIcon: GoalIcon })=>({
                    default: GoalIcon
                })),
        projects: ()=>(parcelRequire("96BFr")).then(({ ProjectsIcon: ProjectsIcon })=>({
                    default: ProjectsIcon
                }))
    };
    const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
        const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
        if (!importFn) return null;
        return (0, (0, parcelRequire("fpDmE")).importIcon)(importFn);
    };
    const $879133cabfb6e190$var$FollowAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).FollowAction];
        if (!context || !actionData) return null;
        const { value: value, isProject: isProject, ...data } = actionData;
        const isStackItem = props.as === 'stack-item';
        const message = value ? (0, (0, parcelRequire("7zaVw")).messages).follow : (0, (0, parcelRequire("7zaVw")).messages).unfollow;
        const projectMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project;
        const goalMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal;
        const stackMessage = isProject ? projectMessage : goalMessage;
        const label = isStackItem ? stackMessage : message;
        const projectTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_description;
        const goalTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_description;
        const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
        const tooltipMessage = isStackItem ? stackTooltipMessage : message;
        const stackIconType = isProject ? 'projects' : 'goal';
        const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
        const followIcon = (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
            label: "Follow",
            testId: `smart-action-follow-action-${stackIconType}-icon`
        });
        const handleError = ()=>{
            const { onError: onErrorCallback } = props;
            const errorMessage = (0, (0, parcelRequire("itef5")).getFollowActionErrorMessage)(isProject, value);
            onErrorCallback?.({
                title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), errorMessage),
                appearance: 'error'
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3xnBw")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: followIcon,
            testId: "smart-action-follow-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props,
            onError: handleError
        });
    };
    var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;
});
parcelRegister("3xnBw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35d557ed1ef6412d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $69hr0;
    var $23vM5;
    const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)(async ()=>{
            if (action) {
                const smartLinkActionType = action.action?.actionType;
                try {
                    setIsLoading(true);
                    analytics?.ui.smartLinkServerActionClickedEvent({
                        smartLinkActionType: smartLinkActionType
                    });
                    fireEvent('track.smartLinkQuickAction.started', {
                        smartLinkActionType: smartLinkActionType
                    });
                    const request = (0, (0, parcelRequire("69hr0")).default)(action);
                    await invoke(request);
                    fireEvent('track.smartLinkQuickAction.success', {
                        smartLinkActionType: smartLinkActionType
                    });
                    if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                    setIsLoading(false);
                    if (onClick) onClick();
                } catch (err) {
                    setIsLoading(false);
                    fireEvent('track.smartLinkQuickAction.failed', {
                        smartLinkActionType: smartLinkActionType,
                        reason: (0, (0, parcelRequire("euMlu")).getInvokeFailureReason)(err)
                    });
                    onErrorCallback?.();
                }
            }
        }, [
            action,
            analytics?.ui,
            invoke,
            onClick,
            onErrorCallback,
            reload,
            fireEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            ...props,
            isLoading: isLoading,
            onClick: handleClick
        });
    };
    var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;
});
parcelRegister("69hr0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22d791805237a266$export$2e2bcd8739ae039);
    const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
            action: {
                ...request.action,
                payload: payload
            },
            providerKey: request.providerKey
        });
    var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;
});
parcelRegister("itef5", function(module, exports) {
    $parcel$export(module.exports, "getFollowActionErrorMessage", ()=>$d31a392ae92ce299$export$49248678d3914625);
    var $7zaVw;
    const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
        if (isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_project_error;
        if (isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_error;
        if (!isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_goal_error;
        if (!isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_error;
        return (0, (0, parcelRequire("7zaVw")).messages).generic_error_message;
    };
});
parcelRegister("7p0py", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftS7u").then(()=>parcelRequire('5UxRR'));
});
parcelRegister("96BFr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3uQsu")
    ]).then(()=>parcelRequire('gsEJ1'));
});
parcelRegister("9mTP8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ea9170f77974c10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $5JpK2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $fpDmE;
    var $23vM5;
    const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction,
                actionFn: async ()=>(0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                        download: data?.downloadUrl,
                        extensionKey: analytics?.extensionKey,
                        analytics: analytics,
                        ...data
                    }),
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).preview_description : (0, (0, parcelRequire("7zaVw")).messages).preview_improved;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).preview_improved),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Open preview"
            }),
            onClick: onClick,
            testId: "smart-action-preview-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            hideTooltipOnMouseDown: true,
            ...data,
            ...props
        }) : null;
    };
    var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;
});
parcelRegister("5JpK2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));
    var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
    function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>$42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
        }, props));
    $42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("jep3X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d1e0763b6a84021$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jOyH3;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $23vM5;
    const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction];
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data && data.url) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction,
                actionFn: async ()=>{
                    await navigator.clipboard.writeText(data.url ?? '');
                    setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_url_to_clipboard);
                },
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
                color: "currentColor",
                label: "copy url",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            onClick: onClick,
            testId: "smart-action-copy-link-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            ...data,
            ...props
        }) : null;
    };
    var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;
});
parcelRegister("ziZLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b53b1e1aa704061$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $dgRei;
    const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        return actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dgRei")).AISummaryActionComponent), {
            ...actionData,
            ...props
        }) : null;
    };
    var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;
});
parcelRegister("dgRei", function(module, exports) {
    $parcel$export(module.exports, "AISummaryActionComponent", ()=>$a6e4dbdfe418b2c1$export$8eed96bc6d982595);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $1MeuC;
    var $8UCLX;
    var $jdA9V;
    const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
        const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, (0, parcelRequire("1MeuC")).default)(url);
        (0, $5uXOq.useEffect)(()=>{
            onLoadingChange?.(status === 'loading');
        }, [
            onLoadingChange,
            status
        ]);
        return status === 'done' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdA9V")).CopySummaryAction), {
            ...props,
            testId: testId,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UCLX")).AISummariseAction), {
            ...props,
            testId: testId,
            summariseUrl: summariseUrl,
            status: status
        });
    };
});
parcelRegister("1MeuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27e30e18347ce2a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hWyvy;
    var $8UXrm;
    var $a1vqi;
    var $1VPdD;
    var $hjhAz;
    var $kR87P;
    var $anB5s;
    const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
    const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
        const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, (0, parcelRequire("anB5s")).useAISummaryConfig)();
        const cardState = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const data = cardState.details?.data;
        const ari = data && (0, (0, parcelRequire("hWyvy")).extractAri)(data);
        const dataUrl = data && (0, (0, parcelRequire("8UXrm")).extractLink)(data) || '';
        const onStart = (0, $5uXOq.useCallback)((id)=>{
            (0, (0, parcelRequire("1VPdD")).startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, []);
        const onSuccess = (0, $5uXOq.useCallback)((id)=>{
            fireEvent('operational.summary.success', {});
            (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        const onError = (0, $5uXOq.useCallback)((id, reason)=>{
            const isSloError = reason === undefined ? true : ![
                'ACCEPTABLE_USE_VIOLATIONS',
                'HIPAA_CONTENT_DETECTED',
                'EXCEEDING_CONTEXT_LENGTH_ERROR'
            ].includes(reason);
            fireEvent('operational.summary.failed', {
                reason: reason || null,
                isSloError: isSloError
            });
            (0, (0, parcelRequire("1VPdD")).failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        return (0, (0, parcelRequire("kR87P")).useAISummary)({
            url: dataUrl,
            ari: ari,
            product: product,
            envKey: envKey,
            baseUrl: baseUrl,
            onStart: onStart,
            onSuccess: onSuccess,
            onError: onError
        });
    };
    var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;
});
parcelRegister("hWyvy", function(module, exports) {
    $parcel$export(module.exports, "extractAri", ()=>$e72cc95d6d37b739$export$be18a6294fd426ec);
    const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
        if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    };
});
parcelRegister("8UXrm", function(module, exports) {
    $parcel$export(module.exports, "extractLink", ()=>$c7ac01b191c63203$export$63f54cf4c5883620);
    var $7OmtM;
    const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
        const url = jsonLd.url;
        if (url) {
            if (typeof url === 'string') return url;
            else return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(url);
        }
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("hjhAz", function(module, exports) {
    $parcel$export(module.exports, "useSmartCardState", ()=>$7fb324870ee27912$export$b0444d00ba7313c6);
    var $bDWQ3 = parcelRequire("bDWQ3");
    var $kECas;
    const $7fb324870ee27912$var$PENDING_STATE = {
        status: 'pending'
    };
    function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
        return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
    }
});
parcelRegister("kR87P", function(module, exports) {
    $parcel$export(module.exports, "useAISummary", ()=>$c5395471ca862cc2$export$becd8f2eba1bbd96);
    var $5uXOq = parcelRequire("5uXOq");
    var $SrCME;
    var $561ku;
    const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
        const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.state || {
            status: 'ready',
            content: ''
        });
        (0, $5uXOq.useEffect)(()=>{
            if (url && !(0, (0, parcelRequire("561ku")).AISummariesStore).get(url)) (0, (0, parcelRequire("561ku")).AISummariesStore).set(url, new (0, (0, parcelRequire("SrCME")).AISummaryService)({
                url: url,
                ari: ari,
                baseUrl: baseUrl,
                product: product,
                envKey: envKey,
                onError: onError,
                onStart: onStart,
                onSuccess: onSuccess
            }));
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.subscribe(setState);
        }, [
            url,
            baseUrl,
            onError,
            onStart,
            onSuccess,
            product,
            ari,
            envKey
        ]);
        const summariseUrl = ()=>{
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.summariseUrl();
        };
        return {
            summariseUrl: summariseUrl,
            state: state
        };
    };
});
parcelRegister("SrCME", function(module, exports) {
    $parcel$export(module.exports, "AISummaryService", ()=>$ad05438f1e08870b$export$73e4b807d5bd74b6);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $itO4f;
    var $VSDnB;
    var $9AA7J;
    var $c0Zwh;
    var $ghXNq;
    class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
        constructor(props){
            this.state = {
                content: '',
                status: 'ready'
            };
            this.subscribedStateSetters = new Set();
            this.getRequestUrl = (envKey, baseUrlOverride)=>{
                const path = 'assist/chat/v1/invoke_agent/stream';
                if (baseUrlOverride || envKey) {
                    const baseUrl = baseUrlOverride || (0, (0, parcelRequire("itO4f")).getBaseUrl)(envKey);
                    return (0, (0, parcelRequire("ghXNq")).addPath)(baseUrl, path);
                }
                return (0, (0, parcelRequire("ghXNq")).addPath)('/gateway/api/', path);
            };
            this.fetchStream = async ()=>{
                const payload = {
                    recipient_agent_named_id: (0, (0, parcelRequire("VSDnB")).fg)('platform-smart-card-use-ai-smartlink-summary-agent') ? 'smartlink_summary_agent' : 'summary_agent',
                    agent_input_context: {
                        content_url: this.url,
                        content_ari: this.ari,
                        prompt_id: 'smart_links',
                        summary_output_mimetype: 'text/markdown'
                    }
                };
                const options = {
                    method: 'POST',
                    headers: this.config.headers,
                    body: JSON.stringify(payload),
                    credentials: 'include'
                };
                const response = await fetch(this.config.requestUrl, options);
                if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
                else return (0, (0, parcelRequire("9AA7J")).readStream)(response);
            };
            this.config = {
                requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-experience-id': 'smart-link',
                    'x-product': (0, (0, parcelRequire("ghXNq")).getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
                }
            };
            this.url = props.url;
            this.ari = props.ari;
            this.onStart = props.onStart;
            this.onSuccess = props.onSuccess;
            this.onError = props.onError;
        }
        async summariseUrl() {
            this.state = {
                status: 'loading',
                content: ''
            };
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            const id = (0, ($parcel$interopDefault($7Jxgt)))();
            try {
                this.onStart?.(id);
                const stream = await this.fetchStream();
                let bufferContent = '';
                for await (const chunk of stream){
                    if (chunk.type === 'ANSWER_PART') {
                        bufferContent += chunk.message.content;
                        for (const subscriber of this.subscribedStateSetters)subscriber({
                            ...this.state,
                            content: bufferContent
                        });
                    }
                    if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                    if (chunk.type === 'ERROR') throw new (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError)(chunk?.message?.message_template);
                }
                this.onSuccess?.(id);
                this.state = {
                    status: 'done',
                    content: bufferContent
                };
            } catch (err) {
                let message = err instanceof (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError) ? err.message : 'UNEXPECTED';
                this.onError?.(id, message);
                this.state = {
                    status: 'error',
                    content: '',
                    error: message
                };
            }
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            return this.state;
        }
        subscribe(stateSetter) {
            this.subscribedStateSetters.add(stateSetter);
            return ()=>{
                this.subscribedStateSetters.delete(stateSetter);
            };
        }
    }
});
parcelRegister("9AA7J", function(module, exports) {
    $parcel$export(module.exports, "readStream", ()=>$27dc203987154036$export$e45226161c660403);
    var $ghXNq;
    async function* $27dc203987154036$export$e45226161c660403(response) {
        const reader = (0, (0, parcelRequire("ghXNq")).getBufferReader)(response);
        let doneStreaming = false;
        let chunkBuffer = '';
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            if (value) {
                const processedChunks = `${chunkBuffer}${value}`.split('\n');
                chunkBuffer = '';
                for (let chunk of processedChunks)try {
                    const jsonChunk = JSON.parse(chunk);
                    if (jsonChunk.type === 'ERROR') reader.cancel();
                    yield jsonChunk;
                } catch (e) {
                    chunkBuffer = chunk;
                }
            }
        } catch (e) {
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else {
                reader.cancel();
                throw e;
            }
        }
        while (!doneStreaming)
        if (chunkBuffer) {
            const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
            throw error;
        }
    }
});
parcelRegister("ghXNq", function(module, exports) {
    $parcel$export(module.exports, "getBufferReader", ()=>$6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
    $parcel$export(module.exports, "addPath", ()=>$6c9c387ba5dd9d5b$export$4c25481b843feb0b);
    $parcel$export(module.exports, "getXProductHeaderValue", ()=>$6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
    const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
        if (!response.body) throw new Error('Response body is empty');
        return response.body.pipeThrough(new TextDecoderStream()).getReader();
    };
    const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
        const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
        const url = [
            urlWithTrailingSlash,
            pathWithoutLeadingSlash
        ].join('');
        return url;
    };
    const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
        JSM: 'JSM',
        JSW: 'JIRA-SOFTWARE',
        JWM: 'JIRA-CORE',
        JPD: 'JPD'
    };
    const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
        const JIRA_PRODUCTS = [
            'JPD',
            'JSM',
            'JSW',
            'JWM'
        ];
        return product !== undefined && JIRA_PRODUCTS.includes(product);
    };
    const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
        if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
        return product;
    };
});
parcelRegister("c0Zwh", function(module, exports) {
    $parcel$export(module.exports, "ChunkProcessingError", ()=>$0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
    class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
        constructor(error){
            super(error);
        }
    }
    const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
        'NETWORK_ERROR',
        'NO_ANSWER',
        'RATE_LIMIT',
        'NO_AGENT',
        'PLUGIN_ERRORED',
        'OPENAI_RATE_LIMIT_USER_ABUSE',
        'ACCEPTABLE_USE_VIOLATIONS',
        'AI_DISABLED',
        'UNEXPECTED',
        'HIPAA_CONTENT_DETECTED',
        'EXCEEDING_CONTEXT_LENGTH_ERROR'
    ];
});
parcelRegister("561ku", function(module, exports) {
    $parcel$export(module.exports, "AISummariesStore", ()=>$cc472589618fd980$export$6979339b6d41707e);
    var $iwKVT = parcelRequire("iwKVT");
    const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
    const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);
});
parcelRegister("anB5s", function(module, exports) {
    $parcel$export(module.exports, "useAISummaryConfig", ()=>$cd0a62b074a064ce$export$4480af2c00aa7ebe);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
        const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        return (0, $5uXOq.useMemo)(()=>({
                baseUrl: connections.client.baseUrlOverride,
                envKey: connections.client.envKey,
                product: product,
                isAdminHubAIEnabled: isAdminHubAIEnabled
            }), [
            connections.client.baseUrlOverride,
            connections.client.envKey,
            product,
            isAdminHubAIEnabled
        ]);
    };
});
parcelRegister("8UCLX", function(module, exports) {
    $parcel$export(module.exports, "AISummariseAction", ()=>$a2971ac1720627ee$export$75a19de44af58722);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jps85;
    var $a1vqi;
    var $7zaVw;
    var $8z1HA;
    var $23vM5;
    var $blyr7;
    function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onCompleted = (0, $5uXOq.useCallback)((state)=>{
            if (state?.status === 'error') onErrorCallback?.((0, (0, parcelRequire("blyr7")).getErrorMessage)(state.error));
        }, [
            onErrorCallback
        ]);
        const handleActionClick = (0, $5uXOq.useCallback)(()=>{
            fireEvent('ui.button.clicked.aiSummary', {});
            fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 0,
                userGeneratedAI: 1
            });
            summariseUrl()?.then(onCompleted, onCompleted);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            onCompleted,
            summariseUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Summarise with AI",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default)
            }),
            onClick: handleActionClick,
            testId: `${testId}-summarise-action`,
            isLoading: status === 'loading',
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action_description),
            ...props
        });
    }
});
parcelRegister("jps85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e2162c0618e136c6$var$_UNSAFE_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e2162c0618e136c6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>$e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
        }, props));
    $e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
    var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;
});
parcelRegister("8z1HA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f8c2f1acb4b6b88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        })));
    var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;
});
parcelRegister("blyr7", function(module, exports) {
    $parcel$export(module.exports, "getErrorMessage", ()=>$2b1346f84062e88d$export$82f46aa4e6535a45);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cnaAy;
    var $RbANO;
    var $1r4gF;
    const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
        const { message: message, url: url } = (0, (0, parcelRequire("cnaAy")).getAISummaryErrorMessage)(error);
        return {
            appearance: 'error',
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("RbANO")).default), {
                reason: error
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...message,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1r4gF")).default), {
                            href: url
                        }, chunks)
                }
            }))
        };
    };
});
parcelRegister("cnaAy", function(module, exports) {
    $parcel$export(module.exports, "getIsAISummaryEnabled", ()=>$3339f41fc1b0dac1$export$d439c74cb206ff29);
    $parcel$export(module.exports, "getAISummaryErrorMessage", ()=>$3339f41fc1b0dac1$export$cd2e891d7f87074d);
    var $8dVIb;
    var $7zaVw;
    const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
    const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
        switch(error){
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_acceptable_use_violation,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_ACCEPTABLE_USE_POLICY)
                };
            case 'HIPAA_CONTENT_DETECTED':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_hipaa_content_detected
                };
            case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_exceeding_context_length_error
                };
            default:
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_generic,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI_TROUBLESHOOTING)
                };
        }
    };
});
parcelRegister("RbANO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$402c39c7523f0dd1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.error.viewed.aiSummary', {
                reason: reason
            });
        }, [
            fireEvent,
            reason
        ]);
        return null;
    };
    var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;
});
parcelRegister("1r4gF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff8f369a3b340dfb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI),
            target: "_blank",
            rel: "noopener noreferrer",
            ...props
        }, children);
    var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;
});
parcelRegister("jdA9V", function(module, exports) {
    $parcel$export(module.exports, "CopySummaryAction", ()=>$2e1357a85e616794$export$cfa1d3eed9a61059);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $3Fq5M;
    var $a1vqi;
    var $7zaVw;
    var $23vM5;
    function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description);
        const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
            fireEvent('ui.button.clicked.copySummary', {});
            await navigator.clipboard.writeText(content ?? '');
            setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_summary_action_description);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            content
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Copy Summary"
            }),
            onClick: handleCopySummaryClick,
            testId: `${testId}-copy-summary-action`,
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description),
            ...props
        });
    }
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("5OUwn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd2a7343c5a2622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $4ldhu;
    var $cgL5K;
    var $a1vqi;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $e5vwM;
    var $3Lbo8;
    const $9fd2a7343c5a2622$var$AutomationModal = (0, $5uXOq.lazy)(()=>(parcelRequire("75mQu")));
    const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const { onClick: onClickCallback } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const automationActionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction];
        const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
            const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
            fireEvent('ui.button.clicked.automationAction', {});
            const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, (0, parcelRequire("3Lbo8")).getModalContent)(product, resourceType) || {};
            const automationModalTitle = modalTitle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), modalTitle) : undefined;
            const automationModalDescription = modalDescription ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...modalDescription,
                values: {
                    name: objectName,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, chunks),
                    br: (0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            }) : undefined;
            modal.open((0, ($parcel$interopDefault($5uXOq))).createElement($9fd2a7343c5a2622$var$AutomationModal, {
                baseAutomationUrl: baseAutomationUrl,
                objectAri: objectAri,
                siteAri: siteAri,
                canManageAutomation: canManageAutomation,
                analyticsSource: analyticsSource,
                modalTitle: automationModalTitle,
                modalDescription: automationModalDescription,
                onClose: ()=>modal.close()
            }));
            onClickCallback?.();
        }, [
            modal,
            onClickCallback,
            fireEvent
        ]);
        if (!automationActionData) return null;
        const automationActionTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_title);
        const automationActionTooltip = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_tooltip);
        const automationActionIconLabel = formatMessage((0, (0, parcelRequire("7zaVw")).messages).automation_action_icon_label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: automationActionTitle,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("e5vwM")).default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        }));
    };
    var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;
});
parcelRegister("7HAq8", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkModalProvider", ()=>$bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
    $parcel$export(module.exports, "useSmartLinkModal", ()=>$bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lnPiq;
    const $bc735e1cde43eb76$var$FALLBACK_API = {
        open: ()=>{},
        close: ()=>{}
    };
    const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = (0, ($parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
    const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        const api = (0, $5uXOq.useMemo)(()=>({
                open: (modal)=>setElement((0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                        fallback: null
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnPiq")).StopPropagation), null, modal))),
                close: ()=>setElement(null)
            }), []);
        const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
            resetErrorBoundary();
            return null;
        }, []);
        const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
            value: api
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallbackRender: fallbackRender,
            onReset: onReset
        }, element));
    };
    const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);
});
parcelRegister("lnPiq", function(module, exports) {
    $parcel$export(module.exports, "StopPropagation", ()=>$a203465a8c9e0684$export$3e100bc08448f36c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $a203465a8c9e0684$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a203465a8c9e0684$var$styles = {
        name: "g32yti",
        styles: "max-height:0;max-width:0;position:absolute"
    };
    const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
        const onClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
        }, []);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a203465a8c9e0684$var$styles,
            onClick: onClick
        }, children));
    };
});
parcelRegister("e5vwM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23884530c116b98b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            "aria-label": label,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
    var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;
});
parcelRegister("3Lbo8", function(module, exports) {
    $parcel$export(module.exports, "getModalContent", ()=>$6b74a4060fa13021$export$93e707b363eaf5c8);
    var $7zaVw;
    const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
        const modalContentMap = {
            confluence: {
                page: {
                    modalTitle: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_title,
                    modalDescription: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_description
                }
            }
        };
        return modalContentMap?.[product]?.[resourceType];
    };
});
parcelRegister("75mQu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lchYl")
    ]).then(()=>parcelRequire('1Rjyb'));
});
parcelRegister("faTeC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b95acafe5e8a7ba5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $a1vqi;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $k98Kd;
    const $b95acafe5e8a7ba5$var$RelatedLinksModal = (0, $5uXOq.lazy)(()=>(parcelRequire("eOjGT")));
    const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.ViewRelatedLinksAction;
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const ari = actionData?.ari;
            if (ari) modal.open((0, (0, parcelRequire("f8Sb3")).jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
                ari: ari,
                showModal: true,
                onClose: ()=>modal.close()
            }));
            fireEvent('ui.button.clicked.relatedLinks', {});
            onClickCallback?.();
        }, [
            actionData?.ari,
            fireEvent,
            modal,
            onClickCallback
        ]);
        return actionData ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("23vM5")).default), {
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).related_links_view_related_urls),
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k98Kd")).default), null),
            onClick: onClick,
            testId: "smart-action-view-related-links-action",
            ariaLabel: "View most recent pages or content types coming from or found on this link",
            ...props
        }) : null;
    };
    var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;
});
parcelRegister("k98Kd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ehOs2;
    function $7c9aac1bc71ae3e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7c9aac1bc71ae3e1$var$rotateSvg = {
        name: "9v7l5f",
        styles: "transform:rotate(180deg);display:inline-block"
    };
    const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7c9aac1bc71ae3e1$var$rotateSvg
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("ehOs2"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        }));
    var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;
});
parcelRegister("ehOs2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));
    var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
    function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>$a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
            LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
        }, props));
    $a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
    var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;
});
parcelRegister("a5U1O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7595d510a7cf11ee$var$_UNSAFE_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>$7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
        }, props));
    $7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;
});
parcelRegister("hxodJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
    function $cc484e6d94653edf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>$cc484e6d94653edf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
        }, props, {
            newIcon: $cc484e6d94653edf$var$_childIssues.default
        }));
    $cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;
});
parcelRegister("eOjGT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXU8n")
    ]).then(()=>parcelRequire('14MtF'));
});
parcelRegister("dghu0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96a6d91fb5d77548$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $akF1x;
    const $96a6d91fb5d77548$var$getBlockStyles = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), " ", (0, (0, parcelRequire("akF1x")).highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, (0, parcelRequire("akF1x")).getGapSize)(size), "rem;}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']:before{content:'\u2190';}");
    const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
        (0, $5uXOq.useEffect)(()=>{
            onRender && onRender();
        }, [
            onRender
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $96a6d91fb5d77548$var$getBlockStyles(direction, size),
                overrideCss
            ],
            "data-smart-block": true,
            "data-testid": testId,
            onTransitionEnd: onTransitionEnd,
            ref: blockRef
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    };
    var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;
});
parcelRegister("gg6Qm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61dcf60a0013442f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
    const $61dcf60a0013442f$var$getElementGroupStyles = (size, maxLines)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)({
            lineHeight: `${lineHeight}rem`
        }, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, lineHeight + 'rem'));
    };
    const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
        if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
        if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
        if (primary.length === 0 && secondary.length === 0 || status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        const primaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(primary);
        const secondaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(secondary);
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const elementGroupStyles = $61dcf60a0013442f$var$getElementGroupStyles(size, $61dcf60a0013442f$var$getMaxLines(maxLines));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, primaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, primaryElements), secondaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, secondaryElements));
    };
    var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;
});
parcelRegister("hYQw7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61b44b31e2da1312$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $cElbi;
    const $61b44b31e2da1312$var$PreviewBlock = ({ status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cElbi")).default), {
            ...blockProps,
            testId: testId,
            overrideUrl: overrideUrl
        });
    };
    var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;
});
parcelRegister("cElbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64981f7edc74268b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $kDhrr;
    var $dghu0;
    function $64981f7edc74268b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $64981f7edc74268b$var$_ref = {
        name: "ooh6hm",
        styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
    };
    const $64981f7edc74268b$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
        if (placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left || placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
            return (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
        }
        if (ignoreContainerPadding) return $64981f7edc74268b$var$_ref;
    };
    const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
        const [styles, setStyles] = (0, $5uXOq.useState)(overrideCss);
        const updateStyles = (0, $5uXOq.useCallback)(()=>{
            setStyles((0, (0, parcelRequire("f8Sb3")).css)($64981f7edc74268b$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateStyles();
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement,
            updateStyles
        ]);
        const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
            updateStyles();
        }, [
            updateStyles
        ]);
        const handleOnError = (0, $5uXOq.useCallback)(()=>{
            if (onError) onError();
        }, [
            onError
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            overrideCss: styles,
            testId: `${testId}-resolved-view`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kDhrr")).default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        }));
    };
    var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;
});
parcelRegister("1JaZ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c880264dd5ccb40b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $kp8aU;
    var $fpDmE;
    var $dghu0;
    const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
    const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
    const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
    const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !text) return null;
        const snippetMaxLines = (0, (0, parcelRequire("fpDmE")).getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
        const statusTestId = !text ? 'resolved' : 'non-resolved';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-${statusTestId}-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kp8aU")).default), {
            maxLines: snippetMaxLines,
            content: text
        }));
    };
    var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;
});
parcelRegister("buvhv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93b66054384f48ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $4URMI;
    var $eqoQu;
    var $bubxq;
    var $fkxMX;
    var $bXy5i;
    var $jHa2h;
    function $93b66054384f48ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $93b66054384f48ec$var$_ref = {
        name: "11eaz",
        styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
    };
    const $93b66054384f48ec$var$getActionStyles = (showOnHover, isOpen)=>{
        if (showOnHover && !isOpen) return $93b66054384f48ec$var$_ref;
    };
    const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolving:
                return 0, (0, parcelRequire("jHa2h")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved:
                return 0, (0, parcelRequire("bXy5i")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
            default:
                return 0, (0, parcelRequire("fkxMX")).default;
        }
    };
    const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
        if (hideRetry && props.retry) delete props.retry;
        const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            setActionDropdownOpen(isOpen);
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        const actionGroup = actions.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            items: actions,
            visibleButtonsNum: showActionOnHover ? 1 : 2,
            onDropdownOpenChange: onDropdownOpenChange
        });
        const actionStyles = $93b66054384f48ec$var$getActionStyles(showActionOnHover, actionDropdownOpen);
        const combinedCss = (0, (0, parcelRequire("f8Sb3")).css)(actionStyles, overrideCss);
        const overrideText = !!text ? {
            text: text
        } : {};
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Title), {
            hideTooltip: hideTitleTooltip,
            maxLines: maxLines,
            onClick: onClick,
            onMouseDown: onMouseDown,
            target: anchorTarget,
            theme: theme,
            ...overrideText
        });
        const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            actionGroup: actionGroup,
            overrideCss: combinedCss,
            testId: testId,
            title: title,
            metadataPosition: metadataPosition,
            hideIcon: hideIcon,
            icon: icon
        });
    };
    var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;
});
parcelRegister("fkxMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbea6814ca213c7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $dC5iT;
    var $8dVIb;
    var $eqoQu;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    function $dcbea6814ca213c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dcbea6814ca213c7$var$actionStyles = {
        name: "r982j0",
        styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
    };
    const $dcbea6814ca213c7$var$actionHoverStyles = {
        name: "y4wzay",
        styles: "position:relative;z-index:1;&:focus{outline-offset:var(--ds-space-negative-025, -2px);}"
    };
    const $dcbea6814ca213c7$var$getMessageStyles = (size, hasAction)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;justify-content:flex-end;", hasAction ? $dcbea6814ca213c7$var$actionStyles : '', sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size)), {
            color: "var(--ds-text-disabled, #6B778C)",
            ':focus': {
                outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
            }
        }, hasAction ? $dcbea6814ca213c7$var$actionHoverStyles : '');
    };
    const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
        const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const hasAction = onClick !== undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-errored-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), title, descriptor && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $dcbea6814ca213c7$var$getMessageStyles(size, hasAction),
            onClick: onClick,
            testId: `${testId}-errored-view-message`,
            tabIndex: hasAction ? 0 : -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...descriptor,
            values: values
        }))), actionGroup);
    };
    var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;
});
parcelRegister("bXy5i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2967317da51f9f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $eqoQu;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    function $e2967317da51f9f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $e2967317da51f9f7$var$_ref = {
        name: "v43pxc",
        styles: "gap:var(--ds-space-050, 0.25rem)"
    };
    const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
        const metadataElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(metadata);
        const subtitleElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(subtitle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, !hideIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible,
            overrideCss: $e2967317da51f9f7$var$_ref
        }, title, subtitleElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal
        }, subtitleElements)), metadataElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            position: metadataPosition ?? (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center
        }, metadataElements), actionGroup);
    };
    var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;
});
parcelRegister("jHa2h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$045d1b1e49cae759$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $gU02S;
    var $fpDmE;
    var $dghu0;
    const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const iconWidth = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const iconStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(iconWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolving-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: iconStyles,
            "data-testid": `${testId}-icon`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            testId: `${testId}-icon-loading`
        })), title, actionGroup);
    };
    var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;
});
parcelRegister("1qDIM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dff75b4d7cc06d3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $4tgi5;
    const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        if (!actionData?.url) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tgi5")).default), {
            ...props,
            testId: testId,
            url: actionData.url
        });
    };
    var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;
});
parcelRegister("4tgi5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$413bb2fab5c71807$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8dVIb;
    var $1MeuC;
    var $bHeMs;
    var $aBTst;
    var $dghu0;
    var $adeuB;
    const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default), (0, (0, parcelRequire("bHeMs")).default));
        const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
        const { state: { content: content, status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        const showAISummary = status === 'done' || status === 'loading' && !!content;
        const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
        const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
        if (!showAISummary) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, placeholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            testId: `${testId}-resolved-view`,
            overrideCss: (0, (0, parcelRequire("f8Sb3")).css)("overflow:visible;", props.overrideCss)
        }, status === 'done' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adeuB")).default), {
            fromCache: isSummarisedOnMountRef.current
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            minHeight: minHeight,
            show: showAISummary,
            showTransition: !isSummarisedOnMountRef.current
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHeMs")).default), {
            testId: `${testId}-ai-summary`,
            minHeight: minHeight,
            content: content
        })));
    };
    var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;
});
parcelRegister("bHeMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea67ef8b17402f34$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $flpap;
    var $aRS1S;
    function $ea67ef8b17402f34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ea67ef8b17402f34$var$AISummaryCSSStyles = {
        name: "178flxl",
        styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
    };
    const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
        if (!content && minHeight === 0) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("flpap")).default), {
            "data-testid": testId,
            css: [
                $ea67ef8b17402f34$var$AISummaryCSSStyles,
                overrideCss
            ],
            children: content,
            options: {
                forceWrapper: true,
                overrides: {
                    ul: (0, (0, parcelRequire("aRS1S")).default)
                }
            },
            style: {
                minHeight: minHeight
            }
        });
    };
    var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;
});
parcelRegister("flpap", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2bc56c6c0b4e02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b2bc56c6c0b4e02e$var$t() {
        return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
        }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
    }
    const $b2bc56c6c0b4e02e$var$n = [
        "children",
        "options"
    ], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
        blockQuote: "0",
        breakLine: "1",
        breakThematic: "2",
        codeBlock: "3",
        codeFenced: "4",
        codeInline: "5",
        footnote: "6",
        footnoteReference: "7",
        gfmTask: "8",
        heading: "9",
        headingSetext: "10",
        htmlBlock: "11",
        htmlComment: "12",
        htmlSelfClosing: "13",
        image: "14",
        link: "15",
        linkAngleBraceStyleDetector: "16",
        linkBareUrlDetector: "17",
        linkMailtoDetector: "18",
        newlineCoalescer: "19",
        orderedList: "20",
        paragraph: "21",
        ref: "22",
        refImage: "23",
        refLink: "24",
        table: "25",
        tableSeparator: "26",
        text: "27",
        textBolded: "28",
        textEmphasized: "29",
        textEscaped: "30",
        textMarked: "31",
        textStrikethroughed: "32",
        unorderedList: "33"
    };
    var $b2bc56c6c0b4e02e$var$i;
    !function(e) {
        e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
    }($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
    const $b2bc56c6c0b4e02e$var$l = [
        "allowFullScreen",
        "allowTransparency",
        "autoComplete",
        "autoFocus",
        "autoPlay",
        "cellPadding",
        "cellSpacing",
        "charSet",
        "classId",
        "colSpan",
        "contentEditable",
        "contextMenu",
        "crossOrigin",
        "encType",
        "formAction",
        "formEncType",
        "formMethod",
        "formNoValidate",
        "formTarget",
        "frameBorder",
        "hrefLang",
        "inputMode",
        "keyParams",
        "keyType",
        "marginHeight",
        "marginWidth",
        "maxLength",
        "mediaGroup",
        "minLength",
        "noValidate",
        "radioGroup",
        "readOnly",
        "rowSpan",
        "spellCheck",
        "srcDoc",
        "srcLang",
        "srcSet",
        "tabIndex",
        "useMap"
    ].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
        class: "className",
        for: "htmlFor"
    }), $b2bc56c6c0b4e02e$var$a = {
        amp: "&",
        apos: "'",
        gt: ">",
        lt: "<",
        nbsp: "\xa0",
        quot: "\u201C"
    }, $b2bc56c6c0b4e02e$var$o = [
        "style",
        "script"
    ], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
    function $b2bc56c6c0b4e02e$var$ce(e) {
        return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
    }
    const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
    function $b2bc56c6c0b4e02e$var$pe(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
    }
    const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
    function $b2bc56c6c0b4e02e$var$he(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
    }
    const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
    function $b2bc56c6c0b4e02e$var$ye(e) {
        const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
        return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
    }
    const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
    function $b2bc56c6c0b4e02e$var$be(e, t) {
        const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
        return {
            match (e, t) {
                const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
                return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
            },
            order: 1,
            parse (e, t, r) {
                const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
                let c = !1;
                return {
                    items: o.map(function(e, n) {
                        const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                        c = p;
                        const u = r.inline, f = r.list;
                        let h;
                        r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                        const m = t(h, r);
                        return r.inline = u, r.list = f, m;
                    }),
                    ordered: n,
                    start: i
                };
            },
            render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                    key: i.key,
                    start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
                }, t.items.map(function(t, r) {
                    return e("li", {
                        key: r
                    }, n(t, i));
                }))
        };
    }
    const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
        $b2bc56c6c0b4e02e$var$p,
        $b2bc56c6c0b4e02e$var$m,
        $b2bc56c6c0b4e02e$var$g,
        $b2bc56c6c0b4e02e$var$$,
        $b2bc56c6c0b4e02e$var$z,
        $b2bc56c6c0b4e02e$var$w,
        $b2bc56c6c0b4e02e$var$T,
        $b2bc56c6c0b4e02e$var$j,
        $b2bc56c6c0b4e02e$var$me,
        $b2bc56c6c0b4e02e$var$ke,
        $b2bc56c6c0b4e02e$var$ge,
        $b2bc56c6c0b4e02e$var$xe
    ], $b2bc56c6c0b4e02e$var$Ce = [
        ...$b2bc56c6c0b4e02e$var$Ee,
        /^[^\n]+(?:  \n|\n{2,})/,
        $b2bc56c6c0b4e02e$var$L,
        $b2bc56c6c0b4e02e$var$B
    ];
    function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
        return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
    }
    function $b2bc56c6c0b4e02e$var$we(e) {
        return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
    }
    function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
        const l = n.inTable;
        n.inTable = !0;
        let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
            } : {
                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
                text: l
            }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
        n.inTable = l;
        let o = [
            []
        ];
        return a.forEach(function(e, t) {
            e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
        }), o;
    }
    function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
        n.inline = !0;
        const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
            return e.trim().split("\n").map(function(e) {
                return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
            });
        }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
        return n.inline = !1, l.length ? {
            align: i,
            cells: l,
            header: a,
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
        } : {
            children: a,
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
        };
    }
    function $b2bc56c6c0b4e02e$var$Ae(e, t) {
        return null == e.align[t] ? {} : {
            textAlign: e.align[t]
        };
    }
    function $b2bc56c6c0b4e02e$var$Te(e) {
        return function(t, n) {
            return n.inline ? e.exec(t) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Oe(e) {
        return function(t, n) {
            return n.inline || n.simple ? e.exec(t) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Be(e) {
        return function(t, n) {
            return n.inline || n.simple ? null : e.exec(t);
        };
    }
    function $b2bc56c6c0b4e02e$var$Me(e) {
        return function(t) {
            return e.exec(t);
        };
    }
    function $b2bc56c6c0b4e02e$var$Re(e, t) {
        if (t.inline || t.simple) return null;
        let n = "";
        e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
        const r = n.trimEnd();
        return "" == r ? null : [
            n,
            r
        ];
    }
    function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
        try {
            if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
        } catch (e) {
            return null;
        }
        return e;
    }
    function $b2bc56c6c0b4e02e$var$Ue(e) {
        return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
    }
    function $b2bc56c6c0b4e02e$var$De(e, t, n) {
        const r = n.inline || !1, i = n.simple || !1;
        n.inline = !0, n.simple = !0;
        const l = e(t, n);
        return n.inline = r, n.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$je(e, t, n) {
        const r = n.inline || !1, i = n.simple || !1;
        n.inline = !1, n.simple = !0;
        const l = e(t, n);
        return n.inline = r, n.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
        const r = n.inline || !1;
        n.inline = !1;
        const i = e(t, n);
        return n.inline = r, i;
    }
    const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
            children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
        });
    function $b2bc56c6c0b4e02e$var$Fe() {
        return {};
    }
    function $b2bc56c6c0b4e02e$var$Pe() {
        return null;
    }
    function $b2bc56c6c0b4e02e$var$_e(...e) {
        return e.filter(Boolean).join(" ");
    }
    function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
        let r = e;
        const i = t.split(".");
        for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
        return r || n;
    }
    function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
        function d(e, n, ...r) {
            const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
            return i.createElement(function(e, t) {
                const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
                return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
            }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
                className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
            }), ...r);
        }
        function G(t) {
            t = t.replace($b2bc56c6c0b4e02e$var$E, "");
            let n = !1;
            i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
            const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
                inline: n
            }));
            for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
            if (null === i.wrapper) return r;
            const l = i.wrapper || (n ? "span" : "div");
            let a;
            if (r.length > 1 || i.forceWrapper) a = r;
            else {
                if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                    key: "outer"
                }, a) : a;
                a = null;
            }
            return $5uXOq.createElement(l, {
                key: "outer"
            }, a);
        }
        function W(t, n) {
            const r = n.match($b2bc56c6c0b4e02e$var$c);
            return r ? r.reduce(function(n, r, a) {
                const o = r.indexOf("=");
                if (-1 !== o) {
                    const c = (function(e) {
                        return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                            return t.toUpperCase();
                        })), e;
                    })(r.slice(0, o)).trim(), s = function(e) {
                        const t = e[0];
                        return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                    }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                        return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                            const n = t.slice(0, t.indexOf(":"));
                            return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                        }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                    }(t, c, s, i.sanitizer);
                    "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                        key: a
                    }));
                } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
                return n;
            }, {}) : null;
        }
        i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
        const Z = [], q = {}, Q = {
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
                order: 1,
                parse: (e, t, n)=>({
                        children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                    }),
                render: (e, t, n)=>d("blockquote", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, t, n)=>d("br", {
                        key: n.key
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, t, n)=>d("hr", {
                        key: n.key
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
                order: 0,
                parse: (e)=>({
                        lang: void 0,
                        text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                    }),
                render: (e, n, r)=>d("pre", {
                        key: r.key
                    }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                        className: e.lang ? `lang-${e.lang}` : ""
                    }), e.text))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
                order: 0,
                parse: (e)=>({
                        attrs: W("code", e[3] || ""),
                        lang: e[2] || void 0,
                        text: e[4],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
                order: 3,
                parse: (e)=>({
                        text: e[2]
                    }),
                render: (e, t, n)=>d("code", {
                        key: n.key
                    }, e.text)
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
                order: 0,
                parse: (e)=>(Z.push({
                        footnote: e[2],
                        identifier: e[1]
                    }), {}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
                order: 1,
                parse: (e)=>({
                        target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                        text: e[1]
                    }),
                render: (e, t, n)=>d("a", {
                        key: n.key,
                        href: i.sanitizer(e.target, "a", "href")
                    }, d("sup", {
                        key: n.key
                    }, e.text))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
                order: 1,
                parse: (e)=>({
                        completed: "x" === e[1].toLowerCase()
                    }),
                render: (e, t, n)=>d("input", {
                        checked: e.completed,
                        key: n.key,
                        readOnly: !0,
                        type: "checkbox"
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
                match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
                order: 1,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                        id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                        level: e[1].length
                    }),
                render: (e, t, n)=>d(`h${e.level}`, {
                        id: e.id,
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
                order: 0,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                        level: "=" === e[2] ? 1 : 2,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
                order: 1,
                parse (e, t, n) {
                    const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                    var c;
                    const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                        attrs: W(p, e[2]),
                        noInnerParse: d,
                        tag: p
                    };
                    return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
                },
                render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                        key: r.key
                    }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
                order: 1,
                parse (e) {
                    const t = e[1].trim();
                    return {
                        attrs: W(t, e[2] || ""),
                        tag: t
                    };
                },
                render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                        key: r.key
                    }))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
                order: 1,
                parse: ()=>({}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
                order: 1,
                parse: (e)=>({
                        alt: e[1],
                        target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                        title: e[3]
                    }),
                render: (e, t, n)=>d("img", {
                        key: n.key,
                        alt: e.alt || void 0,
                        title: e.title || void 0,
                        src: i.sanitizer(e.target, "img", "src")
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
                order: 3,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                        target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                        title: e[3]
                    }),
                render: (e, t, n)=>d("a", {
                        key: n.key,
                        href: i.sanitizer(e.target, "a", "href"),
                        title: e.title
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: e[1],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
                match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: e[1],
                        title: void 0,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
                order: 0,
                parse (e) {
                    let t = e[1], n = e[1];
                    return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                        children: [
                            {
                                text: t.replace("mailto:", ""),
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: n,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    };
                }
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: ()=>"\n"
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
                match: $b2bc56c6c0b4e02e$var$Re,
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("p", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
                order: 0,
                parse: (e)=>(q[e[1]] = {
                        target: e[2],
                        title: e[4]
                    }, {}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
                order: 0,
                parse: (e)=>({
                        alt: e[1] || void 0,
                        ref: e[2]
                    }),
                render: (e, t, n)=>q[e.ref] ? d("img", {
                        key: n.key,
                        alt: e.alt,
                        src: i.sanitizer(q[e.ref].target, "img", "src"),
                        title: q[e.ref].title
                    }) : null
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
                order: 0,
                parse: (e, t, n)=>({
                        children: t(e[1], n),
                        fallbackChildren: e[0],
                        ref: e[2]
                    }),
                render: (e, t, n)=>q[e.ref] ? d("a", {
                        key: n.key,
                        href: i.sanitizer(q[e.ref].target, "a", "href"),
                        title: q[e.ref].title
                    }, t(e.children, n)) : d("span", {
                        key: n.key
                    }, e.fallbackChildren)
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Le,
                render (e, t, n) {
                    const r = e;
                    return d("table", {
                        key: n.key
                    }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                        return d("th", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }))), d("tbody", null, r.cells.map(function(e, i) {
                        return d("tr", {
                            key: i
                        }, e.map(function(e, i) {
                            return d("td", {
                                key: i,
                                style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                            }, t(e, n));
                        }));
                    })));
                }
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
                order: 4,
                parse: (e)=>({
                        text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                    }),
                render: (e)=>e.text
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
                order: 2,
                parse: (e, t, n)=>({
                        children: t(e[2], n)
                    }),
                render: (e, t, n)=>d("strong", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
                order: 3,
                parse: (e, t, n)=>({
                        children: t(e[2], n)
                    }),
                render: (e, t, n)=>d("em", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
                order: 1,
                parse: (e)=>({
                        text: e[1],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("mark", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("del", {
                        key: n.key
                    }, t(e.children, n))
            }
        };
        !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
        const re = function(e) {
            let t = Object.keys(e);
            function n(r, i) {
                let l = [];
                for(i.prevCapture = i.prevCapture || ""; r;){
                    let a = 0;
                    for(; a < t.length;){
                        const o = t[a], c = e[o], s = c.match(r, i);
                        if (s) {
                            const e = s[0];
                            i.prevCapture += e, r = r.substring(e.length);
                            const t = c.parse(s, n, i);
                            null == t.type && (t.type = o), l.push(t);
                            break;
                        }
                        a++;
                    }
                }
                return i.prevCapture = "", l;
            }
            return t.sort(function(t, n) {
                let r = e[t].order, i = e[n].order;
                return r !== i ? r - i : t < n ? -1 : 1;
            }), function(e, t) {
                return n(function(e) {
                    return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
                }(e), t);
            };
        }(Q), ie = (le = function(e, t) {
            return function(n, r, i) {
                const l = e[n.type].render;
                return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
            };
        }(Q, i.renderRule), function e(t, n = {}) {
            if (Array.isArray(t)) {
                const r = n.key, i = [];
                let l = !1;
                for(let r = 0; r < t.length; r++){
                    n.key = r;
                    const a = e(t[r], n), o = "string" == typeof a;
                    o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
                }
                return n.key = r, i;
            }
            return le(t, e, n);
        });
        var le;
        const ae = G(n);
        return Z.length ? d("div", null, ae, d("footer", {
            key: "footer"
        }, Z.map(function(e) {
            return d("div", {
                id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                key: e.identifier
            }, e.identifier, ie(re(e.footnote, {
                inline: !0
            })));
        }))) : ae;
    }
    var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
        let { children: r = "", options: i } = t, l = function(e, t) {
            if (null == e) return {};
            var n, r, i = {}, l = Object.keys(e);
            for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
            return i;
        }(t, $b2bc56c6c0b4e02e$var$n);
        return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
    };
});
parcelRegister("aRS1S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$270fc2c4bbd80c91$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    function $270fc2c4bbd80c91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $270fc2c4bbd80c91$var$listStyles = {
        name: "k4jzwf",
        styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
    };
    const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            css: $270fc2c4bbd80c91$var$listStyles,
            ...props
        }, children);
    var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;
});
parcelRegister("aBTst", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8d8f80d50d9d1e4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
        const [height, setHeight] = (0, $5uXOq.useState)(0);
        const ref = (0, $5uXOq.useRef)(null);
        const transition = isFadeIn ? 'height, opacity' : 'height';
        (0, $5uXOq.useEffect)(()=>{
            if (show && ref.current) setHeight(ref.current.scrollHeight);
            else setHeight(0);
        }, [
            children,
            show
        ]);
        return show ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                height: height,
                minHeight: minHeight,
                lineHeight: 0,
                overflow: 'hidden',
                opacity: height > 0 ? 1 : 0,
                transitionProperty: showTransition ? transition : 'none',
                transitionDuration: '0.3s'
            },
            ref: ref
        }, children) : null;
    };
    var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;
});
parcelRegister("adeuB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$749bb6d43c83bff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.summary.viewed', {
                fromCache: fromCache
            });
            if (fromCache) fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 1,
                userGeneratedAI: 0
            });
        }, [
            fireEvent,
            fromCache
        ]);
        return null;
    };
    var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;
});
parcelRegister("85ffk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5cb2203e6787402$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $obtkX;
    const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("obtkX")).default), {
            ...props,
            testId: testId
        });
    };
    var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;
});
parcelRegister("obtkX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6b56bbc6d143050$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $dghu0;
    var $kBKwT;
    const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        const { testId: testId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kBKwT")).AIFooterMetadata), {
            ...actionData,
            testId: `${testId}-ai-metadata`
        }) : null);
    };
    var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;
});
parcelRegister("kBKwT", function(module, exports) {
    $parcel$export(module.exports, "AIFooterMetadata", ()=>$84dc366e320e5880$export$175228cc2c92b3b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $gKZoD;
    var $jps85;
    var $dC5iT;
    var $f5TWP;
    var $3bDjY;
    var $7zaVw;
    var $1MeuC;
    var $8z1HA;
    var $c8Sqt;
    const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { state: { status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        if (status !== 'done') return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            testId: testId,
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summarized_info_short),
            position: "bottom"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8Sqt")).InfoIcon), {
                label: "Information",
                LEGACY_size: "small",
                color: "var(--ds-icon-subtle, #626F86)"
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
            label: "AI",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default),
            color: "var(--ds-icon-subtle, #626F86)"
        }));
    };
});
parcelRegister("c8Sqt", function(module, exports) {
    $parcel$export(module.exports, "InfoIcon", ()=>$a035773c38c242b5$export$2957fc44b3d2481);
    var $5uXOq = parcelRequire("5uXOq");
    var $2Yv61;
    var $lqBg9;
    const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))), {
            color: props.color || 'currentColor',
            LEGACY_fallbackIcon: (0, (0, parcelRequire("lqBg9")).default),
            ...props
        });
});
parcelRegister("lqBg9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f1ed3211c768fe6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
            fill: "currentColor"
        }));
    const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
        });
    var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;
});
parcelRegister("fh9qw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b695424587865b74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8CUq3;
    var $8dVIb;
    var $Nh1XU;
    var $jRHKj;
    var $fpDmE;
    var $s2ak7;
    function $b695424587865b74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b695424587865b74$var$ignoreContainerPaddingStyles = {
        name: "19m4cma",
        styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
    };
    const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
        'PreviewAction',
        'CopyLinkAction',
        'AISummaryAction'
    ];
    const $b695424587865b74$var$sort = (a, b)=>{
        let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
        let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
        if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        return idxA - idxB;
    };
    const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("s2ak7")).ActionFooter));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [message, setMessage] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
            setIsLoading(isLoading);
        }, [
            setIsLoading
        ]);
        const padding = !ui?.hidePadding ? (0, (0, parcelRequire("fpDmE")).getPrimitivesPaddingSpaceBySize)(ui?.size || (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium) : undefined;
        const onClick = (0, $5uXOq.useCallback)((name)=>{
            setMessage(undefined);
            onClickCallback?.(name);
        }, [
            onClickCallback
        ]);
        const onError = (0, $5uXOq.useCallback)((error)=>{
            setMessage(error);
        }, []);
        const actions = (0, $5uXOq.useMemo)(()=>{
            if (!context?.actions) return;
            const arr = Object.keys(context.actions);
            arr.sort($b695424587865b74$var$sort);
            return arr.map((name)=>{
                const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
                return Action ? (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
                    as: "stack-item",
                    spaceInline: spaceInline,
                    key: name,
                    onClick: ()=>onClick(name),
                    onError: onError,
                    onLoadingChange: onLoadingChange,
                    size: size,
                    xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                        paddingInline: padding
                    }),
                    hideTooltip: isLoading
                }) : null;
            });
        }, [
            context?.actions,
            onClick,
            onError,
            padding,
            size,
            spaceInline,
            isLoading,
            onLoadingChange
        ]);
        return actions ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b695424587865b74$var$ignoreContainerPaddingStyles,
            ref: blockRef,
            "data-testid": testId
        }, actions, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("s2ak7")).ActionFooter), {
            message: message,
            paddingInline: padding,
            testId: testId
        })) : null;
    };
    var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;
});
parcelRegister("s2ak7", function(module, exports) {
    $parcel$export(module.exports, "ActionFooter", ()=>$e384e6334b5a98a7$export$2d2b754ac238f9aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $059q9;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $aBTst;
    const $e384e6334b5a98a7$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        borderRadius: 'border.radius',
        margin: 'space.100',
        marginBottom: 'space.0',
        lineHeight: '20px',
        padding: 'space.075',
        paddingInline: 'space.100',
        width: '100%',
        ':empty': {
            display: 'none'
        }
    });
    const $e384e6334b5a98a7$var$errorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.danger'
    });
    const $e384e6334b5a98a7$var$errorContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.025'
    });
    const $e384e6334b5a98a7$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
        switch(appearance){
            case 'error':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "compact",
                    label: "Error",
                    LEGACY_size: "small",
                    testId: "action-error-icon",
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
                });
            default:
                return null;
        }
    };
    const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
        if (!message) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: `${testId}-footer`,
            xcss: [
                $e384e6334b5a98a7$var$containerStyles,
                message.appearance === 'error' && $e384e6334b5a98a7$var$errorStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            isFadeIn: true,
            show: true,
            showTransition: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "start",
            grow: "fill",
            space: "space.075",
            xcss: $e384e6334b5a98a7$var$errorContentStyles
        }, message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e384e6334b5a98a7$var$titleStyles
        }, message.title))));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("i41Ob", function(module, exports) {
    $parcel$export(module.exports, "LoadingCardLink", ()=>$b4c0875f37c33ad9$export$1ca0544321134ad6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bMldO;
    const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bMldO")).CardLinkView), {
            key: 'lazy-render-key',
            testId: 'lazy-render-placeholder',
            "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
            isSelected: isSelected,
            link: url,
            className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
            placeholder: placeholder
        });
    };
});
parcelRegister("bMldO", function(module, exports) {
    $parcel$export(module.exports, "CardLinkView", ()=>$d0b446175f31475d$export$ce508304ed2dd145);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkxZO;
    class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkxZO")).Frame), {
                withoutBackground: true,
                ...this.props
            }, this.props.placeholder || this.props.link);
        }
    }
});
parcelRegister("kkxZO", function(module, exports) {
    $parcel$export(module.exports, "Frame", ()=>$2ed7f4f9fecd197d$export$b89a827e9254211a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4URMI;
    var $hhfQm;
    const $2ed7f4f9fecd197d$export$b89a827e9254211a = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, [
            onClick
        ]);
        const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, [
            onClick
        ]);
        const handleMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const isInteractive = Boolean(onClick);
        const isAnchor = Boolean(link || onClick);
        const Wrapper = isAnchor ? (0, (0, parcelRequire("hhfQm")).WrapperAnchor) : (0, (0, parcelRequire("hhfQm")).WrapperSpan);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            href: link,
            withoutBackground: withoutBackground,
            isSelected: isSelected,
            isInteractive: isInteractive,
            tabIndex: isInteractive ? 0 : undefined,
            "aria-label": isAnchor ? link ?? 'Link' : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onKeyPress: handleKeyPress,
            "data-testid": testId,
            className: className,
            ref: ref,
            isHovered: isHovered,
            truncateInline: truncateInline
        }, children);
    });
});
parcelRegister("hhfQm", function(module, exports) {
    $parcel$export(module.exports, "WrapperAnchor", ()=>$11180a0f0f1d6ba1$export$6e4bde711df5c2ab);
    $parcel$export(module.exports, "WrapperSpan", ()=>$11180a0f0f1d6ba1$export$8b5c95e985c4ec9a);
    var $bWGt6 = parcelRequire("bWGt6");
    const $11180a0f0f1d6ba1$var$lineHeight = 22;
    const $11180a0f0f1d6ba1$var$selectedStyles = {
        cursor: 'pointer',
        boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
        outline: 'none',
        userSelect: 'none',
        '&, :hover, :focus, :active': {
            textDecoration: 'none'
        },
        '&:hover': {
            border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
        }
    };
    const $11180a0f0f1d6ba1$var$isInteractive = ({ isInteractive: isInteractive })=>{
        if (isInteractive) return {
            ':active': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`
            },
            ':focus': $11180a0f0f1d6ba1$var$selectedStyles
        };
        return undefined;
    };
    const $11180a0f0f1d6ba1$var$isSelected = ({ isSelected: isSelected })=>{
        if (isSelected) return $11180a0f0f1d6ba1$var$selectedStyles;
        else return {
            userSelect: 'text'
        };
    };
    const $11180a0f0f1d6ba1$var$hoveredStyles = {
        borderColor: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    };
    const $11180a0f0f1d6ba1$var$activeHoveredFocusedStyles = (props)=>{
        if (props.withoutBackground) return undefined;
        return {
            textDecoration: 'none'
        };
    };
    const $11180a0f0f1d6ba1$var$hoveredWihBorderStyles = (props)=>({
            ...$11180a0f0f1d6ba1$var$hoveredStyles,
            ...$11180a0f0f1d6ba1$var$activeHoveredFocusedStyles(props)
        });
    const $11180a0f0f1d6ba1$var$baseWrapperStyles = (props)=>({
            lineHeight: `${$11180a0f0f1d6ba1$var$lineHeight}px`,
            padding: `${"var(--ds-space-025, 2px)"} 0px`,
            ...props.withoutBackground ? {
                paddingLeft: 0,
                marginLeft: "var(--ds-space-negative-025, -2px)"
            } : undefined,
            display: 'inline',
            boxDecorationBreak: 'clone',
            borderRadius: "var(--ds-border-radius-100, 4px)",
            color: `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
            ...props.withoutBackground ? undefined : {
                backgroundColor: "var(--ds-surface-raised, white)"
            },
            ...$11180a0f0f1d6ba1$var$isSelected(props),
            ...props.withoutBackground ? undefined : {
                border: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
            },
            '&:hover': $11180a0f0f1d6ba1$var$hoveredStyles,
            '&, :hover, :focus, :active': $11180a0f0f1d6ba1$var$activeHoveredFocusedStyles(props),
            transition: '0.1s all ease-in-out',
            MozUserSelect: 'none',
            ...props.isHovered ? $11180a0f0f1d6ba1$var$hoveredWihBorderStyles(props) : undefined
        });
    const $11180a0f0f1d6ba1$var$truncateStyles = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
        lineHeight: `${$11180a0f0f1d6ba1$var$lineHeight - 1}px`,
        display: '-webkit-inline-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        padding: 0,
        '@supports not (-webkit-line-clamp: 1)': {
            display: 'inline-block',
            maxHeight: `${$11180a0f0f1d6ba1$var$lineHeight}px`,
            padding: `${"var(--ds-space-025, 2px)"} 0px`
        }
    };
    const $11180a0f0f1d6ba1$var$isTruncated = ({ truncateInline: truncateInline })=>{
        if (truncateInline) return $11180a0f0f1d6ba1$var$truncateStyles;
        return undefined;
    };
    const $11180a0f0f1d6ba1$export$6e4bde711df5c2ab = (0, $bWGt6.default)("a", {
        target: "e26bri1"
    })((props)=>({
            ...$11180a0f0f1d6ba1$var$baseWrapperStyles(props),
            ...$11180a0f0f1d6ba1$var$isInteractive(props),
            ...$11180a0f0f1d6ba1$var$isTruncated(props)
        }));
    $11180a0f0f1d6ba1$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
    const $11180a0f0f1d6ba1$export$8b5c95e985c4ec9a = (0, $bWGt6.default)("span", {
        target: "e26bri0"
    })((props)=>({
            ...$11180a0f0f1d6ba1$var$baseWrapperStyles(props),
            ...$11180a0f0f1d6ba1$var$isTruncated(props)
        }));
    $11180a0f0f1d6ba1$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';
});
const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
parcelRegister("4kgag", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ij5kv")
    ]).then(()=>parcelRequire('6Of57'));
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("jNfmW", function(module, exports) {
    $parcel$export(module.exports, "smartLinkFallback", ()=>$9ef24fe69398dbc8$export$e684dcf56ac8ae14);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4yMr;
    const $9ef24fe69398dbc8$export$e684dcf56ac8ae14 = (url)=>()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: url,
                target: "_blank",
                rel: "noopener noreferrer"
            }, url);
});
parcelRegister("50H8f", function(module, exports) {
    $parcel$export(module.exports, "useKnowledgeFilterService", ()=>$2d4285338743d707$export$e7f441744c2ab3f0);
    $parcel$export(module.exports, "useKnowledgeFilterFormField", ()=>$2d4285338743d707$export$ad221c44afd5157f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bewxV;
    var $3R6Lh;
    const $2d4285338743d707$export$cac55d864f039044 = (0, $5uXOq.createContext)(null);
    const $2d4285338743d707$export$e7f441744c2ab3f0 = ()=>{
        const { siteId: siteId } = (0, (0, parcelRequire("3R6Lh")).useSiteContext)();
        const serviceContext = (0, $5uXOq.useContext)($2d4285338743d707$export$cac55d864f039044);
        const knowledgeFilterService = (0, $5uXOq.useMemo)(()=>{
            if (serviceContext) return serviceContext;
            return new (0, (0, parcelRequire("bewxV")).KnowledgeFilterServiceImpl)(siteId);
        }, [
            serviceContext,
            siteId
        ]);
        return knowledgeFilterService;
    };
    const $2d4285338743d707$export$ad221c44afd5157f = ()=>{
        const { getEntitiesByAris: getEntitiesByAris } = $2d4285338743d707$export$e7f441744c2ab3f0();
        const getKnowledgeSourcesFromFormFields = (0, $5uXOq.useCallback)((fields)=>{
            const sources = [];
            if (fields.confluenceKnowledgeEnabled) {
                let space_filter = [];
                let parent_filter = [];
                if (fields.confluenceFilterScope?.value === 'pages') fields.confluenceAncestorPageFilters?.forEach((filter)=>{
                    parent_filter.push(filter.ari);
                });
                else if (fields.confluenceFilterScope?.value === 'spaces') fields.confluenceSpaceFilters?.forEach((filter)=>{
                    space_filter.push(filter.ari);
                });
                sources.push({
                    enabled: true,
                    source: 'confluence',
                    configuration: {
                        parent_filter: parent_filter,
                        space_filter: space_filter
                    }
                });
            }
            if (fields.jiraKnowledgeEnabled) sources.push({
                enabled: true,
                source: 'jira',
                configuration: {
                    project_filter: fields.jiraProjectFilters?.map((filter)=>filter.ari) ?? []
                }
            });
            if (fields.atlasKnowledgeEnabled) sources.push({
                enabled: true,
                source: 'atlas',
                configuration: undefined
            });
            if (fields.googleDriveKnowledgeEnabled) sources.push({
                enabled: true,
                source: 'google_drive',
                configuration: undefined
            });
            if (fields.microsoftSharePointKnowledgeEnabled) sources.push({
                enabled: true,
                source: 'microsoft_sharepoint',
                configuration: undefined
            });
            if (fields.slackKnowledgeEnabled) sources.push({
                enabled: true,
                source: 'slack',
                configuration: undefined
            });
            return {
                enabled: fields.knowledgeScope,
                sources: sources
            };
        }, []);
        const getKnowledgeSourceFieldsFromScaffold = (0, $5uXOq.useCallback)(async (agent)=>{
            let config = {
                knowledgeScope: false
            };
            if (!agent.knowledge_sources?.enabled) return config;
            config.knowledgeScope = true;
            const filterPromises = [];
            for (const { source: source, configuration: knowledgeConfig, enabled: enabled } of agent.knowledge_sources.sources)switch(source){
                case 'confluence':
                    config.confluenceKnowledgeEnabled = enabled;
                    if (knowledgeConfig.parent_filter.length) filterPromises.push(getEntitiesByAris({
                        aris: knowledgeConfig.parent_filter
                    }).then((filters)=>{
                        config.confluenceAncestorPageFilters = filters.map((page)=>({
                                ari: page.ari,
                                label: page.displayName,
                                value: page.ari,
                                url: page.url
                            }));
                        config.confluenceFilterScope = {
                            label: '',
                            value: 'pages'
                        };
                    }));
                    if (knowledgeConfig.space_filter.length) filterPromises.push(getEntitiesByAris({
                        aris: knowledgeConfig.space_filter
                    }).then((filters)=>{
                        config.confluenceSpaceFilters = filters.map((page)=>({
                                ari: page.ari,
                                label: page.displayName,
                                value: page.ari,
                                iconUrl: page.iconUrl,
                                url: page.url
                            }));
                        config.confluenceFilterScope = {
                            label: '',
                            value: 'spaces'
                        };
                    }));
                    break;
                case 'jira':
                    config.jiraKnowledgeEnabled = enabled;
                    filterPromises.push(getEntitiesByAris({
                        aris: knowledgeConfig.project_filter
                    }).then((filters)=>{
                        config.jiraProjectFilters = filters.map((page)=>({
                                ari: page.ari,
                                label: page.displayName,
                                value: page.ari,
                                iconUrl: page.iconUrl,
                                url: page.url
                            }));
                    }));
                    break;
                case 'atlas':
                    config.atlasKnowledgeEnabled = enabled;
                    break;
                case 'google_drive':
                    config.googleDriveKnowledgeEnabled = enabled;
                    break;
                case 'microsoft_sharepoint':
                    config.microsoftSharePointKnowledgeEnabled = enabled;
                    break;
                case 'slack':
                    config.slackKnowledgeEnabled = enabled;
                    break;
            }
            await Promise.all(filterPromises);
            return config;
        }, [
            getEntitiesByAris
        ]);
        return {
            getKnowledgeSourcesFromFormFields: getKnowledgeSourcesFromFormFields,
            getKnowledgeSourceFieldsFromScaffold: getKnowledgeSourceFieldsFromScaffold
        };
    };
});
parcelRegister("bewxV", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeFilterServiceImpl", ()=>$bd46e17b0573787c$export$a0684b2b2bbfab69);
    var $3kN8f;
    var $RMYZT;
    function $bd46e17b0573787c$var$notEmpty(value) {
        return value !== null && value !== undefined;
    }
    class $bd46e17b0573787c$export$a0684b2b2bbfab69 {
        constructor(siteId){
            this.siteId = siteId;
            this.entityTypeToAti = (type)=>{
                switch(type){
                    case 'space':
                        return 'ati:cloud:confluence:space';
                    case 'page':
                        return 'ati:cloud:confluence:page';
                    case 'project':
                        return 'ati:cloud:jira:project';
                }
            };
            this.filterResults = async ({ query: query, entityType: entityType, confluenceSpaces: confluenceSpaces = [] })=>{
                const result = await (0, (0, parcelRequire("RMYZT")).fetchAgg)({
                    graphQuery: (0, $f354927440a471b9$export$4bc63ef50ec3954e),
                    siteId: this.siteId,
                    variables: {
                        query: query,
                        entityAti: this.entityTypeToAti(entityType),
                        confluenceSpaces: confluenceSpaces
                    }
                });
                return result.data.search.search.edges?.map((edge)=>edge.node).map((item)=>({
                        ari: item.ari,
                        displayName: item.displayName,
                        iconUrl: item.iconUrl,
                        spaceKey: item.spaceKey,
                        url: item.url
                    }));
            };
            this.getEntitiesByAris = async (options)=>{
                let entities = {
                    space: {
                        responseMapper: (response)=>response?.data?.confluence?.spaces?.filter($bd46e17b0573787c$var$notEmpty).map((space)=>({
                                    ...space,
                                    url: space.links.base + space.links.webUi,
                                    iconUrl: space.iconUrl.path
                                })) ?? [],
                        aris: [],
                        graphQuery: (0, $f354927440a471b9$export$21da0c227e4ca0b8)
                    },
                    page: {
                        responseMapper: (response)=>response?.data?.confluence?.pages?.filter($bd46e17b0573787c$var$notEmpty).map((page)=>({
                                    ...page,
                                    url: page.links.base + page.links.webUi
                                })) ?? [],
                        aris: [],
                        graphQuery: (0, $f354927440a471b9$export$a970d24119afd9d2)
                    },
                    project: {
                        responseMapper: (response)=>response?.data?.jira?.jiraProjects?.filter($bd46e17b0573787c$var$notEmpty).map((project)=>({
                                    ...project,
                                    iconUrl: project.iconUrl.small
                                })) ?? [],
                        aris: [],
                        graphQuery: (0, $f354927440a471b9$export$46cf0e4af88c5342)
                    }
                };
                for (const ari of options.aris)try {
                    const resourceType = ari.split(/[:\/]/)[4];
                    if (entities[resourceType]) entities[resourceType].aris.push(ari);
                } catch (error) {}
                const aggPromises = [];
                for (const { aris: aris, graphQuery: graphQuery, responseMapper: responseMapper } of Object.values(entities))if (aris.length) aggPromises.push((0, (0, parcelRequire("RMYZT")).fetchAgg)({
                    graphQuery: graphQuery,
                    variables: {
                        aris: aris
                    }
                }).then((result)=>{
                    return responseMapper(result).map((item)=>({
                            ari: item.ari,
                            displayName: item.displayName,
                            iconUrl: item.iconUrl,
                            spaceKey: item.spaceKey,
                            url: item.url
                        }));
                }));
                const results = await Promise.all(aggPromises).catch((error)=>{
                    (0, (0, parcelRequire("3kN8f")).logException)({
                        exception: error,
                        name: 'KnowledgeFilterService.getEntitiesByAris'
                    });
                    return [];
                });
                return results.flat();
            };
        }
    }
});
parcelRegister("RMYZT", function(module, exports) {
    $parcel$export(module.exports, "fetchAgg", ()=>$ec3ff2ac22aaa523$export$f49dad89491f6bf2);
    var $lyFsp;
    const $ec3ff2ac22aaa523$export$f49dad89491f6bf2 = async ({ siteId: siteId, graphQuery: graphQuery, variables: variables })=>{
        const response = await (0, (0, parcelRequire("lyFsp")).performGqlFetch)({
            gqlQuery: graphQuery,
            variables: {
                siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
                ...variables
            }
        });
        return response;
    };
});
parcelRegister("lyFsp", function(module, exports) {
    $parcel$export(module.exports, "performGqlFetch", ()=>$ab52746bc71cce73$export$f602b5befecb0b84);
    var $5uriq;
    const $ab52746bc71cce73$var$extractQueryName = (gqlQuery)=>{
        const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
        return operationMatch ? operationMatch[1] : null;
    };
    const $ab52746bc71cce73$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables })=>{
        try {
            const response = await fetch('/gateway/api/graphql', {
                headers: {
                    'Content-Type': 'application/json',
                    ...headerOptions
                },
                method: 'POST',
                body: JSON.stringify({
                    query: gqlQuery,
                    variables: variables
                })
            });
            const json = await response.json();
            if (json?.errors?.length) await $ab52746bc71cce73$var$processGqlErrorResponse({
                errors: json.errors,
                gqlQuery: gqlQuery
            });
            return json;
        } catch (err) {
            throw new (0, (0, parcelRequire("5uriq")).FetchError)('GraphQL query failed', {
                cause: err
            });
        }
    };
    class $ab52746bc71cce73$export$ba203f24e0131ba7 extends Error {
        constructor(message, { errors: errors, queryName: queryName }){
            super(message);
            this.name = 'GraphQLError';
            this.errors = errors;
            this.queryName = queryName;
        }
    }
    const $ab52746bc71cce73$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
        const errorsToThrow = [];
        errors.forEach((error)=>{
            errorsToThrow.push({
                message: error.message,
                status_code: error.extensions.statusCode,
                classification: error.extensions.classification
            });
        });
        throw new $ab52746bc71cce73$export$ba203f24e0131ba7('GraphQL API error', {
            errors: errorsToThrow,
            queryName: $ab52746bc71cce73$var$extractQueryName(gqlQuery)
        });
    };
});
parcelRegister("5uriq", function(module, exports) {
    $parcel$export(module.exports, "FetchError", ()=>$83a711147490cc54$export$26e841bcf1aeb894);
    class $83a711147490cc54$export$26e841bcf1aeb894 extends Error {
        constructor(message, cause){
            super(message), this.cause = cause;
            this.name = 'FetchError';
            if (cause) this.cause = cause;
        }
    }
});
const $f354927440a471b9$export$4bc63ef50ec3954e = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				}
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;
const $f354927440a471b9$export$46cf0e4af88c5342 = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;
const $f354927440a471b9$export$a970d24119afd9d2 = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;
const $f354927440a471b9$export$21da0c227e4ca0b8 = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;
parcelRegister("3R6Lh", function(module, exports) {
    $parcel$export(module.exports, "SiteContext", ()=>$6673bdb2d1c96344$export$2cab3982d83485b0);
    $parcel$export(module.exports, "useSiteContext", ()=>$6673bdb2d1c96344$export$55c0e3cb4fbc46cf);
    var $5uXOq = parcelRequire("5uXOq");
    const $6673bdb2d1c96344$export$2cab3982d83485b0 = (0, $5uXOq.createContext)({
        siteId: ''
    });
    const $6673bdb2d1c96344$export$55c0e3cb4fbc46cf = ()=>{
        const context = (0, $5uXOq.useContext)($6673bdb2d1c96344$export$2cab3982d83485b0);
        return context;
    };
});
parcelRegister("itLPw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4138289d1077b191$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4138289d1077b191$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noKnowledgeAdded: {
            id: 'rovo-chat.view-agent.no-knowledge-added',
            defaultMessage: 'No custom knowledge sources',
            description: 'Message displayed when no knowledge is added to the Agent'
        },
        forgeKnowledgeDescription: {
            id: 'rovo-chat.view-agent.hidden-knowledge-description',
            defaultMessage: "Forge Agents built with code don't use typical knowledge sources",
            description: 'Description of the knowledge section, this is displayed when knowledge is purposely hidden'
        }
    });
});
parcelRegister("dQjNg", function(module, exports) {
    $parcel$export(module.exports, "getAAIDFromARI", ()=>$09d02c91f15af39c$export$3761e66a04602cbd);
    $parcel$export(module.exports, "getARIFromAAID", ()=>$09d02c91f15af39c$export$acf3e1bcf222b00d);
    $parcel$export(module.exports, "AgentCreatedBy", ()=>$09d02c91f15af39c$export$1565ea9a9fb7ad67);
    $parcel$export(module.exports, "useProfileResolution", ()=>$09d02c91f15af39c$export$5d980898591175e);
    $parcel$export(module.exports, "filterAndSortAgents", ()=>$09d02c91f15af39c$export$13d60404a0dddebd);
    $parcel$export(module.exports, "getEnabledKnowlegeArisFromAgent", ()=>$09d02c91f15af39c$export$a6e36c224ec3c0cb);
    $parcel$export(module.exports, "getSuggestedOotbAgents", ()=>$09d02c91f15af39c$export$6d876204c5d593ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $23aI7;
    var $8dw1i;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    parcelRequire("26CR2");
    var $264zF = parcelRequire("264zF");
    var $1DVhQ;
    var $4ojTZ;
    var $8G7CX;
    var $3xYdY;
    var $gBv35;
    var $3go6U;
    const $09d02c91f15af39c$export$3761e66a04602cbd = (ari)=>{
        const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
        return matched ? matched[1] : undefined;
    };
    const $09d02c91f15af39c$export$acf3e1bcf222b00d = (aaid)=>{
        return `ari:cloud:identity::user/${aaid}`;
    };
    const $09d02c91f15af39c$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
        if ((0, (0, parcelRequire("8G7CX")).isCustomerAgent)(agent)) {
            const aaid = agent.creator ? $09d02c91f15af39c$export$3761e66a04602cbd(agent.creator) : undefined;
            if (!aaid) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($09d02c91f15af39c$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified
            });
        }
        if ((0, (0, parcelRequire("8G7CX")).isSystemAgent)(agent) || !agent.creator) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("23aI7"))))), {
            primaryColor: "var(--ds-icon-brand, #0C66E4)",
            label: "Atlassian"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "Atlassian"));
        if ((0, (0, parcelRequire("8G7CX")).isForgeAgent)(agent)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, agent.creator);
        return null;
    };
    const $09d02c91f15af39c$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
        (0, (0, parcelRequire("gKZoD")).di)($09d02c91f15af39c$export$5d980898591175e);
        const { profile: profile, client: client } = $09d02c91f15af39c$export$5d980898591175e(userId, siteId);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, (0, parcelRequire("3go6U")).default).deactivatedCreatorName, {
            name: profile.data.fullName
        }) : profile.data?.fullName;
        if (profile.isFetching || !profile.data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            height: 18,
            width: 100,
            borderRadius: 3
        });
        if (simplified) return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: `/people/${userId}`,
            target: "_blank"
        }, fullName);
        return profileCard ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $264zF.default), {
            userId: userId,
            resourceClient: client,
            ariaLabel: fullName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dw1i")).default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dw1i")).default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        });
    };
    function $09d02c91f15af39c$export$5d980898591175e(userId, siteId, shouldFetch = true) {
        const profileClient = (0, (0, parcelRequire("gBv35")).useProfileClient)();
        const profile = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'fetchProfile',
                siteId,
                userId
            ],
            queryFn: async ()=>{
                try {
                    const response = await profileClient.getProfile(siteId, userId);
                    return response;
                } catch (error) {
                    return {};
                }
            },
            enabled: shouldFetch
        });
        return {
            profile: profile,
            client: profileClient
        };
    }
    const $09d02c91f15af39c$export$13d60404a0dddebd = (agents, filters)=>{
        return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
    };
    const $09d02c91f15af39c$export$a6e36c224ec3c0cb = (agent)=>{
        if (!agent.knowledge_sources?.enabled) return [];
        return agent.knowledge_sources.sources.filter((source)=>source.enabled).reduce((acc, source)=>{
            switch(source.source){
                case 'confluence':
                    acc.push(...source.configuration?.parent_filter ?? []);
                    acc.push(...source.configuration?.space_filter ?? []);
                    break;
                case 'jira':
                    acc.push(...source.configuration?.project_filter ?? []);
                    break;
            }
            return acc;
        }, []);
    };
    const $09d02c91f15af39c$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
        const defaultAgentsNamedIds = product && (0, (0, parcelRequire("VSDnB")).fg)('rovo_enable_ootb_favourited_agents') ? (0, (0, parcelRequire("3xYdY")).DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, (0, parcelRequire("3xYdY")).DEFAULT_AGENTS_NAMED_ID_LIST) : (0, (0, parcelRequire("3xYdY")).DEFAULT_AGENTS_NAMED_ID_LIST);
        const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
        return defaultAgents;
    };
});
parcelRegister("8dw1i", function(module, exports) {
    $parcel$export(module.exports, "UNKNOWN_USER_ID", ()=>$359ac0149aaccbc2$export$af8124aa496797f2);
    $parcel$export(module.exports, "default", ()=>$359ac0149aaccbc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhVLw;
    var $kbF2s;
    var $ab8uA;
    var $k3AGD;
    var $cqJWb;
    var $4kfbr;
    var $cb25w;
    var $jZA09;
    var $j6B3T;
    var $bTspB;
    const $359ac0149aaccbc2$export$7452d7062a4d0634 = 1000;
    const $359ac0149aaccbc2$export$af8124aa496797f2 = '_|unknown|_';
    class $359ac0149aaccbc2$export$92ab8442e7a15cef extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        constructor(props){
            super(props), this.handleOnClick = (e)=>{
                const { id: id, text: text, onClick: onClick } = this.props;
                if (onClick) onClick(id, text, e);
            }, this.handleOnMouseEnter = (e)=>{
                const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
                if (onMouseEnter) onMouseEnter(id, text, e);
                this.hoverTimeout = window.setTimeout(()=>{
                    if (onHover) onHover();
                    this.hoverTimeout = undefined;
                }, $359ac0149aaccbc2$export$7452d7062a4d0634);
            }, this.handleOnMouseLeave = (e)=>{
                const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
                if (onMouseLeave) onMouseLeave(id, text, e);
                if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            }, this.getMentionType = ()=>{
                const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
                if (isHighlighted) return (0, (0, parcelRequire("cqJWb")).MentionType).SELF;
                if ((0, (0, parcelRequire("cqJWb")).isRestricted)(accessLevel)) return (0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED;
                return (0, (0, parcelRequire("cqJWb")).MentionType).DEFAULT;
            };
            (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(props.id).start();
        }
        componentDidMount() {
            (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(this.props.id).success();
        }
        componentWillUnmount() {
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            const ufoInstance = (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(this.props.id);
            if ([
                (0, (0, parcelRequire("jZA09")).UFOExperienceState)['STARTED'],
                (0, (0, parcelRequire("jZA09")).UFOExperienceState)['IN_PROGRESS']
            ].includes(ufoInstance.state)) ufoInstance.abort();
        }
        renderUnknownUserError(id) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6B3T")).UnknownUserError), {
                values: {
                    userId: id.slice(-5)
                }
            }, (message)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `@${message}`));
        }
        render() {
            const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
            const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
            const mentionType = this.getMentionType();
            const failedMention = text === `@${$359ac0149aaccbc2$export$af8124aa496797f2}`;
            const mentionComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab8uA")).default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false
            }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTspB")).UfoErrorBoundary), {
                id: id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kbF2s")).default), null, mentionType === (0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: mentionComponent
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3AGD")).default), {
                name: text
            }, mentionComponent)) : mentionComponent)));
        }
    }
    const $359ac0149aaccbc2$var$MentionWithAnalytics = (0, (0, parcelRequire("cb25w")).default)({
        onClick: (createEvent, props)=>{
            const { id: id, text: text, accessLevel: accessLevel } = props;
            const event = (0, (0, parcelRequire("4kfbr")).fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
            return event;
        },
        onHover: (createEvent, props)=>{
            const { id: id, text: text, accessLevel: accessLevel } = props;
            const event = (0, (0, parcelRequire("4kfbr")).fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
            return event;
        }
    })($359ac0149aaccbc2$export$92ab8442e7a15cef);
    const $359ac0149aaccbc2$var$Mention = $359ac0149aaccbc2$var$MentionWithAnalytics;
    var $359ac0149aaccbc2$export$2e2bcd8739ae039 = $359ac0149aaccbc2$var$Mention;
});
parcelRegister("kbF2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2323b0dd270b712$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $j6B3T;
    const $a2323b0dd270b712$var$EMPTY = {};
    const $a2323b0dd270b712$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($a2323b0dd270b712$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($a2323b0dd270b712$var$EMPTY);
            (0, (0, parcelRequire("j6B3T")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $a2323b0dd270b712$var$MessagesIntlProvider = (props)=>{
        const { children: children } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const messages = $a2323b0dd270b712$var$useI18n(intl.locale);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...intl,
            messages: messages
        }, children);
    };
    var $a2323b0dd270b712$export$2e2bcd8739ae039 = $a2323b0dd270b712$var$MessagesIntlProvider;
});
parcelRegister("j6B3T", function(module, exports) {
    $parcel$export(module.exports, "UnknownUserError", ()=>$2ed9ffbf75c73a6c$export$98e06fe7a6174253);
    $parcel$export(module.exports, "NoAccessWarning", ()=>$2ed9ffbf75c73a6c$export$58bd5a2057b6b855);
    $parcel$export(module.exports, "NoAccessLabel", ()=>$2ed9ffbf75c73a6c$export$da9f8ce14593162f);
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$2ed9ffbf75c73a6c$export$d0a3169680473b6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $8aQI9;
    const $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const message = formatMessage(messageDescriptor, values);
            if (typeof children === 'function') return children(message);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                values: values,
                ...messageDescriptor
            });
        };
    const $2ed9ffbf75c73a6c$export$98e06fe7a6174253 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).unknownUserError);
    const $2ed9ffbf75c73a6c$export$58bd5a2057b6b855 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).noAccessWarning);
    const $2ed9ffbf75c73a6c$export$da9f8ce14593162f = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).noAccessLabel);
    const $2ed9ffbf75c73a6c$export$4a258ffee7316766 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).defaultHeadline);
    const $2ed9ffbf75c73a6c$export$702321a50d74536e = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).defaultAdvisedAction);
    const $2ed9ffbf75c73a6c$export$ed7f16088a93ae9d = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).loginAgain);
    const $2ed9ffbf75c73a6c$export$3ab158df56460d1c = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).differentText);
    const $2ed9ffbf75c73a6c$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("jnKJ1")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("8SJKQ")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("hYoQy")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("2bcHM")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("4j0ky")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("7RC8J")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("gvMUc")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("hk7Jz")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("aYEpz")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("5gawx")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("1RH6c")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("lfLU3")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("6NuWr")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("1pAlF")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("eEv2y")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("cwLXs")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("2NHoQ")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("kZTyH")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("eUKy5")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("lmwJp")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("1UGd3")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("63ikG")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("hgg7A")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("2P9BM")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("fliA1")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("5N21C")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("lM2PH")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("MMGBa")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("4GoCd")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("jsQ53")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $2ed9ffbf75c73a6c$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("2bcHM")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("8aQI9", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6ca607c1e1522de5$export$defe85febe8b728c);
    var $7VHMR;
    const $6ca607c1e1522de5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unknownUserError: {
            id: 'fabric.mention.unknow.user.error',
            defaultMessage: 'Unknown user {userId}',
            description: 'Mention user name could not be found or look up failed'
        },
        noAccessWarning: {
            id: 'fabric.mention.noAccess.warning',
            defaultMessage: "{name} won't be notified as they have no access",
            description: "Warning message to show that the mentioned user won't be notified"
        },
        noAccessLabel: {
            id: 'fabric.mention.noAccess.label',
            defaultMessage: 'No access',
            description: 'Label for no access icon'
        },
        defaultHeadline: {
            id: 'fabric.mention.error.defaultHeadline',
            defaultMessage: 'Something went wrong',
            description: 'Error message shown when there is an error communicating with backend'
        },
        defaultAdvisedAction: {
            id: 'fabric.mention.error.defaultAction',
            defaultMessage: 'Try again in a few seconds',
            description: 'Default advised action when an error occurs'
        },
        loginAgain: {
            id: 'fabric.mention.error.loginAgain',
            defaultMessage: 'Try logging out then in again',
            description: 'Login again message when there is an authentication error occurs'
        },
        differentText: {
            id: 'fabric.mention.error.differentText',
            defaultMessage: 'Try entering different text',
            description: 'Enter different text message when a forbidden error occurs'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.mentions.team.member.count',
            defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.mentions.team.member.count.including.you',
            defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.mentions.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.mentions.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        }
    });
});
parcelRegister("jnKJ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsDeQ").then(()=>parcelRequire('dTLgY'));
});
parcelRegister("8SJKQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6dIE2").then(()=>parcelRequire('keyh3'));
});
parcelRegister("hYoQy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jYcAq").then(()=>parcelRequire('eL3iu'));
});
parcelRegister("2bcHM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6MuqU").then(()=>parcelRequire('wBhQ2'));
});
parcelRegister("4j0ky", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l8igA").then(()=>parcelRequire('27EyS'));
});
parcelRegister("7RC8J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cp1kc").then(()=>parcelRequire('eoxiv'));
});
parcelRegister("gvMUc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("tBMef").then(()=>parcelRequire('6jEIT'));
});
parcelRegister("hk7Jz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e4cqm").then(()=>parcelRequire('dkMw7'));
});
parcelRegister("aYEpz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("yHeUA").then(()=>parcelRequire('5NjhV'));
});
parcelRegister("5gawx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("69FtF").then(()=>parcelRequire('bWMX4'));
});
parcelRegister("1RH6c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1SwVQ").then(()=>parcelRequire('aPy43'));
});
parcelRegister("lfLU3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iMqxw").then(()=>parcelRequire('6FrOe'));
});
parcelRegister("6NuWr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("i9sdu").then(()=>parcelRequire('epfvh'));
});
parcelRegister("1pAlF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aydQg").then(()=>parcelRequire('hjvLU'));
});
parcelRegister("eEv2y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5znUH").then(()=>parcelRequire('dclct'));
});
parcelRegister("cwLXs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1lvxw").then(()=>parcelRequire('56DDk'));
});
parcelRegister("2NHoQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7yQmI").then(()=>parcelRequire('1Vmnr'));
});
parcelRegister("kZTyH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6TpZW").then(()=>parcelRequire('lTYFq'));
});
parcelRegister("eUKy5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2eSUb").then(()=>parcelRequire('hxNc0'));
});
parcelRegister("lmwJp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fUluO").then(()=>parcelRequire('h7PMN'));
});
parcelRegister("1UGd3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("DchKe").then(()=>parcelRequire('3T3Pt'));
});
parcelRegister("63ikG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eYBMi").then(()=>parcelRequire('jvE81'));
});
parcelRegister("hgg7A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6q2et").then(()=>parcelRequire('lxjSE'));
});
parcelRegister("2P9BM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iINAq").then(()=>parcelRequire('fIX00'));
});
parcelRegister("fliA1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ibfKG").then(()=>parcelRequire('kbvg1'));
});
parcelRegister("5N21C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("80oK6").then(()=>parcelRequire('2eUU2'));
});
parcelRegister("lM2PH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9X4yo").then(()=>parcelRequire('kxF7S'));
});
parcelRegister("MMGBa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hYMIE").then(()=>parcelRequire('aIfZT'));
});
parcelRegister("4GoCd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cjVNf").then(()=>parcelRequire('lVs4z'));
});
parcelRegister("jsQ53", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("16rPB").then(()=>parcelRequire('bY3rp'));
});
parcelRegister("ab8uA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6273a4608d138fff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $cqJWb;
    var $5uXOq = parcelRequire("5uXOq");
    const $6273a4608d138fff$var$mentionStyle = {
        [(0, (0, parcelRequire("cqJWb")).MentionType).SELF]: {
            background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            borderColor: 'transparent',
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        [(0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED]: {
            background: 'transparent',
            borderColor: `var(--ds-border-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            text: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            hoveredBackground: 'transparent',
            pressedBackground: 'transparent'
        },
        [(0, (0, parcelRequire("cqJWb")).MentionType).DEFAULT]: {
            background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            borderColor: 'transparent',
            text: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        }
    };
    const $6273a4608d138fff$var$getStyle = ({ mentionType: mentionType }, property)=>{
        const obj = $6273a4608d138fff$var$mentionStyle[mentionType][property];
        return typeof obj === 'string' ? obj : obj;
    };
    const $6273a4608d138fff$var$PrimitiveMention = (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ref: ref,
            css: (0, (0, parcelRequire("f8Sb3")).css)("display:inline;border:1px solid ", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'borderColor'), ";background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'background'), ";color:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:normal;word-break:break-word;&:hover{background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'hoveredBackground'), ";}&:active{background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'pressedBackground'), ";}"),
            ...other
        });
    });
    var $6273a4608d138fff$export$2e2bcd8739ae039 = $6273a4608d138fff$var$PrimitiveMention;
});
parcelRegister("cqJWb", function(module, exports) {
    $parcel$export(module.exports, "MentionType", ()=>$90ca79fb430b6e09$export$2102863a3c660c6b);
    $parcel$export(module.exports, "UserAccessLevel", ()=>$90ca79fb430b6e09$export$81124e6148ca5db0);
    $parcel$export(module.exports, "UserType", ()=>$90ca79fb430b6e09$export$8436e53e45ffe15b);
    $parcel$export(module.exports, "SliNames", ()=>$90ca79fb430b6e09$export$7afb0727c7d7e8af);
    $parcel$export(module.exports, "ComponentNames", ()=>$90ca79fb430b6e09$export$5c42d9dea6d035c1);
    $parcel$export(module.exports, "Actions", ()=>$90ca79fb430b6e09$export$b52183d5cfb26dc9);
    $parcel$export(module.exports, "MentionNameStatus", ()=>$90ca79fb430b6e09$export$b8fa67dc54502853);
    $parcel$export(module.exports, "isRestricted", ()=>$90ca79fb430b6e09$export$dbaa15dc1820b89a);
    $parcel$export(module.exports, "isSpecialMention", ()=>$90ca79fb430b6e09$export$37b8dcac6198c514);
    $parcel$export(module.exports, "isAppMention", ()=>$90ca79fb430b6e09$export$eb590c844d13454c);
    $parcel$export(module.exports, "isTeamMention", ()=>$90ca79fb430b6e09$export$803b1379348dbfd5);
    $parcel$export(module.exports, "isSpecialMentionText", ()=>$90ca79fb430b6e09$export$d13d4f976b36a397);
    $parcel$export(module.exports, "isPromise", ()=>$90ca79fb430b6e09$export$4369c812aac99591);
    var $90ca79fb430b6e09$export$2102863a3c660c6b;
    (function(MentionType) {
        MentionType[MentionType["SELF"] = 0] = "SELF";
        MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
        MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    })($90ca79fb430b6e09$export$2102863a3c660c6b || ($90ca79fb430b6e09$export$2102863a3c660c6b = {}));
    var $90ca79fb430b6e09$export$81124e6148ca5db0;
    (function(UserAccessLevel) {
        UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
        UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
        UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
        UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    })($90ca79fb430b6e09$export$81124e6148ca5db0 || ($90ca79fb430b6e09$export$81124e6148ca5db0 = {}));
    var $90ca79fb430b6e09$export$8436e53e45ffe15b;
    (function(UserType) {
        UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
        UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
        UserType[UserType["APP"] = 2] = "APP";
        UserType[UserType["TEAM"] = 3] = "TEAM";
        UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    })($90ca79fb430b6e09$export$8436e53e45ffe15b || ($90ca79fb430b6e09$export$8436e53e45ffe15b = {}));
    var $90ca79fb430b6e09$export$7afb0727c7d7e8af;
    (function(SliNames) {
        SliNames["SEARCH"] = "searchUser";
        SliNames["SEARCH_TEAM"] = "searchTeam";
        SliNames["INITIAL_STATE"] = "initialState";
        SliNames["SELECT"] = "select";
        SliNames["SELECT_TEAM"] = "selectTeam";
    })($90ca79fb430b6e09$export$7afb0727c7d7e8af || ($90ca79fb430b6e09$export$7afb0727c7d7e8af = {}));
    var $90ca79fb430b6e09$export$5c42d9dea6d035c1;
    (function(ComponentNames) {
        ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
        ComponentNames["MENTION"] = "mention";
    })($90ca79fb430b6e09$export$5c42d9dea6d035c1 || ($90ca79fb430b6e09$export$5c42d9dea6d035c1 = {}));
    var $90ca79fb430b6e09$export$b52183d5cfb26dc9;
    (function(Actions) {
        Actions["VIEWED"] = "viewed";
        Actions["CLICKED"] = "clicked";
        Actions["CLOSED"] = "closed";
        Actions["SUCCEEDED"] = "succeeded";
        Actions["FAILED"] = "failed";
    })($90ca79fb430b6e09$export$b52183d5cfb26dc9 || ($90ca79fb430b6e09$export$b52183d5cfb26dc9 = {}));
    var $90ca79fb430b6e09$export$b8fa67dc54502853;
    (function(MentionNameStatus) {
        MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
        MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
        MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    })($90ca79fb430b6e09$export$b8fa67dc54502853 || ($90ca79fb430b6e09$export$b8fa67dc54502853 = {}));
    function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
        return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
    }
    function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
        return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
    }
    function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
        return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
    }
    function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
        return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
    }
    function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
        return mentionText && (mentionText === '@all' || mentionText === '@here');
    }
    const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);
});
parcelRegister("k3AGD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4938be5a70d0163$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $e4938be5a70d0163$var$AsyncNoAccessTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("22G24")).then((module)=>{
            return {
                default: module.NoAccessTooltip
            };
        }));
    var $e4938be5a70d0163$export$2e2bcd8739ae039 = $e4938be5a70d0163$var$AsyncNoAccessTooltip;
});
parcelRegister("22G24", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8n8M3").then(()=>parcelRequire('4YERU'));
});
parcelRegister("4kfbr", function(module, exports) {
    $parcel$export(module.exports, "SLI_EVENT_TYPE", ()=>$f8976e2813fe24b2$export$245097525aef1262);
    $parcel$export(module.exports, "SMART_EVENT_TYPE", ()=>$f8976e2813fe24b2$export$c724588856bbfbcf);
    $parcel$export(module.exports, "fireAnalyticsMentionEvent", ()=>$f8976e2813fe24b2$export$44902bc7b3f0b09f);
    $parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", ()=>$f8976e2813fe24b2$export$91b2fa6a0fe06408);
    var $cqJWb;
    const $f8976e2813fe24b2$var$packageName = "platform-pkg";
    const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
    const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
    const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
    const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = {
                    action: action,
                    actionSubject: (0, (0, parcelRequire("cqJWb")).ComponentNames).TYPEAHEAD,
                    attributes: {
                        packageName: $f8976e2813fe24b2$var$packageName,
                        packageVersion: $f8976e2813fe24b2$var$packageVersion,
                        componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                        duration: Math.round(duration),
                        userIds: userIds,
                        queryLength: query ? query.length : 0
                    },
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
                };
                const analyticsEvent = props.createAnalyticsEvent(eventPayload);
                analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
            const payload = {
                action: action,
                actionSubject: actionSubject,
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                    accessLevel: accessLevel,
                    isSpecial: (0, (0, parcelRequire("cqJWb")).isSpecialMentionText)(text),
                    userId: id
                }
            };
            const event = createEvent(payload);
            event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            return event;
        };
    const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
                props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
        const eventPayload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                ...attributes
            }
        };
        return eventPayload;
    };
    const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = {
                    action: action,
                    actionSubject: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                    actionSubjectId: 'hydration',
                    attributes: {
                        packageName: $f8976e2813fe24b2$var$packageName,
                        packageVersion: $f8976e2813fe24b2$var$packageVersion,
                        componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                        userId: userId,
                        fromCache: fromCache,
                        duration: Math.round(duration)
                    },
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
                };
                const analyticsEvent = props.createAnalyticsEvent(eventPayload);
                analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
    const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
            if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
                accessLevel: accessLevel,
                isSpecial: (0, (0, parcelRequire("cqJWb")).isSpecialMentionText)(text)
            });
        };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';
parcelRegister("bTspB", function(module, exports) {
    $parcel$export(module.exports, "mentionRenderedUfoExperience", ()=>$fb9391c5736559e1$export$1d011e4240507c78);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$fb9391c5736559e1$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    const $fb9391c5736559e1$export$1d011e4240507c78 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('mention-rendered', {
        platform: {
            component: 'mention'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    class $fb9391c5736559e1$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            $fb9391c5736559e1$export$1d011e4240507c78.getInstance(this.props.id).failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("26CR2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b61766090747c00e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "withOuterListeners", ()=>(parcelRequire("iMLpJ")).default);
    $parcel$export(module.exports, "TeamProfileCard", ()=>(parcelRequire("AF8aN")).default);
    $parcel$export(module.exports, "ProfileCardTrigger", ()=>(parcelRequire("264zF")).default);
    $parcel$export(module.exports, "ProfileClient", ()=>(parcelRequire("bp5g1")).default);
    $parcel$export(module.exports, "UserProfileClient", ()=>(parcelRequire("dFLsP")).default);
    $parcel$export(module.exports, "DELAY_MS_SHOW", ()=>$e41878b3b8cab0db$export$5b956b542f1bc1b3);
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>(parcelRequire("5uVl7")).AgentProfileCardTrigger);
    var $bp5g1 = parcelRequire("bp5g1");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    var $9gV7o = parcelRequire("9gV7o");
    var $6uTwi = parcelRequire("6uTwi");
    var $lrMir = parcelRequire("lrMir");
    var $d4FHw = parcelRequire("d4FHw");
    var $264zF = parcelRequire("264zF");
    var $iMLpJ = parcelRequire("iMLpJ");
    var $AF8aN = parcelRequire("AF8aN");
    var $5uVl7 = parcelRequire("5uVl7");
    var $kDbj5 = parcelRequire("kDbj5");
    var $b61766090747c00e$export$2e2bcd8739ae039 = (0, $d4FHw.default);
});
parcelRegister("9gV7o", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$f7de3dc4d7bc51ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $8S93R;
    var $5OOAU;
    var $77Oft;
    var $fygPX;
    var $ivXTE = parcelRequire("ivXTE");
    var $8qsT1 = parcelRequire("8qsT1");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $aRdJp = parcelRequire("aRdJp");
    var $a3FJs = parcelRequire("a3FJs");
    var $h9eXl = parcelRequire("h9eXl");
    var $37c0Y = parcelRequire("37c0Y");
    var $dlHyi = parcelRequire("dlHyi");
    const $f7de3dc4d7bc51ad$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlockStart: 'space.400',
        paddingInline: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$avatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.300',
        left: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$cardContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        position: 'relative'
    });
    const $f7de3dc4d7bc51ad$var$AgentProfileCard = ({ agent: agent, isLoading: isLoading, isCreatedByViewingUser: isCreatedByViewingUser, cloudId: cloudId, onChatClick: onChatClick, product: product = 'rovo', hasError: hasError, errorType: errorType, onConversationStartersClick: onConversationStartersClick, resourceClient: resourceClient, addFlag: addFlag })=>{
        const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onOpenChat: onOpenChatFullScreen, onConversationStarter: onConversationStarter, onViewFullProfile: onViewFullProfile } = (0, $37c0Y.useAgentUrlActions)({
            cloudId: cloudId || ''
        });
        const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
        const [starCount, setStarCount] = (0, $5uXOq.useState)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const userDefinedConversationStarters = agent?.user_defined_conversation_starters?.map((starter)=>{
            return {
                message: starter,
                type: 'user-defined'
            };
        });
        (0, $5uXOq.useEffect)(()=>{
            setIsStarred(!!agent?.favourite);
            setStarCount(agent?.favourite_count);
        }, [
            agent?.favourite,
            agent?.favourite_count
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const handleSetFavourite = (0, $5uXOq.useCallback)(async ()=>{
            if (agent?.id) try {
                await resourceClient.setFavouriteAgent(agent.id, !isStarred, fireAnalytics);
                if (isStarred) setStarCount(starCount ? starCount - 1 : 0);
                else setStarCount((starCount || 0) + 1);
                setIsStarred(!isStarred);
            } catch (error) {}
        }, [
            agent?.id,
            fireAnalytics,
            isStarred,
            resourceClient,
            starCount
        ]);
        const handleOnDelete = (0, $5uXOq.useCallback)(async ()=>{
            if (agent) try {
                await resourceClient.deleteAgent(agent.id, fireAnalytics);
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agent.name
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                });
            } catch (error) {
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                });
            }
        }, [
            addFlag,
            agent,
            fireAnalytics,
            formatMessage,
            resourceClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoading && agent) fireAnalytics((0, $ivXTE.profileCardRendered)('agent', 'content'));
        }, [
            agent,
            fireAnalytics,
            isLoading
        ]);
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
            profileType: "agent",
            fireAnalytics: fireAnalytics
        }));
        if (hasError || !agent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            errorType: errorType,
            fireAnalytics: fireAnalytics
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$cardContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).AgentBanner), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            height: 96,
            agentIdentityAccountId: agent.identity_account_id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$avatarStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xlarge",
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY',
            forgeAgentIconUrl: agent.icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $f7de3dc4d7bc51ad$var$styles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileInfo), {
            agentName: agent.name,
            isStarred: isStarred,
            onStarToggle: handleSetFavourite,
            isHidden: agent.visibility === 'PRIVATE',
            creatorRender: agent.creatorInfo?.type && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileCreator), {
                creator: {
                    type: agent.creatorInfo?.type,
                    name: agent.creatorInfo?.name || '',
                    profileLink: agent.creatorInfo?.profileLink || ''
                },
                isLoading: false,
                onCreatorLinkClick: ()=>{}
            }),
            starCountRender: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fygPX")).AgentStarCount), {
                starCount: starCount,
                isLoading: false
            }),
            agentDescription: agent.description
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h9eXl.ConversationStarters), {
            isAgentDefault: agent.is_default,
            userDefinedConversationStarters: userDefinedConversationStarters,
            onConversationStarterClick: (conversationStarter)=>{
                onConversationStartersClick ? onConversationStartersClick(conversationStarter) : onConversationStarter({
                    agentId: agent.id,
                    prompt: conversationStarter.message
                });
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aRdJp.AgentActions), {
            agent: agent,
            isAgentCreatedByCurrentUser: isCreatedByViewingUser,
            onEditAgent: ()=>onEditAgent(agent.id),
            onCopyAgent: ()=>onCopyAgent(agent.id),
            onDuplicateAgent: ()=>onDuplicateAgent(agent.id),
            onDeleteAgent: handleOnDelete,
            onChatClick: ()=>onChatClick ? onChatClick() : onOpenChatFullScreen(agent.id, agent.name),
            resourceClient: resourceClient,
            onViewFullProfileClick: ()=>onViewFullProfile(agent.id)
        })));
    };
    var $f7de3dc4d7bc51ad$export$2e2bcd8739ae039 = $f7de3dc4d7bc51ad$var$AgentProfileCard;
});
parcelRegister("8qsT1", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$599d4a7a6a9f8f79$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $599d4a7a6a9f8f79$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (fireAnalytics) fireAnalytics((0, $ivXTE.profileCardRendered)(profileType, 'spinner'));
        }, [
            fireAnalytics,
            profileType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
});
parcelRegister("jnj6z", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$a03faa2abdc74ae6$export$6aa22a823032b784);
    $parcel$export(module.exports, "ProfileImage", ()=>$a03faa2abdc74ae6$export$a7a74ab5cffd1455);
    $parcel$export(module.exports, "ActionsFlexSpacer", ()=>$a03faa2abdc74ae6$export$d395c8d16f1e359d);
    $parcel$export(module.exports, "KudosBlobAnimation", ()=>$a03faa2abdc74ae6$export$4a8a956251d4bf6f);
    $parcel$export(module.exports, "AnimationWrapper", ()=>$a03faa2abdc74ae6$export$58517bb1b373a54c);
    $parcel$export(module.exports, "AnimatedKudosButton", ()=>$a03faa2abdc74ae6$export$6196a3f52a6944fe);
    $parcel$export(module.exports, "ActionButtonGroup", ()=>$a03faa2abdc74ae6$export$73d695ae27330056);
    $parcel$export(module.exports, "OverflowActionButtonsWrapper", ()=>$a03faa2abdc74ae6$export$ff778e5b796745a6);
    $parcel$export(module.exports, "CardContent", ()=>$a03faa2abdc74ae6$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "DetailsGroup", ()=>$a03faa2abdc74ae6$export$35cf684daac137ac);
    $parcel$export(module.exports, "DisabledInfo", ()=>$a03faa2abdc74ae6$export$2062e7265a95a823);
    $parcel$export(module.exports, "FullNameLabel", ()=>$a03faa2abdc74ae6$export$1270e9c1fc39142b);
    $parcel$export(module.exports, "LozengeWrapper", ()=>$a03faa2abdc74ae6$export$75180efdd3f4d9c2);
    $parcel$export(module.exports, "CustomLozengeContainer", ()=>$a03faa2abdc74ae6$export$6ebf103500ba5a45);
    $parcel$export(module.exports, "JobTitleLabel", ()=>$a03faa2abdc74ae6$export$d6c0e5f211c8d617);
    $parcel$export(module.exports, "AppTitleLabel", ()=>$a03faa2abdc74ae6$export$4865ffa72a4d5f9);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$a03faa2abdc74ae6$export$a5e06607a5ac6158);
    $parcel$export(module.exports, "CardContainer", ()=>$a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
    $parcel$export(module.exports, "DetailsLabel", ()=>$a03faa2abdc74ae6$export$138a08882ebf7289);
    $parcel$export(module.exports, "DetailsLabelIcon", ()=>$a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
    $parcel$export(module.exports, "DetailsLabelText", ()=>$a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a03faa2abdc74ae6$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
    const $a03faa2abdc74ae6$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo20"
    })("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 45, "px;");
    const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo19"
    })({
        name: "eukccz",
        styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
    });
    const $a03faa2abdc74ae6$export$d395c8d16f1e359d = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo18"
    })({
        name: "18pny36",
        styles: "flex:1 0 auto"
    });
    const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, (0, parcelRequire("f8Sb3")).keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
    const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo17"
    })("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 4 / (0, (0, parcelRequire("k5uoT")).fontSize)(), "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
    const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {
            className: "kudos-blob-animation",
            ...props
        });
    const $a03faa2abdc74ae6$export$58517bb1b373a54c = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo16"
    })("clip-path:inset(0px 0px 0px 0px round ", (0, (0, parcelRequire("k5uoT")).borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
    const $a03faa2abdc74ae6$export$6196a3f52a6944fe = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo15"
    })({
        name: "18xp5qc",
        styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
    });
    const $a03faa2abdc74ae6$export$73d695ae27330056 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo14"
    })("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$ff778e5b796745a6 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo13"
    })("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo12"
    })("display:flex;flex-direction:column;min-height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 17, "px;");
    const $a03faa2abdc74ae6$export$35cf684daac137ac = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo11"
    })("display:flex;flex-direction:column;margin-left:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 14.5, "px;width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 24.5, "px;");
    const $a03faa2abdc74ae6$export$2062e7265a95a823 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo10"
    })("font-size:", (0, (0, parcelRequire("k5uoT")).fontSizeSmall)(), "px;color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
    const $a03faa2abdc74ae6$export$1270e9c1fc39142b = (0, $bWGt6.default)("h2", {
        target: "e1ebb2vo9"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $huHkE.headerTextColorInactive) : (0, $huHkE.headerTextColor), ";margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";}");
    const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo8"
    })({
        name: "m760b1",
        styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
    });
    const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
        target: "e1ebb2vo7"
    })({
        name: "15oqcei",
        styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
    });
    const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo6"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo5"
    })("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, (0, parcelRequire("k5uoT")).borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo4"
    })("align-items:center;display:flex;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;justify-content:center;position:relative;");
    const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo3"
    })("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`, ";overflow:hidden;");
    const $a03faa2abdc74ae6$export$138a08882ebf7289 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo2"
    })("display:flex;align-items:center;line-height:24px;font-size:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
    const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = (0, $bWGt6.default)("dt", {
        target: "e1ebb2vo1"
    })("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
    const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = (0, $bWGt6.default)("dd", {
        target: "e1ebb2vo0"
    })("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");
});
parcelRegister("huHkE", function(module, exports) {
    $parcel$export(module.exports, "bgColor", ()=>$61d9a2704bf54ca1$export$7dcbec377a25efc6);
    $parcel$export(module.exports, "headerBgColor", ()=>$61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
    $parcel$export(module.exports, "teamHeaderBgColor", ()=>$61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
    $parcel$export(module.exports, "headerBgColorDisabledUser", ()=>$61d9a2704bf54ca1$export$ef73fded6fab455c);
    $parcel$export(module.exports, "headerTextColor", ()=>$61d9a2704bf54ca1$export$5c2df128da90e8de);
    $parcel$export(module.exports, "headerTextColorInactive", ()=>$61d9a2704bf54ca1$export$a882617dcf7f98a6);
    $parcel$export(module.exports, "appLabelBgColor", ()=>$61d9a2704bf54ca1$export$6f79b778f6280d31);
    $parcel$export(module.exports, "appLabelTextColor", ()=>$61d9a2704bf54ca1$export$3db47a978b9599f9);
    $parcel$export(module.exports, "labelTextColor", ()=>$61d9a2704bf54ca1$export$dd73341f2a5541fa);
    $parcel$export(module.exports, "labelIconColor", ()=>$61d9a2704bf54ca1$export$5a20f73e634c37e3);
    $parcel$export(module.exports, "errorIconColor", ()=>$61d9a2704bf54ca1$export$85e73a744c5d1042);
    $parcel$export(module.exports, "errorTitleColor", ()=>$61d9a2704bf54ca1$export$be3c814f7ed506ed);
    $parcel$export(module.exports, "errorTextColor", ()=>$61d9a2704bf54ca1$export$ddf766d3bfcf965c);
    const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
    const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
    const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
    const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
    const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
});
parcelRegister("geGTf", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>(parcelRequire("gMO5Q")).ErrorBoundary);
    $parcel$export(module.exports, "ErrorIllustration", ()=>(parcelRequire("5HjZK")).ErrorIllustration);
    $parcel$export(module.exports, "ErrorMessage", ()=>(parcelRequire("cI0Td")).default);
    var $gMO5Q = parcelRequire("gMO5Q");
    var $5HjZK = parcelRequire("5HjZK");
    var $cI0Td = parcelRequire("cI0Td");
});
parcelRegister("gMO5Q", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$bd7ac2918bb58c89$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $bd7ac2918bb58c89$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            this.props.onError();
        }
        render() {
            return this.props.children;
        }
    }
    var $bd7ac2918bb58c89$export$2e2bcd8739ae039 = $bd7ac2918bb58c89$export$e926676385687eaf;
});
parcelRegister("5HjZK", function(module, exports) {
    $parcel$export(module.exports, "ErrorIllustration", ()=>$dc9c80930a9669a0$export$e0319f52fc2380b1);
    var $5uXOq = parcelRequire("5uXOq");
    const $dc9c80930a9669a0$export$e0319f52fc2380b1 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "42",
            height: "53",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "var(--ds-surface-overlay, white)",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
    };
});
parcelRegister("cI0Td", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f71e8c5b4eb5da96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $d5Zn3;
    var $coLPe = parcelRequire("coLPe");
    var $ivXTE = parcelRequire("ivXTE");
    const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
        const errorType = props.errorType || {
            reason: 'default'
        };
        const errorReason = errorType.reason;
        const { fireAnalytics: fireAnalytics, reload: reload } = props;
        const hasRetry = !!reload;
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
                hasRetry: hasRetry,
                errorType: errorReason
            }));
        }, [
            errorReason,
            fireAnalytics,
            hasRetry
        ]);
        const errorContent = ()=>{
            if (errorReason === 'NotFound') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "The user is no longer available for the site");
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "Oops, looks like we\u2019re having issues", (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorText), null, "Try again and we\u2019ll give it another shot"));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
            label: "icon error",
            size: "xlarge"
        }), errorContent(), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: reload
        }, "Try again"));
    };
    var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("coLPe", function(module, exports) {
    $parcel$export(module.exports, "ErrorWrapper", ()=>$263bdf68dbaa8e29$export$bb27b7e39840238f);
    $parcel$export(module.exports, "ErrorTitle", ()=>$263bdf68dbaa8e29$export$b065fd053267ec81);
    $parcel$export(module.exports, "ErrorText", ()=>$263bdf68dbaa8e29$export$7f714e6c560938e5);
    $parcel$export(module.exports, "TeamErrorTitle", ()=>$263bdf68dbaa8e29$export$d139ade0bdee219d);
    $parcel$export(module.exports, "TeamErrorText", ()=>$263bdf68dbaa8e29$export$90d92ccfb27352c6);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    const $263bdf68dbaa8e29$export$bb27b7e39840238f = (0, $bWGt6.default)("div", {
        target: "e1g2atxt4"
    })({
        textAlign: 'center',
        padding: "var(--ds-space-300, 24px)",
        color: (0, $huHkE.errorIconColor)
    });
    const $263bdf68dbaa8e29$export$b065fd053267ec81 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt3"
    })({
        color: (0, $huHkE.errorTitleColor),
        lineHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
        margin: `${"var(--ds-space-100, 8px)"} 0`
    });
    const $263bdf68dbaa8e29$export$7f714e6c560938e5 = (0, $bWGt6.default)("span", {
        target: "e1g2atxt2"
    })({
        color: (0, $huHkE.errorTextColor)
    });
    const $263bdf68dbaa8e29$export$d139ade0bdee219d = (0, $bWGt6.default)("p", {
        target: "e1g2atxt1"
    })((0, (0, parcelRequire("3RZIb")).h400));
    const $263bdf68dbaa8e29$export$90d92ccfb27352c6 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt0"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-100, 8px)"
    });
});
parcelRegister("aRdJp", function(module, exports) {
    $parcel$export(module.exports, "AgentActions", ()=>$e34fa80969140484$export$a091e6fbe251d12f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $zPb6e;
    var $h88oy;
    var $kMJs7 = parcelRequire("kMJs7");
    const $e34fa80969140484$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $e34fa80969140484$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $e34fa80969140484$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $e34fa80969140484$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $e34fa80969140484$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $e34fa80969140484$var$actionsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderColor: 'color.border',
        padding: 'space.200',
        marginBlockStart: 'space.200',
        color: 'color.text'
    });
    const $e34fa80969140484$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, isForgeAgent: isForgeAgent })=>{
        return isForgeAgent ? [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ] : [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDuplicate),
                onClick: onDuplicateAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ];
    };
    const $e34fa80969140484$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
        return [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionEdit),
                onClick: onEditAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDelete),
                onClick: onDeleteAgent
            }
        ];
    };
    const $e34fa80969140484$export$a091e6fbe251d12f = ({ isAgentCreatedByCurrentUser: isAgentCreatedByCurrentUser, onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, onViewFullProfileClick: onViewFullProfileClick, agent: agent, resourceClient: resourceClient })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
        const isForgeAgent = agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY';
        const loadAgentPermissions = (0, $5uXOq.useCallback)(async ()=>{
            const { permissions: { AGENT_UPDATE: AGENT_UPDATE, AGENT_DEACTIVATE: AGENT_DEACTIVATE } } = await resourceClient.getRovoAgentPermissions(agent.id);
            return {
                isEditEnabled: AGENT_UPDATE.permitted,
                isDeleteEnabled: AGENT_DEACTIVATE.permitted
            };
        }, [
            agent.id,
            resourceClient
        ]);
        const agentActions = $e34fa80969140484$var$buildAgentActions({
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent,
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY'
        });
        const agentSetting = $e34fa80969140484$var$buildAgentSettings({
            onEditAgent: onEditAgent,
            onDeleteAgent: ()=>{
                setIsDeleteModalOpen(true);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            xcss: $e34fa80969140484$var$actionsWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            shouldFitContainer: true,
            onClick: (e)=>{
                e.stopPropagation();
                onChatClick();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $e34fa80969140484$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillTextStyles
        }, formatMessage($e34fa80969140484$var$messages.actionChatToAgent)))))), (0, (0, parcelRequire("VSDnB")).fg)('rovo_use_agent_permissions') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("zPb6e")).AgentDropdownMenu), {
            agentId: agent.id,
            isAgentCreatedByUser: isAgentCreatedByCurrentUser ?? false,
            onDeleteAgent: ()=>setIsDeleteModalOpen(true),
            onEditAgent: onEditAgent,
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent,
            isForgeAgent: isForgeAgent,
            loadAgentPermissions: loadAgentPermissions,
            loadPermissionsOnMount: true,
            onViewAgentFullProfileClick: onViewFullProfileClick,
            doesAgentHaveIdentityAccountId: !!agent.identity_account_id,
            shouldTriggerStopPropagation: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: "more",
                    ref: triggerRef,
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onClick?.(e);
                    }
                })),
            placement: "bottom-end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })), isAgentCreatedByCurrentUser && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kMJs7.AgentDeleteConfirmationModal), {
            isOpen: isDeleteModalOpen,
            onClose: ()=>{
                setIsDeleteModalOpen(false);
            },
            onSubmit: onDeleteAgent,
            agentId: agent.id,
            agentName: agent.name
        }));
    };
    const $e34fa80969140484$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actionChatToAgent: {
            id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
            defaultMessage: 'Chat to Agent',
            description: 'Text for the "chat to agent" action to chat to the agent'
        },
        actionDelete: {
            id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
            defaultMessage: 'Delete Agent',
            description: 'Text for the "Delete" action to delete an agent'
        },
        actionEdit: {
            id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
            defaultMessage: 'Edit Agent',
            description: 'Text for the "Edit" action to edit an agent'
        },
        actionCopyLink: {
            id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
            defaultMessage: 'Copy link',
            description: 'Text for the Copy link of an agent'
        },
        actionDuplicate: {
            id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
            defaultMessage: 'Duplicate Agent',
            description: 'Text for the Duplicate Agent action to create a duplicate'
        }
    });
});
parcelRegister("zPb6e", function(module, exports) {
    $parcel$export(module.exports, "AgentDropdownMenu", ()=>$4de29d55d41f6cce$export$fc284fc0f7cc8f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $h88oy;
    var $ccIkk;
    const $4de29d55d41f6cce$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $4de29d55d41f6cce$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $4de29d55d41f6cce$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $4de29d55d41f6cce$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $4de29d55d41f6cce$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $4de29d55d41f6cce$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $4de29d55d41f6cce$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatPillTextStyles
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).chatToAgentButton))))));
    };
    const $4de29d55d41f6cce$export$fc284fc0f7cc8f16 = ({ isAgentCreatedByUser: isAgentCreatedByUser, onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onDeleteAgent: onDeleteAgent, onViewAgentFullProfileClick: onViewAgentFullProfileClick, isForgeAgent: isForgeAgent, showViewAgentOption: showViewAgentOption = false, onViewAgentClick: onViewAgentClick, onDropdownTriggerClick: onDropdownTriggerClick, spacing: spacing, appearance: appearance, dropdownMenuTestId: dropdownMenuTestId, doesAgentHaveIdentityAccountId: doesAgentHaveIdentityAccountId, loadAgentPermissions: loadAgentPermissions, loadPermissionsOnMount: loadPermissionsOnMount, shouldTriggerStopPropagation: shouldTriggerStopPropagation })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("VSDnB")).fg));
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [hasBeenCopied, setHasBeenCopied] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [permissions, setPermissions] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const fetchData = async ()=>{
                if (!loadAgentPermissions || !(0, (0, parcelRequire("VSDnB")).fg)('rovo_use_agent_permissions')) {
                    const canEditDelete = isAgentCreatedByUser && !isForgeAgent;
                    setPermissions({
                        isEditEnabled: canEditDelete,
                        isDeleteEnabled: canEditDelete
                    });
                    return;
                }
                setIsLoading(true);
                const { isEditEnabled: isEditEnabled, isDeleteEnabled: isDeleteEnabled } = await loadAgentPermissions();
                setIsLoading(false);
                setPermissions({
                    isEditEnabled: isEditEnabled,
                    isDeleteEnabled: isDeleteEnabled
                });
            };
            if (!permissions && (isOpen || loadPermissionsOnMount)) fetchData();
        }, [
            isAgentCreatedByUser,
            isForgeAgent,
            isOpen,
            loadAgentPermissions,
            loadPermissionsOnMount,
            permissions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isOpen) setHasBeenCopied(false);
        }, [
            isOpen
        ]);
        const renderEditDelete = ()=>{
            if (!permissions?.isEditEnabled && !permissions?.isDeleteEnabled) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                hasSeparator: true
            }, permissions.isEditEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: onEditAgent
            }, formatMessage((0, (0, parcelRequire("ccIkk")).default).editAgent)), permissions.isDeleteEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: onDeleteAgent
            }, formatMessage((0, (0, parcelRequire("ccIkk")).default).deleteAgent)));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: isLoading,
            isOpen: isOpen,
            testId: dropdownMenuTestId,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: formatMessage((0, (0, parcelRequire("ccIkk")).default).moreActionsLabel),
                    ref: triggerRef,
                    spacing: spacing,
                    appearance: appearance,
                    onClick: (e, analyticsEvent)=>{
                        if (onDropdownTriggerClick) onDropdownTriggerClick(e, analyticsEvent);
                        if (shouldTriggerStopPropagation) e.stopPropagation();
                        props.onClick?.(e);
                    }
                }),
            onOpenChange: (args)=>{
                setIsOpen(args.isOpen);
                if (!args.isOpen) setHasBeenCopied(false);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, showViewAgentOption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewAgentClick
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).viewAgent)), doesAgentHaveIdentityAccountId && onViewAgentFullProfileClick && (0, (0, parcelRequire("VSDnB")).fg)('rovo_agent_profile_page') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewAgentFullProfileClick
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).viewAgentFullProfile)), !isForgeAgent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onDuplicateAgent
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).duplicateAgent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: (e)=>{
                e.stopPropagation();
                setHasBeenCopied(true);
                onCopyAgent?.(e);
            }
        }, formatMessage(hasBeenCopied ? (0, (0, parcelRequire("ccIkk")).default).linkedCopiedToProfile : (0, (0, parcelRequire("ccIkk")).default).copyLinkToProfile))), renderEditDelete());
    };
});
parcelRegister("h88oy", function(module, exports) {
    $parcel$export(module.exports, "ChatPillIcon", ()=>$222c44ccbe7ec2a4$export$38f9b635c1c454e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $82RQj;
    var $jyBoJ;
    const $222c44ccbe7ec2a4$export$38f9b635c1c454e7 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("82RQj"))))), {
            ...props,
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("jyBoJ")).default)
        });
});
parcelRegister("82RQj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5db846b1e6bcdc52$var$_UNSAFE_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>$5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.17.1zm-3.5 2H0a.75.75 0 0 0 1.12.65zM2.63 2h10.75V.5H2.63zM14.5 3.13v8.25H16V3.13zm-1.12 9.37H4.25V14h9.13zm-9.5.1-3.5 2 .74 1.3 3.5-2zM1.5 15.25V3.13H0v12.12zm13-3.87c0 .62-.5 1.13-1.12 1.13V14A2.63 2.63 0 0 0 16 11.38zM13.38 2c.62 0 1.13.5 1.13 1.13H16A2.63 2.63 0 0 0 13.38.5zM2.63.5A2.63 2.63 0 0 0 0 3.13h1.5C1.5 2.5 2 2 2.63 2zM6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
        }, props));
    $5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
    var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;
});
parcelRegister("jyBoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c3657b5b4eabc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $c2c3657b5b4eabc6$var$ChatIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinejoin: "round",
            fill: "transparent"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "6",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "9",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "12",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }));
    const $c2c3657b5b4eabc6$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $c2c3657b5b4eabc6$var$ChatIconGlyph
        });
    var $c2c3657b5b4eabc6$export$2e2bcd8739ae039 = $c2c3657b5b4eabc6$var$ChatIcon;
});
parcelRegister("ccIkk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8f2564df10c4301$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8f2564df10c4301$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chatToAgentButton: {
            id: 'rovo-chat.view-agent.chat-to-agent-button',
            defaultMessage: 'Chat to Agent',
            description: 'Button to chat to agent'
        },
        moreActionsLabel: {
            id: 'rovo-chat.view-agent.more-actions-label',
            defaultMessage: 'More actions',
            description: 'More actions dropdown menu label'
        },
        duplicateAgent: {
            id: 'rovo-chat.view-agent.duplicate-agent',
            defaultMessage: 'Duplicate Agent',
            description: 'Button to duplicate an agent'
        },
        editAgent: {
            id: 'rovo-chat.view-agent.edit-agent',
            defaultMessage: 'Edit Agent',
            description: 'Button to edit an agent'
        },
        deleteAgent: {
            id: 'rovo-chat.view-agent.delete-agent',
            defaultMessage: 'Delete Agent',
            description: 'Button to delete an agent'
        },
        copyLinkToProfile: {
            id: 'rovo-chat.view-agent.copy-link-to-profile',
            defaultMessage: 'Copy link',
            description: 'Button to copy the link to the agent profile'
        },
        linkedCopiedToProfile: {
            id: 'rovo-chat.view-agent.link-copied-to-profile',
            defaultMessage: 'Copied URL',
            description: 'Button confirming link to agent profile is copied'
        },
        viewAgent: {
            id: 'rovo-chat.view-agents.view-agent',
            defaultMessage: 'View Agent',
            description: 'Button to view an agent'
        },
        viewAgentFullProfile: {
            id: 'rovo-chat.view-agents.view-agent-full-profile',
            defaultMessage: 'View full profile',
            description: 'Button to view an agent full profile'
        }
    });
});
parcelRegister("kMJs7", function(module, exports) {
    $parcel$export(module.exports, "AgentDeleteConfirmationModal", ()=>$9ca0177e5b141068$export$39d869cf16a68f79);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $eCeGD;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $cgL5K;
    const $9ca0177e5b141068$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, isOpen: isOpen, onSubmit: onSubmit, agentId: agentId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
            if (agentId) {
                await onSubmit();
                onClose();
            }
        }, [
            agentId,
            onClose,
            onSubmit
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage($9ca0177e5b141068$var$messages.title, {
            agentName: agentName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage($9ca0177e5b141068$var$messages.body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage($9ca0177e5b141068$var$messages.cancelText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "danger",
            onClick: (_e, event)=>{
                handleDeleteAgent();
            }
        }, formatMessage($9ca0177e5b141068$var$messages.confirmText))))));
    };
    const $9ca0177e5b141068$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.cancel-text',
            defaultMessage: 'Cancel'
        },
        confirmText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.confirm-text',
            defaultMessage: 'Delete'
        },
        title: {
            id: 'profilecard.agent-profile.delete-agent-confirm-title',
            defaultMessage: 'Delete "{agentName}"?',
            description: 'Title text for the delete agent confirmation modal'
        },
        body: {
            id: 'profilecard.agent-profile.delete-agent-confirm-body',
            defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
            description: 'Body text for the delete agent confirmation modal'
        },
        error: {
            id: 'profilecard.agent-profile.delete-agent-error',
            defaultMessage: 'Could not delete agent',
            description: 'Error message displayed when an agent cannot be deleted'
        },
        errorAgentNotFound: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-not-found',
            defaultMessage: 'That agent could not be found.',
            description: 'Error message displayed when an agent cannot be found'
        },
        errorAgentInUse: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-in-use',
            defaultMessage: 'Agent is currently in use. Try again later.',
            description: 'Error message displayed when an agent is in use'
        },
        errorIncorrectOwner: {
            id: 'profilecard.agent-profile.delete-agent-error.incorrect-owner',
            defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
            description: 'Error message displayed when the agent owner is incorrect'
        },
        agentDeletedSuccess: {
            id: 'profilecard.agent-profile.delete-agent-success',
            defaultMessage: 'Agent has been deleted!',
            description: 'Success message displayed when an agent is deleted'
        }
    });
});
parcelRegister("a3FJs", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardWrapper", ()=>$642b3278878bc39a$export$2c6604b50c274e6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $642b3278878bc39a$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $642b3278878bc39a$var$styles
        }, children);
    };
});
parcelRegister("h9eXl", function(module, exports) {
    $parcel$export(module.exports, "ConversationStarters", ()=>$e92c824efb5f3806$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $4ns5a;
    const $e92c824efb5f3806$export$ea338c37011da44c = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
        const handleConversationStarterClick = (conversationStarter)=>{
            onConversationStarterClick(conversationStarter);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            alignInline: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ns5a")).AgentConversationStarters), {
            isAgentDefault: isAgentDefault,
            onConversationStarterClick: handleConversationStarterClick,
            userDefinedConversationStarters: userDefinedConversationStarters
        }));
    };
});
parcelRegister("4ns5a", function(module, exports) {
    $parcel$export(module.exports, "getConversationStarters", ()=>$a3b222b85982a88a$export$c2d882153e0984c5);
    $parcel$export(module.exports, "AgentConversationStarters", ()=>$a3b222b85982a88a$export$171adfc74aa509c3);
    $parcel$export(module.exports, "ConversationStarters", ()=>$a3b222b85982a88a$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $42CjB;
    var $lzNDe;
    var $f5TWP;
    var $1NZUH;
    var $52GXX;
    const $a3b222b85982a88a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
        const type = 'static';
        const customAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion3,
                type: type
            }
        ];
        const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
        const defaultAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion3,
                type: type
            }
        ];
        const getCombinedConversationStarters = ()=>{
            const shouldCombine = !isAgentDefault;
            if (shouldCombine) return [
                ...userDefinedConversationStarters,
                ...customAgentConversationStarters
            ].slice(0, 3);
            return defaultAgentConversationStarters;
        };
        return {
            userDefinedConversationStarters: userDefinedConversationStarters,
            customAgentConversationStarters: customAgentConversationStarters,
            defaultAgentConversationStarters: defaultAgentConversationStarters,
            combinedConversationStarters: getCombinedConversationStarters()
        };
    };
    const $a3b222b85982a88a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { combinedConversationStarters: combinedConversationStarters } = (0, $5uXOq.useMemo)(()=>$a3b222b85982a88a$export$c2d882153e0984c5({
                userDefinedConversationStarters: userDefinedConversationStarters,
                isAgentDefault: isAgentDefault
            }), [
            userDefinedConversationStarters,
            isAgentDefault
        ]);
        const starters = (0, $5uXOq.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                    message: starter.message,
                    type: starter.type
                } : {
                    message: formatMessage(starter.message),
                    type: starter.type
                }), [
            combinedConversationStarters,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3b222b85982a88a$export$ea338c37011da44c, {
            starters: starters,
            ...props
        });
    };
    const $a3b222b85982a88a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, starters.map((starter, index)=>{
            const isLastStarter = index === starters.length - 1;
            const chatPill = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).ChatPill), {
                testId: "conversation-starter",
                key: starter.message,
                onClick: ()=>onConversationStarterClick(starter)
            }, starter.message);
            return isLastStarter && showReloadButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                space: "space.050",
                grow: "fill",
                alignInline: "end",
                key: starter.message
            }, chatPill, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("lzNDe"))))),
                onClick: onReloadButtonClick,
                appearance: "subtle",
                label: ""
            })) : chatPill;
        }), !!onBrowseAgentsClick && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).BrowseAgentsPill), {
            onClick: onBrowseAgentsClick
        }));
    };
});
parcelRegister("lzNDe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fb535dae8e778b64$var$_UNSAFE_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fb535dae8e778b64$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fb535dae8e778b64$var$RetryIcon = (props)=>$fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v2.5m2.625-2.125L12.75 11l-2.625-2.625"/>`
        }, props));
    $fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
    var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;
});
parcelRegister("1NZUH", function(module, exports) {
    $parcel$export(module.exports, "ChatPill", ()=>$0fd9c621f10bd238$export$e33faa86e0996d96);
    $parcel$export(module.exports, "BrowseAgentsPill", ()=>$0fd9c621f10bd238$export$76b47032dcd9063b);
    $parcel$export(module.exports, "ConversationStarterPill", ()=>$0fd9c621f10bd238$export$f7619b16091e62a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4V6HW;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $h88oy;
    var $eCjlc;
    const $0fd9c621f10bd238$var$conversationStarterPillStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        padding: 'space.100',
        border: `1px solid ${"var(--ds-border, #091E4224)"}`,
        borderRadius: 'border.radius.200',
        borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        background: 'none',
        width: '100%',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    });
    const $0fd9c621f10bd238$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        padding: 'space.100',
        borderRadius: 'border.radius.200',
        borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        backgroundColor: 'color.background.neutral',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    });
    const $0fd9c621f10bd238$var$buttonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $0fd9c621f10bd238$var$queryTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left'
    });
    const $0fd9c621f10bd238$var$whiteSpacePreWrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'pre-wrap'
    });
    const $0fd9c621f10bd238$export$e33faa86e0996d96 = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0fd9c621f10bd238$var$queryTextStyles,
                whiteSpacePreWrap && $0fd9c621f10bd238$var$whiteSpacePreWrapStyles
            ]
        }, children))));
    const $0fd9c621f10bd238$export$76b47032dcd9063b = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4V6HW"))))), {
            color: "currentColor",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0fd9c621f10bd238$var$queryTextStyles
        }, formatMessage((0, (0, parcelRequire("eCjlc")).default).browseAgentsPillLabel))));
    });
    const $0fd9c621f10bd238$export$f7619b16091e62a2 = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$conversationStarterPillStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0fd9c621f10bd238$var$queryTextStyles,
                whiteSpacePreWrap && $0fd9c621f10bd238$var$whiteSpacePreWrapStyles
            ]
        }, children))));
});
parcelRegister("4V6HW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3951b0552a35072b$var$_UNSAFE_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3951b0552a35072b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3951b0552a35072b$var$AiAgentIcon = (props)=>$3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m13.643 4.136-5-3a1.25 1.25 0 0 0-1.286 0l-5 3a1.25 1.25 0 0 0-.607 1.072v5.584c0 .44.23.846.607 1.072l5 3c.396.238.89.238 1.286 0l5-3a1.25 1.25 0 0 0 .607-1.072V5.208c0-.44-.23-.846-.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"/>`
        }, props));
    $3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
    var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;
});
parcelRegister("eCjlc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34bad2d4003b85e8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34bad2d4003b85e8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        browseAgentsPillLabel: {
            id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
            defaultMessage: 'Browse Agents',
            description: 'The label displayed on the browse agents pill'
        }
    });
});
parcelRegister("52GXX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$53d3212f8a8a35da$export$defe85febe8b728c);
    var $7VHMR;
    const $53d3212f8a8a35da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.suggestion1',
            defaultMessage: 'Are any of my tickets overdue?',
            description: 'The first suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.suggestion2',
            defaultMessage: 'What should I work on next?',
            description: 'The second suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.suggestion3',
            defaultMessage: 'Write an update about my week',
            description: 'The third suggestion displayed in the empty state of the chat history'
        },
        agentEmptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
            defaultMessage: 'Tell me about yourself',
            description: 'The first suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
            defaultMessage: 'What can you help me with?',
            description: 'The second suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
            defaultMessage: "Summarize what I'm looking at",
            description: 'The third suggestion displayed in the empty state when an agent is selected'
        }
    });
});
parcelRegister("37c0Y", function(module, exports) {
    $parcel$export(module.exports, "useAgentUrlActions", ()=>$4da156710b0b2a06$export$56665b80ee272742);
    var $5uXOq = parcelRequire("5uXOq");
    var $kTK0a;
    var $VSDnB;
    var $7Z8dX;
    var $9IyQf = parcelRequire("9IyQf");
    const $4da156710b0b2a06$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    const $4da156710b0b2a06$var$ROVO_PARAM_PREFIX = 'rovoChat';
    const $4da156710b0b2a06$var$createRovoParams = (params)=>{
        const rovoParams = {};
        Object.entries(params).forEach(([key, value])=>{
            rovoParams[`${$4da156710b0b2a06$var$ROVO_PARAM_PREFIX}${$4da156710b0b2a06$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
        });
        return rovoParams;
    };
    const $4da156710b0b2a06$export$56665b80ee272742 = ({ cloudId: cloudId })=>{
        const { publishWithPostMessage: publishWithPostMessage } = (0, (0, parcelRequire("7Z8dX")).useRovoPostMessageToPubsub)();
        const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const url = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/${agentId}/edit`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(url, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onCopyAgent = (agentId)=>{
            navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
        };
        const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/new`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId,
                    agentId: agentId,
                    pathway: 'agents-create'
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onConversationStarter = ({ agentId: agentId, prompt: prompt })=>{
            const startConversationInNewTab = ()=>{
                const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
                const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                    cloudId: cloudId,
                    ...$4da156710b0b2a06$var$createRovoParams({
                        cloudId: cloudId,
                        agentId: agentId,
                        prompt: prompt,
                        pathway: 'chat'
                    })
                });
                window.open(urlWithParams, '_blank', 'noopener, noreferrer');
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_profile_card_open_chat_sidebar')) publishWithPostMessage({
                targetWindow: window,
                payload: {
                    type: 'chat-new',
                    source: 'AgentProfileCard',
                    data: {
                        name: prompt.slice(0, 50),
                        prompt: prompt,
                        agentId: agentId,
                        dialogues: []
                    }
                },
                onAcknowledgeTimeout: ()=>{
                    startConversationInNewTab();
                }
            });
            else startConversationInNewTab();
        };
        const onOpenChat = (agentId, agentName)=>{
            const openChatInNewTab = ()=>{
                const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
                const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                    cloudId: cloudId,
                    ...$4da156710b0b2a06$var$createRovoParams({
                        cloudId: cloudId,
                        agentId: agentId
                    })
                });
                window.open(urlWithParams, '_blank', 'noopener, noreferrer');
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_profile_card_open_chat_sidebar')) publishWithPostMessage({
                targetWindow: window,
                payload: {
                    type: 'chat-new',
                    source: 'AgentProfileCard',
                    data: {
                        agentId: agentId,
                        dialogues: [],
                        name: `Chat with ${agentName}`
                    }
                },
                onAcknowledgeTimeout: ()=>{
                    openChatInNewTab();
                }
            });
            else openChatInNewTab();
        };
        const onViewFullProfile = (agentId)=>{
            window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
        };
        return {
            onEditAgent: onEditAgent,
            onCopyAgent: onCopyAgent,
            onDuplicateAgent: onDuplicateAgent,
            onOpenChat: onOpenChat,
            onConversationStarter: onConversationStarter,
            onViewFullProfile: onViewFullProfile
        };
    };
});
parcelRegister("9IyQf", function(module, exports) {
    $parcel$export(module.exports, "encodeParamsToUrl", ()=>$f44b342f66021b18$export$3220405ab77f2c5d);
    const $f44b342f66021b18$export$3220405ab77f2c5d = (baseUrl, params)=>{
        const url = new URL(baseUrl);
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params))searchParams.append(key, String(value));
        url.search = searchParams.toString();
        return url.toString();
    };
});
parcelRegister("dlHyi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b47fe3036cdacda7$export$defe85febe8b728c);
    var $7VHMR;
    const $b47fe3036cdacda7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentDeletedSuccessFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-title',
            defaultMessage: 'Agent deleted',
            description: 'Flag message title displayed when an agent is deleted'
        },
        agentDeletedSuccessFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-description',
            defaultMessage: 'You deleted {agentName}',
            description: 'Flag message description displayed when an agent is deleted'
        },
        agentDeletedErrorFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-title',
            defaultMessage: 'Failed to delete Agent',
            description: 'Flag message title displayed when there is an error deleting agent'
        },
        agentDeletedErrorFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-description',
            defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
            description: 'Flag message description displayed when there is an error deleting agent'
        }
    });
});
parcelRegister("6uTwi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a486335f4f64442$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $9MMkr = parcelRequire("9MMkr");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $gMO5Q = parcelRequire("gMO5Q");
    var $lpWVl = parcelRequire("lpWVl");
    var $devOt = parcelRequire("devOt");
    class $6a486335f4f64442$export$f811dc569217c959 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: [],
                trigger: 'hover',
                position: 'bottom-start',
                triggerLinkType: 'link'
            };
        }
        componentDidMount() {
            this._isMounted = true;
        }
        componentDidUpdate(prevProps) {
            const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
            const { visible: visible } = this.state;
            if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
        }
        handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: team,
                shouldShowGiveKudos: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        filterActions() {
            const actions = (0, $4sfdL.default)(this.props.actions, this.state.data);
            if (this.state.shouldShowGiveKudos) {
                const kudosAction = {
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                    id: 'give-kudos',
                    callback: ()=>{
                        this.openKudosDrawer();
                    },
                    link: this.kudosUrl()
                };
                return actions.concat([
                    kudosAction
                ]);
            }
            return actions;
        }
        renderPopup() {
            if (this.state.renderError) return this.props.children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gMO5Q.ErrorBoundary), {
                onError: this.onErrorBoundary
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
            }));
        }
        render() {
            if (this.props.children) return this.renderPopup();
            else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
        }
        constructor(...args){
            super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            }, this.fireAnalyticsWithDuration = (generator)=>{
                const event = generator((0, $6TKEY.getPageTime)() - this.openTime);
                this.fireAnalytics(event);
            }, this.hideProfilecard = (delay = 0)=>{
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.hideTimer = window.setTimeout(()=>{
                    this.setState({
                        visible: false
                    });
                }, delay);
            }, this.showProfilecard = (delay = 0)=>{
                clearTimeout(this.hideTimer);
                clearTimeout(this.showTimer);
                this.showTimer = window.setTimeout(()=>{
                    if (!this.state.visible) {
                        this.clientFetchProfile();
                        this.openTime = (0, $6TKEY.getPageTime)();
                        this.setState({
                            visible: true
                        });
                    }
                }, delay);
            }, this.onClick = (event)=>{
                if (this.props.triggerLinkType === 'link') {
                    if ((0, $dv9z3.isBasicClick)(event)) event.preventDefault();
                }
                if (this.props.triggerLinkType === 'clickable-link') {
                    if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
                }
                if (this.props.trigger !== 'hover') {
                    this.openedByHover = false;
                    this.showProfilecard(0);
                    if (!this.state.visible) this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'click'));
                }
            }, this.onMouseEnter = ()=>{
                if (this.props.trigger === 'click') return;
                if (!this.state.visible) {
                    this.openedByHover = true;
                    this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'hover'));
                }
                this.showProfilecard((0, $e41878b3b8cab0db$export$5b956b542f1bc1b3));
            }, this.onMouseLeave = ()=>{
                if (this.props.trigger === 'click') return;
                if (this.openedByHover) this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
            }, this.onClose = ()=>{
                this.hideProfilecard();
            }, this.openKudosDrawer = ()=>{
                this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
                this.setState({
                    kudosDrawerOpen: true
                });
            }, this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            }, this.kudosUrl = ()=>{
                const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
                const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
                return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
            }, this.stopPropagation = (event)=>{
                event.stopPropagation();
            }, this.triggerListeners = {
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            }, this.cardListeners = {
                onClick: this.stopPropagation,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            }, this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                shouldShowGiveKudos: false,
                teamCentralBaseUrl: undefined,
                kudosDrawerOpen: false
            }, this.clientFetchProfile = ()=>{
                const { orgId: orgId, teamId: teamId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    data: null
                }, ()=>{
                    const fireEvent = (event)=>{
                        this.fireAnalytics(event);
                    };
                    const requests = Promise.all([
                        this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            }, this.onErrorBoundary = ()=>{
                this.fireAnalytics((0, $ivXTE.profileCardRendered)('team', 'errorBoundary', {
                    duration: 0
                }));
                this.setState({
                    renderError: true
                });
            }, this.renderProfileCard = ()=>{
                const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
                const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
                const newProps = {
                    clientFetchProfile: this.clientFetchProfile,
                    actions: this.filterActions(),
                    analytics: this.fireAnalyticsWithDuration,
                    team: data || undefined,
                    generateUserLink: generateUserLink,
                    onUserClick: onUserClick,
                    viewingUserId: viewingUserId,
                    viewProfileLink: viewProfileLink,
                    viewProfileOnClick: viewProfileOnClick
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", this.cardListeners, this.state.visible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
                        analytics: this.fireAnalyticsWithDuration
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lpWVl.TeamProfileCardLazy), {
                    ...newProps,
                    isLoading: isLoading,
                    hasError: hasError,
                    errorType: error
                })));
            }, this.renderKudosLauncher = ()=>{
                return this.state.shouldShowGiveKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: null
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, (0, parcelRequire("gH4E9")).KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                }));
            }, this.renderTrigger = (triggerProps)=>{
                const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
                if (triggerLinkType === 'none') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    ...triggerProps,
                    ...this.triggerListeners
                }, children));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    style: {
                        color: 'initial',
                        textDecoration: 'none'
                    },
                    href: viewProfileLink,
                    ...triggerProps,
                    ref: triggerProps.ref,
                    ...this.triggerListeners
                }, children));
            };
        }
    }
    var $6a486335f4f64442$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($6a486335f4f64442$export$f811dc569217c959);
});
parcelRegister("adIkV", function(module, exports) {
    $parcel$export(module.exports, "GiveKudosLauncherLazy", ()=>$c3877992df568d20$export$93fe397a02fe8b76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c3877992df568d20$export$93fe397a02fe8b76 = (0, $5uXOq.lazy)(()=>(parcelRequire("7TeXq")));
});
parcelRegister("7TeXq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("HRhLG")
    ]).then(()=>parcelRequire('iRLc5'));
});
parcelRegister("gH4E9", function(module, exports) {
    $parcel$export(module.exports, "KudosType", ()=>$b9e3bff5640b4187$export$4fa2020056771264);
    $parcel$export(module.exports, "FlagEventType", ()=>$b9e3bff5640b4187$export$d21f9befaa2961a);
    $parcel$export(module.exports, "isFlagEventTypeValue", ()=>$b9e3bff5640b4187$export$7a1fc1a1b0477464);
    var $b9e3bff5640b4187$export$4fa2020056771264;
    (function(KudosType) {
        KudosType["INDIVIDUAL"] = "individual";
        KudosType["TEAM"] = "team";
    })($b9e3bff5640b4187$export$4fa2020056771264 || ($b9e3bff5640b4187$export$4fa2020056771264 = {}));
    var $b9e3bff5640b4187$export$d21f9befaa2961a;
    (function(FlagEventType) {
        FlagEventType["KUDOS_CREATED"] = "kudos-created";
        FlagEventType["KUDOS_FAILED"] = "kudos-failed";
        FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
        FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
        FlagEventType["DIRTY"] = "dirty";
        FlagEventType["CLOSE"] = "close";
    })($b9e3bff5640b4187$export$d21f9befaa2961a || ($b9e3bff5640b4187$export$d21f9befaa2961a = {}));
    const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
        return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
    };
});
parcelRegister("4sfdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1251cd76451c32$export$2e2bcd8739ae039);
    const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
        return actions.filter((action)=>{
            if (!action.shouldRender) return true;
            else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
            return action.shouldRender(data);
        });
    };
    var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;
});
parcelRegister("9MMkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b852a44de86ce4d8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b852a44de86ce4d8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inactiveAccountMsg: {
            id: 'pt.profile-card.inactive.account',
            defaultMessage: 'Account deactivated',
            description: 'A text in a grey lozenge shows that this user is inactive'
        },
        generalDescMsgForDisabledUser: {
            id: 'pt.profile-card.general.msg.disabled.user',
            defaultMessage: 'You can no longer collaborate with this person.',
            description: 'A first sentence of a long text explains this user is inactive/closed'
        },
        inactiveAccountDescMsgNoDate: {
            id: 'pt.profile-card.inactive.account.no.date',
            defaultMessage: 'Their account has been deactivated.',
            description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.inactive.account.has.date.this.week',
            defaultMessage: 'Their account was deactivated this week.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.inactive.account.has.date.this.month',
            defaultMessage: 'Their account was deactivated this month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.inactive.account.has.date.last.month',
            defaultMessage: 'Their account was deactivated last month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.inactive.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deactivated for a few months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.inactive.account.has.date.several.months',
            defaultMessage: 'Their account has been deactivated for several months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deactivated for more than a year.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        closedAccountMsg: {
            id: 'pt.profile-card.closed.account',
            defaultMessage: 'Account deleted',
            description: 'A text in a grey lozenge shows that this user is closed/deleted'
        },
        closedAccountDescMsgNoDate: {
            id: 'pt.profile-card.closed.account.no.date',
            defaultMessage: 'Their account has been deleted.',
            description: 'A long text explains this user is closed when we do not know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.closed.account.has.date.this.week',
            defaultMessage: 'Their account was deleted this week.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.closed.account.has.date.this.month',
            defaultMessage: 'Their account was deleted this month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.closed.account.has.date.last.month',
            defaultMessage: 'Their account was deleted last month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.closed.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deleted for a few months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.closed.account.has.date.several.months',
            defaultMessage: 'Their account has been deleted for several months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deleted for more than a year.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        disabledAccountDefaultName: {
            id: 'pt.profile-card.disabled.account.default.name',
            defaultMessage: 'Former user',
            description: 'A default name when we cannot get name of an inactive or closed user'
        },
        teamViewProfile: {
            id: 'pt.team-profile-card.team.action.view-profile',
            defaultMessage: 'View profile',
            description: "Button that takes you to view this team\u2019s profile"
        },
        memberCount: {
            id: 'pt.team-profile-card.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team'
        },
        memberCountIncludingYou: {
            id: 'pt.team-profile-card.team.member.count-including-you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team and highlight that the user is a member'
        },
        membersMoreThan50: {
            id: 'pt.team-profile-card.team.member.many',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the team has more than 50 members'
        },
        membersMoreThan50IncludingYou: {
            id: 'pt.team-profile-card.team.member.many-including-you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
        },
        teamErrorTitle: {
            id: 'pt.team-profile-card.error.title',
            defaultMessage: "We\u2019re having trouble retrieving this teams information",
            description: 'Title for an error view explaining that data for this team cannot be accessed'
        },
        teamErrorText: {
            id: 'pt.team-profile-card.error.suggestion',
            defaultMessage: 'Wait a few moments, then try again.',
            description: 'Second line suggesting how to fix the issue'
        },
        teamErrorButton: {
            id: 'pt.team-profile-card.error.refresh-button',
            defaultMessage: 'Try again',
            description: 'Text on a button that will try to get the data again when clicked'
        },
        teamForbiddenErrorStateTitle: {
            id: 'pt.team-profile-card.forbidden-error-state.title',
            defaultMessage: "We can\u2019t show you this team",
            description: 'Title for the error state that is displayed when a user lacks access to the team'
        },
        teamForbiddenErrorStateDescription: {
            id: 'pt.team-profile-card.forbidden-error-state.description',
            defaultMessage: "You don\u2019t have access to view this team.",
            description: 'Description for the error state that is displayed when a user lacks access to the team'
        },
        managerSectionHeading: {
            id: 'pt.team-profile-card.manager.heading',
            defaultMessage: 'Manager',
            description: "Title for a section on the profile card that show the user's direct manager"
        },
        directReportsSectionHeading: {
            id: 'pt.team-profile-card.directReports.heading',
            defaultMessage: 'Direct reports',
            description: "Title for a section on the profile card that show the user's direct reports"
        },
        giveKudosButton: {
            id: 'pt.profile-card.give-kudos',
            defaultMessage: 'Give kudos',
            description: 'Title for the button on the profile card for a user to give a kudos'
        },
        profileCardMoreIconLabel: {
            id: 'pt.profile-card.more-icon-label',
            defaultMessage: 'More',
            description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
        }
    });
    var $b852a44de86ce4d8$export$2e2bcd8739ae039 = $b852a44de86ce4d8$var$messages;
});
parcelRegister("dv9z3", function(module, exports) {
    $parcel$export(module.exports, "isBasicClick", ()=>$29a366424d2cda97$export$eddcd8a5b7e09991);
    const $29a366424d2cda97$export$eddcd8a5b7e09991 = (event)=>{
        return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    };
});
const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;
parcelRegister("lpWVl", function(module, exports) {
    $parcel$export(module.exports, "TeamProfileCardLazy", ()=>$9bee5bfea0ce3d14$export$82a49d896f41ca78);
    var $5uXOq = parcelRequire("5uXOq");
    const $9bee5bfea0ce3d14$export$82a49d896f41ca78 = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("AF8aN"))));
});
parcelRegister("AF8aN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$3bb916baa86f0602$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jnhNB;
    var $2rqOp;
    var $fVnbM;
    var $jhVLw;
    var $bJeNF;
    var $3Z96c;
    var $eZUJu;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $3bDjY;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $coLPe = parcelRequire("coLPe");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    parcelRequire("geGTf");
    var $5HjZK = parcelRequire("5HjZK");
    var $drhKV = parcelRequire("drhKV");
    var $devOt = parcelRequire("devOt");
    const $3bb916baa86f0602$var$LARGE_MEMBER_COUNT = 50;
    const $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    function $3bb916baa86f0602$var$onMemberClick(callback, userId, analytics, index, hasHref) {
        return (event)=>{
            analytics((duration)=>(0, $ivXTE.teamAvatarClicked)({
                    duration: duration,
                    hasHref: hasHref,
                    hasOnClick: !!callback,
                    index: index
                }));
            if (callback) callback(userId, event);
        };
    }
    const $3bb916baa86f0602$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
        const count = members ? members.length : 0;
        const message = includingYou ? count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50IncludingYou : (0, $9MMkr.default).memberCountIncludingYou : count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50 : (0, $9MMkr.default).memberCount;
        const isMoreMembersOpen = (0, $5uXOq.useRef)(false);
        const onMoreClick = (0, $5uXOq.useCallback)(()=>{
            const { current: isOpen } = isMoreMembersOpen;
            if (!isOpen) analytics((duration)=>(0, $ivXTE.moreMembersClicked)({
                    duration: duration,
                    memberCount: count
                }));
            isMoreMembersOpen.current = !isOpen;
        }, [
            analytics,
            count
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MemberCount), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...message,
            values: {
                count: count
            }
        })), members && members.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AvatarSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: members.map((member, index)=>{
                const href = generateUserLink?.(member.id);
                const onClick = $3bb916baa86f0602$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                return {
                    key: member.id,
                    name: member.fullName,
                    src: member.avatarUrl,
                    href: href,
                    onClick: onClick
                };
            }),
            maxCount: 9,
            showMoreButtonProps: {
                onClick: onMoreClick
            },
            testId: "profilecard-avatar-group"
        })));
    };
    function $3bb916baa86f0602$var$onActionClick(action, analytics, index) {
        return (event, ...args)=>{
            analytics((duration)=>(0, $ivXTE.actionClicked)('team', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || ''
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        };
    }
    const $3bb916baa86f0602$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
        const isGiveKudosActionButton = action.id === $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID;
        const actionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            key: action.id || index,
            onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index),
            href: action.link,
            shouldFitContainer: true
        }, action.label, isGiveKudosActionButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
        if (isGiveKudosActionButton) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), null, actionButton);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, actionButton);
    };
    const $3bb916baa86f0602$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
        const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
        const count = actions.length;
        const onMoreClick = (0, $5uXOq.useCallback)((shouldBeOpen)=>{
            if (shouldBeOpen) analytics((duration)=>(0, $ivXTE.moreActionsClicked)('team', {
                    duration: duration,
                    numActions: count + 2
                }));
            setOpen(shouldBeOpen);
        }, [
            analytics,
            count
        ]);
        if (!count) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MoreButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setOpen(false),
            placement: "bottom-start",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                        onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index + 2),
                        key: action.id || index,
                        href: action.link
                    }, action.label))),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        spacing: "spacious",
                        label: "actions",
                        color: "currentColor"
                    })
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    };
    const $3bb916baa86f0602$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
        if (!actions) return null;
        const extraActions = actions.slice(2);
        const initialActions = actions.slice(0, 2);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, initialActions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ActionButton, {
                action: action,
                analytics: analytics,
                index: index,
                key: index
            })), extraActions && (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ExtraActions, {
            actions: extraActions,
            analytics: analytics
        }));
    };
    const $3bb916baa86f0602$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
        const allActions = [
            {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamViewProfile),
                link: viewProfileLink,
                callback: viewProfileOnClick,
                id: 'view-profile'
            },
            ...actions || []
        ];
        const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'content', {
                    duration: duration,
                    numActions: allActions.length,
                    memberCount: team.members?.length,
                    includingYou: includingYou,
                    descriptionLength: team.description.length,
                    titleLength: team.displayName.length
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: team.displayName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamName), null, team.displayName)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamMembers, {
            analytics: analytics,
            members: team.members,
            generateUserLink: generateUserLink,
            includingYou: includingYou,
            onUserClick: onUserClick
        }), team.description.trim() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.DescriptionWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.Description), null, team.description)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ButtonSection, {
            actions: allActions,
            analytics: analytics
        })));
    };
    const $3bb916baa86f0602$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
        const hasRetry = !!clientFetchProfile;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration,
                    hasRetry: hasRetry
                }));
        }, [
            analytics,
            hasRetry
        ]);
        const retry = (0, $5uXOq.useCallback)(()=>{
            analytics((duration)=>(0, $ivXTE.errorRetryClicked)({
                    duration: duration
                }));
            if (clientFetchProfile) clientFetchProfile();
        }, [
            analytics,
            clientFetchProfile
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "team-profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5HjZK.ErrorIllustration), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorText)), clientFetchProfile && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            testId: "client-fetch-profile-button",
            shouldFitContainer: true,
            onClick: retry,
            isLoading: isLoading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorButton)))));
    };
    const $3bb916baa86f0602$var$TeamProfileCard = (props)=>{
        const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
        if (hasError) {
            if (errorType?.reason === 'TEAMS_FORBIDDEN') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $drhKV.default), {
                analytics: analytics
            });
            else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
                "data-testid": "team-profilecard"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ErrorMessage, {
                analytics: analytics,
                clientFetchProfile: clientFetchProfile,
                isLoading: isLoading
            }));
        }
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
            analytics: analytics
        });
        if (team) return (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamProfilecardContent, {
            ...props,
            team: team
        });
        return null;
    };
    var $3bb916baa86f0602$export$2e2bcd8739ae039 = $3bb916baa86f0602$var$TeamProfileCard;
});
parcelRegister("iE5Av", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$cfab992fac525e86$export$6aa22a823032b784);
    $parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", ()=>$cfab992fac525e86$export$66ecf3d3b7b1c016);
    $parcel$export(module.exports, "CardHeader", ()=>$cfab992fac525e86$export$5665775b26e26c5d);
    $parcel$export(module.exports, "CardContent", ()=>$cfab992fac525e86$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "TeamName", ()=>$cfab992fac525e86$export$8fe6f0aed18a58c7);
    $parcel$export(module.exports, "MemberCount", ()=>$cfab992fac525e86$export$1cbd03a20253b620);
    $parcel$export(module.exports, "AvatarSection", ()=>$cfab992fac525e86$export$82a6f3ee677bdbfe);
    $parcel$export(module.exports, "DescriptionWrapper", ()=>$cfab992fac525e86$export$2bf1f2b0d31b60fc);
    $parcel$export(module.exports, "Description", ()=>$cfab992fac525e86$export$393edc798c47379d);
    $parcel$export(module.exports, "ActionButtons", ()=>$cfab992fac525e86$export$88c65d2d98aab183);
    $parcel$export(module.exports, "WrappedButton", ()=>$cfab992fac525e86$export$44e087c32db6077d);
    $parcel$export(module.exports, "MoreButton", ()=>$cfab992fac525e86$export$7f94856880993f27);
    $parcel$export(module.exports, "LoadingWrapper", ()=>$cfab992fac525e86$export$43a792a870d28db2);
    $parcel$export(module.exports, "AccessLockSVGWrapper", ()=>$cfab992fac525e86$export$71bcd744fda975e5);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $cfab992fac525e86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $cfab992fac525e86$export$a443be8291b92497 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f414"
    })({
        name: "ck88l6",
        styles: "display:inherit"
    });
    const $cfab992fac525e86$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f413"
    })({
        backgroundColor: (0, $huHkE.bgColor),
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`,
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
    });
    const $cfab992fac525e86$export$66ecf3d3b7b1c016 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f412"
    })({
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative'
    });
    const $cfab992fac525e86$export$5665775b26e26c5d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f411"
    })("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $huHkE.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 16, "px;");
    const $cfab992fac525e86$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f410"
    })({
        display: 'flex',
        flexDirection: 'column',
        padding: "var(--ds-space-300, 24px)",
        minHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 13}px`
    });
    const $cfab992fac525e86$export$8fe6f0aed18a58c7 = (0, $bWGt6.default)("h6", {
        target: "e1kkd6f49"
    })((0, (0, parcelRequire("3RZIb")).h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
    const $cfab992fac525e86$export$1cbd03a20253b620 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f48"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-050, 4px)"
    });
    const $cfab992fac525e86$export$82a6f3ee677bdbfe = (0, $bWGt6.default)("div", {
        target: "e1kkd6f47"
    })({
        name: "li9rw7",
        styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
    });
    const $cfab992fac525e86$export$2bf1f2b0d31b60fc = (0, $bWGt6.default)("div", {
        target: "e1kkd6f46"
    })({
        name: "vi4bqq",
        styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
    });
    const $cfab992fac525e86$export$393edc798c47379d = (0, $bWGt6.default)("span", {
        target: "e1kkd6f45"
    })({
        name: "yog5y2",
        styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
    });
    const $cfab992fac525e86$export$88c65d2d98aab183 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f44"
    })({
        width: 'calc(100% + 8px)',
        display: 'flex',
        justifyContent: 'space-between',
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
        backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
    });
    const $cfab992fac525e86$export$44e087c32db6077d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f43"
    })({
        name: "1svotkm",
        styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$7f94856880993f27 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f42"
    })({
        name: "9kivhj",
        styles: "margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$43a792a870d28db2 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f41"
    })({
        name: "o13o72",
        styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
    });
    const $cfab992fac525e86$export$71bcd744fda975e5 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f40"
    })({
        name: "ifz8jz",
        styles: "margin-bottom:var(--ds-space-300, 24px)"
    });
});
parcelRegister("drhKV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3602a6790b0d2a05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hTEpF;
    var $9MMkr = parcelRequire("9MMkr");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $fMbSw = parcelRequire("fMbSw");
    var $3602a6790b0d2a05$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamForbiddenErrorStateWrapper), {
            "data-testid": "team-profilecard-forbidden-error-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateTitle),
            description: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateDescription),
            renderImage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AccessLockSVGWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fMbSw.default), null))
        }));
    };
});
parcelRegister("fMbSw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3cdb196cf5a3a60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $f3cdb196cf5a3a60$var$AccessLockSVG = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "191",
            height: "222",
            viewBox: "0 0 191 222",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            style: {
                mixBlendMode: 'multiply'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
            fill: "#FFE380"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
            fill: "#253858"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
            fill: "#FFFAE5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white"
        }))));
    };
    var $f3cdb196cf5a3a60$export$2e2bcd8739ae039 = $f3cdb196cf5a3a60$var$AccessLockSVG;
});
parcelRegister("devOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d55bb5393d16af5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $7d55bb5393d16af5$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'spinner', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            isLoading: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.LoadingWrapper), {
            "data-testid": "team-profilecard-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null))));
    };
});
parcelRegister("lrMir", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ProfilecardInternal", ()=>$4585e7f6ae851e43$export$64e0275ede8ab792);
    $parcel$export(module.exports, "default", ()=>$4585e7f6ae851e43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $ujWmd;
    var $fVnbM;
    var $jhVLw;
    var $eZJjh;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $jHIf5 = parcelRequire("jHIf5");
    var $cfBc7 = parcelRequire("cfBc7");
    const $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    const $4585e7f6ae851e43$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
        const kudosUrl = (0, $5uXOq.useMemo)(()=>{
            const recipientId = userId ? `&recipientId=${userId}` : '';
            const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
            return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
        }, [
            cloudId,
            teamCentralBaseUrl,
            userId
        ]);
        const kudosButtonCallback = (0, $5uXOq.useCallback)(()=>{
            if (openKudosDrawer) openKudosDrawer();
            else window.open(kudosUrl);
        }, [
            kudosUrl,
            openKudosDrawer
        ]);
        const kudosAction = (0, $5uXOq.useMemo)(()=>{
            return {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                id: $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID,
                callback: kudosButtonCallback,
                link: kudosUrl
            };
        }, [
            kudosButtonCallback,
            kudosUrl
        ]);
        return {
            kudosAction: kudosAction,
            kudosButtonCallback: kudosButtonCallback,
            kudosUrl: kudosUrl
        };
    };
    const $4585e7f6ae851e43$var$Wrapper = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testid": "profilecard",
            role: "dialog",
            "aria-labelledby": "profilecard-name-label"
        }, props.children);
    const $4585e7f6ae851e43$export$64e0275ede8ab792 = (props)=>{
        const [openTime] = (0, $5uXOq.useState)((0, $6TKEY.getPageTime)());
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const fireAnalyticsWithDuration = (0, $5uXOq.useCallback)((generator)=>{
            const elapsed = (0, $6TKEY.getPageTime)() - openTime;
            const event = generator(elapsed);
            fireAnalytics(event);
        }, [
            fireAnalytics,
            openTime
        ]);
        const { kudosAction: kudosAction } = $4585e7f6ae851e43$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
        const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
        const realActions = (0, $5uXOq.useMemo)(()=>{
            if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
            return actions.concat([
                kudosAction
            ]);
        }, [
            actions,
            isCurrentUser,
            isKudosEnabled,
            kudosAction,
            status
        ]);
        const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
        const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
        (0, $5uXOq.useEffect)(()=>{
            if (canRender) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'content', {
                    duration: duration,
                    numActions: realActions.length
                }));
        }, [
            canRender,
            fireAnalyticsWithDuration,
            realActions
        ]);
        if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: props.clientFetchProfile,
            errorType: props.errorType || null,
            fireAnalytics: fireAnalytics
        }));
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$LoadingView, {
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }));
        if (!canRender) return null;
        const isDisabledUser = status === 'inactive' || status === 'closed';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContainer), {
            isDisabledUser: isDisabledUser,
            withoutElevation: props.withoutElevation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ProfileImage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xlarge",
            src: status !== 'closed' ? props.avatarUrl : undefined,
            borderColor: `var(--ds-shadow-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cfBc7.ProfileCardDetails), {
            ...props,
            status: status,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }), realActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionsFlexSpacer), null), (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Actions, {
            actions: realActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
        })))));
    };
    const $4585e7f6ae851e43$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
        const onActionClick = (0, $5uXOq.useCallback)((action, args, event, index)=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.actionClicked)('user', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || 'no-id-specified'
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        }, [
            fireAnalyticsWithDuration
        ]);
        if (!actions || actions.length === 0) return null;
        const regularActions = actions.slice(0, (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD));
        const overflowActions = actions.length > (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $jHIf5.ACTION_OVERFLOW_THRESHOLD)) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionButtonGroup), {
            "data-testid": "profilecard-actions"
        }, regularActions.map((action, index)=>{
            const isKudos = action.id === $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID;
            const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
                isInset: true,
                key: `profile-card-action-focus-ring_${action.id || index}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "default",
                key: action.id || index,
                onClick: (event, ...args)=>onActionClick(action, args, event, index),
                href: action.link,
                autoFocus: index === 0 && isTriggeredUsingKeyboard
            }, action.label, isKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
            if (isKudos) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), {
                key: `profile-card-action-kudos_${action.id || index}`
            }, button);
            return button;
        }), overflowActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jHIf5.OverflowProfileCardButtons), {
            actions: overflowActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD))
        }));
    };
    const $4585e7f6ae851e43$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'spinner', {
                    duration: duration
                }));
        }, [
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), {
            "data-testid": "profilecard-spinner-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $4585e7f6ae851e43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($4585e7f6ae851e43$export$64e0275ede8ab792);
});
parcelRegister("jHIf5", function(module, exports) {
    $parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", ()=>$c3d6d65db2db7a42$export$3e2419a7546ad45e);
    $parcel$export(module.exports, "OverflowProfileCardButtons", ()=>$c3d6d65db2db7a42$export$9d9b53d23c0df7a1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9yOBd;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $c3d6d65db2db7a42$export$3e2419a7546ad45e = 2;
    const $c3d6d65db2db7a42$export$9d9b53d23c0df7a1 = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [, setOpen] = (0, $5uXOq.useState)(false);
        const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
        const numActions = actions.length + $c3d6d65db2db7a42$export$3e2419a7546ad45e;
        const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: nextOpen })=>{
            setOpen((prevOpen)=>{
                if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.moreActionsClicked)('user', {
                        duration: duration,
                        numActions: numActions
                    }));
                return nextOpen;
            });
        }, [
            numActions,
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.OverflowActionButtonsWrapper), {
            "data-testid": "profilecard-actions-overflow"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            onOpenChange: onOpenChange,
            placement: 'bottom-end',
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intl.formatMessage((0, $9MMkr.default).profileCardMoreIconLabel)
                    })
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: action.id,
                onClick: (event, ...args)=>{
                    onItemClick(action, args, event, index);
                },
                href: action.link
            }, action.label)))));
    };
});
parcelRegister("cfBc7", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardDetails", ()=>$5c33ece4bf360f1e$export$c0e6870b898eb99d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $lj8SI;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $hljsi = parcelRequire("hljsi");
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    parcelRequire("kyz3w");
    var $kXUaX = parcelRequire("kXUaX");
    var $htJ3O = parcelRequire("htJ3O");
    const $5c33ece4bf360f1e$var$detailedListWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        padding: 'space.0'
    });
    const $5c33ece4bf360f1e$var$fullNameLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        letterSpacing: 'normal',
        lineHeight: `${24 / 18}em`
    });
    const $5c33ece4bf360f1e$var$noMetaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.400',
        marginRight: '0',
        marginBottom: 'space.150',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$metaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150',
        marginRight: '0',
        marginBottom: '0',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$disabledAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text'
    });
    const $5c33ece4bf360f1e$var$activeAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.inverse'
    });
    const $5c33ece4bf360f1e$var$renderName = (nickname, fullName, meta)=>{
        if (!fullName && !nickname) return null;
        const isNicknameRedundant = !nickname || nickname === fullName;
        const shownNickname = ` (${nickname}) `;
        const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$activeAccountStyles,
                meta ? $5c33ece4bf360f1e$var$metaLabelStyles : $5c33ece4bf360f1e$var$noMetaLabelStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: !meta,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
    };
    const $5c33ece4bf360f1e$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
        if (disabledAccountMessage) return disabledAccountMessage;
        const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
        const relativeDateKey = (0, $hljsi.default)(date);
        const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
        const secondSentence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default)[msgKey]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            testId: "profilecard-disabled-account"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).generalDescMsgForDisabledUser), " ", secondSentence);
    };
    const $5c33ece4bf360f1e$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
        if (lozenges.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                ...otherProps,
                key: index
            }, text)));
    };
    const $5c33ece4bf360f1e$var$BotProfileCardDetails = (props)=>{
        const { fullName: fullName, nickname: nickname } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(nickname, fullName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AppTitleLabel), null, "App"));
    };
    const $5c33ece4bf360f1e$var$DisabledProfileCardDetails = (props)=>{
        const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
        const name = status === 'inactive' ? fullName || nickname : nickname || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).disabledAccountDefaultName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$noMetaLabelStyles,
                $5c33ece4bf360f1e$var$disabledAccountStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, name) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: true,
            isDisabledAccount: true,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, name), hasDisabledAccountLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.LozengeWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default",
            isBold: true
        }, status === 'inactive' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).inactiveAccountMsg) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).closedAccountMsg))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DisabledInfo), null, $5c33ece4bf360f1e$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, companyName));
    };
    const $5c33ece4bf360f1e$export$c0e6870b898eb99d = (props)=>{
        const { meta: meta, status: status } = props;
        if (props.isBot) return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$BotProfileCardDetails, props);
        if (status === 'inactive' || status === 'closed') return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$DisabledProfileCardDetails, {
            ...props,
            status: status
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(props.nickname, props.fullName, meta), meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.JobTitleLabel), null, meta), (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$CustomLozenges, {
            lozenges: props.customLozenges
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "dl",
            xcss: $5c33ece4bf360f1e$var$detailedListWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "email"
        }, props.email), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "time"
        }, props.timestring), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, props.companyName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "location"
        }, props.location)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $htJ3O.default), {
            reportingLines: props.reportingLines,
            reportingLinesProfileUrl: props.reportingLinesProfileUrl,
            onReportingLinesClick: props.onReportingLinesClick,
            fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
        }));
    };
});
parcelRegister("hljsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a208e25df4a65e86$export$2e2bcd8739ae039);
    var $kMWS1;
    var $f0lG8;
    var $ki4Ey;
    var $jovBr;
    function $a208e25df4a65e86$export$c03bb0116ee09d4b(date, today = new Date()) {
        return !!date.getTime && (0, (0, parcelRequire("jovBr")).default)(date) && date.getTime() <= today.getTime();
    }
    function $a208e25df4a65e86$export$2e2bcd8739ae039(date, today = new Date()) {
        if (!date || !$a208e25df4a65e86$export$c03bb0116ee09d4b(date, today)) return null;
        if ((0, (0, parcelRequire("ki4Ey")).default)(date)) return 'ThisWeek';
        if ((0, (0, parcelRequire("f0lG8")).default)(date)) return 'ThisMonth';
        if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
        const diffInMonths = (0, (0, parcelRequire("kMWS1")).default)(today, date);
        if (diffInMonths < 6) return 'AFewMonths';
        if (diffInMonths <= 12) return 'SeveralMonths';
        return 'MoreThanAYear';
    }
});
parcelRegister("kyz3w", function(module, exports) {
    $parcel$export(module.exports, "IconLabel", ()=>(parcelRequire("kXUaX")).default);
    var $kXUaX = parcelRequire("kXUaX");
});
parcelRegister("kXUaX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd3f55567e0e46d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8yYK6;
    var $aVnO1;
    var $cKlYO;
    var $jRceo;
    var $jnj6z = parcelRequire("jnj6z");
    const $9fd3f55567e0e46d$var$icons = {
        location: (0, ($parcel$interopDefault((0, parcelRequire("cKlYO"))))),
        time: (0, ($parcel$interopDefault((0, parcelRequire("8yYK6"))))),
        email: (0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))),
        companyName: (0, ($parcel$interopDefault((0, parcelRequire("jRceo")))))
    };
    class $9fd3f55567e0e46d$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                icon: ''
            };
        }
        render() {
            if (!this.props.children) return null;
            const IconElement = this.props.icon && $9fd3f55567e0e46d$var$icons[this.props.icon];
            const displayIcon = IconElement ? (0, ($parcel$interopDefault($5uXOq))).createElement(IconElement, {
                label: `${this.props.icon}`,
                LEGACY_size: "small",
                color: "currentColor"
            }) : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabel), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelIcon), {
                as: "dt"
            }, displayIcon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelText), {
                as: "dd"
            }, this.props.children));
        }
    }
});
parcelRegister("8yYK6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63c09dee2c4be134$var$_react = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63c09dee2c4be134$var$_clock = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("hyKRO")));
    var $63c09dee2c4be134$var$_recent = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5IlYG")));
    function $63c09dee2c4be134$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63c09dee2c4be134$var$ClockIcon = (props)=>$63c09dee2c4be134$var$_react.default.createElement($63c09dee2c4be134$var$_clock.default, Object.assign({
            LEGACY_fallbackIcon: $63c09dee2c4be134$var$_recent.default
        }, props));
    $63c09dee2c4be134$var$ClockIcon.Name = 'ClockIconMigration';
    var $63c09dee2c4be134$var$_default = module.exports.default = $63c09dee2c4be134$var$ClockIcon;
});
parcelRegister("aVnO1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));
    var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
    function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f41b19bed4136e0$var$EmailIcon = (props)=>$7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
        }, props));
    $7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
    var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;
});
parcelRegister("eRB05", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad22b76beceec928$var$_UNSAFE_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad22b76beceec928$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad22b76beceec928$var$EmailIcon = (props)=>$ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
    var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;
});
parcelRegister("5bEkJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
    function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3c6d443366bf8cbb$var$EmailIcon = (props)=>$3c6d443366bf8cbb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $3c6d443366bf8cbb$var$_email.default
        }));
    $3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
    var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;
});
parcelRegister("cKlYO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $947ad4a84d881cd0$var$_react = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $947ad4a84d881cd0$var$_location = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("d3xMd")));
    var $947ad4a84d881cd0$var$_location2 = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("773gM")));
    function $947ad4a84d881cd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $947ad4a84d881cd0$var$LocationIcon = (props)=>$947ad4a84d881cd0$var$_react.default.createElement($947ad4a84d881cd0$var$_location.default, Object.assign({
            LEGACY_fallbackIcon: $947ad4a84d881cd0$var$_location2.default
        }, props));
    $947ad4a84d881cd0$var$LocationIcon.Name = 'LocationIconMigration';
    var $947ad4a84d881cd0$var$_default = module.exports.default = $947ad4a84d881cd0$var$LocationIcon;
});
parcelRegister("d3xMd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9815c17f4ba43822$var$_react = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9815c17f4ba43822$var$_UNSAFE_baseNew = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9815c17f4ba43822$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9815c17f4ba43822$var$LocationIcon = (props)=>$9815c17f4ba43822$var$_react.default.createElement($9815c17f4ba43822$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
        }, props));
    $9815c17f4ba43822$var$LocationIcon.displayName = 'LocationIcon';
    var $9815c17f4ba43822$var$_default = module.exports.default = $9815c17f4ba43822$var$LocationIcon;
});
parcelRegister("773gM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $52dbb9250ec5d302$var$_react = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $52dbb9250ec5d302$var$_location = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("d3xMd")));
    function $52dbb9250ec5d302$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $52dbb9250ec5d302$var$LocationIcon = (props)=>$52dbb9250ec5d302$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
        }, props, {
            newIcon: $52dbb9250ec5d302$var$_location.default
        }));
    $52dbb9250ec5d302$var$LocationIcon.displayName = 'LocationIcon';
    var $52dbb9250ec5d302$var$_default = module.exports.default = $52dbb9250ec5d302$var$LocationIcon;
});
parcelRegister("jRceo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e74c746303d0418a$var$_react = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e74c746303d0418a$var$_officeBuilding = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    var $e74c746303d0418a$var$_officeBuilding2 = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("icDh5")));
    function $e74c746303d0418a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e74c746303d0418a$var$OfficeBuildingIcon = (props)=>$e74c746303d0418a$var$_react.default.createElement($e74c746303d0418a$var$_officeBuilding.default, Object.assign({
            LEGACY_fallbackIcon: $e74c746303d0418a$var$_officeBuilding2.default
        }, props));
    $e74c746303d0418a$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
    var $e74c746303d0418a$var$_default = module.exports.default = $e74c746303d0418a$var$OfficeBuildingIcon;
});
parcelRegister("4bTdk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30d304d6d8375db3$var$_UNSAFE_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $30d304d6d8375db3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>$30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
        }, props));
    $30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;
});
parcelRegister("icDh5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    function $d407d01834f2f44a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>$d407d01834f2f44a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
        }, props, {
            newIcon: $d407d01834f2f44a$var$_officeBuilding.default
        }));
    $d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;
});
parcelRegister("htJ3O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7034dd6b25e87bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $ujWmd;
    var $jnhNB;
    var $fVnbM;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $9MMkr = parcelRequire("9MMkr");
    var $aLmg4 = parcelRequire("aLmg4");
    var $ivXTE = parcelRequire("ivXTE");
    function $b7034dd6b25e87bb$var$getProfileHref(userId, profileUrl) {
        return profileUrl ? profileUrl + userId : undefined;
    }
    const $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: 'font.heading.xxsmall',
        fontWeight: 600,
        marginBottom: 'space.100'
    });
    const $b7034dd6b25e87bb$var$reportingLinesHeadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: '0'
    });
    const $b7034dd6b25e87bb$var$ReportingLinesDetails = (props)=>{
        const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
        const { managers: managers = [], reports: reports = [] } = reportingLines;
        const manager = managers.length >= 1 ? managers[0] : undefined;
        const hasReports = reports.length > 0;
        const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
                fireAnalyticsWithDuration((duration)=>(0, $ivXTE.reportingLinesClicked)({
                        duration: duration,
                        userType: userType
                    }));
                onReportingLinesClick(user);
            } : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, manager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles,
                $b7034dd6b25e87bb$var$reportingLinesHeadingStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), {
            style: {
                marginBottom: 0
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.OffsetWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            href: $b7034dd6b25e87bb$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
            onClick: getReportingLinesOnClick(manager, 'manager'),
            isDisabled: !onReportingLinesClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: manager.pii?.picture
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerName), null, manager.pii?.name))))), hasReports && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            size: "small",
            data: reports.map((member)=>{
                return {
                    key: member.accountIdentifier,
                    name: member.pii?.name || '',
                    src: member.pii?.picture,
                    href: $b7034dd6b25e87bb$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                    onClick: getReportingLinesOnClick(member, 'direct-report')
                };
            }),
            maxCount: 5,
            testId: "profilecard-reports-avatar-group"
        })));
    };
    var $b7034dd6b25e87bb$export$2e2bcd8739ae039 = $b7034dd6b25e87bb$var$ReportingLinesDetails;
});
parcelRegister("aLmg4", function(module, exports) {
    $parcel$export(module.exports, "ReportingLinesSection", ()=>$feff5fbdc7496043$export$ae48ddd79a45b949);
    $parcel$export(module.exports, "ReportingLinesHeading", ()=>$feff5fbdc7496043$export$abdd342d30bb5b5f);
    $parcel$export(module.exports, "ManagerSection", ()=>$feff5fbdc7496043$export$2992b481dad9fb03);
    $parcel$export(module.exports, "ManagerName", ()=>$feff5fbdc7496043$export$98f8ec89e658b052);
    $parcel$export(module.exports, "OffsetWrapper", ()=>$feff5fbdc7496043$export$56eae56612ce5f3);
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $feff5fbdc7496043$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $feff5fbdc7496043$export$ae48ddd79a45b949 = (0, $bWGt6.default)("div", {
        target: "e11fux8a4"
    })({
        name: "1m5erzj",
        styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$abdd342d30bb5b5f = (0, $bWGt6.default)("h3", {
        target: "e11fux8a3"
    })({
        color: (0, $huHkE.appLabelTextColor),
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        marginBottom: "var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$2992b481dad9fb03 = (0, $bWGt6.default)("div", {
        target: "e11fux8a2"
    })({
        display: 'flex',
        alignItems: 'center',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $feff5fbdc7496043$export$98f8ec89e658b052 = (0, $bWGt6.default)("span", {
        target: "e11fux8a1"
    })({
        name: "1y3q7as",
        styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$56eae56612ce5f3 = (0, $bWGt6.default)("div", {
        target: "e11fux8a0"
    })({
        name: "ysolxb",
        styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
    });
});
parcelRegister("d4FHw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e50495f0c6da843b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $4sfdL = parcelRequire("4sfdL");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $lrMir = parcelRequire("lrMir");
    var $ifxzB = parcelRequire("ifxzB");
    class $e50495f0c6da843b$var$ProfileCardResourced extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: []
            };
        }
        componentDidMount() {
            this._isMounted = true;
            this.clientFetchProfile();
        }
        componentDidUpdate(prevProps) {
            const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
            if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
        }
        handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: profileData,
                reportingLinesData: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        render() {
            const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled, teamCentralBaseUrl: teamCentralBaseUrl } = this.state;
            const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
            const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
            if (isFetchingOrNotStartToFetchYet) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
                fireAnalytics: this.fireAnalytics
            }));
            else if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
                "data-testid": "profile-card-resourced-error-state"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
                errorType: error,
                reload: this.clientFetchProfile,
                fireAnalytics: this.fireAnalytics
            }));
            const newProps = {
                hasError: hasError,
                errorType: error,
                clientFetchProfile: this.clientFetchProfile,
                reportingLines: reportingLinesData,
                onReportingLinesClick: onReportingLinesClick,
                cloudId: cloudId,
                userId: userId,
                addFlag: addFlag,
                ...data,
                isKudosEnabled: isKudosEnabled,
                teamCentralBaseUrl: teamCentralBaseUrl,
                openKudosDrawer: this.openKudosDrawer
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isKudosEnabled && newProps.teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                    recipientId: this.props.userId
                },
                analyticsSource: "profile-card",
                teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                cloudId: this.props.cloudId,
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lrMir.default), {
                ...newProps,
                actions: this.filterActions()
            })));
        }
        constructor(...args){
            super(...args), this._isMounted = false, this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                reportingLinesData: undefined,
                isKudosEnabled: false,
                kudosDrawerOpen: false,
                teamCentralBaseUrl: undefined
            }, this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            }, this.clientFetchProfile = ()=>{
                const { cloudId: cloudId, userId: userId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    hasError: false,
                    data: null
                }, ()=>{
                    const requests = Promise.all([
                        this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                        this.props.resourceClient.getReportingLines(userId),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            }, this.filterActions = ()=>(0, $4sfdL.default)(this.props.actions, this.state.data), this.openKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: true
                });
            }, this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            };
        }
    }
    const $e50495f0c6da843b$export$a6d9ff68ecba3be5 = $e50495f0c6da843b$var$ProfileCardResourced;
    var $e50495f0c6da843b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($e50495f0c6da843b$var$ProfileCardResourced);
});
parcelRegister("ifxzB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44786ae639641a68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
        }, [
            fireAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;
});
parcelRegister("264zF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74b3c02273951832$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $chprS = parcelRequire("chprS");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $kDbj5 = parcelRequire("kDbj5");
    var $dYuIx = parcelRequire("dYuIx");
    var $ifxzB = parcelRequire("ifxzB");
    function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
        if (isAgent && (0, (0, parcelRequire("VSDnB")).fg)('enable_agent_profile_card')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kDbj5.AgentProfileCardResourced), {
            accountId: userId,
            cloudId: cloudId,
            resourceClient: resourceClient,
            viewingUserId: viewingUserId,
            trigger: trigger,
            product: product,
            onChatClick: agentActions?.onChatClick,
            onConversationStartersClick: agentActions?.onConversationStartersClick,
            addFlag: addFlag
        });
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        }));
    }
    function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isMounted = (0, $5uXOq.useRef)(false);
        const showDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
        const hideDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
        const [hasError, setHasError] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
        const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
        const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
        const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
        const triggerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            setIsLoading(undefined);
            setHasError(false);
            setError(null);
            setData(null);
            setReportingLinesData(undefined);
            setShouldShowGiveKudos(false);
            setTeamCentralBaseUrl(undefined);
        }, [
            userId
        ]);
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (!isMounted.current) return;
            (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
                onVisibilityChange && onVisibilityChange(false);
            }, hideDelay);
        }, [
            hideDelay,
            isTriggeredUsingKeyboard,
            onVisibilityChange
        ]);
        const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
            if (event.key && event.key !== 'Escape') return;
            if (triggerRef.current) triggerRef.current.focus();
            setTriggeredUsingKeyboard(false);
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, [
            setTriggeredUsingKeyboard,
            setVisible,
            onVisibilityChange
        ]);
        const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(false);
            setData(profileData);
            setReportingLinesData(reportingLinesData);
            setTeamCentralBaseUrl(teamCentralBaseUrl);
            setShouldShowGiveKudos(shouldShowGiveKudos);
        }, [
            setHasError,
            setIsLoading,
            setData,
            setReportingLinesData,
            setShouldShowGiveKudos
        ]);
        const handleClientError = (0, $5uXOq.useCallback)((err)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(true);
            setError(err);
        }, [
            setHasError,
            setIsLoading,
            setError
        ]);
        const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
            if (isLoading === true) return;
            setIsLoading(true);
            setHasError(false);
            setError(null);
            setData(null);
            try {
                const requests = Promise.all([
                    resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                    resourceClient.getReportingLines(userId),
                    resourceClient.shouldShowGiveKudos(),
                    resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                const responses = await requests;
                handleClientSuccess(...responses);
            } catch (err) {
                handleClientError(err);
            }
        }, [
            cloudId,
            fireAnalytics,
            isLoading,
            resourceClient,
            userId,
            handleClientSuccess,
            handleClientError
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    clientFetchProfile();
                    setVisible(true);
                    onVisibilityChange && onVisibilityChange(true);
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            clientFetchProfile,
            onVisibilityChange
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setTriggeredUsingKeyboard(true);
                showProfilecard();
                if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
            }
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        const filterActions = (0, $5uXOq.useCallback)(()=>{
            return (0, $4sfdL.default)(actions, data);
        }, [
            actions,
            data
        ]);
        const openKudosDrawer = ()=>{
            hideProfilecard();
            setKudosDrawerOpen(true);
        };
        const closeKudosDrawer = ()=>{
            setKudosDrawerOpen(false);
        };
        const showLoading = isLoading === true || isLoading === undefined;
        const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: onFocus
            } : {}, [
            hideProfilecard,
            onFocus,
            onMouseEnter,
            trigger
        ]);
        const profilecardProps = {
            userId: userId,
            fullName: prepopulatedData?.fullName,
            isCurrentUser: userId === viewingUserId,
            clientFetchProfile: clientFetchProfile,
            ...data,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            openKudosDrawer: openKudosDrawer,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            disabledAriaAttributes: disabledAriaAttributes
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!visible,
            onClose: (event)=>{
                hideProfilecard();
                handleKeyboardClose(event);
            },
            placement: position,
            offset: offset ?? [
                0,
                8
            ],
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", wrapperProps, showLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$LoadingView, {
                    fireAnalytics: fireAnalytics
                }) : visible && (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$ProfileCardContent, {
                    profilecardProps: profilecardProps,
                    isAgent: !!data?.isAgent,
                    userId: userId,
                    cloudId: cloudId,
                    resourceClient: resourceClient,
                    viewingUserId: viewingUserId,
                    trigger: trigger,
                    product: product,
                    profileCardAction: filterActions(),
                    errorType: error,
                    hasError: hasError,
                    agentActions: agentActions,
                    addFlag: addFlag
                })),
            trigger: (triggerProps)=>{
                const { ref: callbackRef, ...innerProps } = triggerProps;
                const ref = (element)=>{
                    triggerRef.current = element;
                    if (typeof callbackRef === 'function') callbackRef(element);
                };
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ...containerListeners,
                    ref: ref,
                    "data-testid": testId,
                    "aria-labelledby": ariaLabelledBy,
                    ...disabledAriaAttributes ? {} : {
                        role: 'button',
                        tabIndex: 0,
                        'aria-label': (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                    }
                }, children);
            },
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: autoFocus ?? trigger === 'click',
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }), shouldShowGiveKudos && teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
            isOpen: kudosDrawerOpen,
            recipient: {
                type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                recipientId: userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            addFlag: addFlag,
            onClose: closeKudosDrawer
        })));
    }
    const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testId": "profilecard.profilecardtrigger.loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        }));
});
parcelRegister("chprS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b051cf4c3ebf799$export$2e2bcd8739ae039);
    var $7VHMR;
    const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
        if (ariaLabelProp) return ariaLabelProp;
        return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
            fullName: fullName
        }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
    };
    const $4b051cf4c3ebf799$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fallbackLabel: {
            id: 'profilecard.user.trigger.fallback-aria-label',
            defaultMessage: 'More information about this user',
            description: 'Label for profile card trigger when we do not have user name'
        },
        label: {
            id: 'profilecard.user.trigger.aria-label',
            defaultMessage: 'More information about {fullName}',
            description: 'Label for profile card trigger'
        }
    });
    var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;
});
parcelRegister("kDbj5", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardResourced", ()=>$9f87d208f89c63eb$export$4b013ffffcb40af8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $cI0Td = parcelRequire("cI0Td");
    var $a3FJs = parcelRequire("a3FJs");
    var $iwWWV = parcelRequire("iwWWV");
    const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
        const [agentData, setAgentData] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
            agentData?.creator_type,
            agentData?.creator
        ]);
        const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    try {
                        if (!creatorUserId || !props.cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${creatorUserId}`,
                            id: creatorUserId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        }, [
            creatorUserId,
            fireAnalytics,
            props.cloudId,
            props.resourceClient
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setIsLoading(true);
            try {
                const profileData = await props.resourceClient.getRovoAgentProfile({
                    type: 'identity',
                    value: props.accountId
                }, fireAnalytics);
                const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
                setAgentData({
                    ...profileData,
                    creatorInfo: agentCreatorInfo
                });
            } catch (err) {
                setError(err);
            } finally{
                setIsLoading(false);
            }
        }, [
            fireAnalytics,
            getCreator,
            props.accountId,
            props.resourceClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchData();
        }, [
            fetchData
        ]);
        if (error || !isLoading && !agentData) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        }));
    };
});
parcelRegister("dG58U", function(module, exports) {
    $parcel$export(module.exports, "getAAIDFromARI", ()=>$dd4eeae2be471029$export$3761e66a04602cbd);
    const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
    const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
        return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
    };
});
parcelRegister("iwWWV", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardLazy", ()=>$b487397875f853f0$export$ed0ca9c1d49ea0bf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b487397875f853f0$export$ed0ca9c1d49ea0bf = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("9gV7o"))));
});
parcelRegister("dYuIx", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardLazy", ()=>$78b4a66e55984f2d$export$403d297463f226af);
    var $5uXOq = parcelRequire("5uXOq");
    const $78b4a66e55984f2d$export$403d297463f226af = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lrMir"))));
});
parcelRegister("iMLpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70b57d5fcda0f9a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    function $70b57d5fcda0f9a2$export$2e2bcd8739ae039(Component) {
        return class WithOuterListeners extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            componentDidMount() {
                if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
            }
            componentWillUnmount() {
                if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, this.props);
            }
            constructor(...args){
                super(...args), this.handleClick = (evt)=>{
                    const { handleClickOutside: handleClickOutside } = this.props;
                    if (handleClickOutside) {
                        const domNode = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                        if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                    }
                }, this.handleKeydown = (evt)=>{
                    const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                    if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
                };
            }
        };
    }
});
parcelRegister("5uVl7", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>$50f554e79ae2423e$export$64983741fea6a45d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $3j5Lk = parcelRequire("3j5Lk");
    var $iwWWV = parcelRequire("iwWWV");
    const $50f554e79ae2423e$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
        const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const getCreator = async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'FORGE':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    const userId = (0, $dG58U.getAAIDFromARI)(creator) || '';
                    try {
                        if (!userId || !cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${userId}`,
                            id: userId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        };
        const fetchAgentProfile = async ()=>{
            const agentInfo = await resourceClient.getRovoAgentProfile({
                type: 'agent',
                value: userId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
            return {
                ...agentInfo,
                creatorInfo: agentCreatorInfo
            };
        };
        const renderProfileCard = ({ profileData: profileData, error: error })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                isCreatedByViewingUser: profileData?.creatorInfo && profileData?.creatorInfo?.id === viewingUserId,
                cloudId: props.cloudId,
                product: product,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                addFlag: props.addFlag
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3j5Lk.default), {
            ...props,
            trigger: "hover",
            renderProfileCard: renderProfileCard,
            fetchProfile: fetchAgentProfile,
            fireAnalytics: fireAnalytics,
            profileCardType: "agent"
        });
    };
});
parcelRegister("3j5Lk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16aed3e91811a6aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $k5uoT;
    var $ivXTE = parcelRequire("ivXTE");
    var $hHa0v = parcelRequire("hHa0v");
    var $8qsT1 = parcelRequire("8qsT1");
    var $iRPRU = parcelRequire("iRPRU");
    var $glChS = parcelRequire("glChS");
    const $16aed3e91811a6aa$var$DELAY_MS_SHOW = 800;
    const $16aed3e91811a6aa$var$DELAY_MS_HIDE = 200;
    function $16aed3e91811a6aa$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
        const showDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_SHOW;
        const hideDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_HIDE;
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $hHa0v.useProfileInfo)({
            fetchUserProfile: fetchProfile
        });
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
            }, hideDelay);
        }, [
            hideDelay
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(async ()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    getProfileData?.();
                    setVisible(true);
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.cardTriggered)(profileCardType, trigger));
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            getProfileData,
            fireAnalytics,
            profileCardType,
            trigger
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            ...popupProps,
            isOpen: !!visible,
            onClose: hideProfilecard,
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: popupProps.autoFocus ?? trigger === 'click',
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldFitContainer: false,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iRPRU.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger
                });
            },
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: hideProfilecard,
                    onFocus: showProfilecard
                }, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $glChS.ProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
                    fireAnalytics: fireAnalytics,
                    profileType: profileCardType
                })) : renderProfileCard({
                    profileData: profileData,
                    error: error
                }))
        });
    }
    var $16aed3e91811a6aa$export$2e2bcd8739ae039 = $16aed3e91811a6aa$var$ProfileCardTrigger;
});
parcelRegister("hHa0v", function(module, exports) {
    $parcel$export(module.exports, "useProfileInfo", ()=>$1015119dde638e8f$export$6cace87f7d7a9738);
    var $5uXOq = parcelRequire("5uXOq");
    const $1015119dde638e8f$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [profileData, setProfileData] = (0, $5uXOq.useState)();
        const getProfileData = async ()=>{
            setIsLoading(true);
            try {
                const profileData = await fetchUserProfile?.();
                setProfileData(profileData);
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };
        return {
            profileData: profileData,
            isLoading: isLoading,
            error: error,
            getProfileData: getProfileData
        };
    };
});
parcelRegister("iRPRU", function(module, exports) {
    $parcel$export(module.exports, "PopupTrigger", ()=>$eb07ae3447684674$export$95d4acdbab2fc6ef);
    var $5uXOq = parcelRequire("5uXOq");
    const $eb07ae3447684674$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                showProfilecard();
            }
        }, [
            showProfilecard
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props,
            ...containerListeners,
            ref: ref,
            "aria-labelledby": ariaLabelledBy
        }, children);
    };
    const $eb07ae3447684674$export$95d4acdbab2fc6ef = (0, ($parcel$interopDefault($5uXOq))).forwardRef($eb07ae3447684674$var$PopupTriggerInner);
});
parcelRegister("glChS", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardWrapper", ()=>$fc69b6eef7bac459$export$59abd6feb7dc8540);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $fc69b6eef7bac459$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $fc69b6eef7bac459$export$59abd6feb7dc8540 = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fc69b6eef7bac459$var$styles
        }, children);
    };
});
parcelRegister("8G7CX", function(module, exports) {
    $parcel$export(module.exports, "isSystemAgent", ()=>$11e5cd279fe5fb4c$export$7c120b233d4844c6);
    $parcel$export(module.exports, "isCustomerAgent", ()=>$11e5cd279fe5fb4c$export$f817e52cf2c5cc8c);
    $parcel$export(module.exports, "isForgeAgent", ()=>$11e5cd279fe5fb4c$export$2149adda3d8a5807);
    const $11e5cd279fe5fb4c$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
    const $11e5cd279fe5fb4c$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
    const $11e5cd279fe5fb4c$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
    const $11e5cd279fe5fb4c$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
});
parcelRegister("3xYdY", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_AGENTS_NAMED_ID_LIST", ()=>$3b04d45962552af9$export$2d0163867590928d);
    $parcel$export(module.exports, "DEFAULT_OOTB_AGENTS_NAMED_IDS", ()=>$3b04d45962552af9$export$804d9ee5f4cc40a8);
    $parcel$export(module.exports, "isCreateOrEditAgentAUPError", ()=>$3b04d45962552af9$export$a08ace1426fa4a9e);
    const $3b04d45962552af9$export$48783720d93c2d26 = {
        id: 'ai_mate_agent',
        named_id: 'ai_mate_agent',
        name: 'AI Mate',
        description: 'AI Mate',
        creator_type: 'SYSTEM',
        available_plugins: {},
        is_default: true,
        visibility: 'PUBLIC'
    };
    const $3b04d45962552af9$export$2d0163867590928d = new Set([
        'decision_director_agent',
        'user_manual_writer_agent',
        'product_requirements_expert_agent'
    ]);
    const $3b04d45962552af9$export$804d9ee5f4cc40a8 = {
        ['confluence']: new Set([
            'decision_director_agent',
            'product_requirements_expert_agent',
            'rovo_expert_agent'
        ]),
        ['jira']: new Set([
            'rovo_expert_agent',
            'issue_organizer_agent',
            'jira_theme_analyzer_agent'
        ]),
        ['atlas']: new Set([
            'progress_tracker_agent',
            'product_requirements_expert_agent',
            'rovo_expert_agent'
        ])
    };
    const $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
    const $3b04d45962552af9$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE;
});
parcelRegister("gBv35", function(module, exports) {
    $parcel$export(module.exports, "useProfileClient", ()=>$8168d85a70e7a063$export$d43dc22a8337ee9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    parcelRequire("26CR2");
    var $bp5g1 = parcelRequire("bp5g1");
    const $8168d85a70e7a063$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
    let $8168d85a70e7a063$var$client;
    const $8168d85a70e7a063$export$d43dc22a8337ee9f = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, $bp5g1.default));
        const profileClient = (0, $5uXOq.useMemo)(()=>{
            if (!$8168d85a70e7a063$var$client) $8168d85a70e7a063$var$client = new (0, $bp5g1.default)({
                url: $8168d85a70e7a063$var$DIRECTORY_URL,
                cacheSize: 1000,
                cacheMaxAge: 86400000
            });
            return $8168d85a70e7a063$var$client;
        }, []);
        return profileClient;
    };
});
parcelRegister("3go6U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52a6773361bb10a2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52a6773361bb10a2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deactivatedCreatorName: {
            id: 'rovo-chat.agent-card.deactivated-name',
            defaultMessage: '{name} (deactivated)',
            description: 'Name of the agent creator when it is deactivated'
        }
    });
});
parcelRegister("9XSXa", function(module, exports) {
    $parcel$export(module.exports, "useKnowledgeProductsRender", ()=>$e4eb9c6c2ccd85ae$export$3aa02e5f70d569cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $czMKq;
    var $iX9TB;
    var $ji7Zl;
    var $e4yMr;
    var $2pMF0;
    var $7anl7;
    var $29YN9;
    var $VSDnB;
    var $f5TWP;
    var $cgL5K;
    var $8CUq3;
    var $f1tAG;
    var $1e6hD;
    var $ejGzF;
    const $e4eb9c6c2ccd85ae$var$getIconForSource = (source)=>{
        switch(source){
            case 'confluence':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                    size: "small",
                    appearance: "brand"
                });
            case 'jira':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                    size: "small",
                    appearance: "brand"
                });
            case 'atlas':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2pMF0")).AtlassianIcon), {
                    size: "small",
                    appearance: "brand"
                });
            case 'microsoft_sharepoint':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iX9TB")).default), {
                    size: "medium",
                    label: ""
                });
            case 'slack':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ji7Zl")).default), {
                    size: "medium",
                    label: ""
                });
            case 'google_drive':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("czMKq")).default), {
                    size: "medium",
                    label: ""
                });
            default:
                return null;
        }
    };
    const $e4eb9c6c2ccd85ae$var$getLabelForSource = (source)=>{
        switch(source){
            case 'confluence':
                return 'Confluence';
            case 'jira':
                return 'Jira';
            case 'atlas':
                return 'Atlassian Home';
            case 'microsoft_sharepoint':
                return 'Microsoft Sharepoint';
            case 'slack':
                return 'Slack';
            case 'google_drive':
                return 'Google Drive';
            default:
                return '';
        }
    };
    const $e4eb9c6c2ccd85ae$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '20px'
    });
    const $e4eb9c6c2ccd85ae$var$KnowledgeSourceProduct = ({ source: source, cloudUrl: cloudUrl })=>{
        const LinkOrText = cloudUrl ? (0, (0, parcelRequire("e4yMr")).default) : (0, (0, parcelRequire("cgL5K")).default);
        const getLabelRender = ()=>{
            switch(source){
                case 'jira':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(LinkOrText, {
                        href: `${cloudUrl}/jira`,
                        target: "_blank"
                    }, $e4eb9c6c2ccd85ae$var$getLabelForSource(source));
                case 'confluence':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(LinkOrText, {
                        href: `${cloudUrl}/wiki`,
                        target: "_blank"
                    }, $e4eb9c6c2ccd85ae$var$getLabelForSource(source));
                case 'atlas':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                        href: (0, (0, parcelRequire("f1tAG")).getAtlasHost)(),
                        target: "_blank"
                    }, $e4eb9c6c2ccd85ae$var$getLabelForSource(source));
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, $e4eb9c6c2ccd85ae$var$getLabelForSource(source));
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $e4eb9c6c2ccd85ae$var$wrapperStyles,
            alignBlock: "center",
            space: "space.075"
        }, $e4eb9c6c2ccd85ae$var$getIconForSource(source), getLabelRender());
    };
    const $e4eb9c6c2ccd85ae$export$581d4179e1c59739 = ({ sources: sources, knowledgeScopeEnabled: knowledgeScopeEnabled, allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered, cloudUrl: cloudUrl })=>{
        let processedSources = sources;
        if (!knowledgeScopeEnabled && (0, (0, parcelRequire("VSDnB")).fg)('rovo_enable_no_knowledge_sources_ui')) processedSources = allKnowledgeSourcesFiltered;
        const knowledgeSourcesRender = [];
        processedSources.forEach((source)=>{
            if (!source.enabled) return null;
            if (source.source === 'confluence' && (source.configuration?.parent_filter?.length || source.configuration?.space_filter?.length)) return null;
            if (source.source === 'jira' && source.configuration?.project_filter?.length) return null;
            knowledgeSourcesRender.push((0, ($parcel$interopDefault($5uXOq))).createElement($e4eb9c6c2ccd85ae$var$KnowledgeSourceProduct, {
                key: source.source,
                source: source.source,
                cloudUrl: cloudUrl
            }));
        });
        return knowledgeSourcesRender.length ? knowledgeSourcesRender : null;
    };
    const $e4eb9c6c2ccd85ae$export$3aa02e5f70d569cc = (config)=>{
        const { isConnectorEnabled: isConnectorEnabled } = (0, (0, parcelRequire("1e6hD")).useKnowledgeConnectors)({
            enabled: (0, (0, parcelRequire("VSDnB")).fg)('rovo_enable_no_knowledge_sources_ui'),
            config: config
        });
        const allKnowledgeSourcesFiltered = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ejGzF")).allKnowledgeSources).filter((source)=>isConnectorEnabled(source.source)), [
            isConnectorEnabled
        ]);
        const getKnowledgeProductsRenderForAgent = (0, $5uXOq.useCallback)((params)=>{
            return $e4eb9c6c2ccd85ae$export$581d4179e1c59739({
                ...params,
                allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered
            });
        }, [
            allKnowledgeSourcesFiltered
        ]);
        return {
            getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent
        };
    };
});
parcelRegister("czMKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d615c308ec78a3ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $d615c308ec78a3ad$var$GoogleDriveIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "20",
            height: "18",
            viewBox: "0 0 20 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
            fill: "#3777E3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
            fill: "#FFCF63"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
            fill: "#11A861"
        }));
    const $d615c308ec78a3ad$var$GoogleDriveIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $d615c308ec78a3ad$var$GoogleDriveIconGlyph
        });
    var $d615c308ec78a3ad$export$2e2bcd8739ae039 = $d615c308ec78a3ad$var$GoogleDriveIcon;
});
parcelRegister("iX9TB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8202f9e7d9f2e622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $8202f9e7d9f2e622$var$MicrosoftSharepointIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
            id: "mask0_1701_19689",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M20 0H0V20H20V0Z",
            fill: "white"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            mask: "url(#mask0_1701_19689)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
            fill: "#036C70"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
            fill: "#1A9BA1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
            fill: "#37C6D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.1",
            d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
            fill: "black"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
            fill: "black"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
            fill: "black"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.2",
            d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
            fill: "black"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
            fill: "#04868B"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
            fill: "white"
        })));
    const $8202f9e7d9f2e622$var$MicrosoftSharepointIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $8202f9e7d9f2e622$var$MicrosoftSharepointIconGlyph
        });
    var $8202f9e7d9f2e622$export$2e2bcd8739ae039 = $8202f9e7d9f2e622$var$MicrosoftSharepointIcon;
});
parcelRegister("ji7Zl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$738cb4e402830970$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $738cb4e402830970$var$SlackIconAiMateGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_271_181639)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
            fill: "#ECB22E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
            fill: "#E01E5A"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_271_181639"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        }))));
    const $738cb4e402830970$var$SlackIconAiMate = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $738cb4e402830970$var$SlackIconAiMateGlyph
        });
    var $738cb4e402830970$export$2e2bcd8739ae039 = $738cb4e402830970$var$SlackIconAiMate;
});
parcelRegister("f1tAG", function(module, exports) {
    $parcel$export(module.exports, "getAtlasHost", ()=>$bb7d427d2d55585d$export$5105758c0e772381);
    $parcel$export(module.exports, "getAtlasURL", ()=>$bb7d427d2d55585d$export$bfee0f88bf621ad3);
    var $VSDnB;
    var $9oBwb;
    const $bb7d427d2d55585d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
    const $bb7d427d2d55585d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
    const $bb7d427d2d55585d$export$5105758c0e772381 = ()=>{
        const host = window.location.host;
        const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
        return isStaging ? $bb7d427d2d55585d$var$ATLAS_STAGING_URL : $bb7d427d2d55585d$var$ATLAS_PROD_URL;
    };
    const $bb7d427d2d55585d$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
        let argConcat = '?';
        let processedPath = path.startsWith('/') ? path : `/${path}`;
        if (processedPath.includes('?')) argConcat = '&';
        const basePath = orgId && (0, (0, parcelRequire("VSDnB")).fg)('rovo_chat_append_org_id_to_atlas_url') ? `${$bb7d427d2d55585d$export$5105758c0e772381()}/o/${orgId}` : $bb7d427d2d55585d$export$5105758c0e772381();
        return (0, (0, parcelRequire("9oBwb")).addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
            cloudId: siteId
        });
    };
});
parcelRegister("1e6hD", function(module, exports) {
    $parcel$export(module.exports, "useKnowledgeConnectors", ()=>$30bef7cfac4334a4$export$88014f3d16427d4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $4ojTZ;
    const $30bef7cfac4334a4$export$88014f3d16427d4b = (params)=>{
        const service = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)(params?.config);
        const experienceTracker = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const connectorsQuery = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'getKnowledgeConnectors'
            ],
            queryFn: async ()=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
                });
                return service.getAgentKnowledgeConfiguration();
            },
            onSuccess: ()=>{
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
                });
            },
            onError: (error)=>{
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                    error: error
                });
            },
            enabled: params?.enabled ?? true
        });
        const isConnectorEnabled = (0, $5uXOq.useCallback)((type)=>{
            return connectorsQuery.data?.knowledgeSources?.some((value)=>value.source === type) ?? false;
        }, [
            connectorsQuery.data
        ]);
        return {
            isConnectorEnabled: isConnectorEnabled
        };
    };
});
parcelRegister("ejGzF", function(module, exports) {
    $parcel$export(module.exports, "allKnowledgeSources", ()=>$a1a560b4a02c6d14$export$a2962da695bf17df);
    const $a1a560b4a02c6d14$export$a2962da695bf17df = [
        {
            source: 'confluence',
            configuration: {
                parent_filter: [],
                space_filter: []
            },
            enabled: true
        },
        {
            source: 'jira',
            configuration: {
                project_filter: []
            },
            enabled: true
        },
        {
            enabled: true,
            source: 'atlas',
            configuration: undefined
        },
        {
            enabled: true,
            source: 'google_drive',
            configuration: undefined
        },
        {
            enabled: true,
            source: 'microsoft_sharepoint',
            configuration: undefined
        },
        {
            enabled: true,
            source: 'slack',
            configuration: undefined
        }
    ];
});
parcelRegister("19iJP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca6ebb19826b4cb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $fuLGr;
    var $c5gm9;
    var $bXooK;
    function $ca6ebb19826b4cb1$export$1064229c13822d9f(props) {
        const [{ orgId: orgId }] = (0, (0, parcelRequire("c5gm9")).useOrg)();
        return orgId ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bXooK")).default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ca6ebb19826b4cb1$var$ProfileAboutTeamsSpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuLGr")).default), {
            size: 'small'
        }));
    }
    var $ca6ebb19826b4cb1$export$2e2bcd8739ae039 = $ca6ebb19826b4cb1$export$1064229c13822d9f;
    const $ca6ebb19826b4cb1$var$ProfileAboutTeamsSpinnerWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-17jr9k9-0"
    })`display:flex;justify-content:center;align-items:center;`;
});
parcelRegister("fuLGr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$febac4e5de7fb6a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $bbYpp;
    const $febac4e5de7fb6a9$var$Spinner = ({ wrapperHeight: wrapperHeight, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bbYpp")).SpinnerWrapper, {
            height: wrapperHeight,
            "data-test-selector": "spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), props));
    var $febac4e5de7fb6a9$export$2e2bcd8739ae039 = $febac4e5de7fb6a9$var$Spinner;
});
parcelRegister("bbYpp", function(module, exports) {
    $parcel$export(module.exports, "SpinnerWrapper", ()=>$cdc48abed99e8bc6$export$52b4dfd89a6b3a1b);
    var $47bDC = parcelRequire("47bDC");
    const $cdc48abed99e8bc6$var$getHeight = ({ height: height })=>{
        if (typeof height === 'number') return `${height}px`;
        return height;
    };
    const $cdc48abed99e8bc6$export$52b4dfd89a6b3a1b = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1umpdm7-0"
    })`display:flex;justify-content:center;align-items:center;margin:${"var(--ds-space-200, 16px)"} 0;height:${$cdc48abed99e8bc6$var$getHeight};`;
});
parcelRegister("bXooK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f220f86d100751c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $fVnbM;
    var $dD7Zc;
    var $fyzT1;
    var $jDqI3;
    var $eZEvj;
    var $fuLGr;
    var $38ra6;
    var $lHKVj;
    var $fff3y;
    var $bA8uW;
    var $1Wq3n;
    var $1tSRh;
    var $63MVP;
    var $4V0ms;
    var $3m1cZ;
    var $bGUXq;
    const $f220f86d100751c4$export$4a2947f47d583741 = 10;
    const $f220f86d100751c4$export$b827413854913969 = 30;
    function $f220f86d100751c4$export$2697725d6b507e8c(props) {
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const [enableInfiniteScroll, setEnableInfiniteScroll] = (0, $5uXOq.useState)(false);
        const [showLess, setShowLess] = (0, $5uXOq.useState)(true);
        const [{ hasLoaded: hasUserDataLoaded, principalUserId: currentUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const { isLoading: isTeamSearchLoading, teams: teamSearchTeams, error: ApolloError, loadMore: loadMore, hasMore: hasMore } = (0, (0, parcelRequire("1Wq3n")).useTeamSearchQuery)({
            first: $f220f86d100751c4$export$4a2947f47d583741 + 1,
            batchSize: $f220f86d100751c4$export$b827413854913969,
            memberIds: [
                props.userId
            ]
        });
        (0, (0, parcelRequire("lHKVj")).useExpTrackerStop)({
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_USERS_TEAMS,
            error: ApolloError
        });
        const createProposedMember = (0, $5uXOq.useCallback)(()=>props.userFullName ? [
                {
                    id: props.userId,
                    value: props.userId,
                    label: props.userFullName,
                    avatarUrl: props.userAvatarUrl,
                    type: 'user'
                }
            ] : [], [
            props.userAvatarUrl,
            props.userFullName,
            props.userId
        ]);
        const handleTeamItemClick = (0, $5uXOq.useCallback)((e, index)=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource)[props.analyticsSource] || (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                actionSubject: 'teamProfileItem',
                attributes: {
                    position: index
                }
            });
        }, [
            analytics,
            props.analyticsSource
        ]);
        const isCurrentUser = ()=>currentUserId === props.userId;
        const hasNoData = !teamSearchTeams;
        if (hasNoData) return null;
        if (ApolloError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("63MVP")).AboutSectionTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.teamSectionTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ErrorContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ErrorIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
            label: $f220f86d100751c4$export$defe85febe8b728c.errorStateTitle.defaultMessage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ErrorMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ErrorTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.errorStateTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ErrorMessage, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.errorStateMessage)))));
        const onShowMoreButtonClick = ()=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'showMore',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED
            });
            setEnableInfiniteScroll(true);
            setShowLess(false);
        };
        const collapseTeamList = ()=>{
            if (!enableInfiniteScroll) setEnableInfiniteScroll(true);
            setShowLess(!showLess);
        };
        const teamList = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tSRh")).default), {
            loadMore: loadMore,
            hasMore: hasMore && enableInfiniteScroll,
            loader: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuLGr")).default), null),
            isLoading: isTeamSearchLoading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showLess ? teamSearchTeams.slice(0, $f220f86d100751c4$export$4a2947f47d583741).map((team, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V0ms")).default), {
                key: team.id,
                team: team,
                isCurrentUser: isCurrentUser(),
                index: index,
                onClick: handleTeamItemClick
            })) : teamSearchTeams.map((team, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V0ms")).default), {
                key: team.id,
                team: team,
                isCurrentUser: isCurrentUser(),
                index: index,
                onClick: handleTeamItemClick
            })), !enableInfiniteScroll && teamSearchTeams.length > $f220f86d100751c4$export$4a2947f47d583741 && (hasMore || !hasMore && showLess) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ShowMoreButton, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: onShowMoreButtonClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.showMore))), enableInfiniteScroll && !hasMore && (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).ShowMoreButton, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: collapseTeamList
        }, showLess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.showMore) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.showLess)))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("63MVP")).AboutSectionTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $f220f86d100751c4$export$defe85febe8b728c.teamSectionTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bGUXq")).AboutTeamsList, null, hasUserDataLoaded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3m1cZ")).default), {
            source: "teamsList",
            isCurrentUser: isCurrentUser(),
            proposedMembers: isCurrentUser() ? [] : createProposedMember(),
            isActiveUser: props.isActiveUser
        }), isTeamSearchLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZEvj")).default), {
            hasAvatar: true,
            isShimmering: true,
            cssFn: ()=>({
                    paddingLeft: 0,
                    paddingRight: 0
                }),
            itemCount: 3
        }) : teamList), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDqI3")).ExperienceSuccess), {
            hasLoaded: !isTeamSearchLoading && !ApolloError,
            name: (0, (0, parcelRequire("bA8uW")).UserExperienceNames).USER_PROFILE_USERS_TEAMS
        }));
    }
    const $f220f86d100751c4$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamSectionTitle: {
            id: 'ptc-directory.user-profile-page.about.teams.heading',
            defaultMessage: 'Teams',
            description: 'Heading for the teams that user is a member of'
        },
        showMore: {
            id: 'ptc-directory.user-profile-page.about.teams.show.more.button',
            defaultMessage: 'Show more',
            description: 'Text for the show more button'
        },
        showLess: {
            id: 'ptc-directory.user-profile-page.about.teams.show.less.button',
            defaultMessage: 'Show less',
            description: 'Text for the show less button'
        },
        errorStateTitle: {
            id: 'ptc-directory.user-profile-page.about.teams.error.title',
            defaultMessage: 'Something went wrong',
            description: 'Error title for when teams fail to load'
        },
        errorStateMessage: {
            id: 'ptc-directory.user-profile-page.about.teams.error.message',
            defaultMessage: 'Refresh the page or try again later',
            description: 'Error instruction for when teams fail to load'
        }
    });
    var $f220f86d100751c4$export$2e2bcd8739ae039 = $f220f86d100751c4$export$2697725d6b507e8c;
});
parcelRegister("1Wq3n", function(module, exports) {
    $parcel$export(module.exports, "useTeamSearchQuery", ()=>$ca998ca0ff1fba59$export$209c3a9213f9e947);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $e7caa;
    var $gqOOy;
    var $5WmsO;
    var $5hWov;
    var $levfe;
    var $iknOf;
    var $jCvwN;
    var $IZxaE;
    var $cBElP;
    var $iTt8D;
    var $7YTpJ;
    const $ca998ca0ff1fba59$var$QueryErrorToApolloError = (error)=>{
        return new (0, (0, parcelRequire("cBElP")).ApolloError)(error.message, error.graphQLErrors, error.networkError ?? null, error.extensions);
    };
    const $ca998ca0ff1fba59$var$excludeKnownGraphQLErrors = (error)=>{
        const mappedError = error instanceof (0, (0, parcelRequire("iknOf")).UseQueryLightError) ? $ca998ca0ff1fba59$var$QueryErrorToApolloError(error) : error;
        if (mappedError.message === 'GraphQL error: User does not have access to the org') return undefined;
        else if (mappedError.graphQLErrors) {
            const filteredError = {
                ...mappedError,
                graphQLErrors: (0, (0, parcelRequire("7YTpJ")).filterExcludedMessages)(mappedError.graphQLErrors)
            };
            const noErrorsLeft = filteredError.networkError == null && filteredError.graphQLErrors.length === 0;
            return noErrorsLeft ? undefined : filteredError;
        }
        return mappedError;
    };
    function $ca998ca0ff1fba59$var$orgIdWithARI(orgId) {
        return orgId?.startsWith((0, (0, parcelRequire("7YTpJ")).ORG_ARI_PREFIX)) ? orgId : `${0, (0, parcelRequire("7YTpJ")).ORG_ARI_PREFIX}${orgId}`;
    }
    const $ca998ca0ff1fba59$export$209c3a9213f9e947 = (props)=>{
        const { cursor: cursor, first: first, memberIds: memberIds, query: query, batchSize: batchSize, skip: providedSkip } = props;
        const { orgId: orgId } = (0, (0, parcelRequire("levfe")).useV3OrgIdStatus)();
        const [exitedTeams] = (0, (0, parcelRequire("gqOOy")).useExitedTeams)();
        const { isLoading: isTeamsVisibilityLoading, permissions: { canViewTeams: canViewTeams } } = (0, (0, parcelRequire("5hWov")).useTeamVisibility)();
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, (0, parcelRequire("iTt8D")).useQueryWrapper)((0, (0, parcelRequire("IZxaE")).default), {
            client: (0, (0, parcelRequire("e7caa")).getGatewayClient)(),
            context: {
                headers: {
                    'X-ExperimentalApi': 'team-members-beta',
                    'atl-client-name': "platform-pkg",
                    'atl-client-version': "0.0.0-use.local"
                }
            },
            operationName: 'TeamSearchV2',
            serviceUrl: `${(0, (0, parcelRequire("jCvwN")).getConfig)().stargateRoot}/graphql`,
            variables: {
                first: first,
                memberIds: memberIds,
                query: query,
                organizationId: $ca998ca0ff1fba59$var$orgIdWithARI(orgId),
                after: cursor,
                sortBy: query ? null : (0, (0, parcelRequire("cBElP")).sortBy),
                siteId: cloudId,
                showEmptyTeams: true
            },
            skip: providedSkip || !orgId || !canViewTeams || isTeamsVisibilityLoading
        }, (0, (0, parcelRequire("VSDnB")).fg)('enable_teams_graphql_migration'));
        const filteredError = error && $ca998ca0ff1fba59$var$excludeKnownGraphQLErrors(error);
        const formattedTeams = (0, $5uXOq.useMemo)(()=>{
            if (!data?.team || filteredError) return [];
            return (0, (0, parcelRequire("7YTpJ")).fromV2ToTeamSearchViewFormat)(data.team?.teamSearch?.nodes || []);
        }, [
            data,
            filteredError
        ]);
        const loadMore = ()=>{
            fetchMore({
                variables: {
                    after: data?.team?.teamSearch?.pageInfo?.endCursor,
                    first: batchSize || first
                },
                handleDataMerge: (prevResult, fetchMoreResult)=>{
                    if (!fetchMoreResult) return prevResult;
                    const prevTeams = prevResult?.team?.teamSearch?.nodes || [];
                    const newTeams = fetchMoreResult?.team?.teamSearch?.nodes || [];
                    return {
                        ...fetchMoreResult,
                        team: {
                            ...fetchMoreResult.team,
                            teamSearch: {
                                ...fetchMoreResult.team?.teamSearch,
                                nodes: [
                                    ...prevTeams,
                                    ...newTeams
                                ]
                            }
                        }
                    };
                }
            });
        };
        const filteredTeams = (0, $5uXOq.useMemo)(()=>formattedTeams.filter((team)=>!exitedTeams.has(team.id)), [
            formattedTeams,
            exitedTeams
        ]);
        return {
            isLoading: loading,
            teams: filteredTeams,
            error: filteredError,
            loadMore: loadMore,
            hasMore: !!data?.team?.teamSearch?.pageInfo?.hasNextPage
        };
    };
});
parcelRegister("gqOOy", function(module, exports) {
    $parcel$export(module.exports, "useTeamProfileDataState", ()=>$541492975b2c7e18$export$1983fe04e6d15665);
    $parcel$export(module.exports, "useTeamMembersState", ()=>$541492975b2c7e18$export$c90591c2030bee);
    $parcel$export(module.exports, "useMyMembership", ()=>$541492975b2c7e18$export$7d96b11823e54583);
    $parcel$export(module.exports, "useExitedTeams", ()=>$541492975b2c7e18$export$d85ae427dffd7a31);
    $parcel$export(module.exports, "useTeamAgentsState", ()=>$541492975b2c7e18$export$80fb38915e92c27f);
    var $3sQ5x;
    var $iXqE5;
    var $dmOdc;
    var $aatv6;
    var $66abk;
    var $bGzDE;
    var $4m5re;
    var $4TUdO;
    var $17Odl;
    var $3n2JP;
    var $89d9t;
    var $j3TB6;
    var $lwEMT;
    const $541492975b2c7e18$var$initialState = {
        teamProfile: {
            teamId: '',
            isLoading: true,
            hasLoaded: false,
            errorType: null,
            data: {}
        },
        teamMembers: {
            teamId: '',
            isLoading: true,
            isLoadingNextPage: false,
            hasLoaded: false,
            hasError: false,
            errorType: null,
            members: [],
            requestingToJoinUsers: [],
            membersPageInfo: {
                hasNextPage: false,
                cursor: null
            },
            requestingToJoinUsersPageInfo: {
                hasNextPage: false,
                cursor: null
            }
        },
        teamAgents: {
            teamId: '',
            isLoading: true,
            isLoadingNextPage: false,
            hasLoaded: false,
            hasError: false,
            errorType: null,
            members: []
        },
        myTeamMembership: {
            teamId: '',
            hasLoaded: false,
            membership: undefined
        },
        exitedTeams: new Set(),
        allTeamsData: {
            teams: [],
            isLoading: true,
            hasError: false,
            cursor: ''
        }
    };
    const $541492975b2c7e18$var$actions = {
        setTeamClientRootUrl: (rootUrl)=>()=>{
                (0, (0, parcelRequire("dmOdc")).teamsClient).setLegionRootUrl(rootUrl);
            },
        collectTeamData: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
                if (getState().teamProfile.teamId === teamId) return;
                await Promise.all([
                    dispatch((0, (0, parcelRequire("17Odl")).getTeamProfile)(teamId)),
                    dispatch((0, (0, parcelRequire("4m5re")).getMyTeamMembership)(teamId)),
                    dispatch((0, (0, parcelRequire("4TUdO")).getTeamMembers)(teamId))
                ]);
                dispatch((0, (0, parcelRequire("bGzDE")).getRequestingToJoinUsers)(teamId));
            },
        restoreTeam: (teamId, options)=>async ({ dispatch: dispatch })=>{
                await (0, (0, parcelRequire("dmOdc")).teamsClient).restoreTeam(teamId);
                if (options?.fetchTeamData) await Promise.all([
                    dispatch((0, (0, parcelRequire("17Odl")).getTeamProfile)(teamId)),
                    dispatch((0, (0, parcelRequire("4m5re")).getMyTeamMembership)(teamId)),
                    dispatch((0, (0, parcelRequire("4TUdO")).getTeamMembers)(teamId))
                ]);
            },
        fetchTeamMembersNextPage: (teamId, count = 100)=>async ({ dispatch: dispatch, getState: getState })=>{
                if (!getState().teamMembers.membersPageInfo.hasNextPage) return;
                await dispatch((0, (0, parcelRequire("4TUdO")).getTeamMembers)(teamId, true, count));
            },
        refreshRequestingToJoinUsers: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
                if (getState().teamProfile.teamId !== teamId) return [];
                return await dispatch((0, (0, parcelRequire("bGzDE")).getRequestingToJoinUsers)(teamId));
            },
        prefillTeamData: (0, parcelRequire("89d9t")).prefillTeamData,
        updateTeamProfile: (teamId, data)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
                const isTransitioningToOpen = data.membershipSettings === 'OPEN' && getState().teamProfile.data.membershipSettings === 'MEMBER_INVITE';
                const response = await (0, (0, parcelRequire("dmOdc")).teamsClient).updateTeamById(teamId, data);
                setState({
                    teamProfile: {
                        ...getState().teamProfile,
                        data: response
                    }
                });
                if (isTransitioningToOpen) dispatch((0, (0, parcelRequire("4TUdO")).getTeamMembers)(teamId));
                return response;
            },
        acceptAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
                const requests = getState().teamMembers.requestingToJoinUsers;
                await Promise.all(requests.map((request)=>{
                    return dispatch((0, (0, parcelRequire("66abk")).approveJoinRequest)(teamId, request.membershipId.memberId, request.user));
                }));
            },
        declineAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
                const requests = getState().teamMembers.requestingToJoinUsers;
                await Promise.all(requests.map((request)=>{
                    return dispatch((0, (0, parcelRequire("bGzDE")).declineJoinRequest)(teamId, request.membershipId.memberId));
                }));
            },
        removeTeamMember: (0, parcelRequire("j3TB6")).removeTeamMember,
        revokeTeamInvite: (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
                const { teamMembers: { teamId: currentTeamId } } = getState();
                const removedInvite = await (0, (0, parcelRequire("dmOdc")).teamsClient).revokeTeamInvite(teamId, memberId);
                if (removedInvite && removedInvite.state !== 'ALUMNI') throw Error('Invite claims to be cancelled but was not');
                if (currentTeamId !== teamId) return;
                setState({
                    teamMembers: {
                        ...getState().teamMembers,
                        members: getState().teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
                    }
                });
            },
        joinTeam: (0, parcelRequire("aatv6")).joinTeam,
        cancelJoinRequest: (teamId)=>async ({ getState: getState, setState: setState })=>{
                const { teamProfile: { teamId: currentTeamId } } = getState();
                await (0, (0, parcelRequire("dmOdc")).teamsClient).cancelJoinRequest(teamId);
                const state = getState();
                if (currentTeamId !== teamId) return;
                setState({
                    ...state,
                    myTeamMembership: {
                        teamId: teamId,
                        hasLoaded: true,
                        membership: undefined
                    }
                });
            },
        acceptTeamInvitation: (0, parcelRequire("aatv6")).acceptTeamInvitation,
        declineTeamInvitation: (teamId)=>async ({ getState: getState })=>{
                const { exitedTeams: exitedTeams } = getState();
                await (0, (0, parcelRequire("dmOdc")).teamsClient).declineTeamInvitation(teamId);
                exitedTeams.add(teamId);
            },
        inviteUsersToTeam: (0, parcelRequire("3n2JP")).inviteUsersToTeam,
        approveJoinRequest: (0, parcelRequire("66abk")).approveJoinRequest,
        declineJoinRequest: (0, parcelRequire("bGzDE")).declineJoinRequest,
        deleteTeam: (teamId)=>async ({ getState: getState, setState: setState })=>{
                const { exitedTeams: exitedTeams } = getState();
                await (0, (0, parcelRequire("dmOdc")).teamsClient).deleteTeam(teamId);
                setState({
                    teamProfile: $541492975b2c7e18$var$initialState.teamProfile,
                    teamMembers: $541492975b2c7e18$var$initialState.teamMembers,
                    myTeamMembership: $541492975b2c7e18$var$initialState.myTeamMembership
                });
                exitedTeams.add(teamId);
            },
        getAllTeams: (allTeamsQuery, keepExistingData)=>async ({ dispatch: dispatch })=>{
                await dispatch((0, (0, parcelRequire("lwEMT")).default)(allTeamsQuery, keepExistingData));
            },
        refreshTeamHealthMonitors: ()=>async ()=>{
                return Promise.resolve();
            }
    };
    const $541492975b2c7e18$var$TeamStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $541492975b2c7e18$var$initialState,
        actions: $541492975b2c7e18$var$actions
    });
    const $541492975b2c7e18$export$1983fe04e6d15665 = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.teamProfile
    });
    const $541492975b2c7e18$export$c90591c2030bee = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.teamMembers
    });
    const $541492975b2c7e18$export$7d96b11823e54583 = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.myTeamMembership
    });
    const $541492975b2c7e18$export$d85ae427dffd7a31 = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.exitedTeams
    });
    const $541492975b2c7e18$export$a50a7dc1b87fcc7 = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.allTeamsData
    });
    const $541492975b2c7e18$export$80fb38915e92c27f = (0, (0, parcelRequire("3sQ5x")).createHook)($541492975b2c7e18$var$TeamStore, {
        selector: (state)=>state.teamAgents
    });
});
parcelRegister("aatv6", function(module, exports) {
    $parcel$export(module.exports, "joinTeam", ()=>$da8183fc149dba31$export$47f143084f31963c);
    $parcel$export(module.exports, "acceptTeamInvitation", ()=>$da8183fc149dba31$export$a0ce1bbc3e3f2e4d);
    var $dmOdc;
    var $bGzDE;
    var $bhfHz;
    const $da8183fc149dba31$export$e4da98dc943d58c8 = (teamId, member)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.teamProfile.teamId !== teamId) return;
            const nextState = (0, (0, parcelRequire("bhfHz")).joinTeamState)(state, member);
            setState(nextState);
        };
    const $da8183fc149dba31$export$47f143084f31963c = (teamId, originQuery, user)=>async ({ dispatch: dispatch })=>{
            const response = await (0, (0, parcelRequire("dmOdc")).teamsClient).selfJoinTeam(teamId, originQuery);
            const newMembership = {
                ...response,
                user: user
            };
            dispatch($da8183fc149dba31$export$e4da98dc943d58c8(teamId, newMembership));
            return response;
        };
    const $da8183fc149dba31$export$a0ce1bbc3e3f2e4d = (teamId, currentUserId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const response = await (0, (0, parcelRequire("dmOdc")).teamsClient).acceptTeamInvitation(teamId);
            const existingUser = getState().teamMembers.members.find((member)=>member.membershipId.memberId === currentUserId);
            if (!existingUser || !existingUser.user) return;
            const newMembership = {
                ...response,
                user: existingUser.user
            };
            dispatch($da8183fc149dba31$export$e4da98dc943d58c8(teamId, newMembership));
            dispatch((0, (0, parcelRequire("bGzDE")).getRequestingToJoinUsers)(teamId));
        };
});
parcelRegister("bGzDE", function(module, exports) {
    $parcel$export(module.exports, "getRequestingToJoinUsers", ()=>$8d91893cb97bea35$export$eb1265581ad35874);
    $parcel$export(module.exports, "declineJoinRequest", ()=>$8d91893cb97bea35$export$d71ce2a87bc937b0);
    var $kHmnq;
    var $dmOdc;
    var $afodl;
    var $2bf04;
    const $8d91893cb97bea35$export$eb1265581ad35874 = (teamId)=>async ({ getState: getState, setState: setState })=>{
            const initialState = getState();
            const isOpenTeam = initialState.teamProfile.data.membershipSettings === 'OPEN';
            const membershipErrors = initialState.teamMembers.hasError;
            const hasPermissionToViewRequestingUsers = initialState.teamProfile.data.permission === 'FULL_WRITE';
            const teamChanged = initialState.teamMembers.teamId !== teamId;
            if (teamChanged || !hasPermissionToViewRequestingUsers || membershipErrors || isOpenTeam) return [];
            try {
                const requestingUsersResponse = await (0, (0, parcelRequire("dmOdc")).teamsClient).queryTeamMemberships(teamId, [
                    'REQUESTING_TO_JOIN'
                ], {
                    first: 100,
                    after: initialState.teamMembers.requestingToJoinUsersPageInfo.cursor ?? undefined
                });
                const requestingUsers = (0, (0, parcelRequire("afodl")).isResultWithPageInfo)(requestingUsersResponse) ? requestingUsersResponse.edges : requestingUsersResponse;
                const state = getState();
                if (state.teamMembers.teamId !== teamId) return [];
                const sortedRequesters = (0, (0, parcelRequire("kHmnq")).sortMembersByType)(requestingUsers);
                setState({
                    teamMembers: {
                        ...state.teamMembers,
                        requestingToJoinUsers: sortedRequesters
                    }
                });
                return sortedRequesters;
            } catch (err) {
                (0, (0, parcelRequire("2bf04")).logException)(err, 'Could not load requesting-to-join users');
                return [];
            }
        };
    const $8d91893cb97bea35$export$d71ce2a87bc937b0 = (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
            await (0, (0, parcelRequire("dmOdc")).teamsClient).declineJoinRequest(teamId, memberId);
            const state = getState();
            if (state.teamMembers.teamId !== teamId) return;
            setState({
                ...state,
                teamMembers: {
                    ...state.teamMembers,
                    requestingToJoinUsers: state.teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
                }
            });
        };
});
parcelRegister("kHmnq", function(module, exports) {
    $parcel$export(module.exports, "sortMembersByType", ()=>$871928547f066260$export$90b27c15351f4a21);
    var $871928547f066260$var$MemberType;
    (function(MemberType) {
        MemberType[MemberType["CURRENT_USER"] = 0] = "CURRENT_USER";
        MemberType[MemberType["MEMBER"] = 1] = "MEMBER";
        MemberType[MemberType["INVITED"] = 2] = "INVITED";
        MemberType[MemberType["INACTIVE"] = 3] = "INACTIVE";
        MemberType[MemberType["DELETED"] = 4] = "DELETED";
    })($871928547f066260$var$MemberType || ($871928547f066260$var$MemberType = {}));
    const $871928547f066260$var$checkType = (member, currentAccountId)=>{
        if (member.membershipId.memberId === currentAccountId) return 0;
        else if (member && member.state === 'INVITED') return 2;
        else if (member.user?.status === 'inactive') return 3;
        else if (member.user?.status === 'closed') return 4;
        else return 1;
    };
    const $871928547f066260$export$90b27c15351f4a21 = (members, currentAccountId)=>{
        const newMembers = members.map((member)=>({
                member: member,
                type: $871928547f066260$var$checkType(member, currentAccountId)
            }));
        newMembers.sort(({ member: memberA, type: typeA }, { member: memberB, type: typeB })=>{
            if (typeA === typeB) return memberA.user?.fullName.localeCompare(memberB.user?.fullName || '') || 0;
            else return typeA - typeB;
        });
        return newMembers.map(({ member: member })=>member);
    };
});
parcelRegister("afodl", function(module, exports) {
    $parcel$export(module.exports, "isResultWithPageInfo", ()=>$6f07430cec62bdd2$export$7fb758c207c3ab4b);
    function $6f07430cec62bdd2$export$7fb758c207c3ab4b(result) {
        return result.pageInfo !== undefined;
    }
});
parcelRegister("bhfHz", function(module, exports) {
    $parcel$export(module.exports, "joinTeamState", ()=>$57537f75a24391af$export$6842649be21ecf13);
    var $kHmnq;
    const $57537f75a24391af$export$6842649be21ecf13 = (teamState, newMembership)=>{
        const { exitedTeams: exitedTeams, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
        const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';
        const teamId = newMembership.membershipId.teamId;
        if (requestingToJoin) return {
            ...teamState,
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: newMembership
            }
        };
        exitedTeams.delete(teamId);
        const currentUserId = newMembership.membershipId.memberId;
        const newMembers = teamMembers.members.filter((membership)=>{
            return membership.membershipId.memberId !== currentUserId;
        }).concat(newMembership);
        return {
            ...teamState,
            teamProfile: {
                teamId: teamId,
                hasLoaded: true,
                isLoading: false,
                errorType: null,
                data: {
                    ...teamProfile.data,
                    permission: 'FULL_WRITE'
                }
            },
            teamMembers: {
                teamId: teamId,
                hasLoaded: true,
                hasError: false,
                isLoading: false,
                isLoadingNextPage: false,
                errorType: null,
                members: (0, (0, parcelRequire("kHmnq")).sortMembersByType)(newMembers, currentUserId),
                requestingToJoinUsers: teamMembers.requestingToJoinUsers,
                membersPageInfo: teamMembers.membersPageInfo,
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: newMembership
            }
        };
    };
});
parcelRegister("66abk", function(module, exports) {
    $parcel$export(module.exports, "approveJoinRequest", ()=>$a2697356b23d45a6$export$a355add01c2f52a3);
    var $kHmnq;
    var $dmOdc;
    const $a2697356b23d45a6$export$a355add01c2f52a3 = (teamId, memberId, user)=>async ({ getState: getState, setState: setState })=>{
            const membership = await (0, (0, parcelRequire("dmOdc")).teamsClient).acceptJoinRequest(teamId, memberId);
            const state = getState();
            const { myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: { teamId: currentTeamId } } = state;
            if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') return;
            const newMembership = {
                ...membership,
                user: user
            };
            const newMembers = teamMembers.members.filter((membership)=>{
                return membership.membershipId.memberId !== memberId;
            }).concat(newMembership);
            const myMembership = myTeamMembership.membership;
            setState({
                ...state,
                teamMembers: {
                    teamId: teamId,
                    hasLoaded: true,
                    isLoadingNextPage: false,
                    hasError: false,
                    isLoading: false,
                    errorType: null,
                    membersPageInfo: teamMembers.membersPageInfo,
                    requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
                    members: (0, (0, parcelRequire("kHmnq")).sortMembersByType)(newMembers, myMembership?.membershipId.memberId),
                    requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
                }
            });
        };
});
parcelRegister("4m5re", function(module, exports) {
    $parcel$export(module.exports, "getMyTeamMembership", ()=>$4407dfc66ee0c8fb$export$72e6f466f46f9da0);
    var $kHmnq;
    var $dmOdc;
    var $loO6b;
    const $4407dfc66ee0c8fb$export$72e6f466f46f9da0 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
            if (!keepExistingData) setState({
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: false,
                    membership: undefined
                }
            });
            const { myTeamMembership: myTeamMembership } = getState();
            if (myTeamMembership.teamId !== teamId) return;
            const { value: membership } = await (0, (0, parcelRequire("loO6b")).promiseWithDefault)((0, (0, parcelRequire("dmOdc")).teamsClient).getMyTeamMembership(teamId), undefined);
            const { teamMembers: teamMembers } = getState();
            const members = teamMembers.members;
            const sortedMembers = members.length > 0 && !!membership ? {
                teamMembers: {
                    ...teamMembers,
                    members: (0, (0, parcelRequire("kHmnq")).sortMembersByType)(members, membership.membershipId.memberId)
                }
            } : {};
            setState({
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: membership
                },
                ...sortedMembers
            });
        };
});
parcelRegister("loO6b", function(module, exports) {
    $parcel$export(module.exports, "promiseWithDefault", ()=>$399bff40b50d1c77$export$a970b469503acdc8);
    function $399bff40b50d1c77$export$a970b469503acdc8(promise, defaultValue) {
        return promise.then((value)=>({
                value: value,
                success: true
            })).catch(()=>({
                value: defaultValue,
                success: false
            }));
    }
});
parcelRegister("4TUdO", function(module, exports) {
    $parcel$export(module.exports, "getTeamMembers", ()=>$6443cbad120854eb$export$e662071d38e352a1);
    var $VSDnB;
    var $kHmnq;
    var $dmOdc;
    var $afodl;
    const $6443cbad120854eb$var$combineIn = (existing, newData)=>{
        const addedMemberIds = new Set(newData.map((member)=>member.membershipId.memberId));
        return existing.filter((member)=>!addedMemberIds.has(member.membershipId.memberId)).concat(newData);
    };
    const $6443cbad120854eb$export$e662071d38e352a1 = (teamId, keepExistingData, first = 100)=>async ({ getState: getState, setState: setState })=>{
            if (!keepExistingData) setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: true,
                    isLoadingNextPage: false,
                    hasLoaded: false,
                    hasError: false,
                    errorType: null,
                    members: [],
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: true,
                    isLoadingNextPage: false,
                    hasLoaded: false,
                    hasError: false,
                    errorType: null,
                    members: []
                }
            });
            const { teamMembers: teamMembers } = getState();
            if (teamMembers.teamId !== teamId) return;
            setState({
                teamMembers: {
                    ...teamMembers,
                    isLoadingNextPage: true
                },
                teamAgents: {
                    ...teamMembers
                }
            });
            try {
                const membershipsResponse = await (0, (0, parcelRequire("dmOdc")).teamsClient).queryTeamMemberships(teamId, [
                    'FULL_MEMBER'
                ], {
                    first: first,
                    after: teamMembers.membersPageInfo.cursor ?? undefined
                });
                const memberships = (0, (0, parcelRequire("afodl")).isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.edges : membershipsResponse;
                const pageInfo = (0, (0, parcelRequire("afodl")).isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.pageInfo : {
                    hasNextPage: false,
                    endCursor: null
                };
                const myMembership = getState().myTeamMembership.membership;
                const myAccountId = myMembership?.membershipId.memberId;
                const membershipsWithExisting = keepExistingData ? $6443cbad120854eb$var$combineIn(teamMembers.members, memberships) : memberships;
                const sortedMembers = (0, (0, parcelRequire("kHmnq")).sortMembersByType)(membershipsWithExisting, myAccountId);
                const membersWithoutAgents = (0, (0, parcelRequire("VSDnB")).fg)('enable_teams_for_agents') ? sortedMembers.filter((member)=>!(member.user?.userType === 'agent')) : sortedMembers;
                const agents = sortedMembers.filter((member)=>member.user?.userType === 'agent');
                setState({
                    teamMembers: {
                        teamId: teamId,
                        isLoading: false,
                        isLoadingNextPage: false,
                        hasLoaded: true,
                        hasError: false,
                        errorType: null,
                        members: membersWithoutAgents,
                        requestingToJoinUsers: [],
                        requestingToJoinUsersPageInfo: {
                            hasNextPage: false,
                            cursor: null
                        },
                        membersPageInfo: {
                            hasNextPage: pageInfo.hasNextPage,
                            cursor: pageInfo.endCursor
                        }
                    },
                    teamAgents: {
                        teamId: teamId,
                        isLoading: false,
                        isLoadingNextPage: false,
                        hasLoaded: true,
                        hasError: false,
                        errorType: null,
                        members: agents
                    }
                });
            } catch (e) {
                if (getState().teamMembers.teamId !== teamId) return;
                setState({
                    teamMembers: {
                        teamId: teamId,
                        isLoading: false,
                        isLoadingNextPage: false,
                        hasLoaded: true,
                        hasError: true,
                        errorType: e,
                        members: [],
                        requestingToJoinUsers: [],
                        membersPageInfo: {
                            hasNextPage: false,
                            cursor: null
                        },
                        requestingToJoinUsersPageInfo: {
                            hasNextPage: false,
                            cursor: null
                        }
                    },
                    teamAgents: {
                        teamId: teamId,
                        isLoading: false,
                        isLoadingNextPage: false,
                        hasLoaded: true,
                        hasError: true,
                        errorType: e,
                        members: []
                    }
                });
            }
        };
});
parcelRegister("17Odl", function(module, exports) {
    $parcel$export(module.exports, "getTeamProfile", ()=>$60ff1b5f1789f089$export$7a5bb1168a5e8491);
    var $dmOdc;
    const $60ff1b5f1789f089$export$7a5bb1168a5e8491 = (teamId)=>async ({ setState: setState })=>{
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: true,
                    hasLoaded: false,
                    errorType: null,
                    data: {}
                }
            });
            try {
                const team = await (0, (0, parcelRequire("dmOdc")).teamsClient).getTeamById(teamId);
                setState({
                    teamProfile: {
                        teamId: teamId,
                        isLoading: false,
                        hasLoaded: true,
                        errorType: null,
                        data: team
                    }
                });
            } catch (e) {
                setState({
                    teamProfile: {
                        teamId: teamId,
                        isLoading: false,
                        hasLoaded: true,
                        errorType: e,
                        data: {}
                    }
                });
            }
        };
});
parcelRegister("3n2JP", function(module, exports) {
    $parcel$export(module.exports, "inviteUsersToTeam", ()=>$7ed51d7ca32e6f6f$export$ac31c528ad2c8490);
    var $kHmnq;
    var $dmOdc;
    var $2bf04;
    var $2af9Q;
    const $7ed51d7ca32e6f6f$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
        const { teamMembers: teamMembers } = teamState;
        const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
        const existingMembers = teamMembers.members.filter((member)=>{
            return !memberIds.has(member.membershipId.memberId);
        });
        const currentUserId = teamState.myTeamMembership.membership?.membershipId.memberId;
        const finalMembers = (0, (0, parcelRequire("kHmnq")).sortMembersByType)(newMemberships.concat(existingMembers), currentUserId);
        return {
            ...teamState,
            teamMembers: {
                ...teamState.teamMembers,
                teamId: teamState.teamMembers.teamId,
                hasLoaded: true,
                hasError: false,
                isLoading: false,
                errorType: null,
                members: finalMembers
            }
        };
    };
    const $7ed51d7ca32e6f6f$var$fetchJobTitlesOfNewMembers = (teamId, unpopulatedMembers, originQuery)=>async ({ getState: getState, setState: setState })=>{
            Promise.all(unpopulatedMembers.map((membership)=>{
                return (0, (0, parcelRequire("dmOdc")).teamsClient).queryAGGUser(membership.membershipId.memberId).then((user)=>{
                    return {
                        ...membership,
                        user: {
                            ...membership.user,
                            title: user.extendedProfile?.jobTitle
                        }
                    };
                });
            })).then((memberships)=>{
                const state = getState();
                if (state.teamMembers.teamId !== teamId) return;
                const titles = {};
                for (const member of memberships)titles[member.membershipId.memberId] = member.user.title || undefined;
                setState({
                    ...state,
                    teamMembers: {
                        ...state.teamMembers,
                        members: state.teamMembers.members.map((member)=>{
                            return {
                                ...member,
                                user: {
                                    ...member.user,
                                    title: titles[member.membershipId.memberId] || member.user.title
                                }
                            };
                        })
                    }
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("2bf04")).logException)(error, 'Could not populate new team members with titles');
            });
        };
    const $7ed51d7ca32e6f6f$export$ac31c528ad2c8490 = (teamId, members, originQuery)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
            (0, (0, parcelRequire("2af9Q")).addNewMembertoTeamSubExp).addMetadata({
                apiVersion: 'v4'
            });
            const addMembershipResponse = await (0, (0, parcelRequire("dmOdc")).teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                    accountId: member.id
                })));
            const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
                if (!partial.accountId) {
                    (0, (0, parcelRequire("2bf04")).logInfoMessage)('teamInvitationInvalidResponse', {
                        message: 'Membership in response was invalid',
                        member: partial,
                        response: addMembershipResponse
                    });
                    return acc;
                }
                const user = members.find((member)=>member.id === partial.accountId);
                if (!user) {
                    (0, (0, parcelRequire("2bf04")).logInfoMessage)('teamInvitationInvalidResponse', {
                        message: 'Could not find user details for this member',
                        member: partial,
                        response: addMembershipResponse
                    });
                    return acc;
                }
                acc.push({
                    membershipId: {
                        teamId: teamId,
                        memberId: partial.accountId
                    },
                    state: 'FULL_MEMBER',
                    role: 'REGULAR',
                    user: {
                        id: user.id,
                        fullName: user.name,
                        avatarUrl: user.avatarUrl,
                        userType: 'user'
                    }
                });
                return acc;
            }, []);
            const state = getState();
            if (teamId !== state.teamMembers.teamId) return;
            const nextState = $7ed51d7ca32e6f6f$export$d7fb3590d40d5847(state, memberships);
            setState(nextState);
            const unpopulatedMembers = addMembershipResponse.members.map((member)=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: member.accountId
                    },
                    state: 'FULL_MEMBER',
                    role: 'REGULAR'
                }));
            dispatch($7ed51d7ca32e6f6f$var$fetchJobTitlesOfNewMembers(teamId, unpopulatedMembers, originQuery));
            return memberships;
        };
});
parcelRegister("2af9Q", function(module, exports) {
    $parcel$export(module.exports, "renderTeamMemberRemoveDialogSubExp", ()=>$76a0c8359266acef$export$d04a4af02b71bd20);
    $parcel$export(module.exports, "removeMemberFromTeamSubExp", ()=>$76a0c8359266acef$export$8e622ac1f6a9e9f4);
    $parcel$export(module.exports, "removeMemberFromTeamExp", ()=>$76a0c8359266acef$export$ded699d92af3fb9e);
    $parcel$export(module.exports, "teamSettingsOverallExp", ()=>$76a0c8359266acef$export$efd0793305afa76a);
    $parcel$export(module.exports, "teamSettingsChangeTeamTypeExp", ()=>$76a0c8359266acef$export$fba164816385656f);
    $parcel$export(module.exports, "renderTeamMemberInviteDialogSubExp", ()=>$76a0c8359266acef$export$568d3db878ad8d23);
    $parcel$export(module.exports, "addNewMembertoTeamSubExp", ()=>$76a0c8359266acef$export$d691a209050136d6);
    $parcel$export(module.exports, "inviteMembersToTeamExperience", ()=>$76a0c8359266acef$export$2bd703f1fbcc240b);
    var $baNgi;
    var $atdLB;
    var $gjd6t;
    const $76a0c8359266acef$export$d04a4af02b71bd20 = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('render-team-member-remove-dialog', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$export$8e622ac1f6a9e9f4 = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('remove-member-from-team-action', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$var$removeMemberFromTeamSubExperiences = [
        $76a0c8359266acef$export$d04a4af02b71bd20,
        $76a0c8359266acef$export$8e622ac1f6a9e9f4
    ];
    const $76a0c8359266acef$export$ded699d92af3fb9e = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('remove-a-member-from-team', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'people'
        },
        until: (0, (0, parcelRequire("gjd6t")).untilAll)($76a0c8359266acef$var$removeMemberFromTeamSubExperiences.map((experience)=>({
                experience: experience
            })))
    });
    const $76a0c8359266acef$export$efd0793305afa76a = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('membership-control-change', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$export$a7f093db8a7d96e1 = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('membership-control-change-handle-requests', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$export$fba164816385656f = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('membership-control-change-change-team-type', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$export$568d3db878ad8d23 = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('render-team-member-invite-dialog', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$export$d691a209050136d6 = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('add-new-member-to-team-action', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
    const $76a0c8359266acef$var$inviteMembersToTeamSubExperiences = [
        $76a0c8359266acef$export$568d3db878ad8d23,
        $76a0c8359266acef$export$d691a209050136d6
    ];
    const $76a0c8359266acef$export$2bd703f1fbcc240b = new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)('invite-members-to-team', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'people'
        },
        until: (0, (0, parcelRequire("gjd6t")).untilAll)($76a0c8359266acef$var$inviteMembersToTeamSubExperiences.map((experience)=>({
                experience: experience
            })))
    });
});
parcelRegister("89d9t", function(module, exports) {
    $parcel$export(module.exports, "prefillTeamData", ()=>$531022751be5c09e$export$bc2925813ab9bc57);
    var $kHmnq;
    var $4m5re;
    var $4TUdO;
    const $531022751be5c09e$var$TIMEOUT_DELAY = 5000;
    function $531022751be5c09e$var$membershipMaker(teamId) {
        return (user)=>{
            return {
                membershipId: {
                    teamId: teamId,
                    memberId: user.id
                },
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: user
            };
        };
    }
    const $531022751be5c09e$export$bc2925813ab9bc57 = (teamId, teamData, members, currentUser)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const newState = {
                ...getState(),
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: teamData
                },
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: (0, (0, parcelRequire("kHmnq")).sortMembersByType)(members.map($531022751be5c09e$var$membershipMaker(teamId)), currentUser.id),
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: members.some((x)=>x.id === currentUser.id) ? $531022751be5c09e$var$membershipMaker(teamId)(currentUser) : undefined
                }
            };
            setState(newState);
            setTimeout(()=>{
                if (getState().teamProfile.teamId !== teamId) return;
                dispatch((0, (0, parcelRequire("4TUdO")).getTeamMembers)(teamId, true));
                dispatch((0, (0, parcelRequire("4m5re")).getMyTeamMembership)(teamId, true));
            }, $531022751be5c09e$var$TIMEOUT_DELAY);
        };
});
parcelRegister("j3TB6", function(module, exports) {
    $parcel$export(module.exports, "removeTeamMember", ()=>$852cef31cf6a8b5e$export$f7c0e1c7a2575f28);
    var $dmOdc;
    const $852cef31cf6a8b5e$export$87a89dfcfcd29512 = (teamState, memberId, permissions)=>{
        const { exitedTeams: exitedTeams, myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
        const teamId = myTeamMembership.teamId;
        const myMembership = myTeamMembership.membership;
        const isCurrentUser = myMembership && myMembership.membershipId.memberId === memberId;
        const finalMembers = {
            ...teamMembers,
            teamId: teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
        };
        if (!isCurrentUser) return {
            ...teamState,
            teamMembers: finalMembers
        };
        exitedTeams.add(teamId);
        const currentTeam = teamProfile.data;
        const permissionAfterRemoval = currentTeam.permission ? permissions?.canAdminTeams ? 'FULL_WRITE' : 'FULL_READ' : currentTeam.permission;
        return {
            ...teamState,
            teamMembers: finalMembers,
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: undefined
            },
            teamProfile: {
                teamId: teamId,
                isLoading: false,
                hasLoaded: true,
                errorType: null,
                data: {
                    ...currentTeam,
                    permission: permissionAfterRemoval
                }
            }
        };
    };
    const $852cef31cf6a8b5e$export$f7c0e1c7a2575f28 = (teamId, memberId, permissions)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            const removeMembershipResponse = await (0, (0, parcelRequire("dmOdc")).teamsClient).removeTeamMemberships(teamId, [
                {
                    accountId: memberId
                }
            ]);
            if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
            if (state.teamMembers.teamId !== teamId) return;
            const nextState = $852cef31cf6a8b5e$export$87a89dfcfcd29512(state, memberId, permissions);
            setState(nextState);
        };
});
parcelRegister("lwEMT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b374341e43188be4$export$2e2bcd8739ae039);
    var $dmOdc;
    const $b374341e43188be4$var$getAllTeams = (allTeamsQuery, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
            if (!keepExistingData) setState({
                allTeamsData: {
                    teams: [],
                    isLoading: true,
                    hasError: false,
                    cursor: ''
                }
            });
            try {
                const { teams: newTeams, cursor: cursor } = await (0, (0, parcelRequire("dmOdc")).teamsClient).getAllTeams(allTeamsQuery);
                setState({
                    allTeamsData: {
                        teams: [
                            ...getState().allTeamsData.teams,
                            ...newTeams
                        ],
                        isLoading: false,
                        hasError: false,
                        cursor: cursor
                    }
                });
            } catch (e) {
                setState({
                    allTeamsData: {
                        isLoading: false,
                        hasError: true,
                        teams: [],
                        cursor: '',
                        errorStatusCode: e.status
                    }
                });
            }
        };
    var $b374341e43188be4$export$2e2bcd8739ae039 = $b374341e43188be4$var$getAllTeams;
});
parcelRegister("levfe", function(module, exports) {
    $parcel$export(module.exports, "useV3OrgIdStatus", ()=>$717feac4baf972fe$export$52558c271a487a01);
    $parcel$export(module.exports, "verifyTeamsInSameOrgIfNeeded", ()=>$717feac4baf972fe$export$61f31a8e9c589b24);
    var $fyzT1;
    var $c5gm9;
    var $a2luh;
    function $717feac4baf972fe$export$52558c271a487a01() {
        const [{ orgId: orgId }] = (0, (0, parcelRequire("c5gm9")).useOrg)();
        return {
            orgId: orgId,
            isOrgLoading: !orgId
        };
    }
    function $717feac4baf972fe$export$61f31a8e9c589b24(teams, analytics, queryName, currentOrgId) {
        if (!currentOrgId) return;
        const orgARI = `ari:cloud:platform::org/${currentOrgId}`;
        const invalidTeams = teams.filter((team)=>!team.includesYou && team.orgId !== currentOrgId && team.orgId !== orgARI);
        if (invalidTeams.length) {
            const logTeamsData = invalidTeams.map((t)=>({
                    teamId: t.id,
                    orgId: t.orgId
                }));
            analytics.pushOperationalEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: 'TeamOrgMismatch',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).FAILED,
                attributes: {
                    currentOrgId: currentOrgId,
                    queryName: queryName
                }
            });
            (0, (0, parcelRequire("a2luh")).logErrorMessage)('TeamOrgMismatch', {
                currentOrgId: currentOrgId,
                teams: logTeamsData
            });
        }
    }
});
parcelRegister("iknOf", function(module, exports) {
    $parcel$export(module.exports, "UseQueryLightError", ()=>$0948a197dcd914bf$export$a1c33d09dbc37a86);
    var $0948a197dcd914bf$export$fe4bb20808298551;
    (function(ErrorCategory) {
        ErrorCategory["NotFound"] = "NotFound";
        ErrorCategory["NotPermitted"] = "NotPermitted";
        ErrorCategory["MalformedInput"] = "MalformedInput";
        ErrorCategory["Internal"] = "Internal";
    })($0948a197dcd914bf$export$fe4bb20808298551 || ($0948a197dcd914bf$export$fe4bb20808298551 = {}));
    class $0948a197dcd914bf$export$7f29b23735f2fedd extends Error {
        constructor(message){
            super(message);
            this.message = message;
        }
    }
    class $0948a197dcd914bf$export$a1c33d09dbc37a86 extends Error {
        constructor(message, name, graphQLErrors, networkError, extensions, extraInfo){
            super(message);
            this.graphQLErrors = graphQLErrors;
            this.networkError = networkError;
            this.extensions = extensions;
            this.extraInfo = extraInfo;
            if (name) this.name = name;
        }
    }
});
parcelRegister("IZxaE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eda80d9671a85e6$export$2e2bcd8739ae039);
    var $5cllN;
    var $5eda80d9671a85e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5cllN")).default)`
	query teamSearchV2(
		$first: Int
		$after: String
		$organizationId: ID!
		$query: String = ""
		$memberIds: [ID] = []
		$sortBy: [TeamSort]
		$siteId: String!
		$showEmptyTeams: Boolean = false
	) {
		team {
			teamSearch: teamSearchV2(
				first: $first
				after: $after
				organizationId: $organizationId
				filter: { query: $query, membership: { memberIds: $memberIds } }
				sortBy: $sortBy
				siteId: $siteId
				showEmptyTeams: $showEmptyTeams
			) @optIn(to: ["Team-search-v2"]) {
				nodes {
					...TeamNodeV2
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}

	fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;
});
parcelRegister("cBElP", function(module, exports) {
    $parcel$export(module.exports, "ApolloError", ()=>$8f9cf413c2b990dc$export$26a337512320b8c6);
    $parcel$export(module.exports, "sortBy", ()=>$8f9cf413c2b990dc$export$b035e44d7bb4278f);
    class $8f9cf413c2b990dc$export$26a337512320b8c6 extends Error {
        constructor(message, graphQLErrors, networkError, extraInfo, type){
            super(message);
            this.message = message;
            this.graphQLErrors = graphQLErrors;
            this.networkError = networkError;
            this.extraInfo = extraInfo;
            this.type = type;
        }
    }
    const $8f9cf413c2b990dc$export$b035e44d7bb4278f = [
        {
            field: 'DISPLAY_NAME',
            order: 'ASC'
        }
    ];
});
parcelRegister("iTt8D", function(module, exports) {
    $parcel$export(module.exports, "useQueryWrapper", ()=>$75a41a2d240f189a$export$3257ca80ae5054af);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $9C6JH;
    const $75a41a2d240f189a$export$3257ca80ae5054af = (query, options, enableTeamsGqlQueryMigration)=>{
        const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, (0, parcelRequire("5tTFS")).useQuery)(query, {
            ...options,
            skip: options.skip || enableTeamsGqlQueryMigration
        });
        const { data: dataNext, loading: loadingNext, error: errorNext, fetchMore: fetchMoreNext } = (0, (0, parcelRequire("9C6JH")).useQueryLight)(query, {
            operationName: options.operationName,
            serviceUrl: options.serviceUrl,
            customHeaders: options.customHeaders || options.context?.headers,
            variables: options.variables,
            skip: options.skip || !enableTeamsGqlQueryMigration
        });
        const transformedApolloFetchMore = (0, $5uXOq.useCallback)(({ variables: variables, handleDataMerge: handleDataMerge })=>{
            fetchMore({
                variables: variables,
                updateQuery: (prevResult, { fetchMoreResult: fetchMoreResult })=>{
                    return handleDataMerge(prevResult, fetchMoreResult) || prevResult;
                }
            });
        }, [
            fetchMore
        ]);
        if (enableTeamsGqlQueryMigration) return {
            data: dataNext,
            loading: loadingNext,
            error: errorNext,
            fetchMore: fetchMoreNext
        };
        return {
            loading: loading,
            error: error,
            data: data,
            fetchMore: transformedApolloFetchMore
        };
    };
});
parcelRegister("9C6JH", function(module, exports) {
    $parcel$export(module.exports, "useQueryLight", ()=>$45b243a28c63fa91$export$153654f6c7880a35);
    $parcel$export(module.exports, "useLazyQueryLight", ()=>$45b243a28c63fa91$export$3309ae9fea8ae473);
    var $5uXOq = parcelRequire("5uXOq");
    var $1c8Um;
    var $ajpes = parcelRequire("ajpes");
    var $4F5SC;
    var $6laLp;
    var $iknOf;
    const $45b243a28c63fa91$var$transformError = ({ error: error, graphQLErrors: graphQLErrors })=>new (0, (0, parcelRequire("iknOf")).UseQueryLightError)(error?.message || graphQLErrors?.[0]?.message || 'Unknown error', error?.name || graphQLErrors?.[0]?.name, graphQLErrors, error);
    const $45b243a28c63fa91$export$153654f6c7880a35 = (query, options)=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [data, setData] = (0, $5uXOq.useState)(undefined);
        const variablesRef = (0, $5uXOq.useRef)(options.variables);
        if (!(0, ($parcel$interopDefault($ajpes)))(variablesRef.current, options.variables)) variablesRef.current = options.variables;
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            try {
                setLoading(true);
                const response = await (0, (0, parcelRequire("4F5SC")).fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        ...options.customHeaders
                    }),
                    credentials: 'include',
                    body: JSON.stringify({
                        query: (0, (0, parcelRequire("1c8Um")).print)(query),
                        variables: {
                            ...variablesRef.current
                        }
                    })
                });
                const responseData = await response.json();
                if (response.ok) {
                    if (responseData.errors) setError($45b243a28c63fa91$var$transformError({
                        graphQLErrors: responseData.errors
                    }));
                    setData(responseData.data);
                    setLoading(false);
                } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
            } catch (error) {
                if (error instanceof Error) setError($45b243a28c63fa91$var$transformError({
                    error: error
                }));
                else {
                    setError($45b243a28c63fa91$var$transformError({
                        error: new Error('Unknown error')
                    }));
                    (0, (0, parcelRequire("6laLp")).logException)(error, `useQueryLight - ${options.operationName}`);
                }
                setData(undefined);
                setLoading(false);
            }
        }, [
            query,
            options.serviceUrl,
            options.operationName,
            options.customHeaders
        ]);
        const fetchMore = (0, $5uXOq.useCallback)(async ({ variables: variables, handleDataMerge: handleDataMerge })=>{
            try {
                setError(undefined);
                const response = await (0, (0, parcelRequire("4F5SC")).fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        ...options.customHeaders
                    }),
                    credentials: 'include',
                    body: JSON.stringify({
                        query: (0, (0, parcelRequire("1c8Um")).print)(query),
                        variables: {
                            ...variablesRef.current,
                            ...variables
                        }
                    })
                });
                const responseData = await response.json();
                if (response.ok) {
                    if (responseData.errors) setError($45b243a28c63fa91$var$transformError({
                        graphQLErrors: responseData.errors
                    }));
                    setData((prevData)=>handleDataMerge(prevData, responseData.data));
                } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
            } catch (error) {
                if (error instanceof Error) setError($45b243a28c63fa91$var$transformError({
                    error: error
                }));
                else {
                    setError($45b243a28c63fa91$var$transformError({
                        error: new Error('Unknown error')
                    }));
                    (0, (0, parcelRequire("6laLp")).logException)(error, `useQueryLight fetchMore - ${options.operationName}`);
                }
            }
        }, [
            query,
            options.serviceUrl,
            options.operationName,
            options.customHeaders
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!options.skip) fetchData();
            else setLoading(false);
        }, [
            options.skip,
            variablesRef.current
        ]);
        return {
            loading: loading,
            error: error,
            data: data,
            refetch: fetchData,
            fetchMore: fetchMore
        };
    };
    const $45b243a28c63fa91$export$3309ae9fea8ae473 = (query, options)=>{
        const [fetchTriggered, setFetchTriggered] = (0, $5uXOq.useState)(false);
        const { loading: loading, error: error, data: data, refetch: refetch, fetchMore: fetchMore } = $45b243a28c63fa91$export$153654f6c7880a35(query, {
            ...options,
            skip: !fetchTriggered
        });
        const triggerFetch = (0, $5uXOq.useCallback)(()=>{
            setFetchTriggered(true);
        }, []);
        return [
            triggerFetch,
            {
                loading: loading,
                error: error,
                data: data,
                refetch: refetch,
                fetchMore: fetchMore
            }
        ];
    };
});
parcelRegister("1tSRh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88d4c4aa4b3f9ebd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $88d4c4aa4b3f9ebd$var$InfiniteScroller = ({ hasMore: hasMore, children: children, loadMore: loadMore, loader: loader, isLoading: isLoading })=>{
        const loadMoreRef = (0, $5uXOq.useRef)(null);
        const fetchMoreCallback = (0, $5uXOq.useCallback)(([loadMoreEntry])=>{
            if (loadMoreEntry.isIntersecting && hasMore && !isLoading) loadMore();
        }, [
            loadMore,
            hasMore,
            isLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
            if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
            return ()=>{
                intersectionObserver.disconnect();
            };
        }, [
            loadMoreRef,
            fetchMoreCallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children, hasMore && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: loadMoreRef
        }), hasMore && loader);
    };
    var $88d4c4aa4b3f9ebd$export$2e2bcd8739ae039 = $88d4c4aa4b3f9ebd$var$InfiniteScroller;
});
parcelRegister("63MVP", function(module, exports) {
    $parcel$export(module.exports, "AboutContent", ()=>$b61421aa0c933c13$export$8197a708459a0877);
    $parcel$export(module.exports, "EmptyState", ()=>$b61421aa0c933c13$export$fddf379e22a74b00);
    $parcel$export(module.exports, "AboutSectionTitle", ()=>$b61421aa0c933c13$export$c9a3ce67560199a2);
    $parcel$export(module.exports, "AboutItemList", ()=>$b61421aa0c933c13$export$b7e7108d011c572b);
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    const $b61421aa0c933c13$export$8197a708459a0877 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1m5ose4-0"
    })``;
    const $b61421aa0c933c13$export$fddf379e22a74b00 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1m5ose4-1"
    })`display:flex;flex-direction:column;align-items:center;width:200px;margin:${"var(--ds-space-500, 40px)"} auto ${"var(--ds-space-200, 16px)"};text-align:center;p{margin-top:${"var(--ds-space-400, 32px)"};}`;
    const $b61421aa0c933c13$export$c9a3ce67560199a2 = (0, $47bDC.default).h2.withConfig({
        componentId: "sc-1m5ose4-2"
    })`${(0, (0, parcelRequire("3RZIb")).h200)};margin-top:${"var(--ds-space-300, 24px)"};margin-bottom:${"var(--ds-space-200, 16px)"};text-transform:uppercase;letter-spacing:normal;`;
    const $b61421aa0c933c13$export$b7e7108d011c572b = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1m5ose4-3"
    })`>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;
});
parcelRegister("4V0ms", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ba54ba354d50e52$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $VSDnB;
    var $f5TWP;
    var $fuhQD;
    var $dIjuX;
    var $lfJPE;
    var $i8owa;
    var $2s6UE;
    var $bnMl7;
    const $2ba54ba354d50e52$var$findMemberText = (isCurrentUser, team)=>{
        let messageData;
        if (isCurrentUser) messageData = (0, (0, parcelRequire("2s6UE")).messages).membersPlain;
        else messageData = team.includesYou ? (0, (0, parcelRequire("2s6UE")).messages).membersIncludingYou : (0, (0, parcelRequire("2s6UE")).messages).membersPlain;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...messageData,
            values: {
                memberCount: team.memberCount
            }
        });
    };
    function $2ba54ba354d50e52$export$2e2bcd8739ae039(props) {
        const { team: team, isCurrentUser: isCurrentUser, index: index, onClick: onClick } = props;
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            if (onClick) onClick(e, index);
        }, [
            index,
            onClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8owa")).default), {
            teamId: team.id,
            trigger: "hover",
            triggerLinkType: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dIjuX")).StyledOutlineLink), {
            onClick: handleClick,
            href: `team/${team.id}`,
            tabIndex: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemWrapper, {
            tabIndex: -1
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemAvatar, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfJPE")).default), {
            teamId: team.id,
            avatarUrl: team.smallAvatarImageUrl
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemBody, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemTeamName, null, team.displayName), team.isVerified && (0, (0, parcelRequire("VSDnB")).fg)('verified-icon-directory') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
            showTooltip: true,
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemTeamMembers, null, $2ba54ba354d50e52$var$findMemberText(isCurrentUser, team))))));
    }
});
parcelRegister("fuhQD", function(module, exports) {
    $parcel$export(module.exports, "VerifiedTeamIcon", ()=>$a137cc376204c926$export$d7949f68d31e5edd);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gqGjQ;
    var $fGmbh;
    var $3bDjY;
    var $27dJz;
    const $a137cc376204c926$export$d7949f68d31e5edd = ({ size: size, label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, (0, parcelRequire("27dJz")).messages).verifiedIconDefaultTooltip) : undefined;
        return tooltipContent ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon"
        }, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            label: tooltipContent,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            spacing: "spacious",
            label: label,
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        });
    };
});
parcelRegister("gqGjQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bf5fe6b7538334be$var$_UNSAFE_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>$bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.226.95c-.696.54-.87 1.52-.4 2.266l.828 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
    var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;
});
parcelRegister("fGmbh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9bd2ad2ea16bb95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        }));
    const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
        });
    var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;
});
parcelRegister("27dJz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$952fb45ddff9712a$export$defe85febe8b728c);
    var $7VHMR;
    const $952fb45ddff9712a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        verifiedIconDefaultTooltip: {
            id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
            defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
            description: 'Tooltip text for the verified team icon'
        }
    });
});
parcelRegister("dIjuX", function(module, exports) {
    $parcel$export(module.exports, "StyledOutlineLink", ()=>$e9005ae84efc39a3$export$2311a2c1c380abc1);
    var $47bDC = parcelRequire("47bDC");
    var $3FhRS;
    const $e9005ae84efc39a3$export$2311a2c1c380abc1 = (0, $47bDC.default)((0, (0, parcelRequire("3FhRS")).default)).withConfig({
        componentId: "bs9apg-0"
    })`display:block;background-color:${`var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border:none;padding:0;&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};cursor:pointer;border-radius:${"var(--ds-border-radius-100, 3px)"};}&:focus{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};outline:none;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.2s ease-in-out;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};}> *:focus{outline:none;}`;
});
parcelRegister("lfJPE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b4e321af1c46210$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $jKZpe;
    var $cUZxE;
    var $bqdXp;
    const $2b4e321af1c46210$var$TeamAvatarLegacy = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
        const [hasError, setError] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setError(false);
        }, [
            avatarUrl,
            teamId
        ]);
        if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bqdXp")).GradientImage, {
            gradientValues: (0, (0, parcelRequire("cUZxE")).getColorFromString)(teamId)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bqdXp")).Image, {
            src: avatarUrl,
            onError: ()=>setError(true),
            alt: ""
        });
    };
    function $2b4e321af1c46210$export$49e1e29e42184983(props) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('use_consistent_default_gradient_component')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKZpe")).TeamAvatar), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2b4e321af1c46210$var$TeamAvatarLegacy, props);
    }
    var $2b4e321af1c46210$export$2e2bcd8739ae039 = $2b4e321af1c46210$export$49e1e29e42184983;
});
parcelRegister("jKZpe", function(module, exports) {
    $parcel$export(module.exports, "TeamAvatar", ()=>$7ca6b55e1807b410$export$49e1e29e42184983);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $8CUq3;
    var $dNl82;
    var $lsJSD;
    var $3EjI7;
    const $7ca6b55e1807b410$var$fallbackStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        margin: 'space.025'
    });
    const $7ca6b55e1807b410$export$49e1e29e42184983 = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
        const [hasError, setError] = (0, $5uXOq.useState)(false);
        const [hasLoaded, setLoaded] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setError(false);
            setLoaded(false);
        }, [
            avatarUrl,
            teamId
        ]);
        if (hasError) return (0, (0, parcelRequire("VSDnB")).fg)('use_consistent_default_gradient_component') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lsJSD")).FallbackGradient), {
            stringToHash: teamId,
            customStyles: $7ca6b55e1807b410$var$fallbackStyle
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("3EjI7")).GradientImage, {
            gradientValues: (0, (0, parcelRequire("dNl82")).getColorFromString)(teamId)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("3EjI7")).Image, {
            src: avatarUrl,
            onError: ()=>setError(true),
            onLoad: ()=>setLoaded(true),
            hasLoaded: hasLoaded,
            alt: ""
        });
    };
});
parcelRegister("dNl82", function(module, exports) {
    $parcel$export(module.exports, "getIndexById", ()=>$4c28c89e6d57b14f$export$489ac0f4353bcbd0);
    $parcel$export(module.exports, "getColorFromString", ()=>$4c28c89e6d57b14f$export$137ec5185b12f5a2);
    const $4c28c89e6d57b14f$var$gradients = [
        `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
    ];
    const $4c28c89e6d57b14f$export$d41d9ab3de2def3d = (str)=>{
        let hash = 0;
        let chr;
        let i;
        for(i = 0; i < str.length; i++){
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash = hash & hash;
        }
        return hash;
    };
    const $4c28c89e6d57b14f$export$1ca062359344df12 = (id)=>{
        return $4c28c89e6d57b14f$export$489ac0f4353bcbd0(id, $4c28c89e6d57b14f$var$gradients.length);
    };
    const $4c28c89e6d57b14f$export$489ac0f4353bcbd0 = (id, arrayLength)=>{
        if (!id) return 0;
        const ordinal = ($4c28c89e6d57b14f$export$d41d9ab3de2def3d(id) % 50).toString().split('').map((chr)=>chr.charCodeAt(0)).reduce((a, b)=>a + b, 0);
        return ordinal % arrayLength;
    };
    const $4c28c89e6d57b14f$export$137ec5185b12f5a2 = (str)=>{
        const index = $4c28c89e6d57b14f$export$1ca062359344df12(str);
        return $4c28c89e6d57b14f$var$gradients[index];
    };
});
parcelRegister("lsJSD", function(module, exports) {
    $parcel$export(module.exports, "FallbackGradient", ()=>$5dec12b98688a40c$export$358466f81685c10c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3faAi;
    var $9Raxt;
    const $5dec12b98688a40c$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        overflow: 'hidden'
    });
    const $5dec12b98688a40c$var$gradientStyles = (0, (0, parcelRequire("3faAi")).gradients).map((gradient)=>(0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundImage: `linear-gradient(${gradient})`
        }));
    function $5dec12b98688a40c$export$358466f81685c10c(props) {
        const gradientIndex = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9Raxt")).getGradientIndexByString)(props.stringToHash), [
            props.stringToHash
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5dec12b98688a40c$var$styles,
                $5dec12b98688a40c$var$gradientStyles[gradientIndex],
                ...Array.isArray(props.customStyles) ? props.customStyles : [
                    props.customStyles
                ]
            ]
        }, props.children);
    }
});
parcelRegister("3faAi", function(module, exports) {
    $parcel$export(module.exports, "gradients", ()=>$038a2a65968c6faa$export$fc5727d09955ec17);
    const $038a2a65968c6faa$export$fc5727d09955ec17 = [
        `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
    ];
});
parcelRegister("9Raxt", function(module, exports) {
    $parcel$export(module.exports, "getGradientIndexByString", ()=>$27a708f157850eb9$export$47d4d34461987b5d);
    var $3faAi;
    const $27a708f157850eb9$var$hashCode = (str)=>{
        let hash = 0;
        let chr;
        let i;
        for(i = 0; i < str.length; i++){
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash = hash & hash;
        }
        return hash;
    };
    const $27a708f157850eb9$export$47d4d34461987b5d = (id)=>{
        if (!id) return 0;
        const ordinal = ($27a708f157850eb9$var$hashCode(id) % 50).toString().split('').map((chr)=>chr.charCodeAt(0)).reduce((a, b)=>a + b, 0);
        return ordinal % (0, (0, parcelRequire("3faAi")).gradients).length;
    };
    const $27a708f157850eb9$export$137ec5185b12f5a2 = (str)=>{
        const index = $27a708f157850eb9$export$47d4d34461987b5d(str);
        return (0, (0, parcelRequire("3faAi")).gradients)[index];
    };
});
parcelRegister("3EjI7", function(module, exports) {
    $parcel$export(module.exports, "GradientImage", ()=>$03e345e45b6033d1$export$cf9c515a80d2f7a4);
    $parcel$export(module.exports, "Image", ()=>$03e345e45b6033d1$export$3e431a229df88919);
    var $47bDC = parcelRequire("47bDC");
    const $03e345e45b6033d1$var$commonCss = (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
    const $03e345e45b6033d1$export$cf9c515a80d2f7a4 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1vmhbf4-0"
    })`${$03e345e45b6033d1$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
    const $03e345e45b6033d1$export$3e431a229df88919 = (0, $47bDC.default).img.withConfig({
        componentId: "sc-1vmhbf4-1"
    })`${$03e345e45b6033d1$var$commonCss};opacity:${(props)=>props.hasLoaded ? 1 : 0};`;
});
parcelRegister("cUZxE", function(module, exports) {
    $parcel$export(module.exports, "getColorFromString", ()=>$002f08c88fb75dc0$export$137ec5185b12f5a2);
    const $002f08c88fb75dc0$var$gradients = [
        `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
        `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
    ];
    const $002f08c88fb75dc0$export$d41d9ab3de2def3d = (str)=>{
        let hash = 0;
        let chr;
        let i;
        for(i = 0; i < str.length; i++){
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash = hash & hash;
        }
        return hash;
    };
    const $002f08c88fb75dc0$export$1ca062359344df12 = (id)=>{
        if (!id) return 0;
        const ordinal = ($002f08c88fb75dc0$export$d41d9ab3de2def3d(id) % 50).toString().split('').map((chr)=>chr.charCodeAt(0)).reduce((a, b)=>a + b, 0);
        return ordinal % $002f08c88fb75dc0$var$gradients.length;
    };
    const $002f08c88fb75dc0$export$137ec5185b12f5a2 = (str)=>{
        const index = $002f08c88fb75dc0$export$1ca062359344df12(str);
        return $002f08c88fb75dc0$var$gradients[index];
    };
});
parcelRegister("bqdXp", function(module, exports) {
    $parcel$export(module.exports, "GradientImage", ()=>$3ee3eead741e4383$export$cf9c515a80d2f7a4);
    $parcel$export(module.exports, "Image", ()=>$3ee3eead741e4383$export$3e431a229df88919);
    var $47bDC = parcelRequire("47bDC");
    const $3ee3eead741e4383$var$commonCss = (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
    const $3ee3eead741e4383$export$cf9c515a80d2f7a4 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-3e4kix-0"
    })`${$3ee3eead741e4383$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
    const $3ee3eead741e4383$export$3e431a229df88919 = (0, $47bDC.default).img.withConfig({
        componentId: "sc-3e4kix-1"
    })`${$3ee3eead741e4383$var$commonCss};`;
});
parcelRegister("i8owa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$825ddc5263532777$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4P8xB = parcelRequire("4P8xB");
    var $fff3y;
    var $5WmsO;
    var $levfe;
    var $7qFce;
    var $39CLR;
    var $2FwA3;
    var $fPHPe;
    function $825ddc5263532777$export$2e2bcd8739ae039(props) {
        const { children: children, onClick: onClick, position: position = 'bottom-start', trigger: trigger = 'hover', triggerLinkType: triggerLinkType = 'link', teamId: teamId } = props;
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const addFlag = (0, (0, parcelRequire("fPHPe")).useFlags)();
        const { contextEntryPoint: contextEntryPoint, push: push } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const profileClient = (0, (0, parcelRequire("7qFce")).useProfileClient)();
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const { orgId: orgId, isOrgLoading: isOrgLoading } = (0, (0, parcelRequire("levfe")).useV3OrgIdStatus)();
        const navigateToTeam = (0, $5uXOq.useCallback)(()=>push(`team/${teamId}`), [
            push,
            teamId
        ]);
        const generateUserLink = (0, $5uXOq.useCallback)((userId)=>(0, (0, parcelRequire("39CLR")).prefixWithContextEntryPoint)(userId, contextEntryPoint), [
            contextEntryPoint
        ]);
        const onUserClick = (0, $5uXOq.useCallback)((userId)=>push(userId), [
            push
        ]);
        if (isOrgLoading) return children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4P8xB.default), {
            position: position,
            orgId: orgId,
            teamId: teamId,
            resourceClient: profileClient,
            viewingUserId: principalUserId,
            trigger: trigger,
            triggerLinkType: triggerLinkType,
            viewProfileLink: (0, (0, parcelRequire("39CLR")).prefixWithContextEntryPoint)(`team/${teamId}`, contextEntryPoint),
            viewProfileOnClick: onClick || navigateToTeam,
            generateUserLink: generateUserLink,
            onUserClick: onUserClick,
            addFlag: addFlag,
            cloudId: cloudId
        }, children);
    }
});
parcelRegister("4P8xB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3295fbeb3692567b$export$2e2bcd8739ae039);
    var $6uTwi = parcelRequire("6uTwi");
    var $3295fbeb3692567b$export$2e2bcd8739ae039 = (0, $6uTwi.default);
});
parcelRegister("7qFce", function(module, exports) {
    $parcel$export(module.exports, "useProfileClient", ()=>$db3c12495af40804$export$d43dc22a8337ee9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    var $blw2B = parcelRequire("blw2B");
    var $4ArtL;
    var $jCvwN;
    var $2FwA3;
    const $db3c12495af40804$var$CACHE_MAX_AGE = 60000;
    function $db3c12495af40804$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId) {
        if (!state.profileClient) return false;
        return state.enableTeamCentral === enableTeamCentral && state.cloudId === cloudId;
    }
    const $db3c12495af40804$var$actions = {
        getClient: ()=>({ getState: getState, dispatch: dispatch })=>{
                const currentClient = getState().profileClient;
                if (currentClient) return currentClient;
                return dispatch($db3c12495af40804$var$actions.createClient());
            },
        createClient: (enableTeamCentral = false, cloudId = 'None', productName = '')=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                if ($db3c12495af40804$var$currentClientMatchesConfig(currentState, enableTeamCentral, cloudId)) return currentState.profileClient;
                setState({
                    enableTeamCentral: enableTeamCentral,
                    cloudId: cloudId
                });
                const { stargateRoot: stargateRoot } = (0, (0, parcelRequire("jCvwN")).getConfig)();
                const profileClient = new (0, $blw2B.default)({
                    gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                    url: `${stargateRoot}/directory/graphql`,
                    teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                    teamCentralBaseUrl: enableTeamCentral ? (0, (0, parcelRequire("jCvwN")).getConfig)().teamCentralUrl : undefined,
                    teamCentralDisabled: !enableTeamCentral,
                    cacheSize: 20,
                    cacheMaxAge: $db3c12495af40804$var$CACHE_MAX_AGE,
                    cloudId: cloudId,
                    productIdentifier: productName.toLowerCase()
                });
                setState({
                    profileClient: profileClient
                });
                return profileClient;
            }
    };
    const $db3c12495af40804$var$ProfileClientStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            enableTeamCentral: false,
            cloudId: 'None'
        },
        actions: $db3c12495af40804$var$actions
    });
    const $db3c12495af40804$var$useProfileClientState = (0, (0, parcelRequire("3sQ5x")).createHook)($db3c12495af40804$var$ProfileClientStore);
    const $db3c12495af40804$export$d43dc22a8337ee9f = ()=>{
        const [{ hasWorkspace: hasWorkspace, orgHasWorkspace: orgHasWorkspace }] = (0, (0, parcelRequire("4ArtL")).useTeamCentralStore)();
        const [state, { getClient: getClient, createClient: createClient }] = $db3c12495af40804$var$useProfileClientState();
        const { cloudId: cloudId, productName: productName } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const enableTeamCentral = hasWorkspace || orgHasWorkspace;
        (0, $5uXOq.useEffect)(()=>{
            if (!$db3c12495af40804$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId)) createClient(enableTeamCentral, cloudId, productName);
        }, [
            createClient,
            enableTeamCentral,
            state,
            cloudId,
            productName
        ]);
        return getClient();
    };
});
parcelRegister("fPHPe", function(module, exports) {
    $parcel$export(module.exports, "useFlags", ()=>$2785bf4a0bb494c9$export$2879604e6aec4ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $38ra6;
    var $2FwA3;
    const $2785bf4a0bb494c9$export$2879604e6aec4ab = ()=>{
        const { addFlag: addFlag } = (0, $5uXOq.useContext)((0, (0, parcelRequire("2FwA3")).default));
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const addFlagWithAnalytics = (flag, analyticsEvent)=>{
            if (analyticsEvent?.sendAnalytics) analytics.pushScreenEvent({
                name: analyticsEvent.name
            });
            addFlag(flag);
        };
        return addFlagWithAnalytics;
    };
});
parcelRegister("2s6UE", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$892e0bd400d4426d$export$defe85febe8b728c);
    var $7VHMR;
    const $892e0bd400d4426d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        membersPlain: {
            id: 'ptc-directory.user-profile-page.about.teams.item.members.plain',
            defaultMessage: '{memberCount, number} {memberCount, plural, one {member} other {members}}',
            description: 'Either the number of members your team has when you are viewing your own profile, or someone elses team that you are not a member of'
        },
        membersIncludingYou: {
            id: 'ptc-directory.user-profile-page.about.teams.item.members.including.you',
            defaultMessage: '{memberCount, number} {memberCount, plural, one {member, including you} other {members, including you}}',
            description: 'The number of team members, when viewing someone elses profile and you are also a member'
        },
        createTeamLabel: {
            id: 'ptc-directory.team-profile-page.create.team.button',
            defaultMessage: 'Create a team',
            description: 'Label of the CTA to create a new team. It is located in the list of teams a user is already a member of'
        },
        createTeamLabelOtherPeople: {
            id: 'ptc-directory.team-profile-page.create.team.button.other-people',
            defaultMessage: 'Create a team together',
            description: 'Label of the CTA to create a new team with other people. It is located in the list of teams a user is already a member of'
        }
    });
});
parcelRegister("bnMl7", function(module, exports) {
    $parcel$export(module.exports, "OutlineLink", ()=>$961e84093655be74$export$5749dbf81b0a6091);
    $parcel$export(module.exports, "TeamsProfileItemWrapper", ()=>$961e84093655be74$export$dfa3a67150a99336);
    $parcel$export(module.exports, "TeamsProfileItemAvatar", ()=>$961e84093655be74$export$5b03fe4ece786130);
    $parcel$export(module.exports, "TeamsProfileAddIcon", ()=>$961e84093655be74$export$e26c34d851c862e3);
    $parcel$export(module.exports, "TeamsProfileItemBody", ()=>$961e84093655be74$export$6dae78c6213b453c);
    $parcel$export(module.exports, "TeamsProfileItemTeamName", ()=>$961e84093655be74$export$14cef269f8b93bc1);
    $parcel$export(module.exports, "TeamsProfileItemTeamMembers", ()=>$961e84093655be74$export$b7842987d4a39270);
    var $47bDC = parcelRequire("47bDC");
    var $dIjuX;
    var $6PHb3;
    const $961e84093655be74$export$5749dbf81b0a6091 = (0, (0, parcelRequire("dIjuX")).StyledOutlineLink).withComponent('button');
    const $961e84093655be74$export$dfa3a67150a99336 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-0"
    })`display:flex;flex-basis:auto;${(0, (0, parcelRequire("6PHb3")).ellipsisInFlexChild)} height:${"var(--ds-space-500, 40px)"};align-items:center;`;
    const $961e84093655be74$export$5b03fe4ece786130 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-1"
    })`display:flex;padding-right:${"var(--ds-space-100, 8px)"};`;
    const $961e84093655be74$export$99f8df7d064294cc = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-2"
    })`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:0px ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"};`;
    const $961e84093655be74$export$e26c34d851c862e3 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-3"
    })`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:${"var(--ds-space-025, 2px)"};`;
    const $961e84093655be74$export$6dae78c6213b453c = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-4"
    })`display:flex;flex-flow:column;flex-basis:auto;${(0, (0, parcelRequire("6PHb3")).ellipsisInFlexChild)};`;
    const $961e84093655be74$export$14cef269f8b93bc1 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-5"
    })`font-size:14px;line-height:16px;padding-bottom:${"var(--ds-space-025, 2px)"};flex-basis:auto;${(0, (0, parcelRequire("6PHb3")).ellipsisInFlexChild)} color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};`;
    const $961e84093655be74$export$b7842987d4a39270 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8junt6-6"
    })`font-size:11px;line-height:14px;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};`;
});
parcelRegister("3m1cZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96dff5f1e5e8b41a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fyzT1;
    var $38ra6;
    var $7m1xZ;
    var $d7tic;
    var $5hWov;
    var $5hMxY;
    var $2s6UE;
    var $a8O97;
    var $bnMl7;
    const $96dff5f1e5e8b41a$var$TeamsProfileItemButton = (props)=>{
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const { openDialog: openDialog } = (0, (0, parcelRequire("7m1xZ")).useDialog)();
        const { proposedMembers: proposedMembers, source: source, isCurrentUser: isCurrentUser, isActiveUser: isActiveUser } = props;
        const { permissions: { canCreateTeams: canCreateTeams } } = (0, (0, parcelRequire("5hWov")).useTeamVisibility)();
        const [{ hasBrowseUsersPermission: hasBrowseUsersPermission }] = (0, (0, parcelRequire("d7tic")).useSettings)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            analytics.pushUIEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CREATE_TEAM_MODAL,
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).CLICKED,
                actionSubject: 'teamCreateDialogTriggerButton',
                attributes: {
                    trigger: source
                }
            });
            openDialog((0, (0, parcelRequire("5hMxY")).default), {
                proposedMembers: proposedMembers || []
            });
        }, [
            analytics,
            openDialog,
            proposedMembers,
            source
        ]);
        const canStartTeamWithUser = hasBrowseUsersPermission && isActiveUser && canCreateTeams;
        const showButton = isCurrentUser || !isCurrentUser && canStartTeamWithUser;
        return showButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).OutlineLink, {
            onClick: handleClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileAddIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a8O97")).TeamAddIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemBody, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, parcelRequire("bnMl7")).TeamsProfileItemTeamName, null, isCurrentUser ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2s6UE")).messages).createTeamLabel) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2s6UE")).messages).createTeamLabelOtherPeople))))) : null;
    };
    var $96dff5f1e5e8b41a$export$2e2bcd8739ae039 = $96dff5f1e5e8b41a$var$TeamsProfileItemButton;
});
parcelRegister("d7tic", function(module, exports) {
    $parcel$export(module.exports, "useSettings", ()=>$2d46dae541b949a8$export$9115b42802a3e44f);
    $parcel$export(module.exports, "useSettingsFeatureFlag", ()=>$2d46dae541b949a8$export$f2df9067cb58ea32);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $dmOdc;
    var $loO6b;
    var $04Mso;
    const $2d46dae541b949a8$export$28456d095a642fd = 'internal.browse-users-allowed';
    const $2d46dae541b949a8$var$actions = {
        getSettings: (product, cloudId)=>async ({ getState: getState, setState: setState })=>{
                if (getState().isFetching || getState().hasLoadedSettings) return;
                setState({
                    isFetching: true
                });
                try {
                    const directorySettingPromise = cloudId ? (0, (0, parcelRequire("dmOdc")).teamsClient).querySettings(cloudId, product) : Promise.resolve({
                        [$2d46dae541b949a8$export$28456d095a642fd]: true
                    });
                    return await (0, (0, parcelRequire("loO6b")).promiseWithDefault)(directorySettingPromise, {
                        [$2d46dae541b949a8$export$28456d095a642fd]: false
                    }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                        const settingsFromRequests = {
                            [$2d46dae541b949a8$export$28456d095a642fd]: false,
                            ...browseUsersEnabled
                        };
                        const finalSettings = {
                            ...(0, (0, parcelRequire("04Mso")).getSettingsFromStorage)() || {},
                            ...settingsFromRequests
                        };
                        setState({
                            hasLoadedSettings: true,
                            hasErrorOnFetchSettings: !settingsSuccess,
                            hasBrowseUsersPermission: !!finalSettings[$2d46dae541b949a8$export$28456d095a642fd],
                            settings: finalSettings
                        });
                    });
                } catch  {
                    setState({
                        hasErrorOnFetchSettings: true,
                        hasLoadedSettings: true
                    });
                } finally{
                    setState({
                        isFetching: false
                    });
                }
            }
    };
    const $2d46dae541b949a8$var$initialState = {
        hasLoadedSettings: false,
        hasErrorOnFetchSettings: false,
        hasBrowseUsersPermission: false,
        isFetching: false,
        settings: {
            [$2d46dae541b949a8$export$28456d095a642fd]: false,
            ...(0, (0, parcelRequire("04Mso")).getSettingsFromStorage)() || {}
        }
    };
    const $2d46dae541b949a8$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2d46dae541b949a8$var$initialState,
        actions: $2d46dae541b949a8$var$actions,
        name: 'Settings'
    });
    const $2d46dae541b949a8$export$8376625f8bb18347 = (0, (0, parcelRequire("gg7kZ")).createContainer)($2d46dae541b949a8$var$Store, {
        onInit: ()=>({ setState: setState }, state)=>{
                setState(state);
            }
    });
    const $2d46dae541b949a8$export$9115b42802a3e44f = (0, (0, parcelRequire("3sQ5x")).createHook)($2d46dae541b949a8$var$Store);
    const $2d46dae541b949a8$export$f2df9067cb58ea32 = (flagName)=>{
        const [{ settings: settings }] = $2d46dae541b949a8$export$9115b42802a3e44f();
        return settings[flagName];
    };
});
parcelRegister("5hMxY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ab60233033312c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tEry;
    const $44ab60233033312c$var$TeamCreateDialogLazy = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tEry")).default), props));
    };
    var $44ab60233033312c$export$2e2bcd8739ae039 = $44ab60233033312c$var$TeamCreateDialogLazy;
});
parcelRegister("5tEry", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7a5ec9edc3f1012$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b7a5ec9edc3f1012$var$TeamCreateDialogLazyWrapper = (0, $5uXOq.lazy)(()=>(parcelRequire("csNVu")));
    var $b7a5ec9edc3f1012$export$2e2bcd8739ae039 = $b7a5ec9edc3f1012$var$TeamCreateDialogLazyWrapper;
});
parcelRegister("csNVu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3DePX")
    ]).then(()=>parcelRequire('5iSAG'));
});
parcelRegister("a8O97", function(module, exports) {
    $parcel$export(module.exports, "TeamAddIcon", ()=>$460f524580a2bfe3$export$6972ee87109b1a65);
    var $5uXOq = parcelRequire("5uXOq");
    const $460f524580a2bfe3$export$6972ee87109b1a65 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "0.5",
            width: "24",
            height: "24",
            rx: "12",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            transform: "translate(4 4.5)",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.6667 11.8333V9.16667C12.6667 8.98986 12.5964 8.82029 12.4714 8.69526C12.3464 8.57024 12.1768 8.5 12 8.5C11.8232 8.5 11.6536 8.57024 11.5286 8.69526C11.4036 8.82029 11.3333 8.98986 11.3333 9.16667V11.8333H8.66667C8.48986 11.8333 8.32029 11.9036 8.19526 12.0286C8.07024 12.1536 8 12.3232 8 12.5C8 12.6768 8.07024 12.8464 8.19526 12.9714C8.32029 13.0964 8.48986 13.1667 8.66667 13.1667H11.3333V15.8333C11.3333 16.0101 11.4036 16.1797 11.5286 16.3047C11.6536 16.4298 11.8232 16.5 12 16.5C12.1768 16.5 12.3464 16.4298 12.4714 16.3047C12.5964 16.1797 12.6667 16.0101 12.6667 15.8333V13.1667H15.3333C15.5101 13.1667 15.6797 13.0964 15.8047 12.9714C15.9298 12.8464 16 12.6768 16 12.5C16 12.3232 15.9298 12.1536 15.8047 12.0286C15.6797 11.9036 15.5101 11.8333 15.3333 11.8333H12.6667Z",
            fill: "#42526E"
        }));
    };
});
parcelRegister("bGUXq", function(module, exports) {
    $parcel$export(module.exports, "AboutTeamsList", ()=>$196b62651b5c0289$export$f8d76b4306b647d6);
    $parcel$export(module.exports, "ShowMoreButton", ()=>$196b62651b5c0289$export$e41c325c8b11c297);
    $parcel$export(module.exports, "ErrorContainer", ()=>$196b62651b5c0289$export$97bdf39f6b82bb0);
    $parcel$export(module.exports, "ErrorTitle", ()=>$196b62651b5c0289$export$b065fd053267ec81);
    $parcel$export(module.exports, "ErrorMessageWrapper", ()=>$196b62651b5c0289$export$9e874bb1adc98a55);
    $parcel$export(module.exports, "ErrorIconWrapper", ()=>$196b62651b5c0289$export$b2471e0920d79944);
    $parcel$export(module.exports, "ErrorMessage", ()=>$196b62651b5c0289$export$915e9e7bd4f0f96d);
    var $47bDC = parcelRequire("47bDC");
    const $196b62651b5c0289$export$eb5006ed1ea4bea6 = (0, $47bDC.default).h6.withConfig({
        componentId: "sc-11mcmk0-0"
    })`color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};margin-bottom:${"var(--ds-space-200, 16px)"};`;
    const $196b62651b5c0289$export$f8d76b4306b647d6 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-1"
    })`display:flex;flex-direction:column;>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;
    const $196b62651b5c0289$export$eddf54ea3db8d0f0 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-2"
    })`margin-right:${"var(--ds-space-100, 8px)"};`;
    const $196b62651b5c0289$export$e41c325c8b11c297 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-3"
    })`text-align:left;padding:${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"};`;
    const $196b62651b5c0289$export$97bdf39f6b82bb0 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-4"
    })`display:flex;`;
    const $196b62651b5c0289$export$b065fd053267ec81 = (0, $47bDC.default).h5.withConfig({
        componentId: "sc-11mcmk0-5"
    })`color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};`;
    const $196b62651b5c0289$export$9e874bb1adc98a55 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-6"
    })``;
    const $196b62651b5c0289$export$b2471e0920d79944 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-7"
    })`margin-right:${"var(--ds-space-100, 8px)"};`;
    const $196b62651b5c0289$export$915e9e7bd4f0f96d = (0, $47bDC.default).div.withConfig({
        componentId: "sc-11mcmk0-8"
    })`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};font-size:11px;`;
});
parcelRegister("6i45Z", function(module, exports) {
    $parcel$export(module.exports, "AgentActions", ()=>$1ef04d2e8348086e$export$a091e6fbe251d12f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $h88oy;
    var $eHuCB;
    var $5WmsO;
    var $2FwA3;
    var $38Ckm;
    const $1ef04d2e8348086e$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $1ef04d2e8348086e$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $1ef04d2e8348086e$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $1ef04d2e8348086e$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $1ef04d2e8348086e$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
        return [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("38Ckm")).messages).actionDuplicate),
                onClick: onDuplicateAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("38Ckm")).messages).actionCopyLink),
                onClick: onCopyAgent
            }
        ];
    };
    const $1ef04d2e8348086e$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
        return [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("38Ckm")).messages).actionEdit),
                onClick: onEditAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("38Ckm")).messages).actionDelete),
                onClick: onDeleteAgent
            }
        ];
    };
    const $1ef04d2e8348086e$export$a091e6fbe251d12f = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, isAgentCreatedByUser: isAgentCreatedByUser, agentId: agentId, isForgeAgent: isForgeAgent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const { productName: productName } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const agentActions = $1ef04d2e8348086e$var$buildAgentActions({
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent
        });
        const agentSetting = $1ef04d2e8348086e$var$buildAgentSettings({
            onEditAgent: onEditAgent,
            onDeleteAgent: onDeleteAgent
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1ef04d2e8348086e$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            shouldFitContainer: true,
            onClick: onChatClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1ef04d2e8348086e$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1ef04d2e8348086e$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1ef04d2e8348086e$var$chatPillTextStyles
        }, formatMessage((0, (0, parcelRequire("38Ckm")).messages).actionChatToAgent)))))), (0, (0, parcelRequire("VSDnB")).fg)('rovo_use_agent_permissions') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHuCB")).AgentDropdownMenu), {
            agentId: agentId,
            isAgentCreatedByUser: isAgentCreatedByUser,
            isForgeAgent: isForgeAgent,
            onCopyAgent: onCopyAgent,
            onDeleteAgent: onDeleteAgent,
            onDuplicateAgent: onDuplicateAgent,
            onEditAgent: onEditAgent,
            loadPermissionsOnMount: true,
            assistanceServiceParams: {
                product: productName.toLowerCase() ?? 'rovo',
                touchpointSource: 'agent-profile-page',
                headers: {
                    'X-Cloudid': cloudId
                },
                experienceId: 'profile-page'
            }
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: "more",
                    ref: triggerRef
                }),
            placement: "bottom-end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: onClick
            }, text);
        })), isAgentCreatedByUser && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: onClick
            }, text);
        }))));
    };
});
parcelRegister("eHuCB", function(module, exports) {
    $parcel$export(module.exports, "ChatToAgentButton", ()=>$5852bb385b278e7a$export$ffe1cf57f0b5db02);
    $parcel$export(module.exports, "AgentDropdownMenu", ()=>$5852bb385b278e7a$export$fc284fc0f7cc8f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eCeGD;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $zPb6e;
    var $h88oy;
    var $rW2Zz;
    var $7Rg6D;
    const $5852bb385b278e7a$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $5852bb385b278e7a$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $5852bb385b278e7a$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $5852bb385b278e7a$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $5852bb385b278e7a$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $5852bb385b278e7a$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5852bb385b278e7a$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5852bb385b278e7a$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $5852bb385b278e7a$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5852bb385b278e7a$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5852bb385b278e7a$var$chatPillTextStyles
        }, formatMessage((0, (0, parcelRequire("7Rg6D")).default).chatToAgentButton))))));
    };
    const $5852bb385b278e7a$export$fc284fc0f7cc8f16 = (props)=>{
        const { refetch: refetch } = (0, (0, parcelRequire("rW2Zz")).useAgentPermissions)({
            agentId: props.agentId,
            enabled: false,
            assistanceServiceParams: props.assistanceServiceParams
        });
        const loadAgentPermissions = (0, $5uXOq.useCallback)(async ()=>{
            const response = await refetch();
            return {
                isEditEnabled: response?.permissions.AGENT_UPDATE?.permitted ?? false,
                isDeleteEnabled: response?.permissions.AGENT_DEACTIVATE?.permitted ?? false
            };
        }, [
            refetch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("zPb6e")).AgentDropdownMenu), {
            ...props,
            loadAgentPermissions: loadAgentPermissions
        });
    };
});
parcelRegister("rW2Zz", function(module, exports) {
    $parcel$export(module.exports, "useAgentPermissions", ()=>$db8ba39ef89917a2$export$be862330bf692bad);
    var $91cKc;
    var $cK3Jm;
    var $4ojTZ;
    const $db8ba39ef89917a2$export$be862330bf692bad = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
        const query = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'getAgentPermissions',
                agentId
            ],
            queryFn: async ()=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).GET_AGENT_PERMISSIONS,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).GET_AGENT_PERMISSIONS
                });
                return await assistanceService.getAgentPermissions(agentId, {
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                });
            },
            onSuccess: ()=>{
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).GET_AGENT_PERMISSIONS
                });
            },
            onError: (error)=>{
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).GET_AGENT_PERMISSIONS,
                    error: error
                });
            },
            enabled: enabled
        });
        return query;
    });
});
parcelRegister("7Rg6D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9c2763ab1d61842$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a9c2763ab1d61842$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chatToAgentButton: {
            id: 'rovo-chat.view-agent.chat-to-agent-button',
            defaultMessage: 'Chat to Agent',
            description: 'Button to chat to agent'
        }
    });
});
parcelRegister("38Ckm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$aa2207130b39be99$export$defe85febe8b728c);
    var $7VHMR;
    const $aa2207130b39be99$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actionChatToAgent: {
            id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
            defaultMessage: 'Chat to Agent',
            description: 'Text for the "chat to agent" action to chat to the agent'
        },
        actionDelete: {
            id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
            defaultMessage: 'Delete Agent',
            description: 'Text for the "Delete" action to delete an agent'
        },
        actionEdit: {
            id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
            defaultMessage: 'Edit Agent',
            description: 'Text for the "Edit" action to edit an agent'
        },
        actionCopyLink: {
            id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
            defaultMessage: 'Copy link',
            description: 'Text for the Copy link of an agent'
        },
        actionDuplicate: {
            id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
            defaultMessage: 'Duplicate Agent',
            description: 'Text for the Duplicate Agent action to create a duplicate'
        },
        agentDeletedSuccessFlagTitle: {
            id: 'ptc-directory.agent-profile.delete-agent-success-flag-title',
            defaultMessage: 'Agent deleted',
            description: 'Flag message title displayed when an agent is deleted'
        },
        agentDeletedSuccessFlagDescription: {
            id: 'ptc-directory.agent-profile.delete-agent-success-flag-description',
            defaultMessage: 'You deleted {agentName}',
            description: 'Flag message description displayed when an agent is deleted'
        },
        agentDeletedErrorFlagTitle: {
            id: 'ptc-directory.agent-profile.delete-agent-error-flag-title',
            defaultMessage: 'Failed to delete Agent',
            description: 'Flag message title displayed when there is an error deleting agent'
        },
        agentDeletedErrorFlagDescription: {
            id: 'ptc-directory.agent-profile.delete-agent-error-flag-description',
            defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
            description: 'Flag message description displayed when there is an error deleting agent'
        }
    });
});
parcelRegister("6eD5g", function(module, exports) {
    $parcel$export(module.exports, "AgentConversationStartersSection", ()=>$779ac05b28e41648$export$574a87e4832466ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $luBm6;
    var $4ns5a;
    var $4kUAd;
    const $779ac05b28e41648$export$574a87e4832466ff = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleConversationStarterClick = (conversationStarter)=>{
            onConversationStarterClick(conversationStarter);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kUAd")).MainContentHeaders), null, formatMessage($779ac05b28e41648$var$messages.openChatLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignInline: "start",
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ns5a")).AgentConversationStarters), {
            isAgentDefault: isAgentDefault,
            onConversationStarterClick: handleConversationStarterClick,
            userDefinedConversationStarters: userDefinedConversationStarters
        })));
    };
    const $779ac05b28e41648$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openChatLabel: {
            id: 'ptc-directory.agent-profile.conversation-starter.header',
            defaultMessage: 'Open chat',
            description: 'Label for about section of the agent'
        }
    });
});
parcelRegister("4kUAd", function(module, exports) {
    $parcel$export(module.exports, "MainContentHeaders", ()=>$e8e70b7038ae1c5a$export$161f9e38c5e0d38e);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    const $e8e70b7038ae1c5a$export$161f9e38c5e0d38e = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "large",
            color: "color.text.subtle",
            weight: "semibold"
        }, children);
});
parcelRegister("j9p2O", function(module, exports) {
    $parcel$export(module.exports, "AgentCreator", ()=>$bef29a5dc839b1ea$export$d892e919a94dad49);
    var $5uXOq = parcelRequire("5uXOq");
    var $77Oft;
    var $hd01g;
    var $7YTpJ;
    const $bef29a5dc839b1ea$export$d892e919a94dad49 = ({ creator: creator, create_type: create_type })=>{
        const userId = create_type === 'CUSTOMER' && creator ? (0, (0, parcelRequire("7YTpJ")).trimUserARI)(creator) : '';
        const { isLoading: isLoading, data: data } = (0, (0, parcelRequire("hd01g")).useTeamsUser)(userId, !userId);
        const getCreator = ()=>{
            switch(create_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'FORGE':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    return {
                        type: 'CUSTOMER',
                        name: data?.fullName || '',
                        profileLink: `/people/${data?.id}`
                    };
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileCreator), {
            creator: getCreator(),
            isLoading: isLoading,
            onCreatorLinkClick: ()=>{}
        });
    };
});
parcelRegister("l9Oyp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3376005ab09c827e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $eCeGD;
    var $qfj8c;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    const $3376005ab09c827e$var$errStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150'
    });
    const $3376005ab09c827e$var$agentResponseMessageTemplate = {
        AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
        USER_NOT_CREATOR: 'errorIncorrectOwner',
        AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
        AGENT_DELETE_SUCCESS: 'agentDeletedSuccess'
    };
    const $3376005ab09c827e$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, agentId: agentId, onDelete: onDelete })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [deleteError, setDeleteError] = (0, $5uXOq.useState)();
        const [isDeletePending, setIsDeletePending] = (0, $5uXOq.useState)(false);
        const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
            if (agentId) {
                setIsDeletePending(true);
                try {
                    await onDelete?.();
                    onClose?.();
                } catch (error) {
                    setDeleteError(formatMessage($3376005ab09c827e$var$messages[$3376005ab09c827e$var$agentResponseMessageTemplate[error?.message_template]]));
                } finally{
                    setIsDeletePending(false);
                }
            }
        }, [
            agentId,
            formatMessage,
            onClose,
            onDelete
        ]);
        if (!agentId) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage($3376005ab09c827e$var$messages.title, {
            agentName: agentName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage($3376005ab09c827e$var$messages.body)), deleteError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3376005ab09c827e$var$errStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, deleteError)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage($3376005ab09c827e$var$messages.cancelText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "danger",
            isDisabled: !!deleteError || isDeletePending,
            onClick: (_e, _event)=>{
                handleDeleteAgent();
            }
        }, formatMessage($3376005ab09c827e$var$messages.confirmText)))));
    };
    var $3376005ab09c827e$export$2e2bcd8739ae039 = $3376005ab09c827e$export$39d869cf16a68f79;
    const $3376005ab09c827e$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelText: {
            id: 'ptc-directory.agent-profile.agent-delete-confirm.cancel-text',
            defaultMessage: 'Cancel'
        },
        confirmText: {
            id: 'ptc-directory.agent-profile.agent-delete-confirm.confirm-text',
            defaultMessage: 'Delete'
        },
        title: {
            id: 'ptc-directory.agent-profile.delete-agent-confirm-title',
            defaultMessage: 'Delete "{agentName}"?',
            description: 'Title text for the delete agent confirmation modal'
        },
        body: {
            id: 'ptc-directory.agent-profile.delete-agent-confirm-body',
            defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
            description: 'Body text for the delete agent confirmation modal'
        },
        error: {
            id: 'ptc-directory.agent-profile.delete-agent-error',
            defaultMessage: 'Could not delete agent',
            description: 'Error message displayed when an agent cannot be deleted'
        },
        errorAgentNotFound: {
            id: 'ptc-directory.agent-profile.delete-agent-error.agent-not-found',
            defaultMessage: 'That agent could not be found.',
            description: 'Error message displayed when an agent cannot be found'
        },
        errorAgentInUse: {
            id: 'ptc-directory.agent-profile.delete-agent-error.agent-in-use',
            defaultMessage: 'Agent is currently in use. Try again later.',
            description: 'Error message displayed when an agent is in use'
        },
        errorIncorrectOwner: {
            id: 'ptc-directory.agent-profile.delete-agent-error.incorrect-owner',
            defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
            description: 'Error message displayed when the agent owner is incorrect'
        },
        agentDeletedSuccess: {
            id: 'ptc-directory.agent-profile.delete-agent-success',
            defaultMessage: 'Agent has been deleted!',
            description: 'Success message displayed when an agent is deleted'
        }
    });
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("i9EPN", function(module, exports) {
    $parcel$export(module.exports, "useAgentActions", ()=>$4e35ca995668cf2a$export$9115df56efd01c09);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9oBwb;
    var $kTK0a;
    var $bpqZM;
    var $lwQnS;
    var $2gP8c;
    var $3FH71;
    var $fyzT1;
    var $fPHPe;
    var $75AK4;
    var $38Ckm;
    const $4e35ca995668cf2a$export$9115df56efd01c09 = ({ product: product, cloudId: cloudId, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId })=>{
        const addFlag = (0, (0, parcelRequire("fPHPe")).useFlags)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("75AK4")).useRouter)();
        const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, (0, parcelRequire("bpqZM")).useAgentFavourites)({
            experienceId: 'profile-page',
            product: product
        });
        const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent } = (0, (0, parcelRequire("lwQnS")).useAgentUrlActions)({
            siteId: cloudId
        });
        const { deleteAgent: deleteRovoAgent } = (0, (0, parcelRequire("2gP8c")).useDeleteAgent)({
            experienceId: 'profile-page',
            product: product
        });
        const setFavouriteAgent = (0, $5uXOq.useCallback)(async (isFavourite, onSuccess)=>{
            if (!agentId) return;
            if (isFavourite) return await favouriteAgent.mutate(agentId, {
                onSuccess: onSuccess
            });
            else return await unfavouriteAgent.mutate(agentId, {
                onSuccess: onSuccess
            });
        }, [
            agentId,
            favouriteAgent,
            unfavouriteAgent
        ]);
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("3FH71")).usePeopleTeamAnalyticsEvents)();
        const editAgent = ()=>{
            if (!agentId) return;
            fireEvent('ui.editAgent.clicked', {});
            onEditAgent(agentId);
        };
        const copyAgent = ()=>{
            if (!agentId) return;
            fireEvent('ui.copyAgent.clicked', {});
            onCopyAgent({
                agentId: agentId,
                agentIdentityAccountId: agentIdentityAccountId
            });
        };
        const duplicateAgent = ()=>{
            if (!agentId) return;
            fireEvent('ui.duplicateAgent.clicked', {});
            onDuplicateAgent(agentId);
        };
        const deleteAgent = ()=>{
            if (!agentId) return;
            fireEvent('ui.deleteAgent.clicked', {});
            deleteRovoAgent.mutate(agentId, {
                onSuccess: ()=>{
                    addFlag({
                        title: formatMessage((0, (0, parcelRequire("38Ckm")).messages).agentDeletedSuccessFlagTitle),
                        description: formatMessage((0, (0, parcelRequire("38Ckm")).messages).agentDeletedSuccessFlagDescription, {
                            agentName: agentName
                        }),
                        type: 'success',
                        id: 'ptc-directory.agent-profile.delete-agent-success'
                    }, {
                        sendAnalytics: true,
                        name: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).AGENT_DELETE_SUCCESS_FLAG
                    });
                    setTimeout(()=>{
                        push('search');
                    }, 100);
                },
                onError: ()=>{
                    addFlag({
                        title: formatMessage((0, (0, parcelRequire("38Ckm")).messages).agentDeletedErrorFlagTitle),
                        description: formatMessage((0, (0, parcelRequire("38Ckm")).messages).agentDeletedErrorFlagDescription),
                        type: 'error',
                        id: 'ptc-directory.agent-profile.delete-agent-error'
                    }, {
                        sendAnalytics: true,
                        name: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).AGENT_DELETE_ERROR_FLAG
                    });
                }
            });
        };
        const onChatWithAgent = ()=>{
            if (!agentId) return;
            fireEvent('ui.chatWithAgent.clicked', {});
            window.open((0, (0, parcelRequire("9oBwb")).addRovoParamsToUrl)(`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`, {
                pathway: 'chat',
                cloudId: cloudId,
                agentId: agentId
            }), '_blank', 'noopener, noreferrer');
        };
        const startConversation = (prompt)=>{
            if (!agentId) return;
            fireEvent('ui.startConversationWithAgent.clicked', {});
            window.open((0, (0, parcelRequire("9oBwb")).addRovoParamsToUrl)(`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`, {
                pathway: 'chat',
                prompt: prompt,
                cloudId: cloudId,
                agentId: agentId
            }), '_blank', 'noopener, noreferrer');
        };
        return {
            setFavouriteAgent: setFavouriteAgent,
            editAgent: editAgent,
            copyAgent: copyAgent,
            duplicateAgent: duplicateAgent,
            deleteAgent: deleteAgent,
            onChatWithAgent: onChatWithAgent,
            startConversation: startConversation
        };
    };
});
parcelRegister("bpqZM", function(module, exports) {
    $parcel$export(module.exports, "useAgentFavourites", ()=>$2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69);
    var $gKZoD;
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $mNrGv;
    const $2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69 = ({ onError: onError, onSuccess: onSuccess, experienceId: experienceId = 'ai-mate', product: product } = {})=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("cK3Jm")).useAssistanceService));
        const assistanceService = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)({
            experienceId: experienceId,
            product: product
        });
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const favouriteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT
                });
                return await assistanceService.favouriteAgent(id);
            },
            onSuccess: async ()=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT
                });
                onSuccess?.({
                    favourite: true
                });
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT,
                    error: error
                });
                onError?.({
                    favourite: true
                });
            }
        });
        const unfavouriteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT
                });
                return await assistanceService.unfavouriteAgent(id);
            },
            onSuccess: async ()=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT
                });
                onSuccess?.({
                    favourite: false
                });
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT,
                    error: error
                });
                onError?.({
                    favourite: false
                });
            }
        });
        return {
            favouriteAgent: favouriteAgent,
            unfavouriteAgent: unfavouriteAgent
        };
    };
});
parcelRegister("mNrGv", function(module, exports) {
    $parcel$export(module.exports, "useMutation", ()=>$46b29c557c6575a6$export$609860bf8b0084c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gRLdW;
    const $46b29c557c6575a6$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
        const mutationFnRef = (0, $5uXOq.useRef)(mutationFn);
        mutationFnRef.current = mutationFn;
        const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
        onSuccessRef.current = onSuccess;
        const onErrorRef = (0, $5uXOq.useRef)(onError);
        onErrorRef.current = onError;
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [isSubmitting, setIsSubmitting] = (0, $5uXOq.useState)(false);
        const mutate = (0, $5uXOq.useCallback)(async (payload, mutateCallback)=>{
            setIsSubmitting(true);
            try {
                const response = await mutationFnRef.current(payload);
                setData(response);
                onSuccessRef.current?.(response);
                mutateCallback?.onSuccess?.(response);
            } catch (error) {
                const apiError = (0, (0, parcelRequire("gRLdW")).mapErrorToApiError)(error);
                setError(apiError);
                onErrorRef.current?.(apiError);
                mutateCallback?.onError?.(apiError);
            } finally{
                setIsSubmitting(false);
            }
        }, []);
        return {
            data: data,
            error: error,
            isSubmitting: isSubmitting,
            mutate: mutate
        };
    };
});
parcelRegister("lwQnS", function(module, exports) {
    $parcel$export(module.exports, "useAgentUrlActions", ()=>$54c9716caa3eca00$export$56665b80ee272742);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $9oBwb;
    var $coJZk;
    const $54c9716caa3eca00$export$56665b80ee272742 = ({ siteId: siteId })=>{
        const { atlasURL: atlasURL } = (0, (0, parcelRequire("coJZk")).useAtlasURL)(siteId);
        const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
            window.open(atlasURL(`/chat/agents/${agentId}/edit`), '_blank', 'noopener, noreferrer');
        }, [
            atlasURL
        ]);
        const onCopyAgent = (0, $5uXOq.useCallback)(({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId })=>{
            if (agentIdentityAccountId && (0, (0, parcelRequire("VSDnB")).fg)('rovo_agent_profile_page')) {
                navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
                return;
            }
            const rovoParams = (0, (0, parcelRequire("9oBwb")).encodeRovoParams)({
                pathway: 'chat',
                agentId: agentId
            });
            navigator.clipboard.writeText(atlasURL(`/chat?${rovoParams}`));
        }, [
            atlasURL
        ]);
        const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const rovoParams = (0, (0, parcelRequire("9oBwb")).encodeRovoParams)({
                pathway: 'agents-create',
                agentId: agentId
            });
            window.open(atlasURL(`/chat/agents/new?${rovoParams}`), '_blank', 'noopener, noreferrer');
        }, [
            atlasURL
        ]);
        const onViewAgentFullProfile = (0, $5uXOq.useCallback)((agentId)=>{
            window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
        }, []);
        const onStartNewChatWindowWithPrompt = (0, $5uXOq.useCallback)((agentId, prompt)=>{
            const rovoParams = (0, (0, parcelRequire("9oBwb")).encodeRovoParams)({
                pathway: 'chat',
                agentId: agentId,
                prompt: prompt
            });
            window.open(atlasURL(`/chat?${rovoParams}`), '_blank', 'noopener, noreferrer');
        }, [
            atlasURL
        ]);
        return {
            onEditAgent: onEditAgent,
            onCopyAgent: onCopyAgent,
            onDuplicateAgent: onDuplicateAgent,
            onViewAgentFullProfile: onViewAgentFullProfile,
            onStartNewChatWindowWithPrompt: onStartNewChatWindowWithPrompt
        };
    };
});
parcelRegister("coJZk", function(module, exports) {
    $parcel$export(module.exports, "useAtlasURL", ()=>$3fd98f43d07a6613$export$8a1abb7c176bd202);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1tAG;
    var $g71tv;
    const $3fd98f43d07a6613$export$8a1abb7c176bd202 = (siteId)=>{
        const { data: tenantData } = (0, (0, parcelRequire("g71tv")).useTenantDataController)(siteId);
        const atlasURL = (0, $5uXOq.useCallback)((path)=>(0, (0, parcelRequire("f1tAG")).getAtlasURL)(siteId, path, tenantData?.orgId), [
            siteId,
            tenantData?.orgId
        ]);
        return {
            atlasURL: atlasURL
        };
    };
});
parcelRegister("g71tv", function(module, exports) {
    $parcel$export(module.exports, "useTenantDataController", ()=>$926b0b614556f1b8$export$b863fec6791eae25);
    var $91cKc;
    var $cSxED;
    var $4ojTZ;
    var $hJfuA;
    const $926b0b614556f1b8$export$b863fec6791eae25 = (siteId)=>{
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const { data: data, isFetching: isFetching, error: error } = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'viewAgentTenantData',
                siteId
            ],
            queryFn: async ()=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_TENANT_DATA,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_TENANT_DATA
                });
                const result = await (0, (0, parcelRequire("hJfuA")).getCloudUrlFromId)(siteId);
                return result;
            },
            onSuccess: ()=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_TENANT_DATA
                });
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENT_TENANT_DATA,
                    error: error
                });
            }
        });
        return {
            data: data,
            isFetching: isFetching,
            error: error
        };
    };
});
parcelRegister("hJfuA", function(module, exports) {
    $parcel$export(module.exports, "getCloudUrlFromId", ()=>$155fa854340f6b93$export$d4ace54df9bd6bb1);
    var $lyFsp;
    const $155fa854340f6b93$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
    const $155fa854340f6b93$export$d4ace54df9bd6bb1 = async (cloudId)=>{
        const response = await (0, (0, parcelRequire("lyFsp")).performGqlFetch)({
            gqlQuery: $155fa854340f6b93$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        return response.data?.tenantContexts?.[0];
    };
});
parcelRegister("2gP8c", function(module, exports) {
    $parcel$export(module.exports, "useDeleteAgent", ()=>$919aea89356508dc$export$89877d4f8d8790ca);
    var $gKZoD;
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $mNrGv;
    const $919aea89356508dc$export$89877d4f8d8790ca = ({ experienceId: experienceId, product: product, onSuccess: onSuccess, onError: onError } = {})=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("cK3Jm")).useAssistanceService));
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const assistanceService = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)({
            experienceId: experienceId,
            product: product
        });
        const deleteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT
                });
                return await assistanceService.deleteAgent(id);
            },
            onSuccess: async (data)=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT
                });
                onSuccess?.();
                return data;
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT,
                    error: error
                });
                onError?.();
            }
        });
        return {
            deleteAgent: deleteAgent
        };
    };
});
parcelRegister("75AK4", function(module, exports) {
    $parcel$export(module.exports, "useRouter", ()=>$51b0842c1ce9558f$export$9a302a45f65d0572);
    var $5uXOq = parcelRequire("5uXOq");
    var $2FwA3;
    const $51b0842c1ce9558f$export$9a302a45f65d0572 = ()=>{
        const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push, replace: replace, history: history } = (0, $5uXOq.useContext)((0, (0, parcelRequire("2FwA3")).default));
        return {
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            history: history
        };
    };
});
parcelRegister("7U47G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aEx3K").then(()=>parcelRequire('dtsuM'));
});
parcelRegister("gc5DR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0e6274cdbe564c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $65ws1;
    var $38ra6;
    var $2FwA3;
    var $lY8FH;
    function $a0e6274cdbe564c1$var$recordPageVisitOrigin(replace) {
        const url = new URL(window.location.href);
        if (!url || !url.searchParams) return;
        const ref = url.searchParams.get('ref') || '';
        const src = url.searchParams.get('src') || '';
        if (!ref && !src) return;
        (0, (0, parcelRequire("65ws1")).default).set({
            src: src,
            ref: ref
        });
        url.searchParams.delete('ref');
        url.searchParams.delete('src');
        if (replace) replace(`${url.pathname}${url.search}`);
    }
    function $a0e6274cdbe564c1$var$RecordTransition(props) {
        const { name: name } = props;
        const { replace: replace } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        const refInitialLoadTracked = (0, $5uXOq.useRef)(false);
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!refInitialLoadTracked.current) {
                refInitialLoadTracked.current = true;
                $a0e6274cdbe564c1$var$recordPageVisitOrigin(replace);
            } else (0, (0, parcelRequire("65ws1")).default).cleanup();
            (0, (0, parcelRequire("lY8FH")).default)(name, analytics);
        }, [
            analytics,
            name,
            replace
        ]);
        return null;
    }
    var $a0e6274cdbe564c1$export$2e2bcd8739ae039 = $a0e6274cdbe564c1$var$RecordTransition;
});
parcelRegister("lY8FH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64277dac6b18863c$export$2e2bcd8739ae039);
    var $l7duG;
    let $64277dac6b18863c$var$dwellHelper = null;
    const $64277dac6b18863c$var$buildDwellEventData = (source)=>{
        return {
            actionSubject: 'page',
            source: source
        };
    };
    const $64277dac6b18863c$var$sendDwellEvent = (eventData, analyticsClient)=>{
        analyticsClient.sendTrackEvent(eventData);
    };
    const $64277dac6b18863c$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
        if (eventSource) {
            const updatedEventData = $64277dac6b18863c$var$buildDwellEventData(eventSource);
            $64277dac6b18863c$var$dwellHelper = (0, (0, parcelRequire("l7duG")).default)((eventData)=>$64277dac6b18863c$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
            $64277dac6b18863c$var$dwellHelper.start();
        }
    };
    const $64277dac6b18863c$var$recordNewPageForDwellTime = (eventSource)=>{
        if ($64277dac6b18863c$var$dwellHelper) {
            if (eventSource) {
                const updatedEventData = $64277dac6b18863c$var$buildDwellEventData(eventSource);
                $64277dac6b18863c$var$dwellHelper.newPage(updatedEventData);
            } else console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
        } else console.error('Dwell time has not been initialised');
    };
    const $64277dac6b18863c$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
        const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
        const eventSource = eventName ? `${eventName}Screen` : null;
        if (!$64277dac6b18863c$var$dwellHelper) $64277dac6b18863c$var$initialiseDwellTime(eventSource, analyticsClient);
        else $64277dac6b18863c$var$recordNewPageForDwellTime(eventSource);
    };
    var $64277dac6b18863c$export$2e2bcd8739ae039 = $64277dac6b18863c$var$recordDwellTime;
});
parcelRegister("l7duG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f6d4735f9f03b2d$export$2e2bcd8739ae039);
    var $5NkCx;
    const $2f6d4735f9f03b2d$var$getDwellTimeHelper = (sendMethod, eventData)=>{
        return new (0, (0, parcelRequire("5NkCx")).default)(sendMethod, eventData);
    };
    var $2f6d4735f9f03b2d$export$2e2bcd8739ae039 = $2f6d4735f9f03b2d$var$getDwellTimeHelper;
});
parcelRegister("9ADns", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dadd0bb5a806c0e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $kNtbp;
    var $gc5DR;
    function $dadd0bb5a806c0e3$var$hasProfileProp(state) {
        return !!state && 'profile' in state;
    }
    const $dadd0bb5a806c0e3$var$KudosPageRoute = ({ match: match, location: location })=>{
        const { uuid: uuid } = match.params;
        const profile = $dadd0bb5a806c0e3$var$hasProfileProp(location.state) ? location.state.profile : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).KUDOS_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).KUDOS_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kNtbp")).default), {
            uuid: uuid,
            referrerProfile: profile
        }));
    };
    var $dadd0bb5a806c0e3$export$2e2bcd8739ae039 = $dadd0bb5a806c0e3$var$KudosPageRoute;
});
parcelRegister("kNtbp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$967c45884049b603$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    const $967c45884049b603$var$LazyKudosPage = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8zAnn")),
        loading: ()=>null
    });
    $967c45884049b603$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
    var $967c45884049b603$export$2e2bcd8739ae039 = $967c45884049b603$var$LazyKudosPage;
});
parcelRegister("8zAnn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7faFL")
    ]).then(()=>parcelRequire('1MiwD'));
});
parcelRegister("fiymB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc770c7507c2347f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $6l1dD;
    var $38ra6;
    var $fff3y;
    var $bj9AK;
    function $cc770c7507c2347f$export$2e2bcd8739ae039(props) {
        const { contextEntryPoint: contextEntryPoint, location: location } = props;
        const [{ principalUserId: principalUserId }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const url = new URL(window.location.href);
        const ref = (0, (0, parcelRequire("6l1dD")).sanitiseValue)(url.searchParams.get('ref') || '', {
            shouldHaveSafeCharsOnly: true,
            shouldEncode: true
        });
        (0, $5uXOq.useEffect)(()=>{
            analytics.pushTrackEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'redirectMePathToMyProfile',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).REDIRECTED,
                attributes: {
                    ref: ref
                }
            });
        }, [
            analytics,
            ref
        ]);
        if (!principalUserId) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9AK")).default), {
            to: `${contextEntryPoint}/${principalUserId}${location.search}`
        });
    }
});
parcelRegister("bj9AK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c19be44686df00c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2FwA3;
    const $0c19be44686df00c$var$Redirect = ({ to: to })=>{
        const { replace: replace } = (0, (0, parcelRequire("2FwA3")).useAppConfig)();
        (0, $5uXOq.useEffect)(()=>{
            replace(to);
        }, [
            replace,
            to
        ]);
        return null;
    };
    var $0c19be44686df00c$export$2e2bcd8739ae039 = $0c19be44686df00c$var$Redirect;
});
parcelRegister("8qmUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5854d2587ae32ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bj9AK;
    const $b5854d2587ae32ae$var$RootRedirect = ({ location: location })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9AK")).default), {
            to: `search${location.search}`
        });
    var $b5854d2587ae32ae$export$2e2bcd8739ae039 = $b5854d2587ae32ae$var$RootRedirect;
});
parcelRegister("fj1iI", function(module, exports) {
    $parcel$export(module.exports, "RouteWithOrgIdLoading", ()=>$1b36544f506dd491$export$ae0909755df943ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $fCZyz;
    var $47bDC = parcelRequire("47bDC");
    var $eZJjh;
    var $c5gm9;
    var $6laLp;
    var $8qmUa;
    function $1b36544f506dd491$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
        const [{ orgId: orgId }] = (0, (0, parcelRequire("c5gm9")).useOrg)();
        const [timedOut, setTimedOut] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const handleNoOrgId = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("6laLp")).logInfoMessage)('No orgId found after 10 seconds', {
                ...props
            });
            setTimedOut(true);
        }, [
            setTimedOut,
            props
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (orgId) return;
            const timeout = setTimeout(()=>{
                if (!orgId) handleNoOrgId();
            }, 10000);
            return ()=>{
                clearTimeout(timeout);
            };
        }, [
            orgId,
            handleNoOrgId
        ]);
        if (timedOut) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8qmUa")).default), {
            location: {
                search: ''
            }
        });
        if (!orgId) return LoadingComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingComponent, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($1b36544f506dd491$var$DefaultLoadingWrapper, {
            "data-testid": "route-with-org-id-loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: 'large'
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCZyz")).default), props);
    }
    const $1b36544f506dd491$var$DefaultLoadingWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1wps406-0"
    })`height:100%;width:100%;padding-top:100px;display:flex;justify-content:center;align-items:center;`;
});
parcelRegister("aHh7I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0038ebeff682e50e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $gc5DR;
    var $hGR3k;
    const $0038ebeff682e50e$var$SearchPageRoute = ()=>{
        const url = new URL(window.location.href);
        const searchQuery = url.searchParams.get('q') || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PEOPLE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PEOPLE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hGR3k")).default), {
            searchQuery: searchQuery
        })));
    };
    var $0038ebeff682e50e$export$2e2bcd8739ae039 = $0038ebeff682e50e$var$SearchPageRoute;
});
parcelRegister("hGR3k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a2a2b999f52843d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $7a2a2b999f52843d$var$LazySearchPage = (0, $5uXOq.lazy)(()=>(parcelRequire("104fA")));
    var $7a2a2b999f52843d$export$2e2bcd8739ae039 = $7a2a2b999f52843d$var$LazySearchPage;
});
parcelRegister("104fA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5WDUO")
    ]).then(()=>parcelRequire('f4P8b'));
});
parcelRegister("hEEh7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6afa4dd7fbd8e02$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $gc5DR;
    var $1eng9;
    const $b6afa4dd7fbd8e02$var$SearchTeamsError = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).ALL_TEAMS_DISABLED
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).ALL_TEAMS_DISABLED
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eng9")).LazyTeamsDisabled), null));
    };
    var $b6afa4dd7fbd8e02$export$2e2bcd8739ae039 = $b6afa4dd7fbd8e02$var$SearchTeamsError;
});
parcelRegister("1eng9", function(module, exports) {
    $parcel$export(module.exports, "LazyTeamsDisabled", ()=>$bb5261a42ebcd0e1$export$f063de2a1a254e59);
    var $4qBtX = parcelRequire("4qBtX");
    const $bb5261a42ebcd0e1$export$f063de2a1a254e59 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("ct1Yr")).then((module)=>module.TeamsDisabled),
        loading: ()=>null
    });
    $bb5261a42ebcd0e1$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';
});
parcelRegister("ct1Yr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lyELu")
    ]).then(()=>parcelRequire('gVX14'));
});
parcelRegister("9Wt9a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9bd2ecbdb3e658af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $55DQp;
    var $ioKz4;
    var $gc5DR;
    var $V3p3m;
    const $9bd2ecbdb3e658af$var$TeamProfileRoute = ({ match: match })=>{
        const { teamId: teamId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).TEAM_PROFILE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).TEAM_PROFILE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("55DQp")).default), {
            teamId: teamId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("V3p3m")).default), {
            teamId: teamId
        }));
    };
    var $9bd2ecbdb3e658af$export$2e2bcd8739ae039 = $9bd2ecbdb3e658af$var$TeamProfileRoute;
});
parcelRegister("55DQp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc7e64bf9ee8f352$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8OWwQ;
    var $38ra6;
    function $fc7e64bf9ee8f352$export$2e2bcd8739ae039({ teamId: teamId }) {
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        (0, (0, parcelRequire("8OWwQ")).useInjectedEventAttribute)('teamId', teamId);
        (0, $5uXOq.useEffect)(()=>{
            analytics.setTeamId(teamId);
            ()=>{
                analytics.setTeamId(undefined);
            };
        }, [
            analytics,
            teamId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    }
});
parcelRegister("V3p3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1d11fa9f4cbcb4$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    const $ea1d11fa9f4cbcb4$var$TeamProfilePage = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("1Kg5p")),
        loading: ()=>null
    });
    $ea1d11fa9f4cbcb4$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
    var $ea1d11fa9f4cbcb4$export$2e2bcd8739ae039 = $ea1d11fa9f4cbcb4$var$TeamProfilePage;
});
parcelRegister("1Kg5p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("llst1")
    ]).then(()=>parcelRequire('aoGdH'));
});
parcelRegister("jM6Gv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95b1d2aa4460da7f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bj9AK;
    const $95b1d2aa4460da7f$var$TeamNoIdRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9AK")).default), {
            to: "/search"
        });
    var $95b1d2aa4460da7f$export$2e2bcd8739ae039 = $95b1d2aa4460da7f$var$TeamNoIdRedirect;
});
parcelRegister("9jKbC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26a7f016093515ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $8X7rl;
    var $gc5DR;
    const $26a7f016093515ae$var$UserProfileRoute = ({ match: match })=>{
        const { userId: userId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PROFILE_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PROFILE_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8X7rl")).default), {
            userId: decodeURIComponent(userId)
        }));
    };
    var $26a7f016093515ae$export$2e2bcd8739ae039 = $26a7f016093515ae$var$UserProfileRoute;
});
parcelRegister("8X7rl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f3ecfab3910cd14$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    const $8f3ecfab3910cd14$var$LazyUserProfile = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("eZHf0")),
        loading: ()=>null
    });
    $8f3ecfab3910cd14$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
    var $8f3ecfab3910cd14$export$2e2bcd8739ae039 = $8f3ecfab3910cd14$var$LazyUserProfile;
});
parcelRegister("eZHf0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kk1Uj")
    ]).then(()=>parcelRequire('20fOf'));
});
parcelRegister("9PUJF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$861a59b3e7732549$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bj9AK;
    const $861a59b3e7732549$var$UserProfileUnknownRoute = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9AK")).default), {
            to: match.params.userId
        });
    var $861a59b3e7732549$export$2e2bcd8739ae039 = $861a59b3e7732549$var$UserProfileUnknownRoute;
});
parcelRegister("bVufh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f219f2f7c850802c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $ioKz4;
    var $gc5DR;
    var $kQx20;
    const $f219f2f7c850802c$var$UserProfileWorkedOn = ({ match: match })=>{
        const { userId: userId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gc5DR")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioKz4")).default), {
            name: (0, (0, parcelRequire("fyzT1")).AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kQx20")).default), {
            userId: decodeURIComponent(userId)
        }));
    };
    var $f219f2f7c850802c$export$2e2bcd8739ae039 = $f219f2f7c850802c$var$UserProfileWorkedOn;
});
parcelRegister("kQx20", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9487606d10049190$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    const $9487606d10049190$var$LazyUserProfileWorkedOn = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("eGkhJ")),
        loading: ()=>null
    });
    $9487606d10049190$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
    var $9487606d10049190$export$2e2bcd8739ae039 = $9487606d10049190$var$LazyUserProfileWorkedOn;
});
parcelRegister("eGkhJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7gEQ1")
    ]).then(()=>parcelRequire('fvhIV'));
});
parcelRegister("bmfV0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7a70e415cdb406b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $grAcD;
    var $39CLR;
    var $2FwA3;
    var $1yBns;
    const $f7a70e415cdb406b$var$appProductMap = {
        '': '',
        'site-directory': '',
        'confluence-directory': (0, (0, parcelRequire("grAcD")).ProductName).CONFLUENCE,
        'jira-directory': (0, (0, parcelRequire("grAcD")).ProductName).JIRA,
        'teamcentral-directory': (0, (0, parcelRequire("grAcD")).ProductName).ATLAS,
        'home-directory': (0, (0, parcelRequire("grAcD")).ProductName).HOME
    };
    const $f7a70e415cdb406b$var$mapAppToProduct = (app)=>{
        return $f7a70e415cdb406b$var$appProductMap[app];
    };
    class $f7a70e415cdb406b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        render() {
            const productFeatureFlags = {
                ...this.state.productFeatureFlags,
                ...this.props.productFeatureFlags
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FwA3")).default).Provider, {
                value: {
                    ...this.props,
                    ...this.state,
                    productFeatureFlags: productFeatureFlags
                }
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.addFlag = (props)=>{
                const { type: type, ...rest } = props;
                this.props.addFlag({
                    ...rest,
                    id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                    type: type,
                    appearance: 'normal',
                    icon: (0, (0, parcelRequire("1yBns")).getTypeIcon)(type)
                });
            }, this.push = (path)=>{
                const { contextEntryPoint: contextEntryPoint } = this.props;
                const finalPath = (0, (0, parcelRequire("39CLR")).prefixWithContextEntryPoint)(path, contextEntryPoint);
                return this.props.push(finalPath);
            }, this.replace = (path)=>{
                const { contextEntryPoint: contextEntryPoint } = this.props;
                const finalPath = (0, (0, parcelRequire("39CLR")).prefixWithContextEntryPoint)(path, contextEntryPoint);
                return this.props.replace(finalPath);
            }, this.state = {
                addFlag: this.addFlag,
                push: this.push,
                replace: this.replace,
                productName: $f7a70e415cdb406b$var$mapAppToProduct(this.props.appName),
                productFeatureFlags: this.props.productFeatureFlags,
                invitePeopleHandlers: this.props.invitePeopleHandlers
            };
        }
    }
});
parcelRegister("1yBns", function(module, exports) {
    $parcel$export(module.exports, "getTypeIcon", ()=>$fcb79ae87932a669$export$672f92b0d52b7cfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $dD7Zc;
    var $1jWct;
    var $c2i4s;
    var $bU3PY;
    const $fcb79ae87932a669$var$flagIconByType = {
        error: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            label: "error123",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        }),
        warning: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            label: "warning123",
            spacing: "spacious",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`
        }),
        info: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))), {
            label: "info123",
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        })
    };
    const $fcb79ae87932a669$var$defaultIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))), {
        label: "winner123",
        spacing: "spacious",
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
    });
    const $fcb79ae87932a669$export$672f92b0d52b7cfe = (type = 'normal')=>$fcb79ae87932a669$var$flagIconByType[type] || $fcb79ae87932a669$var$defaultIcon;
});
parcelRegister("b8wBX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8b08eb533f61d71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $iiI2P;
    var $a2luh;
    class $f8b08eb533f61d71$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromError(error) {
            return {
                hasError: true
            };
        }
        componentDidCatch(error, errorInfo) {
            const { analytics: analytics, appName: appName } = this.props;
            (0, (0, parcelRequire("a2luh")).logException)(error, 'Caught error in ErrorBoundaryApp', {
                info: errorInfo,
                tags: {
                    severity: 'high',
                    boundary: 'AppRoot'
                }
            });
            analytics.pushOperationalEvent({
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: 'errorBoundary',
                action: (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).TRIGGERED,
                attributes: {
                    product: appName,
                    boundary: 'app',
                    error: error.toString()
                },
                tags: [
                    'error',
                    'error-boundary'
                ]
            });
        }
        render() {
            if (!this.state.hasError) return this.props.children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iiI2P")).GenericErrorPage), {
                hasSupportLink: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    }
});
parcelRegister("bCUYQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb9099bb66d2e3fe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fyzT1;
    var $38ra6;
    var $fff3y;
    var $3HUMg;
    var $5WmsO;
    var $fjVRf;
    const $eb9099bb66d2e3fe$var$mapAppNameToProduct = {
        '': 'STANDALONE',
        'site-directory': 'STANDALONE',
        'confluence-directory': 'CONFLUENCE',
        'jira-directory': 'JIRA',
        'teamcentral-directory': 'TOWNSQUARE',
        'home-directory': 'HOME'
    };
    function $eb9099bb66d2e3fe$export$f07589effd6b0ff3(props) {
        const { appName: appName, children: children } = props;
        const [{ cloudId: cloudId }] = (0, (0, parcelRequire("5WmsO")).useSite)();
        const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, (0, parcelRequire("fff3y")).usePrincipalUser)();
        const analytics = (0, (0, parcelRequire("38ra6")).default)();
        const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings, isFetching: isFetching }, { getSettings: getSettings }] = (0, (0, parcelRequire("3HUMg")).useSettings)();
        (0, $5uXOq.useEffect)(()=>{
            analytics.startUIViewedEvent(principalUserId);
        }, [
            analytics,
            principalUserId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasLoadedSettings) analytics.pushOperationalEvent({
                action: hasErrorOnFetchSettings ? (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).FAILED : (0, (0, parcelRequire("fyzT1")).AnalyticsEventActions).SUCCEEDED,
                actionSubject: (0, (0, parcelRequire("fjVRf")).SliAnalytics).GetSettings,
                source: (0, (0, parcelRequire("fyzT1")).AnalyticsEventSource).DIRECTORY_APP
            });
        }, [
            analytics,
            hasLoadedSettings,
            hasErrorOnFetchSettings
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const product = $eb9099bb66d2e3fe$var$mapAppNameToProduct[appName];
            if (!hasLoadedSettings && !isFetching && cloudId) getSettings(product, cloudId);
        }, [
            appName,
            hasLoadedSettings,
            getSettings,
            cloudId,
            isFetching
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (cloudId) getPrincipalUserInfo(cloudId);
        }, [
            cloudId
        ]);
        return children;
    }
    var $eb9099bb66d2e3fe$export$2e2bcd8739ae039 = $eb9099bb66d2e3fe$export$f07589effd6b0ff3;
});
parcelRegister("3HUMg", function(module, exports) {
    $parcel$export(module.exports, "useFeatureFlag", ()=>$3d54c792f0b0e8b2$export$61acb772777ef35d);
    $parcel$export(module.exports, "useSettings", ()=>$3d54c792f0b0e8b2$export$9115b42802a3e44f);
    var $bhBxN;
    var $d7tic;
    const $3d54c792f0b0e8b2$export$c5cecc6f5d4bab3e = ()=>{
        return true;
    };
    const $3d54c792f0b0e8b2$export$61acb772777ef35d = (flagName)=>{
        return (0, (0, parcelRequire("bhBxN")).useFeatureFlag)(flagName);
    };
    const $3d54c792f0b0e8b2$export$9115b42802a3e44f = ()=>{
        return (0, (0, parcelRequire("d7tic")).useSettings)();
    };
});
parcelRegister("bhBxN", function(module, exports) {
    $parcel$export(module.exports, "useFeatureFlag", ()=>$108073b61d0286e6$export$61acb772777ef35d);
    var $d7tic;
    var $mw4O5;
    const $108073b61d0286e6$export$61acb772777ef35d = (flag)=>{
        const { productFeatureFlags: productFeatureFlags } = (0, (0, parcelRequire("mw4O5")).useAppConfig)();
        const flagValue = (0, (0, parcelRequire("d7tic")).useSettingsFeatureFlag)(flag);
        if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
        return flagValue;
    };
    const $108073b61d0286e6$export$80200644648c0ee1 = (flagName)=>!!$108073b61d0286e6$export$61acb772777ef35d(flagName);
});
parcelRegister("fjVRf", function(module, exports) {
    $parcel$export(module.exports, "SliAnalytics", ()=>$3f64278d3feeb44b$export$9cb5f615baf57db6);
    var $3f64278d3feeb44b$export$9cb5f615baf57db6;
    (function(SliAnalytics) {
        SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
        SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
        SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
        SliAnalytics["TeamSearch"] = "TeamSearch";
        SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
        SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
        SliAnalytics["GetSettings"] = "GetSettings";
    })($3f64278d3feeb44b$export$9cb5f615baf57db6 || ($3f64278d3feeb44b$export$9cb5f615baf57db6 = {}));
});
parcelRegister("c9lD2", function(module, exports) {
    $parcel$export(module.exports, "createShowFlagHandler", ()=>$3cf06505514424b8$export$58bf1d914631d59f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $7HGHK;
    var $fG9jT;
    const $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
    const $3cf06505514424b8$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
            const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
            const flagTitle = flagFromPTC.title;
            const flagDesc = flagFromPTC.description;
            const flagActions = flagFromPTC?.actions;
            showFlag({
                render: ({ key: key })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG9jT")).default), {
                        key: key,
                        id: key || flagFromPTC.id || $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT,
                        flagType: flagType,
                        title: flagTitle != null ? flagTitle : '',
                        description: flagDesc != null ? flagDesc : '',
                        actions: (0, (0, parcelRequire("4R6GH")).fg)('pass-actions-to-the-custom-flag') ? flagActions : undefined,
                        isAutoDismiss: true,
                        onDismissed: (id)=>{
                            dismissFlag((0, (0, parcelRequire("7HGHK")).toFlagId)(id));
                        }
                    })
            });
        };
});
parcelRegister("fG9jT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$874cfd4b776497f7$export$2e2bcd8739ae039);
    var $3KRpp;
    var $874cfd4b776497f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).CommonFlag);
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("fnaRp", function(module, exports) {
    $parcel$export(module.exports, "peopleProfilesPageLoad", ()=>$73adf83f024db228$export$37d218590c0c9938);
    var $dGrdR;
    const $73adf83f024db228$export$37d218590c0c9938 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'people-profiles'
    });
});
